// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 strokeWidth=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23adb5bd%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 strokeWidth=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 strokeWidth=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 strokeWidth=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23abade7%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23209f84%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f72b50%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f72b50%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2868, 68, 68, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 strokeWidth=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 strokeWidth=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23444%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23222453%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%239a9ce2%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./images/banner/shape.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuOTk5OTggOS43MDAyOUM2LjgyMDc2IDkuNzAwMjkgNi42NDE1NiA5LjYzMTg2IDYuNTA0OTMgOS40OTUyOUwyLjIwNTE0IDUuMTk1NDZDMS45MzE2MiA0LjkyMTk0IDEuOTMxNjIgNC40Nzg0NyAyLjIwNTE0IDQuMjA1MDZDMi40Nzg1NSAzLjkzMTY1IDIuOTIxOTMgMy45MzE2NSAzLjE5NTQ4IDQuMjA1MDZMNi45OTk5OCA4LjAwOTc4TDEwLjgwNDUgNC4yMDUxOUMxMS4wNzggMy45MzE3OCAxMS41MjE0IDMuOTMxNzggMTEuNzk0OCA0LjIwNTE5QzEyLjA2ODQgNC40Nzg2IDEyLjA2ODQgNC45MjIwNyAxMS43OTQ4IDUuMTk1Nkw3LjQ5NTA0IDkuNDk1NDJDNy4zNTgzNCA5LjYzMjAyIDcuMTc5MTQgOS43MDAyOSA2Ljk5OTk4IDkuNzAwMjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./images/shap/ext-blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./images/shap/ext-orange.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDEzIDEzIj48cGF0aCBmaWxsPSIjNDI0NzcwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjI4OCA2LjI5NkwzLjIwMiAyLjIxYS43MS43MSAwIDAgMSAuMDA3LS45OTljLjI4LS4yOC43MjUtLjI4Ljk5OS0uMDA3TDguODAzIDUuOGEuNjk1LjY5NSAwIDAgMSAuMjAyLjQ5Ni42OTUuNjk1IDAgMCAxLS4yMDIuNDk3bC00LjU5NSA0LjU5NWEuNzA0LjcwNCAwIDAgMS0xLS4wMDcuNzEuNzEgMCAwIDEtLjAwNi0uOTk5bDQuMDg2LTQuMDg2eiIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./images/background/line-bg3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./images/main-banner/shape1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./images/team/shape3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./images/team/shape1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./images/team/shape2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("./images/error.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("./images/quote.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("./images/shap/footer-line.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("./images/background/footer-shape.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Bootstrap  v5.3.0 (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
    --bs-gray-100: #a1f4ff;
    --bs-gray-200: #60eaff;
    --bs-gray-300: #18d5f8;
    --bs-gray-400: #00b8de;
    --bs-gray-500: #008bb1;
    --bs-gray-600: #087496;
    --bs-gray-700: #105e7a;
    --bs-gray-800: #124e67;
    --bs-gray-900: #053347;
    --bs-primary: #008BB1;
    --bs-secondary: #f17732;
    --bs-success: #209f84;
    --bs-info: #2754e6;
    --bs-warning: #fe970e;
    --bs-danger: #f72b50;
    --bs-light: #fff;
    --bs-dark: #008BB1;
    --bs-primary-rgb: 161, 244, 255;
    --bs-secondary-rgb: 96, 234, 255;
    --bs-success-rgb: 24, 213, 248;
    --bs-info-rgb: 0, 184, 222;
    --bs-warning-rgb: 0, 139, 177;
    --bs-danger-rgb: 8, 116, 150;
    --bs-light-rgb: 16, 94, 122;
    --bs-dark-rgb: 18, 78, 103;
    --bs-primary-text-emphasis: #222453;
    --bs-secondary-text-emphasis: #603014;
    --bs-success-text-emphasis: #0d4035;
    --bs-info-text-emphasis: #10225c;
    --bs-warning-text-emphasis: #663c06;
    --bs-danger-text-emphasis: #631120;
    --bs-light-text-emphasis: #495057;
    --bs-dark-text-emphasis: #495057;
    --bs-primary-bg-subtle: #dddef5;
    --bs-secondary-bg-subtle: #fce4d6;
    --bs-success-bg-subtle: #d2ece6;
    --bs-info-bg-subtle: #d4ddfa;
    --bs-warning-bg-subtle: #ffeacf;
    --bs-danger-bg-subtle: #fdd5dc;
    --bs-light-bg-subtle: #fcfcfd;
    --bs-dark-bg-subtle: #ced4da;
    --bs-primary-border-subtle: #bbbdec;
    --bs-secondary-border-subtle: #f9c9ad;
    --bs-success-border-subtle: #a6d9ce;
    --bs-info-border-subtle: #a9bbf5;
    --bs-warning-border-subtle: #ffd59f;
    --bs-danger-border-subtle: #fcaab9;
    --bs-light-border-subtle: #e9ecef;
    --bs-dark-border-subtle: #adb5bd;
    --bs-white-rgb: 255, 255, 255;
    --bs-black-rgb: 0, 0, 0;
    --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
    --bs-body-font-family: "Montserrat", sans-serif;
    --bs-body-font-size: 1rem;
    --bs-body-font-weight: 500;
    --bs-body-line-height: 1.5;
    --bs-body-color: #3F4650;
    --bs-body-color-rgb: 63, 70, 80;
    --bs-body-bg: #ffffff;
    --bs-body-bg-rgb: 255, 255, 255;
    --bs-emphasis-color: #000;
    --bs-emphasis-color-rgb: 0, 0, 0;
    --bs-secondary-color: rgba(68, 68, 68, 0.75);
    --bs-secondary-color-rgb: 68, 68, 68;
    --bs-secondary-bg: #e9ecef;
    --bs-secondary-bg-rgb: 233, 236, 239;
    --bs-tertiary-color: rgba(68, 68, 68, 0.5);
    --bs-tertiary-color-rgb: 68, 68, 68;
    --bs-tertiary-bg: #f8f9fa;
    --bs-tertiary-bg-rgb: 248, 249, 250;
    --bs-heading-color: #14181d;
    --bs-link-color: #008BB1;
    --bs-link-color-rgb: 86, 90, 207;
    --bs-link-decoration: underline;
    --bs-link-hover-color: var(--bs-primary);
    ;
    --bs-link-hover-color-rgb: 69, 72, 166;
    --bs-code-color: #d63384;
    --bs-highlight-bg: #fff3cd;
    --bs-border-width: 1px;
    --bs-border-style: solid;
    --bs-border-color: #E1E1F0;
    --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
    --bs-border-radius: 0.375rem;
    --bs-border-radius-sm: 0.25rem;
    --bs-border-radius-lg: 20px;
    --bs-border-radius-xl: 1rem;
    --bs-border-radius-xxl: 2rem;
    --bs-border-radius-2xl: var(--bs-border-radius-xxl);
    --bs-border-radius-pill: 50rem;
    --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
    --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
    --bs-focus-ring-width: 0.25rem;
    --bs-focus-ring-opacity: 0.25;
    --bs-focus-ring-color: rgba(86, 90, 207, 0.25);
    --bs-form-valid-color: #209f84;
    --bs-form-valid-border-color: #209f84;
    --bs-form-invalid-color: #f72b50;
    --bs-form-invalid-border-color: #f72b50
}

[data-bs-theme=dark] {
    color-scheme: dark;
    --bs-body-color: #adb5bd;
    --bs-body-color-rgb: 173, 181, 189;
    --bs-body-bg: #212529;
    --bs-body-bg-rgb: 33, 37, 41;
    --bs-emphasis-color: #fff;
    --bs-emphasis-color-rgb: 255, 255, 255;
    --bs-secondary-color: rgba(173, 181, 189, 0.75);
    --bs-secondary-color-rgb: 173, 181, 189;
    --bs-secondary-bg: #343a40;
    --bs-secondary-bg-rgb: 52, 58, 64;
    --bs-tertiary-color: rgba(173, 181, 189, 0.5);
    --bs-tertiary-color-rgb: 173, 181, 189;
    --bs-tertiary-bg: #2b3035;
    --bs-tertiary-bg-rgb: 43, 48, 53;
    --bs-primary-text-emphasis: #9a9ce2;
    --bs-secondary-text-emphasis: #f7ad84;
    --bs-success-text-emphasis: #79c5b5;
    --bs-info-text-emphasis: #7d98f0;
    --bs-warning-text-emphasis: #fec16e;
    --bs-danger-text-emphasis: #fa8096;
    --bs-light-text-emphasis: #f8f9fa;
    --bs-dark-text-emphasis: #dee2e6;
    --bs-primary-bg-subtle: #111229;
    --bs-secondary-bg-subtle: #30180a;
    --bs-success-bg-subtle: #06201a;
    --bs-info-bg-subtle: #08112e;
    --bs-warning-bg-subtle: #331e03;
    --bs-danger-bg-subtle: #310910;
    --bs-light-bg-subtle: #343a40;
    --bs-dark-bg-subtle: #1a1d20;
    --bs-primary-border-subtle: #34367c;
    --bs-secondary-border-subtle: #91471e;
    --bs-success-border-subtle: #135f4f;
    --bs-info-border-subtle: #17328a;
    --bs-warning-border-subtle: #985b08;
    --bs-danger-border-subtle: #941a30;
    --bs-light-border-subtle: #495057;
    --bs-dark-border-subtle: #343a40;
    --bs-heading-color: inherit;
    --bs-link-color: #9a9ce2;
    --bs-link-hover-color: #aeb0e8;
    --bs-link-color-rgb: 154, 156, 226;
    --bs-link-hover-color-rgb: 174, 176, 232;
    --bs-code-color: #e685b5;
    --bs-border-color: #495057;
    --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
    --bs-form-valid-color: #75b798;
    --bs-form-valid-border-color: #75b798;
    --bs-form-invalid-color: #ea868f;
    --bs-form-invalid-border-color: #ea868f
}

*,
*::before,
*::after {
    box-sizing: border-box
}

@media(prefers-reduced-motion: no-preference) {
    :root {
        scroll-behavior: smooth
    }
}

body {
    margin: 0;
    font-family: var(--bs-body-font-family);
    font-size: var(--bs-body-font-size);
    font-weight: var(--bs-body-font-weight);
    line-height: var(--bs-body-line-height);
    color: var(--bs-body-color);
    text-align: var(--bs-body-text-align);
    background-color: var(--bs-body-bg);
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
    margin: 1rem 0;
    color: inherit;
    border: 0;
    border-top: var(--bs-border-width) solid;
    opacity: .25
}

h6,
.h6,
h5,
.h5,
h4,
.h4,
h3,
.h3,
h2,
.h2,
h1,
.h1 {
    margin-top: 0;
    margin-bottom: .5rem;
    font-weight: 500;
    line-height: 1.2;
    color: var(--bs-heading-color)
}

h1,
.h1 {
    font-size: calc(1.4375rem + 2.25vw)
}

@media(min-width: 1200px) {

    h1,
    .h1 {
        font-size: 3.125rem
    }
}

h2,
.h2 {
    font-size: calc(1.34375rem + 1.125vw)
}

@media(min-width: 1200px) {

    h2,
    .h2 {
        font-size: 2.1875rem
    }
}

h3,
.h3 {
    font-size: calc(1.3rem + 0.6vw)
}

@media(min-width: 1200px) {

    h3,
    .h3 {
        font-size: 1.75rem
    }
}

h4,
.h4 {
    font-size: calc(1.275rem + 0.3vw)
}

@media(min-width: 1200px) {

    h4,
    .h4 {
        font-size: 1.5rem
    }
}

h5,
.h5 {
    font-size: 1.25rem
}

h6,
.h6 {
    font-size: 1.125rem
}

p {
    margin-top: 0;
    margin-bottom: 1rem
}

abbr[title] {
    -webkit-text-decoration: underline dotted;
            text-decoration: underline dotted;
    cursor: help;
    text-decoration-skip-ink: none
}

address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit
}

ol,
ul {
    padding-left: 2rem
}

ol,
ul,
dl {
    margin-top: 0;
    margin-bottom: 1rem
}

ol ol,
ul ul,
ol ul,
ul ol {
    margin-bottom: 0
}

dt {
    font-weight: 700
}

dd {
    margin-bottom: .5rem;
    margin-left: 0
}

blockquote {
    margin: 0 0 1rem
}

b,
strong {
    font-weight: bolder
}

small,
.small {
    font-size: 0.875em
}

mark,
.mark {
    padding: .1875em;
    background-color: var(--bs-highlight-bg)
}

sub,
sup {
    position: relative;
    font-size: 0.75em;
    line-height: 0;
    vertical-align: baseline
}

sub {
    bottom: -0.25em
}

sup {
    top: -0.5em
}

a {
    color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
    text-decoration: underline
}

a:hover {
    --bs-link-color-rgb: var(--bs-link-hover-color-rgb)
}

a:not([href]):not([class]),
a:not([href]):not([class]):hover {
    color: inherit;
    text-decoration: none
}

pre,
code,
kbd,
samp {
    font-family: var(--bs-font-monospace);
    font-size: 1em
}

pre {
    display: block;
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    font-size: 0.875em
}

pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal
}

code {
    font-size: 0.875em;
    color: var(--bs-code-color);
    word-wrap: break-word
}

a>code {
    color: inherit
}

kbd {
    padding: .1875rem .375rem;
    font-size: 0.875em;
    color: var(--bs-body-bg);
    background-color: var(--bs-body-color);
    border-radius: .25rem
}

kbd kbd {
    padding: 0;
    font-size: 1em
}

figure {
    margin: 0 0 1rem
}

img,
svg {
    vertical-align: middle
}

table {
    caption-side: bottom;
    border-collapse: collapse
}

caption {
    padding-top: .5rem;
    padding-bottom: .5rem;
    color: var(--bs-secondary-color);
    text-align: left
}

th {
    text-align: inherit;
    text-align: -webkit-match-parent
}

thead,
tbody,
tfoot,
tr,
td,
th {
    border-color: inherit;
    border-style: solid;
    border-width: 0
}

label {
    display: inline-block
}

button {
    border-radius: 0
}

button:focus:not(:focus-visible) {
    outline: 0
}

input,
button,
select,
optgroup,
textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit
}

button,
select {
    text-transform: none
}

[role=button] {
    cursor: pointer
}

select {
    word-wrap: normal
}

select:disabled {
    opacity: 1
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
    display: none !important
}

button,
[type=button],
[type=reset],
[type=submit] {
    -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
    cursor: pointer
}

::-moz-focus-inner {
    padding: 0;
    border-style: none
}

textarea {
    resize: vertical
}

fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0
}

legend {
    float: left;
    width: 100%;
    padding: 0;
    margin-bottom: .5rem;
    font-size: calc(1.275rem + 0.3vw);
    line-height: inherit
}

@media(min-width: 1200px) {
    legend {
        font-size: 1.5rem
    }
}

legend+* {
    clear: left
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
    padding: 0
}

::-webkit-inner-spin-button {
    height: auto
}

[type=search] {
    outline-offset: -2px;
    -webkit-appearance: textfield
}

::-webkit-search-decoration {
    -webkit-appearance: none
}

::-webkit-color-swatch-wrapper {
    padding: 0
}

::file-selector-button {
    font: inherit;
    -webkit-appearance: button
}

output {
    display: inline-block
}

iframe {
    border: 0
}

summary {
    display: list-item;
    cursor: pointer
}

progress {
    vertical-align: baseline
}

[hidden] {
    display: none !important
}

.lead {
    font-size: 1.25rem;
    font-weight: 300
}

.display-1 {
    font-size: calc(1.625rem + 4.5vw);
    font-weight: 300;
    line-height: 1.2
}

@media(min-width: 1200px) {
    .display-1 {
        font-size: 5rem
    }
}

.display-2 {
    font-size: calc(1.575rem + 3.9vw);
    font-weight: 300;
    line-height: 1.2
}

@media(min-width: 1200px) {
    .display-2 {
        font-size: 4.5rem
    }
}

.display-3 {
    font-size: calc(1.525rem + 3.3vw);
    font-weight: 300;
    line-height: 1.2
}

@media(min-width: 1200px) {
    .display-3 {
        font-size: 4rem
    }
}

.display-4 {
    font-size: calc(1.475rem + 2.7vw);
    font-weight: 300;
    line-height: 1.2
}

@media(min-width: 1200px) {
    .display-4 {
        font-size: 3.5rem
    }
}

.display-5 {
    font-size: calc(1.425rem + 2.1vw);
    font-weight: 300;
    line-height: 1.2
}

@media(min-width: 1200px) {
    .display-5 {
        font-size: 3rem
    }
}

.display-6 {
    font-size: calc(1.375rem + 1.5vw);
    font-weight: 300;
    line-height: 1.2
}

@media(min-width: 1200px) {
    .display-6 {
        font-size: 2.5rem
    }
}

.list-unstyled {
    padding-left: 0;
    list-style: none
}

.list-inline {
    padding-left: 0;
    list-style: none
}

.list-inline-item {
    display: inline-block
}

.list-inline-item:not(:last-child) {
    margin-right: .5rem
}

.initialism {
    font-size: 0.875em;
    text-transform: uppercase
}

.blockquote {
    margin-bottom: 1rem;
    font-size: 1.25rem
}

.blockquote>:last-child {
    margin-bottom: 0
}

.blockquote-footer {
    margin-top: -1rem;
    margin-bottom: 1rem;
    font-size: 0.875em;
    color: #6c757d
}

.blockquote-footer::before {
    content: "— "
}

.img-fluid {
    max-width: 100%;
    /* height: auto */
    height: 250px;
}

.img-thumbnail {
    padding: .25rem;
    background-color: var(--bs-body-bg);
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-radius: var(--bs-border-radius);
    max-width: 100%;
    height: auto
}

.figure {
    display: inline-block
}

.figure-img {
    margin-bottom: .5rem;
    line-height: 1
}

.figure-caption {
    font-size: 0.875em;
    color: var(--bs-secondary-color)
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
    --bs-gutter-x: 30px;
    --bs-gutter-y: 0;
    width: 100%;
    padding-right: calc(var(--bs-gutter-x)*.5);
    padding-left: calc(var(--bs-gutter-x)*.5);
    margin-right: auto;
    margin-left: auto
}

@media(min-width: 576px) {

    .container-sm,
    .container {
        max-width: 540px
    }
}

@media(min-width: 768px) {

    .container-md,
    .container-sm,
    .container {
        max-width: 720px
    }
}

@media(min-width: 992px) {

    .container-lg,
    .container-md,
    .container-sm,
    .container {
        max-width: 960px
    }
}

@media(min-width: 1200px) {

    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
        max-width: 1199px
    }
}

:root {
    --bs-breakpoint-xs: 0;
    --bs-breakpoint-sm: 576px;
    --bs-breakpoint-md: 768px;
    --bs-breakpoint-lg: 992px;
    --bs-breakpoint-xl: 1200px;
    --bs-breakpoint-xxl: 1440
}

.row {
    --bs-gutter-x: 30px;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1*var(--bs-gutter-y));
    margin-right: calc(-0.5*var(--bs-gutter-x));
    margin-left: calc(-0.5*var(--bs-gutter-x))
}

.row>* {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--bs-gutter-x)*.5);
    padding-left: calc(var(--bs-gutter-x)*.5);
    margin-top: var(--bs-gutter-y)
}

.col {
    flex: 1 0
}

.row-cols-auto>* {
    flex: 0 0 auto;
    width: auto
}

.row-cols-1>* {
    flex: 0 0 auto;
    width: 100%
}

.row-cols-2>* {
    flex: 0 0 auto;
    width: 50%
}

.row-cols-3>* {
    flex: 0 0 auto;
    width: 33.3333333333%
}

.row-cols-4>* {
    flex: 0 0 auto;
    width: 25%
}

.row-cols-5>* {
    flex: 0 0 auto;
    width: 20%
}

.row-cols-6>* {
    flex: 0 0 auto;
    width: 16.6666666667%
}

.col-auto {
    flex: 0 0 auto;
    width: auto
}

.col-1 {
    flex: 0 0 auto;
    width: 8.33333333%
}

.col-2 {
    flex: 0 0 auto;
    width: 16.66666667%
}

.col-3 {
    flex: 0 0 auto;
    width: 25%
}

.col-4 {
    flex: 0 0 auto;
    width: 33.33333333%
}

.col-5 {
    flex: 0 0 auto;
    width: 41.66666667%
}

.col-6 {
    flex: 0 0 auto;
    width: 50%
}

.col-7 {
    flex: 0 0 auto;
    width: 58.33333333%
}

.col-8 {
    flex: 0 0 auto;
    width: 66.66666667%
}

.col-9 {
    flex: 0 0 auto;
    width: 75%
}

.col-10 {
    flex: 0 0 auto;
    width: 83.33333333%
}

.col-11 {
    flex: 0 0 auto;
    width: 91.66666667%
}

.col-12 {
    flex: 0 0 auto;
    width: 100%
}

.offset-1 {
    margin-left: 8.33333333%
}

.offset-2 {
    margin-left: 16.66666667%
}

.offset-3 {
    margin-left: 25%
}

.offset-4 {
    margin-left: 33.33333333%
}

.offset-5 {
    margin-left: 41.66666667%
}

.offset-6 {
    margin-left: 50%
}

.offset-7 {
    margin-left: 58.33333333%
}

.offset-8 {
    margin-left: 66.66666667%
}

.offset-9 {
    margin-left: 75%
}

.offset-10 {
    margin-left: 83.33333333%
}

.offset-11 {
    margin-left: 91.66666667%
}

.g-0,
.gx-0 {
    --bs-gutter-x: 0
}

.g-0,
.gy-0 {
    --bs-gutter-y: 0
}

.g-1,
.gx-1 {
    --bs-gutter-x: 0.25rem
}

.g-1,
.gy-1 {
    --bs-gutter-y: 0.25rem
}

.g-2,
.gx-2 {
    --bs-gutter-x: 0.5rem
}

.g-2,
.gy-2 {
    --bs-gutter-y: 0.5rem
}

.g-3,
.gx-3 {
    --bs-gutter-x: 1rem
}

.g-3,
.gy-3 {
    --bs-gutter-y: 1rem
}

.g-4,
.gx-4 {
    --bs-gutter-x: 1.5rem
}

.g-4,
.gy-4 {
    --bs-gutter-y: 1.5rem
}

.g-5,
.gx-5 {
    --bs-gutter-x: 3rem
}

.g-5,
.gy-5 {
    --bs-gutter-y: 3rem
}

@media(min-width: 576px) {
    .col-sm {
        flex: 1 0
    }

    .row-cols-sm-auto>* {
        flex: 0 0 auto;
        width: auto
    }

    .row-cols-sm-1>* {
        flex: 0 0 auto;
        width: 100%
    }

    .row-cols-sm-2>* {
        flex: 0 0 auto;
        width: 50%
    }

    .row-cols-sm-3>* {
        flex: 0 0 auto;
        width: 33.3333333333%
    }

    .row-cols-sm-4>* {
        flex: 0 0 auto;
        width: 25%
    }

    .row-cols-sm-5>* {
        flex: 0 0 auto;
        width: 20%
    }

    .row-cols-sm-6>* {
        flex: 0 0 auto;
        width: 16.6666666667%
    }

    .col-sm-auto {
        flex: 0 0 auto;
        width: auto
    }

    .col-sm-1 {
        flex: 0 0 auto;
        width: 8.33333333%
    }

    .col-sm-2 {
        flex: 0 0 auto;
        width: 16.66666667%
    }

    .col-sm-3 {
        flex: 0 0 auto;
        width: 25%
    }

    .col-sm-4 {
        flex: 0 0 auto;
        width: 33.33333333%
    }

    .col-sm-5 {
        flex: 0 0 auto;
        width: 41.66666667%
    }

    .col-sm-6 {
        flex: 0 0 auto;
        width: 50%
    }

    .col-sm-7 {
        flex: 0 0 auto;
        width: 58.33333333%
    }

    .col-sm-8 {
        flex: 0 0 auto;
        width: 66.66666667%
    }

    .col-sm-9 {
        flex: 0 0 auto;
        width: 75%
    }

    .col-sm-10 {
        flex: 0 0 auto;
        width: 83.33333333%
    }

    .col-sm-11 {
        flex: 0 0 auto;
        width: 91.66666667%
    }

    .col-sm-12 {
        flex: 0 0 auto;
        width: 100%
    }

    .offset-sm-0 {
        margin-left: 0
    }

    .offset-sm-1 {
        margin-left: 8.33333333%
    }

    .offset-sm-2 {
        margin-left: 16.66666667%
    }

    .offset-sm-3 {
        margin-left: 25%
    }

    .offset-sm-4 {
        margin-left: 33.33333333%
    }

    .offset-sm-5 {
        margin-left: 41.66666667%
    }

    .offset-sm-6 {
        margin-left: 50%
    }

    .offset-sm-7 {
        margin-left: 58.33333333%
    }

    .offset-sm-8 {
        margin-left: 66.66666667%
    }

    .offset-sm-9 {
        margin-left: 75%
    }

    .offset-sm-10 {
        margin-left: 83.33333333%
    }

    .offset-sm-11 {
        margin-left: 91.66666667%
    }

    .g-sm-0,
    .gx-sm-0 {
        --bs-gutter-x: 0
    }

    .g-sm-0,
    .gy-sm-0 {
        --bs-gutter-y: 0
    }

    .g-sm-1,
    .gx-sm-1 {
        --bs-gutter-x: 0.25rem
    }

    .g-sm-1,
    .gy-sm-1 {
        --bs-gutter-y: 0.25rem
    }

    .g-sm-2,
    .gx-sm-2 {
        --bs-gutter-x: 0.5rem
    }

    .g-sm-2,
    .gy-sm-2 {
        --bs-gutter-y: 0.5rem
    }

    .g-sm-3,
    .gx-sm-3 {
        --bs-gutter-x: 1rem
    }

    .g-sm-3,
    .gy-sm-3 {
        --bs-gutter-y: 1rem
    }

    .g-sm-4,
    .gx-sm-4 {
        --bs-gutter-x: 1.5rem
    }

    .g-sm-4,
    .gy-sm-4 {
        --bs-gutter-y: 1.5rem
    }

    .g-sm-5,
    .gx-sm-5 {
        --bs-gutter-x: 3rem
    }

    .g-sm-5,
    .gy-sm-5 {
        --bs-gutter-y: 3rem
    }
}

@media(min-width: 768px) {
    .col-md {
        flex: 1 0
    }

    .row-cols-md-auto>* {
        flex: 0 0 auto;
        width: auto
    }

    .row-cols-md-1>* {
        flex: 0 0 auto;
        width: 100%
    }

    .row-cols-md-2>* {
        flex: 0 0 auto;
        width: 50%
    }

    .row-cols-md-3>* {
        flex: 0 0 auto;
        width: 33.3333333333%
    }

    .row-cols-md-4>* {
        flex: 0 0 auto;
        width: 25%
    }

    .row-cols-md-5>* {
        flex: 0 0 auto;
        width: 20%
    }

    .row-cols-md-6>* {
        flex: 0 0 auto;
        width: 16.6666666667%
    }

    .col-md-auto {
        flex: 0 0 auto;
        width: auto
    }

    .col-md-1 {
        flex: 0 0 auto;
        width: 8.33333333%
    }

    .col-md-2 {
        flex: 0 0 auto;
        width: 16.66666667%
    }

    .col-md-3 {
        flex: 0 0 auto;
        width: 25%
    }

    .col-md-4 {
        flex: 0 0 auto;
        width: 33.33333333%
    }

    .col-md-5 {
        flex: 0 0 auto;
        width: 41.66666667%
    }

    .col-md-6 {
        flex: 0 0 auto;
        width: 50%
    }

    .col-md-7 {
        flex: 0 0 auto;
        width: 58.33333333%
    }

    .col-md-8 {
        flex: 0 0 auto;
        width: 66.66666667%
    }

    .col-md-9 {
        flex: 0 0 auto;
        width: 75%
    }

    .col-md-10 {
        flex: 0 0 auto;
        width: 83.33333333%
    }

    .col-md-11 {
        flex: 0 0 auto;
        width: 91.66666667%
    }

    .col-md-12 {
        flex: 0 0 auto;
        width: 100%
    }

    .offset-md-0 {
        margin-left: 0
    }

    .offset-md-1 {
        margin-left: 8.33333333%
    }

    .offset-md-2 {
        margin-left: 16.66666667%
    }

    .offset-md-3 {
        margin-left: 25%
    }

    .offset-md-4 {
        margin-left: 33.33333333%
    }

    .offset-md-5 {
        margin-left: 41.66666667%
    }

    .offset-md-6 {
        margin-left: 50%
    }

    .offset-md-7 {
        margin-left: 58.33333333%
    }

    .offset-md-8 {
        margin-left: 66.66666667%
    }

    .offset-md-9 {
        margin-left: 75%
    }

    .offset-md-10 {
        margin-left: 83.33333333%
    }

    .offset-md-11 {
        margin-left: 91.66666667%
    }

    .g-md-0,
    .gx-md-0 {
        --bs-gutter-x: 0
    }

    .g-md-0,
    .gy-md-0 {
        --bs-gutter-y: 0
    }

    .g-md-1,
    .gx-md-1 {
        --bs-gutter-x: 0.25rem
    }

    .g-md-1,
    .gy-md-1 {
        --bs-gutter-y: 0.25rem
    }

    .g-md-2,
    .gx-md-2 {
        --bs-gutter-x: 0.5rem
    }

    .g-md-2,
    .gy-md-2 {
        --bs-gutter-y: 0.5rem
    }

    .g-md-3,
    .gx-md-3 {
        --bs-gutter-x: 1rem
    }

    .g-md-3,
    .gy-md-3 {
        --bs-gutter-y: 1rem
    }

    .g-md-4,
    .gx-md-4 {
        --bs-gutter-x: 1.5rem
    }

    .g-md-4,
    .gy-md-4 {
        --bs-gutter-y: 1.5rem
    }

    .g-md-5,
    .gx-md-5 {
        --bs-gutter-x: 3rem
    }

    .g-md-5,
    .gy-md-5 {
        --bs-gutter-y: 3rem
    }
}

@media(min-width: 992px) {
    .col-lg {
        flex: 1 0
    }

    .row-cols-lg-auto>* {
        flex: 0 0 auto;
        width: auto
    }

    .row-cols-lg-1>* {
        flex: 0 0 auto;
        width: 100%
    }

    .row-cols-lg-2>* {
        flex: 0 0 auto;
        width: 50%
    }

    .row-cols-lg-3>* {
        flex: 0 0 auto;
        width: 33.3333333333%
    }

    .row-cols-lg-4>* {
        flex: 0 0 auto;
        width: 25%
    }

    .row-cols-lg-5>* {
        flex: 0 0 auto;
        width: 20%
    }

    .row-cols-lg-6>* {
        flex: 0 0 auto;
        width: 16.6666666667%
    }

    .col-lg-auto {
        flex: 0 0 auto;
        width: auto
    }

    .col-lg-1 {
        flex: 0 0 auto;
        width: 8.33333333%
    }

    .col-lg-2 {
        flex: 0 0 auto;
        width: 16.66666667%
    }

    .col-lg-3 {
        flex: 0 0 auto;
        width: 25%
    }

    .col-lg-4 {
        flex: 0 0 auto;
        width: 33.33333333%
    }

    .col-lg-5 {
        flex: 0 0 auto;
        width: 41.66666667%
    }

    .col-lg-6 {
        flex: 0 0 auto;
        width: 50%
    }

    .col-lg-7 {
        flex: 0 0 auto;
        width: 58.33333333%
    }

    .col-lg-8 {
        flex: 0 0 auto;
        width: 66.66666667%
    }

    .col-lg-9 {
        flex: 0 0 auto;
        width: 75%
    }

    .col-lg-10 {
        flex: 0 0 auto;
        width: 83.33333333%
    }

    .col-lg-11 {
        flex: 0 0 auto;
        width: 91.66666667%
    }

    .col-lg-12 {
        flex: 0 0 auto;
        width: 100%
    }

    .offset-lg-0 {
        margin-left: 0
    }

    .offset-lg-1 {
        margin-left: 8.33333333%
    }

    .offset-lg-2 {
        margin-left: 16.66666667%
    }

    .offset-lg-3 {
        margin-left: 25%
    }

    .offset-lg-4 {
        margin-left: 33.33333333%
    }

    .offset-lg-5 {
        margin-left: 41.66666667%
    }

    .offset-lg-6 {
        margin-left: 50%
    }

    .offset-lg-7 {
        margin-left: 58.33333333%
    }

    .offset-lg-8 {
        margin-left: 66.66666667%
    }

    .offset-lg-9 {
        margin-left: 75%
    }

    .offset-lg-10 {
        margin-left: 83.33333333%
    }

    .offset-lg-11 {
        margin-left: 91.66666667%
    }

    .g-lg-0,
    .gx-lg-0 {
        --bs-gutter-x: 0
    }

    .g-lg-0,
    .gy-lg-0 {
        --bs-gutter-y: 0
    }

    .g-lg-1,
    .gx-lg-1 {
        --bs-gutter-x: 0.25rem
    }

    .g-lg-1,
    .gy-lg-1 {
        --bs-gutter-y: 0.25rem
    }

    .g-lg-2,
    .gx-lg-2 {
        --bs-gutter-x: 0.5rem
    }

    .g-lg-2,
    .gy-lg-2 {
        --bs-gutter-y: 0.5rem
    }

    .g-lg-3,
    .gx-lg-3 {
        --bs-gutter-x: 1rem
    }

    .g-lg-3,
    .gy-lg-3 {
        --bs-gutter-y: 1rem
    }

    .g-lg-4,
    .gx-lg-4 {
        --bs-gutter-x: 1.5rem
    }

    .g-lg-4,
    .gy-lg-4 {
        --bs-gutter-y: 1.5rem
    }

    .g-lg-5,
    .gx-lg-5 {
        --bs-gutter-x: 3rem
    }

    .g-lg-5,
    .gy-lg-5 {
        --bs-gutter-y: 3rem
    }
}

@media(min-width: 1200px) {
    .col-xl {
        flex: 1 0
    }

    .row-cols-xl-auto>* {
        flex: 0 0 auto;
        width: auto
    }

    .row-cols-xl-1>* {
        flex: 0 0 auto;
        width: 100%
    }

    .row-cols-xl-2>* {
        flex: 0 0 auto;
        width: 50%
    }

    .row-cols-xl-3>* {
        flex: 0 0 auto;
        width: 33.3333333333%
    }

    .row-cols-xl-4>* {
        flex: 0 0 auto;
        width: 25%
    }

    .row-cols-xl-5>* {
        flex: 0 0 auto;
        width: 20%
    }

    .row-cols-xl-6>* {
        flex: 0 0 auto;
        width: 16.6666666667%
    }

    .col-xl-auto {
        flex: 0 0 auto;
        width: auto
    }

    .col-xl-1 {
        flex: 0 0 auto;
        width: 8.33333333%
    }

    .col-xl-2 {
        flex: 0 0 auto;
        width: 16.66666667%
    }

    .col-xl-3 {
        flex: 0 0 auto;
        width: 25%
    }

    .col-xl-4 {
        flex: 0 0 auto;
        width: 33.33333333%
    }

    .col-xl-5 {
        flex: 0 0 auto;
        width: 41.66666667%
    }

    .col-xl-6 {
        flex: 0 0 auto;
        width: 50%
    }

    .col-xl-7 {
        flex: 0 0 auto;
        width: 58.33333333%
    }

    .col-xl-8 {
        flex: 0 0 auto;
        width: 66.66666667%
    }

    .col-xl-9 {
        flex: 0 0 auto;
        width: 75%
    }

    .col-xl-10 {
        flex: 0 0 auto;
        width: 83.33333333%
    }

    .col-xl-11 {
        flex: 0 0 auto;
        width: 91.66666667%
    }

    .col-xl-12 {
        flex: 0 0 auto;
        width: 100%
    }

    .offset-xl-0 {
        margin-left: 0
    }

    .offset-xl-1 {
        margin-left: 8.33333333%
    }

    .offset-xl-2 {
        margin-left: 16.66666667%
    }

    .offset-xl-3 {
        margin-left: 25%
    }

    .offset-xl-4 {
        margin-left: 33.33333333%
    }

    .offset-xl-5 {
        margin-left: 41.66666667%
    }

    .offset-xl-6 {
        margin-left: 50%
    }

    .offset-xl-7 {
        margin-left: 58.33333333%
    }

    .offset-xl-8 {
        margin-left: 66.66666667%
    }

    .offset-xl-9 {
        margin-left: 75%
    }

    .offset-xl-10 {
        margin-left: 83.33333333%
    }

    .offset-xl-11 {
        margin-left: 91.66666667%
    }

    .g-xl-0,
    .gx-xl-0 {
        --bs-gutter-x: 0
    }

    .g-xl-0,
    .gy-xl-0 {
        --bs-gutter-y: 0
    }

    .g-xl-1,
    .gx-xl-1 {
        --bs-gutter-x: 0.25rem
    }

    .g-xl-1,
    .gy-xl-1 {
        --bs-gutter-y: 0.25rem
    }

    .g-xl-2,
    .gx-xl-2 {
        --bs-gutter-x: 0.5rem
    }

    .g-xl-2,
    .gy-xl-2 {
        --bs-gutter-y: 0.5rem
    }

    .g-xl-3,
    .gx-xl-3 {
        --bs-gutter-x: 1rem
    }

    .g-xl-3,
    .gy-xl-3 {
        --bs-gutter-y: 1rem
    }

    .g-xl-4,
    .gx-xl-4 {
        --bs-gutter-x: 1.5rem
    }

    .g-xl-4,
    .gy-xl-4 {
        --bs-gutter-y: 1.5rem
    }

    .g-xl-5,
    .gx-xl-5 {
        --bs-gutter-x: 3rem
    }

    .g-xl-5,
    .gy-xl-5 {
        --bs-gutter-y: 3rem
    }
}

@media(min-width: 1440) {
    .col-xxl {
        flex: 1 0
    }

    .row-cols-xxl-auto>* {
        flex: 0 0 auto;
        width: auto
    }

    .row-cols-xxl-1>* {
        flex: 0 0 auto;
        width: 100%
    }

    .row-cols-xxl-2>* {
        flex: 0 0 auto;
        width: 50%
    }

    .row-cols-xxl-3>* {
        flex: 0 0 auto;
        width: 33.3333333333%
    }

    .row-cols-xxl-4>* {
        flex: 0 0 auto;
        width: 25%
    }

    .row-cols-xxl-5>* {
        flex: 0 0 auto;
        width: 20%
    }

    .row-cols-xxl-6>* {
        flex: 0 0 auto;
        width: 16.6666666667%
    }

    .col-xxl-auto {
        flex: 0 0 auto;
        width: auto
    }

    .col-xxl-1 {
        flex: 0 0 auto;
        width: 8.33333333%
    }

    .col-xxl-2 {
        flex: 0 0 auto;
        width: 16.66666667%
    }

    .col-xxl-3 {
        flex: 0 0 auto;
        width: 25%
    }

    .col-xxl-4 {
        flex: 0 0 auto;
        width: 33.33333333%
    }

    .col-xxl-5 {
        flex: 0 0 auto;
        width: 41.66666667%
    }

    .col-xxl-6 {
        flex: 0 0 auto;
        width: 50%
    }

    .col-xxl-7 {
        flex: 0 0 auto;
        width: 58.33333333%
    }

    .col-xxl-8 {
        flex: 0 0 auto;
        width: 66.66666667%
    }

    .col-xxl-9 {
        flex: 0 0 auto;
        width: 75%
    }

    .col-xxl-10 {
        flex: 0 0 auto;
        width: 83.33333333%
    }

    .col-xxl-11 {
        flex: 0 0 auto;
        width: 91.66666667%
    }

    .col-xxl-12 {
        flex: 0 0 auto;
        width: 100%
    }

    .offset-xxl-0 {
        margin-left: 0
    }

    .offset-xxl-1 {
        margin-left: 8.33333333%
    }

    .offset-xxl-2 {
        margin-left: 16.66666667%
    }

    .offset-xxl-3 {
        margin-left: 25%
    }

    .offset-xxl-4 {
        margin-left: 33.33333333%
    }

    .offset-xxl-5 {
        margin-left: 41.66666667%
    }

    .offset-xxl-6 {
        margin-left: 50%
    }

    .offset-xxl-7 {
        margin-left: 58.33333333%
    }

    .offset-xxl-8 {
        margin-left: 66.66666667%
    }

    .offset-xxl-9 {
        margin-left: 75%
    }

    .offset-xxl-10 {
        margin-left: 83.33333333%
    }

    .offset-xxl-11 {
        margin-left: 91.66666667%
    }

    .g-xxl-0,
    .gx-xxl-0 {
        --bs-gutter-x: 0
    }

    .g-xxl-0,
    .gy-xxl-0 {
        --bs-gutter-y: 0
    }

    .g-xxl-1,
    .gx-xxl-1 {
        --bs-gutter-x: 0.25rem
    }

    .g-xxl-1,
    .gy-xxl-1 {
        --bs-gutter-y: 0.25rem
    }

    .g-xxl-2,
    .gx-xxl-2 {
        --bs-gutter-x: 0.5rem
    }

    .g-xxl-2,
    .gy-xxl-2 {
        --bs-gutter-y: 0.5rem
    }

    .g-xxl-3,
    .gx-xxl-3 {
        --bs-gutter-x: 1rem
    }

    .g-xxl-3,
    .gy-xxl-3 {
        --bs-gutter-y: 1rem
    }

    .g-xxl-4,
    .gx-xxl-4 {
        --bs-gutter-x: 1.5rem
    }

    .g-xxl-4,
    .gy-xxl-4 {
        --bs-gutter-y: 1.5rem
    }

    .g-xxl-5,
    .gx-xxl-5 {
        --bs-gutter-x: 3rem
    }

    .g-xxl-5,
    .gy-xxl-5 {
        --bs-gutter-y: 3rem
    }
}

.table {
    --bs-table-color-type: initial;
    --bs-table-bg-type: initial;
    --bs-table-color-state: initial;
    --bs-table-bg-state: initial;
    --bs-table-color: var(--bs-body-color);
    --bs-table-bg: var(--bs-body-bg);
    --bs-table-border-color: var(--bs-border-color);
    --bs-table-accent-bg: transparent;
    --bs-table-striped-color: var(--bs-body-color);
    --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
    --bs-table-active-color: var(--bs-body-color);
    --bs-table-active-bg: rgba(0, 0, 0, 0.1);
    --bs-table-hover-color: var(--bs-body-color);
    --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
    width: 100%;
    margin-bottom: 1rem;
    vertical-align: top;
    border-color: var(--bs-table-border-color)
}

.table>:not(caption)>*>* {
    padding: .5rem .5rem;
    color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
    background-color: var(--bs-table-bg);
    border-bottom-width: var(--bs-border-width);
    box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)))
}

.table>tbody {
    vertical-align: inherit
}

.table>thead {
    vertical-align: bottom
}

.table-group-divider {
    border-top: calc(var(--bs-border-width) * 2) solid currentcolor
}

.caption-top {
    caption-side: top
}

.table-sm>:not(caption)>*>* {
    padding: .25rem .25rem
}

.table-bordered>:not(caption)>* {
    border-width: var(--bs-border-width) 0
}

.table-bordered>:not(caption)>*>* {
    border-width: 0 var(--bs-border-width)
}

.table-borderless>:not(caption)>*>* {
    border-bottom-width: 0
}

.table-borderless>:not(:first-child) {
    border-top-width: 0
}

.table-striped>tbody>tr:nth-of-type(odd)>* {
    --bs-table-color-type: var(--bs-table-striped-color);
    --bs-table-bg-type: var(--bs-table-striped-bg)
}

.table-striped-columns>:not(caption)>tr>:nth-child(even) {
    --bs-table-color-type: var(--bs-table-striped-color);
    --bs-table-bg-type: var(--bs-table-striped-bg)
}

.table-active {
    --bs-table-color-state: var(--bs-table-active-color);
    --bs-table-bg-state: var(--bs-table-active-bg)
}

.table-hover>tbody>tr:hover>* {
    --bs-table-color-state: var(--bs-table-hover-color);
    --bs-table-bg-state: var(--bs-table-hover-bg)
}

.table-primary {
    --bs-table-color: #000;
    --bs-table-bg: #dddef5;
    --bs-table-border-color: #c7c8dd;
    --bs-table-striped-bg: #d2d3e9;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #c7c8dd;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #cccde3;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color)
}

.table-secondary {
    --bs-table-color: #000;
    --bs-table-bg: #fce4d6;
    --bs-table-border-color: #e3cdc1;
    --bs-table-striped-bg: #efd9cb;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #e3cdc1;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #e9d3c6;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color)
}

.table-success {
    --bs-table-color: #000;
    --bs-table-bg: #d2ece6;
    --bs-table-border-color: #bdd4cf;
    --bs-table-striped-bg: #c8e0db;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #bdd4cf;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #c2dad5;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color)
}

.table-info {
    --bs-table-color: #000;
    --bs-table-bg: #d4ddfa;
    --bs-table-border-color: #bfc7e1;
    --bs-table-striped-bg: #c9d2ee;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #bfc7e1;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #c4cce7;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color)
}

.table-warning {
    --bs-table-color: #000;
    --bs-table-bg: #ffeacf;
    --bs-table-border-color: #e6d3ba;
    --bs-table-striped-bg: #f2dec5;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #e6d3ba;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #ecd8bf;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color)
}

.table-danger {
    --bs-table-color: #000;
    --bs-table-bg: #fdd5dc;
    --bs-table-border-color: #e4c0c6;
    --bs-table-striped-bg: #f0cad1;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #e4c0c6;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #eac5cc;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color)
}

.table-light {
    --bs-table-color: #000;
    --bs-table-bg: #fff;
    --bs-table-border-color: #e6e6e6;
    --bs-table-striped-bg: #f2f2f2;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #e6e6e6;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #ececec;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color)
}

.table-dark {
    --bs-table-color: #fff;
    --bs-table-bg: var(--bs-dark);
    --bs-table-border-color: #353886;
    --bs-table-striped-bg: #2a2d7f;
    --bs-table-striped-color: #fff;
    --bs-table-active-bg: #353886;
    --bs-table-active-color: #fff;
    --bs-table-hover-bg: #303382;
    --bs-table-hover-color: #fff;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color)
}

.table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch
}

@media(max-width: 575.98px) {
    .table-responsive-sm {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }
}

@media(max-width: 767.98px) {
    .table-responsive-md {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }
}

@media(max-width: 991.98px) {
    .table-responsive-lg {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }
}

@media(max-width: 1199.98px) {
    .table-responsive-xl {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }
}

@media(max-width: 1439.98) {
    .table-responsive-xxl {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }
}

.form-label {
    margin-bottom: .5rem
}

.col-form-label {
    padding-top: calc(0.375rem + var(--bs-border-width));
    padding-bottom: calc(0.375rem + var(--bs-border-width));
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5
}

.col-form-label-lg {
    padding-top: calc(0.5rem + var(--bs-border-width));
    padding-bottom: calc(0.5rem + var(--bs-border-width));
    font-size: 1.25rem
}

.col-form-label-sm {
    padding-top: calc(0.25rem + var(--bs-border-width));
    padding-bottom: calc(0.25rem + var(--bs-border-width));
    font-size: 0.875rem
}

.form-text {
    margin-top: .25rem;
    font-size: 0.875em;
    color: var(--bs-secondary-color)
}

.form-control {
    display: block;
    width: 100%;
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    color: var(--bs-body-color);
    background-color: var(--bs-body-bg);
    background-clip: padding-box;
    border: var(--bs-border-width) solid var(--bs-border-color);
    appearance: none;
    border-radius: var(--bs-border-radius);
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media(prefers-reduced-motion: reduce) {
    .form-control {
        transition: none
    }
}

.form-control[type=file] {
    overflow: hidden
}

.form-control[type=file]:not(:disabled):not([readonly]) {
    cursor: pointer
}

.form-control:focus {
    color: var(--bs-body-color);
    background-color: var(--bs-body-bg);
    border-color: #abade7;
    outline: 0;
    box-shadow: 0 0 0 .25rem rgba(86, 90, 207, .25)
}

.form-control::-webkit-date-and-time-value {
    min-width: 85px;
    height: 1.5em;
    margin: 0
}

.form-control::-webkit-datetime-edit {
    display: block;
    padding: 0
}

.form-control::placeholder {
    color: var(--bs-secondary-color);
    opacity: 1
}

.form-control:disabled {
    background-color: var(--bs-secondary-bg);
    opacity: 1
}

.form-control::file-selector-button {
    padding: .375rem .75rem;
    margin: -0.375rem -0.75rem;
    margin-inline-end: .75rem;
    color: var(--bs-body-color);
    background-color: var(--bs-tertiary-bg);
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: var(--bs-border-width);
    border-radius: 0;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media(prefers-reduced-motion: reduce) {
    .form-control::file-selector-button {
        transition: none
    }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
    background-color: var(--bs-secondary-bg)
}

.form-control-plaintext {
    display: block;
    width: 100%;
    padding: .375rem 0;
    margin-bottom: 0;
    line-height: 1.5;
    color: var(--bs-body-color);
    background-color: rgba(0, 0, 0, 0);
    border: solid rgba(0, 0, 0, 0);
    border-width: var(--bs-border-width) 0
}

.form-control-plaintext:focus {
    outline: 0
}

.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0
}

.form-control-sm {
    min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
    padding: .25rem .5rem;
    font-size: 0.875rem;
    border-radius: var(--bs-border-radius-sm)
}

.form-control-sm::file-selector-button {
    padding: .25rem .5rem;
    margin: -0.25rem -0.5rem;
    margin-inline-end: .5rem
}

.form-control-lg {
    min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
    padding: .5rem 1rem;
    font-size: 1.25rem;
    border-radius: var(--bs-border-radius-lg)
}

.form-control-lg::file-selector-button {
    padding: .5rem 1rem;
    margin: -0.5rem -1rem;
    margin-inline-end: 1rem
}

textarea.form-control {
    min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2))
}

textarea.form-control-sm {
    min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2))
}

textarea.form-control-lg {
    min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2))
}

.form-control-color {
    width: 3rem;
    height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
    padding: .375rem
}

.form-control-color:not(:disabled):not([readonly]) {
    cursor: pointer
}

.form-control-color::-moz-color-swatch {
    border: 0 !important;
    border-radius: var(--bs-border-radius)
}

.form-control-color::-webkit-color-swatch {
    border: 0 !important;
    border-radius: var(--bs-border-radius)
}

.form-control-color.form-control-sm {
    height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2))
}

.form-control-color.form-control-lg {
    height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2))
}

.form-select {
    --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    display: block;
    width: 100%;
    padding: .375rem 2.25rem .375rem .75rem;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    color: var(--bs-body-color);
    background-color: var(--bs-body-bg);
    background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
    background-repeat: no-repeat;
    background-position: right .75rem center;
    background-size: 16px 12px;
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-radius: var(--bs-border-radius);
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    appearance: none
}

@media(prefers-reduced-motion: reduce) {
    .form-select {
        transition: none
    }
}

.form-select:focus {
    border-color: #abade7;
    outline: 0;
    box-shadow: 0 0 0 0rem rgba(86, 90, 207, .25)
}

.form-select[multiple],
.form-select[size]:not([size="1"]) {
    padding-right: .75rem;
    background-image: none
}

.form-select:disabled {
    background-color: var(--bs-secondary-bg)
}

.form-select:-moz-focusring {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0 0 0 var(--bs-body-color)
}

.form-select-sm {
    padding-top: .25rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    font-size: 0.875rem;
    border-radius: var(--bs-border-radius-sm)
}

.form-select-lg {
    padding-top: .5rem;
    padding-bottom: .5rem;
    padding-left: 1rem;
    font-size: 1.25rem;
    border-radius: var(--bs-border-radius-lg)
}

[data-bs-theme=dark] .form-select {
    --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
}

.form-check {
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5em;
    margin-bottom: .125rem
}

.form-check .form-check-input {
    float: left;
    margin-left: -1.5em
}

.form-check-reverse {
    padding-right: 1.5em;
    padding-left: 0;
    text-align: right
}

.form-check-reverse .form-check-input {
    float: right;
    margin-right: -1.5em;
    margin-left: 0
}

.form-check-input {
    --bs-form-check-bg: var(--bs-body-bg);
    width: 1em;
    height: 1em;
    margin-top: .25em;
    vertical-align: top;
    background-color: var(--bs-form-check-bg);
    background-image: var(--bs-form-check-bg-image);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: var(--bs-border-width) solid var(--bs-border-color);
    appearance: none;
    -webkit-print-color-adjust: exact;
            print-color-adjust: exact
}

.form-check-input[type=checkbox] {
    border-radius: .25em
}

.form-check-input[type=radio] {
    border-radius: 50%
}

.form-check-input:active {
    filter: brightness(90%)
}

.form-check-input:focus {
    border-color: #abade7;
    outline: 0;
    box-shadow: 0 0 0 .25rem rgba(86, 90, 207, .25)
}

.form-check-input:checked {
    background-color: #565acf;
    border-color: #565acf
}

.form-check-input:checked[type=checkbox] {
    --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
}

.form-check-input:checked[type=radio] {
    --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
}

.form-check-input[type=checkbox]:indeterminate {
    background-color: #565acf;
    border-color: #565acf;
    --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___})
}

.form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: .5
}

.form-check-input[disabled]~.form-check-label,
.form-check-input:disabled~.form-check-label {
    cursor: default;
    opacity: .5
}

.form-switch {
    padding-left: 2.5em
}

.form-switch .form-check-input {
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    width: 2em;
    margin-left: -2.5em;
    background-image: var(--bs-form-switch-bg);
    background-position: left center;
    border-radius: 2em;
    transition: background-position .15s ease-in-out
}

@media(prefers-reduced-motion: reduce) {
    .form-switch .form-check-input {
        transition: none
    }
}

.form-switch .form-check-input:focus {
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
}

.form-switch .form-check-input:checked {
    background-position: right center;
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___})
}

.form-switch.form-check-reverse {
    padding-right: 2.5em;
    padding-left: 0
}

.form-switch.form-check-reverse .form-check-input {
    margin-right: -2.5em;
    margin-left: 0
}

.form-check-inline {
    display: inline-block;
    margin-right: 1rem
}

.btn-check {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none
}

.btn-check[disabled]+.btn,
.btn-check:disabled+.btn {
    pointer-events: none;
    filter: none;
    opacity: .65
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___})
}

.form-range {
    width: 100%;
    height: 1rem;
    padding: 0;
    background-color: rgba(0, 0, 0, 0);
    appearance: none
}

.form-range:focus {
    outline: 0
}

.form-range:focus::-webkit-slider-thumb {
    box-shadow: 0 0 0 1px #fff, 0 0 0 .25rem rgba(86, 90, 207, .25)
}

.form-range:focus::-moz-range-thumb {
    box-shadow: 0 0 0 1px #fff, 0 0 0 .25rem rgba(86, 90, 207, .25)
}

.form-range::-moz-focus-outer {
    border: 0
}

.form-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    background-color: #565acf;
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    appearance: none
}

@media(prefers-reduced-motion: reduce) {
    .form-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none
    }
}

.form-range::-webkit-slider-thumb:active {
    background-color: #cccef1
}

.form-range::-webkit-slider-runnable-track {
    width: 100%;
    height: .5rem;
    color: rgba(0, 0, 0, 0);
    cursor: pointer;
    background-color: var(--bs-tertiary-bg);
    border-color: rgba(0, 0, 0, 0);
    border-radius: 1rem
}

.form-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #565acf;
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    appearance: none
}

@media(prefers-reduced-motion: reduce) {
    .form-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none
    }
}

.form-range::-moz-range-thumb:active {
    background-color: #cccef1
}

.form-range::-moz-range-track {
    width: 100%;
    height: .5rem;
    color: rgba(0, 0, 0, 0);
    cursor: pointer;
    background-color: var(--bs-tertiary-bg);
    border-color: rgba(0, 0, 0, 0);
    border-radius: 1rem
}

.form-range:disabled {
    pointer-events: none
}

.form-range:disabled::-webkit-slider-thumb {
    background-color: var(--bs-secondary-color)
}

.form-range:disabled::-moz-range-thumb {
    background-color: var(--bs-secondary-color)
}

.form-floating {
    position: relative
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext,
.form-floating>.form-select {
    height: calc(3.5rem + calc(var(--bs-border-width) * 2));
    min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
    line-height: 1.25
}

.form-floating>label {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    height: 100%;
    padding: 1rem .75rem;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
    border: var(--bs-border-width) solid rgba(0, 0, 0, 0);
    transform-origin: 0 0;
    transition: opacity .1s ease-in-out, transform .1s ease-in-out
}

@media(prefers-reduced-motion: reduce) {
    .form-floating>label {
        transition: none
    }
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext {
    padding: 1rem .75rem
}

.form-floating>.form-control::placeholder,
.form-floating>.form-control-plaintext::placeholder {
    color: rgba(0, 0, 0, 0)
}

.form-floating>.form-control:focus,
.form-floating>.form-control:not(:placeholder-shown),
.form-floating>.form-control-plaintext:focus,
.form-floating>.form-control-plaintext:not(:placeholder-shown) {
    padding-top: 1.625rem;
    padding-bottom: .625rem
}

.form-floating>.form-control:-webkit-autofill,
.form-floating>.form-control-plaintext:-webkit-autofill {
    padding-top: 1.625rem;
    padding-bottom: .625rem
}

.form-floating>.form-select {
    padding-top: 1.625rem;
    padding-bottom: .625rem
}

.form-floating>.form-control:focus~label,
.form-floating>.form-control:not(:placeholder-shown)~label,
.form-floating>.form-control-plaintext~label,
.form-floating>.form-select~label {
    color: rgba(var(--bs-body-color-rgb), 0.65);
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem)
}

.form-floating>.form-control:focus~label::after,
.form-floating>.form-control:not(:placeholder-shown)~label::after,
.form-floating>.form-control-plaintext~label::after,
.form-floating>.form-select~label::after {
    position: absolute;
    inset: 1rem .375rem;
    z-index: -1;
    height: 1.5em;
    content: "";
    background-color: var(--bs-body-bg);
    border-radius: var(--bs-border-radius)
}

.form-floating>.form-control:-webkit-autofill~label {
    color: rgba(var(--bs-body-color-rgb), 0.65);
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem)
}

.form-floating>.form-control-plaintext~label {
    border-width: var(--bs-border-width) 0
}

.form-floating>:disabled~label {
    color: #6c757d
}

.form-floating>:disabled~label::after {
    background-color: var(--bs-secondary-bg)
}

.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%
}

.input-group>.form-control,
.input-group>.form-select,
.input-group>.form-floating {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0
}

.input-group>.form-control:focus,
.input-group>.form-select:focus,
.input-group>.form-floating:focus-within {
    z-index: 5
}

.input-group .btn {
    position: relative;
    z-index: 2
}

.input-group .btn:focus {
    z-index: 5
}

.input-group-text {
    display: flex;
    align-items: center;
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    color: var(--bs-body-color);
    text-align: center;
    white-space: nowrap;
    background-color: var(--bs-tertiary-bg);
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-radius: var(--bs-border-radius)
}

.input-group-lg>.form-control,
.input-group-lg>.form-select,
.input-group-lg>.input-group-text,
.input-group-lg>.btn {
    padding: .5rem 1rem;
    font-size: 1.25rem;
    border-radius: var(--bs-border-radius-lg)
}

.input-group-sm>.form-control,
.input-group-sm>.form-select,
.input-group-sm>.input-group-text,
.input-group-sm>.btn {
    padding: .25rem .5rem;
    font-size: 0.875rem;
    border-radius: var(--bs-border-radius-sm)
}

.input-group-lg>.form-select,
.input-group-sm>.form-select {
    padding-right: 3rem
}

.input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-control,
.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-select {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.input-group.has-validation>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-control,
.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-select {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
    margin-left: calc(var(--bs-border-width) * -1);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.input-group>.form-floating:not(:first-child)>.form-control,
.input-group>.form-floating:not(:first-child)>.form-select {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.valid-feedback {
    display: none;
    width: 100%;
    margin-top: .25rem;
    font-size: 0.875em;
    color: var(--bs-form-valid-color)
}

.valid-tooltip {
    position: absolute;
    top: 100%;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: .25rem .5rem;
    margin-top: .1rem;
    font-size: 0.875rem;
    color: #fff;
    background-color: var(--bs-success);
    border-radius: var(--bs-border-radius)
}

.was-validated :valid~.valid-feedback,
.was-validated :valid~.valid-tooltip,
.is-valid~.valid-feedback,
.is-valid~.valid-tooltip {
    display: block
}

.was-validated .form-control:valid,
.form-control.is-valid {
    border-color: var(--bs-form-valid-border-color);
    padding-right: calc(1.5em + 0.75rem);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
    border-color: var(--bs-form-valid-border-color);
    box-shadow: 0 0 0 0rem rgba(var(--bs-success-rgb), 0.25)
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
    padding-right: calc(1.5em + 0.75rem);
    background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem)
}

.was-validated .form-select:valid,
.form-select.is-valid {
    border-color: var(--bs-form-valid-border-color)
}

.was-validated .form-select:valid:not([multiple]):not([size]),
.was-validated .form-select:valid:not([multiple])[size="1"],
.form-select.is-valid:not([multiple]):not([size]),
.form-select.is-valid:not([multiple])[size="1"] {
    --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    padding-right: 4.125rem;
    background-position: right .75rem center, center right 2.25rem;
    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)
}

.was-validated .form-select:valid:focus,
.form-select.is-valid:focus {
    border-color: var(--bs-form-valid-border-color);
    box-shadow: 0 0 0 0rem rgba(var(--bs-success-rgb), 0.25)
}

.was-validated .form-control-color:valid,
.form-control-color.is-valid {
    width: calc(3rem + calc(1.5em + 0.75rem))
}

.was-validated .form-check-input:valid,
.form-check-input.is-valid {
    border-color: var(--bs-form-valid-border-color)
}

.was-validated .form-check-input:valid:checked,
.form-check-input.is-valid:checked {
    background-color: var(--bs-form-valid-color)
}

.was-validated .form-check-input:valid:focus,
.form-check-input.is-valid:focus {
    box-shadow: 0 0 0 0rem rgba(var(--bs-success-rgb), 0.25)
}

.was-validated .form-check-input:valid~.form-check-label,
.form-check-input.is-valid~.form-check-label {
    color: var(--bs-form-valid-color)
}

.form-check-inline .form-check-input~.valid-feedback {
    margin-left: .5em
}

.was-validated .input-group>.form-control:not(:focus):valid,
.input-group>.form-control:not(:focus).is-valid,
.was-validated .input-group>.form-select:not(:focus):valid,
.input-group>.form-select:not(:focus).is-valid,
.was-validated .input-group>.form-floating:not(:focus-within):valid,
.input-group>.form-floating:not(:focus-within).is-valid {
    z-index: 3
}

.invalid-feedback {
    display: none;
    width: 100%;
    margin-top: .25rem;
    font-size: 0.875em;
    color: var(--bs-form-invalid-color)
}

.invalid-tooltip {
    position: absolute;
    top: 100%;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: .25rem .5rem;
    margin-top: .1rem;
    font-size: 0.875rem;
    color: #fff;
    background-color: var(--bs-danger);
    border-radius: var(--bs-border-radius)
}

.was-validated :invalid~.invalid-feedback,
.was-validated :invalid~.invalid-tooltip,
.is-invalid~.invalid-feedback,
.is-invalid~.invalid-tooltip {
    display: block
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
    border-color: var(--bs-form-invalid-border-color);
    padding-right: calc(1.5em + 0.75rem);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
    border-color: var(--bs-form-invalid-border-color);
    box-shadow: 0 0 0 0rem rgba(var(--bs-danger-rgb), 0.25)
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
    padding-right: calc(1.5em + 0.75rem);
    background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem)
}

.was-validated .form-select:invalid,
.form-select.is-invalid {
    border-color: var(--bs-form-invalid-border-color)
}

.was-validated .form-select:invalid:not([multiple]):not([size]),
.was-validated .form-select:invalid:not([multiple])[size="1"],
.form-select.is-invalid:not([multiple]):not([size]),
.form-select.is-invalid:not([multiple])[size="1"] {
    --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    padding-right: 4.125rem;
    background-position: right .75rem center, center right 2.25rem;
    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)
}

.was-validated .form-select:invalid:focus,
.form-select.is-invalid:focus {
    border-color: var(--bs-form-invalid-border-color);
    box-shadow: 0 0 0 0rem rgba(var(--bs-danger-rgb), 0.25)
}

.was-validated .form-control-color:invalid,
.form-control-color.is-invalid {
    width: calc(3rem + calc(1.5em + 0.75rem))
}

.was-validated .form-check-input:invalid,
.form-check-input.is-invalid {
    border-color: var(--bs-form-invalid-border-color)
}

.was-validated .form-check-input:invalid:checked,
.form-check-input.is-invalid:checked {
    background-color: var(--bs-form-invalid-color)
}

.was-validated .form-check-input:invalid:focus,
.form-check-input.is-invalid:focus {
    box-shadow: 0 0 0 0rem rgba(var(--bs-danger-rgb), 0.25)
}

.was-validated .form-check-input:invalid~.form-check-label,
.form-check-input.is-invalid~.form-check-label {
    color: var(--bs-form-invalid-color)
}

.form-check-inline .form-check-input~.invalid-feedback {
    margin-left: .5em
}

.was-validated .input-group>.form-control:not(:focus):invalid,
.input-group>.form-control:not(:focus).is-invalid,
.was-validated .input-group>.form-select:not(:focus):invalid,
.input-group>.form-select:not(:focus).is-invalid,
.was-validated .input-group>.form-floating:not(:focus-within):invalid,
.input-group>.form-floating:not(:focus-within).is-invalid {
    z-index: 4
}

.btn {
    --bs-btn-padding-x: 0.75rem;
    --bs-btn-padding-y: 0.375rem;
    --bs-btn-font-family: ;
    --bs-btn-font-size: 1rem;
    --bs-btn-font-weight: 400;
    --bs-btn-line-height: 1.5;
    --bs-btn-color: var(--bs-body-color);
    --bs-btn-bg: transparent;
    --bs-btn-border-width: var(--bs-border-width);
    --bs-btn-border-color: transparent;
    --bs-btn-border-radius: var(--bs-border-radius);
    --bs-btn-hover-border-color: transparent;
    --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
    --bs-btn-disabled-opacity: 0.65;
    --bs-btn-focus-box-shadow: 0 0 0 0rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
    display: inline-block;
    padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
    font-family: var(--bs-btn-font-family);
    font-size: var(--bs-btn-font-size);
    font-weight: var(--bs-btn-font-weight);
    line-height: var(--bs-btn-line-height);
    color: var(--bs-btn-color);
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
    border-radius: var(--bs-btn-border-radius);
    background-color: var(--bs-btn-bg);
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media(prefers-reduced-motion: reduce) {
    .btn {
        transition: none
    }
}

.btn:hover {
    color: var(--bs-btn-hover-color);
    background-color: #2ab4ff !important;
    border-color: #2ab4ff !important;
}

.btn-check+.btn:hover {
    color: var(--bs-btn-color);
    background-color: var(--bs-btn-bg);
    border-color: var(--bs-btn-border-color)
}

.btn:focus-visible {
    color: var(--bs-btn-hover-color);
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow)
}

.btn-check:focus-visible+.btn {
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow)
}

.btn-check:checked+.btn,
:not(.btn-check)+.btn:active,
.btn:first-child:active,
.btn.active,
.btn.show {
    color: var(--bs-btn-active-color);
    background-color: var(--bs-btn-active-bg);
    border-color: var(--bs-btn-active-border-color)
}

.btn-check:checked+.btn:focus-visible,
:not(.btn-check)+.btn:active:focus-visible,
.btn:first-child:active:focus-visible,
.btn.active:focus-visible,
.btn.show:focus-visible {
    box-shadow: var(--bs-btn-focus-box-shadow)
}

.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
    color: var(--bs-btn-disabled-color);
    pointer-events: none;
    background-color: var(--bs-btn-disabled-bg);
    border-color: var(--bs-btn-disabled-border-color);
    opacity: var(--bs-btn-disabled-opacity)
}

.btn-primary {
    --bs-btn-color: #fff;
    --bs-btn-bg: var(--bs-primary);
    --bs-btn-border-color: var(--bs-primary);
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: var(--bs-primary);
    --bs-btn-hover-border-color: var(--bs-primary);
    ;
    --bs-btn-focus-shadow-rgb: 111, 115, 214;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: var(--bs-primary);
    ;
    --bs-btn-active-border-color: #41449b;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #565acf;
    --bs-btn-disabled-border-color: #565acf;
}

.btn-secondary {
    --bs-btn-color: #000;
    --bs-btn-bg: #008bb1;
    --bs-btn-border-color: #008bb1;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #2ab4ff;
    --bs-btn-hover-border-color: #2ab4ff;
    --bs-btn-focus-shadow-rgb: 205, 101, 43;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #2ab4ff;
    --bs-btn-active-border-color: #2ab4ff;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #000;
    --bs-btn-disabled-bg: #2ab4ff;
    --bs-btn-disabled-border-color: #2ab4ff
}

.btn-success {
    --bs-btn-color: #000;
    --bs-btn-bg: #209f84;
    --bs-btn-border-color: #209f84;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #41ad96;
    --bs-btn-hover-border-color: #36a990;
    --bs-btn-focus-shadow-rgb: 27, 135, 112;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #4db29d;
    --bs-btn-active-border-color: #36a990;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #000;
    --bs-btn-disabled-bg: #209f84;
    --bs-btn-disabled-border-color: #209f84
}

.btn-info {
    --bs-btn-color: #fff;
    --bs-btn-bg: #2754e6;
    --bs-btn-border-color: #2754e6;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #2147c4;
    --bs-btn-hover-border-color: #1f43b8;
    --bs-btn-focus-shadow-rgb: 71, 110, 234;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #1f43b8;
    --bs-btn-active-border-color: #1d3fad;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #2754e6;
    --bs-btn-disabled-border-color: #2754e6
}

.btn-warning {
    --bs-btn-color: #000;
    --bs-btn-bg: #fe970e;
    --bs-btn-border-color: #fe970e;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #fea732;
    --bs-btn-hover-border-color: #fea126;
    --bs-btn-focus-shadow-rgb: 216, 128, 12;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #feac3e;
    --bs-btn-active-border-color: #fea126;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #000;
    --bs-btn-disabled-bg: #fe970e;
    --bs-btn-disabled-border-color: #fe970e
}

.btn-danger {
    --bs-btn-color: #000;
    --bs-btn-bg: #f72b50;
    --bs-btn-border-color: #f72b50;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #f84b6a;
    --bs-btn-hover-border-color: #f84062;
    --bs-btn-focus-shadow-rgb: 210, 37, 68;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #f95573;
    --bs-btn-active-border-color: #f84062;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #000;
    --bs-btn-disabled-bg: #f72b50;
    --bs-btn-disabled-border-color: #f72b50
}

.btn-light {
    --bs-btn-color: #000;
    --bs-btn-bg: #fff;
    --bs-btn-border-color: #fff;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #d9d9d9;
    --bs-btn-hover-border-color: #cccccc;
    --bs-btn-focus-shadow-rgb: 217, 217, 217;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #cccccc;
    --bs-btn-active-border-color: #bfbfbf;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #000;
    --bs-btn-disabled-bg: #fff;
    --bs-btn-disabled-border-color: #fff
}

.btn-dark {
    --bs-btn-color: #fff;
    --bs-btn-bg: var(--bs-dark);
    --bs-btn-border-color: var(--bs-dark);
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #41438c;
    --bs-btn-hover-border-color: #353886;
    --bs-btn-focus-shadow-rgb: 65, 67, 140;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #4c4e93;
    --bs-btn-active-border-color: #353886;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: var(--bs-dark);
    --bs-btn-disabled-border-color: var(--bs-dark)
}

.btn-outline-primary {
    --bs-btn-color: #fff;
    --bs-btn-bg: var(--bs-primary);
    --bs-btn-border-color: var(--bs-primary);
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: var(--bs-primary);
    --bs-btn-hover-border-color: var(--bs-primary);
    --bs-btn-focus-shadow-rgb: 111, 115, 214;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: var(--bs-primary);
    --bs-btn-active-border-color: #41449b;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #565acf;
    --bs-btn-disabled-border-color: #565acf;
    --bs-gradient: none
}

.btn-outline-secondary {
    --bs-btn-color: #f17732;
    --bs-btn-border-color: #f17732;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #f17732;
    --bs-btn-hover-border-color: #f17732;
    --bs-btn-focus-shadow-rgb: 241, 119, 50;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #f17732;
    --bs-btn-active-border-color: #f17732;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #f17732;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #f17732;
    --bs-gradient: none
}

.btn-outline-success {
    --bs-btn-color: #209f84;
    --bs-btn-border-color: #209f84;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #209f84;
    --bs-btn-hover-border-color: #209f84;
    --bs-btn-focus-shadow-rgb: 32, 159, 132;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #209f84;
    --bs-btn-active-border-color: #209f84;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #209f84;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #209f84;
    --bs-gradient: none
}

.btn-outline-info {
    --bs-btn-color: #2754e6;
    --bs-btn-border-color: #2754e6;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #2754e6;
    --bs-btn-hover-border-color: #2754e6;
    --bs-btn-focus-shadow-rgb: 39, 84, 230;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #2754e6;
    --bs-btn-active-border-color: #2754e6;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #2754e6;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #2754e6;
    --bs-gradient: none
}

.btn-outline-warning {
    --bs-btn-color: #fe970e;
    --bs-btn-border-color: #fe970e;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #fe970e;
    --bs-btn-hover-border-color: #fe970e;
    --bs-btn-focus-shadow-rgb: 254, 151, 14;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #fe970e;
    --bs-btn-active-border-color: #fe970e;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fe970e;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #fe970e;
    --bs-gradient: none
}

.btn-outline-danger {
    --bs-btn-color: #f72b50;
    --bs-btn-border-color: #f72b50;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #f72b50;
    --bs-btn-hover-border-color: #f72b50;
    --bs-btn-focus-shadow-rgb: 247, 43, 80;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #f72b50;
    --bs-btn-active-border-color: #f72b50;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #f72b50;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #f72b50;
    --bs-gradient: none
}

.btn-outline-light {
    --bs-btn-color: #fff;
    --bs-btn-border-color: #fff;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #fff;
    --bs-btn-hover-border-color: #fff;
    --bs-btn-focus-shadow-rgb: 255, 255, 255;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #fff;
    --bs-btn-active-border-color: #fff;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #fff;
    --bs-gradient: none
}

.btn-outline-dark {
    --bs-btn-color: var(--bs-dark);
    --bs-btn-border-color: var(--bs-dark);
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: var(--bs-dark);
    --bs-btn-hover-border-color: var(--bs-dark);
    --bs-btn-focus-shadow-rgb: 31, 34, 120;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: var(--bs-dark);
    --bs-btn-active-border-color: var(--bs-dark);
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: var(--bs-dark);
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: var(--bs-dark);
    --bs-gradient: none
}

.btn-link {
    --bs-btn-font-weight: 400;
    --bs-btn-color: var(--bs-link-color);
    --bs-btn-bg: transparent;
    --bs-btn-border-color: transparent;
    --bs-btn-hover-color: var(--bs-link-hover-color);
    --bs-btn-hover-border-color: transparent;
    --bs-btn-active-color: var(--bs-link-hover-color);
    --bs-btn-active-border-color: transparent;
    --bs-btn-disabled-color: #6c757d;
    --bs-btn-disabled-border-color: transparent;
    --bs-btn-box-shadow: 0 0 0 #000;
    --bs-btn-focus-shadow-rgb: 111, 115, 214;
    text-decoration: underline
}

.btn-link:focus-visible {
    color: var(--bs-btn-color)
}

.btn-link:hover {
    color: var(--bs-btn-hover-color)
}

.btn-lg,
.btn-group-lg>.btn {
    --bs-btn-padding-y: 0.5rem;
    --bs-btn-padding-x: 1rem;
    --bs-btn-font-size: 1.25rem;
    --bs-btn-border-radius: var(--bs-border-radius-lg)
}

.btn-sm,
.btn-group-sm>.btn {
    --bs-btn-padding-y: 0.25rem;
    --bs-btn-padding-x: 0.5rem;
    --bs-btn-font-size: 0.875rem;
    --bs-btn-border-radius: var(--bs-border-radius-sm)
}

.fade {
    transition: opacity .15s linear
}

@media(prefers-reduced-motion: reduce) {
    .fade {
        transition: none
    }
}

.fade:not(.show) {
    opacity: 0
}

.collapse:not(.show) {
    display: none
}

.collapsing {
    height: 0;
    overflow: hidden;
    transition: height .35s ease
}

@media(prefers-reduced-motion: reduce) {
    .collapsing {
        transition: none
    }
}

.collapsing.collapse-horizontal {
    width: 0;
    height: auto;
    transition: width .35s ease
}

@media(prefers-reduced-motion: reduce) {
    .collapsing.collapse-horizontal {
        transition: none
    }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
    position: relative
}

.dropdown-toggle {
    white-space: nowrap
}

.dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid rgba(0, 0, 0, 0);
    border-bottom: 0;
    border-left: .3em solid rgba(0, 0, 0, 0)
}

.dropdown-toggle:empty::after {
    margin-left: 0
}

.dropdown-menu {
    --bs-dropdown-zindex: 1000;
    --bs-dropdown-min-width: 10rem;
    --bs-dropdown-padding-x: 0;
    --bs-dropdown-padding-y: 0.5rem;
    --bs-dropdown-spacer: 0.125rem;
    --bs-dropdown-font-size: 1rem;
    --bs-dropdown-color: var(--bs-body-color);
    --bs-dropdown-bg: var(--bs-body-bg);
    --bs-dropdown-border-color: var(--bs-border-color-translucent);
    --bs-dropdown-border-radius: var(--bs-border-radius);
    --bs-dropdown-border-width: var(--bs-border-width);
    --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
    --bs-dropdown-divider-margin-y: 0.5rem;
    --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    --bs-dropdown-link-color: var(--bs-body-color);
    --bs-dropdown-link-hover-color: var(--bs-body-color);
    --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
    --bs-dropdown-link-active-color: #fff;
    --bs-dropdown-link-active-bg: #565acf;
    --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
    --bs-dropdown-item-padding-x: 1rem;
    --bs-dropdown-item-padding-y: 0.25rem;
    --bs-dropdown-header-color: #6c757d;
    --bs-dropdown-header-padding-x: 1rem;
    --bs-dropdown-header-padding-y: 0.5rem;
    position: absolute;
    z-index: var(--bs-dropdown-zindex);
    display: none;
    min-width: var(--bs-dropdown-min-width);
    padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
    margin: 0;
    font-size: var(--bs-dropdown-font-size);
    color: var(--bs-dropdown-color);
    text-align: left;
    list-style: none;
    background-color: var(--bs-dropdown-bg);
    background-clip: padding-box;
    border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
    border-radius: var(--bs-dropdown-border-radius)
}

.dropdown-menu[data-bs-popper] {
    top: 100%;
    left: 0;
    margin-top: var(--bs-dropdown-spacer)
}

.dropdown-menu-start {
    --bs-position: start
}

.dropdown-menu-start[data-bs-popper] {
    right: auto;
    left: 0
}

.dropdown-menu-end {
    --bs-position: end
}

.dropdown-menu-end[data-bs-popper] {
    right: 0;
    left: auto
}

@media(min-width: 576px) {
    .dropdown-menu-sm-start {
        --bs-position: start
    }

    .dropdown-menu-sm-start[data-bs-popper] {
        right: auto;
        left: 0
    }

    .dropdown-menu-sm-end {
        --bs-position: end
    }

    .dropdown-menu-sm-end[data-bs-popper] {
        right: 0;
        left: auto
    }
}

@media(min-width: 768px) {
    .dropdown-menu-md-start {
        --bs-position: start
    }

    .dropdown-menu-md-start[data-bs-popper] {
        right: auto;
        left: 0
    }

    .dropdown-menu-md-end {
        --bs-position: end
    }

    .dropdown-menu-md-end[data-bs-popper] {
        right: 0;
        left: auto
    }
}

@media(min-width: 992px) {
    .dropdown-menu-lg-start {
        --bs-position: start
    }

    .dropdown-menu-lg-start[data-bs-popper] {
        right: auto;
        left: 0
    }

    .dropdown-menu-lg-end {
        --bs-position: end
    }

    .dropdown-menu-lg-end[data-bs-popper] {
        right: 0;
        left: auto
    }
}

@media(min-width: 1200px) {
    .dropdown-menu-xl-start {
        --bs-position: start
    }

    .dropdown-menu-xl-start[data-bs-popper] {
        right: auto;
        left: 0
    }

    .dropdown-menu-xl-end {
        --bs-position: end
    }

    .dropdown-menu-xl-end[data-bs-popper] {
        right: 0;
        left: auto
    }
}

@media(min-width: 1440) {
    .dropdown-menu-xxl-start {
        --bs-position: start
    }

    .dropdown-menu-xxl-start[data-bs-popper] {
        right: auto;
        left: 0
    }

    .dropdown-menu-xxl-end {
        --bs-position: end
    }

    .dropdown-menu-xxl-end[data-bs-popper] {
        right: 0;
        left: auto
    }
}

.dropup .dropdown-menu[data-bs-popper] {
    top: auto;
    bottom: 100%;
    margin-top: 0;
    margin-bottom: var(--bs-dropdown-spacer)
}

.dropup .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: 0;
    border-right: .3em solid rgba(0, 0, 0, 0);
    border-bottom: .3em solid;
    border-left: .3em solid rgba(0, 0, 0, 0)
}

.dropup .dropdown-toggle:empty::after {
    margin-left: 0
}

.dropend .dropdown-menu[data-bs-popper] {
    top: 0;
    right: auto;
    left: 100%;
    margin-top: 0;
    margin-left: var(--bs-dropdown-spacer)
}

.dropend .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid rgba(0, 0, 0, 0);
    border-right: 0;
    border-bottom: .3em solid rgba(0, 0, 0, 0);
    border-left: .3em solid
}

.dropend .dropdown-toggle:empty::after {
    margin-left: 0
}

.dropend .dropdown-toggle::after {
    vertical-align: 0
}

.dropstart .dropdown-menu[data-bs-popper] {
    top: 0;
    right: 100%;
    left: auto;
    margin-top: 0;
    margin-right: var(--bs-dropdown-spacer)
}

.dropstart .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: ""
}

.dropstart .dropdown-toggle::after {
    display: none
}

.dropstart .dropdown-toggle::before {
    display: inline-block;
    margin-right: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid rgba(0, 0, 0, 0);
    border-right: .3em solid;
    border-bottom: .3em solid rgba(0, 0, 0, 0)
}

.dropstart .dropdown-toggle:empty::after {
    margin-left: 0
}

.dropstart .dropdown-toggle::before {
    vertical-align: 0
}

.dropdown-divider {
    height: 0;
    margin: var(--bs-dropdown-divider-margin-y) 0;
    overflow: hidden;
    border-top: 1px solid var(--bs-dropdown-divider-bg);
    opacity: 1
}

.dropdown-item {
    display: block;
    width: 100%;
    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
    clear: both;
    font-weight: 400;
    color: var(--bs-dropdown-link-color);
    text-align: inherit;
    text-decoration: none;
    white-space: nowrap;
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    border-radius: var(--bs-dropdown-item-border-radius, 0)
}

.dropdown-item:hover,
.dropdown-item:focus {
    color: var(--bs-dropdown-link-hover-color);
    background-color: var(--bs-dropdown-link-hover-bg)
}

.dropdown-item.active,
.dropdown-item:active {
    color: var(--bs-dropdown-link-active-color);
    text-decoration: none;
    background-color: var(--bs-dropdown-link-active-bg)
}

.dropdown-item.disabled,
.dropdown-item:disabled {
    color: var(--bs-dropdown-link-disabled-color);
    pointer-events: none;
    background-color: rgba(0, 0, 0, 0)
}

.dropdown-menu.show {
    display: block
}

.dropdown-header {
    display: block;
    padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
    margin-bottom: 0;
    font-size: 0.875rem;
    color: var(--bs-dropdown-header-color);
    white-space: nowrap
}

.dropdown-item-text {
    display: block;
    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
    color: var(--bs-dropdown-link-color)
}

.dropdown-menu-dark {
    --bs-dropdown-color: #dee2e6;
    --bs-dropdown-bg: #343a40;
    --bs-dropdown-border-color: var(--bs-border-color-translucent);
    --bs-dropdown-box-shadow: ;
    --bs-dropdown-link-color: #dee2e6;
    --bs-dropdown-link-hover-color: #fff;
    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
    --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
    --bs-dropdown-link-active-color: #fff;
    --bs-dropdown-link-active-bg: #565acf;
    --bs-dropdown-link-disabled-color: #adb5bd;
    --bs-dropdown-header-color: #adb5bd
}

.btn-group,
.btn-group-vertical {
    position: relative;
    display: inline-flex;
    vertical-align: middle
}

.btn-group>.btn,
.btn-group-vertical>.btn {
    position: relative;
    flex: 1 1 auto
}

.btn-group>.btn-check:checked+.btn,
.btn-group>.btn-check:focus+.btn,
.btn-group>.btn:hover,
.btn-group>.btn:focus,
.btn-group>.btn:active,
.btn-group>.btn.active,
.btn-group-vertical>.btn-check:checked+.btn,
.btn-group-vertical>.btn-check:focus+.btn,
.btn-group-vertical>.btn:hover,
.btn-group-vertical>.btn:focus,
.btn-group-vertical>.btn:active,
.btn-group-vertical>.btn.active {
    z-index: 1
}

.btn-toolbar {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start
}

.btn-toolbar .input-group {
    width: auto
}

.btn-group {
    border-radius: var(--bs-border-radius)
}

.btn-group>:not(.btn-check:first-child)+.btn,
.btn-group>.btn-group:not(:first-child) {
    margin-left: calc(var(--bs-border-width) * -1)
}

.btn-group>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn.dropdown-toggle-split:first-child,
.btn-group>.btn-group:not(:last-child)>.btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.btn-group>.btn:nth-child(n+3),
.btn-group>:not(.btn-check)+.btn,
.btn-group>.btn-group:not(:first-child)>.btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.dropdown-toggle-split {
    padding-right: .5625rem;
    padding-left: .5625rem
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropend .dropdown-toggle-split::after {
    margin-left: 0
}

.dropstart .dropdown-toggle-split::before {
    margin-right: 0
}

.btn-sm+.dropdown-toggle-split,
.btn-group-sm>.btn+.dropdown-toggle-split {
    padding-right: .375rem;
    padding-left: .375rem
}

.btn-lg+.dropdown-toggle-split,
.btn-group-lg>.btn+.dropdown-toggle-split {
    padding-right: .75rem;
    padding-left: .75rem
}

.btn-group-vertical {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center
}

.btn-group-vertical>.btn,
.btn-group-vertical>.btn-group {
    width: 100%
}

.btn-group-vertical>.btn:not(:first-child),
.btn-group-vertical>.btn-group:not(:first-child) {
    margin-top: calc(var(--bs-border-width) * -1)
}

.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical>.btn-group:not(:last-child)>.btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0
}

.btn-group-vertical>.btn~.btn,
.btn-group-vertical>.btn-group:not(:first-child)>.btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.nav {
    --bs-nav-link-padding-x: 1rem;
    --bs-nav-link-padding-y: 0.5rem;
    --bs-nav-link-font-weight: ;
    --bs-nav-link-color: var(--bs-link-color);
    --bs-nav-link-hover-color: var(--bs-link-hover-color);
    --bs-nav-link-disabled-color: var(--bs-secondary-color);
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none
}

.nav-link {
    display: block;
    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
    font-size: var(--bs-nav-link-font-size);
    font-weight: var(--bs-nav-link-font-weight);
    color: var(--bs-nav-link-color);
    text-decoration: none;
    background: none;
    border: 0;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out
}

@media(prefers-reduced-motion: reduce) {
    .nav-link {
        transition: none
    }
}

.nav-link:hover,
.nav-link:focus {
    color: var(--bs-nav-link-hover-color)
}

.nav-link:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 .25rem rgba(86, 90, 207, .25)
}

.nav-link.disabled {
    color: var(--bs-nav-link-disabled-color);
    pointer-events: none;
    cursor: default
}

.nav-tabs {
    --bs-nav-tabs-border-width: var(--bs-border-width);
    --bs-nav-tabs-border-color: var(--bs-border-color);
    --bs-nav-tabs-border-radius: var(--bs-border-radius);
    --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
    --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
    --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
    --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
    border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color)
}

.nav-tabs .nav-link {
    margin-bottom: calc(-1*var(--bs-nav-tabs-border-width));
    border: var(--bs-nav-tabs-border-width) solid rgba(0, 0, 0, 0);
    border-top-left-radius: var(--bs-nav-tabs-border-radius);
    border-top-right-radius: var(--bs-nav-tabs-border-radius)
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
    isolation: isolate;
    border-color: var(--bs-nav-tabs-link-hover-border-color)
}

.nav-tabs .nav-link.disabled,
.nav-tabs .nav-link:disabled {
    color: var(--bs-nav-link-disabled-color);
    background-color: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0)
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
    color: var(--bs-nav-tabs-link-active-color);
    background-color: var(--bs-nav-tabs-link-active-bg);
    border-color: var(--bs-nav-tabs-link-active-border-color)
}

.nav-tabs .dropdown-menu {
    margin-top: calc(-1*var(--bs-nav-tabs-border-width));
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.nav-pills {
    --bs-nav-pills-border-radius: var(--bs-border-radius);
    --bs-nav-pills-link-active-color: #fff;
    --bs-nav-pills-link-active-bg: #565acf
}

.nav-pills .nav-link {
    border-radius: var(--bs-nav-pills-border-radius)
}

.nav-pills .nav-link:disabled {
    color: var(--bs-nav-link-disabled-color);
    background-color: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0)
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    color: var(--bs-nav-pills-link-active-color);
    background-color: var(--bs-nav-pills-link-active-bg)
}

.nav-underline {
    --bs-nav-underline-gap: 1rem;
    --bs-nav-underline-border-width: 0.125rem;
    --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
    gap: var(--bs-nav-underline-gap)
}

.nav-underline .nav-link {
    padding-right: 0;
    padding-left: 0;
    border-bottom: var(--bs-nav-underline-border-width) solid rgba(0, 0, 0, 0)
}

.nav-underline .nav-link:hover,
.nav-underline .nav-link:focus {
    border-bottom-color: currentcolor
}

.nav-underline .nav-link.active,
.nav-underline .show>.nav-link {
    font-weight: 700;
    color: var(--bs-nav-underline-link-active-color);
    border-bottom-color: currentcolor
}

.nav-fill>.nav-link,
.nav-fill .nav-item {
    flex: 1 1 auto;
    text-align: center
}

.nav-justified>.nav-link,
.nav-justified .nav-item {
    flex-basis: 0;
    flex-grow: 1;
    text-align: center
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
    width: 100%
}

.tab-content>.tab-pane {
    display: none
}

.tab-content>.active {
    display: block
}

.navbar {
    --bs-navbar-padding-x: 0;
    --bs-navbar-padding-y: 0.5rem;
    --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
    --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
    --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
    --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
    --bs-navbar-brand-padding-y: 0.3125rem;
    --bs-navbar-brand-margin-end: 1rem;
    --bs-navbar-brand-font-size: 1.25rem;
    --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
    --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
    --bs-navbar-nav-link-padding-x: 0.5rem;
    --bs-navbar-toggler-padding-y: 0.25rem;
    --bs-navbar-toggler-padding-x: 0.75rem;
    --bs-navbar-toggler-font-size: 1.25rem;
    --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
    --bs-navbar-toggler-border-radius: var(--bs-border-radius);
    --bs-navbar-toggler-focus-width: 0rem;
    --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x)
}

.navbar>.container,
.navbar>.container-fluid,
.navbar>.container-sm,
.navbar>.container-md,
.navbar>.container-lg,
.navbar>.container-xl {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between
}

.navbar-brand {
    padding-top: var(--bs-navbar-brand-padding-y);
    padding-bottom: var(--bs-navbar-brand-padding-y);
    margin-right: var(--bs-navbar-brand-margin-end);
    font-size: var(--bs-navbar-brand-font-size);
    color: var(--bs-navbar-brand-color);
    text-decoration: none;
    white-space: nowrap
}

.navbar-brand:hover,
.navbar-brand:focus {
    color: var(--bs-navbar-brand-hover-color)
}

.navbar-nav {
    --bs-nav-link-padding-x: 0;
    --bs-nav-link-padding-y: 0.5rem;
    --bs-nav-link-font-weight: ;
    --bs-nav-link-color: var(--bs-navbar-color);
    --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
    --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none
}

.navbar-nav .nav-link.active,
.navbar-nav .nav-link.show {
    color: var(--bs-navbar-active-color)
}

.navbar-nav .dropdown-menu {
    position: static
}

.navbar-text {
    padding-top: .5rem;
    padding-bottom: .5rem;
    color: var(--bs-navbar-color)
}

.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
    color: var(--bs-navbar-active-color)
}

.navbar-collapse {
    flex-basis: 100%;
    flex-grow: 1;
    align-items: center
}

.navbar-toggler {
    padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
    font-size: var(--bs-navbar-toggler-font-size);
    line-height: 1;
    color: var(--bs-navbar-color);
    background-color: rgba(0, 0, 0, 0);
    border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
    border-radius: var(--bs-navbar-toggler-border-radius);
    transition: var(--bs-navbar-toggler-transition)
}

@media(prefers-reduced-motion: reduce) {
    .navbar-toggler {
        transition: none
    }
}

.navbar-toggler:hover {
    text-decoration: none
}

.navbar-toggler:focus {
    text-decoration: none;
    outline: 0;
    box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width)
}

.navbar-toggler-icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    vertical-align: middle;
    background-image: var(--bs-navbar-toggler-icon-bg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%
}

.navbar-nav-scroll {
    max-height: var(--bs-scroll-height, 75vh);
    overflow-y: auto
}

@media(min-width: 576px) {
    .navbar-expand-sm {
        flex-wrap: nowrap;
        justify-content: flex-start
    }

    .navbar-expand-sm .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x)
    }

    .navbar-expand-sm .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-sm .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-sm .navbar-toggler {
        display: none
    }

    .navbar-expand-sm .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: rgba(0, 0, 0, 0) !important;
        border: 0 !important;
        transform: none !important;
        transition: none
    }

    .navbar-expand-sm .offcanvas .offcanvas-header {
        display: none
    }

    .navbar-expand-sm .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible
    }
}

@media(min-width: 768px) {
    .navbar-expand-md {
        flex-wrap: nowrap;
        justify-content: flex-start
    }

    .navbar-expand-md .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-md .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x)
    }

    .navbar-expand-md .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-md .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-md .navbar-toggler {
        display: none
    }

    .navbar-expand-md .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: rgba(0, 0, 0, 0) !important;
        border: 0 !important;
        transform: none !important;
        transition: none
    }

    .navbar-expand-md .offcanvas .offcanvas-header {
        display: none
    }

    .navbar-expand-md .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible
    }
}

@media(min-width: 992px) {
    .navbar-expand-lg {
        flex-wrap: nowrap;
        justify-content: flex-start
    }

    .navbar-expand-lg .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x)
    }

    .navbar-expand-lg .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-lg .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-lg .navbar-toggler {
        display: none
    }

    .navbar-expand-lg .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: rgba(0, 0, 0, 0) !important;
        border: 0 !important;
        transform: none !important;
        transition: none
    }

    .navbar-expand-lg .offcanvas .offcanvas-header {
        display: none
    }

    .navbar-expand-lg .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible
    }
}

@media(min-width: 1200px) {
    .navbar-expand-xl {
        flex-wrap: nowrap;
        justify-content: flex-start
    }

    .navbar-expand-xl .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x)
    }

    .navbar-expand-xl .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-xl .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-xl .navbar-toggler {
        display: none
    }

    .navbar-expand-xl .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: rgba(0, 0, 0, 0) !important;
        border: 0 !important;
        transform: none !important;
        transition: none
    }

    .navbar-expand-xl .offcanvas .offcanvas-header {
        display: none
    }

    .navbar-expand-xl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible
    }
}

@media(min-width: 1440) {
    .navbar-expand-xxl {
        flex-wrap: nowrap;
        justify-content: flex-start
    }

    .navbar-expand-xxl .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-xxl .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-xxl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x)
    }

    .navbar-expand-xxl .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-xxl .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-xxl .navbar-toggler {
        display: none
    }

    .navbar-expand-xxl .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: rgba(0, 0, 0, 0) !important;
        border: 0 !important;
        transform: none !important;
        transition: none
    }

    .navbar-expand-xxl .offcanvas .offcanvas-header {
        display: none
    }

    .navbar-expand-xxl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible
    }
}

.navbar-expand {
    flex-wrap: nowrap;
    justify-content: flex-start
}

.navbar-expand .navbar-nav {
    flex-direction: row
}

.navbar-expand .navbar-nav .dropdown-menu {
    position: absolute
}

.navbar-expand .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x)
}

.navbar-expand .navbar-nav-scroll {
    overflow: visible
}

.navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto
}

.navbar-expand .navbar-toggler {
    display: none
}

.navbar-expand .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0 !important;
    transform: none !important;
    transition: none
}

.navbar-expand .offcanvas .offcanvas-header {
    display: none
}

.navbar-expand .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
    --bs-navbar-color: rgba(255, 255, 255, 0.55);
    --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
    --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
    --bs-navbar-active-color: #fff;
    --bs-navbar-brand-color: #fff;
    --bs-navbar-brand-hover-color: #fff;
    --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
    --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___})
}

[data-bs-theme=dark] .navbar-toggler-icon {
    --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___})
}

.card {
    --bs-card-spacer-y: 1rem;
    --bs-card-spacer-x: 1rem;
    --bs-card-title-spacer-y: 0.5rem;
    --bs-card-title-color: ;
    --bs-card-subtitle-color: ;
    --bs-card-border-width: var(--bs-border-width);
    --bs-card-border-color: var(--bs-border-color-translucent);
    --bs-card-border-radius: var(--bs-border-radius);
    --bs-card-box-shadow: ;
    --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
    --bs-card-cap-padding-y: 0.5rem;
    --bs-card-cap-padding-x: 1rem;
    --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
    --bs-card-cap-color: ;
    --bs-card-height: ;
    --bs-card-color: ;
    --bs-card-bg: var(--bs-body-bg);
    --bs-card-img-overlay-padding: 1rem;
    --bs-card-group-margin: 15px;
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    height: var(--bs-card-height);
    color: var(--bs-body-color);
    word-wrap: break-word;
    background-color: var(--bs-card-bg);
    background-clip: border-box;
    border: var(--bs-card-border-width) solid var(--bs-card-border-color);
    border-radius: var(--bs-card-border-radius)
}

.card>hr {
    margin-right: 0;
    margin-left: 0
}

.card>.list-group {
    border-top: inherit;
    border-bottom: inherit
}

.card>.list-group:first-child {
    border-top-width: 0;
    border-top-left-radius: var(--bs-card-inner-border-radius);
    border-top-right-radius: var(--bs-card-inner-border-radius)
}

.card>.list-group:last-child {
    border-bottom-width: 0;
    border-bottom-right-radius: var(--bs-card-inner-border-radius);
    border-bottom-left-radius: var(--bs-card-inner-border-radius)
}

.card>.card-header+.list-group,
.card>.list-group+.card-footer {
    border-top: 0
}

.card-body {
    flex: 1 1 auto;
    padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
    color: var(--bs-card-color)
}

.card-title {
    margin-bottom: var(--bs-card-title-spacer-y);
    color: var(--bs-card-title-color)
}

.card-subtitle {
    margin-top: calc(-0.5*var(--bs-card-title-spacer-y));
    margin-bottom: 0;
    color: var(--bs-card-subtitle-color)
}

.card-text:last-child {
    margin-bottom: 0
}

.card-link+.card-link {
    margin-left: var(--bs-card-spacer-x)
}

.card-header {
    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
    margin-bottom: 0;
    color: var(--bs-card-cap-color);
    background-color: var(--bs-card-cap-bg);
    border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color)
}

.card-header:first-child {
    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0
}

.card-footer {
    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
    color: var(--bs-card-cap-color);
    background-color: var(--bs-card-cap-bg);
    border-top: var(--bs-card-border-width) solid var(--bs-card-border-color)
}

.card-footer:last-child {
    border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius)
}

.card-header-tabs {
    margin-right: calc(-0.5*var(--bs-card-cap-padding-x));
    margin-bottom: calc(-1*var(--bs-card-cap-padding-y));
    margin-left: calc(-0.5*var(--bs-card-cap-padding-x));
    border-bottom: 0
}

.card-header-tabs .nav-link.active {
    background-color: var(--bs-card-bg);
    border-bottom-color: var(--bs-card-bg)
}

.card-header-pills {
    margin-right: calc(-0.5*var(--bs-card-cap-padding-x));
    margin-left: calc(-0.5*var(--bs-card-cap-padding-x))
}

.card-img-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: var(--bs-card-img-overlay-padding);
    border-radius: var(--bs-card-inner-border-radius)
}

.card-img,
.card-img-top,
.card-img-bottom {
    width: 100%
}

.card-img,
.card-img-top {
    border-top-left-radius: var(--bs-card-inner-border-radius);
    border-top-right-radius: var(--bs-card-inner-border-radius)
}

.card-img,
.card-img-bottom {
    border-bottom-right-radius: var(--bs-card-inner-border-radius);
    border-bottom-left-radius: var(--bs-card-inner-border-radius)
}

.card-group>.card {
    margin-bottom: var(--bs-card-group-margin)
}

@media(min-width: 576px) {
    .card-group {
        display: flex;
        flex-flow: row wrap
    }

    .card-group>.card {
        flex: 1 0;
        margin-bottom: 0
    }

    .card-group>.card+.card {
        margin-left: 0;
        border-left: 0
    }

    .card-group>.card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0
    }

    .card-group>.card:not(:last-child) .card-img-top,
    .card-group>.card:not(:last-child) .card-header {
        border-top-right-radius: 0
    }

    .card-group>.card:not(:last-child) .card-img-bottom,
    .card-group>.card:not(:last-child) .card-footer {
        border-bottom-right-radius: 0
    }

    .card-group>.card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0
    }

    .card-group>.card:not(:first-child) .card-img-top,
    .card-group>.card:not(:first-child) .card-header {
        border-top-left-radius: 0
    }

    .card-group>.card:not(:first-child) .card-img-bottom,
    .card-group>.card:not(:first-child) .card-footer {
        border-bottom-left-radius: 0
    }
}

.accordion {
    --bs-accordion-color: var(--bs-body-color);
    --bs-accordion-bg: var(--bs-body-bg);
    --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
    --bs-accordion-border-color: var(--bs-border-color);
    --bs-accordion-border-width: var(--bs-border-width);
    --bs-accordion-border-radius: var(--bs-border-radius);
    --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
    --bs-accordion-btn-padding-x: 1.25rem;
    --bs-accordion-btn-padding-y: 1rem;
    --bs-accordion-btn-color: var(--bs-body-color);
    --bs-accordion-btn-bg: var(--bs-accordion-bg);
    --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    --bs-accordion-btn-icon-width: 1.25rem;
    --bs-accordion-btn-icon-transform: rotate(-180deg);
    --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
    --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    --bs-accordion-btn-focus-border-color: #abade7;
    --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(86, 90, 207, 0.25);
    --bs-accordion-body-padding-x: 1.25rem;
    --bs-accordion-body-padding-y: 1rem;
    --bs-accordion-active-color: var(--bs-primary-text-emphasis);
    --bs-accordion-active-bg: var(--bs-primary-bg-subtle)
}

.accordion-button {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
    font-size: 1rem;
    color: var(--bs-accordion-btn-color);
    text-align: left;
    background-color: var(--bs-accordion-btn-bg);
    border: 0;
    border-radius: 0;
    overflow-anchor: none;
    transition: var(--bs-accordion-transition)
}

@media(prefers-reduced-motion: reduce) {
    .accordion-button {
        transition: none
    }
}

.accordion-button:not(.collapsed) {
    color: var(--bs-accordion-active-color);
    background-color: var(--bs-accordion-active-bg);
    box-shadow: inset 0 calc(-1*var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color)
}

.accordion-button:not(.collapsed)::after {
    background-image: var(--bs-accordion-btn-active-icon);
    transform: var(--bs-accordion-btn-icon-transform)
}

.accordion-button::after {
    flex-shrink: 0;
    width: var(--bs-accordion-btn-icon-width);
    height: var(--bs-accordion-btn-icon-width);
    margin-left: auto;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: var(--bs-accordion-btn-icon-width);
    transition: var(--bs-accordion-btn-icon-transition)
}

@media(prefers-reduced-motion: reduce) {
    .accordion-button::after {
        transition: none
    }
}

.accordion-button:hover {
    z-index: 2
}

.accordion-button:focus {
    z-index: 3;
    border-color: var(--bs-accordion-btn-focus-border-color);
    outline: 0;
    box-shadow: var(--bs-accordion-btn-focus-box-shadow)
}

.accordion-header {
    margin-bottom: 0
}

.accordion-item {
    color: var(--bs-accordion-color);
    background-color: var(--bs-accordion-bg);
    border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color)
}

.accordion-item:first-of-type {
    border-top-left-radius: var(--bs-accordion-border-radius);
    border-top-right-radius: var(--bs-accordion-border-radius)
}

.accordion-item:first-of-type .accordion-button {
    border-top-left-radius: var(--bs-accordion-inner-border-radius);
    border-top-right-radius: var(--bs-accordion-inner-border-radius)
}

.accordion-item:not(:first-of-type) {
    border-top: 0
}

.accordion-item:last-of-type {
    border-bottom-right-radius: var(--bs-accordion-border-radius);
    border-bottom-left-radius: var(--bs-accordion-border-radius)
}

.accordion-item:last-of-type .accordion-button.collapsed {
    border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
    border-bottom-left-radius: var(--bs-accordion-inner-border-radius)
}

.accordion-item:last-of-type .accordion-collapse {
    border-bottom-right-radius: var(--bs-accordion-border-radius);
    border-bottom-left-radius: var(--bs-accordion-border-radius)
}

.accordion-body {
    padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x)
}

.accordion-flush .accordion-collapse {
    border-width: 0
}

.accordion-flush .accordion-item {
    border-right: 0;
    border-left: 0;
    border-radius: 0
}

.accordion-flush .accordion-item:first-child {
    border-top: 0
}

.accordion-flush .accordion-item:last-child {
    border-bottom: 0
}

.accordion-flush .accordion-item .accordion-button,
.accordion-flush .accordion-item .accordion-button.collapsed {
    border-radius: 0
}

[data-bs-theme=dark] .accordion-button::after {
    --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___})
}

.breadcrumb {
    --bs-breadcrumb-padding-x: 0;
    --bs-breadcrumb-padding-y: 0;
    --bs-breadcrumb-margin-bottom: 1rem;
    --bs-breadcrumb-bg: ;
    --bs-breadcrumb-border-radius: ;
    --bs-breadcrumb-divider-color: var(--bs-secondary-color);
    --bs-breadcrumb-item-padding-x: 0.5rem;
    --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
    display: flex;
    flex-wrap: wrap;
    padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
    margin-bottom: var(--bs-breadcrumb-margin-bottom);
    font-size: var(--bs-breadcrumb-font-size);
    list-style: none;
    background-color: var(--bs-breadcrumb-bg);
    border-radius: var(--bs-breadcrumb-border-radius)
}

.breadcrumb-item+.breadcrumb-item {
    padding-left: var(--bs-breadcrumb-item-padding-x)
}

.breadcrumb-item+.breadcrumb-item::before {
    float: left;
    padding-right: var(--bs-breadcrumb-item-padding-x);
    color: var(--bs-breadcrumb-divider-color);
    content: var(--bs-breadcrumb-divider, "/")
        /* rtl: var(--bs-breadcrumb-divider, "/") */
}

.breadcrumb-item.active {
    color: var(--bs-breadcrumb-item-active-color)
}

.pagination {
    --bs-pagination-padding-x: 0.75rem;
    --bs-pagination-padding-y: 0.375rem;
    --bs-pagination-font-size: 1rem;
    --bs-pagination-color: var(--bs-link-color);
    --bs-pagination-bg: var(--bs-body-bg);
    --bs-pagination-border-width: var(--bs-border-width);
    --bs-pagination-border-color: var(--bs-border-color);
    --bs-pagination-border-radius: var(--bs-border-radius);
    --bs-pagination-hover-color: var(--bs-link-hover-color);
    --bs-pagination-hover-bg: var(--bs-tertiary-bg);
    --bs-pagination-hover-border-color: var(--bs-border-color);
    --bs-pagination-focus-color: var(--bs-link-hover-color);
    --bs-pagination-focus-bg: var(--bs-secondary-bg);
    --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(86, 90, 207, 0.25);
    --bs-pagination-active-color: #fff;
    --bs-pagination-active-bg: #008BB1;
    --bs-pagination-active-border-color: #008BB1;
    --bs-pagination-disabled-color: var(--bs-secondary-color);
    --bs-pagination-disabled-bg: var(--bs-secondary-bg);
    --bs-pagination-disabled-border-color: var(--bs-border-color);
    display: flex;
    padding-left: 0;
    list-style: none
}

.page-link {
    position: relative;
    display: block;
    padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
    font-size: var(--bs-pagination-font-size);
    color: var(--bs-pagination-color);
    /* color: var(--bs-primary); */
    text-decoration: none;
    background-color: var(--bs-pagination-bg);
    border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media(prefers-reduced-motion: reduce) {
    .page-link {
        transition: none
    }
}

.page-link:hover {
    z-index: 2;
    color: var(--bs-pagination-hover-color);
    background-color: var(--bs-pagination-hover-bg);
    border-color: var(--bs-pagination-hover-border-color)
}

.page-link:focus {
    z-index: 3;
    color: var(--bs-pagination-focus-color);
    background-color: var(--bs-pagination-focus-bg);
    outline: 0;
    box-shadow: var(--bs-pagination-focus-box-shadow)
}

.page-link.active,
.active>.page-link {
    z-index: 3;
    color: var(--bs-pagination-active-color);
    background-color: var(--bs-pagination-active-bg);
    border-color: var(--bs-pagination-active-border-color)
}

.page-link.disabled,
.disabled>.page-link {
    color: var(--bs-pagination-disabled-color);
    pointer-events: none;
    background-color: var(--bs-pagination-disabled-bg);
    border-color: var(--bs-pagination-disabled-border-color)
}

.page-item:not(:first-child) .page-link {
    margin-left: calc(var(--bs-border-width) * -1)
}

.page-item:first-child .page-link {
    border-top-left-radius: var(--bs-pagination-border-radius);
    border-bottom-left-radius: var(--bs-pagination-border-radius)
}

.page-item:last-child .page-link {
    border-top-right-radius: var(--bs-pagination-border-radius);
    border-bottom-right-radius: var(--bs-pagination-border-radius)
}

.pagination-lg {
    --bs-pagination-padding-x: 1.5rem;
    --bs-pagination-padding-y: 0.75rem;
    --bs-pagination-font-size: 1.25rem;
    --bs-pagination-border-radius: var(--bs-border-radius-lg)
}

.pagination-sm {
    --bs-pagination-padding-x: 0.5rem;
    --bs-pagination-padding-y: 0.25rem;
    --bs-pagination-font-size: 0.875rem;
    --bs-pagination-border-radius: var(--bs-border-radius-sm)
}

.badge {
    --bs-badge-padding-x: 0.65em;
    --bs-badge-padding-y: 0.35em;
    --bs-badge-font-size: 0.75em;
    --bs-badge-font-weight: 700;
    --bs-badge-color: #fff;
    --bs-badge-border-radius: var(--bs-border-radius);
    display: inline-block;
    padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
    font-size: var(--bs-badge-font-size);
    font-weight: var(--bs-badge-font-weight);
    line-height: 1;
    color: var(--bs-badge-color);
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: var(--bs-badge-border-radius)
}

.badge:empty {
    display: none
}

.btn .badge {
    position: relative;
    top: -1px
}

.alert {
    --bs-alert-bg: transparent;
    --bs-alert-padding-x: 1rem;
    --bs-alert-padding-y: 1rem;
    --bs-alert-margin-bottom: 1rem;
    --bs-alert-color: inherit;
    --bs-alert-border-color: transparent;
    --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
    --bs-alert-border-radius: var(--bs-border-radius);
    --bs-alert-link-color: inherit;
    position: relative;
    padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
    margin-bottom: var(--bs-alert-margin-bottom);
    color: var(--bs-alert-color);
    background-color: var(--bs-alert-bg);
    border: var(--bs-alert-border);
    border-radius: var(--bs-alert-border-radius)
}

.alert-heading {
    color: inherit
}

.alert-link {
    font-weight: 700;
    color: var(--bs-alert-link-color)
}

.alert-dismissible {
    padding-right: 3rem
}

.alert-dismissible .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 1.25rem 1rem
}

.alert-primary {
    --bs-alert-color: var(--bs-primary-text-emphasis);
    --bs-alert-bg: var(--bs-primary-bg-subtle);
    --bs-alert-border-color: var(--bs-primary-border-subtle);
    --bs-alert-link-color: var(--bs-primary-text-emphasis)
}

.alert-secondary {
    --bs-alert-color: var(--bs-secondary-text-emphasis);
    --bs-alert-bg: var(--bs-secondary-bg-subtle);
    --bs-alert-border-color: var(--bs-secondary-border-subtle);
    --bs-alert-link-color: var(--bs-secondary-text-emphasis)
}

.alert-success {
    --bs-alert-color: var(--bs-success-text-emphasis);
    --bs-alert-bg: var(--bs-success-bg-subtle);
    --bs-alert-border-color: var(--bs-success-border-subtle);
    --bs-alert-link-color: var(--bs-success-text-emphasis)
}

.alert-info {
    --bs-alert-color: var(--bs-info-text-emphasis);
    --bs-alert-bg: var(--bs-info-bg-subtle);
    --bs-alert-border-color: var(--bs-info-border-subtle);
    --bs-alert-link-color: var(--bs-info-text-emphasis)
}

.alert-warning {
    --bs-alert-color: var(--bs-warning-text-emphasis);
    --bs-alert-bg: var(--bs-warning-bg-subtle);
    --bs-alert-border-color: var(--bs-warning-border-subtle);
    --bs-alert-link-color: var(--bs-warning-text-emphasis)
}

.alert-danger {
    --bs-alert-color: var(--bs-danger-text-emphasis);
    --bs-alert-bg: var(--bs-danger-bg-subtle);
    --bs-alert-border-color: var(--bs-danger-border-subtle);
    --bs-alert-link-color: var(--bs-danger-text-emphasis)
}

.alert-light {
    --bs-alert-color: var(--bs-light-text-emphasis);
    --bs-alert-bg: var(--bs-light-bg-subtle);
    --bs-alert-border-color: var(--bs-light-border-subtle);
    --bs-alert-link-color: var(--bs-light-text-emphasis)
}

.alert-dark {
    --bs-alert-color: var(--bs-dark-text-emphasis);
    --bs-alert-bg: var(--bs-dark-bg-subtle);
    --bs-alert-border-color: var(--bs-dark-border-subtle);
    --bs-alert-link-color: var(--bs-dark-text-emphasis)
}

@keyframes progress-bar-stripes {
    0% {
        background-position-x: 1rem
    }
}

.progress,
.progress-stacked {
    --bs-progress-height: 1rem;
    --bs-progress-font-size: 0.75rem;
    --bs-progress-bg: var(--bs-secondary-bg);
    --bs-progress-border-radius: var(--bs-border-radius);
    --bs-progress-box-shadow: var(--bs-box-shadow-inset);
    --bs-progress-bar-color: #fff;
    --bs-progress-bar-bg: #565acf;
    --bs-progress-bar-transition: width 0.6s ease;
    display: flex;
    height: var(--bs-progress-height);
    overflow: hidden;
    font-size: var(--bs-progress-font-size);
    background-color: var(--bs-progress-bg);
    border-radius: var(--bs-progress-border-radius)
}

.progress-bar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    color: var(--bs-progress-bar-color);
    text-align: center;
    white-space: nowrap;
    background-color: var(--bs-progress-bar-bg);
    transition: var(--bs-progress-bar-transition)
}

@media(prefers-reduced-motion: reduce) {
    .progress-bar {
        transition: none
    }
}

.progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: var(--bs-progress-height) var(--bs-progress-height)
}

.progress-stacked>.progress {
    overflow: visible
}

.progress-stacked>.progress>.progress-bar {
    width: 100%
}

.progress-bar-animated {
    animation: 1s linear infinite progress-bar-stripes
}

@media(prefers-reduced-motion: reduce) {
    .progress-bar-animated {
        animation: none
    }
}

.list-group {
    --bs-list-group-color: var(--bs-body-color);
    --bs-list-group-bg: var(--bs-body-bg);
    --bs-list-group-border-color: var(--bs-border-color);
    --bs-list-group-border-width: var(--bs-border-width);
    --bs-list-group-border-radius: var(--bs-border-radius);
    --bs-list-group-item-padding-x: 1rem;
    --bs-list-group-item-padding-y: 0.5rem;
    --bs-list-group-action-color: var(--bs-secondary-color);
    --bs-list-group-action-hover-color: var(--bs-emphasis-color);
    --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
    --bs-list-group-action-active-color: var(--bs-body-color);
    --bs-list-group-action-active-bg: var(--bs-secondary-bg);
    --bs-list-group-disabled-color: var(--bs-secondary-color);
    --bs-list-group-disabled-bg: var(--bs-body-bg);
    --bs-list-group-active-color: #fff;
    --bs-list-group-active-bg: #565acf;
    --bs-list-group-active-border-color: #565acf;
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    border-radius: var(--bs-list-group-border-radius)
}

.list-group-numbered {
    list-style-type: none;
    counter-reset: section
}

.list-group-numbered>.list-group-item::before {
    content: counters(section, ".") ". ";
    counter-increment: section
}

.list-group-item-action {
    width: 100%;
    color: var(--bs-list-group-action-color);
    text-align: inherit
}

.list-group-item-action:hover,
.list-group-item-action:focus {
    z-index: 1;
    color: var(--bs-list-group-action-hover-color);
    text-decoration: none;
    background-color: var(--bs-list-group-action-hover-bg)
}

.list-group-item-action:active {
    color: var(--bs-list-group-action-active-color);
    background-color: var(--bs-list-group-action-active-bg)
}

.list-group-item {
    position: relative;
    display: block;
    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
    color: var(--bs-list-group-color);
    text-decoration: none;
    background-color: var(--bs-list-group-bg);
    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color)
}

.list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit
}

.list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit
}

.list-group-item.disabled,
.list-group-item:disabled {
    color: var(--bs-list-group-disabled-color);
    pointer-events: none;
    background-color: var(--bs-list-group-disabled-bg)
}

.list-group-item.active {
    z-index: 2;
    color: var(--bs-list-group-active-color);
    background-color: var(--bs-list-group-active-bg);
    border-color: var(--bs-list-group-active-border-color)
}

.list-group-item+.list-group-item {
    border-top-width: 0
}

.list-group-item+.list-group-item.active {
    margin-top: calc(-1*var(--bs-list-group-border-width));
    border-top-width: var(--bs-list-group-border-width)
}

.list-group-horizontal {
    flex-direction: row
}

.list-group-horizontal>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0
}

.list-group-horizontal>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0
}

.list-group-horizontal>.list-group-item.active {
    margin-top: 0
}

.list-group-horizontal>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0
}

.list-group-horizontal>.list-group-item+.list-group-item.active {
    margin-left: calc(-1*var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width)
}

@media(min-width: 576px) {
    .list-group-horizontal-sm {
        flex-direction: row
    }

    .list-group-horizontal-sm>.list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0
    }

    .list-group-horizontal-sm>.list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-sm>.list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-sm>.list-group-item+.list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0
    }

    .list-group-horizontal-sm>.list-group-item+.list-group-item.active {
        margin-left: calc(-1*var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width)
    }
}

@media(min-width: 768px) {
    .list-group-horizontal-md {
        flex-direction: row
    }

    .list-group-horizontal-md>.list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0
    }

    .list-group-horizontal-md>.list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-md>.list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-md>.list-group-item+.list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0
    }

    .list-group-horizontal-md>.list-group-item+.list-group-item.active {
        margin-left: calc(-1*var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width)
    }
}

@media(min-width: 992px) {
    .list-group-horizontal-lg {
        flex-direction: row
    }

    .list-group-horizontal-lg>.list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0
    }

    .list-group-horizontal-lg>.list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-lg>.list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-lg>.list-group-item+.list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0
    }

    .list-group-horizontal-lg>.list-group-item+.list-group-item.active {
        margin-left: calc(-1*var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width)
    }
}

@media(min-width: 1200px) {
    .list-group-horizontal-xl {
        flex-direction: row
    }

    .list-group-horizontal-xl>.list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0
    }

    .list-group-horizontal-xl>.list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-xl>.list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-xl>.list-group-item+.list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0
    }

    .list-group-horizontal-xl>.list-group-item+.list-group-item.active {
        margin-left: calc(-1*var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width)
    }
}

@media(min-width: 1440) {
    .list-group-horizontal-xxl {
        flex-direction: row
    }

    .list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0
    }

    .list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-xxl>.list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-xxl>.list-group-item+.list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0
    }

    .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {
        margin-left: calc(-1*var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width)
    }
}

.list-group-flush {
    border-radius: 0
}

.list-group-flush>.list-group-item {
    border-width: 0 0 var(--bs-list-group-border-width)
}

.list-group-flush>.list-group-item:last-child {
    border-bottom-width: 0
}

.list-group-item-primary {
    --bs-list-group-color: var(--bs-primary-text-emphasis);
    --bs-list-group-bg: var(--bs-primary-bg-subtle);
    --bs-list-group-border-color: var(--bs-primary-border-subtle);
    --bs-list-group-action-hover-color: var(--bs-emphasis-color);
    --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
    --bs-list-group-action-active-color: var(--bs-emphasis-color);
    --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
    --bs-list-group-active-color: var(--bs-primary-bg-subtle);
    --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
    --bs-list-group-active-border-color: var(--bs-primary-text-emphasis)
}

.list-group-item-secondary {
    --bs-list-group-color: var(--bs-secondary-text-emphasis);
    --bs-list-group-bg: var(--bs-secondary-bg-subtle);
    --bs-list-group-border-color: var(--bs-secondary-border-subtle);
    --bs-list-group-action-hover-color: var(--bs-emphasis-color);
    --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
    --bs-list-group-action-active-color: var(--bs-emphasis-color);
    --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
    --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
    --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
    --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis)
}

.list-group-item-success {
    --bs-list-group-color: var(--bs-success-text-emphasis);
    --bs-list-group-bg: var(--bs-success-bg-subtle);
    --bs-list-group-border-color: var(--bs-success-border-subtle);
    --bs-list-group-action-hover-color: var(--bs-emphasis-color);
    --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
    --bs-list-group-action-active-color: var(--bs-emphasis-color);
    --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
    --bs-list-group-active-color: var(--bs-success-bg-subtle);
    --bs-list-group-active-bg: var(--bs-success-text-emphasis);
    --bs-list-group-active-border-color: var(--bs-success-text-emphasis)
}

.list-group-item-info {
    --bs-list-group-color: var(--bs-info-text-emphasis);
    --bs-list-group-bg: var(--bs-info-bg-subtle);
    --bs-list-group-border-color: var(--bs-info-border-subtle);
    --bs-list-group-action-hover-color: var(--bs-emphasis-color);
    --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
    --bs-list-group-action-active-color: var(--bs-emphasis-color);
    --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
    --bs-list-group-active-color: var(--bs-info-bg-subtle);
    --bs-list-group-active-bg: var(--bs-info-text-emphasis);
    --bs-list-group-active-border-color: var(--bs-info-text-emphasis)
}

.list-group-item-warning {
    --bs-list-group-color: var(--bs-warning-text-emphasis);
    --bs-list-group-bg: var(--bs-warning-bg-subtle);
    --bs-list-group-border-color: var(--bs-warning-border-subtle);
    --bs-list-group-action-hover-color: var(--bs-emphasis-color);
    --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
    --bs-list-group-action-active-color: var(--bs-emphasis-color);
    --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
    --bs-list-group-active-color: var(--bs-warning-bg-subtle);
    --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
    --bs-list-group-active-border-color: var(--bs-warning-text-emphasis)
}

.list-group-item-danger {
    --bs-list-group-color: var(--bs-danger-text-emphasis);
    --bs-list-group-bg: var(--bs-danger-bg-subtle);
    --bs-list-group-border-color: var(--bs-danger-border-subtle);
    --bs-list-group-action-hover-color: var(--bs-emphasis-color);
    --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
    --bs-list-group-action-active-color: var(--bs-emphasis-color);
    --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
    --bs-list-group-active-color: var(--bs-danger-bg-subtle);
    --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
    --bs-list-group-active-border-color: var(--bs-danger-text-emphasis)
}

.list-group-item-light {
    --bs-list-group-color: var(--bs-light-text-emphasis);
    --bs-list-group-bg: var(--bs-light-bg-subtle);
    --bs-list-group-border-color: var(--bs-light-border-subtle);
    --bs-list-group-action-hover-color: var(--bs-emphasis-color);
    --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
    --bs-list-group-action-active-color: var(--bs-emphasis-color);
    --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
    --bs-list-group-active-color: var(--bs-light-bg-subtle);
    --bs-list-group-active-bg: var(--bs-light-text-emphasis);
    --bs-list-group-active-border-color: var(--bs-light-text-emphasis)
}

.list-group-item-dark {
    --bs-list-group-color: var(--bs-dark-text-emphasis);
    --bs-list-group-bg: var(--bs-dark-bg-subtle);
    --bs-list-group-border-color: var(--bs-dark-border-subtle);
    --bs-list-group-action-hover-color: var(--bs-emphasis-color);
    --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
    --bs-list-group-action-active-color: var(--bs-emphasis-color);
    --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
    --bs-list-group-active-color: var(--bs-dark-bg-subtle);
    --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
    --bs-list-group-active-border-color: var(--bs-dark-text-emphasis)
}

.btn-close {
    --bs-btn-close-color: #000;
    --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    --bs-btn-close-opacity: 0.5;
    --bs-btn-close-hover-opacity: 0.75;
    --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(86, 90, 207, 0.25);
    --bs-btn-close-focus-opacity: 1;
    --bs-btn-close-disabled-opacity: 0.25;
    --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: .25em .25em;
    color: var(--bs-btn-close-color);
    background: rgba(0, 0, 0, 0) var(--bs-btn-close-bg) center/1em auto no-repeat;
    border: 0;
    border-radius: .375rem;
    opacity: var(--bs-btn-close-opacity)
}

.btn-close:hover {
    color: var(--bs-btn-close-color);
    text-decoration: none;
    opacity: var(--bs-btn-close-hover-opacity)
}

.btn-close:focus {
    outline: 0;
    box-shadow: var(--bs-btn-close-focus-shadow);
    opacity: var(--bs-btn-close-focus-opacity)
}

.btn-close:disabled,
.btn-close.disabled {
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    opacity: var(--bs-btn-close-disabled-opacity)
}

.btn-close-white {
    filter: var(--bs-btn-close-white-filter)
}

[data-bs-theme=dark] .btn-close {
    filter: var(--bs-btn-close-white-filter)
}

.toast {
    --bs-toast-zindex: 1090;
    --bs-toast-padding-x: 0.75rem;
    --bs-toast-padding-y: 0.5rem;
    --bs-toast-spacing: 30px;
    --bs-toast-max-width: 350px;
    --bs-toast-font-size: 0.875rem;
    --bs-toast-color: ;
    --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
    --bs-toast-border-width: var(--bs-border-width);
    --bs-toast-border-color: var(--bs-border-color-translucent);
    --bs-toast-border-radius: var(--bs-border-radius);
    --bs-toast-box-shadow: var(--bs-box-shadow);
    --bs-toast-header-color: var(--bs-secondary-color);
    --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
    --bs-toast-header-border-color: var(--bs-border-color-translucent);
    width: var(--bs-toast-max-width);
    max-width: 100%;
    font-size: var(--bs-toast-font-size);
    color: var(--bs-toast-color);
    pointer-events: auto;
    background-color: var(--bs-toast-bg);
    background-clip: padding-box;
    border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
    box-shadow: var(--bs-toast-box-shadow);
    border-radius: var(--bs-toast-border-radius)
}

.toast.showing {
    opacity: 0
}

.toast:not(.show) {
    display: none
}

.toast-container {
    --bs-toast-zindex: 1090;
    position: absolute;
    z-index: var(--bs-toast-zindex);
    width: max-content;
    max-width: 100%;
    pointer-events: none
}

.toast-container>:not(:last-child) {
    margin-bottom: var(--bs-toast-spacing)
}

.toast-header {
    display: flex;
    align-items: center;
    padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
    color: var(--bs-toast-header-color);
    background-color: var(--bs-toast-header-bg);
    background-clip: padding-box;
    border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
    border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
    border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width))
}

.toast-header .btn-close {
    margin-right: calc(-0.5*var(--bs-toast-padding-x));
    margin-left: var(--bs-toast-padding-x)
}

.toast-body {
    padding: var(--bs-toast-padding-x);
    word-wrap: break-word
}

.modal {
    --bs-modal-zindex: 1055;
    --bs-modal-width: 500px;
    --bs-modal-padding: 1rem;
    --bs-modal-margin: 0.5rem;
    --bs-modal-color: ;
    --bs-modal-bg: var(--bs-body-bg);
    --bs-modal-border-color: var(--bs-border-color-translucent);
    --bs-modal-border-width: var(--bs-border-width);
    --bs-modal-border-radius: var(--bs-border-radius-lg);
    --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
    --bs-modal-header-padding-x: 1rem;
    --bs-modal-header-padding-y: 1rem;
    --bs-modal-header-padding: 1rem 1rem;
    --bs-modal-header-border-color: var(--bs-border-color);
    --bs-modal-header-border-width: var(--bs-border-width);
    --bs-modal-title-line-height: 1.5;
    --bs-modal-footer-gap: 0.5rem;
    --bs-modal-footer-bg: ;
    --bs-modal-footer-border-color: var(--bs-border-color);
    --bs-modal-footer-border-width: var(--bs-border-width);
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--bs-modal-zindex);
    display: none;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0
}

.modal-dialog {
    position: relative;
    width: auto;
    margin: var(--bs-modal-margin);
    pointer-events: none
}

.modal.fade .modal-dialog {
    transition: transform .3s ease-out;
    transform: translate(0, -50px)
}

@media(prefers-reduced-motion: reduce) {
    .modal.fade .modal-dialog {
        transition: none
    }
}

.modal.show .modal-dialog {
    transform: none
}

.modal.modal-static .modal-dialog {
    transform: scale(1.02)
}

.modal-dialog-scrollable {
    height: calc(100% - var(--bs-modal-margin)*2)
}

.modal-dialog-scrollable .modal-content {
    max-height: 100%;
    overflow: hidden
}

.modal-dialog-scrollable .modal-body {
    overflow-y: auto
}

.modal-dialog-centered {
    display: flex;
    align-items: center;
    min-height: calc(100% - var(--bs-modal-margin)*2)
}

.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    color: var(--bs-modal-color);
    pointer-events: auto;
    background-color: var(--bs-modal-bg);
    background-clip: padding-box;
    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
    border-radius: var(--bs-modal-border-radius);
    outline: 0
}

.modal-backdrop {
    --bs-backdrop-zindex: 1050;
    --bs-backdrop-bg: #000;
    --bs-backdrop-opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--bs-backdrop-zindex);
    width: 100vw;
    height: 100vh;
    background-color: var(--bs-backdrop-bg)
}

.modal-backdrop.fade {
    opacity: 0
}

.modal-backdrop.show {
    opacity: var(--bs-backdrop-opacity)
}

.modal-header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding: var(--bs-modal-header-padding);
    border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
    border-top-left-radius: var(--bs-modal-inner-border-radius);
    border-top-right-radius: var(--bs-modal-inner-border-radius)
}

.modal-header .btn-close {
    padding: calc(var(--bs-modal-header-padding-y)*.5) calc(var(--bs-modal-header-padding-x)*.5);
    margin: calc(-0.5*var(--bs-modal-header-padding-y)) calc(-0.5*var(--bs-modal-header-padding-x)) calc(-0.5*var(--bs-modal-header-padding-y)) auto
}

.modal-title {
    margin-bottom: 0;
    line-height: var(--bs-modal-title-line-height)
}

.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: var(--bs-modal-padding)
}

.modal-footer {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap)*.5);
    background-color: var(--bs-modal-footer-bg);
    border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
    border-bottom-right-radius: var(--bs-modal-inner-border-radius);
    border-bottom-left-radius: var(--bs-modal-inner-border-radius)
}

.modal-footer>* {
    margin: calc(var(--bs-modal-footer-gap)*.5)
}

@media(min-width: 576px) {
    .modal {
        --bs-modal-margin: 1.75rem;
        --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15)
    }

    .modal-dialog {
        max-width: var(--bs-modal-width);
        margin-right: auto;
        margin-left: auto
    }

    .modal-sm {
        --bs-modal-width: 300px
    }
}

@media(min-width: 992px) {

    .modal-lg,
    .modal-xl {
        --bs-modal-width: 800px
    }
}

@media(min-width: 1200px) {
    .modal-xl {
        --bs-modal-width: 1140px
    }
}

.modal-fullscreen {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0
}

.modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0
}

.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
    border-radius: 0
}

.modal-fullscreen .modal-body {
    overflow-y: auto
}

@media(max-width: 575.98px) {
    .modal-fullscreen-sm-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0
    }

    .modal-fullscreen-sm-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0
    }

    .modal-fullscreen-sm-down .modal-header,
    .modal-fullscreen-sm-down .modal-footer {
        border-radius: 0
    }

    .modal-fullscreen-sm-down .modal-body {
        overflow-y: auto
    }
}

@media(max-width: 767.98px) {
    .modal-fullscreen-md-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0
    }

    .modal-fullscreen-md-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0
    }

    .modal-fullscreen-md-down .modal-header,
    .modal-fullscreen-md-down .modal-footer {
        border-radius: 0
    }

    .modal-fullscreen-md-down .modal-body {
        overflow-y: auto
    }
}

@media(max-width: 991.98px) {
    .modal-fullscreen-lg-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0
    }

    .modal-fullscreen-lg-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0
    }

    .modal-fullscreen-lg-down .modal-header,
    .modal-fullscreen-lg-down .modal-footer {
        border-radius: 0
    }

    .modal-fullscreen-lg-down .modal-body {
        overflow-y: auto
    }
}

@media(max-width: 1199.98px) {
    .modal-fullscreen-xl-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0
    }

    .modal-fullscreen-xl-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0
    }

    .modal-fullscreen-xl-down .modal-header,
    .modal-fullscreen-xl-down .modal-footer {
        border-radius: 0
    }

    .modal-fullscreen-xl-down .modal-body {
        overflow-y: auto
    }
}

@media(max-width: 1439.98) {
    .modal-fullscreen-xxl-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0
    }

    .modal-fullscreen-xxl-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0
    }

    .modal-fullscreen-xxl-down .modal-header,
    .modal-fullscreen-xxl-down .modal-footer {
        border-radius: 0
    }

    .modal-fullscreen-xxl-down .modal-body {
        overflow-y: auto
    }
}

.tooltip {
    --bs-tooltip-zindex: 1080;
    --bs-tooltip-max-width: 200px;
    --bs-tooltip-padding-x: 0.5rem;
    --bs-tooltip-padding-y: 0.25rem;
    --bs-tooltip-margin: ;
    --bs-tooltip-font-size: 0.875rem;
    --bs-tooltip-color: var(--bs-body-bg);
    --bs-tooltip-bg: var(--bs-emphasis-color);
    --bs-tooltip-border-radius: var(--bs-border-radius);
    --bs-tooltip-opacity: 0.9;
    --bs-tooltip-arrow-width: 0.8rem;
    --bs-tooltip-arrow-height: 0.4rem;
    z-index: var(--bs-tooltip-zindex);
    display: block;
    margin: var(--bs-tooltip-margin);
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    white-space: normal;
    word-spacing: normal;
    line-break: auto;
    font-size: var(--bs-tooltip-font-size);
    word-wrap: break-word;
    opacity: 0
}

.tooltip.show {
    opacity: var(--bs-tooltip-opacity)
}

.tooltip .tooltip-arrow {
    display: block;
    width: var(--bs-tooltip-arrow-width);
    height: var(--bs-tooltip-arrow-height)
}

.tooltip .tooltip-arrow::before {
    position: absolute;
    content: "";
    border-color: rgba(0, 0, 0, 0);
    border-style: solid
}

.bs-tooltip-top .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
    bottom: calc(-1*var(--bs-tooltip-arrow-height))
}

.bs-tooltip-top .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
    top: -1px;
    border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width)*.5) 0;
    border-top-color: var(--bs-tooltip-bg)
}

.bs-tooltip-end .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
    left: calc(-1*var(--bs-tooltip-arrow-height));
    width: var(--bs-tooltip-arrow-height);
    height: var(--bs-tooltip-arrow-width)
}

.bs-tooltip-end .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
    right: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width)*.5) 0;
    border-right-color: var(--bs-tooltip-bg)
}

.bs-tooltip-bottom .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
    top: calc(-1*var(--bs-tooltip-arrow-height))
}

.bs-tooltip-bottom .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height);
    border-bottom-color: var(--bs-tooltip-bg)
}

.bs-tooltip-start .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
    right: calc(-1*var(--bs-tooltip-arrow-height));
    width: var(--bs-tooltip-arrow-height);
    height: var(--bs-tooltip-arrow-width)
}

.bs-tooltip-start .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
    left: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width)*.5) 0 calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height);
    border-left-color: var(--bs-tooltip-bg)
}

.tooltip-inner {
    max-width: var(--bs-tooltip-max-width);
    padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
    color: var(--bs-tooltip-color);
    text-align: center;
    background-color: var(--bs-tooltip-bg);
    border-radius: var(--bs-tooltip-border-radius)
}

.popover {
    --bs-popover-zindex: 1070;
    --bs-popover-max-width: 276px;
    --bs-popover-font-size: 0.875rem;
    --bs-popover-bg: var(--bs-body-bg);
    --bs-popover-border-width: var(--bs-border-width);
    --bs-popover-border-color: var(--bs-border-color-translucent);
    --bs-popover-border-radius: var(--bs-border-radius-lg);
    --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
    --bs-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    --bs-popover-header-padding-x: 1rem;
    --bs-popover-header-padding-y: 0.5rem;
    --bs-popover-header-font-size: 1rem;
    --bs-popover-header-color: #14181d;
    --bs-popover-header-bg: var(--bs-secondary-bg);
    --bs-popover-body-padding-x: 1rem;
    --bs-popover-body-padding-y: 1rem;
    --bs-popover-body-color: var(--bs-body-color);
    --bs-popover-arrow-width: 1rem;
    --bs-popover-arrow-height: 0.5rem;
    --bs-popover-arrow-border: var(--bs-popover-border-color);
    z-index: var(--bs-popover-zindex);
    display: block;
    max-width: var(--bs-popover-max-width);
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    white-space: normal;
    word-spacing: normal;
    line-break: auto;
    font-size: var(--bs-popover-font-size);
    word-wrap: break-word;
    background-color: var(--bs-popover-bg);
    background-clip: padding-box;
    border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
    border-radius: var(--bs-popover-border-radius)
}

.popover .popover-arrow {
    display: block;
    width: var(--bs-popover-arrow-width);
    height: var(--bs-popover-arrow-height)
}

.popover .popover-arrow::before,
.popover .popover-arrow::after {
    position: absolute;
    display: block;
    content: "";
    border-color: rgba(0, 0, 0, 0);
    border-style: solid;
    border-width: 0
}

.bs-popover-top>.popover-arrow,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow {
    bottom: calc(-1*(var(--bs-popover-arrow-height)) - var(--bs-popover-border-width))
}

.bs-popover-top>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,
.bs-popover-top>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {
    border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width)*.5) 0
}

.bs-popover-top>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before {
    bottom: 0;
    border-top-color: var(--bs-popover-arrow-border)
}

.bs-popover-top>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {
    bottom: var(--bs-popover-border-width);
    border-top-color: var(--bs-popover-bg)
}

.bs-popover-end>.popover-arrow,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow {
    left: calc(-1*(var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
    width: var(--bs-popover-arrow-height);
    height: var(--bs-popover-arrow-width)
}

.bs-popover-end>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,
.bs-popover-end>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width)*.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width)*.5) 0
}

.bs-popover-end>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before {
    left: 0;
    border-right-color: var(--bs-popover-arrow-border)
}

.bs-popover-end>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {
    left: var(--bs-popover-border-width);
    border-right-color: var(--bs-popover-bg)
}

.bs-popover-bottom>.popover-arrow,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow {
    top: calc(-1*(var(--bs-popover-arrow-height)) - var(--bs-popover-border-width))
}

.bs-popover-bottom>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,
.bs-popover-bottom>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {
    border-width: 0 calc(var(--bs-popover-arrow-width)*.5) var(--bs-popover-arrow-height)
}

.bs-popover-bottom>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before {
    top: 0;
    border-bottom-color: var(--bs-popover-arrow-border)
}

.bs-popover-bottom>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {
    top: var(--bs-popover-border-width);
    border-bottom-color: var(--bs-popover-bg)
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: var(--bs-popover-arrow-width);
    margin-left: calc(-0.5*var(--bs-popover-arrow-width));
    content: "";
    border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg)
}

.bs-popover-start>.popover-arrow,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow {
    right: calc(-1*(var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
    width: var(--bs-popover-arrow-height);
    height: var(--bs-popover-arrow-width)
}

.bs-popover-start>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,
.bs-popover-start>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width)*.5) 0 calc(var(--bs-popover-arrow-width)*.5) var(--bs-popover-arrow-height)
}

.bs-popover-start>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before {
    right: 0;
    border-left-color: var(--bs-popover-arrow-border)
}

.bs-popover-start>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {
    right: var(--bs-popover-border-width);
    border-left-color: var(--bs-popover-bg)
}

.popover-header {
    padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
    margin-bottom: 0;
    font-size: var(--bs-popover-header-font-size);
    color: var(--bs-popover-header-color);
    background-color: var(--bs-popover-header-bg);
    border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
    border-top-left-radius: var(--bs-popover-inner-border-radius);
    border-top-right-radius: var(--bs-popover-inner-border-radius)
}

.popover-header:empty {
    display: none
}

.popover-body {
    padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
    color: var(--bs-popover-body-color)
}

.carousel {
    position: relative
}

.carousel.pointer-event {
    touch-action: pan-y
}

.carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden
}

.carousel-inner::after {
    display: block;
    clear: both;
    content: ""
}

.carousel-item {
    position: relative;
    display: none;
    float: left;
    width: 100%;
    margin-right: -100%;
    backface-visibility: hidden;
    transition: transform .6s ease-in-out
}

@media(prefers-reduced-motion: reduce) {
    .carousel-item {
        transition: none
    }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
    display: block
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
    transform: translateX(100%)
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
    transform: translateX(-100%)
}

.carousel-fade .carousel-item {
    opacity: 0;
    transition-property: opacity;
    transform: none
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
    z-index: 1;
    opacity: 1
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
    z-index: 0;
    opacity: 0;
    transition: opacity 0s .6s
}

@media(prefers-reduced-motion: reduce) {

    .carousel-fade .active.carousel-item-start,
    .carousel-fade .active.carousel-item-end {
        transition: none
    }
}

.carousel-control-prev,
.carousel-control-next {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15%;
    padding: 0;
    color: #fff;
    text-align: center;
    background: none;
    border: 0;
    opacity: .5;
    transition: opacity .15s ease
}

@media(prefers-reduced-motion: reduce) {

    .carousel-control-prev,
    .carousel-control-next {
        transition: none
    }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: .9
}

.carousel-control-prev {
    left: 0
}

.carousel-control-next {
    right: 0
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: 100% 100%
}

.carousel-control-prev-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___})
}

.carousel-control-next-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___})
}

.carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    padding: 0;
    margin-right: 15%;
    margin-bottom: 1rem;
    margin-left: 15%
}

.carousel-indicators [data-bs-target] {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    padding: 0;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border: 0;
    border-top: 10px solid rgba(0, 0, 0, 0);
    border-bottom: 10px solid rgba(0, 0, 0, 0);
    opacity: .5;
    transition: opacity .6s ease
}

@media(prefers-reduced-motion: reduce) {
    .carousel-indicators [data-bs-target] {
        transition: none
    }
}

.carousel-indicators .active {
    opacity: 1
}

.carousel-caption {
    position: absolute;
    right: 15%;
    bottom: 1.25rem;
    left: 15%;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
    color: #fff;
    text-align: center
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
    filter: invert(1) grayscale(100)
}

.carousel-dark .carousel-indicators [data-bs-target] {
    background-color: #000
}

.carousel-dark .carousel-caption {
    color: #000
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon,
[data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
    filter: invert(1) grayscale(100)
}

[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target],
[data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
    background-color: #000
}

[data-bs-theme=dark] .carousel .carousel-caption,
[data-bs-theme=dark].carousel .carousel-caption {
    color: #000
}

.spinner-grow,
.spinner-border {
    display: inline-block;
    width: var(--bs-spinner-width);
    height: var(--bs-spinner-height);
    vertical-align: var(--bs-spinner-vertical-align);
    border-radius: 50%;
    animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name)
}

@keyframes spinner-border {
    to {
        transform: rotate(360deg)
            /* rtl:ignore */
    }
}

.spinner-border {
    --bs-spinner-width: 2rem;
    --bs-spinner-height: 2rem;
    --bs-spinner-vertical-align: -0.125em;
    --bs-spinner-border-width: 0.25em;
    --bs-spinner-animation-speed: 0.75s;
    --bs-spinner-animation-name: spinner-border;
    border: var(--bs-spinner-border-width) solid currentcolor;
    border-right-color: rgba(0, 0, 0, 0)
}

.spinner-border-sm {
    --bs-spinner-width: 1rem;
    --bs-spinner-height: 1rem;
    --bs-spinner-border-width: 0.2em
}

@keyframes spinner-grow {
    0% {
        transform: scale(0)
    }

    50% {
        opacity: 1;
        transform: none
    }
}

.spinner-grow {
    --bs-spinner-width: 2rem;
    --bs-spinner-height: 2rem;
    --bs-spinner-vertical-align: -0.125em;
    --bs-spinner-animation-speed: 0.75s;
    --bs-spinner-animation-name: spinner-grow;
    background-color: currentcolor;
    opacity: 0
}

.spinner-grow-sm {
    --bs-spinner-width: 1rem;
    --bs-spinner-height: 1rem
}

@media(prefers-reduced-motion: reduce) {

    .spinner-border,
    .spinner-grow {
        --bs-spinner-animation-speed: 1.5s
    }
}

.offcanvas,
.offcanvas-xxl,
.offcanvas-xl,
.offcanvas-lg,
.offcanvas-md,
.offcanvas-sm {
    --bs-offcanvas-zindex: 1045;
    --bs-offcanvas-width: 400px;
    --bs-offcanvas-height: 30vh;
    --bs-offcanvas-padding-x: 1rem;
    --bs-offcanvas-padding-y: 1rem;
    --bs-offcanvas-color: var(--bs-body-color);
    --bs-offcanvas-bg: var(--bs-body-bg);
    --bs-offcanvas-border-width: var(--bs-border-width);
    --bs-offcanvas-border-color: var(--bs-border-color-translucent);
    --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    --bs-offcanvas-transition: transform 0.3s ease-in-out;
    --bs-offcanvas-title-line-height: 1.5
}

@media(max-width: 575.98px) {
    .offcanvas-sm {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: var(--bs-offcanvas-transition)
    }
}

@media(max-width: 575.98px)and (prefers-reduced-motion: reduce) {
    .offcanvas-sm {
        transition: none
    }
}

@media(max-width: 575.98px) {
    .offcanvas-sm.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%)
    }

    .offcanvas-sm.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%)
    }

    .offcanvas-sm.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%)
    }

    .offcanvas-sm.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%)
    }

    .offcanvas-sm.showing,
    .offcanvas-sm.show:not(.hiding) {
        transform: none
    }

    .offcanvas-sm.showing,
    .offcanvas-sm.hiding,
    .offcanvas-sm.show {
        visibility: visible
    }
}

@media(min-width: 576px) {
    .offcanvas-sm {
        --bs-offcanvas-height: auto;
        --bs-offcanvas-border-width: 0;
        background-color: rgba(0, 0, 0, 0) !important
    }

    .offcanvas-sm .offcanvas-header {
        display: none
    }

    .offcanvas-sm .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: rgba(0, 0, 0, 0) !important
    }
}

@media(max-width: 767.98px) {
    .offcanvas-md {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: var(--bs-offcanvas-transition)
    }
}

@media(max-width: 767.98px)and (prefers-reduced-motion: reduce) {
    .offcanvas-md {
        transition: none
    }
}

@media(max-width: 767.98px) {
    .offcanvas-md.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%)
    }

    .offcanvas-md.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%)
    }

    .offcanvas-md.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%)
    }

    .offcanvas-md.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%)
    }

    .offcanvas-md.showing,
    .offcanvas-md.show:not(.hiding) {
        transform: none
    }

    .offcanvas-md.showing,
    .offcanvas-md.hiding,
    .offcanvas-md.show {
        visibility: visible
    }
}

@media(min-width: 768px) {
    .offcanvas-md {
        --bs-offcanvas-height: auto;
        --bs-offcanvas-border-width: 0;
        background-color: rgba(0, 0, 0, 0) !important
    }

    .offcanvas-md .offcanvas-header {
        display: none
    }

    .offcanvas-md .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: rgba(0, 0, 0, 0) !important
    }
}

@media(max-width: 991.98px) {
    .offcanvas-lg {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: var(--bs-offcanvas-transition)
    }
}

@media(max-width: 991.98px)and (prefers-reduced-motion: reduce) {
    .offcanvas-lg {
        transition: none
    }
}

@media(max-width: 991.98px) {
    .offcanvas-lg.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%)
    }

    .offcanvas-lg.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%)
    }

    .offcanvas-lg.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%)
    }

    .offcanvas-lg.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%)
    }

    .offcanvas-lg.showing,
    .offcanvas-lg.show:not(.hiding) {
        transform: none
    }

    .offcanvas-lg.showing,
    .offcanvas-lg.hiding,
    .offcanvas-lg.show {
        visibility: visible
    }
}

@media(min-width: 992px) {
    .offcanvas-lg {
        --bs-offcanvas-height: auto;
        --bs-offcanvas-border-width: 0;
        background-color: rgba(0, 0, 0, 0) !important
    }

    .offcanvas-lg .offcanvas-header {
        display: none
    }

    .offcanvas-lg .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: rgba(0, 0, 0, 0) !important
    }
}

@media(max-width: 1199.98px) {
    .offcanvas-xl {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: var(--bs-offcanvas-transition)
    }
}

@media(max-width: 1199.98px)and (prefers-reduced-motion: reduce) {
    .offcanvas-xl {
        transition: none
    }
}

@media(max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%)
    }

    .offcanvas-xl.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%)
    }

    .offcanvas-xl.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%)
    }

    .offcanvas-xl.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%)
    }

    .offcanvas-xl.showing,
    .offcanvas-xl.show:not(.hiding) {
        transform: none
    }

    .offcanvas-xl.showing,
    .offcanvas-xl.hiding,
    .offcanvas-xl.show {
        visibility: visible
    }
}

@media(min-width: 1200px) {
    .offcanvas-xl {
        --bs-offcanvas-height: auto;
        --bs-offcanvas-border-width: 0;
        background-color: rgba(0, 0, 0, 0) !important
    }

    .offcanvas-xl .offcanvas-header {
        display: none
    }

    .offcanvas-xl .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: rgba(0, 0, 0, 0) !important
    }
}

@media(max-width: 1439.98) {
    .offcanvas-xxl {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: var(--bs-offcanvas-transition)
    }
}

@media(max-width: 1439.98)and (prefers-reduced-motion: reduce) {
    .offcanvas-xxl {
        transition: none
    }
}

@media(max-width: 1439.98) {
    .offcanvas-xxl.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%)
    }

    .offcanvas-xxl.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%)
    }

    .offcanvas-xxl.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%)
    }

    .offcanvas-xxl.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%)
    }

    .offcanvas-xxl.showing,
    .offcanvas-xxl.show:not(.hiding) {
        transform: none
    }

    .offcanvas-xxl.showing,
    .offcanvas-xxl.hiding,
    .offcanvas-xxl.show {
        visibility: visible
    }
}

@media(min-width: 1440) {
    .offcanvas-xxl {
        --bs-offcanvas-height: auto;
        --bs-offcanvas-border-width: 0;
        background-color: rgba(0, 0, 0, 0) !important
    }

    .offcanvas-xxl .offcanvas-header {
        display: none
    }

    .offcanvas-xxl .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: rgba(0, 0, 0, 0) !important
    }
}

.offcanvas {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition)
}

@media(prefers-reduced-motion: reduce) {
    .offcanvas {
        transition: none
    }
}

.offcanvas.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%)
}

.offcanvas.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%)
}

.offcanvas.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%)
}

.offcanvas.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%)
}

.offcanvas.showing,
.offcanvas.show:not(.hiding) {
    transform: none
}

.offcanvas.showing,
.offcanvas.hiding,
.offcanvas.show {
    visibility: visible
}

.offcanvas-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #000
}

.offcanvas-backdrop.fade {
    opacity: 0
}

.offcanvas-backdrop.show {
    opacity: .5
}

.offcanvas-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x)
}

.offcanvas-header .btn-close {
    padding: calc(var(--bs-offcanvas-padding-y)*.5) calc(var(--bs-offcanvas-padding-x)*.5);
    margin-top: calc(-0.5*var(--bs-offcanvas-padding-y));
    margin-right: calc(-0.5*var(--bs-offcanvas-padding-x));
    margin-bottom: calc(-0.5*var(--bs-offcanvas-padding-y))
}

.offcanvas-title {
    margin-bottom: 0;
    line-height: var(--bs-offcanvas-title-line-height)
}

.offcanvas-body {
    flex-grow: 1;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
    overflow-y: auto
}

.placeholder {
    display: inline-block;
    min-height: 1em;
    vertical-align: middle;
    cursor: wait;
    background-color: currentcolor;
    opacity: .5
}

.placeholder.btn::before {
    display: inline-block;
    content: ""
}

.placeholder-xs {
    min-height: .6em
}

.placeholder-sm {
    min-height: .8em
}

.placeholder-lg {
    min-height: 1.2em
}

.placeholder-glow .placeholder {
    animation: placeholder-glow 2s ease-in-out infinite
}

@keyframes placeholder-glow {
    50% {
        opacity: .2
    }
}

.placeholder-wave {
    mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
    mask-size: 200% 100%;
    animation: placeholder-wave 2s linear infinite
}

@keyframes placeholder-wave {
    100% {
        mask-position: -200% 0%
    }
}

.clearfix::after {
    display: block;
    clear: both;
    content: ""
}

.text-bg-primary {
    color: #fff !important;
    background-color: RGBA(86, 90, 207, var(--bs-bg-opacity, 1)) !important
}

.text-bg-secondary {
    color: #000 !important;
    background-color: RGBA(241, 119, 50, var(--bs-bg-opacity, 1)) !important
}

.text-bg-success {
    color: #000 !important;
    background-color: RGBA(32, 159, 132, var(--bs-bg-opacity, 1)) !important
}

.text-bg-info {
    color: #fff !important;
    background-color: RGBA(39, 84, 230, var(--bs-bg-opacity, 1)) !important
}

.text-bg-warning {
    color: #000 !important;
    background-color: RGBA(254, 151, 14, var(--bs-bg-opacity, 1)) !important
}

.text-bg-danger {
    color: #000 !important;
    background-color: RGBA(247, 43, 80, var(--bs-bg-opacity, 1)) !important
}

.text-bg-light {
    color: #000 !important;
    background-color: RGBA(255, 255, 255, var(--bs-bg-opacity, 1)) !important
}

.text-bg-dark {
    color: #fff !important;
    background-color: RGBA(31, 34, 120, var(--bs-bg-opacity, 1)) !important
}

.link-primary {
    color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-primary:hover,
.link-primary:focus {
    color: RGBA(69, 72, 166, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(69, 72, 166, var(--bs-link-underline-opacity, 1)) !important
}

.link-secondary {
    color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-secondary:hover,
.link-secondary:focus {
    color: RGBA(244, 146, 91, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(244, 146, 91, var(--bs-link-underline-opacity, 1)) !important
}

.link-success {
    color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-success:hover,
.link-success:focus {
    color: RGBA(77, 178, 157, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(77, 178, 157, var(--bs-link-underline-opacity, 1)) !important
}

.link-info {
    color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-info:hover,
.link-info:focus {
    color: RGBA(31, 67, 184, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(31, 67, 184, var(--bs-link-underline-opacity, 1)) !important
}

.link-warning {
    color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-warning:hover,
.link-warning:focus {
    color: RGBA(254, 172, 62, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(254, 172, 62, var(--bs-link-underline-opacity, 1)) !important
}

.link-danger {
    color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-danger:hover,
.link-danger:focus {
    color: RGBA(249, 85, 115, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(249, 85, 115, var(--bs-link-underline-opacity, 1)) !important
}

.link-light {
    color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-light:hover,
.link-light:focus {
    color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important
}

.link-dark {
    color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-dark:hover,
.link-dark:focus {
    color: RGBA(25, 27, 96, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(25, 27, 96, var(--bs-link-underline-opacity, 1)) !important
}

.link-body-emphasis {
    color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-body-emphasis:hover,
.link-body-emphasis:focus {
    color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
    text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important
}

.focus-ring:focus {
    outline: 0;
    box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color)
}

.icon-link {
    display: inline-flex;
    gap: .375rem;
    align-items: center;
    text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
    text-underline-offset: .25em;
    backface-visibility: hidden
}

.icon-link>.bi {
    flex-shrink: 0;
    width: 1em;
    height: 1em;
    fill: currentcolor;
    transition: .2s ease-in-out transform
}

@media(prefers-reduced-motion: reduce) {
    .icon-link>.bi {
        transition: none
    }
}

.icon-link-hover:hover>.bi,
.icon-link-hover:focus-visible>.bi {
    transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0))
}

.ratio {
    position: relative;
    width: 100%
}

.ratio::before {
    display: block;
    padding-top: var(--bs-aspect-ratio);
    content: ""
}

.ratio>* {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%
}

.ratio-1x1 {
    --bs-aspect-ratio: 100%
}

.ratio-4x3 {
    --bs-aspect-ratio: 75%
}

.ratio-16x9 {
    --bs-aspect-ratio: 56.25%
}

.ratio-21x9 {
    --bs-aspect-ratio: 42.8571428571%
}

.fixed-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030
}

.fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030
}

.sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020
}

.sticky-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020
}

@media(min-width: 576px) {
    .sticky-sm-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }

    .sticky-sm-bottom {
        position: sticky;
        bottom: 0;
        z-index: 1020
    }
}

@media(min-width: 768px) {
    .sticky-md-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }

    .sticky-md-bottom {
        position: sticky;
        bottom: 0;
        z-index: 1020
    }
}

@media(min-width: 992px) {
    .sticky-lg-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }

    .sticky-lg-bottom {
        position: sticky;
        bottom: 0;
        z-index: 1020
    }
}

@media(min-width: 1200px) {
    .sticky-xl-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }

    .sticky-xl-bottom {
        position: sticky;
        bottom: 0;
        z-index: 1020
    }
}

@media(min-width: 1440) {
    .sticky-xxl-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }

    .sticky-xxl-bottom {
        position: sticky;
        bottom: 0;
        z-index: 1020
    }
}

.hstack {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: stretch
}

.vstack {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-self: stretch
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important
}

.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
    position: absolute !important
}

.stretched-link::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    content: ""
}

.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.vr {
    display: inline-block;
    align-self: stretch;
    width: 1px;
    min-height: 1em;
    background-color: currentcolor;
    opacity: .25
}

.align-baseline {
    vertical-align: baseline !important
}

.align-top {
    vertical-align: top !important
}

.align-middle {
    vertical-align: middle !important
}

.align-bottom {
    vertical-align: bottom !important
}

.align-text-bottom {
    vertical-align: text-bottom !important
}

.align-text-top {
    vertical-align: text-top !important
}

.float-start {
    float: left !important
}

.float-end {
    float: right !important
}

.float-none {
    float: none !important
}

.object-fit-contain {
    object-fit: contain !important
}

.object-fit-cover {
    object-fit: cover !important
}

.object-fit-fill {
    object-fit: fill !important
}

.object-fit-scale {
    object-fit: scale-down !important
}

.object-fit-none {
    object-fit: none !important
}

.opacity-0 {
    opacity: 0 !important
}

.opacity-25 {
    opacity: .25 !important
}

.opacity-50 {
    opacity: .5 !important
}

.opacity-75 {
    opacity: .75 !important
}

.opacity-100 {
    opacity: 1 !important
}

.overflow-auto {
    overflow: auto !important
}

.overflow-hidden {
    overflow: hidden !important
}

.overflow-visible {
    overflow: visible !important
}

.overflow-scroll {
    overflow: scroll !important
}

.overflow-x-auto {
    overflow-x: auto !important
}

.overflow-x-hidden {
    overflow-x: hidden !important
}

.overflow-x-visible {
    overflow-x: visible !important
}

.overflow-x-scroll {
    overflow-x: scroll !important
}

.overflow-y-auto {
    overflow-y: auto !important
}

.overflow-y-hidden {
    overflow-y: hidden !important
}

.overflow-y-visible {
    overflow-y: visible !important
}

.overflow-y-scroll {
    overflow-y: scroll !important
}

.d-inline {
    display: inline !important
}

.d-inline-block {
    display: inline-block !important
}

.d-block {
    display: block !important
}

.d-grid {
    display: grid !important
}

.d-inline-grid {
    display: inline-grid !important
}

.d-table {
    display: table !important
}

.d-table-row {
    display: table-row !important
}

.d-table-cell {
    display: table-cell !important
}

.d-flex {
    display: flex !important
}

.d-inline-flex {
    display: inline-flex !important
}

.d-none {
    display: none !important
}

.shadow {
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important
}

.shadow-sm {
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important
}

.shadow-lg {
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, .175) !important
}

.shadow-none {
    box-shadow: none !important
}

.focus-ring-primary {
    --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-secondary {
    --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-success {
    --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-info {
    --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-warning {
    --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-danger {
    --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-light {
    --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-dark {
    --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity))
}

.position-static {
    position: static !important
}

.position-relative {
    position: relative !important
}

.position-absolute {
    position: absolute !important
}

.position-fixed {
    position: fixed !important
}

.position-sticky {
    position: sticky !important
}

.top-0 {
    top: 0 !important
}

.top-50 {
    top: 50% !important
}

.top-100 {
    top: 100% !important
}

.bottom-0 {
    bottom: 0 !important
}

.bottom-50 {
    bottom: 50% !important
}

.bottom-100 {
    bottom: 100% !important
}

.start-0 {
    left: 0 !important
}

.start-50 {
    left: 50% !important
}

.start-100 {
    left: 100% !important
}

.end-0 {
    right: 0 !important
}

.end-50 {
    right: 50% !important
}

.end-100 {
    right: 100% !important
}

.translate-middle {
    transform: translate(-50%, -50%) !important
}

.translate-middle-x {
    transform: translateX(-50%) !important
}

.translate-middle-y {
    transform: translateY(-50%) !important
}

.border {
    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important
}

.border-0 {
    border: 0 !important
}

.border-top {
    border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important
}

.border-top-0 {
    border-top: 0 !important
}

.border-end {
    border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important
}

.border-end-0 {
    border-right: 0 !important
}

.border-bottom {
    border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important
}

.border-bottom-0 {
    border-bottom: 0 !important
}

.border-start {
    border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important
}

.border-start-0 {
    border-left: 0 !important
}

.border-primary {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important
}

.border-secondary {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important
}

.border-success {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important
}

.border-info {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important
}

.border-warning {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important
}

.border-danger {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important
}

.border-light {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important
}

.border-dark {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important
}

.border-black {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important
}

.border-white {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important
}

.border-primary-subtle {
    border-color: var(--bs-primary-border-subtle) !important
}

.border-secondary-subtle {
    border-color: var(--bs-secondary-border-subtle) !important
}

.border-success-subtle {
    border-color: var(--bs-success-border-subtle) !important
}

.border-info-subtle {
    border-color: var(--bs-info-border-subtle) !important
}

.border-warning-subtle {
    border-color: var(--bs-warning-border-subtle) !important
}

.border-danger-subtle {
    border-color: var(--bs-danger-border-subtle) !important
}

.border-light-subtle {
    border-color: var(--bs-light-border-subtle) !important
}

.border-dark-subtle {
    border-color: var(--bs-dark-border-subtle) !important
}

.border-1 {
    border-width: 1px !important
}

.border-2 {
    border-width: 2px !important
}

.border-3 {
    border-width: 3px !important
}

.border-4 {
    border-width: 4px !important
}

.border-5 {
    border-width: 5px !important
}

.border-opacity-10 {
    --bs-border-opacity: 0.1
}

.border-opacity-25 {
    --bs-border-opacity: 0.25
}

.border-opacity-50 {
    --bs-border-opacity: 0.5
}

.border-opacity-75 {
    --bs-border-opacity: 0.75
}

.border-opacity-100 {
    --bs-border-opacity: 1
}

.w-25 {
    width: 25% !important
}

.w-50 {
    width: 50% !important
}

.w-75 {
    width: 75% !important
}

.w-100 {
    width: 100% !important
}

.w-auto {
    width: auto !important
}

.mw-100 {
    max-width: 100% !important
}

.vw-100 {
    width: 100vw !important
}

.min-vw-100 {
    min-width: 100vw !important
}

.h-25 {
    height: 25% !important
}

.h-50 {
    height: 50% !important
}

.h-75 {
    height: 75% !important
}

.h-100 {
    height: 100% !important
}

.h-auto {
    height: auto !important
}

.mh-100 {
    max-height: 100% !important
}

.vh-100 {
    height: 100vh !important
}

.min-vh-100 {
    min-height: 100vh !important
}

.flex-fill {
    flex: 1 1 auto !important
}

.flex-row {
    flex-direction: row !important
}

.flex-column {
    flex-direction: column !important
}

.flex-row-reverse {
    flex-direction: row-reverse !important
}

.flex-column-reverse {
    flex-direction: column-reverse !important
}

.flex-grow-0 {
    flex-grow: 0 !important
}

.flex-grow-1 {
    flex-grow: 1 !important
}

.flex-shrink-0 {
    flex-shrink: 0 !important
}

.flex-shrink-1 {
    flex-shrink: 1 !important
}

.flex-wrap {
    flex-wrap: wrap !important
}

.flex-nowrap {
    flex-wrap: nowrap !important
}

.flex-wrap-reverse {
    flex-wrap: wrap-reverse !important
}

.justify-content-start {
    justify-content: flex-start !important
}

.justify-content-end {
    justify-content: flex-end !important
}

.justify-content-center {
    justify-content: center !important
}

.justify-content-between {
    justify-content: space-between !important
}

.justify-content-around {
    justify-content: space-around !important
}

.justify-content-evenly {
    justify-content: space-evenly !important
}

.align-items-start {
    align-items: flex-start !important
}

.align-items-end {
    align-items: flex-end !important
}

.align-items-center {
    align-items: center !important
}

.align-items-baseline {
    align-items: baseline !important
}

.align-items-stretch {
    align-items: stretch !important
}

.align-content-start {
    align-content: flex-start !important
}

.align-content-end {
    align-content: flex-end !important
}

.align-content-center {
    align-content: center !important
}

.align-content-between {
    align-content: space-between !important
}

.align-content-around {
    align-content: space-around !important
}

.align-content-stretch {
    align-content: stretch !important
}

.align-self-auto {
    align-self: auto !important
}

.align-self-start {
    align-self: flex-start !important
}

.align-self-end {
    align-self: flex-end !important
}

.align-self-center {
    align-self: center !important
}

.align-self-baseline {
    align-self: baseline !important
}

.align-self-stretch {
    align-self: stretch !important
}

.order-first {
    order: -1 !important
}

.order-0 {
    order: 0 !important
}

.order-1 {
    order: 1 !important
}

.order-2 {
    order: 2 !important
}

.order-3 {
    order: 3 !important
}

.order-4 {
    order: 4 !important
}

.order-5 {
    order: 5 !important
}

.order-last {
    order: 6 !important
}

.m-0 {
    margin: 0 !important
}

.m-1 {
    margin: .25rem !important
}

.m-2 {
    margin: .5rem !important
}

.m-3 {
    margin: 1rem !important
}

.m-4 {
    margin: 1.5rem !important
}

.m-5 {
    margin: 3rem !important
}

.m-auto {
    margin: auto !important
}

.mx-0 {
    margin-right: 0 !important;
    margin-left: 0 !important
}

.mx-1 {
    margin-right: .25rem !important;
    margin-left: .25rem !important
}

.mx-2 {
    margin-right: .5rem !important;
    margin-left: .5rem !important
}

.mx-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important
}

.mx-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important
}

.mx-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important
}

.mx-auto {
    margin-right: auto !important;
    margin-left: auto !important
}

.my-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important
}

.my-1 {
    margin-top: .25rem !important;
    margin-bottom: .25rem !important
}

.my-2 {
    margin-top: .5rem !important;
    margin-bottom: .5rem !important
}

.my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important
}

.my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important
}

.my-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important
}

.my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important
}

.mt-0 {
    margin-top: 0 !important
}

.mt-1 {
    margin-top: .25rem !important
}

.mt-2 {
    margin-top: .5rem !important
}

.mt-3 {
    margin-top: 1rem !important
}

.mt-4 {
    margin-top: 1.5rem !important
}

.mt-5 {
    margin-top: 3rem !important
}

.mt-auto {
    margin-top: auto !important
}

.me-0 {
    margin-right: 0 !important
}

.me-1 {
    margin-right: .25rem !important
}

.me-2 {
    margin-right: .5rem !important
}

.me-3 {
    margin-right: 1rem !important
}

.me-4 {
    margin-right: 1.5rem !important
}

.me-5 {
    margin-right: 3rem !important
}

.me-auto {
    margin-right: auto !important
}

.mb-0 {
    margin-bottom: 0 !important
}

.mb-1 {
    margin-bottom: .25rem !important
}

.mb-2 {
    margin-bottom: .5rem !important
}

.mb-3 {
    margin-bottom: 1rem !important
}

.mb-4 {
    margin-bottom: 1.5rem !important
}

.mb-5 {
    margin-bottom: 3rem !important
}

.mb-auto {
    margin-bottom: auto !important
}

.ms-0 {
    margin-left: 0 !important
}

.ms-1 {
    margin-left: .25rem !important
}

.ms-2 {
    margin-left: .5rem !important
}

.ms-3 {
    margin-left: 1rem !important
}

.ms-4 {
    margin-left: 1.5rem !important
}

.ms-5 {
    margin-left: 3rem !important
}

.ms-auto {
    margin-left: auto !important
}

.p-0 {
    padding: 0 !important
}

.p-1 {
    padding: .25rem !important
}

.p-2 {
    padding: .5rem !important
}

.p-3 {
    padding: 1rem !important
}

.p-4 {
    padding: 1.5rem !important
}

.p-5 {
    padding: 3rem !important
}

.px-0 {
    padding-right: 0 !important;
    padding-left: 0 !important
}

.px-1 {
    padding-right: .25rem !important;
    padding-left: .25rem !important
}

.px-2 {
    padding-right: .5rem !important;
    padding-left: .5rem !important
}

.px-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important
}

.px-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important
}

.px-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important
}

.py-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important
}

.py-1 {
    padding-top: .25rem !important;
    padding-bottom: .25rem !important
}

.py-2 {
    padding-top: .5rem !important;
    padding-bottom: .5rem !important
}

.py-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important
}

.py-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important
}

.py-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important
}

.pt-0 {
    padding-top: 0 !important
}

.pt-1 {
    padding-top: .25rem !important
}

.pt-2 {
    padding-top: .5rem !important
}

.pt-3 {
    padding-top: 1rem !important
}

.pt-4 {
    padding-top: 1.5rem !important
}

.pt-5 {
    padding-top: 3rem !important
}

.pe-0 {
    padding-right: 0 !important
}

.pe-1 {
    padding-right: .25rem !important
}

.pe-2 {
    padding-right: .5rem !important
}

.pe-3 {
    padding-right: 1rem !important
}

.pe-4 {
    padding-right: 1.5rem !important
}

.pe-5 {
    padding-right: 3rem !important
}

.pb-0 {
    padding-bottom: 0 !important
}

.pb-1 {
    padding-bottom: .25rem !important
}

.pb-2 {
    padding-bottom: .5rem !important
}

.pb-3 {
    padding-bottom: 1rem !important
}

.pb-4 {
    padding-bottom: 1.5rem !important
}

.pb-5 {
    padding-bottom: 3rem !important
}

.ps-0 {
    padding-left: 0 !important
}

.ps-1 {
    padding-left: .25rem !important
}

.ps-2 {
    padding-left: .5rem !important
}

.ps-3 {
    padding-left: 1rem !important
}

.ps-4 {
    padding-left: 1.5rem !important
}

.ps-5 {
    padding-left: 3rem !important
}

.gap-0 {
    gap: 0 !important
}

.gap-1 {
    gap: .25rem !important
}

.gap-2 {
    gap: .5rem !important
}

.gap-3 {
    gap: 1rem !important
}

.gap-4 {
    gap: 1.5rem !important
}

.gap-5 {
    gap: 3rem !important
}

.row-gap-0 {
    row-gap: 0 !important
}

.row-gap-1 {
    row-gap: .25rem !important
}

.row-gap-2 {
    row-gap: .5rem !important
}

.row-gap-3 {
    row-gap: 1rem !important
}

.row-gap-4 {
    row-gap: 1.5rem !important
}

.row-gap-5 {
    row-gap: 3rem !important
}

.column-gap-0 {
    column-gap: 0 !important
}

.column-gap-1 {
    column-gap: .25rem !important
}

.column-gap-2 {
    column-gap: .5rem !important
}

.column-gap-3 {
    column-gap: 1rem !important
}

.column-gap-4 {
    column-gap: 1.5rem !important
}

.column-gap-5 {
    column-gap: 3rem !important
}

.font-monospace {
    font-family: var(--bs-font-monospace) !important
}

.fs-1 {
    font-size: calc(1.4375rem + 2.25vw) !important
}

.fs-2 {
    font-size: calc(1.34375rem + 1.125vw) !important
}

.fs-3 {
    font-size: calc(1.3rem + 0.6vw) !important
}

.fs-4 {
    font-size: calc(1.275rem + 0.3vw) !important
}

.fs-5 {
    font-size: 1.25rem !important
}

.fs-6 {
    font-size: 1.125rem !important
}

.fst-italic {
    font-style: italic !important
}

.fst-normal {
    font-style: normal !important
}

.fw-lighter {
    font-weight: lighter !important
}

.fw-light {
    font-weight: 300 !important
}

.fw-normal {
    font-weight: 400 !important
}

.fw-medium {
    font-weight: 500 !important
}

.fw-semibold {
    font-weight: 600 !important
}

.fw-bold {
    font-weight: 700 !important
}

.fw-bolder {
    font-weight: bolder !important
}

.lh-1 {
    line-height: 1 !important
}

.lh-sm {
    line-height: 1.25 !important
}

.lh-base {
    line-height: 1.5 !important
}

.lh-lg {
    line-height: 2 !important
}

.text-start {
    text-align: left !important
}

.text-end {
    text-align: right !important
}

.text-center {
    text-align: center !important
}

.text-decoration-none {
    text-decoration: none !important
}

.text-decoration-underline {
    text-decoration: underline !important
}

.text-decoration-line-through {
    text-decoration: line-through !important
}

.text-lowercase {
    text-transform: lowercase !important
}

.text-uppercase {
    text-transform: uppercase !important
}

.text-capitalize {
    text-transform: capitalize !important
}

.text-wrap {
    white-space: normal !important
}

.text-nowrap {
    white-space: nowrap !important
}

.text-break {
    word-wrap: break-word !important;
    word-break: break-word !important
}

.text-primary {
    --bs-text-opacity: 1;
    color: #00b8de !important
}

.text-secondary {
    --bs-text-opacity: 1;
    color: #00b8de !important;
    /* color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important */
}

.text-success {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important
}

.text-info {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important
}

.text-warning {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important
}

.text-danger {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important
}

.text-light {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important
}

.text-dark {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important
}

.text-black {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important
}

.text-white {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important
}

.text-body {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important
}

.text-muted {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important
}

.text-black-50 {
    --bs-text-opacity: 1;
    color: rgba(0, 0, 0, .5) !important
}

.text-white-50 {
    --bs-text-opacity: 1;
    color: rgba(255, 255, 255, .5) !important
}

.text-body-secondary {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important
}

.text-body-tertiary {
    --bs-text-opacity: 1;
    color: var(--bs-tertiary-color) !important
}

.text-body-emphasis {
    --bs-text-opacity: 1;
    color: var(--bs-emphasis-color) !important
}

.text-reset {
    --bs-text-opacity: 1;
    color: inherit !important
}

.text-opacity-25 {
    --bs-text-opacity: 0.25
}

.text-opacity-50 {
    --bs-text-opacity: 0.5
}

.text-opacity-75 {
    --bs-text-opacity: 0.75
}

.text-opacity-100 {
    --bs-text-opacity: 1
}

.text-primary-emphasis {
    color: var(--bs-primary-text-emphasis) !important
}

.text-secondary-emphasis {
    color: var(--bs-secondary-text-emphasis) !important
}

.text-success-emphasis {
    color: var(--bs-success-text-emphasis) !important
}

.text-info-emphasis {
    color: var(--bs-info-text-emphasis) !important
}

.text-warning-emphasis {
    color: var(--bs-warning-text-emphasis) !important
}

.text-danger-emphasis {
    color: var(--bs-danger-text-emphasis) !important
}

.text-light-emphasis {
    color: var(--bs-light-text-emphasis) !important
}

.text-dark-emphasis {
    color: var(--bs-dark-text-emphasis) !important
}

.link-opacity-10 {
    --bs-link-opacity: 0.1
}

.link-opacity-10-hover:hover {
    --bs-link-opacity: 0.1
}

.link-opacity-25 {
    --bs-link-opacity: 0.25
}

.link-opacity-25-hover:hover {
    --bs-link-opacity: 0.25
}

.link-opacity-50 {
    --bs-link-opacity: 0.5
}

.link-opacity-50-hover:hover {
    --bs-link-opacity: 0.5
}

.link-opacity-75 {
    --bs-link-opacity: 0.75
}

.link-opacity-75-hover:hover {
    --bs-link-opacity: 0.75
}

.link-opacity-100 {
    --bs-link-opacity: 1
}

.link-opacity-100-hover:hover {
    --bs-link-opacity: 1
}

.link-offset-1 {
    text-underline-offset: .125em !important
}

.link-offset-1-hover:hover {
    text-underline-offset: .125em !important
}

.link-offset-2 {
    text-underline-offset: .25em !important
}

.link-offset-2-hover:hover {
    text-underline-offset: .25em !important
}

.link-offset-3 {
    text-underline-offset: .375em !important
}

.link-offset-3-hover:hover {
    text-underline-offset: .375em !important
}

.link-underline-primary {
    --bs-link-underline-opacity: 1;
    text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-secondary {
    --bs-link-underline-opacity: 1;
    text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-success {
    --bs-link-underline-opacity: 1;
    text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-info {
    --bs-link-underline-opacity: 1;
    text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-warning {
    --bs-link-underline-opacity: 1;
    text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-danger {
    --bs-link-underline-opacity: 1;
    text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-light {
    --bs-link-underline-opacity: 1;
    text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-dark {
    --bs-link-underline-opacity: 1;
    text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline {
    --bs-link-underline-opacity: 1;
    text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-underline-opacity-0 {
    --bs-link-underline-opacity: 0
}

.link-underline-opacity-0-hover:hover {
    --bs-link-underline-opacity: 0
}

.link-underline-opacity-10 {
    --bs-link-underline-opacity: 0.1
}

.link-underline-opacity-10-hover:hover {
    --bs-link-underline-opacity: 0.1
}

.link-underline-opacity-25 {
    --bs-link-underline-opacity: 0.25
}

.link-underline-opacity-25-hover:hover {
    --bs-link-underline-opacity: 0.25
}

.link-underline-opacity-50 {
    --bs-link-underline-opacity: 0.5
}

.link-underline-opacity-50-hover:hover {
    --bs-link-underline-opacity: 0.5
}

.link-underline-opacity-75 {
    --bs-link-underline-opacity: 0.75
}

.link-underline-opacity-75-hover:hover {
    --bs-link-underline-opacity: 0.75
}

.link-underline-opacity-100 {
    --bs-link-underline-opacity: 1
}

.link-underline-opacity-100-hover:hover {
    --bs-link-underline-opacity: 1
}

.bg-primary {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important
}

.bg-secondary {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important
}

.bg-success {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important
}

.bg-info {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important
}

.bg-warning {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important
}

.bg-danger {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important
}

.bg-light {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important
}

.bg-dark {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important
}

.bg-black {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important
}

.bg-white {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important
}

.bg-body {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important
}

.bg-transparent {
    --bs-bg-opacity: 1;
    background-color: rgba(0, 0, 0, 0) !important
}

.bg-body-secondary {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important
}

.bg-body-tertiary {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important
}

.bg-opacity-10 {
    --bs-bg-opacity: 0.1
}

.bg-opacity-25 {
    --bs-bg-opacity: 0.25
}

.bg-opacity-50 {
    --bs-bg-opacity: 0.5
}

.bg-opacity-75 {
    --bs-bg-opacity: 0.75
}

.bg-opacity-100 {
    --bs-bg-opacity: 1
}

.bg-primary-subtle {
    background-color: var(--bs-primary-bg-subtle) !important
}

.bg-secondary-subtle {
    background-color: var(--bs-secondary-bg-subtle) !important
}

.bg-success-subtle {
    background-color: var(--bs-success-bg-subtle) !important
}

.bg-info-subtle {
    background-color: var(--bs-info-bg-subtle) !important
}

.bg-warning-subtle {
    background-color: var(--bs-warning-bg-subtle) !important
}

.bg-danger-subtle {
    background-color: var(--bs-danger-bg-subtle) !important
}

.bg-light-subtle {
    background-color: var(--bs-light-bg-subtle) !important
}

.bg-dark-subtle {
    background-color: var(--bs-dark-bg-subtle) !important
}

.bg-gradient {
    background-image: var(--bs-gradient) !important
}

.user-select-all {
    -webkit-user-select: all !important;
            user-select: all !important
}

.user-select-auto {
    -webkit-user-select: auto !important;
            user-select: auto !important
}

.user-select-none {
    -webkit-user-select: none !important;
            user-select: none !important
}

.pe-none {
    pointer-events: none !important
}

.pe-auto {
    pointer-events: auto !important
}

.rounded {
    border-radius: var(--bs-border-radius) !important
}

.rounded-0 {
    border-radius: 0 !important
}

.rounded-1 {
    border-radius: var(--bs-border-radius-sm) !important
}

.rounded-2 {
    border-radius: var(--bs-border-radius) !important
}

.rounded-3 {
    border-radius: var(--bs-border-radius-lg) !important
}

.rounded-4 {
    border-radius: var(--bs-border-radius-xl) !important
}

.rounded-5 {
    border-radius: var(--bs-border-radius-xxl) !important
}

.rounded-circle {
    border-radius: 50% !important
}

.rounded-pill {
    border-radius: var(--bs-border-radius-pill) !important
}

.rounded-top {
    border-top-left-radius: var(--bs-border-radius) !important;
    border-top-right-radius: var(--bs-border-radius) !important
}

.rounded-top-0 {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important
}

.rounded-top-1 {
    border-top-left-radius: var(--bs-border-radius-sm) !important;
    border-top-right-radius: var(--bs-border-radius-sm) !important
}

.rounded-top-2 {
    border-top-left-radius: var(--bs-border-radius) !important;
    border-top-right-radius: var(--bs-border-radius) !important
}

.rounded-top-3 {
    border-top-left-radius: var(--bs-border-radius-lg) !important;
    border-top-right-radius: var(--bs-border-radius-lg) !important
}

.rounded-top-4 {
    border-top-left-radius: var(--bs-border-radius-xl) !important;
    border-top-right-radius: var(--bs-border-radius-xl) !important
}

.rounded-top-5 {
    border-top-left-radius: var(--bs-border-radius-xxl) !important;
    border-top-right-radius: var(--bs-border-radius-xxl) !important
}

.rounded-top-circle {
    border-top-left-radius: 50% !important;
    border-top-right-radius: 50% !important
}

.rounded-top-pill {
    border-top-left-radius: var(--bs-border-radius-pill) !important;
    border-top-right-radius: var(--bs-border-radius-pill) !important
}

.rounded-end {
    border-top-right-radius: var(--bs-border-radius) !important;
    border-bottom-right-radius: var(--bs-border-radius) !important
}

.rounded-end-0 {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important
}

.rounded-end-1 {
    border-top-right-radius: var(--bs-border-radius-sm) !important;
    border-bottom-right-radius: var(--bs-border-radius-sm) !important
}

.rounded-end-2 {
    border-top-right-radius: var(--bs-border-radius) !important;
    border-bottom-right-radius: var(--bs-border-radius) !important
}

.rounded-end-3 {
    border-top-right-radius: var(--bs-border-radius-lg) !important;
    border-bottom-right-radius: var(--bs-border-radius-lg) !important
}

.rounded-end-4 {
    border-top-right-radius: var(--bs-border-radius-xl) !important;
    border-bottom-right-radius: var(--bs-border-radius-xl) !important
}

.rounded-end-5 {
    border-top-right-radius: var(--bs-border-radius-xxl) !important;
    border-bottom-right-radius: var(--bs-border-radius-xxl) !important
}

.rounded-end-circle {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important
}

.rounded-end-pill {
    border-top-right-radius: var(--bs-border-radius-pill) !important;
    border-bottom-right-radius: var(--bs-border-radius-pill) !important
}

.rounded-bottom {
    border-bottom-right-radius: var(--bs-border-radius) !important;
    border-bottom-left-radius: var(--bs-border-radius) !important
}

.rounded-bottom-0 {
    border-bottom-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important
}

.rounded-bottom-1 {
    border-bottom-right-radius: var(--bs-border-radius-sm) !important;
    border-bottom-left-radius: var(--bs-border-radius-sm) !important
}

.rounded-bottom-2 {
    border-bottom-right-radius: var(--bs-border-radius) !important;
    border-bottom-left-radius: var(--bs-border-radius) !important
}

.rounded-bottom-3 {
    border-bottom-right-radius: var(--bs-border-radius-lg) !important;
    border-bottom-left-radius: var(--bs-border-radius-lg) !important
}

.rounded-bottom-4 {
    border-bottom-right-radius: var(--bs-border-radius-xl) !important;
    border-bottom-left-radius: var(--bs-border-radius-xl) !important
}

.rounded-bottom-5 {
    border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
    border-bottom-left-radius: var(--bs-border-radius-xxl) !important
}

.rounded-bottom-circle {
    border-bottom-right-radius: 50% !important;
    border-bottom-left-radius: 50% !important
}

.rounded-bottom-pill {
    border-bottom-right-radius: var(--bs-border-radius-pill) !important;
    border-bottom-left-radius: var(--bs-border-radius-pill) !important
}

.rounded-start {
    border-bottom-left-radius: var(--bs-border-radius) !important;
    border-top-left-radius: var(--bs-border-radius) !important
}

.rounded-start-0 {
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important
}

.rounded-start-1 {
    border-bottom-left-radius: var(--bs-border-radius-sm) !important;
    border-top-left-radius: var(--bs-border-radius-sm) !important
}

.rounded-start-2 {
    border-bottom-left-radius: var(--bs-border-radius) !important;
    border-top-left-radius: var(--bs-border-radius) !important
}

.rounded-start-3 {
    border-bottom-left-radius: var(--bs-border-radius-lg) !important;
    border-top-left-radius: var(--bs-border-radius-lg) !important
}

.rounded-start-4 {
    border-bottom-left-radius: var(--bs-border-radius-xl) !important;
    border-top-left-radius: var(--bs-border-radius-xl) !important
}

.rounded-start-5 {
    border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
    border-top-left-radius: var(--bs-border-radius-xxl) !important
}

.rounded-start-circle {
    border-bottom-left-radius: 50% !important;
    border-top-left-radius: 50% !important
}

.rounded-start-pill {
    border-bottom-left-radius: var(--bs-border-radius-pill) !important;
    border-top-left-radius: var(--bs-border-radius-pill) !important
}

.visible {
    visibility: visible !important
}

.invisible {
    visibility: hidden !important
}

.z-n1 {
    z-index: -1 !important
}

.z-0 {
    z-index: 0 !important
}

.z-1 {
    z-index: 1 !important
}

.z-2 {
    z-index: 2 !important
}

.z-3 {
    z-index: 3 !important
}

@media(min-width: 576px) {
    .float-sm-start {
        float: left !important
    }

    .float-sm-end {
        float: right !important
    }

    .float-sm-none {
        float: none !important
    }

    .object-fit-sm-contain {
        object-fit: contain !important
    }

    .object-fit-sm-cover {
        object-fit: cover !important
    }

    .object-fit-sm-fill {
        object-fit: fill !important
    }

    .object-fit-sm-scale {
        object-fit: scale-down !important
    }

    .object-fit-sm-none {
        object-fit: none !important
    }

    .d-sm-inline {
        display: inline !important
    }

    .d-sm-inline-block {
        display: inline-block !important
    }

    .d-sm-block {
        display: block !important
    }

    .d-sm-grid {
        display: grid !important
    }

    .d-sm-inline-grid {
        display: inline-grid !important
    }

    .d-sm-table {
        display: table !important
    }

    .d-sm-table-row {
        display: table-row !important
    }

    .d-sm-table-cell {
        display: table-cell !important
    }

    .d-sm-flex {
        display: flex !important
    }

    .d-sm-inline-flex {
        display: inline-flex !important
    }

    .d-sm-none {
        display: none !important
    }

    .flex-sm-fill {
        flex: 1 1 auto !important
    }

    .flex-sm-row {
        flex-direction: row !important
    }

    .flex-sm-column {
        flex-direction: column !important
    }

    .flex-sm-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-sm-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-sm-grow-0 {
        flex-grow: 0 !important
    }

    .flex-sm-grow-1 {
        flex-grow: 1 !important
    }

    .flex-sm-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-sm-shrink-1 {
        flex-shrink: 1 !important
    }

    .flex-sm-wrap {
        flex-wrap: wrap !important
    }

    .flex-sm-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-sm-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .justify-content-sm-start {
        justify-content: flex-start !important
    }

    .justify-content-sm-end {
        justify-content: flex-end !important
    }

    .justify-content-sm-center {
        justify-content: center !important
    }

    .justify-content-sm-between {
        justify-content: space-between !important
    }

    .justify-content-sm-around {
        justify-content: space-around !important
    }

    .justify-content-sm-evenly {
        justify-content: space-evenly !important
    }

    .align-items-sm-start {
        align-items: flex-start !important
    }

    .align-items-sm-end {
        align-items: flex-end !important
    }

    .align-items-sm-center {
        align-items: center !important
    }

    .align-items-sm-baseline {
        align-items: baseline !important
    }

    .align-items-sm-stretch {
        align-items: stretch !important
    }

    .align-content-sm-start {
        align-content: flex-start !important
    }

    .align-content-sm-end {
        align-content: flex-end !important
    }

    .align-content-sm-center {
        align-content: center !important
    }

    .align-content-sm-between {
        align-content: space-between !important
    }

    .align-content-sm-around {
        align-content: space-around !important
    }

    .align-content-sm-stretch {
        align-content: stretch !important
    }

    .align-self-sm-auto {
        align-self: auto !important
    }

    .align-self-sm-start {
        align-self: flex-start !important
    }

    .align-self-sm-end {
        align-self: flex-end !important
    }

    .align-self-sm-center {
        align-self: center !important
    }

    .align-self-sm-baseline {
        align-self: baseline !important
    }

    .align-self-sm-stretch {
        align-self: stretch !important
    }

    .order-sm-first {
        order: -1 !important
    }

    .order-sm-0 {
        order: 0 !important
    }

    .order-sm-1 {
        order: 1 !important
    }

    .order-sm-2 {
        order: 2 !important
    }

    .order-sm-3 {
        order: 3 !important
    }

    .order-sm-4 {
        order: 4 !important
    }

    .order-sm-5 {
        order: 5 !important
    }

    .order-sm-last {
        order: 6 !important
    }

    .m-sm-0 {
        margin: 0 !important
    }

    .m-sm-1 {
        margin: .25rem !important
    }

    .m-sm-2 {
        margin: .5rem !important
    }

    .m-sm-3 {
        margin: 1rem !important
    }

    .m-sm-4 {
        margin: 1.5rem !important
    }

    .m-sm-5 {
        margin: 3rem !important
    }

    .m-sm-auto {
        margin: auto !important
    }

    .mx-sm-0 {
        margin-right: 0 !important;
        margin-left: 0 !important
    }

    .mx-sm-1 {
        margin-right: .25rem !important;
        margin-left: .25rem !important
    }

    .mx-sm-2 {
        margin-right: .5rem !important;
        margin-left: .5rem !important
    }

    .mx-sm-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-sm-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important
    }

    .mx-sm-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important
    }

    .mx-sm-auto {
        margin-right: auto !important;
        margin-left: auto !important
    }

    .my-sm-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important
    }

    .my-sm-1 {
        margin-top: .25rem !important;
        margin-bottom: .25rem !important
    }

    .my-sm-2 {
        margin-top: .5rem !important;
        margin-bottom: .5rem !important
    }

    .my-sm-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-sm-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important
    }

    .my-sm-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important
    }

    .my-sm-auto {
        margin-top: auto !important;
        margin-bottom: auto !important
    }

    .mt-sm-0 {
        margin-top: 0 !important
    }

    .mt-sm-1 {
        margin-top: .25rem !important
    }

    .mt-sm-2 {
        margin-top: .5rem !important
    }

    .mt-sm-3 {
        margin-top: 1rem !important
    }

    .mt-sm-4 {
        margin-top: 1.5rem !important
    }

    .mt-sm-5 {
        margin-top: 3rem !important
    }

    .mt-sm-auto {
        margin-top: auto !important
    }

    .me-sm-0 {
        margin-right: 0 !important
    }

    .me-sm-1 {
        margin-right: .25rem !important
    }

    .me-sm-2 {
        margin-right: .5rem !important
    }

    .me-sm-3 {
        margin-right: 1rem !important
    }

    .me-sm-4 {
        margin-right: 1.5rem !important
    }

    .me-sm-5 {
        margin-right: 3rem !important
    }

    .me-sm-auto {
        margin-right: auto !important
    }

    .mb-sm-0 {
        margin-bottom: 0 !important
    }

    .mb-sm-1 {
        margin-bottom: .25rem !important
    }

    .mb-sm-2 {
        margin-bottom: .5rem !important
    }

    .mb-sm-3 {
        margin-bottom: 1rem !important
    }

    .mb-sm-4 {
        margin-bottom: 1.5rem !important
    }

    .mb-sm-5 {
        margin-bottom: 3rem !important
    }

    .mb-sm-auto {
        margin-bottom: auto !important
    }

    .ms-sm-0 {
        margin-left: 0 !important
    }

    .ms-sm-1 {
        margin-left: .25rem !important
    }

    .ms-sm-2 {
        margin-left: .5rem !important
    }

    .ms-sm-3 {
        margin-left: 1rem !important
    }

    .ms-sm-4 {
        margin-left: 1.5rem !important
    }

    .ms-sm-5 {
        margin-left: 3rem !important
    }

    .ms-sm-auto {
        margin-left: auto !important
    }

    .p-sm-0 {
        padding: 0 !important
    }

    .p-sm-1 {
        padding: .25rem !important
    }

    .p-sm-2 {
        padding: .5rem !important
    }

    .p-sm-3 {
        padding: 1rem !important
    }

    .p-sm-4 {
        padding: 1.5rem !important
    }

    .p-sm-5 {
        padding: 3rem !important
    }

    .px-sm-0 {
        padding-right: 0 !important;
        padding-left: 0 !important
    }

    .px-sm-1 {
        padding-right: .25rem !important;
        padding-left: .25rem !important
    }

    .px-sm-2 {
        padding-right: .5rem !important;
        padding-left: .5rem !important
    }

    .px-sm-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-sm-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important
    }

    .px-sm-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important
    }

    .py-sm-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .py-sm-1 {
        padding-top: .25rem !important;
        padding-bottom: .25rem !important
    }

    .py-sm-2 {
        padding-top: .5rem !important;
        padding-bottom: .5rem !important
    }

    .py-sm-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-sm-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important
    }

    .py-sm-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important
    }

    .pt-sm-0 {
        padding-top: 0 !important
    }

    .pt-sm-1 {
        padding-top: .25rem !important
    }

    .pt-sm-2 {
        padding-top: .5rem !important
    }

    .pt-sm-3 {
        padding-top: 1rem !important
    }

    .pt-sm-4 {
        padding-top: 1.5rem !important
    }

    .pt-sm-5 {
        padding-top: 3rem !important
    }

    .pe-sm-0 {
        padding-right: 0 !important
    }

    .pe-sm-1 {
        padding-right: .25rem !important
    }

    .pe-sm-2 {
        padding-right: .5rem !important
    }

    .pe-sm-3 {
        padding-right: 1rem !important
    }

    .pe-sm-4 {
        padding-right: 1.5rem !important
    }

    .pe-sm-5 {
        padding-right: 3rem !important
    }

    .pb-sm-0 {
        padding-bottom: 0 !important
    }

    .pb-sm-1 {
        padding-bottom: .25rem !important
    }

    .pb-sm-2 {
        padding-bottom: .5rem !important
    }

    .pb-sm-3 {
        padding-bottom: 1rem !important
    }

    .pb-sm-4 {
        padding-bottom: 1.5rem !important
    }

    .pb-sm-5 {
        padding-bottom: 3rem !important
    }

    .ps-sm-0 {
        padding-left: 0 !important
    }

    .ps-sm-1 {
        padding-left: .25rem !important
    }

    .ps-sm-2 {
        padding-left: .5rem !important
    }

    .ps-sm-3 {
        padding-left: 1rem !important
    }

    .ps-sm-4 {
        padding-left: 1.5rem !important
    }

    .ps-sm-5 {
        padding-left: 3rem !important
    }

    .gap-sm-0 {
        gap: 0 !important
    }

    .gap-sm-1 {
        gap: .25rem !important
    }

    .gap-sm-2 {
        gap: .5rem !important
    }

    .gap-sm-3 {
        gap: 1rem !important
    }

    .gap-sm-4 {
        gap: 1.5rem !important
    }

    .gap-sm-5 {
        gap: 3rem !important
    }

    .row-gap-sm-0 {
        row-gap: 0 !important
    }

    .row-gap-sm-1 {
        row-gap: .25rem !important
    }

    .row-gap-sm-2 {
        row-gap: .5rem !important
    }

    .row-gap-sm-3 {
        row-gap: 1rem !important
    }

    .row-gap-sm-4 {
        row-gap: 1.5rem !important
    }

    .row-gap-sm-5 {
        row-gap: 3rem !important
    }

    .column-gap-sm-0 {
        column-gap: 0 !important
    }

    .column-gap-sm-1 {
        column-gap: .25rem !important
    }

    .column-gap-sm-2 {
        column-gap: .5rem !important
    }

    .column-gap-sm-3 {
        column-gap: 1rem !important
    }

    .column-gap-sm-4 {
        column-gap: 1.5rem !important
    }

    .column-gap-sm-5 {
        column-gap: 3rem !important
    }

    .text-sm-start {
        text-align: left !important
    }

    .text-sm-end {
        text-align: right !important
    }

    .text-sm-center {
        text-align: center !important
    }
}

@media(min-width: 768px) {
    .float-md-start {
        float: left !important
    }

    .float-md-end {
        float: right !important
    }

    .float-md-none {
        float: none !important
    }

    .object-fit-md-contain {
        object-fit: contain !important
    }

    .object-fit-md-cover {
        object-fit: cover !important
    }

    .object-fit-md-fill {
        object-fit: fill !important
    }

    .object-fit-md-scale {
        object-fit: scale-down !important
    }

    .object-fit-md-none {
        object-fit: none !important
    }

    .d-md-inline {
        display: inline !important
    }

    .d-md-inline-block {
        display: inline-block !important
    }

    .d-md-block {
        display: block !important
    }

    .d-md-grid {
        display: grid !important
    }

    .d-md-inline-grid {
        display: inline-grid !important
    }

    .d-md-table {
        display: table !important
    }

    .d-md-table-row {
        display: table-row !important
    }

    .d-md-table-cell {
        display: table-cell !important
    }

    .d-md-flex {
        display: flex !important
    }

    .d-md-inline-flex {
        display: inline-flex !important
    }

    .d-md-none {
        display: none !important
    }

    .flex-md-fill {
        flex: 1 1 auto !important
    }

    .flex-md-row {
        flex-direction: row !important
    }

    .flex-md-column {
        flex-direction: column !important
    }

    .flex-md-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-md-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-md-grow-0 {
        flex-grow: 0 !important
    }

    .flex-md-grow-1 {
        flex-grow: 1 !important
    }

    .flex-md-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-md-shrink-1 {
        flex-shrink: 1 !important
    }

    .flex-md-wrap {
        flex-wrap: wrap !important
    }

    .flex-md-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-md-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .justify-content-md-start {
        justify-content: flex-start !important
    }

    .justify-content-md-end {
        justify-content: flex-end !important
    }

    .justify-content-md-center {
        justify-content: center !important
    }

    .justify-content-md-between {
        justify-content: space-between !important
    }

    .justify-content-md-around {
        justify-content: space-around !important
    }

    .justify-content-md-evenly {
        justify-content: space-evenly !important
    }

    .align-items-md-start {
        align-items: flex-start !important
    }

    .align-items-md-end {
        align-items: flex-end !important
    }

    .align-items-md-center {
        align-items: center !important
    }

    .align-items-md-baseline {
        align-items: baseline !important
    }

    .align-items-md-stretch {
        align-items: stretch !important
    }

    .align-content-md-start {
        align-content: flex-start !important
    }

    .align-content-md-end {
        align-content: flex-end !important
    }

    .align-content-md-center {
        align-content: center !important
    }

    .align-content-md-between {
        align-content: space-between !important
    }

    .align-content-md-around {
        align-content: space-around !important
    }

    .align-content-md-stretch {
        align-content: stretch !important
    }

    .align-self-md-auto {
        align-self: auto !important
    }

    .align-self-md-start {
        align-self: flex-start !important
    }

    .align-self-md-end {
        align-self: flex-end !important
    }

    .align-self-md-center {
        align-self: center !important
    }

    .align-self-md-baseline {
        align-self: baseline !important
    }

    .align-self-md-stretch {
        align-self: stretch !important
    }

    .order-md-first {
        order: -1 !important
    }

    .order-md-0 {
        order: 0 !important
    }

    .order-md-1 {
        order: 1 !important
    }

    .order-md-2 {
        order: 2 !important
    }

    .order-md-3 {
        order: 3 !important
    }

    .order-md-4 {
        order: 4 !important
    }

    .order-md-5 {
        order: 5 !important
    }

    .order-md-last {
        order: 6 !important
    }

    .m-md-0 {
        margin: 0 !important
    }

    .m-md-1 {
        margin: .25rem !important
    }

    .m-md-2 {
        margin: .5rem !important
    }

    .m-md-3 {
        margin: 1rem !important
    }

    .m-md-4 {
        margin: 1.5rem !important
    }

    .m-md-5 {
        margin: 3rem !important
    }

    .m-md-auto {
        margin: auto !important
    }

    .mx-md-0 {
        margin-right: 0 !important;
        margin-left: 0 !important
    }

    .mx-md-1 {
        margin-right: .25rem !important;
        margin-left: .25rem !important
    }

    .mx-md-2 {
        margin-right: .5rem !important;
        margin-left: .5rem !important
    }

    .mx-md-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-md-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important
    }

    .mx-md-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important
    }

    .mx-md-auto {
        margin-right: auto !important;
        margin-left: auto !important
    }

    .my-md-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important
    }

    .my-md-1 {
        margin-top: .25rem !important;
        margin-bottom: .25rem !important
    }

    .my-md-2 {
        margin-top: .5rem !important;
        margin-bottom: .5rem !important
    }

    .my-md-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-md-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important
    }

    .my-md-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important
    }

    .my-md-auto {
        margin-top: auto !important;
        margin-bottom: auto !important
    }

    .mt-md-0 {
        margin-top: 0 !important
    }

    .mt-md-1 {
        margin-top: .25rem !important
    }

    .mt-md-2 {
        margin-top: .5rem !important
    }

    .mt-md-3 {
        margin-top: 1rem !important
    }

    .mt-md-4 {
        margin-top: 1.5rem !important
    }

    .mt-md-5 {
        margin-top: 3rem !important
    }

    .mt-md-auto {
        margin-top: auto !important
    }

    .me-md-0 {
        margin-right: 0 !important
    }

    .me-md-1 {
        margin-right: .25rem !important
    }

    .me-md-2 {
        margin-right: .5rem !important
    }

    .me-md-3 {
        margin-right: 1rem !important
    }

    .me-md-4 {
        margin-right: 1.5rem !important
    }

    .me-md-5 {
        margin-right: 3rem !important
    }

    .me-md-auto {
        margin-right: auto !important
    }

    .mb-md-0 {
        margin-bottom: 0 !important
    }

    .mb-md-1 {
        margin-bottom: .25rem !important
    }

    .mb-md-2 {
        margin-bottom: .5rem !important
    }

    .mb-md-3 {
        margin-bottom: 1rem !important
    }

    .mb-md-4 {
        margin-bottom: 1.5rem !important
    }

    .mb-md-5 {
        margin-bottom: 3rem !important
    }

    .mb-md-auto {
        margin-bottom: auto !important
    }

    .ms-md-0 {
        margin-left: 0 !important
    }

    .ms-md-1 {
        margin-left: .25rem !important
    }

    .ms-md-2 {
        margin-left: .5rem !important
    }

    .ms-md-3 {
        margin-left: 1rem !important
    }

    .ms-md-4 {
        margin-left: 1.5rem !important
    }

    .ms-md-5 {
        margin-left: 3rem !important
    }

    .ms-md-auto {
        margin-left: auto !important
    }

    .p-md-0 {
        padding: 0 !important
    }

    .p-md-1 {
        padding: .25rem !important
    }

    .p-md-2 {
        padding: .5rem !important
    }

    .p-md-3 {
        padding: 1rem !important
    }

    .p-md-4 {
        padding: 1.5rem !important
    }

    .p-md-5 {
        padding: 3rem !important
    }

    .px-md-0 {
        padding-right: 0 !important;
        padding-left: 0 !important
    }

    .px-md-1 {
        padding-right: .25rem !important;
        padding-left: .25rem !important
    }

    .px-md-2 {
        padding-right: .5rem !important;
        padding-left: .5rem !important
    }

    .px-md-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-md-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important
    }

    .px-md-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important
    }

    .py-md-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .py-md-1 {
        padding-top: .25rem !important;
        padding-bottom: .25rem !important
    }

    .py-md-2 {
        padding-top: .5rem !important;
        padding-bottom: .5rem !important
    }

    .py-md-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-md-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important
    }

    .py-md-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important
    }

    .pt-md-0 {
        padding-top: 0 !important
    }

    .pt-md-1 {
        padding-top: .25rem !important
    }

    .pt-md-2 {
        padding-top: .5rem !important
    }

    .pt-md-3 {
        padding-top: 1rem !important
    }

    .pt-md-4 {
        padding-top: 1.5rem !important
    }

    .pt-md-5 {
        padding-top: 3rem !important
    }

    .pe-md-0 {
        padding-right: 0 !important
    }

    .pe-md-1 {
        padding-right: .25rem !important
    }

    .pe-md-2 {
        padding-right: .5rem !important
    }

    .pe-md-3 {
        padding-right: 1rem !important
    }

    .pe-md-4 {
        padding-right: 1.5rem !important
    }

    .pe-md-5 {
        padding-right: 3rem !important
    }

    .pb-md-0 {
        padding-bottom: 0 !important
    }

    .pb-md-1 {
        padding-bottom: .25rem !important
    }

    .pb-md-2 {
        padding-bottom: .5rem !important
    }

    .pb-md-3 {
        padding-bottom: 1rem !important
    }

    .pb-md-4 {
        padding-bottom: 1.5rem !important
    }

    .pb-md-5 {
        padding-bottom: 3rem !important
    }

    .ps-md-0 {
        padding-left: 0 !important
    }

    .ps-md-1 {
        padding-left: .25rem !important
    }

    .ps-md-2 {
        padding-left: .5rem !important
    }

    .ps-md-3 {
        padding-left: 1rem !important
    }

    .ps-md-4 {
        padding-left: 1.5rem !important
    }

    .ps-md-5 {
        padding-left: 3rem !important
    }

    .gap-md-0 {
        gap: 0 !important
    }

    .gap-md-1 {
        gap: .25rem !important
    }

    .gap-md-2 {
        gap: .5rem !important
    }

    .gap-md-3 {
        gap: 1rem !important
    }

    .gap-md-4 {
        gap: 1.5rem !important
    }

    .gap-md-5 {
        gap: 3rem !important
    }

    .row-gap-md-0 {
        row-gap: 0 !important
    }

    .row-gap-md-1 {
        row-gap: .25rem !important
    }

    .row-gap-md-2 {
        row-gap: .5rem !important
    }

    .row-gap-md-3 {
        row-gap: 1rem !important
    }

    .row-gap-md-4 {
        row-gap: 1.5rem !important
    }

    .row-gap-md-5 {
        row-gap: 3rem !important
    }

    .column-gap-md-0 {
        column-gap: 0 !important
    }

    .column-gap-md-1 {
        column-gap: .25rem !important
    }

    .column-gap-md-2 {
        column-gap: .5rem !important
    }

    .column-gap-md-3 {
        column-gap: 1rem !important
    }

    .column-gap-md-4 {
        column-gap: 1.5rem !important
    }

    .column-gap-md-5 {
        column-gap: 3rem !important
    }

    .text-md-start {
        text-align: left !important
    }

    .text-md-end {
        text-align: right !important
    }

    .text-md-center {
        text-align: center !important
    }
}

@media(min-width: 992px) {
    .float-lg-start {
        float: left !important
    }

    .float-lg-end {
        float: right !important
    }

    .float-lg-none {
        float: none !important
    }

    .object-fit-lg-contain {
        object-fit: contain !important
    }

    .object-fit-lg-cover {
        object-fit: cover !important
    }

    .object-fit-lg-fill {
        object-fit: fill !important
    }

    .object-fit-lg-scale {
        object-fit: scale-down !important
    }

    .object-fit-lg-none {
        object-fit: none !important
    }

    .d-lg-inline {
        display: inline !important
    }

    .d-lg-inline-block {
        display: inline-block !important
    }

    .d-lg-block {
        display: block !important
    }

    .d-lg-grid {
        display: grid !important
    }

    .d-lg-inline-grid {
        display: inline-grid !important
    }

    .d-lg-table {
        display: table !important
    }

    .d-lg-table-row {
        display: table-row !important
    }

    .d-lg-table-cell {
        display: table-cell !important
    }

    .d-lg-flex {
        display: flex !important
    }

    .d-lg-inline-flex {
        display: inline-flex !important
    }

    .d-lg-none {
        display: none !important
    }

    .flex-lg-fill {
        flex: 1 1 auto !important
    }

    .flex-lg-row {
        flex-direction: row !important
    }

    .flex-lg-column {
        flex-direction: column !important
    }

    .flex-lg-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-lg-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-lg-grow-0 {
        flex-grow: 0 !important
    }

    .flex-lg-grow-1 {
        flex-grow: 1 !important
    }

    .flex-lg-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-lg-shrink-1 {
        flex-shrink: 1 !important
    }

    .flex-lg-wrap {
        flex-wrap: wrap !important
    }

    .flex-lg-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-lg-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .justify-content-lg-start {
        justify-content: flex-start !important
    }

    .justify-content-lg-end {
        justify-content: flex-end !important
    }

    .justify-content-lg-center {
        justify-content: center !important
    }

    .justify-content-lg-between {
        justify-content: space-between !important
    }

    .justify-content-lg-around {
        justify-content: space-around !important
    }

    .justify-content-lg-evenly {
        justify-content: space-evenly !important
    }

    .align-items-lg-start {
        align-items: flex-start !important
    }

    .align-items-lg-end {
        align-items: flex-end !important
    }

    .align-items-lg-center {
        align-items: center !important
    }

    .align-items-lg-baseline {
        align-items: baseline !important
    }

    .align-items-lg-stretch {
        align-items: stretch !important
    }

    .align-content-lg-start {
        align-content: flex-start !important
    }

    .align-content-lg-end {
        align-content: flex-end !important
    }

    .align-content-lg-center {
        align-content: center !important
    }

    .align-content-lg-between {
        align-content: space-between !important
    }

    .align-content-lg-around {
        align-content: space-around !important
    }

    .align-content-lg-stretch {
        align-content: stretch !important
    }

    .align-self-lg-auto {
        align-self: auto !important
    }

    .align-self-lg-start {
        align-self: flex-start !important
    }

    .align-self-lg-end {
        align-self: flex-end !important
    }

    .align-self-lg-center {
        align-self: center !important
    }

    .align-self-lg-baseline {
        align-self: baseline !important
    }

    .align-self-lg-stretch {
        align-self: stretch !important
    }

    .order-lg-first {
        order: -1 !important
    }

    .order-lg-0 {
        order: 0 !important
    }

    .order-lg-1 {
        order: 1 !important
    }

    .order-lg-2 {
        order: 2 !important
    }

    .order-lg-3 {
        order: 3 !important
    }

    .order-lg-4 {
        order: 4 !important
    }

    .order-lg-5 {
        order: 5 !important
    }

    .order-lg-last {
        order: 6 !important
    }

    .m-lg-0 {
        margin: 0 !important
    }

    .m-lg-1 {
        margin: .25rem !important
    }

    .m-lg-2 {
        margin: .5rem !important
    }

    .m-lg-3 {
        margin: 1rem !important
    }

    .m-lg-4 {
        margin: 1.5rem !important
    }

    .m-lg-5 {
        margin: 3rem !important
    }

    .m-lg-auto {
        margin: auto !important
    }

    .mx-lg-0 {
        margin-right: 0 !important;
        margin-left: 0 !important
    }

    .mx-lg-1 {
        margin-right: .25rem !important;
        margin-left: .25rem !important
    }

    .mx-lg-2 {
        margin-right: .5rem !important;
        margin-left: .5rem !important
    }

    .mx-lg-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-lg-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important
    }

    .mx-lg-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important
    }

    .mx-lg-auto {
        margin-right: auto !important;
        margin-left: auto !important
    }

    .my-lg-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important
    }

    .my-lg-1 {
        margin-top: .25rem !important;
        margin-bottom: .25rem !important
    }

    .my-lg-2 {
        margin-top: .5rem !important;
        margin-bottom: .5rem !important
    }

    .my-lg-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-lg-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important
    }

    .my-lg-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important
    }

    .my-lg-auto {
        margin-top: auto !important;
        margin-bottom: auto !important
    }

    .mt-lg-0 {
        margin-top: 0 !important
    }

    .mt-lg-1 {
        margin-top: .25rem !important
    }

    .mt-lg-2 {
        margin-top: .5rem !important
    }

    .mt-lg-3 {
        margin-top: 1rem !important
    }

    .mt-lg-4 {
        margin-top: 1.5rem !important
    }

    .mt-lg-5 {
        margin-top: 3rem !important
    }

    .mt-lg-auto {
        margin-top: auto !important
    }

    .me-lg-0 {
        margin-right: 0 !important
    }

    .me-lg-1 {
        margin-right: .25rem !important
    }

    .me-lg-2 {
        margin-right: .5rem !important
    }

    .me-lg-3 {
        margin-right: 1rem !important
    }

    .me-lg-4 {
        margin-right: 1.5rem !important
    }

    .me-lg-5 {
        margin-right: 3rem !important
    }

    .me-lg-auto {
        margin-right: auto !important
    }

    .mb-lg-0 {
        margin-bottom: 0 !important
    }

    .mb-lg-1 {
        margin-bottom: .25rem !important
    }

    .mb-lg-2 {
        margin-bottom: .5rem !important
    }

    .mb-lg-3 {
        margin-bottom: 1rem !important
    }

    .mb-lg-4 {
        margin-bottom: 1.5rem !important
    }

    .mb-lg-5 {
        margin-bottom: 3rem !important
    }

    .mb-lg-auto {
        margin-bottom: auto !important
    }

    .ms-lg-0 {
        margin-left: 0 !important
    }

    .ms-lg-1 {
        margin-left: .25rem !important
    }

    .ms-lg-2 {
        margin-left: .5rem !important
    }

    .ms-lg-3 {
        margin-left: 1rem !important
    }

    .ms-lg-4 {
        margin-left: 1.5rem !important
    }

    .ms-lg-5 {
        margin-left: 3rem !important
    }

    .ms-lg-auto {
        margin-left: auto !important
    }

    .p-lg-0 {
        padding: 0 !important
    }

    .p-lg-1 {
        padding: .25rem !important
    }

    .p-lg-2 {
        padding: .5rem !important
    }

    .p-lg-3 {
        padding: 1rem !important
    }

    .p-lg-4 {
        padding: 1.5rem !important
    }

    .p-lg-5 {
        padding: 3rem !important
    }

    .px-lg-0 {
        padding-right: 0 !important;
        padding-left: 0 !important
    }

    .px-lg-1 {
        padding-right: .25rem !important;
        padding-left: .25rem !important
    }

    .px-lg-2 {
        padding-right: .5rem !important;
        padding-left: .5rem !important
    }

    .px-lg-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-lg-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important
    }

    .px-lg-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important
    }

    .py-lg-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .py-lg-1 {
        padding-top: .25rem !important;
        padding-bottom: .25rem !important
    }

    .py-lg-2 {
        padding-top: .5rem !important;
        padding-bottom: .5rem !important
    }

    .py-lg-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-lg-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important
    }

    .py-lg-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important
    }

    .pt-lg-0 {
        padding-top: 0 !important
    }

    .pt-lg-1 {
        padding-top: .25rem !important
    }

    .pt-lg-2 {
        padding-top: .5rem !important
    }

    .pt-lg-3 {
        padding-top: 1rem !important
    }

    .pt-lg-4 {
        padding-top: 1.5rem !important
    }

    .pt-lg-5 {
        padding-top: 3rem !important
    }

    .pe-lg-0 {
        padding-right: 0 !important
    }

    .pe-lg-1 {
        padding-right: .25rem !important
    }

    .pe-lg-2 {
        padding-right: .5rem !important
    }

    .pe-lg-3 {
        padding-right: 1rem !important
    }

    .pe-lg-4 {
        padding-right: 1.5rem !important
    }

    .pe-lg-5 {
        padding-right: 3rem !important
    }

    .pb-lg-0 {
        padding-bottom: 0 !important
    }

    .pb-lg-1 {
        padding-bottom: .25rem !important
    }

    .pb-lg-2 {
        padding-bottom: .5rem !important
    }

    .pb-lg-3 {
        padding-bottom: 1rem !important
    }

    .pb-lg-4 {
        padding-bottom: 1.5rem !important
    }

    .pb-lg-5 {
        padding-bottom: 3rem !important
    }

    .ps-lg-0 {
        padding-left: 0 !important
    }

    .ps-lg-1 {
        padding-left: .25rem !important
    }

    .ps-lg-2 {
        padding-left: .5rem !important
    }

    .ps-lg-3 {
        padding-left: 1rem !important
    }

    .ps-lg-4 {
        padding-left: 1.5rem !important
    }

    .ps-lg-5 {
        padding-left: 3rem !important
    }

    .gap-lg-0 {
        gap: 0 !important
    }

    .gap-lg-1 {
        gap: .25rem !important
    }

    .gap-lg-2 {
        gap: .5rem !important
    }

    .gap-lg-3 {
        gap: 1rem !important
    }

    .gap-lg-4 {
        gap: 1.5rem !important
    }

    .gap-lg-5 {
        gap: 3rem !important
    }

    .row-gap-lg-0 {
        row-gap: 0 !important
    }

    .row-gap-lg-1 {
        row-gap: .25rem !important
    }

    .row-gap-lg-2 {
        row-gap: .5rem !important
    }

    .row-gap-lg-3 {
        row-gap: 1rem !important
    }

    .row-gap-lg-4 {
        row-gap: 1.5rem !important
    }

    .row-gap-lg-5 {
        row-gap: 3rem !important
    }

    .column-gap-lg-0 {
        column-gap: 0 !important
    }

    .column-gap-lg-1 {
        column-gap: .25rem !important
    }

    .column-gap-lg-2 {
        column-gap: .5rem !important
    }

    .column-gap-lg-3 {
        column-gap: 1rem !important
    }

    .column-gap-lg-4 {
        column-gap: 1.5rem !important
    }

    .column-gap-lg-5 {
        column-gap: 3rem !important
    }

    .text-lg-start {
        text-align: left !important
    }

    .text-lg-end {
        text-align: right !important
    }

    .text-lg-center {
        text-align: center !important
    }
}

@media(min-width: 1200px) {
    .float-xl-start {
        float: left !important
    }

    .float-xl-end {
        float: right !important
    }

    .float-xl-none {
        float: none !important
    }

    .object-fit-xl-contain {
        object-fit: contain !important
    }

    .object-fit-xl-cover {
        object-fit: cover !important
    }

    .object-fit-xl-fill {
        object-fit: fill !important
    }

    .object-fit-xl-scale {
        object-fit: scale-down !important
    }

    .object-fit-xl-none {
        object-fit: none !important
    }

    .d-xl-inline {
        display: inline !important
    }

    .d-xl-inline-block {
        display: inline-block !important
    }

    .d-xl-block {
        display: block !important
    }

    .d-xl-grid {
        display: grid !important
    }

    .d-xl-inline-grid {
        display: inline-grid !important
    }

    .d-xl-table {
        display: table !important
    }

    .d-xl-table-row {
        display: table-row !important
    }

    .d-xl-table-cell {
        display: table-cell !important
    }

    .d-xl-flex {
        display: flex !important
    }

    .d-xl-inline-flex {
        display: inline-flex !important
    }

    .d-xl-none {
        display: none !important
    }

    .flex-xl-fill {
        flex: 1 1 auto !important
    }

    .flex-xl-row {
        flex-direction: row !important
    }

    .flex-xl-column {
        flex-direction: column !important
    }

    .flex-xl-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-xl-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-xl-grow-0 {
        flex-grow: 0 !important
    }

    .flex-xl-grow-1 {
        flex-grow: 1 !important
    }

    .flex-xl-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-xl-shrink-1 {
        flex-shrink: 1 !important
    }

    .flex-xl-wrap {
        flex-wrap: wrap !important
    }

    .flex-xl-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-xl-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .justify-content-xl-start {
        justify-content: flex-start !important
    }

    .justify-content-xl-end {
        justify-content: flex-end !important
    }

    .justify-content-xl-center {
        justify-content: center !important
    }

    .justify-content-xl-between {
        justify-content: space-between !important
    }

    .justify-content-xl-around {
        justify-content: space-around !important
    }

    .justify-content-xl-evenly {
        justify-content: space-evenly !important
    }

    .align-items-xl-start {
        align-items: flex-start !important
    }

    .align-items-xl-end {
        align-items: flex-end !important
    }

    .align-items-xl-center {
        align-items: center !important
    }

    .align-items-xl-baseline {
        align-items: baseline !important
    }

    .align-items-xl-stretch {
        align-items: stretch !important
    }

    .align-content-xl-start {
        align-content: flex-start !important
    }

    .align-content-xl-end {
        align-content: flex-end !important
    }

    .align-content-xl-center {
        align-content: center !important
    }

    .align-content-xl-between {
        align-content: space-between !important
    }

    .align-content-xl-around {
        align-content: space-around !important
    }

    .align-content-xl-stretch {
        align-content: stretch !important
    }

    .align-self-xl-auto {
        align-self: auto !important
    }

    .align-self-xl-start {
        align-self: flex-start !important
    }

    .align-self-xl-end {
        align-self: flex-end !important
    }

    .align-self-xl-center {
        align-self: center !important
    }

    .align-self-xl-baseline {
        align-self: baseline !important
    }

    .align-self-xl-stretch {
        align-self: stretch !important
    }

    .order-xl-first {
        order: -1 !important
    }

    .order-xl-0 {
        order: 0 !important
    }

    .order-xl-1 {
        order: 1 !important
    }

    .order-xl-2 {
        order: 2 !important
    }

    .order-xl-3 {
        order: 3 !important
    }

    .order-xl-4 {
        order: 4 !important
    }

    .order-xl-5 {
        order: 5 !important
    }

    .order-xl-last {
        order: 6 !important
    }

    .m-xl-0 {
        margin: 0 !important
    }

    .m-xl-1 {
        margin: .25rem !important
    }

    .m-xl-2 {
        margin: .5rem !important
    }

    .m-xl-3 {
        margin: 1rem !important
    }

    .m-xl-4 {
        margin: 1.5rem !important
    }

    .m-xl-5 {
        margin: 3rem !important
    }

    .m-xl-auto {
        margin: auto !important
    }

    .mx-xl-0 {
        margin-right: 0 !important;
        margin-left: 0 !important
    }

    .mx-xl-1 {
        margin-right: .25rem !important;
        margin-left: .25rem !important
    }

    .mx-xl-2 {
        margin-right: .5rem !important;
        margin-left: .5rem !important
    }

    .mx-xl-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-xl-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important
    }

    .mx-xl-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important
    }

    .mx-xl-auto {
        margin-right: auto !important;
        margin-left: auto !important
    }

    .my-xl-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important
    }

    .my-xl-1 {
        margin-top: .25rem !important;
        margin-bottom: .25rem !important
    }

    .my-xl-2 {
        margin-top: .5rem !important;
        margin-bottom: .5rem !important
    }

    .my-xl-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-xl-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important
    }

    .my-xl-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important
    }

    .my-xl-auto {
        margin-top: auto !important;
        margin-bottom: auto !important
    }

    .mt-xl-0 {
        margin-top: 0 !important
    }

    .mt-xl-1 {
        margin-top: .25rem !important
    }

    .mt-xl-2 {
        margin-top: .5rem !important
    }

    .mt-xl-3 {
        margin-top: 1rem !important
    }

    .mt-xl-4 {
        margin-top: 1.5rem !important
    }

    .mt-xl-5 {
        margin-top: 3rem !important
    }

    .mt-xl-auto {
        margin-top: auto !important
    }

    .me-xl-0 {
        margin-right: 0 !important
    }

    .me-xl-1 {
        margin-right: .25rem !important
    }

    .me-xl-2 {
        margin-right: .5rem !important
    }

    .me-xl-3 {
        margin-right: 1rem !important
    }

    .me-xl-4 {
        margin-right: 1.5rem !important
    }

    .me-xl-5 {
        margin-right: 3rem !important
    }

    .me-xl-auto {
        margin-right: auto !important
    }

    .mb-xl-0 {
        margin-bottom: 0 !important
    }

    .mb-xl-1 {
        margin-bottom: .25rem !important
    }

    .mb-xl-2 {
        margin-bottom: .5rem !important
    }

    .mb-xl-3 {
        margin-bottom: 1rem !important
    }

    .mb-xl-4 {
        margin-bottom: 1.5rem !important
    }

    .mb-xl-5 {
        margin-bottom: 3rem !important
    }

    .mb-xl-auto {
        margin-bottom: auto !important
    }

    .ms-xl-0 {
        margin-left: 0 !important
    }

    .ms-xl-1 {
        margin-left: .25rem !important
    }

    .ms-xl-2 {
        margin-left: .5rem !important
    }

    .ms-xl-3 {
        margin-left: 1rem !important
    }

    .ms-xl-4 {
        margin-left: 1.5rem !important
    }

    .ms-xl-5 {
        margin-left: 3rem !important
    }

    .ms-xl-auto {
        margin-left: auto !important
    }

    .p-xl-0 {
        padding: 0 !important
    }

    .p-xl-1 {
        padding: .25rem !important
    }

    .p-xl-2 {
        padding: .5rem !important
    }

    .p-xl-3 {
        padding: 1rem !important
    }

    .p-xl-4 {
        padding: 1.5rem !important
    }

    .p-xl-5 {
        padding: 3rem !important
    }

    .px-xl-0 {
        padding-right: 0 !important;
        padding-left: 0 !important
    }

    .px-xl-1 {
        padding-right: .25rem !important;
        padding-left: .25rem !important
    }

    .px-xl-2 {
        padding-right: .5rem !important;
        padding-left: .5rem !important
    }

    .px-xl-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-xl-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important
    }

    .px-xl-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important
    }

    .py-xl-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .py-xl-1 {
        padding-top: .25rem !important;
        padding-bottom: .25rem !important
    }

    .py-xl-2 {
        padding-top: .5rem !important;
        padding-bottom: .5rem !important
    }

    .py-xl-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-xl-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important
    }

    .py-xl-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important
    }

    .pt-xl-0 {
        padding-top: 0 !important
    }

    .pt-xl-1 {
        padding-top: .25rem !important
    }

    .pt-xl-2 {
        padding-top: .5rem !important
    }

    .pt-xl-3 {
        padding-top: 1rem !important
    }

    .pt-xl-4 {
        padding-top: 1.5rem !important
    }

    .pt-xl-5 {
        padding-top: 3rem !important
    }

    .pe-xl-0 {
        padding-right: 0 !important
    }

    .pe-xl-1 {
        padding-right: .25rem !important
    }

    .pe-xl-2 {
        padding-right: .5rem !important
    }

    .pe-xl-3 {
        padding-right: 1rem !important
    }

    .pe-xl-4 {
        padding-right: 1.5rem !important
    }

    .pe-xl-5 {
        padding-right: 3rem !important
    }

    .pb-xl-0 {
        padding-bottom: 0 !important
    }

    .pb-xl-1 {
        padding-bottom: .25rem !important
    }

    .pb-xl-2 {
        padding-bottom: .5rem !important
    }

    .pb-xl-3 {
        padding-bottom: 1rem !important
    }

    .pb-xl-4 {
        padding-bottom: 1.5rem !important
    }

    .pb-xl-5 {
        padding-bottom: 3rem !important
    }

    .ps-xl-0 {
        padding-left: 0 !important
    }

    .ps-xl-1 {
        padding-left: .25rem !important
    }

    .ps-xl-2 {
        padding-left: .5rem !important
    }

    .ps-xl-3 {
        padding-left: 1rem !important
    }

    .ps-xl-4 {
        padding-left: 1.5rem !important
    }

    .ps-xl-5 {
        padding-left: 3rem !important
    }

    .gap-xl-0 {
        gap: 0 !important
    }

    .gap-xl-1 {
        gap: .25rem !important
    }

    .gap-xl-2 {
        gap: .5rem !important
    }

    .gap-xl-3 {
        gap: 1rem !important
    }

    .gap-xl-4 {
        gap: 1.5rem !important
    }

    .gap-xl-5 {
        gap: 3rem !important
    }

    .row-gap-xl-0 {
        row-gap: 0 !important
    }

    .row-gap-xl-1 {
        row-gap: .25rem !important
    }

    .row-gap-xl-2 {
        row-gap: .5rem !important
    }

    .row-gap-xl-3 {
        row-gap: 1rem !important
    }

    .row-gap-xl-4 {
        row-gap: 1.5rem !important
    }

    .row-gap-xl-5 {
        row-gap: 3rem !important
    }

    .column-gap-xl-0 {
        column-gap: 0 !important
    }

    .column-gap-xl-1 {
        column-gap: .25rem !important
    }

    .column-gap-xl-2 {
        column-gap: .5rem !important
    }

    .column-gap-xl-3 {
        column-gap: 1rem !important
    }

    .column-gap-xl-4 {
        column-gap: 1.5rem !important
    }

    .column-gap-xl-5 {
        column-gap: 3rem !important
    }

    .text-xl-start {
        text-align: left !important
    }

    .text-xl-end {
        text-align: right !important
    }

    .text-xl-center {
        text-align: center !important
    }
}

@media(min-width: 1440) {
    .float-xxl-start {
        float: left !important
    }

    .float-xxl-end {
        float: right !important
    }

    .float-xxl-none {
        float: none !important
    }

    .object-fit-xxl-contain {
        object-fit: contain !important
    }

    .object-fit-xxl-cover {
        object-fit: cover !important
    }

    .object-fit-xxl-fill {
        object-fit: fill !important
    }

    .object-fit-xxl-scale {
        object-fit: scale-down !important
    }

    .object-fit-xxl-none {
        object-fit: none !important
    }

    .d-xxl-inline {
        display: inline !important
    }

    .d-xxl-inline-block {
        display: inline-block !important
    }

    .d-xxl-block {
        display: block !important
    }

    .d-xxl-grid {
        display: grid !important
    }

    .d-xxl-inline-grid {
        display: inline-grid !important
    }

    .d-xxl-table {
        display: table !important
    }

    .d-xxl-table-row {
        display: table-row !important
    }

    .d-xxl-table-cell {
        display: table-cell !important
    }

    .d-xxl-flex {
        display: flex !important
    }

    .d-xxl-inline-flex {
        display: inline-flex !important
    }

    .d-xxl-none {
        display: none !important
    }

    .flex-xxl-fill {
        flex: 1 1 auto !important
    }

    .flex-xxl-row {
        flex-direction: row !important
    }

    .flex-xxl-column {
        flex-direction: column !important
    }

    .flex-xxl-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-xxl-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-xxl-grow-0 {
        flex-grow: 0 !important
    }

    .flex-xxl-grow-1 {
        flex-grow: 1 !important
    }

    .flex-xxl-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-xxl-shrink-1 {
        flex-shrink: 1 !important
    }

    .flex-xxl-wrap {
        flex-wrap: wrap !important
    }

    .flex-xxl-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-xxl-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .justify-content-xxl-start {
        justify-content: flex-start !important
    }

    .justify-content-xxl-end {
        justify-content: flex-end !important
    }

    .justify-content-xxl-center {
        justify-content: center !important
    }

    .justify-content-xxl-between {
        justify-content: space-between !important
    }

    .justify-content-xxl-around {
        justify-content: space-around !important
    }

    .justify-content-xxl-evenly {
        justify-content: space-evenly !important
    }

    .align-items-xxl-start {
        align-items: flex-start !important
    }

    .align-items-xxl-end {
        align-items: flex-end !important
    }

    .align-items-xxl-center {
        align-items: center !important
    }

    .align-items-xxl-baseline {
        align-items: baseline !important
    }

    .align-items-xxl-stretch {
        align-items: stretch !important
    }

    .align-content-xxl-start {
        align-content: flex-start !important
    }

    .align-content-xxl-end {
        align-content: flex-end !important
    }

    .align-content-xxl-center {
        align-content: center !important
    }

    .align-content-xxl-between {
        align-content: space-between !important
    }

    .align-content-xxl-around {
        align-content: space-around !important
    }

    .align-content-xxl-stretch {
        align-content: stretch !important
    }

    .align-self-xxl-auto {
        align-self: auto !important
    }

    .align-self-xxl-start {
        align-self: flex-start !important
    }

    .align-self-xxl-end {
        align-self: flex-end !important
    }

    .align-self-xxl-center {
        align-self: center !important
    }

    .align-self-xxl-baseline {
        align-self: baseline !important
    }

    .align-self-xxl-stretch {
        align-self: stretch !important
    }

    .order-xxl-first {
        order: -1 !important
    }

    .order-xxl-0 {
        order: 0 !important
    }

    .order-xxl-1 {
        order: 1 !important
    }

    .order-xxl-2 {
        order: 2 !important
    }

    .order-xxl-3 {
        order: 3 !important
    }

    .order-xxl-4 {
        order: 4 !important
    }

    .order-xxl-5 {
        order: 5 !important
    }

    .order-xxl-last {
        order: 6 !important
    }

    .m-xxl-0 {
        margin: 0 !important
    }

    .m-xxl-1 {
        margin: .25rem !important
    }

    .m-xxl-2 {
        margin: .5rem !important
    }

    .m-xxl-3 {
        margin: 1rem !important
    }

    .m-xxl-4 {
        margin: 1.5rem !important
    }

    .m-xxl-5 {
        margin: 3rem !important
    }

    .m-xxl-auto {
        margin: auto !important
    }

    .mx-xxl-0 {
        margin-right: 0 !important;
        margin-left: 0 !important
    }

    .mx-xxl-1 {
        margin-right: .25rem !important;
        margin-left: .25rem !important
    }

    .mx-xxl-2 {
        margin-right: .5rem !important;
        margin-left: .5rem !important
    }

    .mx-xxl-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-xxl-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important
    }

    .mx-xxl-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important
    }

    .mx-xxl-auto {
        margin-right: auto !important;
        margin-left: auto !important
    }

    .my-xxl-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important
    }

    .my-xxl-1 {
        margin-top: .25rem !important;
        margin-bottom: .25rem !important
    }

    .my-xxl-2 {
        margin-top: .5rem !important;
        margin-bottom: .5rem !important
    }

    .my-xxl-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-xxl-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important
    }

    .my-xxl-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important
    }

    .my-xxl-auto {
        margin-top: auto !important;
        margin-bottom: auto !important
    }

    .mt-xxl-0 {
        margin-top: 0 !important
    }

    .mt-xxl-1 {
        margin-top: .25rem !important
    }

    .mt-xxl-2 {
        margin-top: .5rem !important
    }

    .mt-xxl-3 {
        margin-top: 1rem !important
    }

    .mt-xxl-4 {
        margin-top: 1.5rem !important
    }

    .mt-xxl-5 {
        margin-top: 3rem !important
    }

    .mt-xxl-auto {
        margin-top: auto !important
    }

    .me-xxl-0 {
        margin-right: 0 !important
    }

    .me-xxl-1 {
        margin-right: .25rem !important
    }

    .me-xxl-2 {
        margin-right: .5rem !important
    }

    .me-xxl-3 {
        margin-right: 1rem !important
    }

    .me-xxl-4 {
        margin-right: 1.5rem !important
    }

    .me-xxl-5 {
        margin-right: 3rem !important
    }

    .me-xxl-auto {
        margin-right: auto !important
    }

    .mb-xxl-0 {
        margin-bottom: 0 !important
    }

    .mb-xxl-1 {
        margin-bottom: .25rem !important
    }

    .mb-xxl-2 {
        margin-bottom: .5rem !important
    }

    .mb-xxl-3 {
        margin-bottom: 1rem !important
    }

    .mb-xxl-4 {
        margin-bottom: 1.5rem !important
    }

    .mb-xxl-5 {
        margin-bottom: 3rem !important
    }

    .mb-xxl-auto {
        margin-bottom: auto !important
    }

    .ms-xxl-0 {
        margin-left: 0 !important
    }

    .ms-xxl-1 {
        margin-left: .25rem !important
    }

    .ms-xxl-2 {
        margin-left: .5rem !important
    }

    .ms-xxl-3 {
        margin-left: 1rem !important
    }

    .ms-xxl-4 {
        margin-left: 1.5rem !important
    }

    .ms-xxl-5 {
        margin-left: 3rem !important
    }

    .ms-xxl-auto {
        margin-left: auto !important
    }

    .p-xxl-0 {
        padding: 0 !important
    }

    .p-xxl-1 {
        padding: .25rem !important
    }

    .p-xxl-2 {
        padding: .5rem !important
    }

    .p-xxl-3 {
        padding: 1rem !important
    }

    .p-xxl-4 {
        padding: 1.5rem !important
    }

    .p-xxl-5 {
        padding: 3rem !important
    }

    .px-xxl-0 {
        padding-right: 0 !important;
        padding-left: 0 !important
    }

    .px-xxl-1 {
        padding-right: .25rem !important;
        padding-left: .25rem !important
    }

    .px-xxl-2 {
        padding-right: .5rem !important;
        padding-left: .5rem !important
    }

    .px-xxl-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-xxl-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important
    }

    .px-xxl-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important
    }

    .py-xxl-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .py-xxl-1 {
        padding-top: .25rem !important;
        padding-bottom: .25rem !important
    }

    .py-xxl-2 {
        padding-top: .5rem !important;
        padding-bottom: .5rem !important
    }

    .py-xxl-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-xxl-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important
    }

    .py-xxl-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important
    }

    .pt-xxl-0 {
        padding-top: 0 !important
    }

    .pt-xxl-1 {
        padding-top: .25rem !important
    }

    .pt-xxl-2 {
        padding-top: .5rem !important
    }

    .pt-xxl-3 {
        padding-top: 1rem !important
    }

    .pt-xxl-4 {
        padding-top: 1.5rem !important
    }

    .pt-xxl-5 {
        padding-top: 3rem !important
    }

    .pe-xxl-0 {
        padding-right: 0 !important
    }

    .pe-xxl-1 {
        padding-right: .25rem !important
    }

    .pe-xxl-2 {
        padding-right: .5rem !important
    }

    .pe-xxl-3 {
        padding-right: 1rem !important
    }

    .pe-xxl-4 {
        padding-right: 1.5rem !important
    }

    .pe-xxl-5 {
        padding-right: 3rem !important
    }

    .pb-xxl-0 {
        padding-bottom: 0 !important
    }

    .pb-xxl-1 {
        padding-bottom: .25rem !important
    }

    .pb-xxl-2 {
        padding-bottom: .5rem !important
    }

    .pb-xxl-3 {
        padding-bottom: 1rem !important
    }

    .pb-xxl-4 {
        padding-bottom: 1.5rem !important
    }

    .pb-xxl-5 {
        padding-bottom: 3rem !important
    }

    .ps-xxl-0 {
        padding-left: 0 !important
    }

    .ps-xxl-1 {
        padding-left: .25rem !important
    }

    .ps-xxl-2 {
        padding-left: .5rem !important
    }

    .ps-xxl-3 {
        padding-left: 1rem !important
    }

    .ps-xxl-4 {
        padding-left: 1.5rem !important
    }

    .ps-xxl-5 {
        padding-left: 3rem !important
    }

    .gap-xxl-0 {
        gap: 0 !important
    }

    .gap-xxl-1 {
        gap: .25rem !important
    }

    .gap-xxl-2 {
        gap: .5rem !important
    }

    .gap-xxl-3 {
        gap: 1rem !important
    }

    .gap-xxl-4 {
        gap: 1.5rem !important
    }

    .gap-xxl-5 {
        gap: 3rem !important
    }

    .row-gap-xxl-0 {
        row-gap: 0 !important
    }

    .row-gap-xxl-1 {
        row-gap: .25rem !important
    }

    .row-gap-xxl-2 {
        row-gap: .5rem !important
    }

    .row-gap-xxl-3 {
        row-gap: 1rem !important
    }

    .row-gap-xxl-4 {
        row-gap: 1.5rem !important
    }

    .row-gap-xxl-5 {
        row-gap: 3rem !important
    }

    .column-gap-xxl-0 {
        column-gap: 0 !important
    }

    .column-gap-xxl-1 {
        column-gap: .25rem !important
    }

    .column-gap-xxl-2 {
        column-gap: .5rem !important
    }

    .column-gap-xxl-3 {
        column-gap: 1rem !important
    }

    .column-gap-xxl-4 {
        column-gap: 1.5rem !important
    }

    .column-gap-xxl-5 {
        column-gap: 3rem !important
    }

    .text-xxl-start {
        text-align: left !important
    }

    .text-xxl-end {
        text-align: right !important
    }

    .text-xxl-center {
        text-align: center !important
    }
}

@media(min-width: 1200px) {
    .fs-1 {
        font-size: 3.125rem !important
    }

    .fs-2 {
        font-size: 2.1875rem !important
    }

    .fs-3 {
        font-size: 1.75rem !important
    }

    .fs-4 {
        font-size: 1.5rem !important
    }
}

@media print {
    .d-print-inline {
        display: inline !important
    }

    .d-print-inline-block {
        display: inline-block !important
    }

    .d-print-block {
        display: block !important
    }

    .d-print-grid {
        display: grid !important
    }

    .d-print-inline-grid {
        display: inline-grid !important
    }

    .d-print-table {
        display: table !important
    }

    .d-print-table-row {
        display: table-row !important
    }

    .d-print-table-cell {
        display: table-cell !important
    }

    .d-print-flex {
        display: flex !important
    }

    .d-print-inline-flex {
        display: inline-flex !important
    }

    .d-print-none {
        display: none !important
    }
}

* {
    outline: none;
    padding: 0
}

*::after {
    margin: 0;
    padding: 0
}

*::before {
    margin: 0;
    padding: 0
}

body {
    line-height: 1.7;
    color: #444
}

body.fixed {
    overflow: hidden;
    position: fixed
}

h1,
.h1 {
    font-size: 50px;
    font-weight: 700
}

@media only screen and (max-width: 1380px) {

    h1,
    .h1 {
        font-size: 42px
    }
}

@media only screen and (max-width: 767px) {

    h1,
    .h1 {
        font-size: 38px
    }
}

@media only screen and (max-width: 575px) {

    h1,
    .h1 {
        font-size: 35px
    }
}

h2,
.h2 {
    font-size: 35px;
    font-weight: 700
}

@media only screen and (max-width: 1380px) {

    h2,
    .h2 {
        font-size: 36px
    }
}

@media only screen and (max-width: 767px) {

    h2,
    .h2 {
        font-size: 32px
    }
}

@media only screen and (max-width: 575px) {

    h2,
    .h2 {
        font-size: 28px
    }
}

h3,
.h3 {
    font-size: 28px;
    font-weight: 700
}

@media only screen and (max-width: 767px) {

    h3,
    .h3 {
        font-size: 24px
    }
}

h4,
.h4 {
    font-size: 24px;
    font-weight: 700
}

@media only screen and (max-width: 767px) {

    h4,
    .h4 {
        font-size: 20px
    }
}

h5,
.h5 {
    font-size: 20px;
    font-weight: 700
}

@media only screen and (max-width: 575px) {

    h5,
    .h5 {
        font-size: 18px
    }
}

h6,
.h6 {
    font-size: 18px;
    font-weight: 700
}

@media only screen and (max-width: 575px) {

    h6,
    .h6 {
        font-size: 16px
    }
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
    font-family: "Montserrat", sans-serif;
    color: var(--bs-dark);
    line-height: 1.3
}

h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a,
.h1 a,
.h2 a,
.h3 a,
.h4 a,
.h5 a,
.h6 a {
    color: var(--bs-dark)
}

ul {
    padding: 0;
    margin: 0
}

img {
    border-style: none;
    height: auto;
    max-width: 100%;
    vertical-align: middle
}

li {
    list-style: none
}

a {
    text-decoration: none;
    outline: none;
    color: #565acf
}

a:hover,
a:focus,
a.active {
    text-decoration: none;
    outline: none;
    color: #565acf
}

b,
strong,
.strong {
    font-weight: 500;
    color: #14181d
}

.h-0 {
    height: 0
}

#main-wrapper {
    opacity: 0;
    transition: all .25s ease-in;
    overflow: hidden;
    position: relative;
    z-index: 1;
    margin-top: 60px
}

#main-wrapper.show {
    opacity: 1
}

.content-body {
    margin-left: 65px;
    margin-top: 18px;
    margin-right: 6px;
    margin-bottom: 45px
}

.bg-gray {
    background-color: #fafafb
}

.container-sm {
    max-width: 990px !important
}

.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
    padding-left: 30px;
    padding-right: 30px
}

@media only screen and (min-width: 1800px) {

    .container-fluid,
    .container-sm,
    .container-md,
    .container-lg,
    .container-xl {
        max-width: 1720px;
        padding-left: 15px;
        padding-right: 15px
    }
}

@media only screen and (max-width: 991px) {

    .container-fluid,
    .container-sm,
    .container-md,
    .container-lg,
    .container-xl {
        padding-left: 15px;
        padding-right: 15px
    }
}

.rounded {
    border-radius: 8px !important
}

#loading-icon-bx {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: #fff;
    z-index: 999999999
}

#loading-icon-bx .loading-inner {
    position: absolute;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%)
}

#loading-icon-bx .loading-inner div {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%
}

#loading-icon-bx .loading-inner div.load-one {
    left: 0%;
    top: 0%;
    animation: load-rotate-one 1.15s linear infinite;
    -o-animation: load-rotate-one 1.15s linear infinite;
    -ms-animation: load-rotate-one 1.15s linear infinite;
    -webkit-animation: load-rotate-one 1.15s linear infinite;
    -moz-animation: load-rotate-one 1.15s linear infinite;
    border-bottom: 5px solid #565acf
}

#loading-icon-bx .loading-inner div.load-two {
    right: 0%;
    top: 0%;
    animation: load-rotate-two 1.15s linear infinite;
    -o-animation: load-rotate-two 1.15s linear infinite;
    -ms-animation: load-rotate-two 1.15s linear infinite;
    -webkit-animation: load-rotate-two 1.15s linear infinite;
    -moz-animation: load-rotate-two 1.15s linear infinite;
    border-right: 5px solid #565acf
}

#loading-icon-bx .loading-inner div.load-three {
    right: 0%;
    bottom: 0%;
    animation: load-rotate-three 1.15s linear infinite;
    -o-animation: load-rotate-three 1.15s linear infinite;
    -ms-animation: load-rotate-three 1.15s linear infinite;
    -webkit-animation: load-rotate-three 1.15s linear infinite;
    -moz-animation: load-rotate-three 1.15s linear infinite;
    border-top: 5px solid #565acf
}

@keyframes load-rotate-one {
    0% {
        transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg)
    }

    100% {
        transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg)
    }
}

@keyframes load-rotate-two {
    0% {
        transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg)
    }

    100% {
        transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg)
    }
}

@keyframes load-rotate-three {
    0% {
        transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg)
    }

    100% {
        transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg)
    }
}

.pa-0 {
    padding: 0
}

.pa-5 {
    padding: 5px
}

.pa-10 {
    padding: 10px
}

.pa-15 {
    padding: 15px
}

.pa-20 {
    padding: 20px
}

.pa-25 {
    padding: 25px
}

.pa-30 {
    padding: 30px
}

.pa-40 {
    padding: 40px
}

.pa-50 {
    padding: 50px
}

.pa-60 {
    padding: 60px
}

.pa-70 {
    padding: 70px
}

.pa-80 {
    padding: 80px
}

.pa-90 {
    padding: 90px
}

.pa-100 {
    padding: 100px
}

.pt-0 {
    padding-top: 0
}

.pt-5 {
    padding-top: 5px
}

.pt-10 {
    padding-top: 10px
}

.pt-15 {
    padding-top: 15px
}

.pt-20 {
    padding-top: 20px
}

.pt-30 {
    padding-top: 30px
}

.pt-40 {
    padding-top: 40px
}

.pt-50 {
    padding-top: 50px
}

.pt-60 {
    padding-top: 60px
}

.pt-70 {
    padding-top: 70px
}

.pt-80 {
    padding-top: 80px
}

.pt-90 {
    padding-top: 90px
}

.pt-100 {
    padding-top: 100px
}

.pb-0 {
    padding-bottom: 0
}

.pb-5 {
    padding-bottom: 5px
}

.pb-10 {
    padding-bottom: 10px
}

.pb-15 {
    padding-bottom: 15px
}

.pb-20 {
    padding-bottom: 20px
}

.pb-30 {
    padding-bottom: 30px
}

.pb-40 {
    padding-bottom: 40px
}

.pb-50 {
    padding-bottom: 50px
}

.pb-60 {
    padding-bottom: 60px
}

.pb-70 {
    padding-bottom: 70px
}

.pb-80 {
    padding-bottom: 80px
}

.pb-90 {
    padding-bottom: 90px
}

.pb-100 {
    padding-bottom: 100px
}

.pl-0 {
    padding-left: 0
}

.pl-5 {
    padding-left: 5px
}

.pl-10 {
    padding-left: 10px
}

.pl-15 {
    padding-left: 15px
}

.pl-20 {
    padding-left: 20px
}

.pl-30 {
    padding-left: 30px
}

.pl-40 {
    padding-left: 40px
}

.pl-50 {
    padding-left: 50px
}

.pl-60 {
    padding-left: 60px
}

.pl-70 {
    padding-left: 70px
}

.pl-80 {
    padding-left: 80px
}

.pl-90 {
    padding-left: 90px
}

.pl-100 {
    padding-left: 100px
}

.pr-0 {
    padding-right: 0
}

.pr-5 {
    padding-right: 5px
}

.pr-10 {
    padding-right: 10px
}

.pr-15 {
    padding-right: 15px
}

.pr-20 {
    padding-right: 20px
}

.pr-30 {
    padding-right: 30px
}

.pr-40 {
    padding-right: 40px
}

.pr-50 {
    padding-right: 50px
}

.pr-60 {
    padding-right: 60px
}

.pr-70 {
    padding-right: 70px
}

.pr-80 {
    padding-right: 80px
}

.pr-90 {
    padding-right: 90px
}

.pr-100 {
    padding-right: 100px
}

.px-0 {
    padding-left: 0;
    padding-right: 0
}

.px-5 {
    padding-left: 5px;
    padding-right: 5px
}

.px-10 {
    padding-left: 10px;
    padding-right: 10px
}

.px-15 {
    padding-left: 15px;
    padding-right: 15px
}

.px-20 {
    padding-left: 20px;
    padding-right: 20px
}

.px-30 {
    padding-left: 30px;
    padding-right: 30px
}

.px-40 {
    padding-left: 40px;
    padding-right: 40px
}

.px-50 {
    padding-left: 50px;
    padding-right: 50px
}

.px-60 {
    padding-left: 60px;
    padding-right: 60px
}

.px-70 {
    padding-left: 70px;
    padding-right: 70px
}

.px-80 {
    padding-left: 80px;
    padding-right: 80px
}

.px-90 {
    padding-left: 90px;
    padding-right: 90px
}

.px-100 {
    padding-left: 100px;
    padding-right: 100px
}

.py-0 {
    padding-bottom: 0;
    padding-top: 0
}

.py-5 {
    padding-bottom: 5px;
    padding-top: 5px
}

.py-10 {
    padding-bottom: 10px;
    padding-top: 10px
}

.py-15 {
    padding-bottom: 15px;
    padding-top: 15px
}

.py-20 {
    padding-bottom: 20px;
    padding-top: 20px
}

.py-30 {
    padding-bottom: 30px;
    padding-top: 30px
}

.py-40 {
    padding-bottom: 40px;
    padding-top: 40px
}

.py-50 {
    padding-bottom: 50px;
    padding-top: 50px
}

.py-60 {
    padding-bottom: 60px;
    padding-top: 60px
}

.py-70 {
    padding-bottom: 70px;
    padding-top: 70px
}

.py-80 {
    padding-bottom: 80px;
    padding-top: 80px
}

.py-90 {
    padding-bottom: 90px;
    padding-top: 90px
}

.py-100 {
    padding-bottom: 100px;
    padding-top: 100px
}

.mx-auto {
    margin-left: auto;
    margin-right: auto
}

.ma-0 {
    margin: 0
}

.ma-5 {
    margin: 5px
}

.ma-10 {
    margin: 10px
}

.ma-15 {
    margin: 15px
}

.ma-20 {
    margin: 20px
}

.ma-25 {
    margin: 25px
}

.ma-30 {
    margin: 30px
}

.ma-40 {
    margin: 40px
}

.ma-50 {
    margin: 50px
}

.ma-60 {
    margin: 60px
}

.ma-70 {
    margin: 70px
}

.ma-80 {
    margin: 80px
}

.ma-90 {
    margin: 90px
}

.ma-100 {
    margin: 100px
}

.mt-0 {
    margin-top: 0
}

.mt-5 {
    margin-top: 5px
}

.mt-10 {
    margin-top: 10px
}

.mt-15 {
    margin-top: 15px
}

.mt-20 {
    margin-top: 20px
}

.mt-30 {
    margin-top: 30px
}

.mt-40 {
    margin-top: 40px
}

.mt-50 {
    margin-top: 50px
}

.mt-60 {
    margin-top: 60px
}

.mt-70 {
    margin-top: 70px
}

.mt-80 {
    margin-top: 80px
}

.mt-90 {
    margin-top: 90px
}

.mt-100 {
    margin-top: 100px
}

.mb-0 {
    margin-bottom: 0
}

.mb-5 {
    margin-bottom: 5px
}

.mb-10 {
    margin-bottom: 10px
}

.mb-15 {
    margin-bottom: 15px
}

.mb-20 {
    margin-bottom: 20px
}

.mb-30 {
    margin-bottom: 30px
}

.mb-40 {
    margin-bottom: 40px
}

.mb-50 {
    margin-bottom: 50px
}

.mb-60 {
    margin-bottom: 60px
}

.mb-70 {
    margin-bottom: 70px
}

.mb-80 {
    margin-bottom: 80px
}

.mb-90 {
    margin-bottom: 90px
}

.mb-100 {
    margin-bottom: 100px
}

.ml-0 {
    margin-left: 0
}

.ml-5 {
    margin-left: 5px
}

.ml-10 {
    margin-left: 10px
}

.ml-15 {
    margin-left: 15px
}

.ml-20 {
    margin-left: 20px
}

.ml-30 {
    margin-left: 30px
}

.ml-40 {
    margin-left: 40px
}

.ml-50 {
    margin-left: 50px
}

.ml-60 {
    margin-left: 60px
}

.ml-70 {
    margin-left: 70px
}

.ml-80 {
    margin-left: 80px
}

.ml-90 {
    margin-left: 90px
}

.ml-100 {
    margin-left: 100px
}

.m-r0 {
    margin-right: 0
}

.m-r5 {
    margin-right: 5px
}

.m-r10 {
    margin-right: 10px
}

.m-r15 {
    margin-right: 15px
}

.m-r20 {
    margin-right: 20px
}

.m-r30 {
    margin-right: 30px
}

.m-r40 {
    margin-right: 40px
}

.m-r50 {
    margin-right: 50px
}

.m-r60 {
    margin-right: 60px
}

.m-r70 {
    margin-right: 70px
}

.m-r80 {
    margin-right: 80px
}

.m-r90 {
    margin-right: 90px
}

.m-r100 {
    margin-right: 100px
}

.mx-0 {
    margin-left: 0;
    margin-right: 0
}

.mx-5 {
    margin-left: 5px;
    margin-right: 5px
}

.mx-10 {
    margin-left: 10px;
    margin-right: 10px
}

.mx-15 {
    margin-left: 15px;
    margin-right: 15px
}

.mx-20 {
    margin-left: 20px;
    margin-right: 20px
}

.mx-30 {
    margin-left: 30px;
    margin-right: 30px
}

.mx-40 {
    margin-left: 40px;
    margin-right: 40px
}

.mx-50 {
    margin-left: 50px;
    margin-right: 50px
}

.mx-60 {
    margin-left: 60px;
    margin-right: 60px
}

.mx-70 {
    margin-left: 70px;
    margin-right: 70px
}

.mx-80 {
    margin-left: 80px;
    margin-right: 80px
}

.mx-90 {
    margin-left: 90px;
    margin-right: 90px
}

.mx-100 {
    margin-left: 100px;
    margin-right: 100px
}

.my-0 {
    margin-bottom: 0;
    margin-top: 0
}

.my-5 {
    margin-bottom: 5px;
    margin-top: 5px
}

.my-10 {
    margin-bottom: 10px;
    margin-top: 10px
}

.my-15 {
    margin-bottom: 15px;
    margin-top: 15px
}

.my-20 {
    margin-bottom: 20px;
    margin-top: 20px
}

.my-30 {
    margin-bottom: 30px;
    margin-top: 30px
}

.my-40 {
    margin-bottom: 40px;
    margin-top: 40px
}

.my-50 {
    margin-bottom: 50px;
    margin-top: 50px
}

.my-60 {
    margin-bottom: 60px;
    margin-top: 60px
}

.my-70 {
    margin-bottom: 70px;
    margin-top: 70px
}

.my-80 {
    margin-bottom: 80px;
    margin-top: 80px
}

.my-90 {
    margin-bottom: 90px;
    margin-top: 90px
}

.my-100 {
    margin-bottom: 100px;
    margin-top: 100px
}

@media only screen and (max-width: 1200px) {
    .mt-lg-0 {
        margin-top: 0
    }

    .mt-lg-5 {
        margin-top: 5px
    }

    .mt-lg-10 {
        margin-top: 10px
    }

    .mt-lg-15 {
        margin-top: 15px
    }

    .mt-lg-20 {
        margin-top: 20px
    }

    .mt-lg-30 {
        margin-top: 30px
    }

    .mt-lg-40 {
        margin-top: 40px
    }

    .mt-lg-50 {
        margin-top: 50px
    }

    .mt-lg-60 {
        margin-top: 60px
    }

    .mt-lg-70 {
        margin-top: 70px
    }

    .mt-lg-80 {
        margin-top: 80px
    }

    .mt-lg-90 {
        margin-top: 90px
    }

    .mt-lg-100 {
        margin-top: 100px
    }

    .mb-lg-0 {
        margin-bottom: 0
    }

    .mb-lg-5 {
        margin-bottom: 5px
    }

    .mb-lg-10 {
        margin-bottom: 10px
    }

    .mb-lg-15 {
        margin-bottom: 15px
    }

    .mb-lg-20 {
        margin-bottom: 20px
    }

    .mb-lg-30 {
        margin-bottom: 30px
    }

    .mb-lg-40 {
        margin-bottom: 40px
    }

    .mb-lg-50 {
        margin-bottom: 50px
    }

    .mb-lg-60 {
        margin-bottom: 60px
    }

    .mb-lg-70 {
        margin-bottom: 70px
    }

    .mb-lg-80 {
        margin-bottom: 80px
    }

    .mb-lg-90 {
        margin-bottom: 90px
    }

    .mb-lg-100 {
        margin-bottom: 100px
    }
}

@media only screen and (max-width: 991px) {
    .mt-md-0 {
        margin-top: 0
    }

    .mt-md-5 {
        margin-top: 5px
    }

    .mt-md-10 {
        margin-top: 10px
    }

    .mt-md-15 {
        margin-top: 15px
    }

    .mt-md-20 {
        margin-top: 20px
    }

    .mt-md-30 {
        margin-top: 30px
    }

    .mt-md-40 {
        margin-top: 40px
    }

    .mt-md-50 {
        margin-top: 50px
    }

    .mt-md-60 {
        margin-top: 60px
    }

    .mt-md-70 {
        margin-top: 70px
    }

    .mt-md-80 {
        margin-top: 80px
    }

    .mt-md-90 {
        margin-top: 90px
    }

    .mt-md-100 {
        margin-top: 100px
    }

    .mb-md-0 {
        margin-bottom: 0
    }

    .mb-md-5 {
        margin-bottom: 5px
    }

    .mb-md-10 {
        margin-bottom: 10px
    }

    .mb-md-15 {
        margin-bottom: 15px
    }

    .mb-md-20 {
        margin-bottom: 20px
    }

    .mb-md-30 {
        margin-bottom: 30px
    }

    .mb-md-40 {
        margin-bottom: 40px
    }

    .mb-md-50 {
        margin-bottom: 50px
    }

    .mb-md-60 {
        margin-bottom: 60px
    }

    .mb-md-70 {
        margin-bottom: 70px
    }

    .mb-md-80 {
        margin-bottom: 80px
    }

    .mb-md-90 {
        margin-bottom: 90px
    }

    .mb-md-100 {
        margin-bottom: 100px
    }
}

@media only screen and (max-width: 767px) {
    .mt-sm-0 {
        margin-top: 0
    }

    .mt-sm-5 {
        margin-top: 5px
    }

    .mt-sm-10 {
        margin-top: 10px
    }

    .mt-sm-15 {
        margin-top: 15px
    }

    .mt-sm-20 {
        margin-top: 20px
    }

    .mt-sm-30 {
        margin-top: 30px
    }

    .mt-sm-40 {
        margin-top: 40px
    }

    .mt-sm-50 {
        margin-top: 50px
    }

    .mt-sm-60 {
        margin-top: 60px
    }

    .mt-sm-70 {
        margin-top: 70px
    }

    .mt-sm-80 {
        margin-top: 80px
    }

    .mt-sm-90 {
        margin-top: 90px
    }

    .mt-sm-100 {
        margin-top: 100px
    }

    .mb-sm-0 {
        margin-bottom: 0
    }

    .mb-sm-5 {
        margin-bottom: 5px
    }

    .mb-sm-10 {
        margin-bottom: 10px
    }

    .mb-sm-15 {
        margin-bottom: 15px
    }

    .mb-sm-20 {
        margin-bottom: 20px
    }

    .mb-sm-30 {
        margin-bottom: 30px
    }

    .mb-sm-40 {
        margin-bottom: 40px
    }

    .mb-sm-50 {
        margin-bottom: 50px
    }

    .mb-sm-60 {
        margin-bottom: 60px
    }

    .mb-sm-70 {
        margin-bottom: 70px
    }

    .mb-sm-80 {
        margin-bottom: 80px
    }

    .mb-sm-90 {
        margin-bottom: 90px
    }

    .mb-sm-100 {
        margin-bottom: 100px
    }
}

@media only screen and (max-width: 576px) {
    .mt-xs-0 {
        margin-top: 0
    }

    .mt-xs-5 {
        margin-top: 5px
    }

    .mt-xs-10 {
        margin-top: 10px
    }

    .mt-xs-15 {
        margin-top: 15px
    }

    .mt-xs-20 {
        margin-top: 20px
    }

    .mt-xs-30 {
        margin-top: 30px
    }

    .mt-xs-40 {
        margin-top: 40px
    }

    .mt-xs-50 {
        margin-top: 50px
    }

    .mt-xs-60 {
        margin-top: 60px
    }

    .mt-xs-70 {
        margin-top: 70px
    }

    .mt-xs-80 {
        margin-top: 80px
    }

    .mt-xs-90 {
        margin-top: 90px
    }

    .mt-xs-100 {
        margin-top: 100px
    }

    .mb-xs-0 {
        margin-bottom: 0
    }

    .mb-xs-5 {
        margin-bottom: 5px
    }

    .mb-xs-10 {
        margin-bottom: 10px
    }

    .mb-xs-15 {
        margin-bottom: 15px
    }

    .mb-xs-20 {
        margin-bottom: 20px
    }

    .mb-xs-30 {
        margin-bottom: 30px
    }

    .mb-xs-40 {
        margin-bottom: 40px
    }

    .mb-xs-50 {
        margin-bottom: 50px
    }

    .mb-xs-60 {
        margin-bottom: 60px
    }

    .mb-xs-70 {
        margin-bottom: 70px
    }

    .mb-xs-80 {
        margin-bottom: 80px
    }

    .mb-xs-90 {
        margin-bottom: 90px
    }

    .mb-xs-100 {
        margin-bottom: 100px
    }
}

.section-sp1 {
    padding-top: 100px;
    padding-bottom: 70px
}

@media only screen and (max-width: 1199px) {
    .section-sp1 {
        padding-top: 70px;
        padding-bottom: 40px
    }
}

@media only screen and (max-width: 991px) {
    .section-sp1 {
        padding-top: 50px;
        padding-bottom: 20px
    }
}

.section-sp2 {
    padding-top: 100px;
    padding-bottom: 100px
}

@media only screen and (max-width: 1199px) {
    .section-sp2 {
        padding-top: 70px;
        padding-bottom: 70px
    }
}

@media only screen and (max-width: 991px) {
    .section-sp2 {
        padding-top: 50px;
        padding-bottom: 50px
    }
}

.section-sp3 {
    padding-top: 100px;
    padding-bottom: 0
}

@media only screen and (max-width: 1199px) {
    .section-sp3 {
        padding-top: 70px
    }
}

@media only screen and (max-width: 991px) {
    .section-sp3 {
        padding-top: 50px
    }
}

.section-sp4 {
    padding-top: 50px;
    padding-bottom: 50px
}

.section-sp5 {
    padding-bottom: 70px
}

@media only screen and (max-width: 1199px) {
    .section-sp5 {
        padding-bottom: 50px
    }
}

@media only screen and (max-width: 991px) {
    .section-sp5 {
        padding-bottom: 20px
    }
}

.fs10 {
    font-size: 10px
}

.fs12 {
    font-size: 12px
}

.fs13 {
    font-size: 13px
}

.fs14 {
    font-size: 14px
}

.fs16 {
    font-size: 16px
}

.fs18 {
    font-size: 18px
}

.fs20 {
    font-size: 20px
}

.fs22 {
    font-size: 22px
}

.fs24 {
    font-size: 24px
}

.fs26 {
    font-size: 26px
}

.fs30 {
    font-size: 30px;
    line-height: 40px
}

.fs35 {
    font-size: 35px;
    line-height: 45px
}

.fs40 {
    font-size: 40px;
    line-height: 50px
}

.fs45 {
    font-size: 45px;
    line-height: 55px
}

.fs50 {
    font-size: 50px;
    line-height: 65px
}

.fs55 {
    font-size: 55px;
    line-height: 65px
}

.fs60 {
    font-size: 60px;
    line-height: 70px
}

.fs70 {
    font-size: 70px;
    line-height: 80px
}

.fs75 {
    font-size: 75px;
    line-height: 85px
}

.fs80 {
    font-size: 80px;
    line-height: 90px
}

.fs90 {
    font-size: 90px;
    line-height: 100px
}

.fs100 {
    font-size: 100px;
    line-height: 110px
}

.fw3 {
    font-weight: 300
}

.fw4 {
    font-weight: 400
}

.fw5 {
    font-weight: 500
}

.fw6 {
    font-weight: 600
}

.fw7 {
    font-weight: 700
}

.fw8 {
    font-weight: 800
}

.fw9 {
    font-weight: 900
}

dl,
ul,
ol {
    list-style-position: outside
}

ul,
ol {
    margin-bottom: 24px
}

ul li,
ol li {
    padding: 0
}

dl {
    margin-left: 0;
    margin-bottom: 30px
}

dl dd {
    margin-bottom: 10px
}

.posi-ab {
    position: absolute
}

.posi-rl {
    position: relative
}

.posi-st {
    position: static
}

.zi1 {
    z-index: 1
}

.zi2 {
    z-index: 2
}

.zi3 {
    z-index: 3
}

.zi4 {
    z-index: 4
}

.zi5 {
    z-index: 5
}

.zi6 {
    z-index: 6
}

.zi7 {
    z-index: 7
}

.zi8 {
    z-index: 8
}

.zi9 {
    z-index: 9
}

.zi10 {
    z-index: 10
}

.zi100 {
    z-index: 100
}

.zi999 {
    z-index: 999
}

::selection {
    color: #fff;
    background: #565acf
}

::selection {
    background: #565acf;
    color: #fff
}

.mfp-gallery {
    list-style: none;
    margin-bottom: 0
}

.mfp-title {
    display: none
}

.list-inline li {
    display: inline-block
}

.full-img {
    width: 100%
}

.sticky-top {
    top: 130px
}

section {
    position: relative
}

.ov-hidden {
    overflow: hidden
}

.row.spno,
.spno {
    margin-left: 0;
    margin-right: 0
}

.row.spno [class*=col],
.row.spno [class*=col],
.spno [class*=col],
.spno [class*=col] {
    padding-left: 0;
    padding-right: 0
}

.row.sp5,
.sp5 {
    margin-left: -5px;
    margin-right: -5px
}

.row.sp5 [class*=col],
.row.sp5 [class*=col],
.sp5 [class*=col],
.sp5 [class*=col] {
    padding-left: 5px;
    padding-right: 5px
}

.row.sp10,
.sp10 {
    margin-left: -10px;
    margin-right: -10px
}

.row.sp10 [class*=col],
.row.sp10 [class*=col],
.sp10 [class*=col],
.sp10 [class*=col] {
    padding-left: 10px;
    padding-right: 10px
}

.row.sp10,
.sp10 {
    margin-left: -10px;
    margin-right: -10px
}

.row.sp10 [class*=col],
.row.sp10 [class*=col],
.sp10 [class*=col],
.sp10 [class*=col] {
    padding-left: 10px;
    padding-right: 10px
}

.row.sp20,
.sp20 {
    margin-left: -20px;
    margin-right: -20px
}

.row.sp20 [class*=col],
.row.sp20 [class*=col],
.sp20 [class*=col],
.sp20 [class*=col] {
    padding-left: 20px;
    padding-right: 20px
}

.page-banner {
    background: #fff;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    overflow: hidden;
    height: 420px;
    width: 100%;
    z-index: 1
}

@media only screen and (max-width: 991px) {
    .page-banner {
        height: 320px
    }
}

@media only screen and (max-width: 767px) {
    .page-banner {
        height: 280px
    }
}

.page-banner .container {
    display: table;
    height: 100%
}

.page-banner .page-banner-entry {
    height: 420px;
    vertical-align: middle;
    display: table-cell;
    padding-top: 40px;
    padding-bottom: 60px
}

@media only screen and (max-width: 991px) {
    .page-banner .page-banner-entry {
        height: 320px;
        padding-bottom: 30px
    }
}

@media only screen and (max-width: 767px) {
    .page-banner .page-banner-entry {
        height: 280px
    }
}

.page-banner h1,
.page-banner .h1 {
    font-weight: 700;
    /* font-size: 72px; */
    font-size: 50px;
    margin-bottom: 20px;
    color: var(--bs-dark);
    text-transform: capitalize
}

@media only screen and (max-width: 1380px) {

    .page-banner h1,
    .page-banner .h1 {
        font-size: 62px
    }
}

@media only screen and (max-width: 991px) {

    .page-banner h1,
    .page-banner .h1 {
        font-size: 52px
    }
}

@media only screen and (max-width: 767px) {

    .page-banner h1,
    .page-banner .h1 {
        font-size: 42px
    }
}

.page-banner:after {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: contain;
    z-index: -1
}

.page-banner.banner-lg {
    height: 550px
}

.page-banner.banner-lg .page-banner-entry {
    height: 550px
}

@media only screen and (max-width: 991px) {
    .page-banner.banner-lg {
        height: 450px
    }

    .page-banner.banner-lg .page-banner-entry {
        height: 450px
    }
}

@media only screen and (max-width: 767px) {
    .page-banner.banner-lg {
        height: 400px
    }

    .page-banner.banner-lg .page-banner-entry {
        height: 400px
    }
}

.page-banner.banner-md {
    height: 450px
}

.page-banner.banner-md .page-banner-entry {
    height: 450px
}

.page-banner.banner-sm {
    height: 300px
}

.page-banner.banner-sm .page-banner-entry {
    height: 300px
}

/* .custom-text{
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
} */



.cutom-search input {
    border: 1px solid #D5D5D5;
    min-height: 53px;
    padding: 8px 16px 8px 42px;
    border-radius: 10px;
    /* min-width: 340px; */
    color: #757575;
    font-size: 15px;
    font-weight: 500;
}

.cutom-search i {
    transform: rotate(270deg) !important;
    top: 34%;
    left: 16px;
}

.cutom-search::placeholder {
    color: #757575;
    font-size: 15px;
    font-weight: 500;
}

.custom-select {
    background-color: #F6F8FA !important;
    padding: 2px 24px 8px 24px;
    border-radius: 10px;
}

.custom-select .css-b62m3t-container,
.custom-select .css-3iigni-container {
    margin-top: -4px;
}

.custom-select .css-1f43avz-a11yText-A11yText,
.custom-select .css-894a34-indicatorSeparator {
    display: none !important;
}

.custom-select .css-13cymwt-control,
.custom-select .css-t3ipsp-control,
.custom-select .css-16xfy0z-control {
    border: none !important;
    background-color: transparent;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500 !important;
    height: 20px !important;
    min-height: 20px !important;
    color: #444444 !important;
    box-shadow: none !important;
}



.custom-select .css-tj5bde-Svg {
    fill: #000000 !important;
    font-weight: 400 !important;

}

.custom-select .css-1xc3v61-indicatorContainer,
.custom-select .css-15lsz6c-indicatorContainer {
    padding: 0;
    height: 14px;
    width: 14px;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.custom-select .css-1xc3v61-indicatorContainer svg,
.custom-select .css-15lsz6c-indicatorContainer svg {
    display: none !important;
}

.custom-select .css-10wo9uf-option,
.custom-select .css-d7l1ni-option {
    font-size: 14px;
    font-weight: 500;

}


.custom-select .css-d7l1ni-option,
.custom-select .css-1224hz6-option,
.custom-select .css-tr4s17-option {
    background-color: #F6F8FA !important;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    color: #444444;
}

.custom-select .css-nkt5xy-option {
    color: #757575 !important;
    font-size: 14px;
    font-weight: 500;
}

.custom-select .css-10wo9uf-option:active {
    background-color: #F6F8FA !important;
    color: #444444 !important;
}

.custom-select .css-qr46ko {
    padding: 12px;
}

.custom-select .css-tr4s17-option:active {
    background-color: #F6F8FA !important;
}

.custom-select .css-hlgwow {
    padding: 0;
}

.custom-select .css-qr46ko::-webkit-scrollbar {
    width: 5px !important;
}

.custom-select .css-qr46ko::-webkit-scrollbar-thumb {
    background: #008BB1;
    width: 4px;
    border-radius: 50px !important;
}

.custom-select .css-qr46ko::-webkit-scrollbar-track {
    background: #F6F8FA !important;
}

.custom-select .css-1u9des2-indicatorSeparator {
    display: none;
}

.custom-select label {
    color: #757575;
    font-size: 12px;
    margin-top: -2px;
    line-height: 10px !important;
    /* line-height: 15px; */
}

/* .custom-select select {
    background-color: transparent !important;
    border: none !important;
    padding: 4px 0 0 0 !important;
    line-height: 17px !important;
    font-size: 15px;
    color: #444444 !important;
    font-weight: 500;
}

.custom-select select option{
    border: none !important;
} */

.section-area .pt-img1 {
    left: 15%;
    bottom: 50px;
    z-index: 1
}

.section-area .pt-img2 {
    left: 0;
    top: 10px
}

.section-area .pt-img3 {
    right: 38%;
    bottom: 6%;
    z-index: 2;
}

.breadcrumb-row {
    /* box-shadow: 0px 5px 30px 0px rgba(86, 90, 207, .3); */
    font-family: "Montserrat", sans-serif;
    /* background-color: #008BB1; */
    padding: 12px 30px;
    border-radius: 10px;
    display: inline-block
}

@media only screen and (max-width: 767px) {
    .breadcrumb-row {
        padding: 10px 24px
    }
}

.breadcrumb-row ul {
    background: rgba(0, 0, 0, 0);
    padding: 0;
    justify-content: center;
    margin: 0
}

.breadcrumb-row ul li {
    padding: 0;
    display: inline-flex;
    font-size: 16px;
    font-weight: 500;
    align-items: center
}

.breadcrumb-row ul li a {
    /* color: #fff; */
    color: #008BB1;
    display: flex;
    align-items: center
}

.breadcrumb-row ul li a svg {
    margin-right: 10px;
    transform: translateY(-2px)
}

@media only screen and (max-width: 1380px) {
    .breadcrumb-row ul li {
        font-size: 14px
    }
}

.breadcrumb-item+.breadcrumb-item {
    /* padding-left: 15px; */
    /* color: #fff */
    color: #008BB1;
}

.breadcrumb-item+.breadcrumb-item::before {
    /* color: #fff; */
    color: #008BB1;
    content: "/";
    font-size: 22px;
    /* padding-right: 15px; */
    opacity: .4;
    font-weight: 300;
    line-height: 22px;
    margin-top: 5px
}

@media only screen and (max-width: 1380px) {
    .breadcrumb-item+.breadcrumb-item {
        padding-left: 10px
    }

    .breadcrumb-item+.breadcrumb-item::before {
        font-size: 18px;
        padding-right: 10px;
        line-height: 18px
    }
}

section {
    position: relative;
    z-index: 1
}

/* .heading-bx {
    margin-bottom: 45px
} */

.heading-bx .title-ext {
    font-weight: 700;
    display: inline-block;
    padding: 3px 15px;
    background-position: center;
    background-repeat: repeat;
    margin-bottom: 15px
}

.heading-bx .title-ext.text-primary {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___})
}

.heading-bx .title-ext.text-secondary {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___})
}

.heading-bx h2.title,
.heading-bx .title.h2 {
    font-size: 45px
}

@media only screen and (max-width: 1380px) {

    .heading-bx h2.title,
    .heading-bx .title.h2 {
        font-size: 36px
    }
}

@media only screen and (max-width: 767px) {

    .heading-bx h2.title,
    .heading-bx .title.h2 {
        font-size: 32px
    }
}

@media only screen and (max-width: 575px) {

    .heading-bx h2.title,
    .heading-bx .title.h2 {
        font-size: 28px
    }
}

@media only screen and (max-width: 991px) {
    .heading-bx {
        padding: 30px 0;
        /* margin-bottom: 20px !important; */
        text-align: center;
    }
}

@media only screen and (max-width: 1199px) {
    /* .heading-bx {
        margin-bottom: 40px
    } */
}

.heading-bx.text-white h1,
.heading-bx.text-white .h1,
.heading-bx.text-white h2,
.heading-bx.text-white .h2,
.heading-bx.text-white h3,
.heading-bx.text-white .h3,
.heading-bx.text-white h4,
.heading-bx.text-white .h4,
.heading-bx.text-white h5,
.heading-bx.text-white .h5,
.heading-bx.text-white h6,
.heading-bx.text-white .h6 {
    color: #fff
}

.heading-bx p {
    padding-top: 5px;
    font-weight: 500
}

@media only screen and (max-width: 1680px) {
    .heading-bx p {
        font-size: 15px
    }
}

@media only screen and (max-width: 1199px) {
    .heading-bx p {
        font-size: 14px;
        line-height: 24px
    }
}

.heading-bx.text-center p {
    max-width: 800px;
    margin-left: auto;
    margin-right: auto
}

.heading-bx.head-col {
    display: flex;
    align-items: center
}

@media only screen and (max-width: 767px) {
    .heading-bx.head-col {
        display: block
    }
}

.heading-bx.head-col .title {
    margin-bottom: 0
}

@media only screen and (max-width: 767px) {
    .heading-bx.head-col .title {
        margin-bottom: 10px
    }
}

.heading-bx.head-col p {
    padding-left: 15px;
    border-left: 4px solid #565acf;
    margin-left: 15px;
    margin-bottom: 0
}

@media only screen and (max-width: 767px) {
    .heading-bx.head-col p {
        padding-left: 0;
        border-left: 0;
        margin-left: 0
    }
}

.text-white h1,
.text-white .h1,
.text-white h2,
.text-white .h2,
.text-white h3,
.text-white .h3,
.text-white h4,
.text-white .h4,
.text-white h5,
.text-white .h5,
.text-white h6,
.text-white .h6 {
    color: #fff
}

@media only screen and (min-width: 1200px)and (max-width: 1440px) {
    .col-xxl-1 {
        flex: 0 0 8.3333333333%;
        max-width: 8.3333333333%
    }

    .col-xxl-2 {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%
    }

    .col-xxl-3 {
        flex: 0 0 25%;
        max-width: 25%
    }

    .col-xxl-4 {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%
    }

    .col-xxl-5 {
        flex: 0 0 41.6666666667%;
        max-width: 41.6666666667%
    }

    .col-xxl-6 {
        flex: 0 0 50%;
        max-width: 50%
    }

    .col-xxl-7 {
        flex: 0 0 58.3333333333%;
        max-width: 58.3333333333%
    }

    .col-xxl-8 {
        flex: 0 0 66.6666666667%;
        max-width: 66.6666666667%
    }

    .col-xxl-9 {
        flex: 0 0 75%;
        max-width: 75%
    }

    .col-xxl-10 {
        flex: 0 0 83.3333333333%;
        max-width: 83.3333333333%
    }

    .col-xxl-11 {
        flex: 0 0 91.6666666667%;
        max-width: 91.6666666667%
    }

    .col-xxl-12 {
        flex: 0 0 100%;
        max-width: 100%
    }
}

.ttr-accordion1 .accordion-item {
    border: 0;
    margin-bottom: 15px
}

.ttr-accordion1 .accordion-button {
    background-color: #f17732;
    font-weight: 600;
    color: #fff;
    border-radius: 8px !important;
    border: 0;
    padding: 18px 25px;
    transition: all .5s
}

.ttr-accordion1 .accordion-button.collapsed {
    background-color: #565acf
}

.ttr-accordion1 .accordion-button.collapsed:after {
    transform: rotateX(0)
}

.ttr-accordion1 .accordion-button:after {
    content: "";
    font-family: "Font Awesome 5 Free";
    background-image: unset;
    font-size: 14px;
    transform: rotateX(-180deg);
    width: auto;
    height: auto;
    transition: all .5s
}

.ttr-accordion1 .accordion-header {
    margin-bottom: -5px
}

.ttr-accordion1 .accordion-body {
    font-size: 15px;
    padding: 25px;
    background-color: rgba(86, 90, 207, .1);
    border-radius: 0 0 8px 8px
}

.card {
    border: 0px solid #e1e1f0;
    margin-bottom: 30px;
    border-radius: 5px;
    box-shadow: 0px 36px 48px rgba(31, 66, 135, .04);
    background: #fff
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e1e1f0;
    background: #fff;
    padding: 20px 30px
}

.card-title {
    font-size: 24px;
    margin-bottom: 0px
}

.card .card-body {
    padding: 20px 30px;
    background: #fff;
    border-radius: 15px
}

.form-group {
    position: relative;
}

.form-group label {
    font-size: 14px;
    font-weight: 500;
    color: #444;
    margin-bottom: 10px;
    background: rgba(0, 0, 0, 0);
    border-color: #e1e1f0;

}

.form-control {
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0);
    padding: 0px 25px;
    font-size: 14px;
    font-weight: 400;
    color: #444;
    transition: all .3s ease-in-out;
    background: #fff;
}

.form-control .select {
    padding: 12px 0
}

.form-control span {
    margin-top: 0
}

.form-control::placeholder {
    color: #444
}

.form-control:hover {
    box-shadow: none !important;
    border-color: #e1e1f0;
    color: #444;
    background: #fff
}

.form-control:focus,
.form-control:active,
.form-control.active {
    box-shadow: none !important;
    border-color: #565acf;
    color: #444;
    background: #fff;
    border-radius: 6px
}

input:-internal-autofill-selected {
    background: #fff !important;
    background-image: none !important;
    color: -internal-light-dark-color(black, white) !important
}

.input-group-text {
    padding: 5px 15px;
    background: #fff;
    margin-bottom: 0px !important;
    color: #444;
    border-color: rgba(0, 0, 0, 0)
}

.input-group-append .input-group-text {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px
}

.input-group-prepend .input-group-text {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px
}

.toggle {
    cursor: pointer;
    display: block
}

.toggle-switch {
    display: inline-block;
    background: #f7f7f7;
    border-radius: 16px;
    width: 45px;
    height: 20px;
    position: relative;
    vertical-align: middle;
    transition: background .25s
}

.toggle-switch:before,
.toggle-switch:after {
    content: ""
}

.toggle-switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    width: 17px;
    height: 17px;
    position: absolute;
    top: 1px;
    left: 3px;
    transition: left .25s
}

.toggle:hover .toggle-switch:before {
    background: linear-gradient(to bottom, #fff 0%, #fff 100%)
}

.toggle-checkbox:checked+.toggle-switch {
    background: #565acf
}

.toggle-checkbox:checked+.toggle-switch:before {
    left: 26px
}

.toggle-checkbox {
    position: absolute;
    visibility: hidden
}

.toggle-label {
    margin-left: 15px;
    position: relative;
    top: 2px;
    font-size: 16px;
    font-weight: 400
}

.file-upload-wrapper {
    position: relative;
    width: 100%;
    height: calc(1.5em + 1rem + 2px);
    border: 1px solid #e1e1f0;
    border-radius: 5px;
    color: #aeaed5
}

.file-upload-wrapper:after {
    content: attr(data-text);
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    padding: 4px 15px;
    display: block;
    width: calc(100% - 40px);
    pointer-events: none;
    z-index: 20;
    height: calc(1.5em + 1rem + 2px);
    line-height: 30px;
    border-radius: 5px 10px 10px 5px;
    font-weight: 400;
    overflow: hidden
}

.file-upload-wrapper:before {
    content: "Upload";
    position: absolute;
    top: 0;
    right: 0;
    display: inline-block;
    height: calc(1.5em + 1rem + 2px);
    background: #565acf;
    color: #fff;
    font-weight: 400;
    z-index: 25;
    font-size: 14px;
    line-height: 40px;
    padding: 0 15px;
    text-transform: capitalize;
    pointer-events: none;
    border-radius: 0 5px 5px 0
}

.file-upload-wrapper:hover:before {
    background: #363abc
}

.file-upload-wrapper input {
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    height: calc(1.5em + 1rem + 2px);
    margin: 0;
    padding: 0;
    display: block;
    cursor: pointer;
    width: 100%
}

#ui-datepicker-div {
    display: none;
    background: #fafafa;
    box-shadow: 0 .125rem .5rem rgba(0, 0, 0, .1);
    margin-top: .25rem;
    border-radius: .5rem;
    padding: .5rem
}

table {
    border-collapse: collapse;
    border-spacing: 0
}

.ui-datepicker-calendar thead th {
    padding: .25rem 0;
    text-align: center;
    font-size: .75rem;
    font-weight: 400;
    color: #444
}

.ui-datepicker-calendar tbody td {
    width: 2.5rem;
    text-align: center;
    padding: 0
}

.ui-datepicker-calendar tbody td a {
    display: block;
    border-radius: .25rem;
    line-height: 2rem;
    transition: .3s all;
    color: #444;
    font-size: .875rem;
    text-decoration: none
}

.ui-datepicker-calendar tbody td a:hover {
    background-color: #565acf;
    color: #fff
}

.ui-datepicker-calendar tbody td a.ui-state-active {
    background-color: #565acf;
    color: #fff
}

.ui-datepicker-header a.ui-corner-all {
    cursor: pointer;
    position: absolute;
    top: 0;
    width: 2rem;
    height: 2rem;
    margin: .5rem;
    border-radius: .25rem;
    transition: .3s all
}

.ui-datepicker-header a.ui-corner-all:hover {
    background-color: #cdcef1;
    color: #fff
}

.ui-datepicker-header a.ui-datepicker-prev {
    left: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
    background-repeat: no-repeat;
    background-size: .5rem;
    background-position: 50%;
    transform: rotate(180deg)
}

.ui-datepicker-header a.ui-datepicker-next {
    right: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
    background-repeat: no-repeat;
    background-size: 10px;
    background-position: 50%
}

.ui-datepicker-header a>span {
    display: none
}

.ui-datepicker-title {
    text-align: center;
    line-height: 2rem;
    margin-bottom: .25rem;
    font-size: .875rem;
    font-weight: 500;
    padding-bottom: .25rem
}

.ui-datepicker-week-col {
    color: #444;
    font-weight: 400;
    font-size: .75rem
}

label.error {
    color: #f72b50;
    position: absolute;
    bottom: 0;
    margin-bottom: -22px;
    font-size: 12px;
    font-weight: 400
}

.bootstrap-select {
    width: 100% !important
}

.bootstrap-select .dropdown-toggle {
    width: 100%;
    padding: 10px;
    font-family: "Montserrat", sans-serif;
    text-transform: none;
    background: #fff;
    color: #444;
    font-size: 14px;
    outline: none !important
}

.bootstrap-select .dropdown-toggle:focus {
    outline: none !important
}

.bootstrap-select .dropdown-toggle:after {
    content: none
}

.bootstrap-select.show.btn-group .dropdown-menu.inner {
    display: block
}

.bootstrap-select .dropdown-menu {
    border: 0;
    border-radius: 0;
    margin-top: -1px;
    padding: 10px 0;
    font-size: 14px;
    box-shadow: 0 20px 30px 0 rgba(0, 0, 0, .1)
}

.bootstrap-select .dropdown-menu a {
    padding: 5px 25px;
    display: block
}

.bootstrap-select .dropdown-menu a:hover {
    background: #fff
}

.bootstrap-select .list {
    background: var(--bs-dark)
}

.nice-select .list {
    width: 100%;
    border: 0;
    margin: 1px 0 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    padding: 8px 0
}

.nice-select .list li {
    font-weight: 500
}

.nice-select .list .option:hover,
.nice-select .list .option.selected {
    background-color: #565acf;
    color: #fff
}

.nice-select:after {
    right: 22px
}

.btn {
    padding: 15px 30px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
    transition: all .5s;
    border-width: 2px;
    line-height: 1.2
}

.btn.shadow {
    box-shadow: 0px 5px 20px 0px rgba(86, 90, 207, .3)
}

.btn-icon-bx {
    width: 40px;
    height: 40px;
    background: #fff;
    border-radius: inherit;
    line-height: 40px;
    display: inline-block;
    margin: -12px -27px -12px 15px;
    color: #000
}

.btn:hover .btn-icon-bx {
    background-color: #2ab4ff;
}

.btn-xs {
    font-size: 12px;
    padding: 6px 15px
}

.btn-xs .btn-icon-bx {
    width: 26px;
    height: 26px;
    line-height: 26px;
    margin: -10px -15px -10px 10px
}

.btn-sm,
.btn-group-sm>.btn {
    font-size: 14px;
    padding: 12px 27px 12px 20px
}

.btn-sm .btn-icon-bx,
.btn-group-sm>.btn .btn-icon-bx {
    width: 34px;
    height: 34px;
    margin: -10px -24px -10px 15px;
    line-height: 34px
}

.btn-lg,
.btn-group-lg>.btn {
    font-size: 16px;
    padding: 20px 35px;
    line-height: 1
}

.btn-lg .btn-icon-bx,
.btn-group-lg>.btn .btn-icon-bx {
    width: 50px;
    height: 50px;
    line-height: 50px;
    margin: -16px -31px -16px 20px
}

.btn-xl {
    font-size: 18px;
    padding: 24px 40px;
    line-height: 1
}

.btn-xl .btn-icon-bx {
    width: 60px;
    height: 60px;
    line-height: 60px;
    margin: -20px -37px -20px 20px
}

[class*=btn-outline-] .btn-icon-bx {
    color: #fff
}

.btn-outline-primary .btn-icon-bx {
    background: #00b8de
}

.btn-outline-secondary .btn-icon-bx {
    background: #f17732
}

.btn-outline-success .btn-icon-bx {
    background: #209f84
}

.btn-outline-danger .btn-icon-bx {
    background: #f72b50
}

.btn-outline-info .btn-icon-bx {
    background: #2754e6
}

.btn-outline-warning .btn-icon-bx {
    background: #fe970e
}

.btn-outline-light .btn-icon-bx {
    background: #fff
}

.btn-outline-dark .btn-icon-bx {
    background: var(--bs-dark)
}

.btn-light {
    color: #f17732;
    background-color: #fff
}

.btn-secondary {
    background-color: var(--bs-btn-bg);
    color: #fff
}

.btn-secondary.light {
    background-color: #fff;
    color: #f17732
}

.btn-secondary.shadow {
    box-shadow: 0px 5px 20px 0px rgba(8, 116, 150, .3) !important
}

.btn-secondary:hover {
    background-color: #2ab4ff;
    color: #fff;
    border: 2px solid #2ab4ff;
    box-shadow: 0px 5px 20px 0px rgba(8, 116, 150, .3) !important
}

/* .btn-primary {
    background-color: #2ab4ff;
} */

.btn-primary.light {
    background-color: #008bb1;
    color: #fff;
    border: 2px solid #008bb1;
}

.btn-primary.light:hover {
    background-color: #2AB4FF;
    box-shadow: 0px 1px 7px 0px rgba(86, 90, 207, .3);
    color: #fff;
    border: 2px solid #2AB4FF;
}

.btn-primary .btn-icon-bx {
    color: #565acf
}

.btn-primary.shadow {
    box-shadow: 0px 5px 20px 0px rgba(86, 90, 207, .3) !important
}

.btn-success {
    background-color: #209f84
}

.btn-success.light {
    background-color: #b4f0e3;
    color: #209f84
}

.btn-success .btn-icon-bx {
    color: #209f84
}

.btn-danger {
    background-color: #f72b50
}

.btn-danger.light {
    background-color: #fef0f2;
    color: #f72b50
}

.btn-danger .btn-icon-bx {
    color: #f72b50
}

.btn-warning {
    background-color: #fe970e
}

.btn-warning.light {
    background-color: #fffaf3;
    color: #fe970e
}

.btn-warning .btn-icon-bx {
    color: #fe970e
}

.btn-info {
    background-color: #2754e6
}

.btn-info.light {
    background-color: #f5f7fe;
    color: #2754e6
}

.btn-info .btn-icon-bx {
    color: #2754e6
}

.btn-dark {
    background-color: var(--bs-dark)
}

.btn-dark.light {
    background-color: #989be4;
    color: #fff
}

.btn-dark .btn-icon-bx {
    color: var(--bs-dark)
}

.table-responsive-sm {
    min-width: 48rem
}

.table {
    margin-bottom: 0px;
    font-weight: 400
}

.table tr td,
.table tr th {
    padding: 15px
}

.table tr th {
    color: #14181d;
    font-weight: 500
}

.table-striped thead tr th {
    padding-bottom: 15px !important
}

.table-striped tbody tr:nth-of-type(odd) {
    background-color: #fff
}

.table-striped tfoot {
    border-top: 2px solid #e1e1f0
}

.table-striped tfoot tr th {
    padding-top: 10px
}

.ttr-separator {
    display: inline-block;
    height: 4px;
    width: 90px;
    margin-bottom: 10px;
    position: relative
}

.ttr-separator.m-b0 {
    margin-bottom: 0
}

.ttr-separator.style-liner {
    width: 20px
}

.ttr-separator.style-icon {
    width: 30px;
    height: auto;
    text-align: center;
    font-size: 20px
}

.ttr-separator[class*=style-]:after,
.ttr-separator[class*=style-]:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 40px;
    width: 70px;
    height: 2px;
    background: #eee;
    transform: translateY(-50%)
}

.ttr-separator[class*=style-]:before {
    left: auto;
    right: 40px
}

.ttr-separator.style-skew {
    width: 15px;
    height: 10px;
    margin-left: 1px;
    margin-right: 1px;
    transform: skewX(-10deg)
}

.ttr-separator.style-skew[class*=style-]:after,
.ttr-separator.style-skew[class*=style-]:before {
    width: 80px;
    height: 4px;
    left: 20px;
    transform: translateY(-50%) skewX(-10deg)
}

.ttr-separator.style-skew[class*=style-]:before {
    right: 20px;
    left: auto
}

.ttr-separator.bnr-title {
    height: 1px;
    width: 155px;
    opacity: .5
}

.ttr-separator.bnr-title:before,
.ttr-separator.bnr-title:after {
    position: absolute;
    content: "";
    background-color: inherit
}

.ttr-separator.bnr-title:before {
    height: inherit;
    right: -80px;
    width: 25px
}

.ttr-separator.bnr-title:after {
    height: inherit;
    right: -90px;
    top: 0;
    width: 6px
}

.ttr-separator.bnr-title i {
    background-color: inherit;
    display: block;
    height: inherit;
    position: absolute;
    right: -50px;
    width: 45px
}

.ttr-separator-outer {
    overflow: hidden
}

.feature-box-xl {
    display: inline-block;
    text-align: center;
    border-radius: 3px;
    width: 150px;
    height: 150px;
    line-height: 150px
}

.feature-box-xl.radius {
    border-radius: 100%
}

.feature-box-xl i {
    font-size: 80px;
    vertical-align: middle
}

.feature-box-xl img {
    vertical-align: middle;
    max-width: 100%;
    width: auto;
    height: 80px
}

.feature-box-lg {
    display: inline-block;
    text-align: center;
    border-radius: 3px;
    width: 120px;
    height: 120px;
    line-height: 120px
}

.feature-box-lg.radius {
    border-radius: 100%
}

.feature-box-lg i {
    font-size: 60px;
    vertical-align: middle
}

.feature-box-lg img {
    vertical-align: middle;
    max-width: 100%;
    width: auto;
    height: 55px
}

.feature-box-md {
    display: inline-block;
    text-align: center;
    border-radius: 3px;
    width: 100px;
    height: 100px;
    line-height: 100px
}

.feature-box-md.radius {
    border-radius: 100%
}

.feature-box-md i {
    font-size: 45px;
    vertical-align: middle
}

.feature-box-md img {
    vertical-align: middle;
    max-width: 100%;
    width: auto;
    height: 40px
}

.feature-box-sm {
    display: inline-block;
    text-align: center;
    border-radius: 3px;
    width: 80px;
    height: 80px;
    line-height: 80px
}

.feature-box-sm.radius {
    border-radius: 100%
}

.feature-box-sm i {
    font-size: 30px;
    vertical-align: middle
}

.feature-box-sm img {
    vertical-align: middle;
    max-width: 100%;
    width: auto;
    height: 30px
}

.feature-box-xs {
    display: inline-block;
    text-align: center;
    border-radius: 3px;
    width: 40px;
    height: 40px;
    line-height: 40px
}

.feature-box-xs.radius {
    border-radius: 100%
}

.feature-box-xs i {
    font-size: 20px;
    vertical-align: middle
}

.feature-box-xs img {
    vertical-align: middle;
    max-width: 100%;
    width: auto;
    height: 20px
}

.icon-xl {
    display: inline-block;
    text-align: center
}

.icon-xl i {
    vertical-align: middle;
    font-size: 80px
}

.icon-xl img {
    vertical-align: middle;
    max-width: 100%;
    width: auto;
    height: 80px
}

.icon-lg {
    display: inline-block;
    text-align: center
}

.icon-lg i {
    vertical-align: middle;
    font-size: 60px
}

.icon-lg img {
    vertical-align: middle;
    max-width: 100%;
    width: auto;
    height: 70px
}

.icon-md {
    display: inline-block;
    text-align: center
}

.icon-md i {
    vertical-align: middle;
    font-size: 45px
}

.icon-md img {
    vertical-align: middle;
    max-width: 100%;
    width: auto;
    height: 50px
}

.icon-sm {
    display: inline-block;
    text-align: center
}

.icon-sm i {
    vertical-align: middle;
    font-size: 30px
}

.icon-sm img {
    vertical-align: middle;
    max-width: 100%;
    width: auto;
    height: 30px
}

.icon-xs {
    display: inline-block;
    text-align: center
}

.icon-xs i {
    vertical-align: middle;
    font-size: 20px
}

.icon-xs img {
    vertical-align: middle;
    max-width: 100%;
    width: auto;
    height: 20px
}

.feature-container {
    position: relative
}

.feature-container .feature-title {
    margin-top: 0
}

.feature-container .after-titile-line {
    margin-bottom: 10px
}

.feature-container p:last-child {
    margin: 0
}

.feature-container.center {
    text-align: center
}

.feature-container.left .feature-box-xl,
.feature-container.left .feature-box-lg,
.feature-container.left .feature-box-md,
.feature-container.left .feature-box-sm,
.feature-container.left .feature-box-xs {
    float: left;
    margin-right: 20px
}

.feature-container.left .icon-xl,
.feature-container.left .icon-lg,
.feature-container.left .icon-md,
.feature-container.left .icon-sm,
.feature-container.left .icon-xs {
    float: left;
    margin-right: 10px
}

.feature-container.right {
    text-align: right
}

.feature-container.right .feature-box-xl,
.feature-container.right .feature-box-lg,
.feature-container.right .feature-box-md,
.feature-container.right .feature-box-sm,
.feature-container.right .feature-box-xs {
    float: right;
    margin-left: 20px
}

.feature-container.right .icon-xl,
.feature-container.right .icon-lg,
.feature-container.right .icon-md,
.feature-container.right .icon-sm,
.feature-container.right .icon-xs {
    float: right;
    margin-left: 10px
}

.icon-content {
    overflow: hidden
}

[class*=feature-box-][class*=bg-] a {
    color: #fff
}

[class*=feature-box-].bg-white a {
    color: inherit
}

[class*=feature-box-][class*=border-] {
    display: table;
    line-height: normal;
    margin-left: auto;
    margin-right: auto
}

[class*=feature-box-][class*=border-] .icon-cell {
    display: table-cell;
    vertical-align: middle
}

.ttr-box,
.info-bx,
.feature-title,
.feature-title-inner {
    position: relative
}

.feature-title-inner {
    display: inline-block
}

.ttr-box[class*=border-],
.info-bx[class*=border-] {
    border-color: #eee
}

.info-bx.border-1,
.info-bx.border-2,
.info-bx.border-3,
.info-bx.border-4,
.info-bx.border-5 {
    border-top: none
}

.border-1,
.border-2,
.border-3,
.border-4,
.border-5 {
    border-style: solid
}

.border-1 {
    border-width: 1px
}

.border-2 {
    border-width: 2px
}

.border-3 {
    border-width: 3px
}

.border-4 {
    border-width: 4px
}

.border-5 {
    border-width: 5px
}

.left-border,
.right-border {
    position: relative
}

.left-border:before,
.right-border:before {
    content: "";
    position: absolute;
    top: 5px;
    width: 1px;
    height: 90%;
    background: #ccc
}

.right-border:before {
    right: 0
}

.action-box,
.ttr-post-media {
    position: relative;
    overflow: hidden
}

.action-box img,
.ttr-post-media img {
    width: 100%;
    height: auto
}

.ttr-box-bg {
    overflow: hidden;
    background-size: cover
}

.ttr-box-bg .btn {
    overflow: unset
}

.ttr-box-bg .glyph-icon {
    font-size: 50px
}

.ttr-box-bg .feature-container {
    background-color: #f8f8f8
}

.ttr-box-bg .text-primary,
.ttr-box-bg .icon-content .feature-title,
.ttr-box-bg .icon-content p,
.ttr-box-bg .icon-box-btn .btn {
    transition: all .5s
}

.ttr-box-bg.active .feature-container {
    background-color: rgba(0, 0, 0, .7)
}

.ttr-box-bg.active .text-primary,
.ttr-box-bg.active .icon-content .feature-title,
.ttr-box-bg.active .icon-content p,
.ttr-box-bg.active .icon-box-btn .btn {
    color: #fff;
    transition: all .5s
}

.ttr-box-bg .icon-box-btn .btn {
    background-color: #eee;
    padding: 15px 20px;
    text-transform: uppercase;
    font-size: 15px;
    border-radius: 0;
    color: #1abc9c;
    font-weight: 600;
    margin-bottom: 0
}

.feature-bx1 {
    align-items: center;
    display: flex;
    background-color: #fff;
    border-radius: 8px;
    padding: 10px 20px 10px 15px;
    z-index: 1;
    overflow: hidden;
    box-shadow: 0px 5px 30px 0px rgba(31, 34, 120, .08);
    border: 1px solid;
    border-color: #565acf
}

.feature-bx1 .icon-cell {
    margin-right: 30px
}

.feature-bx1 .icon-cell svg {
    width: 45px;
    height: 45px
}

.feature-bx1:after {
    content: "";
    width: 85px;
    height: 85px;
    position: absolute;
    border-radius: 50%;
    z-index: -1;
    top: -8px;
    left: -12px
}

.feature-bx1.feature1 {
    border-color: #b2f0fb
}

.feature-bx1.feature1:after {
    background-color: #ecfcff
}

.feature-bx1.feature2 {
    border-color: #a4fcc4
}

.feature-bx1.feature2:after {
    background-color: #eefff4
}

.feature-bx1.feature3 {
    border-color: #ffbdbc
}

.feature-bx1.feature3:after {
    background-color: #fff0f0
}

.feature-bx1.feature4 {
    border-color: #e2c4ff
}

.feature-bx1.feature4:after {
    background-color: #f8f0ff
}

.feature-bx1 .icon-content .ttr-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--bs-dark);
    margin: 0
}

.feature-bx1:hover .icon-cell svg {
    animation: vibrate .5s alternate
}

.feature-bx2 {
    border-radius: 20px;
    background-color: #fff;
    z-index: 1;
    overflow: hidden;
    padding: 40px;
    box-shadow: 1px 1px 50px rgba(0, 0, 0, .08);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
    background-repeat: no-repeat;
    background-size: 100%
}

@media only screen and (max-width: 575px) {
    .feature-bx2 {
        padding: 30px 20px
    }
}

.feature-bx2 .feature-box-xl {
    background: #fff;
    border: 2px solid rgba(86, 90, 207, .1);
    border-radius: 13px;
    width: 130px;
    height: 130px;
    line-height: 130px
}

.feature-bx2 .feature-box-xl img,
.feature-bx2 .feature-box-xl svg {
    width: 60px
}

.feature-bx2 .icon-content p {
    font-size: 15px;
    margin-bottom: 20px
}

.feature-bx2:hover .feature-box-xl i,
.feature-bx2:hover .feature-box-xl svg,
.feature-bx2:hover .feature-box-xl img {
    animation: vibrate .5s alternate
}

.feature-bx2:hover .btn {
    background-color: #008bb1;
    border-color: #008bb1;
    color: #fff
}

.feature-bx3 {
    border-radius: 20px;
    padding: 50px 30px;
    transition: all .5s;
    background-color: #fff;
    position: relative;
    margin: 15px 0 0 15px
}

.feature-bx3:after {
    content: "";
    position: absolute;
    top: -15px;
    left: -15px;
    border-radius: 20px;
    width: 100%;
    height: 100%;
    border: 2px solid #565acf;
    z-index: -1
}

.feature-bx3 .ttr-title {
    margin-bottom: 12px
}

.feature-bx3 .counter {
    font-size: 60px;
    line-height: 1;
    margin-bottom: 10px
}

.feature-bx3 p {
    font-size: 14px
}

.feature-bx3 .ttr-title,
.feature-bx3 .counter,
.feature-bx3 p {
    transition: all .5s
}

.feature-bx3:hover {
    background-color: #565acf
}

.feature-bx3:hover .ttr-title,
.feature-bx3:hover .counter,
.feature-bx3:hover p {
    color: #fff !important
}


@media only screen and (max-width: 575px) {
    .feature-bx3 {
        padding: 40px
    }
}

.feature-bx4 {
    background-color: #fff;
    border-radius: 8px;
    padding: 45px 35px 35px;
    z-index: 1;
    overflow: hidden;
    box-shadow: 0px 5px 30px 0px rgba(31, 34, 120, .08);
    border: 1px solid;
    border-color: #565acf
}

.feature-bx4 .feature-icon {
    position: relative;
    margin-bottom: 25px
}

.feature-bx4 .feature-icon svg {
    width: 45px;
    height: 45px
}

.feature-bx4 .feature-icon:after {
    content: "";
    width: 65px;
    height: 65px;
    position: absolute;
    border-radius: 50%;
    z-index: -1;
    top: -18px;
    right: -22px
}

.feature-bx4.feature1 {
    border-color: #b2f0fb
}

.feature-bx4.feature1 .feature-icon:after {
    background-color: #ecfcff
}

.feature-bx4.feature2 {
    border-color: #a4fcc4
}

.feature-bx4.feature2 .feature-icon:after {
    background-color: #eefff4
}

.feature-bx4.feature3 {
    border-color: #ffbdbc
}

.feature-bx4.feature3 .feature-icon:after {
    background-color: #fff0f0
}

.feature-bx4.feature4 {
    border-color: #e2c4ff
}

.feature-bx4.feature4 .feature-icon:after {
    background-color: #f8f0ff
}

.feature-bx4 .icon-content .ttr-title {
    color: var(--bs-dark);
    margin: 0 0 12px
}

.feature-bx4 .icon-content p {
    margin: 0
}

.feature-bx4:hover .feature-icon img {
    animation: vibrate .5s alternate
}

.feature-bx5 {
    position: relative;
    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);
    padding: 40px 30px;
    border-radius: 20px;
    background-color: #fff;
    transition: all .5s;
    overflow: hidden;
    z-index: 1
}

.feature-bx5:before,
.feature-bx5:after {
    content: "";
    position: absolute;
    height: 100px;
    width: 100px;
    border: 3px solid;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0);
    opacity: .2;
    transition: all .5s
}

.feature-bx5:before {
    left: -30px;
    top: -30px;
    border-color: #565acf
}

.feature-bx5:after {
    right: -30px;
    bottom: -30px;
    border-color: #f17732
}

.table-wrapper {
    position: relative;
    padding: 30px;
    background: #fff;
    border: 2px solid #e4e3e4;
    transition: all .5s;
    border-radius: 8px
}

.table-wrapper .table-head {
    margin-bottom: 30px
}

.table-wrapper .table-head .table-title {
    margin-bottom: 25px;
    text-align: center
}

.table-wrapper .table-head .table-title .sub-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 0
}

.table-wrapper .table-head .table-price {
    display: flex;
    justify-content: center;
    align-items: center
}

.table-wrapper .table-head .table-price sup {
    font-size: 26px;
    font-weight: bold;
    margin-right: 5px;
    color: #14181d
}

.table-wrapper .table-head .table-price h6,
.table-wrapper .table-head .table-price .h6 {
    font-size: 52px;
    font-weight: 700;
    margin-bottom: 0
}

.table-wrapper .table-head .table-price p {
    margin: 0 0 0 5px;
    font-size: 14px
}

@media only screen and (max-width: 767px) {
    .table-wrapper .table-head .table-price sup {
        font-size: 14px
    }

    .table-wrapper .table-head .table-price h6,
    .table-wrapper .table-head .table-price .h6 {
        font-size: 36px
    }
}

.table-wrapper .table-body {
    margin-bottom: 40px
}

.table-wrapper .table-body .title {
    font-size: 16px;
    margin-bottom: 30px;
    text-align: center
}

@media only screen and (max-width: 767px) {
    .table-wrapper .table-body .title {
        font-size: 14px
    }
}

.table-wrapper .table-body .table-features {
    margin-bottom: 0
}

.table-wrapper .table-body .table-features li {
    font-size: 15px;
    position: relative;
    line-height: 20px;
    margin-bottom: 15px;
    padding-left: 34px;
    font-weight: 500
}

.table-wrapper .table-body .table-features li:before {
    content: "";
    font-size: 24px;
    font-family: "Line Awesome Free";
    font-weight: 900;
    line-height: 25px;
    color: #11a435;
    position: absolute;
    left: 0;
    top: 0
}

.table-wrapper:hover {
    border: 2px solid #565acf;
    box-shadow: 0 5px 20px rgba(0, 98, 255, .2);
    margin-top: -10px
}

.table-wrapper:hover .table-head .table-price sup,
.table-wrapper:hover .table-head .table-price h6,
.table-wrapper:hover .table-head .table-price .h6 {
    color: #565acf
}

.table-wrapper:hover .table-footer .btn {
    background-color: #565acf;
    color: #fff
}

.table-switch {
    display: flex;
    justify-content: center;
    align-items: center
}

.table-switch .form-check-input {
    width: 60px;
    height: 30px;
    box-shadow: 0 3px 10px 0 rgba(0, 98, 252, .2);
    background-color: #565acf
}

.table-switch:before {
    height: 22px;
    width: 22px
}

.table-switch label {
    margin: 0 55px 0 14px;
    font-size: 16px;
    color: #666;
    cursor: pointer;
    font-weight: 500
}

.ovbl-light,
.ovbl-middle,
.ovbl-dark,
.ovgd-light,
.ovgd-middle,
.ovgd-dark,
.ovwh-light,
.ovwh-middle,
.ovwh-dark,
.ovpr-light,
.ovpr-middle,
.ovpr-dark,
.ovpr {
    position: relative
}

.ovbl-light:before,
.ovbl-middle:before,
.ovbl-dark:before,
.ovgd-light:before,
.ovgd-middle:before,
.ovgd-dark:before,
.ovwh-light:before,
.ovwh-middle:before,
.ovwh-dark:before,
.ovpr-light:before,
.ovpr-middle:before,
.ovpr-dark:before,
.ovpr:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%
}

.ovbl-light .container,
.ovbl-light .container-fluid,
.ovbl-light .container-sm,
.ovbl-light .container-md,
.ovbl-light .container-lg,
.ovbl-light .container-xl,
.ovbl-middle .container,
.ovbl-middle .container-fluid,
.ovbl-middle .container-sm,
.ovbl-middle .container-md,
.ovbl-middle .container-lg,
.ovbl-middle .container-xl,
.ovbl-dark .container,
.ovbl-dark .container-fluid,
.ovbl-dark .container-sm,
.ovbl-dark .container-md,
.ovbl-dark .container-lg,
.ovbl-dark .container-xl,
.ovgd-light .container,
.ovgd-light .container-fluid,
.ovgd-light .container-sm,
.ovgd-light .container-md,
.ovgd-light .container-lg,
.ovgd-light .container-xl,
.ovgd-middle .container,
.ovgd-middle .container-fluid,
.ovgd-middle .container-sm,
.ovgd-middle .container-md,
.ovgd-middle .container-lg,
.ovgd-middle .container-xl,
.ovgd-dark .container,
.ovgd-dark .container-fluid,
.ovgd-dark .container-sm,
.ovgd-dark .container-md,
.ovgd-dark .container-lg,
.ovgd-dark .container-xl,
.ovwh-light .container,
.ovwh-light .container-fluid,
.ovwh-light .container-sm,
.ovwh-light .container-md,
.ovwh-light .container-lg,
.ovwh-light .container-xl,
.ovwh-middle .container,
.ovwh-middle .container-fluid,
.ovwh-middle .container-sm,
.ovwh-middle .container-md,
.ovwh-middle .container-lg,
.ovwh-middle .container-xl,
.ovwh-dark .container,
.ovwh-dark .container-fluid,
.ovwh-dark .container-sm,
.ovwh-dark .container-md,
.ovwh-dark .container-lg,
.ovwh-dark .container-xl,
.ovpr-light .container,
.ovpr-light .container-fluid,
.ovpr-light .container-sm,
.ovpr-light .container-md,
.ovpr-light .container-lg,
.ovpr-light .container-xl,
.ovpr-middle .container,
.ovpr-middle .container-fluid,
.ovpr-middle .container-sm,
.ovpr-middle .container-md,
.ovpr-middle .container-lg,
.ovpr-middle .container-xl,
.ovpr-dark .container,
.ovpr-dark .container-fluid,
.ovpr-dark .container-sm,
.ovpr-dark .container-md,
.ovpr-dark .container-lg,
.ovpr-dark .container-xl,
.ovpr .container,
.ovpr .container-fluid,
.ovpr .container-sm,
.ovpr .container-md,
.ovpr .container-lg,
.ovpr .container-xl {
    position: relative;
    z-index: 1
}

.ovbl-light:before,
.ovbl-middle:before,
.ovbl-dark:before {
    background: var(--bs-dark)
}

.ovgd-light:before,
.ovgd-middle:before,
.ovgd-dark:before {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%)
}

.ovwh-light:before,
.ovwh-middle:before,
.ovwh-dark:before {
    background: #fff
}

.ovpr-light:before,
.ovpr-middle:before,
.ovpr-dark:before,
.ovpr:before {
    background: #008bb1;
}

.ovpr-light:before,
.ovwh-light:before,
.ovgd-light:before,
.ovbl-light:before {
    opacity: .3
}

.ovpr-middle:before,
.ovwh-middle:before,
.ovgd-middle:before,
.ovbl-middle:before {
    opacity: .5
}

.ovpr-dark:before,
.ovwh-dark:before,
.ovgd-dark:before,
.ovbl-dark:before {
    opacity: .9
}

.overlay-bx {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 10;
    opacity: 0;
    visibility: hidden;
    transition: all .8s
}

.overlay-bx .align-b {
    height: auto;
    left: 0;
    list-style: outside none none;
    margin: 0;
    position: absolute;
    top: auto;
    bottom: 0;
    width: 100%;
    transform: translate(0);
    -o-transform: translate(0);
    -moz-transform: translate(0);
    -webkit-transform: translate(0)
}

.overlay-bx .align-m {
    height: auto;
    left: 50%;
    list-style: outside none none;
    margin: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    width: 100%;
    padding: 0 10px
}

.overlay-icon {
    height: auto;
    left: 50%;
    list-style: outside none none;
    margin: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    width: 100%;
    padding: 0 10px
}

.overlay-icon a {
    display: inline-block;
    padding: 0;
    margin: 0 2px
}

.overlay-icon a i {
    background-color: #fff
}

.thumb-wraper {
    display: inline-block;
    position: relative
}

@media only screen and (max-width: 575px) {
    .thumb-wraper {
        padding: 15px
    }
}

.thumb-wraper .bg-img {
    position: relative;
    z-index: -2
}

.thumb-wraper ul li {
    position: absolute
}

.thumb-wraper ul li a {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    overflow: hidden;
    display: block;
    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);
    transition: all .5s;
    position: relative
}

.thumb-wraper ul li a img {
    width: 100%;
    height: 100%;
    object-fit: cover
}

.thumb-wraper ul li:after {
    content: "";
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    position: absolute;
    background-color: #565acf;
    transition: all .5s;
    z-index: -1;
    transform: scale(0);
    border-radius: 50%
}

.thumb-wraper ul li.active:after {
    transform: scale(1.14)
}

.thumb-wraper ul li:nth-child(1) {
    top: 100px;
    left: 20px
}

.thumb-wraper ul li:nth-child(2) {
    top: 0px;
    left: 50%;
    transform: translateX(-50%)
}

.thumb-wraper ul li:nth-child(3) {
    top: 100px;
    right: 20px
}

.thumb-wraper ul li:nth-child(4) {
    right: 30px;
    bottom: 110px
}

.thumb-wraper ul li:nth-child(5) {
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%)
}

.thumb-wraper ul li:nth-child(6) {
    left: 30px;
    bottom: 110px
}

@media only screen and (max-width: 575px) {
    .thumb-wraper ul li:nth-child(2) {
        top: 10px
    }

    .thumb-wraper ul li:nth-child(5) {
        bottom: 32px
    }

    .thumb-wraper ul li a {
        width: 50px;
        height: 50px
    }
}

.testimonial-bx {
    height: 303px;
    min-height: 302px;
    position: relative;
    border-radius: 40px 0 40px 40px;
    box-shadow: 0px 0px 30px rgba(185, 67, 0, .1);
    background-color: var(--bs-dark);
    padding: 50px;
    margin: 50px 20px 20px
}

.testimonial-bx:after {
    content: "";
    position: absolute;
    right: 40px;
    bottom: 20px;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    font-size: 92px;
    color: #fff;
    opacity: .3;
    line-height: 92px
}

.testimonial-bx .testimonial-content p {
    line-height: 28px;
    font-size: 18px;
    color: #fff;
    font-weight: 400;
    font-style: italic;
    margin-bottom: 30px
}

.testimonial-bx .client-info .name {
    font-weight: 600;
    color: #fff;
    margin-bottom: 8px;
    font-size: 22px
}

.testimonial-bx .client-info p {
    font-weight: 600;
    color: #fff;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 0
}

.testimonial-bx .quote-icon {
    position: absolute;
    top: -50px;
    left: 50px
}

.testimonial-bx .quote-icon i {
    font-size: 36px;
    color: #008BB1;
    width: 75px;
    height: 75px;
    text-align: center;
    background-color: #fff;
    line-height: 75px;
    border-radius: 20px;
    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1)
}

@media only screen and (max-width: 1199px) {
    .testimonial-bx {
        border-radius: 30px 0 30px 30px;
        padding: 50px 30px 30px
    }

    .testimonial-bx .testimonial-content p {
        line-height: 26px;
        font-size: 16px
    }

    .testimonial-bx .quote-icon {
        top: -45px;
        left: 30px
    }
}

@media only screen and (max-width: 575px) {
    .testimonial-bx {
        margin: 50px 0px 0px
    }

    .testimonial-bx:after {
        font-size: 50px;
        line-height: 72px
    }

    .testimonial-bx .quote-icon {
        top: -35px
    }

    .testimonial-bx .quote-icon i {
        font-size: 28px;
        width: 65px;
        height: 65px;
        line-height: 65px
    }
}

.testimonial-slide {
    padding-bottom: 75px
}

.testimonial-slide .slick-arrow {
    height: 50px;
    width: 50px;
    border-radius: 12px;
    background-color: #60eaff;
    color: #008BB1;
    font-size: 24px;
    bottom: 0;
    top: auto;
    transition: all .5s;
    font-size: 0
}

.testimonial-slide .slick-arrow:before {
    content: "";
    font-family: "Line Awesome Free";
    font-weight: 900;
    color: var(--primary);
    font-size: 24px
}

.testimonial-slide .slick-arrow:hover {
    background-color: #008BB1;
    color: #60eaff
}

.testimonial-slide .slick-prev {
    left: 20px
}

.testimonial-slide .slick-prev:before {
    content: ""
}

.testimonial-slide .slick-next {
    right: auto;
    left: 85px
}

.testimonial-slide .slick-next:before {
    content: ""
}

.testimonial-slide .swiper-pagination {
    right: 30px;
    display: inline-block;
    text-align: right;
    left: auto;
    width: auto;
    bottom: 0;
    color: #f17732;
    font-weight: 700
}

.testimonial-slide .swiper-pagination .swiper-pagination-current {
    font-size: 25px
}

.testimonial-slide .swiper-pagination .swiper-pagination-total {
    font-size: 15px;
    opacity: .5
}

@media only screen and (max-width: 575px) {
    .testimonial-slide {
        padding-bottom: 100px
    }

    .testimonial-slide .slick-prev {
        left: 0
    }

    .testimonial-slide .slick-next {
        left: 60px
    }

    .testimonial-slide .swiper-pagination {
        right: 10px
    }
}

.section-area .pt-img1 {
    bottom: 94px;
    left: 180px
}

@media only screen and (max-width: 768px) {
    .section-area .pt-img1 {
        top: 94%;
        left: 30px;
        width: 70px;
        height: 70px;
    }
}

@media only screen and (max-width: 991px) {
    .section-area .pt-img1 {
        top: 94%;
        left: 30px;
        width: 70px;
        height: 70px;
    }
}

@media only screen and (max-width: 1024px) {
    .section-area .pt-img1 {
        top: 93%;
        left: 30px;
        width: 70px;
        height: 70px;
    }
}


.section-area .pt-img2 {
    bottom: 110px;
    left: 150px
}

@media only screen and (max-width: 1380px) {
    .section-area .pt-img2 {
        bottom: 30px;
        left: 30px
    }
}

@media only screen and (max-width: 768px) {
    .section-area .pt-img2 {
        top: 30px;
        left: 140px
    }
}

.section-area .pt-img3 {
    bottom: 7%;
    right: 400px;
    z-index: 99;
}

@media only screen and (max-width: 1024px) {
    .section-area .pt-img3 {
        top: 92%;
        right: 40px;
        z-index: 99;

    }
}

@media only screen and (max-width: 768px) {
    .section-area .pt-img3 {
        top: 1370px;
        right: 10%;
        z-index: 99;
    }
}

.section-area .pt-img4 {
    top: 5%;
    right: 160px
}

@media only screen and (max-width: 1380px) {
    .section-area .pt-img4 {
        top: 6%;
        right: 10%
    }
}

@media only screen and (max-width: 991px) {
    .section-area .pt-img3 {
        top: 94%;
        right: 10%;
        z-index: 99;
    }
}

@media only screen and (max-width: 768px) {
    .section-area .pt-img4 {
        top: 22%;
        right: 10%
    }
}

.action-wraper .action-inner {
    background-color: #565acf;
    box-shadow: 0 5px 20px rgba(86, 90, 207, .2);
    border-radius: 20px;
    padding: 45px
}

.action-wraper .action-inner .title {
    font-size: 40px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 15px
}

.action-wraper .action-inner .text {
    margin: 0;
    font-weight: 400;
    color: #fff
}

.filter-mobile {
    display: flex;
    margin-bottom: 30px;
    display: none;
    border: 1px solid rgba(0, 0, 0, .1);
    align-items: center;
    text-align: center;
    position: sticky;
    top: 80px;
    background: #fff;
    box-shadow: 0px 0px 10px 0 rgba(0, 0, 0, .2)
}

.filter-mobile .filter-bx:first-child {
    border-right: 1px solid rgba(0, 0, 0, .1)
}

.filter-mobile .filter-bx {
    width: 50%;
    padding: 10px
}

.filter-btn i {
    margin-right: 5px
}

.filter-btn .close {
    display: none;
    opacity: 0
}

.filter-btn .close:hover {
    background: rgba(255, 255, 255, .1)
}

.filter-bx .bootstrap-select .dropdown-toggle {
    max-width: 100px;
    border: 2px solid rgba(0, 0, 0, .1) !important;
    border-radius: 4px;
    padding: 2px 10px;
    color: #404040;
    font-weight: 600;
    height: 32px
}

.filter-bx .bootstrap-select .dropdown-toggle .caret {
    top: 9px
}

.filter-on .filter-btn.close {
    border: 0;
    z-index: 1;
    position: fixed;
    right: 10px;
    top: 10px;
    color: #565acf;
    opacity: 1;
    font-size: 18px;
    display: block;
    transition: all .5s;
    -moz-transition: all .5s;
    -moz-transition: all .5s;
    -ms-transition: all .5s;
    -o-transition: all .5s;
    opacity: 1
}

.filter-left {
    padding: 20px 20px;
    width: 280px;
    position: fixed !important;
    left: -310px;
    top: 0;
    background: #fff;
    z-index: 9999999;
    box-shadow: 0 0 30px 0 rgba(0, 0, 0, .1);
    overflow-y: scroll;
    height: 100%;
    transition: all .5s;
    -moz-transition: all .5s;
    -moz-transition: all .5s;
    -ms-transition: all .5s;
    -o-transition: all .5s
}

.filter-left .filter-bar {
    top: 80px;
    position: sticky;
    z-index: 999
}

.filter-bar.sticky-top .side-bar {
    z-index: 9;
    top: 0;
    position: unset
}

.sticky-top.filter-bar {
    z-index: 99999999;
    top: 80px;
    position: sticky
}

.filter-left:after {
    content: "";
    position: fixed;
    width: 0;
    background: #fff;
    height: 100%;
    z-index: -1;
    left: 0;
    top: 0;
    opacity: 0;
    transition: all .5s;
    -moz-transition: all .5s;
    -moz-transition: all .5s;
    -ms-transition: all .5s;
    -o-transition: all .5s
}

.filter-left.filter-on:after {
    width: 100%;
    left: 280px;
    opacity: .8
}

.filter-left.filter-on {
    left: 0
}

.filter-bar {
    top: 80px;
    position: sticky;
    z-index: 999
}

.filter-bar.sticky-top .side-bar {
    z-index: 9;
    top: 0;
    position: unset
}

.contectus-flex {
    display: flex;
    flex-direction: row;
}

.sticky-top.filter-bar {
    z-index: 99999999;
    top: 80px;
    position: sticky
}

.pagination-bx .pagination {
    margin: 0;
    width: 100%
}

.pagination {
    padding: 10px 0;
    display: block
}

.pagination li {
    display: inline-block;
    padding: 0 4px
}

.pagination li:first-child,
.pagination li:last-child {
    min-width: 103px;
}

.pagination>li:first-child>a,
.pagination>li:first-child>span {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    margin-left: 0;
}

.pagination>li:last-child>a,
.pagination>li:last-child>span {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0
}

.pagination>li>a,
.pagination>li>span {
    background-color: #fff;
    color: #008BB1;
    padding: 12px 15px;
    font-weight: 600;
    font-size: 14px;
    min-width: 40px;
    line-height: 1;
    display: block;
    border-radius: 8px !important;
    border: 2px solid rgba(86, 90, 207, .2);
    transition: all .5s
}

.pagination>li>a:hover,
.pagination>li>span:hover {
    border-color: #008bb1;
    color: #fff
}

@media only screen and (max-width: 575px) {

    .pagination>li>a,
    .pagination>li>span {
        padding: 10px 15px
    }
}

.pagination>.active>a,
.pagination>.active>span,
.pagination>.active>a:hover,
.pagination>.active>span:hover,
.pagination>.active>a:focus,
.pagination>.active>span:focus {
    border-color: rgba(0, 0, 0, 0)
}

@media only screen and (max-width: 575px) {
    .pagination li {
        margin: 0
    }
}

.pagination-sm .pagination>li>a,
.pagination-sm .pagination>li>span .pagination-sm .pagination>.previous>a,
.pagination-sm .pagination>.next>a {
    font-size: 12px;
    padding: 6px 12px
}

.pagination-lg .pagination>li>a,
.pagination-lg .pagination>li>span .pagination-lg .pagination>.previous>a,
.pagination-lg .pagination>.next>a {
    font-size: 18px;
    padding: 10px 20px
}

.pagination-bx.primary .pagination>li>a,
.pagination-bx.primary .pagination>li>span {
    background-color: #1abc9c;
    color: #fff;
    margin: 0 1px;
    border: 0
}

.pagination-bx.primary .pagination>li>a:hover,
.pagination-bx.primary .pagination>li>span:hover,
.pagination-bx.primary .pagination>li.active>span,
.pagination-bx.primary .pagination>li.active>a {
    background-color: #148f77
}

.pagination-bx.rounded .pagination>li>a,
.pagination-bx.rounded .pagination>li>span {
    border-radius: 30px;
    margin: 0 1px
}

.pagination-bx.rounded-sm .pagination>li>a,
.pagination-bx.rounded-sm .pagination>li>span {
    border-radius: 4px;
    margin: 0 1px;
    display: block;
    text-transform: uppercase;
    letter-spacing: 2px
}

.pagination-bx.gray .pagination>li>a,
.pagination-bx.gray .pagination>li>span {
    background-color: #f6f7f8;
    margin: 0 1px;
    border: 0
}

.pagination-bx.gray .pagination>li>a:hover,
.pagination-bx.gray .pagination>li>span:hover,
.pagination-bx.gray .pagination>li.active>span,
.pagination-bx.gray .pagination>li.active>a {
    background-color: #565acf;
    color: #fff
}

.pagination i {
    font-size: 12px
}

.pagination li.active a {
    background-color: #008BB1;
    color: #fff
}

.pagination>li.active>a:hover,
.pagination>li>a:hover,
.pagination>li>span:hover {
    color: #fff;
    background-color: #565acf
}

.main-banner {
    position: relative;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    overflow: hidden;
    z-index: 1;
    height: 1085px
}

.main-banner:after {
    content: "";
    height: 100%;
    width: 100%;
    left: 0;
    bottom: 0;
    position: absolute;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
    background-repeat: no-repeat;
    background-position: bottom left;
    background-size: 100%;
    z-index: -1
}

.main-banner h1,
.main-banner .h1 {
    margin-bottom: 50px;
    font-weight: 800;
    line-height: 1.3;
    color: var(--bs-dark);
    font-size: 55px
}

.main-banner .btn-lg,
.main-banner .btn-group-lg>.btn {
    padding: 20px 45px
}

.main-banner .title-ext {
    margin: 0 0 20px;
    font-size: 21px;
    font-weight: 700;
    display: inline-block;
    padding: 5px 15px;
    background-position: center;
    background-repeat: repeat
}

.main-banner .title-ext.text-primary {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___})
}

.main-banner .title-ext.text-secondary {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___})
}

.main-banner .tag-list li {
    display: inline-block;
    margin-right: 8px;
    position: relative;
    padding-right: 5px;
    font-size: 14px;
    color: var(--bs-dark);
    font-weight: 600
}

.main-banner .tag-list li:after {
    content: ",";
    position: absolute;
    bottom: 0;
    right: 0;
    color: #777
}

.main-banner .tag-list li.title {
    font-weight: 600
}

.main-banner .tag-list li.title:after {
    content: none
}

.main-banner .tag-list li a {
    text-transform: capitalize;
    font-weight: 400;
    color: #666
}

.main-banner .tag-list li a:hover {
    color: #565acf
}

.main-banner .banner-img {
    animation: up-down 2.5s infinite alternate;
    position: relative;
    margin-right: -160px;
    margin-left: -50px
}

.main-banner .inner-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%)
}

@media only screen and (max-width: 1680px) {
    .main-banner {
        height: 800px
    }

    .main-banner .banner-img {
        margin-right: 0;
        margin-left: 0px
    }

    .main-banner h1,
    .main-banner .h1 {
        margin-bottom: 30px;
        font-size: 45px
    }

    .main-banner .title-ext {
        margin: 0 0 10px;
        font-size: 18px
    }
}

@media only screen and (max-width: 1199px) {
    .main-banner {
        height: 700px
    }

    .main-banner h1,
    .main-banner .h1 {
        margin-bottom: 30px;
        font-size: 36px
    }

    .main-banner .title-ext {
        font-size: 16px;
        margin: 0 0 15px
    }
}

@media only screen and (max-width: 991px) {
    .main-banner {
        height: 500px
    }

    .main-banner h1,
    .main-banner .h1 {
        font-size: 28px;
        margin-bottom: 20px
    }

    .main-banner .title-ext {
        font-size: 14px;
        margin: 0 0 10px;
        padding: 3px 10px
    }

    .main-banner .btn-lg,
    .main-banner .btn-group-lg>.btn {
        padding: 12px 24px;
        font-size: 14px
    }
}

@media only screen and (max-width: 767px) {
    .main-banner .banner-img {
        margin-right: -40px;
        margin-left: -20px
    }

    .main-banner h1,
    .main-banner .h1 {
        font-size: 24px;
        margin-bottom: 20px
    }

    .main-banner .main-banner {
        height: 500px
    }
}

@media only screen and (max-width: 575px) {
    .main-banner {
        height: auto;
        padding-top: 100px
    }

    .main-banner .banner-img {
        margin: 30px 10px
    }

    .main-banner .inner-content {
        position: unset;
        transform: unset
    }
}

.main-banner .pt-img1 {
    bottom: 35%;
    left: 5%
}

@media only screen and (max-width: 1380px) {
    .main-banner .pt-img1 {
        left: 0%;
        bottom: 25%
    }
}

.main-banner .pt-img2 {
    top: 24%;
    left: 51%
}

@media only screen and (max-width: 991px) {
    .main-banner .pt-img2 {
        top: 30%;
        left: 55%
    }
}

.main-banner .pt-img3 {
    top: 23%;
    left: 17%
}

.main-banner .pt-img4 {
    bottom: 15%;
    left: 41%;
    z-index: 1
}

@media only screen and (max-width: 991px) {
    .main-banner .pt-img4 {
        bottom: 10%;
        left: 45%
    }
}

.main-banner .pt-img5 {
    bottom: 150px;
    right: 150px
}

.work-area .pt-img1 {
    bottom: 15%;
    left: 5%
}

.work-area .pt-img2 {
    top: 50%;
    right: 5%
}

@media only screen and (max-width: 991px) {
    .work-area .pt-img2 {
        top: 250px;
        width: 100px;
        height: 100px;
        right: 10px
    }
}

.work-area .pt-img3 {
    bottom: 10%;
    right: 20%
}

@media only screen and (max-width: 991px) {
    .work-area .pt-img3 {
        bottom: 120px;
        right: 430px
    }
}

.work-area .work-bx {
    margin-top: 30px
}

@media only screen and (max-width: 991px) {
    .work-area .work-bx {
        margin-top: 0
    }
}

.work-area .work-bx.active {
    margin-top: 0
}

.slider {
    width: 550px;
}

@media only screen and (max-width: 576px) {
    .slider {
        width: 100%;
    }

}

.work-bx {
    position: relative;
    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);
    padding: 40px 30px;
    border-radius: 20px;
    background-color: #fff;
    transition: all .5s;
    overflow: hidden;
    z-index: 1
}

.work-bx:after {
    content: "";
    height: 0;
    width: 100%;
    background-color: #008BB1;
    position: absolute;
    top: 0;
    right: 0;
    z-index: -1;
    transition: all .5s;
    transform-origin: top;
    -moz-transform-origin: top;
    -ms-transform-origin: top;
    -webkit-transform-origin: top;
    -o-transform-origin: top
}

.work-bx .work-num-bx {
    transition: all .5s;
    z-index: 9;
    font-size: 80px;
    font-weight: 900;
    margin-bottom: 30px;
    line-height: 80px;
    -webkit-text-stroke: 2px #f17732;
    text-shadow: 0 10px 0 #ffe3d3;
    color: rgba(0, 0, 0, 0)
}

.work-bx .work-content {
    transition: all .5s;
    transition: all .5s
}

.work-bx .work-content p {
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    margin-bottom: 30px
}

.work-bx .btn {
    font-weight: 600
}

.work-bx.active:after,
.work-bx:hover:after {
    height: 100%;
    top: auto;
    bottom: 0;
    transform-origin: bottom;
    -moz-transform-origin: bottom;
    -ms-transform-origin: bottom;
    -webkit-transform-origin: bottom;
    -o-transform-origin: bottom;
    animation-duration: .5s
}

.work-bx.active .work-num-bx,
.work-bx:hover .work-num-bx {
    text-shadow: 0 10px 0 #f38f5e;
    -webkit-text-stroke: 2px #fff
}

.work-bx.active .work-content p,
.work-bx.active .work-content .title,
.work-bx:hover .work-content p,
.work-bx:hover .work-content .title {
    color: #fff !important
}

.work-bx.active .btn,
.work-bx:hover .btn {
    background-color: #fff;
    border-color: #fff;
    color: #f17732
}

.work-bx.active .btn .btn-icon-bx,
.work-bx:hover .btn .btn-icon-bx {
    /* background-color: #f17732; */
    color: #fff
}

.about-area .pt-img1 {
    bottom: 20%;
    left: 16%
}

@media only screen and (max-width: 1380px) {
    .about-area .pt-img1 {
        left: 100px
    }
}

.about-area .pt-img2 {
    bottom: 5%;
    right: 25%
}

.about-area .pt-img3 {
    top: 30%;
    right: 7%
}

.about-area .pt-img4 {
    bottom: 10%;
    right: 1%
}

.about-area .pt-img5 {
    top: 25%;
    left: 5%
}

@media only screen and (max-width: 1380px) {
    .about-area .pt-img5 {
        left: 35px
    }
}

.about-thumb-area {
    margin-right: 30px;
    position: relative
}

.about-thumb-area ul {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -20px
}

.about-thumb-area ul li {
    display: inline-flex;
    padding: 0 10px;
    margin-bottom: 20px
}

.about-thumb-area ul li:nth-child(1),
.about-thumb-area ul li:nth-child(3) {
    width: 45%
}

.about-thumb-area ul li:nth-child(2),
.about-thumb-area ul li:nth-child(4) {
    width: 55%
}

.about-thumb-area .about-thumb1 {
    border-radius: 0 60px 60px;
    margin-top: auto;
    margin-left: auto
}

.about-thumb-area .about-thumb2 {
    border-radius: 60px 0 60px 60px;
    margin-top: auto;
    margin-right: auto
}

.about-thumb-area .about-thumb3 {
    border-radius: 60px 60px 60px 0;
    margin-bottom: auto;
    margin-left: auto
}

.about-thumb-area .about-thumb4 {
    border-radius: 60px 60px 0px 60px;
    margin-bottom: auto;
    margin-left: auto
}

.about-thumb-area .exp-bx {
    background-color: #e6e7ff;
    border-radius: 60px 60px 0px 60px;
    padding: 60px 0px 30px;
    text-align: center;
    line-height: 75px;
    font-size: 120px;
    font-weight: 800;
    position: relative;
    display: block;
    color: #008BB1;
    z-index: 2;
    width: 220px
}

.about-thumb-area .exp-bx span {
    display: block;
    font-size: 18px;
    color: var(--bs-dark)
}

.about-thumb-area .exp-bx:after {
    content: "";
    position: absolute;
    top: 10px;
    left: 10px;
    width: 100%;
    height: 100%;
    border: 2px solid #565acf;
    border-radius: 60px 60px 0px 60px;
    z-index: -1
}

.about-thumb-area:after {
    content: "";
    position: absolute;
    top: 49%;
    left: 40%;
    width: 50px;
    height: 50px;
    background-color: #008BB1;
    border-radius: 15px;
    transform: rotate(45deg)
}

@media only screen and (max-width: 1199px) {
    .about-thumb-area {
        margin-right: 0
    }
}

@media only screen and (max-width: 991px) {
    .about-thumb-area:after {
        top: 51%;
        left: 41%
    }
}

@media only screen and (max-width: 767px) {
    .about-thumb-area:after {
        top: 48%;
        left: 40%
    }
}

@media only screen and (max-width: 575px) {
    .about-thumb-area {
        margin: 0 15px
    }

    .about-thumb-area ul {
        margin: 0 -10px
    }

    .about-thumb-area ul li {
        padding: 0 5px;
        margin-bottom: 10px
    }

    .about-thumb-area .about-thumb2 {
        border-radius: 30px 0 30px 30px
    }

    .about-thumb-area .about-thumb3 {
        border-radius: 30px 30px 30px 0
    }

    .about-thumb-area .about-thumb1 {
        border-radius: 0 30px 30px
    }

    .about-thumb-area .exp-bx {
        padding: 50px 0px 20px;
        border-radius: 30px 30px 0px 30px;
        line-height: 55px;
        font-size: 70px;
        width: 85%
    }

    .about-thumb-area .exp-bx:after {
        border-radius: 30px 30px 0px 30px;
        top: 8px;
        left: 8px
    }

    .about-thumb-area .exp-bx span {
        font-size: 12px
    }

    .about-thumb-area:after {
        top: 43%;
        left: 41%;
        width: 25px;
        height: 25px;
        border-radius: 5px
    }
}

.account-wraper1 {
    padding-bottom: 100px;

}

.account-wraper1 .appointment-inner {
    background-color: #f5f5fc;
    border-radius: 40px;
    position: relative;
    z-index: 1
}

@media only screen and (max-width: 767px) {
    .account-wraper1 {
        background-color: #f5f5fc
    }
}

.account-wraper1 .pt-img1 {
    top: 100px;
    left: 70px
}

@media only screen and (max-width: 991px) {
    .account-wraper1 .pt-img1 {
        top: 190px;
        left: 10px
    }
}

@media only screen and (max-width: 1199px) {
    .account-wraper1 .pt-img1 {
        top: 50px;
        left: 50px
    }
}

.account-wraper1 .pt-img2 {
    left: -90px;
    bottom: 150px
}

@media only screen and (max-width: 991px) {
    .account-wraper1 .pt-img2 {
        left: -60px;
        bottom: 50px
    }
}

@media only screen and (max-width: 1199px) {
    .account-wraper1 .pt-img2 {
        left: -60px;
        bottom: -40px
    }
}

.account-wraper1 .pt-img3 {
    right: -70px;
    top: 50px
}

@media only screen and (max-width: 1680px) {
    .account-wraper1 .pt-img3 {
        right: 20px;
        top: -30px
    }
}

.account-wraper1 .pt-img4 {
    right: -40px;
    bottom: 150px
}

@media only screen and (max-width: 1680px) {
    .account-wraper1 .pt-img4 {
        right: 30px;
        bottom: -30px
    }
}

@media only screen and (max-width: 1199px) {
    .account-wraper1 {
        padding-bottom: 70px
    }
}

@media only screen and (max-width: 991px) {
    .account-wraper1 {
        padding-bottom: 50px
    }
}

@media only screen and (max-width: 767px) {
    .account-wraper1 {
        padding-bottom: 0
    }
}

@media only screen and (max-width: 575px) {

    .account-wraper1 .container-fluid,
    .account-wraper1 .container-sm,
    .account-wraper1 .container-md,
    .account-wraper1 .container-lg,
    .account-wraper1 .container-xl {
        padding-left: 0;
        padding-right: 0
    }
}

.flex-form-group {
    display: flex;
    flex-direction: row;
    gap: 20px;
}

.form-wraper .form-group {
    margin-bottom: 20px
}

.form-wraper .form-select.bootstrap-select {
    padding: 0;
    border: 0
}

.form-wraper .form-select.bootstrap-select .dropdown-toggle {
    border: 1px solid;
    border-color: rgba(86, 90, 207, .3);
    border-radius: 8px;
    height: 60px;
    font-weight: 500;
    font-size: 16px;
    color: #444;
    padding: 18px 25px;
    margin-top: 0
}

.form-wraper .form-select.bootstrap-select .dropdown-toggle:after {
    content: "";
    position: absolute;
    top: 50%;
    font-family: "Line Awesome Free";
    right: 20px;
    font-weight: 900;
    border: 0;
    transform: translateY(-50%);
    color: #9a9ccc
}

.form-wraper .form-select.bootstrap-select .dropdown-menu {
    box-shadow: 0 2px 20px rgba(0, 0, 0, .1)
}

.form-wraper .form-select.bootstrap-select .dropdown-menu .dropdown-item {
    padding: 10px 25px;
    font-size: 14px;
    font-weight: 600;
    color: var(--bs-dark);
    transition: all .5s
}

.form-wraper .form-select.bootstrap-select .dropdown-menu .dropdown-item:hover {
    background-color: #565acf;
    color: #fff
}

.form-wraper .form-select.bootstrap-select .dropdown-item.active.selected {
    color: #fff
}

.form-wraper .form-select.bootstrap-select .dropdown-item.active.selected:hover {
    background-color: #565acf
}

.form-wraper .form-control {
    border: 1px solid;
    border-color: rgba(86, 90, 207, .3);
    border-radius: 8px;
    height: 60px;
    font-weight: 500;
    font-size: 16px;
    color: #000
}

.form-wraper .form-control:active,
.form-wraper .form-control:focus,
.form-wraper .form-control:hover {
    border-color: #565acf
}

.form-wraper .form-control::placeholder {
    color: #444
}

.form-wraper textarea.form-control {
    height: 150px
}

@media only screen and (max-width: 991px) {
    .form-wraper .form-group {
        margin-bottom: 15px
    }
}

.appointment-form {
    background-color: #fff;
    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);
    border-radius: 40px;
    padding: 40px 35px;
    text-align: center;
    position: relative
}

.appointment-form .title {
    margin-bottom: 30px
}

.appointment-form button {
    margin-top: 15px
}

.appointment-form:after {
    content: "";
    position: absolute;
    top: -20px;
    left: -20px;
    border-radius: 40px;
    width: 100%;
    height: 100%;
    border: 2px solid #008bb1;
    z-index: -1
}

@media only screen and (max-width: 1380px) {
    .appointment-form {
        margin-left: 50px
    }
}

@media only screen and (max-width: 991px) {
    .appointment-form {
        margin-left: 20px;
        padding: 30px;
        border-radius: 20px
    }

    .appointment-form:after {
        top: -15px;
        left: -15px;
        border-radius: 20px
    }

    .appointment-form .title {
        margin-bottom: 20px;
        font-size: 20px
    }

    .appointment-form .form-group {
        margin-bottom: 15px
    }

    .appointment-form button {
        margin-top: 5px
    }
}

@media only screen and (max-width: 575px) {
    .appointment-form {
        margin-left: 10px;
        border-radius: 20px;
        padding: 20px
    }

    .appointment-form .form-control {
        height: 50px;
        font-size: 14px;
        padding: 12px 18px
    }

    .appointment-form .form-select.bootstrap-select .dropdown-toggle {
        height: 50px;
        font-size: 14px;
        padding: 15px 18px
    }

    .appointment-form:after {
        top: -10px;
        left: -10px;
        border-radius: 20px
    }
}

.appointment-thumb {
    position: relative;
    width: 730px;
    margin-left: 70px
}

.appointment-thumb .images-group img {
    position: absolute
}

.appointment-thumb .images-group .img1 {
    right: 16px;
    bottom: 16px;
    height: 530px;
    animation: left-right 2s infinite alternate
}

@media only screen and (max-width: 1199px) {
    .appointment-thumb .images-group .img1 {
        right: 10px;
        bottom: 14px;
        height: 430px
    }
}

.appointment-thumb .images-group .img2 {
    left: 80px;
    bottom: 255px;
    width: 130px;
    animation: up-down 2.3s infinite alternate
}

@media only screen and (max-width: 1199px) {
    .appointment-thumb .images-group .img2 {
        left: 60px;
        bottom: 200px;
        width: 100px
    }
}

.appointment-thumb .images-group .img3 {
    right: 260px;
    bottom: 120px;
    width: 94px;
    animation: up-down 2.5s infinite alternate
}

@media only screen and (max-width: 1199px) {
    .appointment-thumb .images-group .img3 {
        right: 166px;
        bottom: 90px;
        width: 85px
    }
}

.appointment-thumb .images-group .img4 {
    left: 20px;
    top: 150px;
    animation: up-down 1.5s infinite alternate
}

@media only screen and (max-width: 1199px) {
    .appointment-thumb .images-group .img4 {
        left: 10px;
        top: 80px
    }
}

.appointment-thumb .images-group .img5 {
    right: 70px;
    top: 30px;
    animation: up-down 2s infinite alternate
}

@media only screen and (max-width: 1380px) {
    .appointment-thumb .images-group .img1 {
        height: 400px;
        right: 20px
    }

    .appointment-thumb .images-group .img2 {
        left: 93px;
        width: 80px;
        bottom: 240px
    }

    .appointment-thumb .images-group .img3 {
        right: 225px;
        width: 70px
    }

    .appointment-thumb .images-group .img4 {
        left: 40px;
        width: 50px
    }

    .appointment-thumb .images-group .img5 {
        right: 80px;
        width: 80px
    }
}

@media only screen and (max-width: 1199px) {
    .appointment-thumb .images-group .img1 {
        height: 280px
    }

    .appointment-thumb .images-group .img2 {
        left: 62px;
        width: 60px;
        bottom: 170px
    }

    .appointment-thumb .images-group .img3 {
        right: 154px;
        width: 50px
    }

    .appointment-thumb .images-group .img4 {
        left: 20px;
        width: 40px
    }

    .appointment-thumb .images-group .img5 {
        right: 70px;
        width: 70px;
        top: 60px
    }
}

@media only screen and (max-width: 991px) {
    .appointment-thumb .images-group .img1 {
        height: 180px
    }

    .appointment-thumb .images-group .img2 {
        left: 39px;
        width: 50px;
        bottom: 110px
    }

    .appointment-thumb .images-group .img3 {
        right: 110px;
        width: 40px
    }

    .appointment-thumb .images-group .img4 {
        left: 15px;
        width: 30px
    }

    .appointment-thumb .images-group .img5 {
        right: 30px;
        width: 60px;
        top: 40px
    }
}

@media only screen and (max-width: 1380px) {
    .appointment-thumb {
        width: 650px;
        margin-left: 0
    }
}

@media only screen and (max-width: 1199px) {
    .appointment-thumb {
        width: 100%;
        padding-left: 0
    }
}

@media only screen and (max-width: 767px) {
    .appointment-thumb {
        width: 320px;
        margin: 30px auto 0
    }
}

.account-wraper2 {
    height: 100vh;
    display: flex;
    align-items: center;
    background-color: #f5f5fc
}

.account-wraper2 .appointment-form {
    padding: 50px 40px
}

.account-wraper2 .appointment-form button {
    margin-top: 0
}

.account-wraper2 .logo {
    margin-bottom: 30px
}

@media only screen and (max-width: 767px) {
    .account-wraper2 .appointment-form {
        padding: 30px
    }
}

.blog-card {
    border: 2px solid #008BB1;
    background-color: #fff;
    border-radius: 10px;
    transition: all .5s;
    padding: 20px;
    cursor: pointer;
}

.blog-card .post-media {
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 20px;
    min-height: 237px;
    height: 237px;
    border: 1px solid #f6f6f6;
}

.blog-detail-card .post-media {
    min-height: 480px !important;
    height: 480px !important;
}



.blog-card .post-media img {
    width: 100%;
}

.blog-card .post-title {
    margin-bottom: 25px;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;

}



.blog-card .post-info {
    padding: 12px
}

@media only screen and (max-width: 991px) {
    .blog-card {
        padding: 15px
    }

    .blog-card .post-info {
        padding: 5px 5px 10px
    }
}

@media only screen and (max-width: 575px) {
    .blog-card {
        padding: 10px
    }

    .blog-card .post-title {
        margin-bottom: 20px
    }
}

.blog-card:hover {
    box-shadow: 0px 10px 30px 0px rgba(31, 34, 120, .1);
    border: 2px solid #565acf;
}

.post-meta {
    align-items: center;
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap
}

.post-meta li {
    display: inline-block;
    position: relative;
    font-size: 14px;
    margin-right: 19px;
    color: var(--bs-dark);
    line-height: 1
}

.post-meta li:last-child {
    margin-right: 0
}

.post-meta li.author a {
    display: flex;
    align-items: center
}

.post-meta li img {
    border-radius: 30px;
    height: 30px;
    width: 30px;
    display: inline-block;
    margin-right: 10px
}

.post-meta li i {
    font-size: 18px;
    margin-right: 5px
}

.post-meta li a {
    color: var(--bs-dark)
}

.blog-slide {
    margin-top: -15px
}

.blog-slide .blog-card {
    margin: 15px
}

@media only screen and (min-width: 1199px) {
    .blog-slide .slick-active.slick-current+.slick-active .blog-card {
        box-shadow: 0px 10px 30px 0px rgba(31, 34, 120, .1);
        border: 2px solid #008bb1;
    }
}

.blog-slide .swiper-slide {
    margin-bottom: 10px
}

@media only screen and (max-width: 575px) {
    .blog-slide .blog-card {
        margin: 5px
    }
}

.blog-area .pt-img1 {
    top: 200px;
    left: 100px
}

@media only screen and (max-width: 991px) {
    .blog-area .pt-img1 {
        top: 170px;
        left: 30px
    }
}

.blog-area .pt-img2 {
    bottom: 50px;
    left: 150px
}

@media only screen and (max-width: 991px) {
    .blog-area .pt-img2 {
        bottom: -50px;
        left: 90px
    }
}

.blog-area .pt-img3 {
    top: 120px;
    right: 200px
}

@media only screen and (max-width: 991px) {
    .blog-area .pt-img3 {
        top: 100px;
        right: 20px
    }
}

.blog-area .pt-img4 {
    bottom: 40px;
    right: 100px
}

@media only screen and (max-width: 991px) {
    .blog-area .pt-img4 {
        bottom: 30px;
        right: 50px
    }
}

.blog-area .blog-bg-5 {
    position: absolute;
    top: 60px;
    left: 0;
    z-index: -1;
    opacity: .2;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat
}

.blog-area .blog-bg-5 svg {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat
}

[class*=pt-img] {
    position: absolute;
    -webkit-user-select: none;
            user-select: none;
    z-index: -1
}

@media only screen and (max-width: 767px) {
    [class*=pt-img] {
        display: none
    }
}

.animate1 {
    animation: up-down 1.5s infinite alternate
}

@media only screen and (max-width: 1380px) {
    .animate1 {
        width: 80px
    }
}

.animate2 {
    animation: up-down 2s infinite alternate
}

.animate-rotate {
    animation: rotation 20s infinite linear
}

.animate-wave {
    animation: left-right 1.5s infinite alternate
}

@media only screen and (max-width: 1380px) {
    .animate-wave {
        width: 100px
    }
}

@keyframes rotation {
    0% {
        transform: rotate(0deg)
    }

    100% {
        transform: rotate(360deg)
    }
}

@keyframes up-down {
    0% {
        transform: translatey(0)
    }

    100% {
        transform: translatey(-10px)
    }
}

@keyframes left-right {
    0% {
        transform: translateX(0)
    }

    100% {
        transform: translateX(-10px)
    }
}

@keyframes vibrate {

    10%,
    90% {
        transform: translate3d(-1px, 0, 0)
    }

    20%,
    80% {
        transform: translate3d(2px, 0, 0)
    }

    30%,
    50%,
    70% {
        transform: translate3d(-4px, 0, 0)
    }

    40%,
    60% {
        transform: translate3d(4px, 0, 0)
    }
}

@keyframes up-down2 {
    0% {
        transform: translate(-50px)
    }

    50% {
        transform: translateX(80px) translateY(-200px)
    }

    100% {
        transform: translate(-50px)
    }
}

.team-member {
    background-color: #fff;
    text-align: center;
    padding: 35px 40px 50px;
    border-radius: 20px;
    transition: all .5s;
    z-index: 1;
    position: relative;
    border: 2px solid;
    border-color: rgba(86, 90, 207, .2)
}

.team-member .team-info .team-info-comntent {
    margin-bottom: 25px
}

.team-member .team-info .team-info-comntent span {
    font-size: 16px;
    font-weight: 600
}

.team-member .team-media {
    padding: 20%;
    position: relative;
    margin-bottom: 20px
}

.team-member .team-media img {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
    mask-position: center center;
    mask-repeat: no-repeat;
    mask-size: 100%;
    padding-top: 40px;
}

.team-member .team-media:after,
.team-member .team-media:before {
    content: "";
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    transition: all .5s;
    opacity: .2;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%
}

.team-member .team-media:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
    background-size: 100%
}

.team-member .team-media:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
    background-size: 77%
}

.team-member .social-media {
    display: flex;
    justify-content: center;
    margin: 0 -6px
}

.team-member .social-media li {
    display: inline-block;
    padding: 0 6px
}

.team-member .social-media li a {
    display: block;
    height: 40px;
    width: 40px;
    background-color: #008BB1;
    border-radius: 8px;
    transition: all .5s;
    color: #fff;
    line-height: 42px;
    text-align: center;
    box-shadow: 0px 10px 40px 0px rgba(31, 34, 120, .1)
}

.team-member.active,
.team-member:hover {
    box-shadow: 0px 10px 50px 0px rgba(0, 2, 72, .1);
    z-index: 9;
    border-color: #fff
}

.team-member.active .team-media:before,
.team-member.active .team-media:after,
.team-member:hover .team-media:before,
.team-member:hover .team-media:after {
    opacity: 1
}

@media only screen and (max-width: 767px) {
    .team-member {
        padding: 20px 30px 30px
    }
}

.team-wraper .pt-img1 {
    top: 15%;
    left: 10%
}

.team-wraper .pt-img2 {
    bottom: 30%;
    left: 5%
}

@media only screen and (max-width: 1380px) {
    .team-wraper .pt-img2 {
        left: 1%
    }
}

.team-wraper .pt-img3 {
    bottom: -50px;
    left: 58%
}

.team-wraper .pt-img4 {
    top: 10%;
    right: 25%
}

.team-wraper .pt-img5 {
    top: 50%;
    right: 5%
}

@media only screen and (max-width: 1380px) {
    .team-wraper .pt-img5 {
        right: 1%
    }
}

.service-menu {
    position: relative;
    background-color: #fff;
    border-radius: 6px 6px 4px 4px !important;
    padding: 30px 30px;
    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);
    border: 1px solid rgba(86, 90, 207, .2);
    border-width: 1px 1px 3px 1px;
    border-bottom-color: #565acf
}

.service-menu li {
    margin-bottom: 10px
}

.service-menu li a {
    display: block;
    padding: 15px 50px 15px 20px;
    text-transform: capitalize;
    font-weight: 600;
    position: relative;
    z-index: 1;
    transition: all .5s;
    color: #fff;
    font-weight: 500;
    font-size: 16px;
    border-radius: 8px;
    background-color: #565acf
}

.service-menu li a i {
    font-size: 18px;
    text-align: center;
    border-radius: 35px;
    position: absolute;
    right: 8px;
    top: 8px;
    width: 38px;
    height: 38px;
    line-height: 38px;
    background: #fff;
    border-radius: inherit;
    display: inline-block;
    color: #565acf
}

.service-menu li:last-child {
    margin-bottom: 0
}

.service-menu li.active a,
.service-menu li:hover a {
    background-color: #f17732
}

.service-menu li.active a i,
.service-menu li:hover a i {
    color: #f17732
}

.service-menu.style-1 li a i {
    font-size: 24px
}

@media only screen and (max-width: 1199px) {
    .service-menu {
        padding: 15px
    }
}

.left-border-1 {
    padding-left: 30px;
    border-left: 1px solid rgba(0, 0, 0, .1)
}

.contact-infolist {
    margin: 0 0 40px;
    padding: 25px 0 5px;
    list-style: none;
    border-top: 1px solid rgba(0, 0, 0, .1);
    border-bottom: 1px solid rgba(0, 0, 0, .1)
}

.contact-infolist li {
    position: relative;
    padding: 0 20px 20px 80px
}

.contact-infolist li img {
    position: absolute;
    left: 0;
    top: 10px;
    width: 60px
}

.contact-infolist li .contact-title {
    color: #020d26;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    margin-bottom: 2px
}

.contact-infolist li a,
.contact-infolist li p {
    font-size: 16px;
    line-height: 24px;
    color: #555;
    font-weight: 400;
    margin-bottom: 5px
}

button.back-to-top {
    border-style: solid;
    border-width: 0;
    bottom: 15px;
    box-shadow: 0px 10px 30px 0px rgba(31, 34, 120, .1);
    color: #fff;
    background-color: #008BB1;
    border-radius: 8px;
    cursor: pointer;
    height: 45px;
    margin: 0;
    position: fixed;
    right: 15px;
    text-align: center;
    width: 45px;
    z-index: 999;
    padding: 0;
    font-size: 12px
}

@media only screen and (max-width: 575px) {
    button.back-to-top {
        height: 35px;
        width: 35px
    }
}

.mfp-bg {
    z-index: 999999
}

.mfp-wrap {
    z-index: 9999999
}

.card-img-servic img {
    border-radius: 5px;
}

.service-wraper {
    position: relative;
    z-index: 1;
    overflow: hidden;
    padding-left: calc((100% - 1200px)/2);
    margin-bottom: 50px;

}

.service-wraper:after {
    content: "";
    background-color: #008BB1;
    height: 100%;
    width: 45%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
    border-radius: 40px 0 0 40px
}

.service-wraper .pt-img1 {
    top: 60px;
    left: 80px;
    opacity: .2
}

@media only screen and (max-width: 991px) {
    .service-wraper .pt-img1 {
        top: 10px;
        left: 80px
    }
}

@media only screen and (max-width: 1199px) {
    .service-wraper .pt-img1 {
        top: 20px;
        left: 80px
    }
}

.service-wraper .pt-img2 {
    bottom: 150px;
    left: 140px
}

@media only screen and (max-width: 1380px) {
    .service-wraper .pt-img2 {
        bottom: 50px;
        left: 150px
    }
}

.service-wraper .pt-img3 {
    bottom: 60px;
    left: 50%
}

@media only screen and (max-width: 991px) {
    .service-wraper .pt-img3 {
        display: none
    }
}

.service-wraper .pt-img4 {
    top: 10px;
    left: 40%
}

.service-wraper .feature-container {
    margin: 15px
}

.service-wraper .slick-slider {
    margin-right: -100px
}

@media only screen and (max-width: 1380px) {
    .service-wraper {
        padding-left: 30px;
        padding-right: 30px
    }
}

@media only screen and (max-width: 1199px) {
    .service-wraper .slick-slider {
        margin-right: -15px;
        margin-left: -15px
    }
}

@media only screen and (max-width: 991px) {
    .service-wraper:after {
        width: 100%;
        border-radius: 0
    }

    .service-wraper .heading-bx .title,
    .service-wraper .heading-bx p {
        color: #fff
    }
}

@media only screen and (max-width: 767px) {
    .service-wraper {
        padding-left: 15px;
        padding-right: 15px
    }
}

.service-wraper2 {
    background-color: rgba(86, 90, 207, .1)
}

.contact-banner .page-banner-entry {
    padding-bottom: 140px
}

.contact-wraper {
    background-color: #fff;
    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);
    border-radius: 40px;
    padding: 70px 50px 40px;
    position: relative;
    margin-top: -150px
}

.contact-wraper .contact-form .form-group {
    margin-bottom: 30px
}

@media only screen and (max-width: 575px) {
    .contact-wraper .contact-form .form-group {
        margin-bottom: 20px
    }
}

@media only screen and (max-width: 1199px) {
    .contact-wraper {
        padding: 50px 40px 20px
    }
}

@media only screen and (max-width: 575px) {
    .contact-wraper {
        padding: 30px 30px 0px;
        border-radius: 20px
    }
}

.card {
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: .25rem;
    background: #fcfcfc;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    margin-bottom: 20px;
}

.card-body {
    padding: 10px;
}

.contact-info {
    padding: 50px 50px 30px;
    color: #fff;
    overflow: hidden;
    border-radius: 8px;
    height: 100%;
    /* width: 1200px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* margin-left: 50px */
}

.contact-info .info-inner {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1
}

.contact-info .info-inner .title {
    color: #fff
}

.contact-info .social-media {
    margin: 0 -3px
}

.contact-info .social-media li {
    display: inline-block;
    padding: 0 3px
}

.contact-info .social-media li a {
    color: #565acf;
    background-color: #fff
}

.contact-info .icon-box {
    margin-right: 100px;
    margin-bottom: 30px
}

.contact-info .icon-box p {
    font-size: 14px
}

.flex-cards-service {
    display: flex;
    flex-direction: row;
    gap: 80px;
    justify-content: center;
    padding: 15px 20px;
    margin-top: 30px !important;
}

@media only screen and (max-width: 1199px) {
    .flex-cards-service {
        display: flex;
        flex-direction: column;
        gap: 20px;
        justify-content: space-evenly;
        padding: 15px 20px;
    }
}


.contact-info .icon-box .title {
    margin-bottom: 12px;
    border-bottom: 2px solid rgba(255, 255, 255, .2);
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    text-transform: capitalize;
    font-size: 18px;
    font-weight: 600
}

.contact-info .icon-box .title i {
    font-size: 24px;
    margin-right: 10px;
    color: #fff
}

@media only screen and (max-width: 1199px) {
    .contact-info {
        margin-left: 0
    }
}

@media only screen and (max-width: 575px) {
    .contact-info {
        padding: 30px 30px 0px
    }

    .contact-info .icon-box {
        margin-right: 0
    }
}

@media only screen and (max-width: 575px) {

    #rc-imageselect,
    .g-recaptcha {
        transform-origin: 0 0;
        -moz-transform-origin: 0 0;
        -o-transform-origin: 0 0;
        -webkit-transform-origin: 0 0;
        transform: scale(0.8);
        -moz-transform: scale(0.8);
        -o-transform: scale(0.8);
        -webkit-transform: scale(0.8);
        margin-bottom: -15px
    }
}

.social-media {
    margin: 0 -3px
}

.social-media li {
    display: inline-block;
    padding: 0 3px
}

.social-media li a {
    display: block;
    height: 40px;
    width: 40px;
    line-height: 40px;
    background-color: #008BB1;
    color: #fff;
    text-align: center;
    border-radius: 8px;
    box-shadow: 0px 10px 40px 0px rgba(31, 34, 120, .1);
    font-size: 16px;
    transition: all .5s
}

.social-media li a:hover {
    color: #fff;
    background-color: #f17732
}

.skillbar-box .title {
    margin-bottom: 0
}

.skillbar-box .skillbar {
    position: relative;
    display: inline-block;
    background: rgba(0, 0, 0, .15);
    height: 6px;
    width: 100%;
    text-align: left;
    border-radius: 10px
}

.skillbar-box .skillbar-bar {
    height: 6px;
    border-radius: 10px;
    width: 0px;
    background: #565acf;
    display: inline-block;
    position: absolute;
    top: 0;
    margin-bottom: 0px;
    overflow: unset !important
}

.skillbar-box .skillbar-bar:after {
    content: "";
    border-radius: 15px;
    background: #fff;
    width: 20px;
    height: 20px;
    position: absolute;
    right: -5px;
    border: 3px solid #565acf;
    top: -8px
}

.skillbar-box .skill-bar-percent {
    position: absolute;
    top: -35px;
    right: 0;
    color: #565acf;
    font-weight: 700;
    font-size: 16px
}

.skillbar-box .skill-bar-text {
    top: -22px;
    position: absolute
}

.skillbar-box .skillbar-bar-main {
    padding: 30px 30px 20px 30px;
    border: 1px solid rgba(0, 0, 0, .1);
    background: #f3f3f3
}

.skillbar-box .skillbar-box {
    margin-bottom: 25px
}

.skillbar-box .skillbar-bar-main.white .title {
    color: #fff
}

.skillbar-box .skillbar-bar-main.white .skillbar {
    background: rgba(255, 255, 255, .15)
}

.skillbar-box .skillbar-bar-main.white .skillbar-bar {
    background: #f17732
}

.skillbar-box .skillbar-bar-main.white .skill-bar-percent {
    color: #f17732
}

.service-wraper3 {
    position: relative
}

.service-wraper3:before {
    content: "";
    border-radius: 50%;
    position: absolute;
    height: 250px;
    width: 250px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(86, 90, 207, .1);
    z-index: -1
}

.slick-arrow-none .slick-arrow {
    display: none !important
}

.help-bx {
    position: relative;
    border-radius: 8px;
    overflow: hidden
}

.help-bx .info {
    padding: 70px 50px;
    text-align: center;
    z-index: 1;
    background-color: rgba(86, 90, 207, .9);
    left: 0;
    top: 0;
    width: 100%;
    height: 100%
}

.help-bx .info img {
    max-width: 60px;
    margin-bottom: 20px
}

.help-bx .title {
    color: #fff;
    margin-bottom: 15px
}

.help-bx p {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 30px;
    color: #fff
}

.brochure-bx {
    position: relative;
    background-color: #fff;
    border-radius: 6px 6px 4px 4px !important;
    padding: 30px 30px;
    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);
    border: 1px solid rgba(86, 90, 207, .2);
    border-width: 1px 1px 3px 1px;
    border-bottom-color: #565acf
}

.brochure-bx .title-head {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    padding-bottom: 8px;
    position: relative;
    margin-bottom: 30px
}

.brochure-bx .title-head:after {
    background: #565acf;
    content: "";
    width: 30px;
    height: 3px;
    position: absolute;
    bottom: -2px;
    left: 0
}

@media only screen and (max-width: 575px) {
    .brochure-bx {
        padding: 15px
    }

    .brochure-bx .title-head {
        margin-bottom: 20px
    }
}

.download-link {
    position: relative;
    display: block;
    padding: 15px 15px 15px 65px;
    margin-top: 20px;
    border-radius: 8px;
    background-color: #565acf
}

.download-link .title {
    font-size: 15px;
    margin: 0;
    line-height: 22px;
    color: #fff
}

.download-link span {
    color: #fff;
    font-size: 14px;
    line-height: 18px
}

.download-link img {
    width: 40px;
    position: absolute;
    left: 15px;
    top: 18px
}

@media only screen and (max-width: 575px) {
    .download-link {
        margin-top: 10px
    }
}

.list-check-squer li {
    display: block;
    color: var(--bs-dark);
    font-size: 20px;
    font-family: "Roboto Condensed";
    font-weight: 500;
    position: relative;
    padding: 8px 15px 7px 50px;
    margin-bottom: 10px;
    line-height: 20px
}

.list-check-squer li:before {
    content: "";
    font-family: "Line Awesome Free";
    font-weight: 900;
    background-color: #565acf;
    transition: all .5s;
    width: 35px;
    height: 35px;
    display: block;
    text-align: center;
    line-height: 35px;
    color: #fff;
    position: absolute;
    left: 0;
    top: 50%;
    border-radius: 4px;
    transform: translateY(-50%)
}

.list-check-squer li:hover:before {
    background-color: #f17732
}

@media only screen and (max-width: 575px) {
    .list-check-squer li {
        font-size: 18px;
        padding: 8px 15px 7px 46px
    }
}

.error-404 .inner-content {
    text-align: center;
    max-width: 550px;
    margin: auto
}

.error-404 .error-title {
    font-size: 180px;
    line-height: 180px;
    margin-bottom: 15px
}

.error-404 .error-title span {
    width: 145px;
    height: 145px;
    display: inline-block;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
    background-size: 100%;
    margin: 0 10px
}

.error-404 .error-text {
    margin-bottom: 15px
}

.error-404 p {
    margin-bottom: 30px
}

@media only screen and (max-width: 575px) {
    .error-404 .error-title {
        font-size: 120px;
        line-height: 120px
    }

    .error-404 .error-title span {
        width: 100px;
        height: 100px
    }
}

.blog-single {
    margin-bottom: 60px;
    box-shadow: unset;
    padding: 0;
    border: 0
}

.blog-single .ttr-post-title {
    margin-bottom: 10px
}

.blog-single .ttr-post-title .post-title {
    margin-bottom: 10px
}

.blog-single .action-box {
    margin-bottom: 30px
}

.blog-single .ttr-post-text {
    margin-top: 10px
}

.blog-single .ttr-post-text ul {
    padding: 0
}

.blog-single .share-post li:first-child {
    margin-right: 5px
}

.blog-single .ttr-post-text ul li {
    padding: 5px 0
}

.blog-single .ttr-post-footer {
    display: flex;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, .1);
    border-width: 1px 0;
    padding: 12px 0;
    margin-top: 30px;
    justify-content: space-between
}

.blog-single .ttr-post-footer .post-tags a {
    color: #008BB1;
    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
    margin-right: 10px
}

.blog-single .ttr-post-footer strong {
    font-size: 15px;
    font-weight: 600;
    margin-right: 10px
}

.blog-single .ttr-post-footer .social-media {
    margin-bottom: 0
}

.blog-single .ttr-post-meta {
    margin-bottom: 0
}

.blog-single .ttr-post-tags {
    margin-top: 20px
}

.blog-single .ttr-post-media {
    border-radius: 4px
}

@media only screen and (max-width: 767px) {
    .blog-single {
        margin-bottom: 40px
    }

    .blog-single .ttr-post-footer {
        display: block
    }

    .blog-single .ttr-post-footer .social-media {
        margin: 15px 0 0
    }

    .blog-single .wp-block-gallery {
        margin-bottom: 5px
    }
}

.blog-single:hover {
    box-shadow: unset;
    border: 0
}

.comments-area {
    padding: 0
}

.comments-area .comments-title {
    text-transform: uppercase;
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 30px
}

ol.comment-list {
    margin-bottom: 60px;
    list-style: none;
    padding-left: 0
}

ol.comment-list li.comment {
    position: relative;
    padding: 0
}

ol.comment-list li.comment .comment-body {
    margin-bottom: 30px;
    position: relative;
    background-color: #fff;
    border-radius: 6px 6px 4px 4px;
    padding: 30px 30px;
    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);
    border: 1px solid rgba(86, 90, 207, .2);
    border-width: 1px 1px 3px 1px;
    border-bottom-color: #008bb1
}

ol.comment-list li.comment .comment-author {
    margin-bottom: 15px;
    display: flex;
    align-items: center
}

ol.comment-list li.comment .comment-author .avatar {
    width: 70px;
    height: 70px;
    border-radius: 14px;
    -webkit-border-radius: 14px;
    background: #fff;
    padding: 4px;
    margin-right: 16px;
    box-shadow: 0 0 30px 0 rgba(0, 10, 105, .03)
}

ol.comment-list li.comment .comment-author .fn {
    display: inline-block;
    color: var(--bs-dark);
    font-size: 20px;
    font-weight: 700;
    font-style: normal;
    margin-bottom: 5px;
    line-height: 28px
}

ol.comment-list li.comment .comment-author .says {
    display: none;
    color: #999;
    font-weight: 600
}

ol.comment-list li.comment .comment-meta {
    color: #8d8d8d;
    text-transform: uppercase
}

ol.comment-list li.comment .comment-meta a {
    color: #008BB1;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: uppercase
}

ol.comment-list li.comment p {
    margin: 0 0 5px;
    font-size: 15px
}

ol.comment-list li.comment .reply a {
    background: #00b8de;
    padding: 6px 14px;
    border-radius: 8px;
    display: inline-block;
    margin-top: 12px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    text-transform: uppercase
}

ol.comment-list li.comment .reply a:hover {
    background-color: #008bb1;
    color: #fff
}

ol.comment-list li.comment .comment-respond .comment-form p {
    padding: 0 15px
}

ol.comment-list li .children {
    list-style: none;
    margin-left: 80px;
    padding: 0
}

ol.comment-list li .children li {
    padding: 0
}

@media only screen and (max-width: 767px) {
    ol.comment-list {
        margin-bottom: 40px
    }

    ol.comment-list .padding-30 {
        padding: 15px
    }

    ol.comment-list li.comment .comment-body {
        margin-bottom: 30px
    }

    ol.comment-list li.comment .reply a {
        position: static
    }

    ol.comment-list li .children {
        margin-left: 30px
    }
}

@media only screen and (max-width: 575px) {
    ol.comment-list li.comment .comment-body {
        padding: 25px
    }
}

.comment-respond {
    position: relative;
    background-color: #fff;
    border-radius: 6px 6px 4px 4px;
    padding: 30px 30px;
    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);
    border: 1px solid #008bb1;
    border-width: 1px 1px 3px 1px;
    border-bottom-color: #565acf
}

.comment-respond .comment-reply-title {
    margin-bottom: 25px
}

.comment-respond .comment-form {
    margin: 0 -10px
}

.comment-respond .comment-notes {
    display: none
}

.comment-respond p {
    width: 50%;
    float: left;
    padding: 0 10px;
    margin-bottom: 20px;
    position: relative
}

.comment-respond p.form-allowed-tags {
    width: 100%
}

.comments-area .comment-form p label {
    display: none;
    line-height: 18px;
    margin-bottom: 10px
}

.comments-area .comment-form p input[type=text],
.comments-area .comment-form p textarea {
    width: 100%;
    height: 50px;
    padding: 15px 25px;
    border: 1px solid;
    text-transform: capitalize;
    color: #000;
    background: #fff;
    font-size: 16px;
    border-color: rgba(86, 90, 207, .3);
    border-radius: 6px;
    font-weight: 500
}

.comments-area .comment-form p input[type=text]::placeholder,
.comments-area .comment-form p textarea::placeholder {
    color: #444
}

.comments-area .comment-form p input[type=text]:hover,
.comments-area .comment-form p textarea:hover,
.comments-area .comment-form p input[type=text]:focus,
.comments-area .comment-form p textarea:focus {
    border-color: #565acf;
    box-shadow: none;
    outline: none
}

.comments-area .comment-form p.comment-form-comment {
    width: 100%;
    display: block;
    clear: both
}

.comments-area .comment-form p textarea {
    height: 120px
}

.comments-area .comment-form p.form-submit {
    clear: both;
    float: none;
    width: 100%;
    margin: 0
}

.comments-area .comment-form p input[type=submit] {
    background-color: #008bb1;
    color: #fff;
    display: inline-block;
    font-weight: 500;
    font-size: 14px;
    padding: 15px 30px;
    border: 2px solid;
    border-color: #008bb1;
    border-radius: 8px;
    text-decoration: none;
    transition: all .5s;
    line-height: 1.2
}

.comments-area .comment-form p input[type=submit]:hover,
.comments-area .comment-form p input[type=submit]:focus,
.comments-area .comment-form p input[type=submit]:active {
    background-color: #00b8de;
    border: 2px solid #00b8de;
}

@media only screen and (max-width: 767px) {
    .comments-area .comment-form p {
        width: 100%;
        float: none;
        margin-bottom: 20px
    }

    .comments-area .comment-respond {
        padding: 20px
    }
}

.author-box {
    margin-bottom: 50px;
    position: relative;
    background-color: #fff;
    border-radius: 6px 6px 4px 4px;
    padding: 30px 30px;
    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);
    border: 1px solid rgba(86, 90, 207, .2);
    border-width: 1px 1px 3px 1px;
    border-bottom-color: #008bb1
}

.author-box.blog-user .author-profile-info {
    display: flex
}

@media only screen and (max-width: 575px) {
    .author-box.blog-user .author-profile-info {
        display: block
    }
}

.author-box .author-profile-pic {
    width: 100px;
    height: 100px;
    min-width: 100px;
    border-radius: 10px;
    overflow: hidden;
    z-index: 2;
    position: relative;
    margin-right: 20px
}

.author-box .author-profile-pic img {
    width: 100%;
    min-width: 100px;
    height: 100px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: none;
    z-index: 2;
    position: relative;
    margin: 0 auto;
    border: 0
}

.author-box .author-profile-pic h6,
.author-box .author-profile-pic .h6 {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 5px
}

.author-box .author-profile-pic p {
    margin-bottom: 15px;
    font-size: 18px;
    line-height: 24px
}

@media only screen and (max-width: 575px) {
    .author-box .author-profile-pic {
        margin-bottom: 20px
    }
}

.min-container,
.blog-post.blog-single {
    max-width: 750px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px
}

.max-container {
    max-width: 1500px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 55px;
    padding-right: 55px
}

.blog-post.blog-single .ttr-post-info {
    padding: 0
}

.blog-post.blog-single .ttr-post-text.text>ol,
.blog-post.blog-single .ttr-post-text.text>ul {
    padding-left: 30px
}

.blog-post.blog-single .ttr-post-text.text>ol li,
.blog-post.blog-single .ttr-post-text.text>ul li {
    padding: 5px 5px;
    color: #2b2d2e
}

.blog-post.blog-single .ttr-post-text.text>.wp-block-gallery {
    padding: 0;
    list-style: none
}

.blog-post.blog-single .ttr-post-text.text>.wp-block-gallery li {
    padding: 0;
    list-style: none;
    margin: 10px
}

.blog-post.blog-single .ttr-post-text ul li,
.blog-post.blog-single .ttr-post-text ol li,
.blog-post.blog-single .ttr-post-text p {
    font-size: 15px;
    line-height: 28px
}

.blog-post.blog-single .ttr-post-text p {
    margin-bottom: 28px
}

.blog-post.blog-single .ttr-post-text .wp-block-gallery {
    margin-left: -195px;
    margin-right: -195px;
    width: calc(100% + 380px + 10px);
    max-width: initial
}

.blog-post.blog-single .ttr-post-text>div+p:first-letter,
.blog-post.blog-single .ttr-post-text>p:first-child:first-letter {
    color: #6d9ec4;
    font-size: 100px;
    float: left;
    margin-right: 20px;
    margin-bottom: 14px;
    margin-top: 15px
}

.blog-post.blog-single .ttr-post-text .has-large-font-size {
    font-size: 36px;
    line-height: 50px;
    color: #000
}

.content-spacious-full .wp-block-gallery {
    margin-left: -205px;
    margin-right: -205px;
    width: calc(100% + 400px + 10px);
    max-width: initial
}

.alignwide {
    margin-left: -105px;
    margin-right: -105px;
    width: calc(100% + 200px + 10px);
    max-width: initial
}

.alignfullwide {
    margin-left: calc(50% - 50vw - var(--content-share-ml, 0px)/2);
    width: 100vw;
    max-width: 100vw;
    box-sizing: border-box
}

.ttr-post-text h1,
.ttr-post-text .h1,
.thm-unit-test .ttr-post-text h1 {
    font-size: 36px;
    line-height: 45px;
    margin-bottom: 10px;
    font-weight: 700
}

.ttr-post-text h2,
.ttr-post-text .h2,
.thm-unit-test .ttr-post-text h2 {
    font-size: 32px;
    line-height: 45px;
    margin-bottom: 5px;
    font-weight: 700
}

.ttr-post-text h3,
.ttr-post-text .h3,
.thm-unit-test .ttr-post-text h3 {
    font-size: 28px;
    line-height: 35px;
    margin-bottom: 8px;
    font-weight: 700
}

.ttr-post-text h4,
.ttr-post-text .h4,
.thm-unit-test .ttr-post-text h4 {
    font-size: 22px;
    line-height: 32px;
    margin-bottom: 5px;
    font-weight: 600
}

.ttr-post-text h5,
.ttr-post-text .h5,
.thm-unit-test .ttr-post-text h5 {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 8px;
    font-weight: 600
}

.ttr-post-text h6,
.ttr-post-text .h6,
.thm-unit-test .ttr-post-text h6 {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 10px;
    font-weight: 600
}

pre {
    margin: 0 0 25px;
    padding: 20px;
    color: #ddd;
    background-color: #222;
    white-space: pre;
    text-shadow: 0 1px 0 #000;
    border-radius: 5px;
    border-bottom: 1px solid #555;
    box-shadow: 0 1px 5px rgba(0, 0, 0, .4) inset, 0 0 20px rgba(0, 0, 0, .2) inset
}

blockquote {
    padding: 50px 30px 50px 140px;
    font-size: 20px;
    color: #fff;
    margin: 25px 0;
    line-height: 1.7;
    position: relative;
    clear: both;
    background: #00b8de;
    border-radius: 10px;
    /* box-shadow: 0 7px 50px -20px #f17732; */
    width: 80%;

}

blockquote:after {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
    position: absolute;
    width: 90px;
    height: 90px;
    left: 30px;
    top: 10px;
    background-size: cover
}

blockquote p {
    color: inherit;
    margin-bottom: 0px;
    font-weight: 600;
    font-style: italic;
    text-align: center;
}

.block-quote-section-main {
    display: flex;
    justify-content: center;
}

.block-quote-section {
    display: flex;
    justify-content: center;
    margin-bottom: -100px;
}

.styled-text {
    font-size: 28px;
    /* font-family: "Poppins", sans-serif; */
}

@media only screen and (max-width: 767px) {
    blockquote {
        font-size: 16px;
        padding: 25px 25px 25px 90px
    }

    blockquote:after {
        width: 40px;
        height: 40px
    }
}

@media only screen and (max-width: 575px) {
    blockquote {
        font-size: 15px;
        padding: 20px 20px 20px 80px
    }

    blockquote:after {
        left: 20px;
        top: 20px
    }
}

.paginate-links {
    display: flex;
    align-items: center;
    margin: 20px 0
}

.paginate-links a,
.paginate-links>span {
    margin: 0 0 0 10px;
    position: relative;
    border: 0px solid #6cc000;
    color: #000;
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    line-height: 40px;
    min-width: 40px;
    height: 40px;
    text-align: center;
    text-transform: capitalize;
    transition: all 500ms ease 0s;
    background: #e0e0e0;
    border-radius: 3px
}

.wp-block-button__link {
    border-radius: 4px;
    font-size: 16px;
    padding: 10px 30px;
    font-weight: 700
}

.wp-block-gallery {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    padding: 0
}

.wp-block-gallery .blocks-gallery-image,
.wp-block-gallery .blocks-gallery-item {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    margin: 0 8px 8px 0;
    position: relative;
    width: calc(50% - 8px)
}

.wp-block-gallery .blocks-gallery-image figure,
.wp-block-gallery .blocks-gallery-item figure {
    height: 100%;
    margin: 0
}

.wp-block-gallery .blocks-gallery-image img,
.wp-block-gallery .blocks-gallery-item img {
    display: block;
    height: auto;
    max-width: 100%;
    width: 100%
}

.wp-block-gallery .blocks-gallery-image figcaption,
.wp-block-gallery .blocks-gallery-item figcaption {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3) 60%, transparent);
    bottom: 0;
    color: #fff;
    font-size: 13px;
    max-height: 100%;
    overflow: auto;
    padding: 40px 10px 5px;
    position: absolute;
    text-align: center;
    width: 100%
}

.wp-block-gallery .blocks-gallery-image figcaption img,
.wp-block-gallery .blocks-gallery-item figcaption img {
    display: inline
}

.wp-block-gallery .blocks-gallery-image:last-child,
.wp-block-gallery .blocks-gallery-item:last-child {
    margin-right: 0
}

.wp-block-gallery .blocks-gallery-image:nth-of-type(2n),
.wp-block-gallery .blocks-gallery-item:nth-of-type(2n) {
    margin-right: 0
}

.wp-block-gallery .blocks-gallery-item.has-add-item-button {
    width: 100%
}

.wp-block-gallery.aligncenter .blocks-gallery-item figure {
    justify-content: center
}

.wp-block-gallery.columns-4 .blocks-gallery-image,
.wp-block-gallery.columns-4 .blocks-gallery-item,
.wp-block-gallery.columns-3 .blocks-gallery-image,
.wp-block-gallery.columns-3 .blocks-gallery-item {
    margin-right: 8px
}

.wp-block-gallery.columns-1 .blocks-gallery-image,
.wp-block-gallery.columns-1 .blocks-gallery-item {
    margin-right: 0;
    width: 100%
}

.wp-block-gallery.is-cropped .blocks-gallery-image a,
.wp-block-gallery.is-cropped .blocks-gallery-image img,
.wp-block-gallery.is-cropped .blocks-gallery-item a,
.wp-block-gallery.is-cropped .blocks-gallery-item img {
    width: 100%
}

.wp-block-gallery.aligncenter,
.wp-block-gallery.alignleft,
.wp-block-gallery.alignright {
    display: flex
}

.wp-block-gallery.alignleft,
.wp-block-gallery.alignright {
    max-width: 305px;
    width: 100%
}

.wp-block-image.alignfullwide img {
    border-radius: 0
}

.wp-block-image img {
    border-radius: 10px
}

.aligncenter {
    text-align: center
}

@supports(position: sticky) {
    .wp-block-gallery .blocks-gallery-image figure {
        align-items: flex-end;
        display: flex;
        justify-content: flex-start
    }
}

@supports(position: sticky) {

    .wp-block-gallery .blocks-gallery-image img,
    .wp-block-gallery .blocks-gallery-item img {
        width: auto
    }
}

@supports(position: sticky) {

    .wp-block-gallery.is-cropped .blocks-gallery-image a,
    .wp-block-gallery.is-cropped .blocks-gallery-image img {
        -o-object-fit: cover;
        flex: 1 1;
        height: 100%;
        object-fit: cover
    }
}

@media only screen and (max-width: 1024px) {
    .alignwide {
        margin-left: 0;
        margin-right: 0;
        width: 100%;
        max-width: 100%
    }

    .alignwide .alignleft {
        margin: 5px 0px 25px 0;
        float: none
    }

    .alignwide .alignleft img {
        width: 100%
    }
}

@media(min-width: 600px) {

    .wp-block-gallery.columns-3 .blocks-gallery-image,
    .wp-block-gallery.columns-3 .blocks-gallery-item {
        margin-right: 20px;
        width: calc(33.33333% - 10.66667px)
    }

    .wp-block-gallery.columns-4 .blocks-gallery-image,
    .wp-block-gallery.columns-4 .blocks-gallery-item {
        margin-right: 20px;
        width: calc(25% - 12px)
    }

    .wp-block-gallery.columns-5 .blocks-gallery-image,
    .wp-block-gallery.columns-5 .blocks-gallery-item {
        margin-right: 20px;
        width: calc(20% - 12.8px)
    }

    .wp-block-gallery.columns-6 .blocks-gallery-image,
    .wp-block-gallery.columns-6 .blocks-gallery-item {
        margin-right: 20px;
        width: calc(16.66667% - 13.33333px)
    }

    .wp-block-gallery.columns-7 .blocks-gallery-image,
    .wp-block-gallery.columns-7 .blocks-gallery-item {
        margin-right: 20px;
        width: calc(14.28571% - 13.71429px)
    }

    .wp-block-gallery.columns-8 .blocks-gallery-image,
    .wp-block-gallery.columns-8 .blocks-gallery-item {
        margin-right: 20px;
        width: calc(12.5% - 14px)
    }

    .wp-block-gallery.columns-1 .blocks-gallery-image:last-child,
    .wp-block-gallery.columns-1 .blocks-gallery-item:last-child,
    .wp-block-gallery.columns-2 .blocks-gallery-image:last-child,
    .wp-block-gallery.columns-2 .blocks-gallery-item:last-child,
    .wp-block-gallery.columns-3 .blocks-gallery-image:last-child,
    .wp-block-gallery.columns-3 .blocks-gallery-item:last-child,
    .wp-block-gallery.columns-4 .blocks-gallery-image:last-child,
    .wp-block-gallery.columns-4 .blocks-gallery-item:last-child,
    .wp-block-gallery.columns-5 .blocks-gallery-image:last-child,
    .wp-block-gallery.columns-5 .blocks-gallery-item:last-child,
    .wp-block-gallery.columns-6 .blocks-gallery-image:last-child,
    .wp-block-gallery.columns-6 .blocks-gallery-item:last-child,
    .wp-block-gallery.columns-7 .blocks-gallery-image:last-child,
    .wp-block-gallery.columns-7 .blocks-gallery-item:last-child,
    .wp-block-gallery.columns-8 .blocks-gallery-image:last-child,
    .wp-block-gallery.columns-8 .blocks-gallery-item:last-child {
        margin-right: 0
    }
}

.menu-logo {
    display: table;
    float: left;
    vertical-align: middle;
    padding: 10px;
    color: #efbb20;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    width: 150px;
    height: 105px;
    position: relative;
    z-index: 9
}

.menu-logo a {
    display: table-cell;
    vertical-align: middle
}

.menu-logo img {
    height: auto;
    width: 100%
}

.menu-logo span {
    font-size: 20px;
    letter-spacing: 20px
}

@media only screen and (max-width: 991px) {
    .menu-logo {
        height: 85px
    }
}

@media only screen and (max-width: 767px) {
    .menu-logo {
        width: 180px
    }
}

@media only screen and (max-width: 575px) {
    .menu-logo {
        height: 75px;
        width: 150px
    }
}

.header {
    position: relative;
    z-index: 9999
}

.header .menu-bar {
    background: #fff;
    width: 100%;
    position: relative
}

.header .container {
    position: relative
}

.header .secondary-menu {
    float: right;
    height: 105px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 9;
    padding-left: 15px
}

.header .secondary-menu .search-btn {
    margin-right: 35px
}

.header .secondary-menu .search-btn .btn-link {
    font-size: 25px;
    line-height: 25px;
    color: #008BB1;
    cursor: pointer;
    border: 0;
    padding: 8px 0;
    background: none
}

.header .secondary-menu ul {
    margin-bottom: 0;
    display: flex;
    align-items: center
}

.header .secondary-menu ul .num-bx {
    margin-right: 40px
}

.header .secondary-menu ul .num-bx a {
    font-weight: 700;
    font-size: 20px;
    color: var(--bs-dark);
    display: flex;
    align-items: center
}

.header .secondary-menu ul .num-bx a i {
    width: 42px;
    height: 42px;
    text-align: center;
    line-height: 42px;
    background-color: rgba(86, 90, 207, .1);
    font-size: 18px;
    border-radius: 8px;
    color: #565acf;
    margin-right: 15px
}

@media only screen and (max-width: 1680px) {
    .header .secondary-menu .search-btn {
        margin-right: 25px
    }

    .header .secondary-menu ul .num-bx {
        margin-right: 30px
    }
}

@media only screen and (max-width: 1380px) {
    .header .secondary-menu ul .num-bx {
        display: none
    }
}

@media only screen and (max-width: 991px) {
    .header .secondary-menu {
        height: 85px
    }

    .header .secondary-menu .btn-area {
        display: none
    }

    .header .secondary-menu .search-btn {
        margin-right: 0
    }
}

@media only screen and (max-width: 575px) {
    .header .secondary-menu {
        height: 75px
    }
}

.navbar-toggler {
    border: 0 solid #efbb20;
    font-size: 16px;
    line-height: 24px;
    margin: 35px 0 32px 20px;
    padding: 0;
    float: right;
    outline: none
}

@media only screen and (max-width: 575px) {
    .navbar-toggler {
        margin: 28px 0 28px 20px
    }
}

.menuicon {
    width: 20px;
    height: 18px;
    position: relative;
    transform: rotate(0deg);
    transition: .5s ease-in-out;
    cursor: pointer
}

.menuicon span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    border-radius: 1px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: .25s ease-in-out;
    background: #000
}

.menuicon span:nth-child(1) {
    top: 0px
}

.menuicon span:nth-child(2) {
    top: 7px
}

.menuicon span:nth-child(3) {
    top: 14px
}

.menuicon.open span:nth-child(1) {
    top: 7px;
    transform: rotate(135deg)
}

.menuicon.open span:nth-child(2) {
    opacity: 0;
    left: -60px
}

.menuicon.open span:nth-child(3) {
    top: 7px;
    transform: rotate(-135deg)
}

.header-tb .menuicon span {
    background: #fff
}

.menu-links {
    padding: 0
}

@media only screen and (max-width: 991px) {
    .menu-links.show {
        left: -1px;
        transition: all .8s;
        margin: 0;
        width: 280px
    }
}

.menu-links .menu-logo {
    display: none
}

@media only screen and (max-width: 991px) {
    .menu-links .menu-logo {
        padding: 30px 20px;
        float: none;
        height: auto;
        width: 240px
    }
}

.menu-links .nav {
    float: right;
    padding: 0;
    margin-right: 50px
}

.menu-links .nav>li {
    margin: 0px;
    font-weight: 400;
    position: relative
}

.menu-links .nav>li.has-mega-menu {
    position: inherit
}

@media only screen and (max-width: 991px) {
    .menu-links .nav>li {
        border-bottom: 1px solid #eee;
        width: 100%
    }
}

.menu-links .nav>li.active>a {
    color: #f17732
}

.menu-links .nav>li>a {
    color: var(--bs-dark);
    font-size: 16px;
    padding: 45px 20px;
    cursor: pointer;
    font-weight: 600;
    display: inline-block;
    position: relative;
    border-width: 0 0 0 1px;
    line-height: 1
}

.menu-links .nav>li>a i {
    font-size: 10px;
    margin-left: 5px;
    margin-top: -3px;
    vertical-align: middle;
    color: #bbbbcf;
    transition: all .5s
}

@media only screen and (max-width: 991px) {
    .menu-links .nav>li>a i {
        right: 0;
        text-align: center;
        z-index: 3;
        float: right;
        margin: 10px 5px 0 0;
        font-size: 12px
    }
}

@media only screen and (max-width: 1199px) {
    .menu-links .nav>li>a {
        padding: 45px 15px
    }
}

@media only screen and (max-width: 991px) {
    .menu-links .nav>li>a {
        padding: 8px 0;
        display: block;
        line-height: 30px;
        color: #fff
    }
}

.menu-links .nav>li .mega-menu,
.menu-links .nav>li .sub-menu {
    background-color: #fff;
    display: block;
    left: 0;
    list-style: none;
    opacity: 0;
    padding: 5px 0;
    position: absolute;
    visibility: hidden;
    width: 220px;
    z-index: 10;
    margin-top: 20px;
    box-shadow: 0px 1px 40px 0px rgba(0, 0, 0, .1);
    transition: all .8s
}

@media only screen and (max-width: 991px) {

    .menu-links .nav>li .mega-menu,
    .menu-links .nav>li .sub-menu {
        display: none;
        position: static;
        visibility: visible;
        width: auto;
        background: rgba(0, 0, 0, 0);
        box-shadow: none;
        margin: 0;
        border-top: 1px solid rgba(255, 255, 255, .1);
        padding: 0
    }
}

.menu-links .nav>li .mega-menu li,
.menu-links .nav>li .sub-menu li {
    position: relative
}

.menu-links .nav>li .mega-menu li a,
.menu-links .nav>li .sub-menu li a {
    color: #666;
    display: block;
    font-size: 14px;
    padding: 10px 25px;
    text-transform: capitalize;
    position: relative;
    transition: all .15s linear;
    -webkit-transition: all .15s linear;
    -moz-transition: all .15s linear;
    -o-transition: all .15s linear;
    font-weight: 500
}

.menu-links .nav>li .mega-menu li a span,
.menu-links .nav>li .sub-menu li a span {
    position: relative
}

.menu-links .nav>li .mega-menu li a span:after,
.menu-links .nav>li .sub-menu li a span:after {
    content: "";
    position: absolute;
    height: 1px;
    width: 0;
    background: #565acf;
    bottom: 0;
    right: 0;
    transition: all .5s;
    transform-origin: right
}

.menu-links .nav>li .mega-menu li a:hover,
.menu-links .nav>li .sub-menu li a:hover {
    color: #565acf
}

.menu-links .nav>li .mega-menu li a:hover span:after,
.menu-links .nav>li .sub-menu li a:hover span:after {
    width: 100%;
    transform-origin: left;
    left: 0;
    right: auto
}

@media only screen and (max-width: 991px) {

    .menu-links .nav>li .mega-menu li a,
    .menu-links .nav>li .sub-menu li a {
        padding: 10px 0px 10px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, .1)
    }

    .menu-links .nav>li .mega-menu li a span:after,
    .menu-links .nav>li .sub-menu li a span:after {
        content: none
    }
}

.menu-links .nav>li .mega-menu li:hover>a,
.menu-links .nav>li .sub-menu li:hover>a {
    color: #565acf
}

.menu-links .nav>li .mega-menu li>.sub-menu,
.menu-links .nav>li .sub-menu li>.sub-menu {
    left: 220px;
    transition: all .5s
}

.menu-links .nav>li .sub-menu li .fa {
    color: inherit;
    display: block;
    float: right;
    font-size: 9px;
    opacity: 1;
    margin-top: 4px
}

.menu-links .nav>li .mega-menu {
    display: flex;
    right: 0px;
    width: 100%;
    z-index: 9;
    padding: 0
}

.menu-links .nav>li .mega-menu>li {
    display: block;
    padding: 30px 0 25px;
    position: relative;
    vertical-align: top;
    width: 25%
}

@media only screen and (max-width: 991px) {
    .menu-links .nav>li .mega-menu>li {
        width: 100%;
        padding: 0
    }
}

.menu-links .nav>li .mega-menu>li>a {
    color: #000;
    display: block;
    padding: 0 20px;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
    padding-bottom: 15px
}

.menu-links .nav>li .mega-menu>li>a>i {
    font-size: 14px;
    margin-right: 5px;
    text-align: center;
    width: 15px
}

@media only screen and (max-width: 991px) {
    .menu-links .nav>li .mega-menu>li>a {
        display: none
    }
}

.menu-links .nav>li .mega-menu>li:after {
    content: "";
    background-color: rgba(0, 0, 0, .1);
    position: absolute;
    right: 0px;
    top: 0px;
    display: block;
    width: 1px;
    height: 100%
}

@media only screen and (max-width: 991px) {
    .menu-links .nav>li .mega-menu>li:after {
        content: none
    }
}

.menu-links .nav>li .mega-menu>li:last-child:after {
    display: none
}

.menu-links .nav>li .mega-menu>li:hover>a {
    background-color: rgba(0, 0, 0, 0)
}

.menu-links .nav>li .mega-menu>li li i {
    font-size: 14px;
    margin-right: 5px;
    text-align: center;
    width: 15px
}

@media only screen and (max-width: 991px) {
    .menu-links .nav>li .mega-menu {
        display: none;
        padding: 10px 0
    }
}

.menu-links .nav>li:hover>.mega-menu,
.menu-links .nav>li:hover>.sub-menu {
    opacity: 1;
    visibility: visible;
    margin-top: 0;
    transition: all .5s
}

.menu-links .nav>li:hover>.mega-menu li:hover>.sub-menu,
.menu-links .nav>li:hover>.sub-menu li:hover>.sub-menu {
    opacity: 1;
    visibility: visible;
    margin-top: 0;
    top: -1px
}

.menu-links .nav>li:hover a {
    color: #00b8de
}

.menu-links .nav>li:hover a i {
    transform: rotate(45deg);
    color: #f17732
}

@media only screen and (max-width: 991px) {
    .menu-links .nav>li:hover a i {
        transform: unset
    }
}

.menu-links .nav>li.open .mega-menu,
.menu-links .nav>li.open .sub-menu {
    display: block;
    opacity: 1
}

@media only screen and (max-width: 991px) {
    .menu-links .nav>li.open>a i:before {
        content: ""
    }
}

@media only screen and (max-width: 1680px) {
    .menu-links .nav {
        margin-right: 0
    }
}

@media only screen and (max-width: 991px) {
    .menu-links .nav {
        float: none;
        width: 70%;
        min-width: 300px
    }
}

.menu-links .social-media {
    text-align: center;
    margin-top: 50px;
    margin: 0 -3px;
    display: none
}

.menu-links .social-media li {
    display: inline-block;
    padding: 0 3px
}

.menu-links .social-media li a {
    height: 40px;
    width: 40px;
    padding: 0;
    line-height: 38px
}

.menu-links .menu-close {
    height: 40px;
    color: #fff;
    background-color: #565acf;
    line-height: 44px;
    text-align: center;
    width: 40px;
    position: absolute;
    right: 0;
    top: 0;
    display: none;
    z-index: 9999
}

@media only screen and (max-width: 991px) {
    .menu-links {
        overflow-y: scroll;
        position: fixed;
        width: 60px;
        left: -280px;
        height: 100vh;
        transition: all .5s;
        top: 0;
        background-color: #fff;
        margin: 0;
        z-index: 99
    }

    .menu-links .social-media,
    .menu-links .menu-close {
        display: block
    }
}

.top-bar {
    background-color: #191f23;
    color: #fff;
    padding: 8px 0
}

@media only screen and (max-width: 575px) {
    .top-bar {
        display: none
    }
}

.top-bar .topbar-left {
    float: left
}

.top-bar .topbar-left li {
    padding-right: 15px
}

.top-bar .topbar-right {
    float: right
}

.top-bar .topbar-right li {
    padding-left: 15px
}

.top-bar .topbar-center,
.top-bar .topbar-left,
.top-bar .topbar-right {
    padding-left: 15px;
    padding-right: 15px
}

.top-bar .topbar-center ul,
.top-bar .topbar-left ul,
.top-bar .topbar-right ul {
    list-style: none;
    margin: 0;
    padding: 0
}

.top-bar .topbar-center ul li,
.top-bar .topbar-left ul li,
.top-bar .topbar-right ul li {
    display: inline-block;
    font-size: 15px
}

@media only screen and (max-width: 1199px) {

    .top-bar .topbar-center ul li,
    .top-bar .topbar-left ul li,
    .top-bar .topbar-right ul li {
        font-size: 13px
    }
}

.top-bar .topbar-center ul a,
.top-bar .topbar-left ul a,
.top-bar .topbar-right ul a {
    color: inherit
}

.top-bar .topbar-center ul i,
.top-bar .topbar-left ul i,
.top-bar .topbar-right ul i {
    color: #565acf;
    transform: scale(1.3);
    -moz-transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -ms-transform: scale(1.3);
    -o-transform: scale(1.3);
    margin-right: 5px
}

.header-transparent {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%
}

.header-transparent.style-1 .menu-links .nav>li>a {
    color: var(--bs-dark)
}

.header-transparent.style-1 .menu-links .nav>li>a:hover {
    color: #f17732
}

.header-transparent.style-1 .menu-links .nav>li>a:hover i {
    transform: rotate(45deg);
    color: #f17732
}

.header-transparent.style-2 .menu-links .nav>li>a {
    color: #fff
}

.header-transparent.style-2 .menu-links .nav>li>a:hover {
    color: #fff
}

.header-transparent .top-bar,
.header-transparent .menu-bar {
    background: rgba(0, 0, 0, 0)
}

.header-transparent .top-bar {
    color: #777;
    border-bottom: 1px solid rgba(0, 0, 0, .1)
}

@media only screen and (max-width: 575px) {
    .header-transparent .top-bar {
        display: none
    }
}

.sticky-header.active .menu-logo {
    transition: all .5s
}

.sticky-header.active .menu-bar {
    position: fixed;
    top: 0;
    left: 0;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, .1)
}

.sticky-header.active .logo-change .logo1 {
    display: none
}

.sticky-header.active .logo-change .logo2 {
    display: block
}

.header-transparent .sticky-header.active .menu-bar {
    position: fixed;
    background-color: #fff
}

@media only screen and (max-width: 991px) {
    .rs-nav .menu-links {
        position: fixed;
        width: 60px;
        left: -105%;
        height: 100vh;
        transition: all .5s;
        top: 0;
        background-color: #171a1e;
        margin: 0;
        z-index: 99;
        overflow-y: scroll;
        flex-direction: column;
        display: flex;
        flex-direction: column;
        justify-content: unset !important
    }

    .rs-nav .menu-links li.open a {
        position: relative
    }

    .rs-nav .menu-links .menu-logo {
        display: block;
        float: none;
        height: auto;
        max-width: 100%;
        padding: 20px 15px;
        width: 100%;
        text-align: center
    }

    .rs-nav .menu-links .menu-logo img {
        max-width: unset;
        width: 150px;
        vertical-align: middle
    }

    .rs-nav .menu-links .menu-logo a {
        display: inline-block
    }

    .rs-nav .menu-links.nav-dark {
        background-color: #202020
    }

    .rs-nav .menu-links.show {
        left: 0;
        transition: all .8s;
        margin: 0;
        width: 100%;
        padding: 15px 15px 5px 15px
    }

    .rs-nav .sticky-header.active .menu-links .nav {
        height: auto
    }

    .rs-nav .social-media {
        margin-top: auto;
        padding: 30px 0
    }

    .navbar-nav {
        height: auto
    }

    .menu-links .nav>li {
        border-color: rgba(255, 255, 255, .1)
    }

    .menu-links .nav>li a {
        font-size: 14px;
        color: #fff
    }

    .menu-links .nav>li:hover>a,
    .menu-links .nav>li.active>a {
        color: #fff;
        border-color: rgba(255, 255, 255, .1)
    }

    .menu-links .nav>li .mega-menu li a,
    .menu-links .nav>li .sub-menu li a {
        color: rgba(255, 255, 255, .7)
    }

    .menu-links .nav>li .mega-menu li:hover>a,
    .menu-links .nav>li .sub-menu li:hover>a {
        background-color: rgba(0, 0, 0, 0)
    }

    .header-transparent .sticky-header.active .menu-links .nav>li>a {
        color: #fff
    }
}

.nav-search-bar {
    background-color: rgba(255, 255, 255, .95);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: none;
    overflow: hidden;
    padding: 0 15px
}

.nav-search-bar>span {
    position: absolute;
    right: 15px;
    top: 15px;
    font-size: 14px;
    cursor: pointer;
    color: #fff;
    background-color: #008BB1;
    height: 40px;
    width: 40px;
    text-align: center;
    line-height: 44px
}

.nav-search-bar.show {
    display: block
}

.nav-search-bar.show form {
    transition: all .5s ease .5s;
    -moz-transition: all .5s ease .5s;
    -webkit-transition: all .5s ease .5s;
    opacity: 1
}

.nav-search-bar form {
    width: 100%;
    max-width: 700px;
    margin: auto;
    position: relative;
    top: 50%;
    transition: all .5s;
    transition: all .5s;
    -webkit-transition: all .5s;
    -moz-transform: translate(0px, -50%);
    -moz-transform: translate(0px, -50%);
    -o-transform: translate(0px, -50%);
    -webkit-transform: translate(0px, -50%);
    opacity: 0
}

.nav-search-bar form span {
    position: absolute;
    right: 15px;
    top: 50%;
    margin: -15px 0;
    height: 25px;
    font-size: 20px;
    cursor: pointer;
    color: #000
}

.nav-search-bar .form-control {
    padding: 15px 60px 15px 15px;
    width: 100%;
    height: 70px;
    border: none;
    background: none;
    color: #000;
    font-size: 20px;
    border-bottom: 2px solid #000;
    border-radius: 0
}

.nav-search-bar .form-control::-moz-placeholder {
    color: #000
}

.nav-search-bar .form-control:-moz-placeholder {
    color: #000
}

.nav-search-bar .form-control:-ms-input-placeholder {
    color: #000
}

.nav-search-bar .form-control::-webkit-input-placeholder {
    color: #000
}

.widget {
    margin-bottom: 40px
}

@media only screen and (max-width: 575px) {
    .widget {
        margin-bottom: 30px
    }
}

.widget-title {
    margin-bottom: 30px;
    position: relative;
    padding-bottom: 15px
}

.widget-title:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 85px;
    height: 7px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
    background-repeat: no-repeat
}

@media only screen and (max-width: 767px) {
    .widget-title {
        padding-bottom: 15px;
        font-size: 20px;
        margin-bottom: 25px
    }

    .widget-title:after {
        width: 75px;
        height: 5px
    }
}

.side-bar .widget {
    position: relative;
    background-color: #fff;
    border-radius: 6px 6px 4px 4px;
    padding: 30px 30px;
    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);
    border: 1px solid rgba(86, 90, 207, .2);
    border-width: 1px 1px 3px 1px;
    border-bottom-color: #008bb1
}

@media only screen and (max-width: 575px) {
    .side-bar .widget {
        margin-bottom: 30px
    }
}

.recent-overlay-post .widget-post {
    position: relative;
    z-index: 1
}

.recent-overlay-post .widget-post:after {
    content: "";
    position: absolute;
    width: 100%;
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    background: #0f1012;
    opacity: .6;
    z-index: 1
}

.widget-link {
    margin: 0px;
    padding: 0px
}

.widget-link li {
    list-style: none;
    display: inline-block;
    padding-left: 3px;
    padding-right: 10px;
    position: relative
}

.widget-link li:after {
    content: "/";
    position: absolute;
    right: 0
}

.widget-link li:last-child {
    padding-right: 3px
}

.widget-link li:last-child:after {
    content: none
}

.widget-link-2 ul {
    margin: 0px;
    padding: 0px;
    list-style: none
}

.widget-link-2 ul li {
    list-style: none;
    display: inline-block;
    padding: 10px 0;
    position: relative
}

.widget-link-2 ul li a {
    padding: 10px 0
}

.wp-block-latest-posts ul,
.wp-block-categories-list ul,
.wp-block-archives-list ul,
.widget_categories ul,
.widget_archive ul,
.widget_meta ul,
.widget_pages ul,
.widget_recent_comments ul,
.widget_nav_menu ul,
.widget_rss ul,
.widget_recent_entries ul,
.widget_services ul,
.widget_getintuch ul {
    list-style: none;
    padding-left: 0;
    margin-bottom: 0
}

.wp-block-latest-posts ul li,
.wp-block-categories-list ul li,
.wp-block-archives-list ul li,
.widget_categories ul li,
.widget_archive ul li,
.widget_meta ul li,
.widget_pages ul li,
.widget_recent_comments ul li,
.widget_nav_menu ul li,
.widget_rss ul li,
.widget_recent_entries ul li,
.widget_services ul li,
.widget_getintuch ul li {
    padding-bottom: 18px;
    margin-bottom: 13px;
    position: relative;
    padding: 10px 0px 10px 15px;
    margin-bottom: 0;
    line-height: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, .1)
}

.wp-block-latest-posts ul li a,
.wp-block-categories-list ul li a,
.wp-block-archives-list ul li a,
.widget_categories ul li a,
.widget_archive ul li a,
.widget_meta ul li a,
.widget_pages ul li a,
.widget_recent_comments ul li a,
.widget_nav_menu ul li a,
.widget_rss ul li a,
.widget_recent_entries ul li a,
.widget_services ul li a,
.widget_getintuch ul li a {
    color: #11171a;
    text-transform: capitalize;
    font-size: 14px;
    font-weight: 500
}

.wp-block-latest-posts ul li a:hover,
.wp-block-categories-list ul li a:hover,
.wp-block-archives-list ul li a:hover,
.widget_categories ul li a:hover,
.widget_archive ul li a:hover,
.widget_meta ul li a:hover,
.widget_pages ul li a:hover,
.widget_recent_comments ul li a:hover,
.widget_nav_menu ul li a:hover,
.widget_rss ul li a:hover,
.widget_recent_entries ul li a:hover,
.widget_services ul li a:hover,
.widget_getintuch ul li a:hover {
    color: #565acf
}

.wp-block-latest-posts ul li:before,
.wp-block-categories-list ul li:before,
.wp-block-archives-list ul li:before,
.widget_categories ul li:before,
.widget_archive ul li:before,
.widget_meta ul li:before,
.widget_pages ul li:before,
.widget_recent_comments ul li:before,
.widget_nav_menu ul li:before,
.widget_rss ul li:before,
.widget_recent_entries ul li:before,
.widget_services ul li:before,
.widget_getintuch ul li:before {
    content: "";
    position: absolute;
    left: 0;
    top: 10px;
    display: block;
    width: 5px;
    height: 5px;
    background: #a6611c;
    top: 17px
}

.wp-block-latest-posts ul li li,
.wp-block-categories-list ul li li,
.wp-block-archives-list ul li li,
.widget_categories ul li li,
.widget_archive ul li li,
.widget_meta ul li li,
.widget_pages ul li li,
.widget_recent_comments ul li li,
.widget_nav_menu ul li li,
.widget_rss ul li li,
.widget_recent_entries ul li li,
.widget_services ul li li,
.widget_getintuch ul li li {
    border-bottom: none;
    padding-top: 8px;
    padding-bottom: 8px;
    line-height: 22px;
    border-bottom: 1px solid rgba(0, 0, 0, .1)
}

.wp-block-latest-posts ul li li:last-child,
.wp-block-categories-list ul li li:last-child,
.wp-block-archives-list ul li li:last-child,
.widget_categories ul li li:last-child,
.widget_archive ul li li:last-child,
.widget_meta ul li li:last-child,
.widget_pages ul li li:last-child,
.widget_recent_comments ul li li:last-child,
.widget_nav_menu ul li li:last-child,
.widget_rss ul li li:last-child,
.widget_recent_entries ul li li:last-child,
.widget_services ul li li:last-child,
.widget_getintuch ul li li:last-child {
    border-bottom: 0;
    padding-bottom: 0
}

.wp-block-latest-posts ul li li:before,
.wp-block-categories-list ul li li:before,
.wp-block-archives-list ul li li:before,
.widget_categories ul li li:before,
.widget_archive ul li li:before,
.widget_meta ul li li:before,
.widget_pages ul li li:before,
.widget_recent_comments ul li li:before,
.widget_nav_menu ul li li:before,
.widget_rss ul li li:before,
.widget_recent_entries ul li li:before,
.widget_services ul li li:before,
.widget_getintuch ul li li:before {
    top: 16px;
    left: 0
}

.wp-block-latest-posts ul li ul,
.wp-block-categories-list ul li ul,
.wp-block-archives-list ul li ul,
.widget_categories ul li ul,
.widget_archive ul li ul,
.widget_meta ul li ul,
.widget_pages ul li ul,
.widget_recent_comments ul li ul,
.widget_nav_menu ul li ul,
.widget_rss ul li ul,
.widget_recent_entries ul li ul,
.widget_services ul li ul,
.widget_getintuch ul li ul {
    padding-left: 20px;
    margin-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, .1);
    margin-left: -15px
}

.search-bx .btn {
    padding: 11px 15px;
    border: 1px solid rgba(0, 0, 0, 0);
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    height: 100%
}

.widget.widget_search {
    border: 0;
    padding: 0
}

.widget.widget_search .screen-reader-text {
    display: block
}

.widget.widget_search .input-group-btn {
    position: relative;
    z-index: 99
}

.searchform {
    position: relative
}

.searchform input[type=text] {
    width: 100%;
    height: 70px;
    position: relative;
    background-color: #fff;
    border-radius: 6px 6px 4px 4px !important;
    padding: 30px 30px;
    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);
    border: 1px solid rgba(86, 90, 207, .2);
    border-width: 1px 1px 3px 1px;
    border-bottom-color: #008bb1
}

.searchform input[type=text]:hover,
.searchform input[type=text]:focus,
.searchform input[type=text]:active {
    border-color: #565acf
}

.searchform .btn {
    height: 50px;
    padding: 0;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
    width: 50px
}

.recent-posts-entry .widget-post {
    margin-bottom: 15px;
    align-items: center;
    display: flex;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px
}

.recent-posts-entry .widget-post:last-child {
    margin-bottom: 0;
    border-bottom: 0;
    padding-bottom: 0
}

.recent-posts-entry .ttr-post-media {
    width: 100px;
    min-width: 100px;
    margin: 0;
    border-radius: 12px
}

.recent-posts-entry .ttr-post-info {
    background: rgba(0, 0, 0, 0);
    padding: 0;
    padding-left: 15px;
    border: none;
    padding-right: 0
}

.recent-posts-entry .ttr-post-info .post-title {
    margin-bottom: 12px;
    font-size: 16px
}

.recent-posts-entry .ttr-post-info .post-title a {
    color: var(--bs-dark)
}

.recent-posts-entry .post-meta {
    margin-bottom: 0
}

.recent-posts-entry .post-meta li a {
    font-family: "Montserrat", sans-serif;
    color: var(--bs-dark);
    text-transform: uppercase;
    font-weight: 400;
    font-size: 14px
}

.widget_recent_comments ul li:before {
    content: "";
    font-family: FontAwesome;
    background: rgba(0, 0, 0, 0);
    width: auto;
    height: auto;
    left: 0;
    top: 10px;
    font-size: 18px;
    color: #11171a
}

.widget_recent_comments ul {
    margin-top: -10px
}

.widget_recent_comments ul li {
    padding-left: 30px;
    color: #11171a;
    line-height: 26px
}

.widget_meta ul li a abbr[title] {
    color: #333;
    border-bottom: none
}

.widget_calendar th,
.widget_calendar td {
    text-align: center;
    border: 1px solid rgba(0, 0, 0, .05);
    padding: .4em
}

.widget_calendar tr {
    border-bottom: 1px solid #eee
}

.widget_calendar table {
    border-collapse: collapse;
    margin: 0;
    width: 100%
}

.widget_calendar .calendar_wrap th,
.widget_calendar .calendar_wrap tfoot td a {
    color: #fff
}

.widget_calendar .calendar_wrap th,
.widget_calendar .calendar_wrap tfoot td {
    background: #7a4815;
    border-color: rgba(0, 0, 0, .05)
}

.widget_calendar .calendar_wrap td a {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 14px;
    color: inherit
}

.widget_calendar .calendar_wrap th:last-child,
.widget_calendar .calendar_wrap tfoot td:last-child {
    border: 0
}

.widget_calendar .calendar_wrap tr:nth-child(2n+2) {
    background-color: #faf8f2
}

.widget_calendar caption {
    text-align: center;
    font-weight: 600;
    caption-side: top;
    background: #a6611c;
    color: #fff;
    text-transform: uppercase;
    font-size: 15px
}

.wp-calendar-nav {
    background: #854e16;
    color: #fff;
    display: flex;
    justify-content: space-between;
    text-align: center
}

.wp-calendar-nav span {
    padding: 5px 20px;
    width: 44%;
    border-right: 1px solid rgba(255, 255, 255, .2)
}

.wp-calendar-nav span a {
    color: #fff
}

.wp-calendar-nav span .pad {
    width: 15%
}

.widget_tag_cloud a {
    padding: 8px 12px;
    background-color: #008bb1;
    font-size: 12px;
    display: inline-block;
    margin: 0 1px 6px;
    color: #fff;
    font-weight: 600;
    border-radius: 8px;
    transition: all .5s
}

.widget_tag_cloud a:hover {
    background-color: #00b8de;
    color: #fff;
}

.widget_archive select {
    width: 100%;
    padding: 5px;
    border: 1px solid #ccc
}

.widget_text select {
    width: 100%;
    padding: 5px;
    border: 1px solid #ccc
}

.widget_text select option {
    width: 100%
}

.widget_text p {
    font-size: 15px;
    line-height: 28px
}

.widget_text b,
.widget_text strong {
    color: #11171a
}

.widget_archive ul li,
.wp-block-categories-list li,
.wp-block-archives-list li,
.wp-block-latest-posts li,
.widget_categories ul li {
    text-align: right;
    display: table;
    width: 100%;
    font-size: 14px;
    padding: 10px 0px 10px 15px;
    line-height: 1.3
}

.widget_archive ul li a,
.wp-block-categories-list li a,
.wp-block-archives-list li a,
.wp-block-latest-posts li a,
.widget_categories ul li a {
    float: left;
    text-transform: capitalize;
    box-shadow: none;
    text-align: left
}

.widget_archive ul li ul,
.wp-block-categories-list li ul,
.wp-block-archives-list li ul,
.wp-block-latest-posts li ul,
.widget_categories ul li ul {
    margin-bottom: -10px
}

.widget_archive ul li:before,
.wp-block-categories-list li:before,
.wp-block-archives-list li:before,
.wp-block-latest-posts li:before,
.widget_categories ul li:before {
    content: none
}

.wp-block-latest-posts,
.wp-block-categories-list,
.wp-block-archives-list {
    margin-bottom: 40px;
    padding: 0
}

.widget_categories form label {
    display: block
}

.rsswidget img {
    display: inherit
}

.widget-title .rsswidget {
    display: inline-block
}

ul a.rsswidget,
ul cite {
    font-weight: 600;
    color: #060429;
    font-size: 14px
}

ul a.rsswidget {
    font-size: 18px
}

ul a.rsswidget:hover {
    color: #a6611c
}

.rssSummary {
    margin: 20px 0;
    font-size: 14px;
    line-height: 1.7
}

.rss-date {
    display: block;
    margin-top: 5px;
    font-size: 14px;
    font-weight: 400;
    color: #9fa1a4
}

.widget_rss ul li {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
    padding-top: 0
}

.widget_rss ul li:last-child {
    margin-bottom: 0;
    border-bottom: 0;
    padding-bottom: 0
}

.widget_getintuch {
    padding-top: 10px
}

.widget_getintuch li {
    margin-bottom: 20px;
    position: relative;
    padding-left: 40px
}

.widget_getintuch li,
.widget_getintuch b,
.widget_getintuch strong {
    display: block;
    text-transform: capitalize
}

.widget_getintuch strong {
    font-weight: 600;
    font-size: 16px
}

.widget_getintuch i {
    position: absolute;
    left: 0;
    top: 5px;
    text-align: center;
    font-size: 22px;
    width: 30px;
    height: 30px;
    line-height: 30px
}

.widget_gallery ul {
    padding-left: 0;
    display: table;
    margin-bottom: 0
}

.widget_gallery ul li {
    display: inline-block;
    width: 33.33%;
    float: left;
    transition: all .5s;
    padding: 2px
}

.widget_gallery ul li img {
    display: inline-block;
    width: 100%
}

.widget_gallery ul li:nth-child(3n-3) {
    margin-right: 0
}

.widget_gallery ul li:hover {
    opacity: .7
}

.widget_gallery ul li a {
    display: inline-block
}

.widget_gallery.gallery-grid-2 li {
    width: 50%
}

.widget_gallery.gallery-grid-4 li {
    width: 25%
}

.widget_gallery.gallery-grid-8 li {
    width: 12.5%
}

@media only screen and (max-width: 767px) {
    .gallery-grid-8 li {
        width: 25%
    }
}

.commentlist .bypostauthor {
    font-weight: 600
}

.admin-bar .is-fixed .main-bar {
    top: 30px
}

@media only screen and (max-width: 991px) {
    .admin-bar .header-nav {
        top: 30px;
        height: calc(100vh - 30px)
    }
}

@media only screen and (max-width: 782px) {
    .admin-bar .is-fixed .main-bar {
        top: 45px
    }

    .admin-bar .header-nav {
        top: 45px;
        height: calc(100vh - 45px)
    }
}

@media only screen and (max-width: 600px) {
    .admin-bar .is-fixed .main-bar {
        top: 0
    }

    .admin-bar .header-nav {
        top: 45px;
        height: calc(100vh - 45px)
    }

    .admin-bar .is-fixed .header-nav {
        top: 0;
        height: 100vh
    }
}

footer {
    position: relative;
    z-index: 1;
    overflow: hidden;
    font-size: 15px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover
}

footer p {
    font-weight: 500
}

footer .widget.footer_widget ul {
    margin-bottom: 0
}

footer .widget .footer-title {
    margin-bottom: 30px;
    position: relative;
    padding-bottom: 20px;
    font-size: 24px
}

footer .widget .footer-title:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 85px;
    height: 7px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
    background-repeat: no-repeat
}

@media only screen and (max-width: 767px) {
    footer .widget .footer-title {
        padding-bottom: 15px;
        font-size: 20px;
        margin-bottom: 25px
    }

    footer .widget .footer-title:after {
        width: 75px;
        height: 5px
    }
}

@media only screen and (max-width: 767px) {
    footer .widget {
        margin-bottom: 40px
    }
}

footer .ft-contact p {
    font-size: 16px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 30px
}

footer .ft-contact .contact-bx {
    display: flex;
    align-items: center
}

footer .ft-contact .contact-bx .icon i {
    font-size: 24px;
    color: #fff;
    margin-right: 15px;
    border-radius: 30px 30px 0px 30px;
    width: 58px;
    height: 58px;
    line-height: 58px;
    text-align: center;
    background-color: var(--bs-dark)
}

footer .ft-contact .contact-bx .contact-number .number {
    margin-bottom: 0;
    font-size: 20px
}

footer .ft-contact .contact-bx .contact-number span {
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: 600;
    display: block;
    color: var(--bs-dark)
}

@media only screen and (max-width: 767px) {
    footer .ft-contact p {
        margin-bottom: 20px
    }
}

footer .footer-logo {
    max-width: 190px;
    margin-bottom: 25px
}

@media only screen and (max-width: 767px) {
    footer .footer-logo {
        margin-bottom: 15px
    }
}

footer .widget-logo ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap
}

footer .widget-logo ul li {
    display: inline-block;
    flex: 50% 1;
    padding: 0 15px 15px 0px
}

footer .footer-top {
    padding: 200px 0 20px
}

@media only screen and (max-width: 1380px) {
    footer .footer-top {
        padding: 150px 0 0
    }
}

@media only screen and (max-width: 991px) {
    footer .footer-top {
        padding: 120px 0 0
    }
}

@media only screen and (max-width: 767px) {
    footer .footer-top {
        padding: 100px 0 0
    }
}

@media only screen and (max-width: 575px) {
    footer .footer-top {
        padding: 70px 0 10px
    }
}

footer .footer-bottom {
    padding: 25px 0;
    font-size: 15px
}

footer .subscribe-form .form-control {
    border-radius: 10px;
    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);
    margin-bottom: 20px;
    height: 52px;
    font-size: 15px;
    font-weight: 500
}

@media only screen and (max-width: 991px) {
    footer .widget.footer_widget.ml-50 {
        margin-left: 0
    }
}

.footer .footer_widget ul li a {
    font-size: 16px;
    font-weight: 500;
    padding: 6px 0;
    display: block;
    line-height: 25px;
    color: #444;
    position: relative
}

.footer .footer_widget ul li a:hover,
.footer .custom-links li a:hover {
    color: var(--bs-dark);
}

.footer .custom-links li a {
    color: #444444;
}



.footer .footer-bottom {
    border-top: 1px solid #d4d5f1
}

.footer .footer-bottom .copyright-text {
    margin: 0
}

.footer .footer-bottom .copyright-text a {
    color: var(--bs-dark) !important;
}

.footer .footer-bottom .link-inline {
    margin: 0 -15px
}

.footer .footer-bottom .link-inline li {
    display: inline-block;
    margin-left: 15px;
    margin-right: 15px;
    text-transform: capitalize
}

.footer .footer-bottom .link-inline li a:hover {
    color: #565acf
}

.footer:after {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100%;
    z-index: -1;
    background-position: left top
}

.footer .footer-social-link ul {
    margin: 0 -8px
}

.footer .footer-social-link ul li {
    display: inline-block;
    padding: 0 8px
}

.footer .pt-img1 {
    top: 100px;
    left: 130px;
    z-index: 1
}

@media only screen and (max-width: 1380px) {
    .footer .pt-img1 {
        top: 80px;
        left: 80px
    }
}


.footer .pt-img2 {
    bottom: 180px;
    left: 30px
}

@media only screen and (max-width: 1380px) {
    .footer .pt-img2 {
        bottom: 100px;
        left: 60px
    }
}

.footer .pt-img3 {
    top: 180px;
    right: 40px
}

@media only screen and (max-width: 991px) {
    .footer .pt-img3 {
        right: -50px
    }
}

.footer .pt-img4 {
    bottom: 120px;
    right: 60px
}

@media only screen and (max-width: 991px) {
    .footer .pt-img4 {
        bottom: 40px;
        sright: 0px
    }
}

.App {
    text-align: center
}

.App-logo {
    height: 40vmin;
    pointer-events: none
}

@media(prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear
    }
}

.App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: #fff
}

.App-link {
    color: #61dafb
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(360deg)
    }
}

.product-card-design h3 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis !important;
}


.services-block-three {
    margin-bottom: 30px;
    cursor: pointer;

    i {
        font-size: 32px;
    }

    .custom-icon {
        font-size: 18px !important;
        color: var(--bs-dark);
    }

    >div {
        display: block;
        border: 2px solid #d5d5d5;
        border-radius: 4px;
        text-align: center;
        background: #fff;
        /* padding: 20px; */
        padding: 14px;
        position: relative;
        margin-bottom: 30px;
        transition: all 0.5s ease;

        &:before {
            display: block;
            content: "";
            width: 9%;
            height: 17%;
            position: absolute;
            bottom: -2px;
            right: -2px;
            border-bottom: 2px solid #03a9f5;
            border-right: 2px solid #03a9f5;
            transition: all 0.5s ease;
        }

        &:after {
            display: block;
            content: "";
            width: 9%;
            height: 17%;
            position: absolute;
            top: -2px;
            left: -2px;
            border-top: 2px solid #03a9f5;
            border-left: 2px solid #03a9f5;
            transition: all 0.5s ease;
        }

        &:hover {
            opacity: 1;
            border-color: #d5d5d5;

            &:before,
            &:after {
                width: 95%;
                height: 90%;
            }
        }
    }

    h4 {
        color: #6f6f6f;
        font-size: 14px;
        margin-bottom: 10px;
        font-weight: 600;
    }

    p {
        margin-bottom: 0;
        color: #757575;
    }

    .bg-color {
        /* background-color: #F6F8FA; */
        min-height: 225px !important;
        height: 225px !important;
        max-height: 225px !important;

    }

    .bg-color img {
        width: 222px;
        height: 166px;
    }
}

.padding-15px-bottom {
    padding-bottom: 15px;
}

a {

    &:hover,
    &:active {
        color: #03a9f5;
        text-decoration: none;
    }
}

/* Product Page Style Sheet Start */
.product-searchbar {
    border-radius: 10px;
    background-color: #F6F8FA;
    max-width: 598px;
}

.product-searchbar input {
    padding: 16px 16px 16px 44px;
    line-height: 17px;
    color: #757575;
    font-weight: 500;
    font-size: 15px;
}

.product-searchbar input::placeholder {
    color: #757575;
    font-size: 15px;
}

.product-searchbar input[type="search"]::-webkit-search-cancel-button {
    display: none;
}

.product-searchbar i {
    top: 30%;
    left: 16px;
    transform: rotate(270deg) !important;
}

.product-tabs {
    height: 100px;
    width: 100px;
}

.product-tabs .tab-icon {
    height: 100px;
    width: 100px;
}

.product-tabs .tab-icon img {
    height: 48px;
    max-width: 68px;
}

.product-tabs p {
    text-transform: capitalize !important;
}

.product-tabs.active p {
    color: var(--bs-dark) !important;
}

.product-tabs>div::before,
.product-tabs>div::after {
    opacity: 0;
    border-color: #008BB1 !important;
    /* width: 20% !important;
    height: 20% !important; */
    width: 20% !important;
    height: 20% !important;
}


.product-tabs.active>div::before,
.product-tabs.active>div::after {
    opacity: 1 !important;
}

.product-tabs.active>div:hover::before,
.product-tabs.active>div:hover::after {
    width: 9%;
    opacity: 1 !important;
    height: 17%
}


.product-tabs:hover>div::before,
.product-tabs:hover>div::after {
    opacity: 1 !important;
    /* width: 9%;
    height: 17% */
}

/* Product Page Style Sheet End */

/* Product Detail Page Style Sheet Start */
.product-img-container {
    border: 1px solid #f6f6f6;
    min-height: 380px;
    height: 380px;
    max-height: 380px;
}

.product-detail-container .content {
    font-size: 16px;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

/* .product-detail-container .product-detail-varient .product-detail-item:hover svg path {
    fill: #008bb1 !important;
} */

.product-detail-container .product-detail-varient .product-detail-item:nth-child(1):hover svg path,
.product-detail-container .product-detail-varient .product-detail-item:nth-child(3):hover svg path,
.product-detail-container .product-detail-varient .product-detail-item:nth-child(5):hover svg path,
.product-detail-container .product-detail-varient .product-detail-item:nth-child(6):hover svg path {
    fill: #008bb1 !important;
}

.product-detail-container .product-detail-varient .product-detail-item:nth-child(2):hover svg path,
.product-detail-container .product-detail-varient .product-detail-item:nth-child(4):hover svg path {
    stroke: #008bb1 !important;
}

.product-detail-container .product-detail-varient .product-detail-item span {
    font-size: 14px;
}

.product-detail-container .product-detail-varient .product-detail-item:hover span {
    color: #00b8de;
    fill: #008bb1 !important;
}

.product-detail-container .product-detail-varient .product-detail-item h6 {
    font-size: 16px;
    padding-top: 3px;
    color: #222222;
}

.custom-submit-btn {
    max-width: 140px;
}

.custom-form-br {
    border: 1px solid #d5d5d5;
}

.custom-form-br input,
.custom-form-br textarea {
    font-size: 15px !important;
}

.custom-form-br input::placeholder,
.custom-form-br textarea::placeholder {
    font-size: 15px !important;
}

.custom-section-bg {
    background-color: #f5f5fc;
}

/* Product Detail Page Style Sheet End */

/* Footer Style Sheet Start */
/* Footer Style Sheet Start */
.foot-contact i {
    color: var(--bs-dark);
    margin-top: 6px;
}

.foot-contact a {
    color: #444;
    font-size: 15px;
}

.foot-contact a:hover {
    color: var(--bs-dark);
}

/* Footer Style Sheet End */

/* Client Review Style Sheet Start */
.custom-client-review .slick-list {
    max-height: 420px;
}

/* Client Review Style Sheet End */

/* About Us Style Sheet Start */
.our-partner-box {
    border: 2px solid #d5d5d5;

    height: 180px;
    width: 180px;
}


.our-partner-box img {
    width: 135px;
    height: 135px;
    transform: scale(1);
    transition: all 0.6s;
    object-fit: contain;
}

.our-partner-box:hover img {
    transform: scale(1.1);
    transition: all 0.6s;
}

/* About Us Style Sheet End */`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;;IAEI,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;IAC/B,gCAAgC;IAChC,8BAA8B;IAC9B,0BAA0B;IAC1B,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,iCAAiC;IACjC,+BAA+B;IAC/B,4BAA4B;IAC5B,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,6BAA6B;IAC7B,uBAAuB;IACvB,qNAAqN;IACrN,yGAAyG;IACzG,yFAAyF;IACzF,+CAA+C;IAC/C,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,wBAAwB;IACxB,+BAA+B;IAC/B,qBAAqB;IACrB,+BAA+B;IAC/B,yBAAyB;IACzB,gCAAgC;IAChC,4CAA4C;IAC5C,oCAAoC;IACpC,0BAA0B;IAC1B,oCAAoC;IACpC,0CAA0C;IAC1C,mCAAmC;IACnC,yBAAyB;IACzB,mCAAmC;IACnC,2BAA2B;IAC3B,wBAAwB;IACxB,gCAAgC;IAChC,+BAA+B;IAC/B,wCAAwC;;IAExC,sCAAsC;IACtC,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,0BAA0B;IAC1B,mDAAmD;IACnD,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;IAC5B,mDAAmD;IACnD,8BAA8B;IAC9B,kDAAkD;IAClD,2DAA2D;IAC3D,oDAAoD;IACpD,2DAA2D;IAC3D,8BAA8B;IAC9B,6BAA6B;IAC7B,8CAA8C;IAC9C,8BAA8B;IAC9B,qCAAqC;IACrC,gCAAgC;IAChC;AACJ;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,qBAAqB;IACrB,4BAA4B;IAC5B,yBAAyB;IACzB,sCAAsC;IACtC,+CAA+C;IAC/C,uCAAuC;IACvC,0BAA0B;IAC1B,iCAAiC;IACjC,6CAA6C;IAC7C,sCAAsC;IACtC,yBAAyB;IACzB,gCAAgC;IAChC,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,iCAAiC;IACjC,+BAA+B;IAC/B,4BAA4B;IAC5B,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,2BAA2B;IAC3B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,wCAAwC;IACxC,wBAAwB;IACxB,0BAA0B;IAC1B,wDAAwD;IACxD,8BAA8B;IAC9B,qCAAqC;IACrC,gCAAgC;IAChC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,uCAAuC;IACvC,mCAAmC;IACnC,uCAAuC;IACvC,uCAAuC;IACvC,2BAA2B;IAC3B,qCAAqC;IACrC,mCAAmC;IACnC,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,cAAc;IACd,SAAS;IACT,wCAAwC;IACxC;AACJ;;AAEA;;;;;;;;;;;;IAYI,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,yCAAiC;YAAjC,iCAAiC;IACjC,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gEAAgE;IAChE;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;;IAII,qCAAqC;IACrC;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,sCAAsC;IACtC;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;;;;;IAMI,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,0BAA0B;AAC9B;;AAEA;;;;IAII;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,iCAAiC;IACjC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mCAAmC;IACnC,2DAA2D;IAC3D,sCAAsC;IACtC,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;;;;IAMI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,0CAA0C;IAC1C,yCAAyC;IACzC,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;;QAGI;IACJ;AACJ;;AAEA;;IAEI;;;;QAII;IACJ;AACJ;;AAEA;;IAEI;;;;;QAKI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,uCAAuC;IACvC,2CAA2C;IAC3C;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,0CAA0C;IAC1C,yCAAyC;IACzC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,+BAA+B;IAC/B,4BAA4B;IAC5B,sCAAsC;IACtC,gCAAgC;IAChC,+CAA+C;IAC/C,iCAAiC;IACjC,8CAA8C;IAC9C,0CAA0C;IAC1C,6CAA6C;IAC7C,wCAAwC;IACxC,4CAA4C;IAC5C,yCAAyC;IACzC,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,qFAAqF;IACrF,oCAAoC;IACpC,2CAA2C;IAC3C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oDAAoD;IACpD;AACJ;;AAEA;IACI,oDAAoD;IACpD;AACJ;;AAEA;IACI,oDAAoD;IACpD;AACJ;;AAEA;IACI,mDAAmD;IACnD;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oDAAoD;IACpD,uDAAuD;IACvD,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kDAAkD;IAClD,qDAAqD;IACrD;AACJ;;AAEA;IACI,mDAAmD;IACnD,sDAAsD;IACtD;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,mCAAmC;IACnC,4BAA4B;IAC5B,2DAA2D;IAC3D,gBAAgB;IAChB,sCAAsC;IACtC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,wCAAwC;IACxC;AACJ;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,uCAAuC;IACvC,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,+CAA+C;IAC/C,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,kCAAkC;IAClC,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI,mEAAmE;IACnE,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB;AACJ;;AAEA;IACI,iEAAiE;IACjE,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,gEAAgE;IAChE;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gEAAuP;IACvP,cAAc;IACd,WAAW;IACX,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,mCAAmC;IACnC,mFAAmF;IACnF,4BAA4B;IAC5B,wCAAwC;IACxC,0BAA0B;IAC1B,2DAA2D;IAC3D,sCAAsC;IACtC,sEAAsE;IACtE;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB;AACJ;;AAEA;IACI,qCAAqC;IACrC,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,+CAA+C;IAC/C,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,2DAA2D;IAC3D,gBAAgB;IAChB,iCAAwB;YAAxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4DAA2K;IAC3K,UAAU;IACV,mBAAmB;IACnB,0CAA0C;IAC1C,gCAAgC;IAChC,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,iHAAyG;IAAzG,yGAAyG;IACzG;AACJ;;AAEA;IACI;QACI,wBAAe;QAAf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,uCAAuC;IACvC,8BAA8B;IAC9B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,8GAAyG;IAAzG,yGAAyG;IACzG;AACJ;;AAEA;IACI;QACI,qBAAe;QAAf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,uCAAuC;IACvC,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,uDAAuD;IACvD,2DAA2D;IAC3D;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,qDAAqD;IACrD,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;;;IAII,2CAA2C;IAC3C;AACJ;;AAEA;;;;IAII,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,WAAW;IACX,mCAAmC;IACnC;AACJ;;AAEA;IACI,2CAA2C;IAC3C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB;AACJ;;AAEA;;;IAGI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,2DAA2D;IAC3D;AACJ;;AAEA;;;;IAII,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;;;;IAII,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII,0BAA0B;IAC1B;AACJ;;AAEA;;;;IAII,0BAA0B;IAC1B;AACJ;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,mCAAmC;IACnC;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,+CAA+C;IAC/C,oCAAoC;IACpC,yDAA2P;IAC3P,4BAA4B;IAC5B,2DAA2D;IAC3D;AACJ;;AAEA;;IAEI,+CAA+C;IAC/C;AACJ;;AAEA;;IAEI,oCAAoC;IACpC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII,iEAAmQ;IACnQ,uBAAuB;IACvB,8DAA8D;IAC9D;AACJ;;AAEA;;IAEI,+CAA+C;IAC/C;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,kCAAkC;IAClC;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,iDAAiD;IACjD,oCAAoC;IACpC,0DAA4U;IAC5U,4BAA4B;IAC5B,2DAA2D;IAC3D;AACJ;;AAEA;;IAEI,iDAAiD;IACjD;AACJ;;AAEA;;IAEI,oCAAoC;IACpC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII,kEAAoV;IACpV,uBAAuB;IACvB,8DAA8D;IAC9D;AACJ;;AAEA;;IAEI,iDAAiD;IACjD;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,oCAAoC;IACpC,wBAAwB;IACxB,6CAA6C;IAC7C,kCAAkC;IAClC,+CAA+C;IAC/C,wCAAwC;IACxC,4FAA4F;IAC5F,+BAA+B;IAC/B,8EAA8E;IAC9E,qBAAqB;IACrB,wDAAwD;IACxD,sCAAsC;IACtC,kCAAkC;IAClC,sCAAsC;IACtC,sCAAsC;IACtC,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,mEAAmE;IACnE,0CAA0C;IAC1C,kCAAkC;IAClC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC;AACJ;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,8CAA8C;IAC9C,UAAU;IACV;AACJ;;AAEA;IACI,8CAA8C;IAC9C,UAAU;IACV;AACJ;;AAEA;;;;;IAKI,iCAAiC;IACjC,yCAAyC;IACzC;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;IAGI,mCAAmC;IACnC,oBAAoB;IACpB,2CAA2C;IAC3C,iDAAiD;IACjD;AACJ;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,wCAAwC;IACxC,0BAA0B;IAC1B,oCAAoC;IACpC,8CAA8C;;IAE9C,wCAAwC;IACxC,2BAA2B;IAC3B,qCAAqC;;IAErC,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B;AACJ;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B;AACJ;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B;AACJ;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B;AACJ;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,2BAA2B;IAC3B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,wCAAwC;IACxC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,0BAA0B;IAC1B;AACJ;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;IAC3B,qCAAqC;IACrC,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,oCAAoC;IACpC;AACJ;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,wCAAwC;IACxC,0BAA0B;IAC1B,oCAAoC;IACpC,8CAA8C;IAC9C,wCAAwC;IACxC,2BAA2B;IAC3B,qCAAqC;IACrC,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;IACvC;AACJ;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC;AACJ;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC;AACJ;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC;AACJ;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC;AACJ;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC;AACJ;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,iCAAiC;IACjC,wCAAwC;IACxC,2BAA2B;IAC3B,wBAAwB;IACxB,kCAAkC;IAClC,4DAA4D;IAC5D,6BAA6B;IAC7B,iCAAiC;IACjC,oCAAoC;IACpC;AACJ;;AAEA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,0BAA0B;IAC1B,iCAAiC;IACjC,2CAA2C;IAC3C,sCAAsC;IACtC,2BAA2B;IAC3B,kCAAkC;IAClC,4CAA4C;IAC5C,4DAA4D;IAC5D,uCAAuC;IACvC,iCAAiC;IACjC,8CAA8C;IAC9C;AACJ;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,wBAAwB;IACxB,kCAAkC;IAClC,gDAAgD;IAChD,wCAAwC;IACxC,iDAAiD;IACjD,yCAAyC;IACzC,gCAAgC;IAChC,2CAA2C;IAC3C,+BAA+B;IAC/B,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B,wBAAwB;IACxB,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,yCAAyC;IACzC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,yCAAyC;IACzC,mCAAmC;IACnC,8DAA8D;IAC9D,oDAAoD;IACpD,kDAAkD;IAClD,yFAAyF;IACzF,4DAA4D;IAC5D,sCAAsC;IACtC,2DAA2D;IAC3D,8CAA8C;IAC9C,oDAAoD;IACpD,kDAAkD;IAClD,qCAAqC;IACrC,qCAAqC;IACrC,2DAA2D;IAC3D,kCAAkC;IAClC,qCAAqC;IACrC,mCAAmC;IACnC,oCAAoC;IACpC,sCAAsC;IACtC,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;IACb,uCAAuC;IACvC,kEAAkE;IAClE,SAAS;IACT,uCAAuC;IACvC,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,uCAAuC;IACvC,4BAA4B;IAC5B,6EAA6E;IAC7E;AACJ;;AAEA;IACI,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,yCAAyC;IACzC,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,uCAAuC;IACvC,eAAe;IACf,0CAA0C;IAC1C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;IACX,uCAAuC;IACvC,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,6CAA6C;IAC7C,gBAAgB;IAChB,mDAAmD;IACnD;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,4EAA4E;IAC5E,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,kCAAkC;IAClC,SAAS;IACT;AACJ;;AAEA;;IAEI,0CAA0C;IAC1C;AACJ;;AAEA;;IAEI,2CAA2C;IAC3C,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,6CAA6C;IAC7C,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,gFAAgF;IAChF,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC;AACJ;;AAEA;IACI,cAAc;IACd,4EAA4E;IAC5E;AACJ;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,8DAA8D;IAC9D,0BAA0B;IAC1B,iCAAiC;IACjC,oCAAoC;IACpC,4DAA4D;IAC5D,sDAAsD;IACtD,qCAAqC;IACrC,qCAAqC;IACrC,0CAA0C;IAC1C;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI,0BAA0B;IAC1B;AACJ;;AAEA;;;IAGI,yBAAyB;IACzB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,2BAA2B;IAC3B,yCAAyC;IACzC,qDAAqD;IACrD,uDAAuD;IACvD,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,kEAAkE;IAClE,uCAAuC;IACvC,2CAA2C;IAC3C,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;IACpB;AACJ;;AAEA;IACI,kDAAkD;IAClD,kDAAkD;IAClD,oDAAoD;IACpD,2GAA2G;IAC3G,yDAAyD;IACzD,+CAA+C;IAC/C,uGAAuG;IACvG;AACJ;;AAEA;IACI,uDAAuD;IACvD,8DAA8D;IAC9D,wDAAwD;IACxD;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,wCAAwC;IACxC,kCAAkC;IAClC;AACJ;;AAEA;;IAEI,2CAA2C;IAC3C,mDAAmD;IACnD;AACJ;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;IACzB;AACJ;;AAEA;IACI,qDAAqD;IACrD,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC,kCAAkC;IAClC;AACJ;;AAEA;;IAEI,4CAA4C;IAC5C;AACJ;;AAEA;IACI,4BAA4B;IAC5B,yCAAyC;IACzC,8DAA8D;IAC9D;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,gDAAgD;IAChD;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,2DAA2D;IAC3D,gEAAgE;IAChE,mEAAmE;IACnE,+DAA+D;IAC/D,sCAAsC;IACtC,kCAAkC;IAClC,oCAAoC;IACpC,8DAA8D;IAC9D,oEAAoE;IACpE,sCAAsC;IACtC,sCAAsC;IACtC,sCAAsC;IACtC,sCAAsC;IACtC,qEAA0Q;IAC1Q,0EAA0E;IAC1E,0DAA0D;IAC1D,qCAAqC;IACrC,4DAA4D;IAC5D,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B;AACJ;;AAEA;;;;;;IAMI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,6CAA6C;IAC7C,gDAAgD;IAChD,+CAA+C;IAC/C,2CAA2C;IAC3C,mCAAmC;IACnC,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,2BAA2B;IAC3B,2CAA2C;IAC3C,uDAAuD;IACvD,6DAA6D;IAC7D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,8EAA8E;IAC9E,6CAA6C;IAC7C,cAAc;IACd,6BAA6B;IAC7B,kCAAkC;IAClC,0EAA0E;IAC1E,qDAAqD;IACrD;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kDAAkD;IAClD,4BAA4B;IAC5B,2BAA2B;IAC3B;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kDAAkD;QAClD;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,6CAA6C;QAC7C,oBAAoB;QACpB,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kDAAkD;QAClD;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,6CAA6C;QAC7C,oBAAoB;QACpB,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kDAAkD;QAClD;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,6CAA6C;QAC7C,oBAAoB;QACpB,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kDAAkD;QAClD;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,6CAA6C;QAC7C,oBAAoB;QACpB,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kDAAkD;QAClD;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,6CAA6C;QAC7C,oBAAoB;QACpB,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kDAAkD;IAClD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,6CAA6C;IAC7C,oBAAoB;IACpB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;;IAEI,4CAA4C;IAC5C,kDAAkD;IAClD,qDAAqD;IACrD,8BAA8B;IAC9B,6BAA6B;IAC7B,mCAAmC;IACnC,0DAA0D;IAC1D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,gCAAgC;IAChC,uBAAuB;IACvB,0BAA0B;IAC1B,8CAA8C;IAC9C,0DAA0D;IAC1D,gDAAgD;IAChD,sBAAsB;IACtB,uFAAuF;IACvF,+BAA+B;IAC/B,6BAA6B;IAC7B,sDAAsD;IACtD,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,mCAAmC;IACnC,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,6BAA6B;IAC7B,2BAA2B;IAC3B,qBAAqB;IACrB,mCAAmC;IACnC,2BAA2B;IAC3B,qEAAqE;IACrE;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,0DAA0D;IAC1D;AACJ;;AAEA;IACI,sBAAsB;IACtB,8DAA8D;IAC9D;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,wDAAwD;IACxD;AACJ;;AAEA;IACI,4CAA4C;IAC5C;AACJ;;AAEA;IACI,oDAAoD;IACpD,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kEAAkE;IAClE,gBAAgB;IAChB,+BAA+B;IAC/B,uCAAuC;IACvC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kEAAkE;IAClE,+BAA+B;IAC/B,uCAAuC;IACvC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qDAAqD;IACrD,oDAAoD;IACpD,oDAAoD;IACpD;AACJ;;AAEA;IACI,mCAAmC;IACnC;AACJ;;AAEA;IACI,qDAAqD;IACrD;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,2CAA2C;IAC3C;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI,0DAA0D;IAC1D;AACJ;;AAEA;;IAEI,8DAA8D;IAC9D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QACI,SAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI,0CAA0C;IAC1C,oCAAoC;IACpC,8KAA8K;IAC9K,mDAAmD;IACnD,mDAAmD;IACnD,qDAAqD;IACrD,4FAA4F;IAC5F,qCAAqC;IACrC,kCAAkC;IAClC,8CAA8C;IAC9C,6CAA6C;IAC7C,iEAAqS;IACrS,sCAAsC;IACtC,kDAAkD;IAClD,8DAA8D;IAC9D,wEAA+S;IAC/S,8CAA8C;IAC9C,0EAA0E;IAC1E,sCAAsC;IACtC,mCAAmC;IACnC,4DAA4D;IAC5D;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,4EAA4E;IAC5E,eAAe;IACf,oCAAoC;IACpC,gBAAgB;IAChB,4CAA4C;IAC5C,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;IAC/C;AACJ;;AAEA;IACI,qDAAqD;IACrD;AACJ;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,0CAA0C;IAC1C,iBAAiB;IACjB,WAAW;IACX,8CAA8C;IAC9C,4BAA4B;IAC5B,mDAAmD;IACnD;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,wDAAwD;IACxD,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC;AACJ;;AAEA;IACI,yDAAyD;IACzD;AACJ;;AAEA;IACI,+DAA+D;IAC/D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6DAA6D;IAC7D;AACJ;;AAEA;IACI,mEAAmE;IACnE;AACJ;;AAEA;IACI,6DAA6D;IAC7D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,iEAAwS;IACxS;AACJ;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,mCAAmC;IACnC,oBAAoB;IACpB,+BAA+B;IAC/B,wDAAwD;IACxD,sCAAsC;IACtC,4DAA4D;IAC5D,aAAa;IACb,eAAe;IACf,sEAAsE;IACtE,iDAAiD;IACjD,yCAAyC;IACzC,gBAAgB;IAChB,yCAAyC;IACzC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kDAAkD;IAClD,yCAAyC;IACzC,yCAAyC;QACrC,2CAA2C;AACnD;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,+BAA+B;IAC/B,2CAA2C;IAC3C,qCAAqC;IACrC,oDAAoD;IACpD,oDAAoD;IACpD,sDAAsD;IACtD,uDAAuD;IACvD,+CAA+C;IAC/C,0DAA0D;IAC1D,uDAAuD;IACvD,gDAAgD;IAChD,uEAAuE;IACvE,kCAAkC;IAClC,kCAAkC;IAClC,4CAA4C;IAC5C,yDAAyD;IACzD,mDAAmD;IACnD,6DAA6D;IAC7D,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sEAAsE;IACtE,yCAAyC;IACzC,iCAAiC;IACjC,8BAA8B;IAC9B,qBAAqB;IACrB,yCAAyC;IACzC,iFAAiF;IACjF;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,uCAAuC;IACvC,+CAA+C;IAC/C;AACJ;;AAEA;IACI,UAAU;IACV,uCAAuC;IACvC,+CAA+C;IAC/C,UAAU;IACV;AACJ;;AAEA;;IAEI,UAAU;IACV,wCAAwC;IACxC,gDAAgD;IAChD;AACJ;;AAEA;;IAEI,0CAA0C;IAC1C,oBAAoB;IACpB,kDAAkD;IAClD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0DAA0D;IAC1D;AACJ;;AAEA;IACI,2DAA2D;IAC3D;AACJ;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,kCAAkC;IAClC;AACJ;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,mCAAmC;IACnC;AACJ;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,iDAAiD;IACjD,qBAAqB;IACrB,4DAA4D;IAC5D,oCAAoC;IACpC,wCAAwC;IACxC,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,8BAA8B;IAC9B,yBAAyB;IACzB,oCAAoC;IACpC,4EAA4E;IAC5E,iDAAiD;IACjD,8BAA8B;IAC9B,kBAAkB;IAClB,4DAA4D;IAC5D,4CAA4C;IAC5C,4BAA4B;IAC5B,oCAAoC;IACpC,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV;AACJ;;AAEA;IACI,iDAAiD;IACjD,0CAA0C;IAC1C,wDAAwD;IACxD;AACJ;;AAEA;IACI,mDAAmD;IACnD,4CAA4C;IAC5C,0DAA0D;IAC1D;AACJ;;AAEA;IACI,iDAAiD;IACjD,0CAA0C;IAC1C,wDAAwD;IACxD;AACJ;;AAEA;IACI,8CAA8C;IAC9C,uCAAuC;IACvC,qDAAqD;IACrD;AACJ;;AAEA;IACI,iDAAiD;IACjD,0CAA0C;IAC1C,wDAAwD;IACxD;AACJ;;AAEA;IACI,gDAAgD;IAChD,yCAAyC;IACzC,uDAAuD;IACvD;AACJ;;AAEA;IACI,+CAA+C;IAC/C,wCAAwC;IACxC,sDAAsD;IACtD;AACJ;;AAEA;IACI,8CAA8C;IAC9C,uCAAuC;IACvC,qDAAqD;IACrD;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B,gCAAgC;IAChC,wCAAwC;IACxC,oDAAoD;IACpD,oDAAoD;IACpD,6BAA6B;IAC7B,6BAA6B;IAC7B,6CAA6C;IAC7C,aAAa;IACb,iCAAiC;IACjC,gBAAgB;IAChB,uCAAuC;IACvC,uCAAuC;IACvC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qMAAqM;IACrM;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,2CAA2C;IAC3C,qCAAqC;IACrC,oDAAoD;IACpD,oDAAoD;IACpD,sDAAsD;IACtD,oCAAoC;IACpC,sCAAsC;IACtC,uDAAuD;IACvD,4DAA4D;IAC5D,sDAAsD;IACtD,yDAAyD;IACzD,wDAAwD;IACxD,yDAAyD;IACzD,8CAA8C;IAC9C,kCAAkC;IAClC,kCAAkC;IAClC,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC;AACJ;;AAEA;;IAEI,UAAU;IACV,8CAA8C;IAC9C,qBAAqB;IACrB;AACJ;;AAEA;IACI,+CAA+C;IAC/C;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gFAAgF;IAChF,iCAAiC;IACjC,qBAAqB;IACrB,yCAAyC;IACzC;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,mCAAmC;IACnC;AACJ;;AAEA;;IAEI,0CAA0C;IAC1C,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,wCAAwC;IACxC,gDAAgD;IAChD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sDAAsD;IACtD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6DAA6D;IAC7D;AACJ;;AAEA;IACI,2DAA2D;IAC3D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mDAAmD;IACnD;AACJ;;AAEA;IACI,uDAAuD;IACvD;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,6DAA6D;QAC7D;IACJ;;IAEA;QACI,2DAA2D;QAC3D;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mDAAmD;QACnD;IACJ;;IAEA;QACI,uDAAuD;QACvD;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,6DAA6D;QAC7D;IACJ;;IAEA;QACI,2DAA2D;QAC3D;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mDAAmD;QACnD;IACJ;;IAEA;QACI,uDAAuD;QACvD;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,6DAA6D;QAC7D;IACJ;;IAEA;QACI,2DAA2D;QAC3D;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mDAAmD;QACnD;IACJ;;IAEA;QACI,uDAAuD;QACvD;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,6DAA6D;QAC7D;IACJ;;IAEA;QACI,2DAA2D;QAC3D;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mDAAmD;QACnD;IACJ;;IAEA;QACI,uDAAuD;QACvD;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,6DAA6D;QAC7D;IACJ;;IAEA;QACI,2DAA2D;QAC3D;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mDAAmD;QACnD;IACJ;;IAEA;QACI,uDAAuD;QACvD;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sDAAsD;IACtD,+CAA+C;IAC/C,6DAA6D;IAC7D,4DAA4D;IAC5D,gEAAgE;IAChE,6DAA6D;IAC7D,iEAAiE;IACjE,yDAAyD;IACzD,0DAA0D;IAC1D;AACJ;;AAEA;IACI,wDAAwD;IACxD,iDAAiD;IACjD,+DAA+D;IAC/D,4DAA4D;IAC5D,kEAAkE;IAClE,6DAA6D;IAC7D,mEAAmE;IACnE,2DAA2D;IAC3D,4DAA4D;IAC5D;AACJ;;AAEA;IACI,sDAAsD;IACtD,+CAA+C;IAC/C,6DAA6D;IAC7D,4DAA4D;IAC5D,gEAAgE;IAChE,6DAA6D;IAC7D,iEAAiE;IACjE,yDAAyD;IACzD,0DAA0D;IAC1D;AACJ;;AAEA;IACI,mDAAmD;IACnD,4CAA4C;IAC5C,0DAA0D;IAC1D,4DAA4D;IAC5D,6DAA6D;IAC7D,6DAA6D;IAC7D,8DAA8D;IAC9D,sDAAsD;IACtD,uDAAuD;IACvD;AACJ;;AAEA;IACI,sDAAsD;IACtD,+CAA+C;IAC/C,6DAA6D;IAC7D,4DAA4D;IAC5D,gEAAgE;IAChE,6DAA6D;IAC7D,iEAAiE;IACjE,yDAAyD;IACzD,0DAA0D;IAC1D;AACJ;;AAEA;IACI,qDAAqD;IACrD,8CAA8C;IAC9C,4DAA4D;IAC5D,4DAA4D;IAC5D,+DAA+D;IAC/D,6DAA6D;IAC7D,gEAAgE;IAChE,wDAAwD;IACxD,yDAAyD;IACzD;AACJ;;AAEA;IACI,oDAAoD;IACpD,6CAA6C;IAC7C,2DAA2D;IAC3D,4DAA4D;IAC5D,8DAA8D;IAC9D,6DAA6D;IAC7D,+DAA+D;IAC/D,uDAAuD;IACvD,wDAAwD;IACxD;AACJ;;AAEA;IACI,mDAAmD;IACnD,4CAA4C;IAC5C,0DAA0D;IAC1D,4DAA4D;IAC5D,6DAA6D;IAC7D,6DAA6D;IAC7D,8DAA8D;IAC9D,sDAAsD;IACtD,uDAAuD;IACvD;AACJ;;AAEA;IACI,0BAA0B;IAC1B,2DAAoV;IACpV,2BAA2B;IAC3B,kCAAkC;IAClC,kEAAkE;IAClE,+BAA+B;IAC/B,qCAAqC;IACrC,uEAAuE;IACvE,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,gCAAgC;IAChC,6EAA6E;IAC7E,SAAS;IACT,sBAAsB;IACtB;AACJ;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,4CAA4C;IAC5C;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;IAClB,gDAAgD;IAChD,+CAA+C;IAC/C,2DAA2D;IAC3D,iDAAiD;IACjD,2CAA2C;IAC3C,kDAAkD;IAClD,uDAAuD;IACvD,kEAAkE;IAClE,gCAAgC;IAChC,eAAe;IACf,oCAAoC;IACpC,4BAA4B;IAC5B,oBAAoB;IACpB,oCAAoC;IACpC,4BAA4B;IAC5B,uEAAuE;IACvE,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4DAA4D;IAC5D,mCAAmC;IACnC,2CAA2C;IAC3C,4BAA4B;IAC5B,qFAAqF;IACrF,0FAA0F;IAC1F;AACJ;;AAEA;IACI,kDAAkD;IAClD;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,2DAA2D;IAC3D,+CAA+C;IAC/C,oDAAoD;IACpD,8DAA8D;IAC9D,2FAA2F;IAC3F,iCAAiC;IACjC,iCAAiC;IACjC,oCAAoC;IACpC,sDAAsD;IACtD,sDAAsD;IACtD,iCAAiC;IACjC,6BAA6B;IAC7B,sBAAsB;IACtB,sDAAsD;IACtD,sDAAsD;IACtD,eAAe;IACf,MAAM;IACN,OAAO;IACP,+BAA+B;IAC/B,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,4BAA4B;IAC5B,oBAAoB;IACpB,oCAAoC;IACpC,4BAA4B;IAC5B,uEAAuE;IACvE,4CAA4C;IAC5C;AACJ;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;IACf,MAAM;IACN,OAAO;IACP,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,8BAA8B;IAC9B,uCAAuC;IACvC,4FAA4F;IAC5F,2DAA2D;IAC3D;AACJ;;AAEA;IACI,4FAA4F;IAC5F;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,sEAAsE;IACtE,2CAA2C;IAC3C,yFAAyF;IACzF,+DAA+D;IAC/D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,gCAAgC;QAChC,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;IAC/B,qBAAqB;IACrB,gCAAgC;IAChC,qCAAqC;IACrC,yCAAyC;IACzC,mDAAmD;IACnD,yBAAyB;IACzB,gCAAgC;IAChC,iCAAiC;IACjC,iCAAiC;IACjC,cAAc;IACd,gCAAgC;IAChC,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,sCAAsC;IACtC,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,SAAS;IACT,qFAAqF;IACrF;AACJ;;AAEA;;IAEI,6CAA6C;IAC7C,qCAAqC;IACrC;AACJ;;AAEA;;IAEI,WAAW;IACX,4HAA4H;IAC5H;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,YAAY;IACZ,qFAAqF;IACrF;AACJ;;AAEA;;IAEI,8CAA8C;IAC9C,qCAAqC;IACrC;AACJ;;AAEA;;IAEI,UAAU;IACV,4HAA4H;IAC5H;AACJ;;AAEA;IACI,sCAAsC;IACtC,gEAAgE;IAChE,8BAA8B;IAC9B,kBAAkB;IAClB,sCAAsC;IACtC;AACJ;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,gCAAgC;IAChC,kCAAkC;IAClC,iDAAiD;IACjD,6DAA6D;IAC7D,sDAAsD;IACtD,2FAA2F;IAC3F,0DAA0D;IAC1D,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,kCAAkC;IAClC,8CAA8C;IAC9C,iCAAiC;IACjC,iCAAiC;IACjC,6CAA6C;IAC7C,8BAA8B;IAC9B,iCAAiC;IACjC,yDAAyD;IACzD,iCAAiC;IACjC,cAAc;IACd,sCAAsC;IACtC,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,sCAAsC;IACtC,qBAAqB;IACrB,sCAAsC;IACtC,4BAA4B;IAC5B,2EAA2E;IAC3E;AACJ;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,SAAS;IACT;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI,gFAAgF;IAChF,qCAAqC;IACrC;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,OAAO;IACP;AACJ;;AAEA;;IAEI,oCAAoC;IACpC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,MAAM;IACN;AACJ;;AAEA;;IAEI,mCAAmC;IACnC;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;IACd,oCAAoC;IACpC,qDAAqD;IACrD,WAAW;IACX;AACJ;;AAEA;;IAEI,iFAAiF;IACjF,qCAAqC;IACrC;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,QAAQ;IACR;AACJ;;AAEA;;IAEI,qCAAqC;IACrC;AACJ;;AAEA;IACI,8EAA8E;IAC9E,gBAAgB;IAChB,6CAA6C;IAC7C,qCAAqC;IACrC,6CAA6C;IAC7C,kFAAkF;IAClF,6DAA6D;IAC7D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0EAA0E;IAC1E;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B;AACJ;;AAEA;;;IAGI,UAAU;IACV;AACJ;;AAEA;;IAEI,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;;;IAII,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,SAAS;IACT,uCAAuC;IACvC,0CAA0C;IAC1C,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,8BAA8B;IAC9B,gCAAgC;IAChC,gDAAgD;IAChD,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,wBAAwB;YACpB,eAAe;IACvB;AACJ;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,qCAAqC;IACrC,iCAAiC;IACjC,mCAAmC;IACnC,2CAA2C;IAC3C,yDAAyD;IACzD;AACJ;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,qCAAqC;IACrC,mCAAmC;IACnC,yCAAyC;IACzC,8BAA8B;IAC9B;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;;;;;IAMI,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;IAC9B,0CAA0C;IAC1C,oCAAoC;IACpC,mDAAmD;IACnD,+DAA+D;IAC/D,kEAAkE;IAClE,qDAAqD;IACrD;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC,qFAAqF;QACrF;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,oFAAoF;QACpF;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,sFAAsF;QACtF;IACJ;;IAEA;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,mFAAmF;QACnF;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI;IACJ;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC,qFAAqF;QACrF;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,oFAAoF;QACpF;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,sFAAsF;QACtF;IACJ;;IAEA;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,mFAAmF;QACnF;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI;IACJ;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC,qFAAqF;QACrF;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,oFAAoF;QACpF;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,sFAAsF;QACtF;IACJ;;IAEA;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,mFAAmF;QACnF;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI;IACJ;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC,qFAAqF;QACrF;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,oFAAoF;QACpF;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,sFAAsF;QACtF;IACJ;;IAEA;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,mFAAmF;QACnF;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI;IACJ;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC,qFAAqF;QACrF;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,oFAAoF;QACpF;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,sFAAsF;QACtF;IACJ;;IAEA;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,mFAAmF;QACnF;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI;IACJ;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,wCAAwC;IACxC,4BAA4B;IAC5B,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,MAAM;IACN,OAAO;IACP,gCAAgC;IAChC,qFAAqF;IACrF;AACJ;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,gCAAgC;IAChC,oFAAoF;IACpF;AACJ;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,OAAO;IACP,kCAAkC;IAClC,gBAAgB;IAChB,sFAAsF;IACtF;AACJ;;AAEA;IACI,QAAQ;IACR,OAAO;IACP,kCAAkC;IAClC,gBAAgB;IAChB,mFAAmF;IACnF;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,sFAAsF;IACtF,oDAAoD;IACpD,sDAAsD;IACtD;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,oEAAoE;IACpE;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;IAC9B;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,+EAA+E;IAC/E,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,wEAAwE;IACxE;AACJ;;AAEA;;IAEI,8DAA8D;IAC9D;AACJ;;AAEA;IACI,0EAA0E;IAC1E;AACJ;;AAEA;;IAEI,+DAA+D;IAC/D;AACJ;;AAEA;IACI,wEAAwE;IACxE;AACJ;;AAEA;;IAEI,+DAA+D;IAC/D;AACJ;;AAEA;IACI,qEAAqE;IACrE;AACJ;;AAEA;;IAEI,8DAA8D;IAC9D;AACJ;;AAEA;IACI,wEAAwE;IACxE;AACJ;;AAEA;;IAEI,+DAA+D;IAC/D;AACJ;;AAEA;IACI,uEAAuE;IACvE;AACJ;;AAEA;;IAEI,+DAA+D;IAC/D;AACJ;;AAEA;IACI,sEAAsE;IACtE;AACJ;;AAEA;;IAEI,gEAAgE;IAChE;AACJ;;AAEA;IACI,qEAAqE;IACrE;AACJ;;AAEA;;IAEI,6DAA6D;IAC7D;AACJ;;AAEA;IACI,+EAA+E;IAC/E;AACJ;;AAEA;;IAEI,kFAAkF;IAClF;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;IACnB,kFAAkF;IAClF,4BAA4B;IAC5B;AACJ;;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP;AACJ;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,4EAA4E;AAChF;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mCAA0B;YAA1B;AACJ;;AAEA;IACI,oCAA2B;YAA3B;AACJ;;AAEA;IACI,oCAA2B;YAA3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0DAA0D;IAC1D;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,6DAA6D;IAC7D;AACJ;;AAEA;IACI,0DAA0D;IAC1D;AACJ;;AAEA;IACI,6DAA6D;IAC7D;AACJ;;AAEA;IACI,6DAA6D;IAC7D;AACJ;;AAEA;IACI,8DAA8D;IAC9D;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI,+DAA+D;IAC/D;AACJ;;AAEA;IACI,2DAA2D;IAC3D;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI,8DAA8D;IAC9D;AACJ;;AAEA;IACI,2DAA2D;IAC3D;AACJ;;AAEA;IACI,8DAA8D;IAC9D;AACJ;;AAEA;IACI,8DAA8D;IAC9D;AACJ;;AAEA;IACI,+DAA+D;IAC/D;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,gEAAgE;IAChE;AACJ;;AAEA;IACI,8DAA8D;IAC9D;AACJ;;AAEA;IACI,wCAAwC;IACxC;AACJ;;AAEA;IACI,iEAAiE;IACjE;AACJ;;AAEA;IACI,8DAA8D;IAC9D;AACJ;;AAEA;IACI,iEAAiE;IACjE;AACJ;;AAEA;IACI,iEAAiE;IACjE;AACJ;;AAEA;IACI,kEAAkE;IAClE;AACJ;;AAEA;IACI,0CAA0C;IAC1C;AACJ;;AAEA;IACI,mEAAmE;IACnE;AACJ;;AAEA;IACI,6DAA6D;IAC7D;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,gEAAgE;IAChE;AACJ;;AAEA;IACI,6DAA6D;IAC7D;AACJ;;AAEA;IACI,gEAAgE;IAChE;AACJ;;AAEA;IACI,gEAAgE;IAChE;AACJ;;AAEA;IACI,iEAAiE;IACjE;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI,kEAAkE;IAClE;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;;;;;;;;;;;IAYI,qCAAqC;IACrC,qBAAqB;IACrB;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;;;IAGI,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;;;IAGI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;;;;;QAKI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;AACJ;;AAEA;;IAEI;;;;;QAKI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,QAAQ;IACR,OAAO;IACP,gDAAgD;IAChD,mDAAmD;IACnD,oDAAoD;IACpD,wDAAwD;IACxD,qDAAqD;IACrD;AACJ;;AAEA;IACI,SAAS;IACT,OAAO;IACP,gDAAgD;IAChD,mDAAmD;IACnD,oDAAoD;IACpD,wDAAwD;IACxD,qDAAqD;IACrD;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,kDAAkD;IAClD,qDAAqD;IACrD,sDAAsD;IACtD,0DAA0D;IAC1D,uDAAuD;IACvD;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AA0CA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AA0CA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AA0CA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAYA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;;IAII,eAAe;IACf;AACJ;;AAEA;;IAEI,iBAAiB;IACjB;AACJ;;AAEA;;;;IAII,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;;;IAII,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;;;IAII,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;;;IAII,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,0DAAgD;IAChD,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;GAKG;;;;AAIH;IACI,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;;IAGI,uBAAuB;IACvB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;AAC/B;;;;AAIA;IACI,wBAAwB;IACxB,2BAA2B;;AAE/B;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;IACtB,0DAAqsB;AACzsB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;;AAEpB;;;AAGA;;;IAGI,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;;;;;;;;;;;;GAYG;;AAEH;IACI,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI,OAAO;IACP;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,UAAU;AACd;;AAEA;IACI,wDAAwD;IACxD,qCAAqC;IACrC,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,4BAA4B;IAC5B,UAAU;IACV,uBAAuB;IACvB;AACJ;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;GAEG;;AAEH;IACI,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,oCAAoC;QACpC,kBAAkB;IACtB;AACJ;;AAEA;IACI;;OAEG;AACP;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,cAAc;QACd;IACJ;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,6BAA6B;IAC7B,SAAS;IACT,kBAAkB;IAGlB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,WAAW;IACX,YAAY;IAGZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uCAAuC;IACvC;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;IAChD;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,4BAA4B;IAC5B,qBAAqB;;AAEzB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAUA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,WAAW;IACX;AACJ;;AAEA;;;IAGI,2BAA2B;IAC3B,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,iCAAiC;IACjC;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;IACX;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,0DAA0D;IAC1D,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,wBAAwB;IACxB,oBAAoB;IACpB,WAAW;IACX,gCAAgC;IAChC,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6CAA6C;IAC7C,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,OAAO;IACP,oDAA6e;IAC7e,4BAA4B;IAC5B,sBAAsB;IACtB,wBAAwB;IACxB;AACJ;;AAEA;IACI,QAAQ;IACR,oDAA6e;IAC7e,4BAA4B;IAC5B,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,SAAS;IACT,eAAe;IACf,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IAGf,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;GAEG;;AAEH;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iDAAiD;IACjD,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,WAAW;IACX,gBAAgB;IAGhB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IAKjB;AACJ;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,UAAU;IAKV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,MAAM;IACN;AACJ;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX;AACJ;;AAEA;;;;;IAKI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI,YAAY;IACZ;AACJ;;AAEA;;;;;IAKI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,WAAW;IAGX;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,4BAA4B;IAC5B,UAAU;IACV,gBAAgB;IAChB,mDAAmD;IACnD,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,2CAA2C;IAC3C,0DAAuD;IACvD,4BAA4B;IAC5B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;;IAII;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAGlB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAKI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;;AAGA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,mDAAmD;IACnD,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,mDAAmD;IACnD,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IAGtB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;IAGX;AACJ;;AAEA;IACI,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IAGzB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP;AACJ;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;IAC3C;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;;;;;;;;;;;;;IAaI;AACJ;;AAEA;;;;;;;;;;;;;IAaI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA8EI,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAKI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII,mBAAmB;AACvB;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,kBAAkB;IAGlB;AACJ;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,6BAA6B;IAC7B,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,6BAA6B;IAC7B,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,mCAAmC;IACnC,qCAAqC;IACrC,wCAAwC;IACxC,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,6BAA6B;IAC7B,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,mCAAmC;IACnC,qCAAqC;IACrC,wCAAwC;IACxC,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mDAAmD;IAGnD,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,OAAO;IACP,MAAM;IACN,kBAAkB;IAClB,yBAAyB;IAGzB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;IAC/B,6CAA6C;IAC7C,gCAAgC;IAChC,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,SAAS;IACT,SAAS;IAGT,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,SAAS;IACT,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;QACV,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;QACV,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;QACV,WAAW;QACX,YAAY;IAChB;AACJ;;;AAGA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,QAAQ;QACR,WAAW;QACX,WAAW;;IAEf;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;IACI,OAAO;IACP;AACJ;;AAEA;IACI;QACI,OAAO;QACP;IACJ;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;IACI;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;IAC5C,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,WAAW;IACX,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,wBAAwB;IACxB,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,MAAM;IACN,gBAAgB;IAChB,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,wBAAwB;IACxB,wBAAwB;IACxB,uBAAuB;IACvB;AACJ;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,MAAM;IACN;AACJ;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,OAAO;IACP,MAAM;IACN,UAAU;IACV,mBAAmB;IACnB,wBAAwB;IACxB,wBAAwB;IACxB,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,MAAM;IACN;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,4BAA4B;IAC5B,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;IACd,cAAc;IACd,6BAA6B;IAC7B,uCAAuC;IAGvC;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;IAGI,eAAe;IACf;AACJ;;AAEA;;;IAGI,eAAe;IACf;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,aAAa;IACb;AACJ;;AAEA;;;;IAII,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,OAAO;IACP,SAAS;IACT,kBAAkB;IAClB,0DAAsD;IACtD,4BAA4B;IAC5B,gCAAgC;IAChC,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,0CAA0C;IAC1C,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;;QAEI,mBAAmB;QACnB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI,mBAAmB;QACnB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB;IACJ;;IAEA;;QAEI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI;QACI,UAAU;QACV,YAAY;QACZ,aAAa;QACb;IACJ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AAEA;IACI,kBAAkB;IAClB,mDAAmD;IACnD,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IAGtB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IAGX,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;IAC1B,yBAAyB;IACzB,6BAA6B;IAC7B;AACJ;;AAEA;IAGI,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;IAChC,6BAA6B;IAC7B;AACJ;;AAEA;IACI,mBAAmB;IAGnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,YAAY;IACZ,SAAS;IACT,SAAS;IACT,wBAAwB;IACxB,6BAA6B;IAC7B,4BAA4B;IAC5B,gCAAgC;IAChC,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,6BAA6B;IAC7B;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB;AACJ;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB;AACJ;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB;AACJ;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,iCAAiC;IACjC;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,iCAAiC;QACjC,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI,iCAAiC;QACjC,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,WAAW;QACX,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;;;;;QAKI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IAGrB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;;;IAGI;AACJ;;AAUA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,mDAAmD;IACnD,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,aAAa;QACb;IACJ;;IAEA;QACI,UAAU;QACV,WAAW;QACX;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB;IACJ;;IAEA;QACI,YAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI,UAAU;QACV,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IAEb;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb,YAAY;IAEZ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,aAAa;QACb;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IAEX;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IAEV;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,SAAS;IAET;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QACI,UAAU;QACV,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,UAAU;QACV,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,UAAU;QACV,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IAGnB,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;AAC5B;;;;AAIA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,4BAA4B;IAC5B,gBAAgB;;AAEpB;;;;AAIA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,mDAAmD;QACnD,yBAAyB;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAYA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAuCA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAYA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IAGnB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IAEI,oDAAyC;IAEzC,4BAA4B;IAE5B,sBAAsB;IAEtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAG3B,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,QAAQ;IACR;AACJ;;AAEA;IACI,0DAA+C;IAC/C;AACJ;;AAEA;IACI,0DAA+C;IAC/C;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAGlB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,gDAAgD;IAChD,UAAU;IACV;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yCAAyC;IACzC,kBAAkB;IAClB,8CAA8C;IAC9C,uCAAuC;IACvC,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IAGV,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;IACvC;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,mDAAmD;IACnD,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,mDAAmD;IACnD,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,6BAA6B;QAC7B,kBAAkB;IACtB;AACJ;;;AAGA;IACI,mBAAmB;IACnB,gDAAgD;IAChD,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI,qBAAqB;QACrB,0BAA0B;QAC1B,wBAAwB;QACxB,6BAA6B;QAC7B,qBAAqB;QACrB,0BAA0B;QAC1B,wBAAwB;QACxB,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,mDAAmD;IACnD,eAAe;IAGf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B;IAC9B,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;IACN,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,4BAA4B;IAC5B,mCAAmC;IACnC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uCAAuC;IACvC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,uCAAuC;IACvC,OAAO;IACP,MAAM;IACN,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yCAAyC;IACzC,kBAAkB;IAClB,8CAA8C;IAC9C,uCAAuC;IACvC,6BAA6B;IAC7B;AACJ;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,gBAAgB;IAChB,yBAAyB;IAGzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,0DAAyC;IACzC,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,8CAA8C;IAC9C,uCAAuC;IACvC,6BAA6B;IAC7B;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,8CAA8C;IAC9C,yBAAyB;IACzB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mCAAmC;IACnC,kBAAkB;IAClB;AACJ;;AAYA;;IAEI;AACJ;;AAEA;;;;IAII,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IAGrB,mBAAmB;IACnB;AACJ;;AAEA;;;IAGI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;QACX,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,8CAA8C;IAC9C,uCAAuC;IACvC,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC;AACJ;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC;AACJ;;AAEA;IACI,8DAA8D;IAC9D,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,UAAU;;AAEd;;AAEA;IACI,WAAW;IACX,0DAAyC;IACzC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI;QACI,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,YAAY;IACZ;AACJ;;AAEA;;IAEI,cAAc;IACd,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;;IAEI,0FAA0F;IAC1F,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,aAAa;QACb;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI,oBAAoB;QACpB,SAAO;QACP,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,WAAW;QACX;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;;;;;;;;;;;;;;;;QAgBI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,SAAS;IACT,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,uCAAuC;IACvC,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAIlB,uBAAuB;IAIvB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,OAAO;IAIP,uBAAuB;IAIvB,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,QAAQ;IAIR;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,QAAQ;IAIR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,UAAU;QAGV,mBAAmB;QACnB,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,kBAAkB;QAClB,UAAU;QACV,YAAY;QACZ,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,cAAc;QACd,iBAAiB;QACjB;IACJ;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,cAAc;IACd,OAAO;IACP,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,8CAA8C;IAG9C;AACJ;;AAEA;;IAEI;;QAEI,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,WAAW;QACX,4BAA4B;QAC5B,gBAAgB;QAChB,SAAS;QACT,6CAA6C;QAC7C;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,SAAS;IACT,QAAQ;IAGR,mBAAmB;IAKnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,WAAW;IAKX,sBAAsB;IACtB,OAAO;IACP;AACJ;;AAEA;;IAEI;;QAEI,2BAA2B;QAC3B;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,WAAW;IAGX;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,YAAY;IACZ,cAAc;IACd,UAAU;IACV;AACJ;;AAEA;IACI,aAAa;IACb,UAAU;IACV,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,0CAA0C;IAC1C;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,cAAc;IACd,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;;IAEI,UAAU;IACV,mBAAmB;IACnB,aAAa;IAGb;AACJ;;AAEA;;IAEI,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,aAAa;IACb;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;QACf,WAAW;QACX,YAAY;QACZ,aAAa;QAGb,mBAAmB;QACnB,MAAM;QACN,sBAAsB;QACtB,SAAS;QACT;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;;;QAGI;IACJ;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;IACrB,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;IACzB,wBAAwB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,WAAW;QACX,aAAa;QAGb,mBAAmB;QACnB,MAAM;QACN,yBAAyB;QACzB,SAAS;QACT,WAAW;QACX,kBAAkB;QAClB,sBAAsB;QACtB,aAAa;QACb,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,OAAO;QAGP,mBAAmB;QACnB,SAAS;QACT,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;;QAEI,WAAW;QACX;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,0CAA0C;IAC1C,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,iCAAiC;IACjC,oCAAoC;IACpC;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,oCAAoC;IACpC,oCAAoC;IACpC,kCAAkC;IAClC,uCAAuC;IACvC;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,0DAAoD;IACpD;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,8CAA8C;IAC9C,uCAAuC;IACvC,6BAA6B;IAC7B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,OAAO;IACP,MAAM;IACN,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;IAaI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;;;;;;;;;;;;;IAaI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;;;;;;;;;;;;;IAaI,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;;;;;;;;;;;;;IAaI;AACJ;;AAEA;;;;;;;;;;;;;IAaI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,cAAc;IACd,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;;;;;;;;;;;;;IAaI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;;;;;;;;;;;;;IAaI,gBAAgB;IAChB;AACJ;;AAEA;;;;;;;;;;;;;IAaI,SAAS;IACT;AACJ;;AAEA;;;;;;;;;;;;;IAaI,kBAAkB;IAClB,eAAe;IACf,uCAAuC;IACvC;AACJ;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,4BAA4B;IAC5B,yBAAyB;IACzB;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yCAAyC;IACzC,kBAAkB;IAClB,8CAA8C;IAC9C,uCAAuC;IACvC,6BAA6B;IAC7B;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,OAAO;IACP,SAAS;IACT,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B;AACJ;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAGlB;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;IAGI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,0CAA0C;IAC1C;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,WAAW;IAGX,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;QACI,MAAM;QACN;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,0DAAoD;IACpD;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,mDAAmD;IACnD,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;;;AAIA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,0DAA2D;IAC3D,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,qBAAqB;IACrB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;AACJ;;;AAGA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;AACtC;;;AAGA;IACI,mBAAmB;IACnB,eAAe;;IAEf;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,yBAAyB;;QAEzB;YACI,cAAc;YACd,WAAW;YACX,SAAS;YACT,WAAW;YACX,kBAAkB;YAClB,YAAY;YACZ,WAAW;YACX,gCAAgC;YAChC,+BAA+B;YAC/B,yBAAyB;QAC7B;;QAEA;YACI,cAAc;YACd,WAAW;YACX,SAAS;YACT,WAAW;YACX,kBAAkB;YAClB,SAAS;YACT,UAAU;YACV,6BAA6B;YAC7B,8BAA8B;YAC9B,yBAAyB;QAC7B;;QAEA;YACI,UAAU;YACV,qBAAqB;;YAErB;;gBAEI,UAAU;gBACV,WAAW;YACf;QACJ;IACJ;;IAEA;QACI,cAAc;QACd,eAAe;QACf,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,+BAA+B;QAC/B,4BAA4B;QAC5B,wBAAwB;QACxB,4BAA4B;;IAEhC;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI;;QAEI,cAAc;QACd,qBAAqB;IACzB;AACJ;;AAEA,mCAAmC;AACnC;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,UAAU;IACV,gCAAgC;IAChC;6BACyB;IACzB,qBAAqB;IACrB,sBAAsB;AAC1B;;;AAGA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,SAAS;IACT,qBAAqB;IACrB;AACJ;;;AAGA;;IAEI,qBAAqB;IACrB;iBACa;AACjB;;AAEA,iCAAiC;;AAEjC,0CAA0C;AAC1C;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;;GAEG;;AAEH;;;;IAII,wBAAwB;AAC5B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wCAAwC;;AAExC,6BAA6B;AAC7B,6BAA6B;AAC7B;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,2BAA2B;;AAE3B,oCAAoC;AACpC;IACI,iBAAiB;AACrB;;AAEA,kCAAkC;;AAElC,+BAA+B;AAC/B;IACI,yBAAyB;;IAEzB,aAAa;IACb,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA,6BAA6B","sourcesContent":["/*!\n * Bootstrap  v5.3.0 (https://getbootstrap.com/)\n * Copyright 2011-2023 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n    --bs-gray-100: #a1f4ff;\n    --bs-gray-200: #60eaff;\n    --bs-gray-300: #18d5f8;\n    --bs-gray-400: #00b8de;\n    --bs-gray-500: #008bb1;\n    --bs-gray-600: #087496;\n    --bs-gray-700: #105e7a;\n    --bs-gray-800: #124e67;\n    --bs-gray-900: #053347;\n    --bs-primary: #008BB1;\n    --bs-secondary: #f17732;\n    --bs-success: #209f84;\n    --bs-info: #2754e6;\n    --bs-warning: #fe970e;\n    --bs-danger: #f72b50;\n    --bs-light: #fff;\n    --bs-dark: #008BB1;\n    --bs-primary-rgb: 161, 244, 255;\n    --bs-secondary-rgb: 96, 234, 255;\n    --bs-success-rgb: 24, 213, 248;\n    --bs-info-rgb: 0, 184, 222;\n    --bs-warning-rgb: 0, 139, 177;\n    --bs-danger-rgb: 8, 116, 150;\n    --bs-light-rgb: 16, 94, 122;\n    --bs-dark-rgb: 18, 78, 103;\n    --bs-primary-text-emphasis: #222453;\n    --bs-secondary-text-emphasis: #603014;\n    --bs-success-text-emphasis: #0d4035;\n    --bs-info-text-emphasis: #10225c;\n    --bs-warning-text-emphasis: #663c06;\n    --bs-danger-text-emphasis: #631120;\n    --bs-light-text-emphasis: #495057;\n    --bs-dark-text-emphasis: #495057;\n    --bs-primary-bg-subtle: #dddef5;\n    --bs-secondary-bg-subtle: #fce4d6;\n    --bs-success-bg-subtle: #d2ece6;\n    --bs-info-bg-subtle: #d4ddfa;\n    --bs-warning-bg-subtle: #ffeacf;\n    --bs-danger-bg-subtle: #fdd5dc;\n    --bs-light-bg-subtle: #fcfcfd;\n    --bs-dark-bg-subtle: #ced4da;\n    --bs-primary-border-subtle: #bbbdec;\n    --bs-secondary-border-subtle: #f9c9ad;\n    --bs-success-border-subtle: #a6d9ce;\n    --bs-info-border-subtle: #a9bbf5;\n    --bs-warning-border-subtle: #ffd59f;\n    --bs-danger-border-subtle: #fcaab9;\n    --bs-light-border-subtle: #e9ecef;\n    --bs-dark-border-subtle: #adb5bd;\n    --bs-white-rgb: 255, 255, 255;\n    --bs-black-rgb: 0, 0, 0;\n    --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n    --bs-body-font-family: \"Montserrat\", sans-serif;\n    --bs-body-font-size: 1rem;\n    --bs-body-font-weight: 500;\n    --bs-body-line-height: 1.5;\n    --bs-body-color: #3F4650;\n    --bs-body-color-rgb: 63, 70, 80;\n    --bs-body-bg: #ffffff;\n    --bs-body-bg-rgb: 255, 255, 255;\n    --bs-emphasis-color: #000;\n    --bs-emphasis-color-rgb: 0, 0, 0;\n    --bs-secondary-color: rgba(68, 68, 68, 0.75);\n    --bs-secondary-color-rgb: 68, 68, 68;\n    --bs-secondary-bg: #e9ecef;\n    --bs-secondary-bg-rgb: 233, 236, 239;\n    --bs-tertiary-color: rgba(68, 68, 68, 0.5);\n    --bs-tertiary-color-rgb: 68, 68, 68;\n    --bs-tertiary-bg: #f8f9fa;\n    --bs-tertiary-bg-rgb: 248, 249, 250;\n    --bs-heading-color: #14181d;\n    --bs-link-color: #008BB1;\n    --bs-link-color-rgb: 86, 90, 207;\n    --bs-link-decoration: underline;\n    --bs-link-hover-color: var(--bs-primary);\n    ;\n    --bs-link-hover-color-rgb: 69, 72, 166;\n    --bs-code-color: #d63384;\n    --bs-highlight-bg: #fff3cd;\n    --bs-border-width: 1px;\n    --bs-border-style: solid;\n    --bs-border-color: #E1E1F0;\n    --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n    --bs-border-radius: 0.375rem;\n    --bs-border-radius-sm: 0.25rem;\n    --bs-border-radius-lg: 20px;\n    --bs-border-radius-xl: 1rem;\n    --bs-border-radius-xxl: 2rem;\n    --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n    --bs-border-radius-pill: 50rem;\n    --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n    --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n    --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n    --bs-focus-ring-width: 0.25rem;\n    --bs-focus-ring-opacity: 0.25;\n    --bs-focus-ring-color: rgba(86, 90, 207, 0.25);\n    --bs-form-valid-color: #209f84;\n    --bs-form-valid-border-color: #209f84;\n    --bs-form-invalid-color: #f72b50;\n    --bs-form-invalid-border-color: #f72b50\n}\n\n[data-bs-theme=dark] {\n    color-scheme: dark;\n    --bs-body-color: #adb5bd;\n    --bs-body-color-rgb: 173, 181, 189;\n    --bs-body-bg: #212529;\n    --bs-body-bg-rgb: 33, 37, 41;\n    --bs-emphasis-color: #fff;\n    --bs-emphasis-color-rgb: 255, 255, 255;\n    --bs-secondary-color: rgba(173, 181, 189, 0.75);\n    --bs-secondary-color-rgb: 173, 181, 189;\n    --bs-secondary-bg: #343a40;\n    --bs-secondary-bg-rgb: 52, 58, 64;\n    --bs-tertiary-color: rgba(173, 181, 189, 0.5);\n    --bs-tertiary-color-rgb: 173, 181, 189;\n    --bs-tertiary-bg: #2b3035;\n    --bs-tertiary-bg-rgb: 43, 48, 53;\n    --bs-primary-text-emphasis: #9a9ce2;\n    --bs-secondary-text-emphasis: #f7ad84;\n    --bs-success-text-emphasis: #79c5b5;\n    --bs-info-text-emphasis: #7d98f0;\n    --bs-warning-text-emphasis: #fec16e;\n    --bs-danger-text-emphasis: #fa8096;\n    --bs-light-text-emphasis: #f8f9fa;\n    --bs-dark-text-emphasis: #dee2e6;\n    --bs-primary-bg-subtle: #111229;\n    --bs-secondary-bg-subtle: #30180a;\n    --bs-success-bg-subtle: #06201a;\n    --bs-info-bg-subtle: #08112e;\n    --bs-warning-bg-subtle: #331e03;\n    --bs-danger-bg-subtle: #310910;\n    --bs-light-bg-subtle: #343a40;\n    --bs-dark-bg-subtle: #1a1d20;\n    --bs-primary-border-subtle: #34367c;\n    --bs-secondary-border-subtle: #91471e;\n    --bs-success-border-subtle: #135f4f;\n    --bs-info-border-subtle: #17328a;\n    --bs-warning-border-subtle: #985b08;\n    --bs-danger-border-subtle: #941a30;\n    --bs-light-border-subtle: #495057;\n    --bs-dark-border-subtle: #343a40;\n    --bs-heading-color: inherit;\n    --bs-link-color: #9a9ce2;\n    --bs-link-hover-color: #aeb0e8;\n    --bs-link-color-rgb: 154, 156, 226;\n    --bs-link-hover-color-rgb: 174, 176, 232;\n    --bs-code-color: #e685b5;\n    --bs-border-color: #495057;\n    --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n    --bs-form-valid-color: #75b798;\n    --bs-form-valid-border-color: #75b798;\n    --bs-form-invalid-color: #ea868f;\n    --bs-form-invalid-border-color: #ea868f\n}\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box\n}\n\n@media(prefers-reduced-motion: no-preference) {\n    :root {\n        scroll-behavior: smooth\n    }\n}\n\nbody {\n    margin: 0;\n    font-family: var(--bs-body-font-family);\n    font-size: var(--bs-body-font-size);\n    font-weight: var(--bs-body-font-weight);\n    line-height: var(--bs-body-line-height);\n    color: var(--bs-body-color);\n    text-align: var(--bs-body-text-align);\n    background-color: var(--bs-body-bg);\n    -webkit-text-size-adjust: 100%;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n    margin: 1rem 0;\n    color: inherit;\n    border: 0;\n    border-top: var(--bs-border-width) solid;\n    opacity: .25\n}\n\nh6,\n.h6,\nh5,\n.h5,\nh4,\n.h4,\nh3,\n.h3,\nh2,\n.h2,\nh1,\n.h1 {\n    margin-top: 0;\n    margin-bottom: .5rem;\n    font-weight: 500;\n    line-height: 1.2;\n    color: var(--bs-heading-color)\n}\n\nh1,\n.h1 {\n    font-size: calc(1.4375rem + 2.25vw)\n}\n\n@media(min-width: 1200px) {\n\n    h1,\n    .h1 {\n        font-size: 3.125rem\n    }\n}\n\nh2,\n.h2 {\n    font-size: calc(1.34375rem + 1.125vw)\n}\n\n@media(min-width: 1200px) {\n\n    h2,\n    .h2 {\n        font-size: 2.1875rem\n    }\n}\n\nh3,\n.h3 {\n    font-size: calc(1.3rem + 0.6vw)\n}\n\n@media(min-width: 1200px) {\n\n    h3,\n    .h3 {\n        font-size: 1.75rem\n    }\n}\n\nh4,\n.h4 {\n    font-size: calc(1.275rem + 0.3vw)\n}\n\n@media(min-width: 1200px) {\n\n    h4,\n    .h4 {\n        font-size: 1.5rem\n    }\n}\n\nh5,\n.h5 {\n    font-size: 1.25rem\n}\n\nh6,\n.h6 {\n    font-size: 1.125rem\n}\n\np {\n    margin-top: 0;\n    margin-bottom: 1rem\n}\n\nabbr[title] {\n    text-decoration: underline dotted;\n    cursor: help;\n    text-decoration-skip-ink: none\n}\n\naddress {\n    margin-bottom: 1rem;\n    font-style: normal;\n    line-height: inherit\n}\n\nol,\nul {\n    padding-left: 2rem\n}\n\nol,\nul,\ndl {\n    margin-top: 0;\n    margin-bottom: 1rem\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n    margin-bottom: 0\n}\n\ndt {\n    font-weight: 700\n}\n\ndd {\n    margin-bottom: .5rem;\n    margin-left: 0\n}\n\nblockquote {\n    margin: 0 0 1rem\n}\n\nb,\nstrong {\n    font-weight: bolder\n}\n\nsmall,\n.small {\n    font-size: 0.875em\n}\n\nmark,\n.mark {\n    padding: .1875em;\n    background-color: var(--bs-highlight-bg)\n}\n\nsub,\nsup {\n    position: relative;\n    font-size: 0.75em;\n    line-height: 0;\n    vertical-align: baseline\n}\n\nsub {\n    bottom: -0.25em\n}\n\nsup {\n    top: -0.5em\n}\n\na {\n    color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n    text-decoration: underline\n}\n\na:hover {\n    --bs-link-color-rgb: var(--bs-link-hover-color-rgb)\n}\n\na:not([href]):not([class]),\na:not([href]):not([class]):hover {\n    color: inherit;\n    text-decoration: none\n}\n\npre,\ncode,\nkbd,\nsamp {\n    font-family: var(--bs-font-monospace);\n    font-size: 1em\n}\n\npre {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 1rem;\n    overflow: auto;\n    font-size: 0.875em\n}\n\npre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal\n}\n\ncode {\n    font-size: 0.875em;\n    color: var(--bs-code-color);\n    word-wrap: break-word\n}\n\na>code {\n    color: inherit\n}\n\nkbd {\n    padding: .1875rem .375rem;\n    font-size: 0.875em;\n    color: var(--bs-body-bg);\n    background-color: var(--bs-body-color);\n    border-radius: .25rem\n}\n\nkbd kbd {\n    padding: 0;\n    font-size: 1em\n}\n\nfigure {\n    margin: 0 0 1rem\n}\n\nimg,\nsvg {\n    vertical-align: middle\n}\n\ntable {\n    caption-side: bottom;\n    border-collapse: collapse\n}\n\ncaption {\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n    color: var(--bs-secondary-color);\n    text-align: left\n}\n\nth {\n    text-align: inherit;\n    text-align: -webkit-match-parent\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0\n}\n\nlabel {\n    display: inline-block\n}\n\nbutton {\n    border-radius: 0\n}\n\nbutton:focus:not(:focus-visible) {\n    outline: 0\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit\n}\n\nbutton,\nselect {\n    text-transform: none\n}\n\n[role=button] {\n    cursor: pointer\n}\n\nselect {\n    word-wrap: normal\n}\n\nselect:disabled {\n    opacity: 1\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n    display: none !important\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n    -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n    cursor: pointer\n}\n\n::-moz-focus-inner {\n    padding: 0;\n    border-style: none\n}\n\ntextarea {\n    resize: vertical\n}\n\nfieldset {\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0\n}\n\nlegend {\n    float: left;\n    width: 100%;\n    padding: 0;\n    margin-bottom: .5rem;\n    font-size: calc(1.275rem + 0.3vw);\n    line-height: inherit\n}\n\n@media(min-width: 1200px) {\n    legend {\n        font-size: 1.5rem\n    }\n}\n\nlegend+* {\n    clear: left\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n    padding: 0\n}\n\n::-webkit-inner-spin-button {\n    height: auto\n}\n\n[type=search] {\n    outline-offset: -2px;\n    -webkit-appearance: textfield\n}\n\n::-webkit-search-decoration {\n    -webkit-appearance: none\n}\n\n::-webkit-color-swatch-wrapper {\n    padding: 0\n}\n\n::file-selector-button {\n    font: inherit;\n    -webkit-appearance: button\n}\n\noutput {\n    display: inline-block\n}\n\niframe {\n    border: 0\n}\n\nsummary {\n    display: list-item;\n    cursor: pointer\n}\n\nprogress {\n    vertical-align: baseline\n}\n\n[hidden] {\n    display: none !important\n}\n\n.lead {\n    font-size: 1.25rem;\n    font-weight: 300\n}\n\n.display-1 {\n    font-size: calc(1.625rem + 4.5vw);\n    font-weight: 300;\n    line-height: 1.2\n}\n\n@media(min-width: 1200px) {\n    .display-1 {\n        font-size: 5rem\n    }\n}\n\n.display-2 {\n    font-size: calc(1.575rem + 3.9vw);\n    font-weight: 300;\n    line-height: 1.2\n}\n\n@media(min-width: 1200px) {\n    .display-2 {\n        font-size: 4.5rem\n    }\n}\n\n.display-3 {\n    font-size: calc(1.525rem + 3.3vw);\n    font-weight: 300;\n    line-height: 1.2\n}\n\n@media(min-width: 1200px) {\n    .display-3 {\n        font-size: 4rem\n    }\n}\n\n.display-4 {\n    font-size: calc(1.475rem + 2.7vw);\n    font-weight: 300;\n    line-height: 1.2\n}\n\n@media(min-width: 1200px) {\n    .display-4 {\n        font-size: 3.5rem\n    }\n}\n\n.display-5 {\n    font-size: calc(1.425rem + 2.1vw);\n    font-weight: 300;\n    line-height: 1.2\n}\n\n@media(min-width: 1200px) {\n    .display-5 {\n        font-size: 3rem\n    }\n}\n\n.display-6 {\n    font-size: calc(1.375rem + 1.5vw);\n    font-weight: 300;\n    line-height: 1.2\n}\n\n@media(min-width: 1200px) {\n    .display-6 {\n        font-size: 2.5rem\n    }\n}\n\n.list-unstyled {\n    padding-left: 0;\n    list-style: none\n}\n\n.list-inline {\n    padding-left: 0;\n    list-style: none\n}\n\n.list-inline-item {\n    display: inline-block\n}\n\n.list-inline-item:not(:last-child) {\n    margin-right: .5rem\n}\n\n.initialism {\n    font-size: 0.875em;\n    text-transform: uppercase\n}\n\n.blockquote {\n    margin-bottom: 1rem;\n    font-size: 1.25rem\n}\n\n.blockquote>:last-child {\n    margin-bottom: 0\n}\n\n.blockquote-footer {\n    margin-top: -1rem;\n    margin-bottom: 1rem;\n    font-size: 0.875em;\n    color: #6c757d\n}\n\n.blockquote-footer::before {\n    content: \"— \"\n}\n\n.img-fluid {\n    max-width: 100%;\n    /* height: auto */\n    height: 250px;\n}\n\n.img-thumbnail {\n    padding: .25rem;\n    background-color: var(--bs-body-bg);\n    border: var(--bs-border-width) solid var(--bs-border-color);\n    border-radius: var(--bs-border-radius);\n    max-width: 100%;\n    height: auto\n}\n\n.figure {\n    display: inline-block\n}\n\n.figure-img {\n    margin-bottom: .5rem;\n    line-height: 1\n}\n\n.figure-caption {\n    font-size: 0.875em;\n    color: var(--bs-secondary-color)\n}\n\n.container,\n.container-fluid,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n    --bs-gutter-x: 30px;\n    --bs-gutter-y: 0;\n    width: 100%;\n    padding-right: calc(var(--bs-gutter-x)*.5);\n    padding-left: calc(var(--bs-gutter-x)*.5);\n    margin-right: auto;\n    margin-left: auto\n}\n\n@media(min-width: 576px) {\n\n    .container-sm,\n    .container {\n        max-width: 540px\n    }\n}\n\n@media(min-width: 768px) {\n\n    .container-md,\n    .container-sm,\n    .container {\n        max-width: 720px\n    }\n}\n\n@media(min-width: 992px) {\n\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container {\n        max-width: 960px\n    }\n}\n\n@media(min-width: 1200px) {\n\n    .container-xl,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container {\n        max-width: 1199px\n    }\n}\n\n:root {\n    --bs-breakpoint-xs: 0;\n    --bs-breakpoint-sm: 576px;\n    --bs-breakpoint-md: 768px;\n    --bs-breakpoint-lg: 992px;\n    --bs-breakpoint-xl: 1200px;\n    --bs-breakpoint-xxl: 1440\n}\n\n.row {\n    --bs-gutter-x: 30px;\n    --bs-gutter-y: 0;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: calc(-1*var(--bs-gutter-y));\n    margin-right: calc(-0.5*var(--bs-gutter-x));\n    margin-left: calc(-0.5*var(--bs-gutter-x))\n}\n\n.row>* {\n    flex-shrink: 0;\n    width: 100%;\n    max-width: 100%;\n    padding-right: calc(var(--bs-gutter-x)*.5);\n    padding-left: calc(var(--bs-gutter-x)*.5);\n    margin-top: var(--bs-gutter-y)\n}\n\n.col {\n    flex: 1 0 0%\n}\n\n.row-cols-auto>* {\n    flex: 0 0 auto;\n    width: auto\n}\n\n.row-cols-1>* {\n    flex: 0 0 auto;\n    width: 100%\n}\n\n.row-cols-2>* {\n    flex: 0 0 auto;\n    width: 50%\n}\n\n.row-cols-3>* {\n    flex: 0 0 auto;\n    width: 33.3333333333%\n}\n\n.row-cols-4>* {\n    flex: 0 0 auto;\n    width: 25%\n}\n\n.row-cols-5>* {\n    flex: 0 0 auto;\n    width: 20%\n}\n\n.row-cols-6>* {\n    flex: 0 0 auto;\n    width: 16.6666666667%\n}\n\n.col-auto {\n    flex: 0 0 auto;\n    width: auto\n}\n\n.col-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%\n}\n\n.col-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%\n}\n\n.col-3 {\n    flex: 0 0 auto;\n    width: 25%\n}\n\n.col-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%\n}\n\n.col-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%\n}\n\n.col-6 {\n    flex: 0 0 auto;\n    width: 50%\n}\n\n.col-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%\n}\n\n.col-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%\n}\n\n.col-9 {\n    flex: 0 0 auto;\n    width: 75%\n}\n\n.col-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%\n}\n\n.col-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%\n}\n\n.col-12 {\n    flex: 0 0 auto;\n    width: 100%\n}\n\n.offset-1 {\n    margin-left: 8.33333333%\n}\n\n.offset-2 {\n    margin-left: 16.66666667%\n}\n\n.offset-3 {\n    margin-left: 25%\n}\n\n.offset-4 {\n    margin-left: 33.33333333%\n}\n\n.offset-5 {\n    margin-left: 41.66666667%\n}\n\n.offset-6 {\n    margin-left: 50%\n}\n\n.offset-7 {\n    margin-left: 58.33333333%\n}\n\n.offset-8 {\n    margin-left: 66.66666667%\n}\n\n.offset-9 {\n    margin-left: 75%\n}\n\n.offset-10 {\n    margin-left: 83.33333333%\n}\n\n.offset-11 {\n    margin-left: 91.66666667%\n}\n\n.g-0,\n.gx-0 {\n    --bs-gutter-x: 0\n}\n\n.g-0,\n.gy-0 {\n    --bs-gutter-y: 0\n}\n\n.g-1,\n.gx-1 {\n    --bs-gutter-x: 0.25rem\n}\n\n.g-1,\n.gy-1 {\n    --bs-gutter-y: 0.25rem\n}\n\n.g-2,\n.gx-2 {\n    --bs-gutter-x: 0.5rem\n}\n\n.g-2,\n.gy-2 {\n    --bs-gutter-y: 0.5rem\n}\n\n.g-3,\n.gx-3 {\n    --bs-gutter-x: 1rem\n}\n\n.g-3,\n.gy-3 {\n    --bs-gutter-y: 1rem\n}\n\n.g-4,\n.gx-4 {\n    --bs-gutter-x: 1.5rem\n}\n\n.g-4,\n.gy-4 {\n    --bs-gutter-y: 1.5rem\n}\n\n.g-5,\n.gx-5 {\n    --bs-gutter-x: 3rem\n}\n\n.g-5,\n.gy-5 {\n    --bs-gutter-y: 3rem\n}\n\n@media(min-width: 576px) {\n    .col-sm {\n        flex: 1 0 0%\n    }\n\n    .row-cols-sm-auto>* {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .row-cols-sm-1>* {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .row-cols-sm-2>* {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .row-cols-sm-3>* {\n        flex: 0 0 auto;\n        width: 33.3333333333%\n    }\n\n    .row-cols-sm-4>* {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .row-cols-sm-5>* {\n        flex: 0 0 auto;\n        width: 20%\n    }\n\n    .row-cols-sm-6>* {\n        flex: 0 0 auto;\n        width: 16.6666666667%\n    }\n\n    .col-sm-auto {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .col-sm-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%\n    }\n\n    .col-sm-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%\n    }\n\n    .col-sm-3 {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .col-sm-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%\n    }\n\n    .col-sm-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%\n    }\n\n    .col-sm-6 {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .col-sm-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%\n    }\n\n    .col-sm-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%\n    }\n\n    .col-sm-9 {\n        flex: 0 0 auto;\n        width: 75%\n    }\n\n    .col-sm-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%\n    }\n\n    .col-sm-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%\n    }\n\n    .col-sm-12 {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .offset-sm-0 {\n        margin-left: 0\n    }\n\n    .offset-sm-1 {\n        margin-left: 8.33333333%\n    }\n\n    .offset-sm-2 {\n        margin-left: 16.66666667%\n    }\n\n    .offset-sm-3 {\n        margin-left: 25%\n    }\n\n    .offset-sm-4 {\n        margin-left: 33.33333333%\n    }\n\n    .offset-sm-5 {\n        margin-left: 41.66666667%\n    }\n\n    .offset-sm-6 {\n        margin-left: 50%\n    }\n\n    .offset-sm-7 {\n        margin-left: 58.33333333%\n    }\n\n    .offset-sm-8 {\n        margin-left: 66.66666667%\n    }\n\n    .offset-sm-9 {\n        margin-left: 75%\n    }\n\n    .offset-sm-10 {\n        margin-left: 83.33333333%\n    }\n\n    .offset-sm-11 {\n        margin-left: 91.66666667%\n    }\n\n    .g-sm-0,\n    .gx-sm-0 {\n        --bs-gutter-x: 0\n    }\n\n    .g-sm-0,\n    .gy-sm-0 {\n        --bs-gutter-y: 0\n    }\n\n    .g-sm-1,\n    .gx-sm-1 {\n        --bs-gutter-x: 0.25rem\n    }\n\n    .g-sm-1,\n    .gy-sm-1 {\n        --bs-gutter-y: 0.25rem\n    }\n\n    .g-sm-2,\n    .gx-sm-2 {\n        --bs-gutter-x: 0.5rem\n    }\n\n    .g-sm-2,\n    .gy-sm-2 {\n        --bs-gutter-y: 0.5rem\n    }\n\n    .g-sm-3,\n    .gx-sm-3 {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-sm-3,\n    .gy-sm-3 {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-sm-4,\n    .gx-sm-4 {\n        --bs-gutter-x: 1.5rem\n    }\n\n    .g-sm-4,\n    .gy-sm-4 {\n        --bs-gutter-y: 1.5rem\n    }\n\n    .g-sm-5,\n    .gx-sm-5 {\n        --bs-gutter-x: 3rem\n    }\n\n    .g-sm-5,\n    .gy-sm-5 {\n        --bs-gutter-y: 3rem\n    }\n}\n\n@media(min-width: 768px) {\n    .col-md {\n        flex: 1 0 0%\n    }\n\n    .row-cols-md-auto>* {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .row-cols-md-1>* {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .row-cols-md-2>* {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .row-cols-md-3>* {\n        flex: 0 0 auto;\n        width: 33.3333333333%\n    }\n\n    .row-cols-md-4>* {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .row-cols-md-5>* {\n        flex: 0 0 auto;\n        width: 20%\n    }\n\n    .row-cols-md-6>* {\n        flex: 0 0 auto;\n        width: 16.6666666667%\n    }\n\n    .col-md-auto {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .col-md-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%\n    }\n\n    .col-md-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%\n    }\n\n    .col-md-3 {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .col-md-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%\n    }\n\n    .col-md-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%\n    }\n\n    .col-md-6 {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .col-md-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%\n    }\n\n    .col-md-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%\n    }\n\n    .col-md-9 {\n        flex: 0 0 auto;\n        width: 75%\n    }\n\n    .col-md-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%\n    }\n\n    .col-md-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%\n    }\n\n    .col-md-12 {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .offset-md-0 {\n        margin-left: 0\n    }\n\n    .offset-md-1 {\n        margin-left: 8.33333333%\n    }\n\n    .offset-md-2 {\n        margin-left: 16.66666667%\n    }\n\n    .offset-md-3 {\n        margin-left: 25%\n    }\n\n    .offset-md-4 {\n        margin-left: 33.33333333%\n    }\n\n    .offset-md-5 {\n        margin-left: 41.66666667%\n    }\n\n    .offset-md-6 {\n        margin-left: 50%\n    }\n\n    .offset-md-7 {\n        margin-left: 58.33333333%\n    }\n\n    .offset-md-8 {\n        margin-left: 66.66666667%\n    }\n\n    .offset-md-9 {\n        margin-left: 75%\n    }\n\n    .offset-md-10 {\n        margin-left: 83.33333333%\n    }\n\n    .offset-md-11 {\n        margin-left: 91.66666667%\n    }\n\n    .g-md-0,\n    .gx-md-0 {\n        --bs-gutter-x: 0\n    }\n\n    .g-md-0,\n    .gy-md-0 {\n        --bs-gutter-y: 0\n    }\n\n    .g-md-1,\n    .gx-md-1 {\n        --bs-gutter-x: 0.25rem\n    }\n\n    .g-md-1,\n    .gy-md-1 {\n        --bs-gutter-y: 0.25rem\n    }\n\n    .g-md-2,\n    .gx-md-2 {\n        --bs-gutter-x: 0.5rem\n    }\n\n    .g-md-2,\n    .gy-md-2 {\n        --bs-gutter-y: 0.5rem\n    }\n\n    .g-md-3,\n    .gx-md-3 {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-md-3,\n    .gy-md-3 {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-md-4,\n    .gx-md-4 {\n        --bs-gutter-x: 1.5rem\n    }\n\n    .g-md-4,\n    .gy-md-4 {\n        --bs-gutter-y: 1.5rem\n    }\n\n    .g-md-5,\n    .gx-md-5 {\n        --bs-gutter-x: 3rem\n    }\n\n    .g-md-5,\n    .gy-md-5 {\n        --bs-gutter-y: 3rem\n    }\n}\n\n@media(min-width: 992px) {\n    .col-lg {\n        flex: 1 0 0%\n    }\n\n    .row-cols-lg-auto>* {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .row-cols-lg-1>* {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .row-cols-lg-2>* {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .row-cols-lg-3>* {\n        flex: 0 0 auto;\n        width: 33.3333333333%\n    }\n\n    .row-cols-lg-4>* {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .row-cols-lg-5>* {\n        flex: 0 0 auto;\n        width: 20%\n    }\n\n    .row-cols-lg-6>* {\n        flex: 0 0 auto;\n        width: 16.6666666667%\n    }\n\n    .col-lg-auto {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .col-lg-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%\n    }\n\n    .col-lg-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%\n    }\n\n    .col-lg-3 {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .col-lg-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%\n    }\n\n    .col-lg-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%\n    }\n\n    .col-lg-6 {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .col-lg-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%\n    }\n\n    .col-lg-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%\n    }\n\n    .col-lg-9 {\n        flex: 0 0 auto;\n        width: 75%\n    }\n\n    .col-lg-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%\n    }\n\n    .col-lg-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%\n    }\n\n    .col-lg-12 {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .offset-lg-0 {\n        margin-left: 0\n    }\n\n    .offset-lg-1 {\n        margin-left: 8.33333333%\n    }\n\n    .offset-lg-2 {\n        margin-left: 16.66666667%\n    }\n\n    .offset-lg-3 {\n        margin-left: 25%\n    }\n\n    .offset-lg-4 {\n        margin-left: 33.33333333%\n    }\n\n    .offset-lg-5 {\n        margin-left: 41.66666667%\n    }\n\n    .offset-lg-6 {\n        margin-left: 50%\n    }\n\n    .offset-lg-7 {\n        margin-left: 58.33333333%\n    }\n\n    .offset-lg-8 {\n        margin-left: 66.66666667%\n    }\n\n    .offset-lg-9 {\n        margin-left: 75%\n    }\n\n    .offset-lg-10 {\n        margin-left: 83.33333333%\n    }\n\n    .offset-lg-11 {\n        margin-left: 91.66666667%\n    }\n\n    .g-lg-0,\n    .gx-lg-0 {\n        --bs-gutter-x: 0\n    }\n\n    .g-lg-0,\n    .gy-lg-0 {\n        --bs-gutter-y: 0\n    }\n\n    .g-lg-1,\n    .gx-lg-1 {\n        --bs-gutter-x: 0.25rem\n    }\n\n    .g-lg-1,\n    .gy-lg-1 {\n        --bs-gutter-y: 0.25rem\n    }\n\n    .g-lg-2,\n    .gx-lg-2 {\n        --bs-gutter-x: 0.5rem\n    }\n\n    .g-lg-2,\n    .gy-lg-2 {\n        --bs-gutter-y: 0.5rem\n    }\n\n    .g-lg-3,\n    .gx-lg-3 {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-lg-3,\n    .gy-lg-3 {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-lg-4,\n    .gx-lg-4 {\n        --bs-gutter-x: 1.5rem\n    }\n\n    .g-lg-4,\n    .gy-lg-4 {\n        --bs-gutter-y: 1.5rem\n    }\n\n    .g-lg-5,\n    .gx-lg-5 {\n        --bs-gutter-x: 3rem\n    }\n\n    .g-lg-5,\n    .gy-lg-5 {\n        --bs-gutter-y: 3rem\n    }\n}\n\n@media(min-width: 1200px) {\n    .col-xl {\n        flex: 1 0 0%\n    }\n\n    .row-cols-xl-auto>* {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .row-cols-xl-1>* {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .row-cols-xl-2>* {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .row-cols-xl-3>* {\n        flex: 0 0 auto;\n        width: 33.3333333333%\n    }\n\n    .row-cols-xl-4>* {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .row-cols-xl-5>* {\n        flex: 0 0 auto;\n        width: 20%\n    }\n\n    .row-cols-xl-6>* {\n        flex: 0 0 auto;\n        width: 16.6666666667%\n    }\n\n    .col-xl-auto {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .col-xl-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%\n    }\n\n    .col-xl-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%\n    }\n\n    .col-xl-3 {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .col-xl-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%\n    }\n\n    .col-xl-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%\n    }\n\n    .col-xl-6 {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .col-xl-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%\n    }\n\n    .col-xl-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%\n    }\n\n    .col-xl-9 {\n        flex: 0 0 auto;\n        width: 75%\n    }\n\n    .col-xl-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%\n    }\n\n    .col-xl-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%\n    }\n\n    .col-xl-12 {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .offset-xl-0 {\n        margin-left: 0\n    }\n\n    .offset-xl-1 {\n        margin-left: 8.33333333%\n    }\n\n    .offset-xl-2 {\n        margin-left: 16.66666667%\n    }\n\n    .offset-xl-3 {\n        margin-left: 25%\n    }\n\n    .offset-xl-4 {\n        margin-left: 33.33333333%\n    }\n\n    .offset-xl-5 {\n        margin-left: 41.66666667%\n    }\n\n    .offset-xl-6 {\n        margin-left: 50%\n    }\n\n    .offset-xl-7 {\n        margin-left: 58.33333333%\n    }\n\n    .offset-xl-8 {\n        margin-left: 66.66666667%\n    }\n\n    .offset-xl-9 {\n        margin-left: 75%\n    }\n\n    .offset-xl-10 {\n        margin-left: 83.33333333%\n    }\n\n    .offset-xl-11 {\n        margin-left: 91.66666667%\n    }\n\n    .g-xl-0,\n    .gx-xl-0 {\n        --bs-gutter-x: 0\n    }\n\n    .g-xl-0,\n    .gy-xl-0 {\n        --bs-gutter-y: 0\n    }\n\n    .g-xl-1,\n    .gx-xl-1 {\n        --bs-gutter-x: 0.25rem\n    }\n\n    .g-xl-1,\n    .gy-xl-1 {\n        --bs-gutter-y: 0.25rem\n    }\n\n    .g-xl-2,\n    .gx-xl-2 {\n        --bs-gutter-x: 0.5rem\n    }\n\n    .g-xl-2,\n    .gy-xl-2 {\n        --bs-gutter-y: 0.5rem\n    }\n\n    .g-xl-3,\n    .gx-xl-3 {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-xl-3,\n    .gy-xl-3 {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-xl-4,\n    .gx-xl-4 {\n        --bs-gutter-x: 1.5rem\n    }\n\n    .g-xl-4,\n    .gy-xl-4 {\n        --bs-gutter-y: 1.5rem\n    }\n\n    .g-xl-5,\n    .gx-xl-5 {\n        --bs-gutter-x: 3rem\n    }\n\n    .g-xl-5,\n    .gy-xl-5 {\n        --bs-gutter-y: 3rem\n    }\n}\n\n@media(min-width: 1440) {\n    .col-xxl {\n        flex: 1 0 0%\n    }\n\n    .row-cols-xxl-auto>* {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .row-cols-xxl-1>* {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .row-cols-xxl-2>* {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .row-cols-xxl-3>* {\n        flex: 0 0 auto;\n        width: 33.3333333333%\n    }\n\n    .row-cols-xxl-4>* {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .row-cols-xxl-5>* {\n        flex: 0 0 auto;\n        width: 20%\n    }\n\n    .row-cols-xxl-6>* {\n        flex: 0 0 auto;\n        width: 16.6666666667%\n    }\n\n    .col-xxl-auto {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .col-xxl-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%\n    }\n\n    .col-xxl-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%\n    }\n\n    .col-xxl-3 {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .col-xxl-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%\n    }\n\n    .col-xxl-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%\n    }\n\n    .col-xxl-6 {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .col-xxl-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%\n    }\n\n    .col-xxl-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%\n    }\n\n    .col-xxl-9 {\n        flex: 0 0 auto;\n        width: 75%\n    }\n\n    .col-xxl-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%\n    }\n\n    .col-xxl-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%\n    }\n\n    .col-xxl-12 {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .offset-xxl-0 {\n        margin-left: 0\n    }\n\n    .offset-xxl-1 {\n        margin-left: 8.33333333%\n    }\n\n    .offset-xxl-2 {\n        margin-left: 16.66666667%\n    }\n\n    .offset-xxl-3 {\n        margin-left: 25%\n    }\n\n    .offset-xxl-4 {\n        margin-left: 33.33333333%\n    }\n\n    .offset-xxl-5 {\n        margin-left: 41.66666667%\n    }\n\n    .offset-xxl-6 {\n        margin-left: 50%\n    }\n\n    .offset-xxl-7 {\n        margin-left: 58.33333333%\n    }\n\n    .offset-xxl-8 {\n        margin-left: 66.66666667%\n    }\n\n    .offset-xxl-9 {\n        margin-left: 75%\n    }\n\n    .offset-xxl-10 {\n        margin-left: 83.33333333%\n    }\n\n    .offset-xxl-11 {\n        margin-left: 91.66666667%\n    }\n\n    .g-xxl-0,\n    .gx-xxl-0 {\n        --bs-gutter-x: 0\n    }\n\n    .g-xxl-0,\n    .gy-xxl-0 {\n        --bs-gutter-y: 0\n    }\n\n    .g-xxl-1,\n    .gx-xxl-1 {\n        --bs-gutter-x: 0.25rem\n    }\n\n    .g-xxl-1,\n    .gy-xxl-1 {\n        --bs-gutter-y: 0.25rem\n    }\n\n    .g-xxl-2,\n    .gx-xxl-2 {\n        --bs-gutter-x: 0.5rem\n    }\n\n    .g-xxl-2,\n    .gy-xxl-2 {\n        --bs-gutter-y: 0.5rem\n    }\n\n    .g-xxl-3,\n    .gx-xxl-3 {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-xxl-3,\n    .gy-xxl-3 {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-xxl-4,\n    .gx-xxl-4 {\n        --bs-gutter-x: 1.5rem\n    }\n\n    .g-xxl-4,\n    .gy-xxl-4 {\n        --bs-gutter-y: 1.5rem\n    }\n\n    .g-xxl-5,\n    .gx-xxl-5 {\n        --bs-gutter-x: 3rem\n    }\n\n    .g-xxl-5,\n    .gy-xxl-5 {\n        --bs-gutter-y: 3rem\n    }\n}\n\n.table {\n    --bs-table-color-type: initial;\n    --bs-table-bg-type: initial;\n    --bs-table-color-state: initial;\n    --bs-table-bg-state: initial;\n    --bs-table-color: var(--bs-body-color);\n    --bs-table-bg: var(--bs-body-bg);\n    --bs-table-border-color: var(--bs-border-color);\n    --bs-table-accent-bg: transparent;\n    --bs-table-striped-color: var(--bs-body-color);\n    --bs-table-striped-bg: rgba(0, 0, 0, 0.05);\n    --bs-table-active-color: var(--bs-body-color);\n    --bs-table-active-bg: rgba(0, 0, 0, 0.1);\n    --bs-table-hover-color: var(--bs-body-color);\n    --bs-table-hover-bg: rgba(0, 0, 0, 0.075);\n    width: 100%;\n    margin-bottom: 1rem;\n    vertical-align: top;\n    border-color: var(--bs-table-border-color)\n}\n\n.table>:not(caption)>*>* {\n    padding: .5rem .5rem;\n    color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n    background-color: var(--bs-table-bg);\n    border-bottom-width: var(--bs-border-width);\n    box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)))\n}\n\n.table>tbody {\n    vertical-align: inherit\n}\n\n.table>thead {\n    vertical-align: bottom\n}\n\n.table-group-divider {\n    border-top: calc(var(--bs-border-width) * 2) solid currentcolor\n}\n\n.caption-top {\n    caption-side: top\n}\n\n.table-sm>:not(caption)>*>* {\n    padding: .25rem .25rem\n}\n\n.table-bordered>:not(caption)>* {\n    border-width: var(--bs-border-width) 0\n}\n\n.table-bordered>:not(caption)>*>* {\n    border-width: 0 var(--bs-border-width)\n}\n\n.table-borderless>:not(caption)>*>* {\n    border-bottom-width: 0\n}\n\n.table-borderless>:not(:first-child) {\n    border-top-width: 0\n}\n\n.table-striped>tbody>tr:nth-of-type(odd)>* {\n    --bs-table-color-type: var(--bs-table-striped-color);\n    --bs-table-bg-type: var(--bs-table-striped-bg)\n}\n\n.table-striped-columns>:not(caption)>tr>:nth-child(even) {\n    --bs-table-color-type: var(--bs-table-striped-color);\n    --bs-table-bg-type: var(--bs-table-striped-bg)\n}\n\n.table-active {\n    --bs-table-color-state: var(--bs-table-active-color);\n    --bs-table-bg-state: var(--bs-table-active-bg)\n}\n\n.table-hover>tbody>tr:hover>* {\n    --bs-table-color-state: var(--bs-table-hover-color);\n    --bs-table-bg-state: var(--bs-table-hover-bg)\n}\n\n.table-primary {\n    --bs-table-color: #000;\n    --bs-table-bg: #dddef5;\n    --bs-table-border-color: #c7c8dd;\n    --bs-table-striped-bg: #d2d3e9;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #c7c8dd;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #cccde3;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color)\n}\n\n.table-secondary {\n    --bs-table-color: #000;\n    --bs-table-bg: #fce4d6;\n    --bs-table-border-color: #e3cdc1;\n    --bs-table-striped-bg: #efd9cb;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #e3cdc1;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #e9d3c6;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color)\n}\n\n.table-success {\n    --bs-table-color: #000;\n    --bs-table-bg: #d2ece6;\n    --bs-table-border-color: #bdd4cf;\n    --bs-table-striped-bg: #c8e0db;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #bdd4cf;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #c2dad5;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color)\n}\n\n.table-info {\n    --bs-table-color: #000;\n    --bs-table-bg: #d4ddfa;\n    --bs-table-border-color: #bfc7e1;\n    --bs-table-striped-bg: #c9d2ee;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #bfc7e1;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #c4cce7;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color)\n}\n\n.table-warning {\n    --bs-table-color: #000;\n    --bs-table-bg: #ffeacf;\n    --bs-table-border-color: #e6d3ba;\n    --bs-table-striped-bg: #f2dec5;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #e6d3ba;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #ecd8bf;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color)\n}\n\n.table-danger {\n    --bs-table-color: #000;\n    --bs-table-bg: #fdd5dc;\n    --bs-table-border-color: #e4c0c6;\n    --bs-table-striped-bg: #f0cad1;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #e4c0c6;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #eac5cc;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color)\n}\n\n.table-light {\n    --bs-table-color: #000;\n    --bs-table-bg: #fff;\n    --bs-table-border-color: #e6e6e6;\n    --bs-table-striped-bg: #f2f2f2;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #e6e6e6;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #ececec;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color)\n}\n\n.table-dark {\n    --bs-table-color: #fff;\n    --bs-table-bg: var(--bs-dark);\n    --bs-table-border-color: #353886;\n    --bs-table-striped-bg: #2a2d7f;\n    --bs-table-striped-color: #fff;\n    --bs-table-active-bg: #353886;\n    --bs-table-active-color: #fff;\n    --bs-table-hover-bg: #303382;\n    --bs-table-hover-color: #fff;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color)\n}\n\n.table-responsive {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch\n}\n\n@media(max-width: 575.98px) {\n    .table-responsive-sm {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n}\n\n@media(max-width: 767.98px) {\n    .table-responsive-md {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n}\n\n@media(max-width: 991.98px) {\n    .table-responsive-lg {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n}\n\n@media(max-width: 1199.98px) {\n    .table-responsive-xl {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n}\n\n@media(max-width: 1439.98) {\n    .table-responsive-xxl {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n}\n\n.form-label {\n    margin-bottom: .5rem\n}\n\n.col-form-label {\n    padding-top: calc(0.375rem + var(--bs-border-width));\n    padding-bottom: calc(0.375rem + var(--bs-border-width));\n    margin-bottom: 0;\n    font-size: inherit;\n    line-height: 1.5\n}\n\n.col-form-label-lg {\n    padding-top: calc(0.5rem + var(--bs-border-width));\n    padding-bottom: calc(0.5rem + var(--bs-border-width));\n    font-size: 1.25rem\n}\n\n.col-form-label-sm {\n    padding-top: calc(0.25rem + var(--bs-border-width));\n    padding-bottom: calc(0.25rem + var(--bs-border-width));\n    font-size: 0.875rem\n}\n\n.form-text {\n    margin-top: .25rem;\n    font-size: 0.875em;\n    color: var(--bs-secondary-color)\n}\n\n.form-control {\n    display: block;\n    width: 100%;\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.5;\n    color: var(--bs-body-color);\n    background-color: var(--bs-body-bg);\n    background-clip: padding-box;\n    border: var(--bs-border-width) solid var(--bs-border-color);\n    appearance: none;\n    border-radius: var(--bs-border-radius);\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .form-control {\n        transition: none\n    }\n}\n\n.form-control[type=file] {\n    overflow: hidden\n}\n\n.form-control[type=file]:not(:disabled):not([readonly]) {\n    cursor: pointer\n}\n\n.form-control:focus {\n    color: var(--bs-body-color);\n    background-color: var(--bs-body-bg);\n    border-color: #abade7;\n    outline: 0;\n    box-shadow: 0 0 0 .25rem rgba(86, 90, 207, .25)\n}\n\n.form-control::-webkit-date-and-time-value {\n    min-width: 85px;\n    height: 1.5em;\n    margin: 0\n}\n\n.form-control::-webkit-datetime-edit {\n    display: block;\n    padding: 0\n}\n\n.form-control::placeholder {\n    color: var(--bs-secondary-color);\n    opacity: 1\n}\n\n.form-control:disabled {\n    background-color: var(--bs-secondary-bg);\n    opacity: 1\n}\n\n.form-control::file-selector-button {\n    padding: .375rem .75rem;\n    margin: -0.375rem -0.75rem;\n    margin-inline-end: .75rem;\n    color: var(--bs-body-color);\n    background-color: var(--bs-tertiary-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: var(--bs-border-width);\n    border-radius: 0;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .form-control::file-selector-button {\n        transition: none\n    }\n}\n\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: var(--bs-secondary-bg)\n}\n\n.form-control-plaintext {\n    display: block;\n    width: 100%;\n    padding: .375rem 0;\n    margin-bottom: 0;\n    line-height: 1.5;\n    color: var(--bs-body-color);\n    background-color: rgba(0, 0, 0, 0);\n    border: solid rgba(0, 0, 0, 0);\n    border-width: var(--bs-border-width) 0\n}\n\n.form-control-plaintext:focus {\n    outline: 0\n}\n\n.form-control-plaintext.form-control-sm,\n.form-control-plaintext.form-control-lg {\n    padding-right: 0;\n    padding-left: 0\n}\n\n.form-control-sm {\n    min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n    padding: .25rem .5rem;\n    font-size: 0.875rem;\n    border-radius: var(--bs-border-radius-sm)\n}\n\n.form-control-sm::file-selector-button {\n    padding: .25rem .5rem;\n    margin: -0.25rem -0.5rem;\n    margin-inline-end: .5rem\n}\n\n.form-control-lg {\n    min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n    padding: .5rem 1rem;\n    font-size: 1.25rem;\n    border-radius: var(--bs-border-radius-lg)\n}\n\n.form-control-lg::file-selector-button {\n    padding: .5rem 1rem;\n    margin: -0.5rem -1rem;\n    margin-inline-end: 1rem\n}\n\ntextarea.form-control {\n    min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2))\n}\n\ntextarea.form-control-sm {\n    min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2))\n}\n\ntextarea.form-control-lg {\n    min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2))\n}\n\n.form-control-color {\n    width: 3rem;\n    height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n    padding: .375rem\n}\n\n.form-control-color:not(:disabled):not([readonly]) {\n    cursor: pointer\n}\n\n.form-control-color::-moz-color-swatch {\n    border: 0 !important;\n    border-radius: var(--bs-border-radius)\n}\n\n.form-control-color::-webkit-color-swatch {\n    border: 0 !important;\n    border-radius: var(--bs-border-radius)\n}\n\n.form-control-color.form-control-sm {\n    height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2))\n}\n\n.form-control-color.form-control-lg {\n    height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2))\n}\n\n.form-select {\n    --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' strokeWidth='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n    display: block;\n    width: 100%;\n    padding: .375rem 2.25rem .375rem .75rem;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.5;\n    color: var(--bs-body-color);\n    background-color: var(--bs-body-bg);\n    background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n    background-repeat: no-repeat;\n    background-position: right .75rem center;\n    background-size: 16px 12px;\n    border: var(--bs-border-width) solid var(--bs-border-color);\n    border-radius: var(--bs-border-radius);\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    appearance: none\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .form-select {\n        transition: none\n    }\n}\n\n.form-select:focus {\n    border-color: #abade7;\n    outline: 0;\n    box-shadow: 0 0 0 0rem rgba(86, 90, 207, .25)\n}\n\n.form-select[multiple],\n.form-select[size]:not([size=\"1\"]) {\n    padding-right: .75rem;\n    background-image: none\n}\n\n.form-select:disabled {\n    background-color: var(--bs-secondary-bg)\n}\n\n.form-select:-moz-focusring {\n    color: rgba(0, 0, 0, 0);\n    text-shadow: 0 0 0 var(--bs-body-color)\n}\n\n.form-select-sm {\n    padding-top: .25rem;\n    padding-bottom: .25rem;\n    padding-left: .5rem;\n    font-size: 0.875rem;\n    border-radius: var(--bs-border-radius-sm)\n}\n\n.form-select-lg {\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n    padding-left: 1rem;\n    font-size: 1.25rem;\n    border-radius: var(--bs-border-radius-lg)\n}\n\n[data-bs-theme=dark] .form-select {\n    --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23adb5bd' stroke-linecap='round' stroke-linejoin='round' strokeWidth='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\")\n}\n\n.form-check {\n    display: block;\n    min-height: 1.5rem;\n    padding-left: 1.5em;\n    margin-bottom: .125rem\n}\n\n.form-check .form-check-input {\n    float: left;\n    margin-left: -1.5em\n}\n\n.form-check-reverse {\n    padding-right: 1.5em;\n    padding-left: 0;\n    text-align: right\n}\n\n.form-check-reverse .form-check-input {\n    float: right;\n    margin-right: -1.5em;\n    margin-left: 0\n}\n\n.form-check-input {\n    --bs-form-check-bg: var(--bs-body-bg);\n    width: 1em;\n    height: 1em;\n    margin-top: .25em;\n    vertical-align: top;\n    background-color: var(--bs-form-check-bg);\n    background-image: var(--bs-form-check-bg-image);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    border: var(--bs-border-width) solid var(--bs-border-color);\n    appearance: none;\n    print-color-adjust: exact\n}\n\n.form-check-input[type=checkbox] {\n    border-radius: .25em\n}\n\n.form-check-input[type=radio] {\n    border-radius: 50%\n}\n\n.form-check-input:active {\n    filter: brightness(90%)\n}\n\n.form-check-input:focus {\n    border-color: #abade7;\n    outline: 0;\n    box-shadow: 0 0 0 .25rem rgba(86, 90, 207, .25)\n}\n\n.form-check-input:checked {\n    background-color: #565acf;\n    border-color: #565acf\n}\n\n.form-check-input:checked[type=checkbox] {\n    --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' strokeWidth='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\")\n}\n\n.form-check-input:checked[type=radio] {\n    --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\")\n}\n\n.form-check-input[type=checkbox]:indeterminate {\n    background-color: #565acf;\n    border-color: #565acf;\n    --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' strokeWidth='3' d='M6 10h8'/%3e%3c/svg%3e\")\n}\n\n.form-check-input:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: .5\n}\n\n.form-check-input[disabled]~.form-check-label,\n.form-check-input:disabled~.form-check-label {\n    cursor: default;\n    opacity: .5\n}\n\n.form-switch {\n    padding-left: 2.5em\n}\n\n.form-switch .form-check-input {\n    --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n    width: 2em;\n    margin-left: -2.5em;\n    background-image: var(--bs-form-switch-bg);\n    background-position: left center;\n    border-radius: 2em;\n    transition: background-position .15s ease-in-out\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .form-switch .form-check-input {\n        transition: none\n    }\n}\n\n.form-switch .form-check-input:focus {\n    --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23abade7'/%3e%3c/svg%3e\")\n}\n\n.form-switch .form-check-input:checked {\n    background-position: right center;\n    --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")\n}\n\n.form-switch.form-check-reverse {\n    padding-right: 2.5em;\n    padding-left: 0\n}\n\n.form-switch.form-check-reverse .form-check-input {\n    margin-right: -2.5em;\n    margin-left: 0\n}\n\n.form-check-inline {\n    display: inline-block;\n    margin-right: 1rem\n}\n\n.btn-check {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none\n}\n\n.btn-check[disabled]+.btn,\n.btn-check:disabled+.btn {\n    pointer-events: none;\n    filter: none;\n    opacity: .65\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n    --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\")\n}\n\n.form-range {\n    width: 100%;\n    height: 1rem;\n    padding: 0;\n    background-color: rgba(0, 0, 0, 0);\n    appearance: none\n}\n\n.form-range:focus {\n    outline: 0\n}\n\n.form-range:focus::-webkit-slider-thumb {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 .25rem rgba(86, 90, 207, .25)\n}\n\n.form-range:focus::-moz-range-thumb {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 .25rem rgba(86, 90, 207, .25)\n}\n\n.form-range::-moz-focus-outer {\n    border: 0\n}\n\n.form-range::-webkit-slider-thumb {\n    width: 1rem;\n    height: 1rem;\n    margin-top: -0.25rem;\n    background-color: #565acf;\n    border: 0;\n    border-radius: 1rem;\n    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    appearance: none\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .form-range::-webkit-slider-thumb {\n        transition: none\n    }\n}\n\n.form-range::-webkit-slider-thumb:active {\n    background-color: #cccef1\n}\n\n.form-range::-webkit-slider-runnable-track {\n    width: 100%;\n    height: .5rem;\n    color: rgba(0, 0, 0, 0);\n    cursor: pointer;\n    background-color: var(--bs-tertiary-bg);\n    border-color: rgba(0, 0, 0, 0);\n    border-radius: 1rem\n}\n\n.form-range::-moz-range-thumb {\n    width: 1rem;\n    height: 1rem;\n    background-color: #565acf;\n    border: 0;\n    border-radius: 1rem;\n    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    appearance: none\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .form-range::-moz-range-thumb {\n        transition: none\n    }\n}\n\n.form-range::-moz-range-thumb:active {\n    background-color: #cccef1\n}\n\n.form-range::-moz-range-track {\n    width: 100%;\n    height: .5rem;\n    color: rgba(0, 0, 0, 0);\n    cursor: pointer;\n    background-color: var(--bs-tertiary-bg);\n    border-color: rgba(0, 0, 0, 0);\n    border-radius: 1rem\n}\n\n.form-range:disabled {\n    pointer-events: none\n}\n\n.form-range:disabled::-webkit-slider-thumb {\n    background-color: var(--bs-secondary-color)\n}\n\n.form-range:disabled::-moz-range-thumb {\n    background-color: var(--bs-secondary-color)\n}\n\n.form-floating {\n    position: relative\n}\n\n.form-floating>.form-control,\n.form-floating>.form-control-plaintext,\n.form-floating>.form-select {\n    height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n    min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n    line-height: 1.25\n}\n\n.form-floating>label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%;\n    padding: 1rem .75rem;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: var(--bs-border-width) solid rgba(0, 0, 0, 0);\n    transform-origin: 0 0;\n    transition: opacity .1s ease-in-out, transform .1s ease-in-out\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .form-floating>label {\n        transition: none\n    }\n}\n\n.form-floating>.form-control,\n.form-floating>.form-control-plaintext {\n    padding: 1rem .75rem\n}\n\n.form-floating>.form-control::placeholder,\n.form-floating>.form-control-plaintext::placeholder {\n    color: rgba(0, 0, 0, 0)\n}\n\n.form-floating>.form-control:focus,\n.form-floating>.form-control:not(:placeholder-shown),\n.form-floating>.form-control-plaintext:focus,\n.form-floating>.form-control-plaintext:not(:placeholder-shown) {\n    padding-top: 1.625rem;\n    padding-bottom: .625rem\n}\n\n.form-floating>.form-control:-webkit-autofill,\n.form-floating>.form-control-plaintext:-webkit-autofill {\n    padding-top: 1.625rem;\n    padding-bottom: .625rem\n}\n\n.form-floating>.form-select {\n    padding-top: 1.625rem;\n    padding-bottom: .625rem\n}\n\n.form-floating>.form-control:focus~label,\n.form-floating>.form-control:not(:placeholder-shown)~label,\n.form-floating>.form-control-plaintext~label,\n.form-floating>.form-select~label {\n    color: rgba(var(--bs-body-color-rgb), 0.65);\n    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem)\n}\n\n.form-floating>.form-control:focus~label::after,\n.form-floating>.form-control:not(:placeholder-shown)~label::after,\n.form-floating>.form-control-plaintext~label::after,\n.form-floating>.form-select~label::after {\n    position: absolute;\n    inset: 1rem .375rem;\n    z-index: -1;\n    height: 1.5em;\n    content: \"\";\n    background-color: var(--bs-body-bg);\n    border-radius: var(--bs-border-radius)\n}\n\n.form-floating>.form-control:-webkit-autofill~label {\n    color: rgba(var(--bs-body-color-rgb), 0.65);\n    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem)\n}\n\n.form-floating>.form-control-plaintext~label {\n    border-width: var(--bs-border-width) 0\n}\n\n.form-floating>:disabled~label {\n    color: #6c757d\n}\n\n.form-floating>:disabled~label::after {\n    background-color: var(--bs-secondary-bg)\n}\n\n.input-group {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    width: 100%\n}\n\n.input-group>.form-control,\n.input-group>.form-select,\n.input-group>.form-floating {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0\n}\n\n.input-group>.form-control:focus,\n.input-group>.form-select:focus,\n.input-group>.form-floating:focus-within {\n    z-index: 5\n}\n\n.input-group .btn {\n    position: relative;\n    z-index: 2\n}\n\n.input-group .btn:focus {\n    z-index: 5\n}\n\n.input-group-text {\n    display: flex;\n    align-items: center;\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.5;\n    color: var(--bs-body-color);\n    text-align: center;\n    white-space: nowrap;\n    background-color: var(--bs-tertiary-bg);\n    border: var(--bs-border-width) solid var(--bs-border-color);\n    border-radius: var(--bs-border-radius)\n}\n\n.input-group-lg>.form-control,\n.input-group-lg>.form-select,\n.input-group-lg>.input-group-text,\n.input-group-lg>.btn {\n    padding: .5rem 1rem;\n    font-size: 1.25rem;\n    border-radius: var(--bs-border-radius-lg)\n}\n\n.input-group-sm>.form-control,\n.input-group-sm>.form-select,\n.input-group-sm>.input-group-text,\n.input-group-sm>.btn {\n    padding: .25rem .5rem;\n    font-size: 0.875rem;\n    border-radius: var(--bs-border-radius-sm)\n}\n\n.input-group-lg>.form-select,\n.input-group-sm>.form-select {\n    padding-right: 3rem\n}\n\n.input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-control,\n.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-select {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.input-group.has-validation>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-control,\n.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-select {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n    margin-left: calc(var(--bs-border-width) * -1);\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.input-group>.form-floating:not(:first-child)>.form-control,\n.input-group>.form-floating:not(:first-child)>.form-select {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.valid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: .25rem;\n    font-size: 0.875em;\n    color: var(--bs-form-valid-color)\n}\n\n.valid-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: .25rem .5rem;\n    margin-top: .1rem;\n    font-size: 0.875rem;\n    color: #fff;\n    background-color: var(--bs-success);\n    border-radius: var(--bs-border-radius)\n}\n\n.was-validated :valid~.valid-feedback,\n.was-validated :valid~.valid-tooltip,\n.is-valid~.valid-feedback,\n.is-valid~.valid-tooltip {\n    display: block\n}\n\n.was-validated .form-control:valid,\n.form-control.is-valid {\n    border-color: var(--bs-form-valid-border-color);\n    padding-right: calc(1.5em + 0.75rem);\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23209f84' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right calc(0.375em + 0.1875rem) center;\n    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)\n}\n\n.was-validated .form-control:valid:focus,\n.form-control.is-valid:focus {\n    border-color: var(--bs-form-valid-border-color);\n    box-shadow: 0 0 0 0rem rgba(var(--bs-success-rgb), 0.25)\n}\n\n.was-validated textarea.form-control:valid,\ntextarea.form-control.is-valid {\n    padding-right: calc(1.5em + 0.75rem);\n    background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem)\n}\n\n.was-validated .form-select:valid,\n.form-select.is-valid {\n    border-color: var(--bs-form-valid-border-color)\n}\n\n.was-validated .form-select:valid:not([multiple]):not([size]),\n.was-validated .form-select:valid:not([multiple])[size=\"1\"],\n.form-select.is-valid:not([multiple]):not([size]),\n.form-select.is-valid:not([multiple])[size=\"1\"] {\n    --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23209f84' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n    padding-right: 4.125rem;\n    background-position: right .75rem center, center right 2.25rem;\n    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)\n}\n\n.was-validated .form-select:valid:focus,\n.form-select.is-valid:focus {\n    border-color: var(--bs-form-valid-border-color);\n    box-shadow: 0 0 0 0rem rgba(var(--bs-success-rgb), 0.25)\n}\n\n.was-validated .form-control-color:valid,\n.form-control-color.is-valid {\n    width: calc(3rem + calc(1.5em + 0.75rem))\n}\n\n.was-validated .form-check-input:valid,\n.form-check-input.is-valid {\n    border-color: var(--bs-form-valid-border-color)\n}\n\n.was-validated .form-check-input:valid:checked,\n.form-check-input.is-valid:checked {\n    background-color: var(--bs-form-valid-color)\n}\n\n.was-validated .form-check-input:valid:focus,\n.form-check-input.is-valid:focus {\n    box-shadow: 0 0 0 0rem rgba(var(--bs-success-rgb), 0.25)\n}\n\n.was-validated .form-check-input:valid~.form-check-label,\n.form-check-input.is-valid~.form-check-label {\n    color: var(--bs-form-valid-color)\n}\n\n.form-check-inline .form-check-input~.valid-feedback {\n    margin-left: .5em\n}\n\n.was-validated .input-group>.form-control:not(:focus):valid,\n.input-group>.form-control:not(:focus).is-valid,\n.was-validated .input-group>.form-select:not(:focus):valid,\n.input-group>.form-select:not(:focus).is-valid,\n.was-validated .input-group>.form-floating:not(:focus-within):valid,\n.input-group>.form-floating:not(:focus-within).is-valid {\n    z-index: 3\n}\n\n.invalid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: .25rem;\n    font-size: 0.875em;\n    color: var(--bs-form-invalid-color)\n}\n\n.invalid-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: .25rem .5rem;\n    margin-top: .1rem;\n    font-size: 0.875rem;\n    color: #fff;\n    background-color: var(--bs-danger);\n    border-radius: var(--bs-border-radius)\n}\n\n.was-validated :invalid~.invalid-feedback,\n.was-validated :invalid~.invalid-tooltip,\n.is-invalid~.invalid-feedback,\n.is-invalid~.invalid-tooltip {\n    display: block\n}\n\n.was-validated .form-control:invalid,\n.form-control.is-invalid {\n    border-color: var(--bs-form-invalid-border-color);\n    padding-right: calc(1.5em + 0.75rem);\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f72b50'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f72b50' stroke='none'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right calc(0.375em + 0.1875rem) center;\n    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)\n}\n\n.was-validated .form-control:invalid:focus,\n.form-control.is-invalid:focus {\n    border-color: var(--bs-form-invalid-border-color);\n    box-shadow: 0 0 0 0rem rgba(var(--bs-danger-rgb), 0.25)\n}\n\n.was-validated textarea.form-control:invalid,\ntextarea.form-control.is-invalid {\n    padding-right: calc(1.5em + 0.75rem);\n    background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem)\n}\n\n.was-validated .form-select:invalid,\n.form-select.is-invalid {\n    border-color: var(--bs-form-invalid-border-color)\n}\n\n.was-validated .form-select:invalid:not([multiple]):not([size]),\n.was-validated .form-select:invalid:not([multiple])[size=\"1\"],\n.form-select.is-invalid:not([multiple]):not([size]),\n.form-select.is-invalid:not([multiple])[size=\"1\"] {\n    --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f72b50'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f72b50' stroke='none'/%3e%3c/svg%3e\");\n    padding-right: 4.125rem;\n    background-position: right .75rem center, center right 2.25rem;\n    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)\n}\n\n.was-validated .form-select:invalid:focus,\n.form-select.is-invalid:focus {\n    border-color: var(--bs-form-invalid-border-color);\n    box-shadow: 0 0 0 0rem rgba(var(--bs-danger-rgb), 0.25)\n}\n\n.was-validated .form-control-color:invalid,\n.form-control-color.is-invalid {\n    width: calc(3rem + calc(1.5em + 0.75rem))\n}\n\n.was-validated .form-check-input:invalid,\n.form-check-input.is-invalid {\n    border-color: var(--bs-form-invalid-border-color)\n}\n\n.was-validated .form-check-input:invalid:checked,\n.form-check-input.is-invalid:checked {\n    background-color: var(--bs-form-invalid-color)\n}\n\n.was-validated .form-check-input:invalid:focus,\n.form-check-input.is-invalid:focus {\n    box-shadow: 0 0 0 0rem rgba(var(--bs-danger-rgb), 0.25)\n}\n\n.was-validated .form-check-input:invalid~.form-check-label,\n.form-check-input.is-invalid~.form-check-label {\n    color: var(--bs-form-invalid-color)\n}\n\n.form-check-inline .form-check-input~.invalid-feedback {\n    margin-left: .5em\n}\n\n.was-validated .input-group>.form-control:not(:focus):invalid,\n.input-group>.form-control:not(:focus).is-invalid,\n.was-validated .input-group>.form-select:not(:focus):invalid,\n.input-group>.form-select:not(:focus).is-invalid,\n.was-validated .input-group>.form-floating:not(:focus-within):invalid,\n.input-group>.form-floating:not(:focus-within).is-invalid {\n    z-index: 4\n}\n\n.btn {\n    --bs-btn-padding-x: 0.75rem;\n    --bs-btn-padding-y: 0.375rem;\n    --bs-btn-font-family: ;\n    --bs-btn-font-size: 1rem;\n    --bs-btn-font-weight: 400;\n    --bs-btn-line-height: 1.5;\n    --bs-btn-color: var(--bs-body-color);\n    --bs-btn-bg: transparent;\n    --bs-btn-border-width: var(--bs-border-width);\n    --bs-btn-border-color: transparent;\n    --bs-btn-border-radius: var(--bs-border-radius);\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n    --bs-btn-disabled-opacity: 0.65;\n    --bs-btn-focus-box-shadow: 0 0 0 0rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n    display: inline-block;\n    padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n    font-family: var(--bs-btn-font-family);\n    font-size: var(--bs-btn-font-size);\n    font-weight: var(--bs-btn-font-weight);\n    line-height: var(--bs-btn-line-height);\n    color: var(--bs-btn-color);\n    text-align: center;\n    text-decoration: none;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n    border-radius: var(--bs-btn-border-radius);\n    background-color: var(--bs-btn-bg);\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .btn {\n        transition: none\n    }\n}\n\n.btn:hover {\n    color: var(--bs-btn-hover-color);\n    background-color: #2ab4ff !important;\n    border-color: #2ab4ff !important;\n}\n\n.btn-check+.btn:hover {\n    color: var(--bs-btn-color);\n    background-color: var(--bs-btn-bg);\n    border-color: var(--bs-btn-border-color)\n}\n\n.btn:focus-visible {\n    color: var(--bs-btn-hover-color);\n    background-color: var(--bs-btn-hover-bg);\n    border-color: var(--bs-btn-hover-border-color);\n    outline: 0;\n    box-shadow: var(--bs-btn-focus-box-shadow)\n}\n\n.btn-check:focus-visible+.btn {\n    border-color: var(--bs-btn-hover-border-color);\n    outline: 0;\n    box-shadow: var(--bs-btn-focus-box-shadow)\n}\n\n.btn-check:checked+.btn,\n:not(.btn-check)+.btn:active,\n.btn:first-child:active,\n.btn.active,\n.btn.show {\n    color: var(--bs-btn-active-color);\n    background-color: var(--bs-btn-active-bg);\n    border-color: var(--bs-btn-active-border-color)\n}\n\n.btn-check:checked+.btn:focus-visible,\n:not(.btn-check)+.btn:active:focus-visible,\n.btn:first-child:active:focus-visible,\n.btn.active:focus-visible,\n.btn.show:focus-visible {\n    box-shadow: var(--bs-btn-focus-box-shadow)\n}\n\n.btn:disabled,\n.btn.disabled,\nfieldset:disabled .btn {\n    color: var(--bs-btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--bs-btn-disabled-bg);\n    border-color: var(--bs-btn-disabled-border-color);\n    opacity: var(--bs-btn-disabled-opacity)\n}\n\n.btn-primary {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: var(--bs-primary);\n    --bs-btn-border-color: var(--bs-primary);\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: var(--bs-primary);\n    --bs-btn-hover-border-color: var(--bs-primary);\n    ;\n    --bs-btn-focus-shadow-rgb: 111, 115, 214;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: var(--bs-primary);\n    ;\n    --bs-btn-active-border-color: #41449b;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #565acf;\n    --bs-btn-disabled-border-color: #565acf;\n}\n\n.btn-secondary {\n    --bs-btn-color: #000;\n    --bs-btn-bg: #008bb1;\n    --bs-btn-border-color: #008bb1;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #2ab4ff;\n    --bs-btn-hover-border-color: #2ab4ff;\n    --bs-btn-focus-shadow-rgb: 205, 101, 43;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #2ab4ff;\n    --bs-btn-active-border-color: #2ab4ff;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #000;\n    --bs-btn-disabled-bg: #2ab4ff;\n    --bs-btn-disabled-border-color: #2ab4ff\n}\n\n.btn-success {\n    --bs-btn-color: #000;\n    --bs-btn-bg: #209f84;\n    --bs-btn-border-color: #209f84;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #41ad96;\n    --bs-btn-hover-border-color: #36a990;\n    --bs-btn-focus-shadow-rgb: 27, 135, 112;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #4db29d;\n    --bs-btn-active-border-color: #36a990;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #000;\n    --bs-btn-disabled-bg: #209f84;\n    --bs-btn-disabled-border-color: #209f84\n}\n\n.btn-info {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #2754e6;\n    --bs-btn-border-color: #2754e6;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #2147c4;\n    --bs-btn-hover-border-color: #1f43b8;\n    --bs-btn-focus-shadow-rgb: 71, 110, 234;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #1f43b8;\n    --bs-btn-active-border-color: #1d3fad;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #2754e6;\n    --bs-btn-disabled-border-color: #2754e6\n}\n\n.btn-warning {\n    --bs-btn-color: #000;\n    --bs-btn-bg: #fe970e;\n    --bs-btn-border-color: #fe970e;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #fea732;\n    --bs-btn-hover-border-color: #fea126;\n    --bs-btn-focus-shadow-rgb: 216, 128, 12;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #feac3e;\n    --bs-btn-active-border-color: #fea126;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #000;\n    --bs-btn-disabled-bg: #fe970e;\n    --bs-btn-disabled-border-color: #fe970e\n}\n\n.btn-danger {\n    --bs-btn-color: #000;\n    --bs-btn-bg: #f72b50;\n    --bs-btn-border-color: #f72b50;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #f84b6a;\n    --bs-btn-hover-border-color: #f84062;\n    --bs-btn-focus-shadow-rgb: 210, 37, 68;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #f95573;\n    --bs-btn-active-border-color: #f84062;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #000;\n    --bs-btn-disabled-bg: #f72b50;\n    --bs-btn-disabled-border-color: #f72b50\n}\n\n.btn-light {\n    --bs-btn-color: #000;\n    --bs-btn-bg: #fff;\n    --bs-btn-border-color: #fff;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #d9d9d9;\n    --bs-btn-hover-border-color: #cccccc;\n    --bs-btn-focus-shadow-rgb: 217, 217, 217;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #cccccc;\n    --bs-btn-active-border-color: #bfbfbf;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #000;\n    --bs-btn-disabled-bg: #fff;\n    --bs-btn-disabled-border-color: #fff\n}\n\n.btn-dark {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: var(--bs-dark);\n    --bs-btn-border-color: var(--bs-dark);\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #41438c;\n    --bs-btn-hover-border-color: #353886;\n    --bs-btn-focus-shadow-rgb: 65, 67, 140;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #4c4e93;\n    --bs-btn-active-border-color: #353886;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: var(--bs-dark);\n    --bs-btn-disabled-border-color: var(--bs-dark)\n}\n\n.btn-outline-primary {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: var(--bs-primary);\n    --bs-btn-border-color: var(--bs-primary);\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: var(--bs-primary);\n    --bs-btn-hover-border-color: var(--bs-primary);\n    --bs-btn-focus-shadow-rgb: 111, 115, 214;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: var(--bs-primary);\n    --bs-btn-active-border-color: #41449b;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #565acf;\n    --bs-btn-disabled-border-color: #565acf;\n    --bs-gradient: none\n}\n\n.btn-outline-secondary {\n    --bs-btn-color: #f17732;\n    --bs-btn-border-color: #f17732;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #f17732;\n    --bs-btn-hover-border-color: #f17732;\n    --bs-btn-focus-shadow-rgb: 241, 119, 50;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #f17732;\n    --bs-btn-active-border-color: #f17732;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #f17732;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #f17732;\n    --bs-gradient: none\n}\n\n.btn-outline-success {\n    --bs-btn-color: #209f84;\n    --bs-btn-border-color: #209f84;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #209f84;\n    --bs-btn-hover-border-color: #209f84;\n    --bs-btn-focus-shadow-rgb: 32, 159, 132;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #209f84;\n    --bs-btn-active-border-color: #209f84;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #209f84;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #209f84;\n    --bs-gradient: none\n}\n\n.btn-outline-info {\n    --bs-btn-color: #2754e6;\n    --bs-btn-border-color: #2754e6;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #2754e6;\n    --bs-btn-hover-border-color: #2754e6;\n    --bs-btn-focus-shadow-rgb: 39, 84, 230;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #2754e6;\n    --bs-btn-active-border-color: #2754e6;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #2754e6;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #2754e6;\n    --bs-gradient: none\n}\n\n.btn-outline-warning {\n    --bs-btn-color: #fe970e;\n    --bs-btn-border-color: #fe970e;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #fe970e;\n    --bs-btn-hover-border-color: #fe970e;\n    --bs-btn-focus-shadow-rgb: 254, 151, 14;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #fe970e;\n    --bs-btn-active-border-color: #fe970e;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fe970e;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #fe970e;\n    --bs-gradient: none\n}\n\n.btn-outline-danger {\n    --bs-btn-color: #f72b50;\n    --bs-btn-border-color: #f72b50;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #f72b50;\n    --bs-btn-hover-border-color: #f72b50;\n    --bs-btn-focus-shadow-rgb: 247, 43, 80;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #f72b50;\n    --bs-btn-active-border-color: #f72b50;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #f72b50;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #f72b50;\n    --bs-gradient: none\n}\n\n.btn-outline-light {\n    --bs-btn-color: #fff;\n    --bs-btn-border-color: #fff;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #fff;\n    --bs-btn-hover-border-color: #fff;\n    --bs-btn-focus-shadow-rgb: 255, 255, 255;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #fff;\n    --bs-btn-active-border-color: #fff;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #fff;\n    --bs-gradient: none\n}\n\n.btn-outline-dark {\n    --bs-btn-color: var(--bs-dark);\n    --bs-btn-border-color: var(--bs-dark);\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: var(--bs-dark);\n    --bs-btn-hover-border-color: var(--bs-dark);\n    --bs-btn-focus-shadow-rgb: 31, 34, 120;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: var(--bs-dark);\n    --bs-btn-active-border-color: var(--bs-dark);\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: var(--bs-dark);\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: var(--bs-dark);\n    --bs-gradient: none\n}\n\n.btn-link {\n    --bs-btn-font-weight: 400;\n    --bs-btn-color: var(--bs-link-color);\n    --bs-btn-bg: transparent;\n    --bs-btn-border-color: transparent;\n    --bs-btn-hover-color: var(--bs-link-hover-color);\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-active-color: var(--bs-link-hover-color);\n    --bs-btn-active-border-color: transparent;\n    --bs-btn-disabled-color: #6c757d;\n    --bs-btn-disabled-border-color: transparent;\n    --bs-btn-box-shadow: 0 0 0 #000;\n    --bs-btn-focus-shadow-rgb: 111, 115, 214;\n    text-decoration: underline\n}\n\n.btn-link:focus-visible {\n    color: var(--bs-btn-color)\n}\n\n.btn-link:hover {\n    color: var(--bs-btn-hover-color)\n}\n\n.btn-lg,\n.btn-group-lg>.btn {\n    --bs-btn-padding-y: 0.5rem;\n    --bs-btn-padding-x: 1rem;\n    --bs-btn-font-size: 1.25rem;\n    --bs-btn-border-radius: var(--bs-border-radius-lg)\n}\n\n.btn-sm,\n.btn-group-sm>.btn {\n    --bs-btn-padding-y: 0.25rem;\n    --bs-btn-padding-x: 0.5rem;\n    --bs-btn-font-size: 0.875rem;\n    --bs-btn-border-radius: var(--bs-border-radius-sm)\n}\n\n.fade {\n    transition: opacity .15s linear\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .fade {\n        transition: none\n    }\n}\n\n.fade:not(.show) {\n    opacity: 0\n}\n\n.collapse:not(.show) {\n    display: none\n}\n\n.collapsing {\n    height: 0;\n    overflow: hidden;\n    transition: height .35s ease\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .collapsing {\n        transition: none\n    }\n}\n\n.collapsing.collapse-horizontal {\n    width: 0;\n    height: auto;\n    transition: width .35s ease\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .collapsing.collapse-horizontal {\n        transition: none\n    }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n    position: relative\n}\n\n.dropdown-toggle {\n    white-space: nowrap\n}\n\n.dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid;\n    border-right: .3em solid rgba(0, 0, 0, 0);\n    border-bottom: 0;\n    border-left: .3em solid rgba(0, 0, 0, 0)\n}\n\n.dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropdown-menu {\n    --bs-dropdown-zindex: 1000;\n    --bs-dropdown-min-width: 10rem;\n    --bs-dropdown-padding-x: 0;\n    --bs-dropdown-padding-y: 0.5rem;\n    --bs-dropdown-spacer: 0.125rem;\n    --bs-dropdown-font-size: 1rem;\n    --bs-dropdown-color: var(--bs-body-color);\n    --bs-dropdown-bg: var(--bs-body-bg);\n    --bs-dropdown-border-color: var(--bs-border-color-translucent);\n    --bs-dropdown-border-radius: var(--bs-border-radius);\n    --bs-dropdown-border-width: var(--bs-border-width);\n    --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));\n    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n    --bs-dropdown-divider-margin-y: 0.5rem;\n    --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    --bs-dropdown-link-color: var(--bs-body-color);\n    --bs-dropdown-link-hover-color: var(--bs-body-color);\n    --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n    --bs-dropdown-link-active-color: #fff;\n    --bs-dropdown-link-active-bg: #565acf;\n    --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);\n    --bs-dropdown-item-padding-x: 1rem;\n    --bs-dropdown-item-padding-y: 0.25rem;\n    --bs-dropdown-header-color: #6c757d;\n    --bs-dropdown-header-padding-x: 1rem;\n    --bs-dropdown-header-padding-y: 0.5rem;\n    position: absolute;\n    z-index: var(--bs-dropdown-zindex);\n    display: none;\n    min-width: var(--bs-dropdown-min-width);\n    padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n    margin: 0;\n    font-size: var(--bs-dropdown-font-size);\n    color: var(--bs-dropdown-color);\n    text-align: left;\n    list-style: none;\n    background-color: var(--bs-dropdown-bg);\n    background-clip: padding-box;\n    border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n    border-radius: var(--bs-dropdown-border-radius)\n}\n\n.dropdown-menu[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--bs-dropdown-spacer)\n}\n\n.dropdown-menu-start {\n    --bs-position: start\n}\n\n.dropdown-menu-start[data-bs-popper] {\n    right: auto;\n    left: 0\n}\n\n.dropdown-menu-end {\n    --bs-position: end\n}\n\n.dropdown-menu-end[data-bs-popper] {\n    right: 0;\n    left: auto\n}\n\n@media(min-width: 576px) {\n    .dropdown-menu-sm-start {\n        --bs-position: start\n    }\n\n    .dropdown-menu-sm-start[data-bs-popper] {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-sm-end {\n        --bs-position: end\n    }\n\n    .dropdown-menu-sm-end[data-bs-popper] {\n        right: 0;\n        left: auto\n    }\n}\n\n@media(min-width: 768px) {\n    .dropdown-menu-md-start {\n        --bs-position: start\n    }\n\n    .dropdown-menu-md-start[data-bs-popper] {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-md-end {\n        --bs-position: end\n    }\n\n    .dropdown-menu-md-end[data-bs-popper] {\n        right: 0;\n        left: auto\n    }\n}\n\n@media(min-width: 992px) {\n    .dropdown-menu-lg-start {\n        --bs-position: start\n    }\n\n    .dropdown-menu-lg-start[data-bs-popper] {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-lg-end {\n        --bs-position: end\n    }\n\n    .dropdown-menu-lg-end[data-bs-popper] {\n        right: 0;\n        left: auto\n    }\n}\n\n@media(min-width: 1200px) {\n    .dropdown-menu-xl-start {\n        --bs-position: start\n    }\n\n    .dropdown-menu-xl-start[data-bs-popper] {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-xl-end {\n        --bs-position: end\n    }\n\n    .dropdown-menu-xl-end[data-bs-popper] {\n        right: 0;\n        left: auto\n    }\n}\n\n@media(min-width: 1440) {\n    .dropdown-menu-xxl-start {\n        --bs-position: start\n    }\n\n    .dropdown-menu-xxl-start[data-bs-popper] {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-xxl-end {\n        --bs-position: end\n    }\n\n    .dropdown-menu-xxl-end[data-bs-popper] {\n        right: 0;\n        left: auto\n    }\n}\n\n.dropup .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--bs-dropdown-spacer)\n}\n\n.dropup .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: 0;\n    border-right: .3em solid rgba(0, 0, 0, 0);\n    border-bottom: .3em solid;\n    border-left: .3em solid rgba(0, 0, 0, 0)\n}\n\n.dropup .dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--bs-dropdown-spacer)\n}\n\n.dropend .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid rgba(0, 0, 0, 0);\n    border-right: 0;\n    border-bottom: .3em solid rgba(0, 0, 0, 0);\n    border-left: .3em solid\n}\n\n.dropend .dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropend .dropdown-toggle::after {\n    vertical-align: 0\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--bs-dropdown-spacer)\n}\n\n.dropstart .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\"\n}\n\n.dropstart .dropdown-toggle::after {\n    display: none\n}\n\n.dropstart .dropdown-toggle::before {\n    display: inline-block;\n    margin-right: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid rgba(0, 0, 0, 0);\n    border-right: .3em solid;\n    border-bottom: .3em solid rgba(0, 0, 0, 0)\n}\n\n.dropstart .dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropstart .dropdown-toggle::before {\n    vertical-align: 0\n}\n\n.dropdown-divider {\n    height: 0;\n    margin: var(--bs-dropdown-divider-margin-y) 0;\n    overflow: hidden;\n    border-top: 1px solid var(--bs-dropdown-divider-bg);\n    opacity: 1\n}\n\n.dropdown-item {\n    display: block;\n    width: 100%;\n    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n    clear: both;\n    font-weight: 400;\n    color: var(--bs-dropdown-link-color);\n    text-align: inherit;\n    text-decoration: none;\n    white-space: nowrap;\n    background-color: rgba(0, 0, 0, 0);\n    border: 0;\n    border-radius: var(--bs-dropdown-item-border-radius, 0)\n}\n\n.dropdown-item:hover,\n.dropdown-item:focus {\n    color: var(--bs-dropdown-link-hover-color);\n    background-color: var(--bs-dropdown-link-hover-bg)\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n    color: var(--bs-dropdown-link-active-color);\n    text-decoration: none;\n    background-color: var(--bs-dropdown-link-active-bg)\n}\n\n.dropdown-item.disabled,\n.dropdown-item:disabled {\n    color: var(--bs-dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: rgba(0, 0, 0, 0)\n}\n\n.dropdown-menu.show {\n    display: block\n}\n\n.dropdown-header {\n    display: block;\n    padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n    margin-bottom: 0;\n    font-size: 0.875rem;\n    color: var(--bs-dropdown-header-color);\n    white-space: nowrap\n}\n\n.dropdown-item-text {\n    display: block;\n    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n    color: var(--bs-dropdown-link-color)\n}\n\n.dropdown-menu-dark {\n    --bs-dropdown-color: #dee2e6;\n    --bs-dropdown-bg: #343a40;\n    --bs-dropdown-border-color: var(--bs-border-color-translucent);\n    --bs-dropdown-box-shadow: ;\n    --bs-dropdown-link-color: #dee2e6;\n    --bs-dropdown-link-hover-color: #fff;\n    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n    --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n    --bs-dropdown-link-active-color: #fff;\n    --bs-dropdown-link-active-bg: #565acf;\n    --bs-dropdown-link-disabled-color: #adb5bd;\n    --bs-dropdown-header-color: #adb5bd\n}\n\n.btn-group,\n.btn-group-vertical {\n    position: relative;\n    display: inline-flex;\n    vertical-align: middle\n}\n\n.btn-group>.btn,\n.btn-group-vertical>.btn {\n    position: relative;\n    flex: 1 1 auto\n}\n\n.btn-group>.btn-check:checked+.btn,\n.btn-group>.btn-check:focus+.btn,\n.btn-group>.btn:hover,\n.btn-group>.btn:focus,\n.btn-group>.btn:active,\n.btn-group>.btn.active,\n.btn-group-vertical>.btn-check:checked+.btn,\n.btn-group-vertical>.btn-check:focus+.btn,\n.btn-group-vertical>.btn:hover,\n.btn-group-vertical>.btn:focus,\n.btn-group-vertical>.btn:active,\n.btn-group-vertical>.btn.active {\n    z-index: 1\n}\n\n.btn-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start\n}\n\n.btn-toolbar .input-group {\n    width: auto\n}\n\n.btn-group {\n    border-radius: var(--bs-border-radius)\n}\n\n.btn-group>:not(.btn-check:first-child)+.btn,\n.btn-group>.btn-group:not(:first-child) {\n    margin-left: calc(var(--bs-border-width) * -1)\n}\n\n.btn-group>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group>.btn.dropdown-toggle-split:first-child,\n.btn-group>.btn-group:not(:last-child)>.btn {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.btn-group>.btn:nth-child(n+3),\n.btn-group>:not(.btn-check)+.btn,\n.btn-group>.btn-group:not(:first-child)>.btn {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.dropdown-toggle-split {\n    padding-right: .5625rem;\n    padding-left: .5625rem\n}\n\n.dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after,\n.dropend .dropdown-toggle-split::after {\n    margin-left: 0\n}\n\n.dropstart .dropdown-toggle-split::before {\n    margin-right: 0\n}\n\n.btn-sm+.dropdown-toggle-split,\n.btn-group-sm>.btn+.dropdown-toggle-split {\n    padding-right: .375rem;\n    padding-left: .375rem\n}\n\n.btn-lg+.dropdown-toggle-split,\n.btn-group-lg>.btn+.dropdown-toggle-split {\n    padding-right: .75rem;\n    padding-left: .75rem\n}\n\n.btn-group-vertical {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center\n}\n\n.btn-group-vertical>.btn,\n.btn-group-vertical>.btn-group {\n    width: 100%\n}\n\n.btn-group-vertical>.btn:not(:first-child),\n.btn-group-vertical>.btn-group:not(:first-child) {\n    margin-top: calc(var(--bs-border-width) * -1)\n}\n\n.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical>.btn-group:not(:last-child)>.btn {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.btn-group-vertical>.btn~.btn,\n.btn-group-vertical>.btn-group:not(:first-child)>.btn {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0\n}\n\n.nav {\n    --bs-nav-link-padding-x: 1rem;\n    --bs-nav-link-padding-y: 0.5rem;\n    --bs-nav-link-font-weight: ;\n    --bs-nav-link-color: var(--bs-link-color);\n    --bs-nav-link-hover-color: var(--bs-link-hover-color);\n    --bs-nav-link-disabled-color: var(--bs-secondary-color);\n    display: flex;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none\n}\n\n.nav-link {\n    display: block;\n    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n    font-size: var(--bs-nav-link-font-size);\n    font-weight: var(--bs-nav-link-font-weight);\n    color: var(--bs-nav-link-color);\n    text-decoration: none;\n    background: none;\n    border: 0;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .nav-link {\n        transition: none\n    }\n}\n\n.nav-link:hover,\n.nav-link:focus {\n    color: var(--bs-nav-link-hover-color)\n}\n\n.nav-link:focus-visible {\n    outline: 0;\n    box-shadow: 0 0 0 .25rem rgba(86, 90, 207, .25)\n}\n\n.nav-link.disabled {\n    color: var(--bs-nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default\n}\n\n.nav-tabs {\n    --bs-nav-tabs-border-width: var(--bs-border-width);\n    --bs-nav-tabs-border-color: var(--bs-border-color);\n    --bs-nav-tabs-border-radius: var(--bs-border-radius);\n    --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);\n    --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n    --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n    --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);\n    border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color)\n}\n\n.nav-tabs .nav-link {\n    margin-bottom: calc(-1*var(--bs-nav-tabs-border-width));\n    border: var(--bs-nav-tabs-border-width) solid rgba(0, 0, 0, 0);\n    border-top-left-radius: var(--bs-nav-tabs-border-radius);\n    border-top-right-radius: var(--bs-nav-tabs-border-radius)\n}\n\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n    isolation: isolate;\n    border-color: var(--bs-nav-tabs-link-hover-border-color)\n}\n\n.nav-tabs .nav-link.disabled,\n.nav-tabs .nav-link:disabled {\n    color: var(--bs-nav-link-disabled-color);\n    background-color: rgba(0, 0, 0, 0);\n    border-color: rgba(0, 0, 0, 0)\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n    color: var(--bs-nav-tabs-link-active-color);\n    background-color: var(--bs-nav-tabs-link-active-bg);\n    border-color: var(--bs-nav-tabs-link-active-border-color)\n}\n\n.nav-tabs .dropdown-menu {\n    margin-top: calc(-1*var(--bs-nav-tabs-border-width));\n    border-top-left-radius: 0;\n    border-top-right-radius: 0\n}\n\n.nav-pills {\n    --bs-nav-pills-border-radius: var(--bs-border-radius);\n    --bs-nav-pills-link-active-color: #fff;\n    --bs-nav-pills-link-active-bg: #565acf\n}\n\n.nav-pills .nav-link {\n    border-radius: var(--bs-nav-pills-border-radius)\n}\n\n.nav-pills .nav-link:disabled {\n    color: var(--bs-nav-link-disabled-color);\n    background-color: rgba(0, 0, 0, 0);\n    border-color: rgba(0, 0, 0, 0)\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n    color: var(--bs-nav-pills-link-active-color);\n    background-color: var(--bs-nav-pills-link-active-bg)\n}\n\n.nav-underline {\n    --bs-nav-underline-gap: 1rem;\n    --bs-nav-underline-border-width: 0.125rem;\n    --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n    gap: var(--bs-nav-underline-gap)\n}\n\n.nav-underline .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--bs-nav-underline-border-width) solid rgba(0, 0, 0, 0)\n}\n\n.nav-underline .nav-link:hover,\n.nav-underline .nav-link:focus {\n    border-bottom-color: currentcolor\n}\n\n.nav-underline .nav-link.active,\n.nav-underline .show>.nav-link {\n    font-weight: 700;\n    color: var(--bs-nav-underline-link-active-color);\n    border-bottom-color: currentcolor\n}\n\n.nav-fill>.nav-link,\n.nav-fill .nav-item {\n    flex: 1 1 auto;\n    text-align: center\n}\n\n.nav-justified>.nav-link,\n.nav-justified .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n    width: 100%\n}\n\n.tab-content>.tab-pane {\n    display: none\n}\n\n.tab-content>.active {\n    display: block\n}\n\n.navbar {\n    --bs-navbar-padding-x: 0;\n    --bs-navbar-padding-y: 0.5rem;\n    --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n    --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n    --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n    --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n    --bs-navbar-brand-padding-y: 0.3125rem;\n    --bs-navbar-brand-margin-end: 1rem;\n    --bs-navbar-brand-font-size: 1.25rem;\n    --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n    --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n    --bs-navbar-nav-link-padding-x: 0.5rem;\n    --bs-navbar-toggler-padding-y: 0.25rem;\n    --bs-navbar-toggler-padding-x: 0.75rem;\n    --bs-navbar-toggler-font-size: 1.25rem;\n    --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2868, 68, 68, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' strokeWidth='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n    --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n    --bs-navbar-toggler-border-radius: var(--bs-border-radius);\n    --bs-navbar-toggler-focus-width: 0rem;\n    --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x)\n}\n\n.navbar>.container,\n.navbar>.container-fluid,\n.navbar>.container-sm,\n.navbar>.container-md,\n.navbar>.container-lg,\n.navbar>.container-xl {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between\n}\n\n.navbar-brand {\n    padding-top: var(--bs-navbar-brand-padding-y);\n    padding-bottom: var(--bs-navbar-brand-padding-y);\n    margin-right: var(--bs-navbar-brand-margin-end);\n    font-size: var(--bs-navbar-brand-font-size);\n    color: var(--bs-navbar-brand-color);\n    text-decoration: none;\n    white-space: nowrap\n}\n\n.navbar-brand:hover,\n.navbar-brand:focus {\n    color: var(--bs-navbar-brand-hover-color)\n}\n\n.navbar-nav {\n    --bs-nav-link-padding-x: 0;\n    --bs-nav-link-padding-y: 0.5rem;\n    --bs-nav-link-font-weight: ;\n    --bs-nav-link-color: var(--bs-navbar-color);\n    --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n    --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none\n}\n\n.navbar-nav .nav-link.active,\n.navbar-nav .nav-link.show {\n    color: var(--bs-navbar-active-color)\n}\n\n.navbar-nav .dropdown-menu {\n    position: static\n}\n\n.navbar-text {\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n    color: var(--bs-navbar-color)\n}\n\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n    color: var(--bs-navbar-active-color)\n}\n\n.navbar-collapse {\n    flex-basis: 100%;\n    flex-grow: 1;\n    align-items: center\n}\n\n.navbar-toggler {\n    padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n    font-size: var(--bs-navbar-toggler-font-size);\n    line-height: 1;\n    color: var(--bs-navbar-color);\n    background-color: rgba(0, 0, 0, 0);\n    border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n    border-radius: var(--bs-navbar-toggler-border-radius);\n    transition: var(--bs-navbar-toggler-transition)\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .navbar-toggler {\n        transition: none\n    }\n}\n\n.navbar-toggler:hover {\n    text-decoration: none\n}\n\n.navbar-toggler:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width)\n}\n\n.navbar-toggler-icon {\n    display: inline-block;\n    width: 1.5em;\n    height: 1.5em;\n    vertical-align: middle;\n    background-image: var(--bs-navbar-toggler-icon-bg);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 100%\n}\n\n.navbar-nav-scroll {\n    max-height: var(--bs-scroll-height, 75vh);\n    overflow-y: auto\n}\n\n@media(min-width: 576px) {\n    .navbar-expand-sm {\n        flex-wrap: nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-sm .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-sm .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-sm .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x)\n    }\n\n    .navbar-expand-sm .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-sm .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-sm .navbar-toggler {\n        display: none\n    }\n\n    .navbar-expand-sm .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: rgba(0, 0, 0, 0) !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none\n    }\n\n    .navbar-expand-sm .offcanvas .offcanvas-header {\n        display: none\n    }\n\n    .navbar-expand-sm .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible\n    }\n}\n\n@media(min-width: 768px) {\n    .navbar-expand-md {\n        flex-wrap: nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-md .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-md .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-md .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x)\n    }\n\n    .navbar-expand-md .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-md .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-md .navbar-toggler {\n        display: none\n    }\n\n    .navbar-expand-md .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: rgba(0, 0, 0, 0) !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none\n    }\n\n    .navbar-expand-md .offcanvas .offcanvas-header {\n        display: none\n    }\n\n    .navbar-expand-md .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible\n    }\n}\n\n@media(min-width: 992px) {\n    .navbar-expand-lg {\n        flex-wrap: nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-lg .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-lg .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x)\n    }\n\n    .navbar-expand-lg .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-lg .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-lg .navbar-toggler {\n        display: none\n    }\n\n    .navbar-expand-lg .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: rgba(0, 0, 0, 0) !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none\n    }\n\n    .navbar-expand-lg .offcanvas .offcanvas-header {\n        display: none\n    }\n\n    .navbar-expand-lg .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible\n    }\n}\n\n@media(min-width: 1200px) {\n    .navbar-expand-xl {\n        flex-wrap: nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-xl .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-xl .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-xl .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x)\n    }\n\n    .navbar-expand-xl .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-xl .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-xl .navbar-toggler {\n        display: none\n    }\n\n    .navbar-expand-xl .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: rgba(0, 0, 0, 0) !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none\n    }\n\n    .navbar-expand-xl .offcanvas .offcanvas-header {\n        display: none\n    }\n\n    .navbar-expand-xl .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible\n    }\n}\n\n@media(min-width: 1440) {\n    .navbar-expand-xxl {\n        flex-wrap: nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-xxl .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-xxl .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-xxl .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x)\n    }\n\n    .navbar-expand-xxl .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-xxl .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-xxl .navbar-toggler {\n        display: none\n    }\n\n    .navbar-expand-xxl .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: rgba(0, 0, 0, 0) !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none\n    }\n\n    .navbar-expand-xxl .offcanvas .offcanvas-header {\n        display: none\n    }\n\n    .navbar-expand-xxl .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible\n    }\n}\n\n.navbar-expand {\n    flex-wrap: nowrap;\n    justify-content: flex-start\n}\n\n.navbar-expand .navbar-nav {\n    flex-direction: row\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n    position: absolute\n}\n\n.navbar-expand .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x)\n}\n\n.navbar-expand .navbar-nav-scroll {\n    overflow: visible\n}\n\n.navbar-expand .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto\n}\n\n.navbar-expand .navbar-toggler {\n    display: none\n}\n\n.navbar-expand .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: rgba(0, 0, 0, 0) !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none\n}\n\n.navbar-expand .offcanvas .offcanvas-header {\n    display: none\n}\n\n.navbar-expand .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n    --bs-navbar-color: rgba(255, 255, 255, 0.55);\n    --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n    --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n    --bs-navbar-active-color: #fff;\n    --bs-navbar-brand-color: #fff;\n    --bs-navbar-brand-hover-color: #fff;\n    --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n    --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' strokeWidth='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n    --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' strokeWidth='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")\n}\n\n.card {\n    --bs-card-spacer-y: 1rem;\n    --bs-card-spacer-x: 1rem;\n    --bs-card-title-spacer-y: 0.5rem;\n    --bs-card-title-color: ;\n    --bs-card-subtitle-color: ;\n    --bs-card-border-width: var(--bs-border-width);\n    --bs-card-border-color: var(--bs-border-color-translucent);\n    --bs-card-border-radius: var(--bs-border-radius);\n    --bs-card-box-shadow: ;\n    --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n    --bs-card-cap-padding-y: 0.5rem;\n    --bs-card-cap-padding-x: 1rem;\n    --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n    --bs-card-cap-color: ;\n    --bs-card-height: ;\n    --bs-card-color: ;\n    --bs-card-bg: var(--bs-body-bg);\n    --bs-card-img-overlay-padding: 1rem;\n    --bs-card-group-margin: 15px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    height: var(--bs-card-height);\n    color: var(--bs-body-color);\n    word-wrap: break-word;\n    background-color: var(--bs-card-bg);\n    background-clip: border-box;\n    border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n    border-radius: var(--bs-card-border-radius)\n}\n\n.card>hr {\n    margin-right: 0;\n    margin-left: 0\n}\n\n.card>.list-group {\n    border-top: inherit;\n    border-bottom: inherit\n}\n\n.card>.list-group:first-child {\n    border-top-width: 0;\n    border-top-left-radius: var(--bs-card-inner-border-radius);\n    border-top-right-radius: var(--bs-card-inner-border-radius)\n}\n\n.card>.list-group:last-child {\n    border-bottom-width: 0;\n    border-bottom-right-radius: var(--bs-card-inner-border-radius);\n    border-bottom-left-radius: var(--bs-card-inner-border-radius)\n}\n\n.card>.card-header+.list-group,\n.card>.list-group+.card-footer {\n    border-top: 0\n}\n\n.card-body {\n    flex: 1 1 auto;\n    padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n    color: var(--bs-card-color)\n}\n\n.card-title {\n    margin-bottom: var(--bs-card-title-spacer-y);\n    color: var(--bs-card-title-color)\n}\n\n.card-subtitle {\n    margin-top: calc(-0.5*var(--bs-card-title-spacer-y));\n    margin-bottom: 0;\n    color: var(--bs-card-subtitle-color)\n}\n\n.card-text:last-child {\n    margin-bottom: 0\n}\n\n.card-link+.card-link {\n    margin-left: var(--bs-card-spacer-x)\n}\n\n.card-header {\n    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n    margin-bottom: 0;\n    color: var(--bs-card-cap-color);\n    background-color: var(--bs-card-cap-bg);\n    border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color)\n}\n\n.card-header:first-child {\n    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0\n}\n\n.card-footer {\n    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n    color: var(--bs-card-cap-color);\n    background-color: var(--bs-card-cap-bg);\n    border-top: var(--bs-card-border-width) solid var(--bs-card-border-color)\n}\n\n.card-footer:last-child {\n    border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius)\n}\n\n.card-header-tabs {\n    margin-right: calc(-0.5*var(--bs-card-cap-padding-x));\n    margin-bottom: calc(-1*var(--bs-card-cap-padding-y));\n    margin-left: calc(-0.5*var(--bs-card-cap-padding-x));\n    border-bottom: 0\n}\n\n.card-header-tabs .nav-link.active {\n    background-color: var(--bs-card-bg);\n    border-bottom-color: var(--bs-card-bg)\n}\n\n.card-header-pills {\n    margin-right: calc(-0.5*var(--bs-card-cap-padding-x));\n    margin-left: calc(-0.5*var(--bs-card-cap-padding-x))\n}\n\n.card-img-overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: var(--bs-card-img-overlay-padding);\n    border-radius: var(--bs-card-inner-border-radius)\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n    width: 100%\n}\n\n.card-img,\n.card-img-top {\n    border-top-left-radius: var(--bs-card-inner-border-radius);\n    border-top-right-radius: var(--bs-card-inner-border-radius)\n}\n\n.card-img,\n.card-img-bottom {\n    border-bottom-right-radius: var(--bs-card-inner-border-radius);\n    border-bottom-left-radius: var(--bs-card-inner-border-radius)\n}\n\n.card-group>.card {\n    margin-bottom: var(--bs-card-group-margin)\n}\n\n@media(min-width: 576px) {\n    .card-group {\n        display: flex;\n        flex-flow: row wrap\n    }\n\n    .card-group>.card {\n        flex: 1 0 0%;\n        margin-bottom: 0\n    }\n\n    .card-group>.card+.card {\n        margin-left: 0;\n        border-left: 0\n    }\n\n    .card-group>.card:not(:last-child) {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0\n    }\n\n    .card-group>.card:not(:last-child) .card-img-top,\n    .card-group>.card:not(:last-child) .card-header {\n        border-top-right-radius: 0\n    }\n\n    .card-group>.card:not(:last-child) .card-img-bottom,\n    .card-group>.card:not(:last-child) .card-footer {\n        border-bottom-right-radius: 0\n    }\n\n    .card-group>.card:not(:first-child) {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0\n    }\n\n    .card-group>.card:not(:first-child) .card-img-top,\n    .card-group>.card:not(:first-child) .card-header {\n        border-top-left-radius: 0\n    }\n\n    .card-group>.card:not(:first-child) .card-img-bottom,\n    .card-group>.card:not(:first-child) .card-footer {\n        border-bottom-left-radius: 0\n    }\n}\n\n.accordion {\n    --bs-accordion-color: var(--bs-body-color);\n    --bs-accordion-bg: var(--bs-body-bg);\n    --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n    --bs-accordion-border-color: var(--bs-border-color);\n    --bs-accordion-border-width: var(--bs-border-width);\n    --bs-accordion-border-radius: var(--bs-border-radius);\n    --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n    --bs-accordion-btn-padding-x: 1.25rem;\n    --bs-accordion-btn-padding-y: 1rem;\n    --bs-accordion-btn-color: var(--bs-body-color);\n    --bs-accordion-btn-bg: var(--bs-accordion-bg);\n    --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23444'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n    --bs-accordion-btn-icon-width: 1.25rem;\n    --bs-accordion-btn-icon-transform: rotate(-180deg);\n    --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n    --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23222453'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n    --bs-accordion-btn-focus-border-color: #abade7;\n    --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(86, 90, 207, 0.25);\n    --bs-accordion-body-padding-x: 1.25rem;\n    --bs-accordion-body-padding-y: 1rem;\n    --bs-accordion-active-color: var(--bs-primary-text-emphasis);\n    --bs-accordion-active-bg: var(--bs-primary-bg-subtle)\n}\n\n.accordion-button {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n    font-size: 1rem;\n    color: var(--bs-accordion-btn-color);\n    text-align: left;\n    background-color: var(--bs-accordion-btn-bg);\n    border: 0;\n    border-radius: 0;\n    overflow-anchor: none;\n    transition: var(--bs-accordion-transition)\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .accordion-button {\n        transition: none\n    }\n}\n\n.accordion-button:not(.collapsed) {\n    color: var(--bs-accordion-active-color);\n    background-color: var(--bs-accordion-active-bg);\n    box-shadow: inset 0 calc(-1*var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color)\n}\n\n.accordion-button:not(.collapsed)::after {\n    background-image: var(--bs-accordion-btn-active-icon);\n    transform: var(--bs-accordion-btn-icon-transform)\n}\n\n.accordion-button::after {\n    flex-shrink: 0;\n    width: var(--bs-accordion-btn-icon-width);\n    height: var(--bs-accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--bs-accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--bs-accordion-btn-icon-width);\n    transition: var(--bs-accordion-btn-icon-transition)\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .accordion-button::after {\n        transition: none\n    }\n}\n\n.accordion-button:hover {\n    z-index: 2\n}\n\n.accordion-button:focus {\n    z-index: 3;\n    border-color: var(--bs-accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--bs-accordion-btn-focus-box-shadow)\n}\n\n.accordion-header {\n    margin-bottom: 0\n}\n\n.accordion-item {\n    color: var(--bs-accordion-color);\n    background-color: var(--bs-accordion-bg);\n    border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color)\n}\n\n.accordion-item:first-of-type {\n    border-top-left-radius: var(--bs-accordion-border-radius);\n    border-top-right-radius: var(--bs-accordion-border-radius)\n}\n\n.accordion-item:first-of-type .accordion-button {\n    border-top-left-radius: var(--bs-accordion-inner-border-radius);\n    border-top-right-radius: var(--bs-accordion-inner-border-radius)\n}\n\n.accordion-item:not(:first-of-type) {\n    border-top: 0\n}\n\n.accordion-item:last-of-type {\n    border-bottom-right-radius: var(--bs-accordion-border-radius);\n    border-bottom-left-radius: var(--bs-accordion-border-radius)\n}\n\n.accordion-item:last-of-type .accordion-button.collapsed {\n    border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n    border-bottom-left-radius: var(--bs-accordion-inner-border-radius)\n}\n\n.accordion-item:last-of-type .accordion-collapse {\n    border-bottom-right-radius: var(--bs-accordion-border-radius);\n    border-bottom-left-radius: var(--bs-accordion-border-radius)\n}\n\n.accordion-body {\n    padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x)\n}\n\n.accordion-flush .accordion-collapse {\n    border-width: 0\n}\n\n.accordion-flush .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    border-radius: 0\n}\n\n.accordion-flush .accordion-item:first-child {\n    border-top: 0\n}\n\n.accordion-flush .accordion-item:last-child {\n    border-bottom: 0\n}\n\n.accordion-flush .accordion-item .accordion-button,\n.accordion-flush .accordion-item .accordion-button.collapsed {\n    border-radius: 0\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n    --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%239a9ce2'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n    --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%239a9ce2'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")\n}\n\n.breadcrumb {\n    --bs-breadcrumb-padding-x: 0;\n    --bs-breadcrumb-padding-y: 0;\n    --bs-breadcrumb-margin-bottom: 1rem;\n    --bs-breadcrumb-bg: ;\n    --bs-breadcrumb-border-radius: ;\n    --bs-breadcrumb-divider-color: var(--bs-secondary-color);\n    --bs-breadcrumb-item-padding-x: 0.5rem;\n    --bs-breadcrumb-item-active-color: var(--bs-secondary-color);\n    display: flex;\n    flex-wrap: wrap;\n    padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n    margin-bottom: var(--bs-breadcrumb-margin-bottom);\n    font-size: var(--bs-breadcrumb-font-size);\n    list-style: none;\n    background-color: var(--bs-breadcrumb-bg);\n    border-radius: var(--bs-breadcrumb-border-radius)\n}\n\n.breadcrumb-item+.breadcrumb-item {\n    padding-left: var(--bs-breadcrumb-item-padding-x)\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n    float: left;\n    padding-right: var(--bs-breadcrumb-item-padding-x);\n    color: var(--bs-breadcrumb-divider-color);\n    content: var(--bs-breadcrumb-divider, \"/\")\n        /* rtl: var(--bs-breadcrumb-divider, \"/\") */\n}\n\n.breadcrumb-item.active {\n    color: var(--bs-breadcrumb-item-active-color)\n}\n\n.pagination {\n    --bs-pagination-padding-x: 0.75rem;\n    --bs-pagination-padding-y: 0.375rem;\n    --bs-pagination-font-size: 1rem;\n    --bs-pagination-color: var(--bs-link-color);\n    --bs-pagination-bg: var(--bs-body-bg);\n    --bs-pagination-border-width: var(--bs-border-width);\n    --bs-pagination-border-color: var(--bs-border-color);\n    --bs-pagination-border-radius: var(--bs-border-radius);\n    --bs-pagination-hover-color: var(--bs-link-hover-color);\n    --bs-pagination-hover-bg: var(--bs-tertiary-bg);\n    --bs-pagination-hover-border-color: var(--bs-border-color);\n    --bs-pagination-focus-color: var(--bs-link-hover-color);\n    --bs-pagination-focus-bg: var(--bs-secondary-bg);\n    --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(86, 90, 207, 0.25);\n    --bs-pagination-active-color: #fff;\n    --bs-pagination-active-bg: #008BB1;\n    --bs-pagination-active-border-color: #008BB1;\n    --bs-pagination-disabled-color: var(--bs-secondary-color);\n    --bs-pagination-disabled-bg: var(--bs-secondary-bg);\n    --bs-pagination-disabled-border-color: var(--bs-border-color);\n    display: flex;\n    padding-left: 0;\n    list-style: none\n}\n\n.page-link {\n    position: relative;\n    display: block;\n    padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n    font-size: var(--bs-pagination-font-size);\n    color: var(--bs-pagination-color);\n    /* color: var(--bs-primary); */\n    text-decoration: none;\n    background-color: var(--bs-pagination-bg);\n    border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .page-link {\n        transition: none\n    }\n}\n\n.page-link:hover {\n    z-index: 2;\n    color: var(--bs-pagination-hover-color);\n    background-color: var(--bs-pagination-hover-bg);\n    border-color: var(--bs-pagination-hover-border-color)\n}\n\n.page-link:focus {\n    z-index: 3;\n    color: var(--bs-pagination-focus-color);\n    background-color: var(--bs-pagination-focus-bg);\n    outline: 0;\n    box-shadow: var(--bs-pagination-focus-box-shadow)\n}\n\n.page-link.active,\n.active>.page-link {\n    z-index: 3;\n    color: var(--bs-pagination-active-color);\n    background-color: var(--bs-pagination-active-bg);\n    border-color: var(--bs-pagination-active-border-color)\n}\n\n.page-link.disabled,\n.disabled>.page-link {\n    color: var(--bs-pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--bs-pagination-disabled-bg);\n    border-color: var(--bs-pagination-disabled-border-color)\n}\n\n.page-item:not(:first-child) .page-link {\n    margin-left: calc(var(--bs-border-width) * -1)\n}\n\n.page-item:first-child .page-link {\n    border-top-left-radius: var(--bs-pagination-border-radius);\n    border-bottom-left-radius: var(--bs-pagination-border-radius)\n}\n\n.page-item:last-child .page-link {\n    border-top-right-radius: var(--bs-pagination-border-radius);\n    border-bottom-right-radius: var(--bs-pagination-border-radius)\n}\n\n.pagination-lg {\n    --bs-pagination-padding-x: 1.5rem;\n    --bs-pagination-padding-y: 0.75rem;\n    --bs-pagination-font-size: 1.25rem;\n    --bs-pagination-border-radius: var(--bs-border-radius-lg)\n}\n\n.pagination-sm {\n    --bs-pagination-padding-x: 0.5rem;\n    --bs-pagination-padding-y: 0.25rem;\n    --bs-pagination-font-size: 0.875rem;\n    --bs-pagination-border-radius: var(--bs-border-radius-sm)\n}\n\n.badge {\n    --bs-badge-padding-x: 0.65em;\n    --bs-badge-padding-y: 0.35em;\n    --bs-badge-font-size: 0.75em;\n    --bs-badge-font-weight: 700;\n    --bs-badge-color: #fff;\n    --bs-badge-border-radius: var(--bs-border-radius);\n    display: inline-block;\n    padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n    font-size: var(--bs-badge-font-size);\n    font-weight: var(--bs-badge-font-weight);\n    line-height: 1;\n    color: var(--bs-badge-color);\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: var(--bs-badge-border-radius)\n}\n\n.badge:empty {\n    display: none\n}\n\n.btn .badge {\n    position: relative;\n    top: -1px\n}\n\n.alert {\n    --bs-alert-bg: transparent;\n    --bs-alert-padding-x: 1rem;\n    --bs-alert-padding-y: 1rem;\n    --bs-alert-margin-bottom: 1rem;\n    --bs-alert-color: inherit;\n    --bs-alert-border-color: transparent;\n    --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n    --bs-alert-border-radius: var(--bs-border-radius);\n    --bs-alert-link-color: inherit;\n    position: relative;\n    padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n    margin-bottom: var(--bs-alert-margin-bottom);\n    color: var(--bs-alert-color);\n    background-color: var(--bs-alert-bg);\n    border: var(--bs-alert-border);\n    border-radius: var(--bs-alert-border-radius)\n}\n\n.alert-heading {\n    color: inherit\n}\n\n.alert-link {\n    font-weight: 700;\n    color: var(--bs-alert-link-color)\n}\n\n.alert-dismissible {\n    padding-right: 3rem\n}\n\n.alert-dismissible .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: 1.25rem 1rem\n}\n\n.alert-primary {\n    --bs-alert-color: var(--bs-primary-text-emphasis);\n    --bs-alert-bg: var(--bs-primary-bg-subtle);\n    --bs-alert-border-color: var(--bs-primary-border-subtle);\n    --bs-alert-link-color: var(--bs-primary-text-emphasis)\n}\n\n.alert-secondary {\n    --bs-alert-color: var(--bs-secondary-text-emphasis);\n    --bs-alert-bg: var(--bs-secondary-bg-subtle);\n    --bs-alert-border-color: var(--bs-secondary-border-subtle);\n    --bs-alert-link-color: var(--bs-secondary-text-emphasis)\n}\n\n.alert-success {\n    --bs-alert-color: var(--bs-success-text-emphasis);\n    --bs-alert-bg: var(--bs-success-bg-subtle);\n    --bs-alert-border-color: var(--bs-success-border-subtle);\n    --bs-alert-link-color: var(--bs-success-text-emphasis)\n}\n\n.alert-info {\n    --bs-alert-color: var(--bs-info-text-emphasis);\n    --bs-alert-bg: var(--bs-info-bg-subtle);\n    --bs-alert-border-color: var(--bs-info-border-subtle);\n    --bs-alert-link-color: var(--bs-info-text-emphasis)\n}\n\n.alert-warning {\n    --bs-alert-color: var(--bs-warning-text-emphasis);\n    --bs-alert-bg: var(--bs-warning-bg-subtle);\n    --bs-alert-border-color: var(--bs-warning-border-subtle);\n    --bs-alert-link-color: var(--bs-warning-text-emphasis)\n}\n\n.alert-danger {\n    --bs-alert-color: var(--bs-danger-text-emphasis);\n    --bs-alert-bg: var(--bs-danger-bg-subtle);\n    --bs-alert-border-color: var(--bs-danger-border-subtle);\n    --bs-alert-link-color: var(--bs-danger-text-emphasis)\n}\n\n.alert-light {\n    --bs-alert-color: var(--bs-light-text-emphasis);\n    --bs-alert-bg: var(--bs-light-bg-subtle);\n    --bs-alert-border-color: var(--bs-light-border-subtle);\n    --bs-alert-link-color: var(--bs-light-text-emphasis)\n}\n\n.alert-dark {\n    --bs-alert-color: var(--bs-dark-text-emphasis);\n    --bs-alert-bg: var(--bs-dark-bg-subtle);\n    --bs-alert-border-color: var(--bs-dark-border-subtle);\n    --bs-alert-link-color: var(--bs-dark-text-emphasis)\n}\n\n@keyframes progress-bar-stripes {\n    0% {\n        background-position-x: 1rem\n    }\n}\n\n.progress,\n.progress-stacked {\n    --bs-progress-height: 1rem;\n    --bs-progress-font-size: 0.75rem;\n    --bs-progress-bg: var(--bs-secondary-bg);\n    --bs-progress-border-radius: var(--bs-border-radius);\n    --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n    --bs-progress-bar-color: #fff;\n    --bs-progress-bar-bg: #565acf;\n    --bs-progress-bar-transition: width 0.6s ease;\n    display: flex;\n    height: var(--bs-progress-height);\n    overflow: hidden;\n    font-size: var(--bs-progress-font-size);\n    background-color: var(--bs-progress-bg);\n    border-radius: var(--bs-progress-border-radius)\n}\n\n.progress-bar {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    color: var(--bs-progress-bar-color);\n    text-align: center;\n    white-space: nowrap;\n    background-color: var(--bs-progress-bar-bg);\n    transition: var(--bs-progress-bar-transition)\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .progress-bar {\n        transition: none\n    }\n}\n\n.progress-bar-striped {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-size: var(--bs-progress-height) var(--bs-progress-height)\n}\n\n.progress-stacked>.progress {\n    overflow: visible\n}\n\n.progress-stacked>.progress>.progress-bar {\n    width: 100%\n}\n\n.progress-bar-animated {\n    animation: 1s linear infinite progress-bar-stripes\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .progress-bar-animated {\n        animation: none\n    }\n}\n\n.list-group {\n    --bs-list-group-color: var(--bs-body-color);\n    --bs-list-group-bg: var(--bs-body-bg);\n    --bs-list-group-border-color: var(--bs-border-color);\n    --bs-list-group-border-width: var(--bs-border-width);\n    --bs-list-group-border-radius: var(--bs-border-radius);\n    --bs-list-group-item-padding-x: 1rem;\n    --bs-list-group-item-padding-y: 0.5rem;\n    --bs-list-group-action-color: var(--bs-secondary-color);\n    --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n    --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n    --bs-list-group-action-active-color: var(--bs-body-color);\n    --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n    --bs-list-group-disabled-color: var(--bs-secondary-color);\n    --bs-list-group-disabled-bg: var(--bs-body-bg);\n    --bs-list-group-active-color: #fff;\n    --bs-list-group-active-bg: #565acf;\n    --bs-list-group-active-border-color: #565acf;\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    border-radius: var(--bs-list-group-border-radius)\n}\n\n.list-group-numbered {\n    list-style-type: none;\n    counter-reset: section\n}\n\n.list-group-numbered>.list-group-item::before {\n    content: counters(section, \".\") \". \";\n    counter-increment: section\n}\n\n.list-group-item-action {\n    width: 100%;\n    color: var(--bs-list-group-action-color);\n    text-align: inherit\n}\n\n.list-group-item-action:hover,\n.list-group-item-action:focus {\n    z-index: 1;\n    color: var(--bs-list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--bs-list-group-action-hover-bg)\n}\n\n.list-group-item-action:active {\n    color: var(--bs-list-group-action-active-color);\n    background-color: var(--bs-list-group-action-active-bg)\n}\n\n.list-group-item {\n    position: relative;\n    display: block;\n    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n    color: var(--bs-list-group-color);\n    text-decoration: none;\n    background-color: var(--bs-list-group-bg);\n    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color)\n}\n\n.list-group-item:first-child {\n    border-top-left-radius: inherit;\n    border-top-right-radius: inherit\n}\n\n.list-group-item:last-child {\n    border-bottom-right-radius: inherit;\n    border-bottom-left-radius: inherit\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n    color: var(--bs-list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--bs-list-group-disabled-bg)\n}\n\n.list-group-item.active {\n    z-index: 2;\n    color: var(--bs-list-group-active-color);\n    background-color: var(--bs-list-group-active-bg);\n    border-color: var(--bs-list-group-active-border-color)\n}\n\n.list-group-item+.list-group-item {\n    border-top-width: 0\n}\n\n.list-group-item+.list-group-item.active {\n    margin-top: calc(-1*var(--bs-list-group-border-width));\n    border-top-width: var(--bs-list-group-border-width)\n}\n\n.list-group-horizontal {\n    flex-direction: row\n}\n\n.list-group-horizontal>.list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0\n}\n\n.list-group-horizontal>.list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0\n}\n\n.list-group-horizontal>.list-group-item.active {\n    margin-top: 0\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item.active {\n    margin-left: calc(-1*var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width)\n}\n\n@media(min-width: 576px) {\n    .list-group-horizontal-sm {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-sm>.list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-sm>.list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-sm>.list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-sm>.list-group-item+.list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-sm>.list-group-item+.list-group-item.active {\n        margin-left: calc(-1*var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width)\n    }\n}\n\n@media(min-width: 768px) {\n    .list-group-horizontal-md {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-md>.list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-md>.list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-md>.list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-md>.list-group-item+.list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-md>.list-group-item+.list-group-item.active {\n        margin-left: calc(-1*var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width)\n    }\n}\n\n@media(min-width: 992px) {\n    .list-group-horizontal-lg {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-lg>.list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-lg>.list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-lg>.list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-lg>.list-group-item+.list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-lg>.list-group-item+.list-group-item.active {\n        margin-left: calc(-1*var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width)\n    }\n}\n\n@media(min-width: 1200px) {\n    .list-group-horizontal-xl {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-xl>.list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-xl>.list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-xl>.list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-xl>.list-group-item+.list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-xl>.list-group-item+.list-group-item.active {\n        margin-left: calc(-1*var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width)\n    }\n}\n\n@media(min-width: 1440) {\n    .list-group-horizontal-xxl {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-xxl>.list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-xxl>.list-group-item+.list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {\n        margin-left: calc(-1*var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width)\n    }\n}\n\n.list-group-flush {\n    border-radius: 0\n}\n\n.list-group-flush>.list-group-item {\n    border-width: 0 0 var(--bs-list-group-border-width)\n}\n\n.list-group-flush>.list-group-item:last-child {\n    border-bottom-width: 0\n}\n\n.list-group-item-primary {\n    --bs-list-group-color: var(--bs-primary-text-emphasis);\n    --bs-list-group-bg: var(--bs-primary-bg-subtle);\n    --bs-list-group-border-color: var(--bs-primary-border-subtle);\n    --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n    --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n    --bs-list-group-action-active-color: var(--bs-emphasis-color);\n    --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n    --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n    --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n    --bs-list-group-active-border-color: var(--bs-primary-text-emphasis)\n}\n\n.list-group-item-secondary {\n    --bs-list-group-color: var(--bs-secondary-text-emphasis);\n    --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n    --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n    --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n    --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n    --bs-list-group-action-active-color: var(--bs-emphasis-color);\n    --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n    --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n    --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n    --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis)\n}\n\n.list-group-item-success {\n    --bs-list-group-color: var(--bs-success-text-emphasis);\n    --bs-list-group-bg: var(--bs-success-bg-subtle);\n    --bs-list-group-border-color: var(--bs-success-border-subtle);\n    --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n    --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n    --bs-list-group-action-active-color: var(--bs-emphasis-color);\n    --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n    --bs-list-group-active-color: var(--bs-success-bg-subtle);\n    --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n    --bs-list-group-active-border-color: var(--bs-success-text-emphasis)\n}\n\n.list-group-item-info {\n    --bs-list-group-color: var(--bs-info-text-emphasis);\n    --bs-list-group-bg: var(--bs-info-bg-subtle);\n    --bs-list-group-border-color: var(--bs-info-border-subtle);\n    --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n    --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n    --bs-list-group-action-active-color: var(--bs-emphasis-color);\n    --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n    --bs-list-group-active-color: var(--bs-info-bg-subtle);\n    --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n    --bs-list-group-active-border-color: var(--bs-info-text-emphasis)\n}\n\n.list-group-item-warning {\n    --bs-list-group-color: var(--bs-warning-text-emphasis);\n    --bs-list-group-bg: var(--bs-warning-bg-subtle);\n    --bs-list-group-border-color: var(--bs-warning-border-subtle);\n    --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n    --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n    --bs-list-group-action-active-color: var(--bs-emphasis-color);\n    --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n    --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n    --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n    --bs-list-group-active-border-color: var(--bs-warning-text-emphasis)\n}\n\n.list-group-item-danger {\n    --bs-list-group-color: var(--bs-danger-text-emphasis);\n    --bs-list-group-bg: var(--bs-danger-bg-subtle);\n    --bs-list-group-border-color: var(--bs-danger-border-subtle);\n    --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n    --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n    --bs-list-group-action-active-color: var(--bs-emphasis-color);\n    --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n    --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n    --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n    --bs-list-group-active-border-color: var(--bs-danger-text-emphasis)\n}\n\n.list-group-item-light {\n    --bs-list-group-color: var(--bs-light-text-emphasis);\n    --bs-list-group-bg: var(--bs-light-bg-subtle);\n    --bs-list-group-border-color: var(--bs-light-border-subtle);\n    --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n    --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n    --bs-list-group-action-active-color: var(--bs-emphasis-color);\n    --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n    --bs-list-group-active-color: var(--bs-light-bg-subtle);\n    --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n    --bs-list-group-active-border-color: var(--bs-light-text-emphasis)\n}\n\n.list-group-item-dark {\n    --bs-list-group-color: var(--bs-dark-text-emphasis);\n    --bs-list-group-bg: var(--bs-dark-bg-subtle);\n    --bs-list-group-border-color: var(--bs-dark-border-subtle);\n    --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n    --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n    --bs-list-group-action-active-color: var(--bs-emphasis-color);\n    --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n    --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n    --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n    --bs-list-group-active-border-color: var(--bs-dark-text-emphasis)\n}\n\n.btn-close {\n    --bs-btn-close-color: #000;\n    --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n    --bs-btn-close-opacity: 0.5;\n    --bs-btn-close-hover-opacity: 0.75;\n    --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(86, 90, 207, 0.25);\n    --bs-btn-close-focus-opacity: 1;\n    --bs-btn-close-disabled-opacity: 0.25;\n    --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n    box-sizing: content-box;\n    width: 1em;\n    height: 1em;\n    padding: .25em .25em;\n    color: var(--bs-btn-close-color);\n    background: rgba(0, 0, 0, 0) var(--bs-btn-close-bg) center/1em auto no-repeat;\n    border: 0;\n    border-radius: .375rem;\n    opacity: var(--bs-btn-close-opacity)\n}\n\n.btn-close:hover {\n    color: var(--bs-btn-close-color);\n    text-decoration: none;\n    opacity: var(--bs-btn-close-hover-opacity)\n}\n\n.btn-close:focus {\n    outline: 0;\n    box-shadow: var(--bs-btn-close-focus-shadow);\n    opacity: var(--bs-btn-close-focus-opacity)\n}\n\n.btn-close:disabled,\n.btn-close.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--bs-btn-close-disabled-opacity)\n}\n\n.btn-close-white {\n    filter: var(--bs-btn-close-white-filter)\n}\n\n[data-bs-theme=dark] .btn-close {\n    filter: var(--bs-btn-close-white-filter)\n}\n\n.toast {\n    --bs-toast-zindex: 1090;\n    --bs-toast-padding-x: 0.75rem;\n    --bs-toast-padding-y: 0.5rem;\n    --bs-toast-spacing: 30px;\n    --bs-toast-max-width: 350px;\n    --bs-toast-font-size: 0.875rem;\n    --bs-toast-color: ;\n    --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n    --bs-toast-border-width: var(--bs-border-width);\n    --bs-toast-border-color: var(--bs-border-color-translucent);\n    --bs-toast-border-radius: var(--bs-border-radius);\n    --bs-toast-box-shadow: var(--bs-box-shadow);\n    --bs-toast-header-color: var(--bs-secondary-color);\n    --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n    --bs-toast-header-border-color: var(--bs-border-color-translucent);\n    width: var(--bs-toast-max-width);\n    max-width: 100%;\n    font-size: var(--bs-toast-font-size);\n    color: var(--bs-toast-color);\n    pointer-events: auto;\n    background-color: var(--bs-toast-bg);\n    background-clip: padding-box;\n    border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n    box-shadow: var(--bs-toast-box-shadow);\n    border-radius: var(--bs-toast-border-radius)\n}\n\n.toast.showing {\n    opacity: 0\n}\n\n.toast:not(.show) {\n    display: none\n}\n\n.toast-container {\n    --bs-toast-zindex: 1090;\n    position: absolute;\n    z-index: var(--bs-toast-zindex);\n    width: max-content;\n    max-width: 100%;\n    pointer-events: none\n}\n\n.toast-container>:not(:last-child) {\n    margin-bottom: var(--bs-toast-spacing)\n}\n\n.toast-header {\n    display: flex;\n    align-items: center;\n    padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n    color: var(--bs-toast-header-color);\n    background-color: var(--bs-toast-header-bg);\n    background-clip: padding-box;\n    border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n    border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n    border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width))\n}\n\n.toast-header .btn-close {\n    margin-right: calc(-0.5*var(--bs-toast-padding-x));\n    margin-left: var(--bs-toast-padding-x)\n}\n\n.toast-body {\n    padding: var(--bs-toast-padding-x);\n    word-wrap: break-word\n}\n\n.modal {\n    --bs-modal-zindex: 1055;\n    --bs-modal-width: 500px;\n    --bs-modal-padding: 1rem;\n    --bs-modal-margin: 0.5rem;\n    --bs-modal-color: ;\n    --bs-modal-bg: var(--bs-body-bg);\n    --bs-modal-border-color: var(--bs-border-color-translucent);\n    --bs-modal-border-width: var(--bs-border-width);\n    --bs-modal-border-radius: var(--bs-border-radius-lg);\n    --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n    --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));\n    --bs-modal-header-padding-x: 1rem;\n    --bs-modal-header-padding-y: 1rem;\n    --bs-modal-header-padding: 1rem 1rem;\n    --bs-modal-header-border-color: var(--bs-border-color);\n    --bs-modal-header-border-width: var(--bs-border-width);\n    --bs-modal-title-line-height: 1.5;\n    --bs-modal-footer-gap: 0.5rem;\n    --bs-modal-footer-bg: ;\n    --bs-modal-footer-border-color: var(--bs-border-color);\n    --bs-modal-footer-border-width: var(--bs-border-width);\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: var(--bs-modal-zindex);\n    display: none;\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    outline: 0\n}\n\n.modal-dialog {\n    position: relative;\n    width: auto;\n    margin: var(--bs-modal-margin);\n    pointer-events: none\n}\n\n.modal.fade .modal-dialog {\n    transition: transform .3s ease-out;\n    transform: translate(0, -50px)\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .modal.fade .modal-dialog {\n        transition: none\n    }\n}\n\n.modal.show .modal-dialog {\n    transform: none\n}\n\n.modal.modal-static .modal-dialog {\n    transform: scale(1.02)\n}\n\n.modal-dialog-scrollable {\n    height: calc(100% - var(--bs-modal-margin)*2)\n}\n\n.modal-dialog-scrollable .modal-content {\n    max-height: 100%;\n    overflow: hidden\n}\n\n.modal-dialog-scrollable .modal-body {\n    overflow-y: auto\n}\n\n.modal-dialog-centered {\n    display: flex;\n    align-items: center;\n    min-height: calc(100% - var(--bs-modal-margin)*2)\n}\n\n.modal-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    color: var(--bs-modal-color);\n    pointer-events: auto;\n    background-color: var(--bs-modal-bg);\n    background-clip: padding-box;\n    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n    border-radius: var(--bs-modal-border-radius);\n    outline: 0\n}\n\n.modal-backdrop {\n    --bs-backdrop-zindex: 1050;\n    --bs-backdrop-bg: #000;\n    --bs-backdrop-opacity: 0.5;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: var(--bs-backdrop-zindex);\n    width: 100vw;\n    height: 100vh;\n    background-color: var(--bs-backdrop-bg)\n}\n\n.modal-backdrop.fade {\n    opacity: 0\n}\n\n.modal-backdrop.show {\n    opacity: var(--bs-backdrop-opacity)\n}\n\n.modal-header {\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--bs-modal-header-padding);\n    border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n    border-top-left-radius: var(--bs-modal-inner-border-radius);\n    border-top-right-radius: var(--bs-modal-inner-border-radius)\n}\n\n.modal-header .btn-close {\n    padding: calc(var(--bs-modal-header-padding-y)*.5) calc(var(--bs-modal-header-padding-x)*.5);\n    margin: calc(-0.5*var(--bs-modal-header-padding-y)) calc(-0.5*var(--bs-modal-header-padding-x)) calc(-0.5*var(--bs-modal-header-padding-y)) auto\n}\n\n.modal-title {\n    margin-bottom: 0;\n    line-height: var(--bs-modal-title-line-height)\n}\n\n.modal-body {\n    position: relative;\n    flex: 1 1 auto;\n    padding: var(--bs-modal-padding)\n}\n\n.modal-footer {\n    display: flex;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap)*.5);\n    background-color: var(--bs-modal-footer-bg);\n    border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n    border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n    border-bottom-left-radius: var(--bs-modal-inner-border-radius)\n}\n\n.modal-footer>* {\n    margin: calc(var(--bs-modal-footer-gap)*.5)\n}\n\n@media(min-width: 576px) {\n    .modal {\n        --bs-modal-margin: 1.75rem;\n        --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15)\n    }\n\n    .modal-dialog {\n        max-width: var(--bs-modal-width);\n        margin-right: auto;\n        margin-left: auto\n    }\n\n    .modal-sm {\n        --bs-modal-width: 300px\n    }\n}\n\n@media(min-width: 992px) {\n\n    .modal-lg,\n    .modal-xl {\n        --bs-modal-width: 800px\n    }\n}\n\n@media(min-width: 1200px) {\n    .modal-xl {\n        --bs-modal-width: 1140px\n    }\n}\n\n.modal-fullscreen {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0\n}\n\n.modal-fullscreen .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0\n}\n\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n    border-radius: 0\n}\n\n.modal-fullscreen .modal-body {\n    overflow-y: auto\n}\n\n@media(max-width: 575.98px) {\n    .modal-fullscreen-sm-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0\n    }\n\n    .modal-fullscreen-sm-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0\n    }\n\n    .modal-fullscreen-sm-down .modal-header,\n    .modal-fullscreen-sm-down .modal-footer {\n        border-radius: 0\n    }\n\n    .modal-fullscreen-sm-down .modal-body {\n        overflow-y: auto\n    }\n}\n\n@media(max-width: 767.98px) {\n    .modal-fullscreen-md-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0\n    }\n\n    .modal-fullscreen-md-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0\n    }\n\n    .modal-fullscreen-md-down .modal-header,\n    .modal-fullscreen-md-down .modal-footer {\n        border-radius: 0\n    }\n\n    .modal-fullscreen-md-down .modal-body {\n        overflow-y: auto\n    }\n}\n\n@media(max-width: 991.98px) {\n    .modal-fullscreen-lg-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0\n    }\n\n    .modal-fullscreen-lg-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0\n    }\n\n    .modal-fullscreen-lg-down .modal-header,\n    .modal-fullscreen-lg-down .modal-footer {\n        border-radius: 0\n    }\n\n    .modal-fullscreen-lg-down .modal-body {\n        overflow-y: auto\n    }\n}\n\n@media(max-width: 1199.98px) {\n    .modal-fullscreen-xl-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0\n    }\n\n    .modal-fullscreen-xl-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0\n    }\n\n    .modal-fullscreen-xl-down .modal-header,\n    .modal-fullscreen-xl-down .modal-footer {\n        border-radius: 0\n    }\n\n    .modal-fullscreen-xl-down .modal-body {\n        overflow-y: auto\n    }\n}\n\n@media(max-width: 1439.98) {\n    .modal-fullscreen-xxl-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0\n    }\n\n    .modal-fullscreen-xxl-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0\n    }\n\n    .modal-fullscreen-xxl-down .modal-header,\n    .modal-fullscreen-xxl-down .modal-footer {\n        border-radius: 0\n    }\n\n    .modal-fullscreen-xxl-down .modal-body {\n        overflow-y: auto\n    }\n}\n\n.tooltip {\n    --bs-tooltip-zindex: 1080;\n    --bs-tooltip-max-width: 200px;\n    --bs-tooltip-padding-x: 0.5rem;\n    --bs-tooltip-padding-y: 0.25rem;\n    --bs-tooltip-margin: ;\n    --bs-tooltip-font-size: 0.875rem;\n    --bs-tooltip-color: var(--bs-body-bg);\n    --bs-tooltip-bg: var(--bs-emphasis-color);\n    --bs-tooltip-border-radius: var(--bs-border-radius);\n    --bs-tooltip-opacity: 0.9;\n    --bs-tooltip-arrow-width: 0.8rem;\n    --bs-tooltip-arrow-height: 0.4rem;\n    z-index: var(--bs-tooltip-zindex);\n    display: block;\n    margin: var(--bs-tooltip-margin);\n    font-family: \"Montserrat\", sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    white-space: normal;\n    word-spacing: normal;\n    line-break: auto;\n    font-size: var(--bs-tooltip-font-size);\n    word-wrap: break-word;\n    opacity: 0\n}\n\n.tooltip.show {\n    opacity: var(--bs-tooltip-opacity)\n}\n\n.tooltip .tooltip-arrow {\n    display: block;\n    width: var(--bs-tooltip-arrow-width);\n    height: var(--bs-tooltip-arrow-height)\n}\n\n.tooltip .tooltip-arrow::before {\n    position: absolute;\n    content: \"\";\n    border-color: rgba(0, 0, 0, 0);\n    border-style: solid\n}\n\n.bs-tooltip-top .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n    bottom: calc(-1*var(--bs-tooltip-arrow-height))\n}\n\n.bs-tooltip-top .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n    top: -1px;\n    border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width)*.5) 0;\n    border-top-color: var(--bs-tooltip-bg)\n}\n\n.bs-tooltip-end .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n    left: calc(-1*var(--bs-tooltip-arrow-height));\n    width: var(--bs-tooltip-arrow-height);\n    height: var(--bs-tooltip-arrow-width)\n}\n\n.bs-tooltip-end .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n    right: -1px;\n    border-width: calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width)*.5) 0;\n    border-right-color: var(--bs-tooltip-bg)\n}\n\n.bs-tooltip-bottom .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n    top: calc(-1*var(--bs-tooltip-arrow-height))\n}\n\n.bs-tooltip-bottom .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height);\n    border-bottom-color: var(--bs-tooltip-bg)\n}\n\n.bs-tooltip-start .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n    right: calc(-1*var(--bs-tooltip-arrow-height));\n    width: var(--bs-tooltip-arrow-height);\n    height: var(--bs-tooltip-arrow-width)\n}\n\n.bs-tooltip-start .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n    left: -1px;\n    border-width: calc(var(--bs-tooltip-arrow-width)*.5) 0 calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height);\n    border-left-color: var(--bs-tooltip-bg)\n}\n\n.tooltip-inner {\n    max-width: var(--bs-tooltip-max-width);\n    padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n    color: var(--bs-tooltip-color);\n    text-align: center;\n    background-color: var(--bs-tooltip-bg);\n    border-radius: var(--bs-tooltip-border-radius)\n}\n\n.popover {\n    --bs-popover-zindex: 1070;\n    --bs-popover-max-width: 276px;\n    --bs-popover-font-size: 0.875rem;\n    --bs-popover-bg: var(--bs-body-bg);\n    --bs-popover-border-width: var(--bs-border-width);\n    --bs-popover-border-color: var(--bs-border-color-translucent);\n    --bs-popover-border-radius: var(--bs-border-radius-lg);\n    --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));\n    --bs-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    --bs-popover-header-padding-x: 1rem;\n    --bs-popover-header-padding-y: 0.5rem;\n    --bs-popover-header-font-size: 1rem;\n    --bs-popover-header-color: #14181d;\n    --bs-popover-header-bg: var(--bs-secondary-bg);\n    --bs-popover-body-padding-x: 1rem;\n    --bs-popover-body-padding-y: 1rem;\n    --bs-popover-body-color: var(--bs-body-color);\n    --bs-popover-arrow-width: 1rem;\n    --bs-popover-arrow-height: 0.5rem;\n    --bs-popover-arrow-border: var(--bs-popover-border-color);\n    z-index: var(--bs-popover-zindex);\n    display: block;\n    max-width: var(--bs-popover-max-width);\n    font-family: \"Montserrat\", sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    white-space: normal;\n    word-spacing: normal;\n    line-break: auto;\n    font-size: var(--bs-popover-font-size);\n    word-wrap: break-word;\n    background-color: var(--bs-popover-bg);\n    background-clip: padding-box;\n    border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n    border-radius: var(--bs-popover-border-radius)\n}\n\n.popover .popover-arrow {\n    display: block;\n    width: var(--bs-popover-arrow-width);\n    height: var(--bs-popover-arrow-height)\n}\n\n.popover .popover-arrow::before,\n.popover .popover-arrow::after {\n    position: absolute;\n    display: block;\n    content: \"\";\n    border-color: rgba(0, 0, 0, 0);\n    border-style: solid;\n    border-width: 0\n}\n\n.bs-popover-top>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow {\n    bottom: calc(-1*(var(--bs-popover-arrow-height)) - var(--bs-popover-border-width))\n}\n\n.bs-popover-top>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,\n.bs-popover-top>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {\n    border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width)*.5) 0\n}\n\n.bs-popover-top>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before {\n    bottom: 0;\n    border-top-color: var(--bs-popover-arrow-border)\n}\n\n.bs-popover-top>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {\n    bottom: var(--bs-popover-border-width);\n    border-top-color: var(--bs-popover-bg)\n}\n\n.bs-popover-end>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow {\n    left: calc(-1*(var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n    width: var(--bs-popover-arrow-height);\n    height: var(--bs-popover-arrow-width)\n}\n\n.bs-popover-end>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,\n.bs-popover-end>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {\n    border-width: calc(var(--bs-popover-arrow-width)*.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width)*.5) 0\n}\n\n.bs-popover-end>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before {\n    left: 0;\n    border-right-color: var(--bs-popover-arrow-border)\n}\n\n.bs-popover-end>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {\n    left: var(--bs-popover-border-width);\n    border-right-color: var(--bs-popover-bg)\n}\n\n.bs-popover-bottom>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow {\n    top: calc(-1*(var(--bs-popover-arrow-height)) - var(--bs-popover-border-width))\n}\n\n.bs-popover-bottom>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,\n.bs-popover-bottom>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {\n    border-width: 0 calc(var(--bs-popover-arrow-width)*.5) var(--bs-popover-arrow-height)\n}\n\n.bs-popover-bottom>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before {\n    top: 0;\n    border-bottom-color: var(--bs-popover-arrow-border)\n}\n\n.bs-popover-bottom>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {\n    top: var(--bs-popover-border-width);\n    border-bottom-color: var(--bs-popover-bg)\n}\n\n.bs-popover-bottom .popover-header::before,\n.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--bs-popover-arrow-width);\n    margin-left: calc(-0.5*var(--bs-popover-arrow-width));\n    content: \"\";\n    border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg)\n}\n\n.bs-popover-start>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow {\n    right: calc(-1*(var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n    width: var(--bs-popover-arrow-height);\n    height: var(--bs-popover-arrow-width)\n}\n\n.bs-popover-start>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,\n.bs-popover-start>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {\n    border-width: calc(var(--bs-popover-arrow-width)*.5) 0 calc(var(--bs-popover-arrow-width)*.5) var(--bs-popover-arrow-height)\n}\n\n.bs-popover-start>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before {\n    right: 0;\n    border-left-color: var(--bs-popover-arrow-border)\n}\n\n.bs-popover-start>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {\n    right: var(--bs-popover-border-width);\n    border-left-color: var(--bs-popover-bg)\n}\n\n.popover-header {\n    padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n    margin-bottom: 0;\n    font-size: var(--bs-popover-header-font-size);\n    color: var(--bs-popover-header-color);\n    background-color: var(--bs-popover-header-bg);\n    border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n    border-top-left-radius: var(--bs-popover-inner-border-radius);\n    border-top-right-radius: var(--bs-popover-inner-border-radius)\n}\n\n.popover-header:empty {\n    display: none\n}\n\n.popover-body {\n    padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n    color: var(--bs-popover-body-color)\n}\n\n.carousel {\n    position: relative\n}\n\n.carousel.pointer-event {\n    touch-action: pan-y\n}\n\n.carousel-inner {\n    position: relative;\n    width: 100%;\n    overflow: hidden\n}\n\n.carousel-inner::after {\n    display: block;\n    clear: both;\n    content: \"\"\n}\n\n.carousel-item {\n    position: relative;\n    display: none;\n    float: left;\n    width: 100%;\n    margin-right: -100%;\n    backface-visibility: hidden;\n    transition: transform .6s ease-in-out\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .carousel-item {\n        transition: none\n    }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n    display: block\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n    transform: translateX(100%)\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n    transform: translateX(-100%)\n}\n\n.carousel-fade .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none\n}\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1\n}\n\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    transition: opacity 0s .6s\n}\n\n@media(prefers-reduced-motion: reduce) {\n\n    .carousel-fade .active.carousel-item-start,\n    .carousel-fade .active.carousel-item-end {\n        transition: none\n    }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 15%;\n    padding: 0;\n    color: #fff;\n    text-align: center;\n    background: none;\n    border: 0;\n    opacity: .5;\n    transition: opacity .15s ease\n}\n\n@media(prefers-reduced-motion: reduce) {\n\n    .carousel-control-prev,\n    .carousel-control-next {\n        transition: none\n    }\n}\n\n.carousel-control-prev:hover,\n.carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    opacity: .9\n}\n\n.carousel-control-prev {\n    left: 0\n}\n\n.carousel-control-next {\n    right: 0\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n    display: inline-block;\n    width: 2rem;\n    height: 2rem;\n    background-repeat: no-repeat;\n    background-position: 50%;\n    background-size: 100% 100%\n}\n\n.carousel-control-prev-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")\n}\n\n.carousel-control-next-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")\n}\n\n.carousel-indicators {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    margin-right: 15%;\n    margin-bottom: 1rem;\n    margin-left: 15%\n}\n\n.carousel-indicators [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: 30px;\n    height: 3px;\n    padding: 0;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 0;\n    border-top: 10px solid rgba(0, 0, 0, 0);\n    border-bottom: 10px solid rgba(0, 0, 0, 0);\n    opacity: .5;\n    transition: opacity .6s ease\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .carousel-indicators [data-bs-target] {\n        transition: none\n    }\n}\n\n.carousel-indicators .active {\n    opacity: 1\n}\n\n.carousel-caption {\n    position: absolute;\n    right: 15%;\n    bottom: 1.25rem;\n    left: 15%;\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n    color: #fff;\n    text-align: center\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n    filter: invert(1) grayscale(100)\n}\n\n.carousel-dark .carousel-indicators [data-bs-target] {\n    background-color: #000\n}\n\n.carousel-dark .carousel-caption {\n    color: #000\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon,\n[data-bs-theme=dark].carousel .carousel-control-prev-icon,\n[data-bs-theme=dark].carousel .carousel-control-next-icon {\n    filter: invert(1) grayscale(100)\n}\n\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target],\n[data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {\n    background-color: #000\n}\n\n[data-bs-theme=dark] .carousel .carousel-caption,\n[data-bs-theme=dark].carousel .carousel-caption {\n    color: #000\n}\n\n.spinner-grow,\n.spinner-border {\n    display: inline-block;\n    width: var(--bs-spinner-width);\n    height: var(--bs-spinner-height);\n    vertical-align: var(--bs-spinner-vertical-align);\n    border-radius: 50%;\n    animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name)\n}\n\n@keyframes spinner-border {\n    to {\n        transform: rotate(360deg)\n            /* rtl:ignore */\n    }\n}\n\n.spinner-border {\n    --bs-spinner-width: 2rem;\n    --bs-spinner-height: 2rem;\n    --bs-spinner-vertical-align: -0.125em;\n    --bs-spinner-border-width: 0.25em;\n    --bs-spinner-animation-speed: 0.75s;\n    --bs-spinner-animation-name: spinner-border;\n    border: var(--bs-spinner-border-width) solid currentcolor;\n    border-right-color: rgba(0, 0, 0, 0)\n}\n\n.spinner-border-sm {\n    --bs-spinner-width: 1rem;\n    --bs-spinner-height: 1rem;\n    --bs-spinner-border-width: 0.2em\n}\n\n@keyframes spinner-grow {\n    0% {\n        transform: scale(0)\n    }\n\n    50% {\n        opacity: 1;\n        transform: none\n    }\n}\n\n.spinner-grow {\n    --bs-spinner-width: 2rem;\n    --bs-spinner-height: 2rem;\n    --bs-spinner-vertical-align: -0.125em;\n    --bs-spinner-animation-speed: 0.75s;\n    --bs-spinner-animation-name: spinner-grow;\n    background-color: currentcolor;\n    opacity: 0\n}\n\n.spinner-grow-sm {\n    --bs-spinner-width: 1rem;\n    --bs-spinner-height: 1rem\n}\n\n@media(prefers-reduced-motion: reduce) {\n\n    .spinner-border,\n    .spinner-grow {\n        --bs-spinner-animation-speed: 1.5s\n    }\n}\n\n.offcanvas,\n.offcanvas-xxl,\n.offcanvas-xl,\n.offcanvas-lg,\n.offcanvas-md,\n.offcanvas-sm {\n    --bs-offcanvas-zindex: 1045;\n    --bs-offcanvas-width: 400px;\n    --bs-offcanvas-height: 30vh;\n    --bs-offcanvas-padding-x: 1rem;\n    --bs-offcanvas-padding-y: 1rem;\n    --bs-offcanvas-color: var(--bs-body-color);\n    --bs-offcanvas-bg: var(--bs-body-bg);\n    --bs-offcanvas-border-width: var(--bs-border-width);\n    --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n    --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n    --bs-offcanvas-transition: transform 0.3s ease-in-out;\n    --bs-offcanvas-title-line-height: 1.5\n}\n\n@media(max-width: 575.98px) {\n    .offcanvas-sm {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: var(--bs-offcanvas-transition)\n    }\n}\n\n@media(max-width: 575.98px)and (prefers-reduced-motion: reduce) {\n    .offcanvas-sm {\n        transition: none\n    }\n}\n\n@media(max-width: 575.98px) {\n    .offcanvas-sm.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(-100%)\n    }\n\n    .offcanvas-sm.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(100%)\n    }\n\n    .offcanvas-sm.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(-100%)\n    }\n\n    .offcanvas-sm.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(100%)\n    }\n\n    .offcanvas-sm.showing,\n    .offcanvas-sm.show:not(.hiding) {\n        transform: none\n    }\n\n    .offcanvas-sm.showing,\n    .offcanvas-sm.hiding,\n    .offcanvas-sm.show {\n        visibility: visible\n    }\n}\n\n@media(min-width: 576px) {\n    .offcanvas-sm {\n        --bs-offcanvas-height: auto;\n        --bs-offcanvas-border-width: 0;\n        background-color: rgba(0, 0, 0, 0) !important\n    }\n\n    .offcanvas-sm .offcanvas-header {\n        display: none\n    }\n\n    .offcanvas-sm .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n        background-color: rgba(0, 0, 0, 0) !important\n    }\n}\n\n@media(max-width: 767.98px) {\n    .offcanvas-md {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: var(--bs-offcanvas-transition)\n    }\n}\n\n@media(max-width: 767.98px)and (prefers-reduced-motion: reduce) {\n    .offcanvas-md {\n        transition: none\n    }\n}\n\n@media(max-width: 767.98px) {\n    .offcanvas-md.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(-100%)\n    }\n\n    .offcanvas-md.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(100%)\n    }\n\n    .offcanvas-md.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(-100%)\n    }\n\n    .offcanvas-md.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(100%)\n    }\n\n    .offcanvas-md.showing,\n    .offcanvas-md.show:not(.hiding) {\n        transform: none\n    }\n\n    .offcanvas-md.showing,\n    .offcanvas-md.hiding,\n    .offcanvas-md.show {\n        visibility: visible\n    }\n}\n\n@media(min-width: 768px) {\n    .offcanvas-md {\n        --bs-offcanvas-height: auto;\n        --bs-offcanvas-border-width: 0;\n        background-color: rgba(0, 0, 0, 0) !important\n    }\n\n    .offcanvas-md .offcanvas-header {\n        display: none\n    }\n\n    .offcanvas-md .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n        background-color: rgba(0, 0, 0, 0) !important\n    }\n}\n\n@media(max-width: 991.98px) {\n    .offcanvas-lg {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: var(--bs-offcanvas-transition)\n    }\n}\n\n@media(max-width: 991.98px)and (prefers-reduced-motion: reduce) {\n    .offcanvas-lg {\n        transition: none\n    }\n}\n\n@media(max-width: 991.98px) {\n    .offcanvas-lg.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(-100%)\n    }\n\n    .offcanvas-lg.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(100%)\n    }\n\n    .offcanvas-lg.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(-100%)\n    }\n\n    .offcanvas-lg.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(100%)\n    }\n\n    .offcanvas-lg.showing,\n    .offcanvas-lg.show:not(.hiding) {\n        transform: none\n    }\n\n    .offcanvas-lg.showing,\n    .offcanvas-lg.hiding,\n    .offcanvas-lg.show {\n        visibility: visible\n    }\n}\n\n@media(min-width: 992px) {\n    .offcanvas-lg {\n        --bs-offcanvas-height: auto;\n        --bs-offcanvas-border-width: 0;\n        background-color: rgba(0, 0, 0, 0) !important\n    }\n\n    .offcanvas-lg .offcanvas-header {\n        display: none\n    }\n\n    .offcanvas-lg .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n        background-color: rgba(0, 0, 0, 0) !important\n    }\n}\n\n@media(max-width: 1199.98px) {\n    .offcanvas-xl {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: var(--bs-offcanvas-transition)\n    }\n}\n\n@media(max-width: 1199.98px)and (prefers-reduced-motion: reduce) {\n    .offcanvas-xl {\n        transition: none\n    }\n}\n\n@media(max-width: 1199.98px) {\n    .offcanvas-xl.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(-100%)\n    }\n\n    .offcanvas-xl.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(100%)\n    }\n\n    .offcanvas-xl.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(-100%)\n    }\n\n    .offcanvas-xl.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(100%)\n    }\n\n    .offcanvas-xl.showing,\n    .offcanvas-xl.show:not(.hiding) {\n        transform: none\n    }\n\n    .offcanvas-xl.showing,\n    .offcanvas-xl.hiding,\n    .offcanvas-xl.show {\n        visibility: visible\n    }\n}\n\n@media(min-width: 1200px) {\n    .offcanvas-xl {\n        --bs-offcanvas-height: auto;\n        --bs-offcanvas-border-width: 0;\n        background-color: rgba(0, 0, 0, 0) !important\n    }\n\n    .offcanvas-xl .offcanvas-header {\n        display: none\n    }\n\n    .offcanvas-xl .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n        background-color: rgba(0, 0, 0, 0) !important\n    }\n}\n\n@media(max-width: 1439.98) {\n    .offcanvas-xxl {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: var(--bs-offcanvas-transition)\n    }\n}\n\n@media(max-width: 1439.98)and (prefers-reduced-motion: reduce) {\n    .offcanvas-xxl {\n        transition: none\n    }\n}\n\n@media(max-width: 1439.98) {\n    .offcanvas-xxl.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(-100%)\n    }\n\n    .offcanvas-xxl.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(100%)\n    }\n\n    .offcanvas-xxl.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(-100%)\n    }\n\n    .offcanvas-xxl.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(100%)\n    }\n\n    .offcanvas-xxl.showing,\n    .offcanvas-xxl.show:not(.hiding) {\n        transform: none\n    }\n\n    .offcanvas-xxl.showing,\n    .offcanvas-xxl.hiding,\n    .offcanvas-xxl.show {\n        visibility: visible\n    }\n}\n\n@media(min-width: 1440) {\n    .offcanvas-xxl {\n        --bs-offcanvas-height: auto;\n        --bs-offcanvas-border-width: 0;\n        background-color: rgba(0, 0, 0, 0) !important\n    }\n\n    .offcanvas-xxl .offcanvas-header {\n        display: none\n    }\n\n    .offcanvas-xxl .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n        background-color: rgba(0, 0, 0, 0) !important\n    }\n}\n\n.offcanvas {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition)\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .offcanvas {\n        transition: none\n    }\n}\n\n.offcanvas.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%)\n}\n\n.offcanvas.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%)\n}\n\n.offcanvas.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%)\n}\n\n.offcanvas.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%)\n}\n\n.offcanvas.showing,\n.offcanvas.show:not(.hiding) {\n    transform: none\n}\n\n.offcanvas.showing,\n.offcanvas.hiding,\n.offcanvas.show {\n    visibility: visible\n}\n\n.offcanvas-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1040;\n    width: 100vw;\n    height: 100vh;\n    background-color: #000\n}\n\n.offcanvas-backdrop.fade {\n    opacity: 0\n}\n\n.offcanvas-backdrop.show {\n    opacity: .5\n}\n\n.offcanvas-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x)\n}\n\n.offcanvas-header .btn-close {\n    padding: calc(var(--bs-offcanvas-padding-y)*.5) calc(var(--bs-offcanvas-padding-x)*.5);\n    margin-top: calc(-0.5*var(--bs-offcanvas-padding-y));\n    margin-right: calc(-0.5*var(--bs-offcanvas-padding-x));\n    margin-bottom: calc(-0.5*var(--bs-offcanvas-padding-y))\n}\n\n.offcanvas-title {\n    margin-bottom: 0;\n    line-height: var(--bs-offcanvas-title-line-height)\n}\n\n.offcanvas-body {\n    flex-grow: 1;\n    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n    overflow-y: auto\n}\n\n.placeholder {\n    display: inline-block;\n    min-height: 1em;\n    vertical-align: middle;\n    cursor: wait;\n    background-color: currentcolor;\n    opacity: .5\n}\n\n.placeholder.btn::before {\n    display: inline-block;\n    content: \"\"\n}\n\n.placeholder-xs {\n    min-height: .6em\n}\n\n.placeholder-sm {\n    min-height: .8em\n}\n\n.placeholder-lg {\n    min-height: 1.2em\n}\n\n.placeholder-glow .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite\n}\n\n@keyframes placeholder-glow {\n    50% {\n        opacity: .2\n    }\n}\n\n.placeholder-wave {\n    mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n    mask-size: 200% 100%;\n    animation: placeholder-wave 2s linear infinite\n}\n\n@keyframes placeholder-wave {\n    100% {\n        mask-position: -200% 0%\n    }\n}\n\n.clearfix::after {\n    display: block;\n    clear: both;\n    content: \"\"\n}\n\n.text-bg-primary {\n    color: #fff !important;\n    background-color: RGBA(86, 90, 207, var(--bs-bg-opacity, 1)) !important\n}\n\n.text-bg-secondary {\n    color: #000 !important;\n    background-color: RGBA(241, 119, 50, var(--bs-bg-opacity, 1)) !important\n}\n\n.text-bg-success {\n    color: #000 !important;\n    background-color: RGBA(32, 159, 132, var(--bs-bg-opacity, 1)) !important\n}\n\n.text-bg-info {\n    color: #fff !important;\n    background-color: RGBA(39, 84, 230, var(--bs-bg-opacity, 1)) !important\n}\n\n.text-bg-warning {\n    color: #000 !important;\n    background-color: RGBA(254, 151, 14, var(--bs-bg-opacity, 1)) !important\n}\n\n.text-bg-danger {\n    color: #000 !important;\n    background-color: RGBA(247, 43, 80, var(--bs-bg-opacity, 1)) !important\n}\n\n.text-bg-light {\n    color: #000 !important;\n    background-color: RGBA(255, 255, 255, var(--bs-bg-opacity, 1)) !important\n}\n\n.text-bg-dark {\n    color: #fff !important;\n    background-color: RGBA(31, 34, 120, var(--bs-bg-opacity, 1)) !important\n}\n\n.link-primary {\n    color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-primary:hover,\n.link-primary:focus {\n    color: RGBA(69, 72, 166, var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(69, 72, 166, var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-secondary {\n    color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-secondary:hover,\n.link-secondary:focus {\n    color: RGBA(244, 146, 91, var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(244, 146, 91, var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-success {\n    color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-success:hover,\n.link-success:focus {\n    color: RGBA(77, 178, 157, var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(77, 178, 157, var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-info {\n    color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-info:hover,\n.link-info:focus {\n    color: RGBA(31, 67, 184, var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(31, 67, 184, var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-warning {\n    color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-warning:hover,\n.link-warning:focus {\n    color: RGBA(254, 172, 62, var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(254, 172, 62, var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-danger {\n    color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-danger:hover,\n.link-danger:focus {\n    color: RGBA(249, 85, 115, var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(249, 85, 115, var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-light {\n    color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-light:hover,\n.link-light:focus {\n    color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-dark {\n    color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-dark:hover,\n.link-dark:focus {\n    color: RGBA(25, 27, 96, var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(25, 27, 96, var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-body-emphasis {\n    color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n    text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-body-emphasis:hover,\n.link-body-emphasis:focus {\n    color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n    text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important\n}\n\n.focus-ring:focus {\n    outline: 0;\n    box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color)\n}\n\n.icon-link {\n    display: inline-flex;\n    gap: .375rem;\n    align-items: center;\n    text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n    text-underline-offset: .25em;\n    backface-visibility: hidden\n}\n\n.icon-link>.bi {\n    flex-shrink: 0;\n    width: 1em;\n    height: 1em;\n    fill: currentcolor;\n    transition: .2s ease-in-out transform\n}\n\n@media(prefers-reduced-motion: reduce) {\n    .icon-link>.bi {\n        transition: none\n    }\n}\n\n.icon-link-hover:hover>.bi,\n.icon-link-hover:focus-visible>.bi {\n    transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0))\n}\n\n.ratio {\n    position: relative;\n    width: 100%\n}\n\n.ratio::before {\n    display: block;\n    padding-top: var(--bs-aspect-ratio);\n    content: \"\"\n}\n\n.ratio>* {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%\n}\n\n.ratio-1x1 {\n    --bs-aspect-ratio: 100%\n}\n\n.ratio-4x3 {\n    --bs-aspect-ratio: 75%\n}\n\n.ratio-16x9 {\n    --bs-aspect-ratio: 56.25%\n}\n\n.ratio-21x9 {\n    --bs-aspect-ratio: 42.8571428571%\n}\n\n.fixed-top {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1030\n}\n\n.fixed-bottom {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1030\n}\n\n.sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020\n}\n\n.sticky-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020\n}\n\n@media(min-width: 576px) {\n    .sticky-sm-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n\n    .sticky-sm-bottom {\n        position: sticky;\n        bottom: 0;\n        z-index: 1020\n    }\n}\n\n@media(min-width: 768px) {\n    .sticky-md-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n\n    .sticky-md-bottom {\n        position: sticky;\n        bottom: 0;\n        z-index: 1020\n    }\n}\n\n@media(min-width: 992px) {\n    .sticky-lg-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n\n    .sticky-lg-bottom {\n        position: sticky;\n        bottom: 0;\n        z-index: 1020\n    }\n}\n\n@media(min-width: 1200px) {\n    .sticky-xl-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n\n    .sticky-xl-bottom {\n        position: sticky;\n        bottom: 0;\n        z-index: 1020\n    }\n}\n\n@media(min-width: 1440) {\n    .sticky-xxl-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n\n    .sticky-xxl-bottom {\n        position: sticky;\n        bottom: 0;\n        z-index: 1020\n    }\n}\n\n.hstack {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    align-self: stretch\n}\n\n.vstack {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    align-self: stretch\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n    width: 1px !important;\n    height: 1px !important;\n    padding: 0 !important;\n    margin: -1px !important;\n    overflow: hidden !important;\n    clip: rect(0, 0, 0, 0) !important;\n    white-space: nowrap !important;\n    border: 0 !important\n}\n\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n    position: absolute !important\n}\n\n.stretched-link::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    content: \"\"\n}\n\n.text-truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap\n}\n\n.vr {\n    display: inline-block;\n    align-self: stretch;\n    width: 1px;\n    min-height: 1em;\n    background-color: currentcolor;\n    opacity: .25\n}\n\n.align-baseline {\n    vertical-align: baseline !important\n}\n\n.align-top {\n    vertical-align: top !important\n}\n\n.align-middle {\n    vertical-align: middle !important\n}\n\n.align-bottom {\n    vertical-align: bottom !important\n}\n\n.align-text-bottom {\n    vertical-align: text-bottom !important\n}\n\n.align-text-top {\n    vertical-align: text-top !important\n}\n\n.float-start {\n    float: left !important\n}\n\n.float-end {\n    float: right !important\n}\n\n.float-none {\n    float: none !important\n}\n\n.object-fit-contain {\n    object-fit: contain !important\n}\n\n.object-fit-cover {\n    object-fit: cover !important\n}\n\n.object-fit-fill {\n    object-fit: fill !important\n}\n\n.object-fit-scale {\n    object-fit: scale-down !important\n}\n\n.object-fit-none {\n    object-fit: none !important\n}\n\n.opacity-0 {\n    opacity: 0 !important\n}\n\n.opacity-25 {\n    opacity: .25 !important\n}\n\n.opacity-50 {\n    opacity: .5 !important\n}\n\n.opacity-75 {\n    opacity: .75 !important\n}\n\n.opacity-100 {\n    opacity: 1 !important\n}\n\n.overflow-auto {\n    overflow: auto !important\n}\n\n.overflow-hidden {\n    overflow: hidden !important\n}\n\n.overflow-visible {\n    overflow: visible !important\n}\n\n.overflow-scroll {\n    overflow: scroll !important\n}\n\n.overflow-x-auto {\n    overflow-x: auto !important\n}\n\n.overflow-x-hidden {\n    overflow-x: hidden !important\n}\n\n.overflow-x-visible {\n    overflow-x: visible !important\n}\n\n.overflow-x-scroll {\n    overflow-x: scroll !important\n}\n\n.overflow-y-auto {\n    overflow-y: auto !important\n}\n\n.overflow-y-hidden {\n    overflow-y: hidden !important\n}\n\n.overflow-y-visible {\n    overflow-y: visible !important\n}\n\n.overflow-y-scroll {\n    overflow-y: scroll !important\n}\n\n.d-inline {\n    display: inline !important\n}\n\n.d-inline-block {\n    display: inline-block !important\n}\n\n.d-block {\n    display: block !important\n}\n\n.d-grid {\n    display: grid !important\n}\n\n.d-inline-grid {\n    display: inline-grid !important\n}\n\n.d-table {\n    display: table !important\n}\n\n.d-table-row {\n    display: table-row !important\n}\n\n.d-table-cell {\n    display: table-cell !important\n}\n\n.d-flex {\n    display: flex !important\n}\n\n.d-inline-flex {\n    display: inline-flex !important\n}\n\n.d-none {\n    display: none !important\n}\n\n.shadow {\n    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important\n}\n\n.shadow-sm {\n    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important\n}\n\n.shadow-lg {\n    box-shadow: 0 1rem 3rem rgba(0, 0, 0, .175) !important\n}\n\n.shadow-none {\n    box-shadow: none !important\n}\n\n.focus-ring-primary {\n    --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity))\n}\n\n.focus-ring-secondary {\n    --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity))\n}\n\n.focus-ring-success {\n    --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity))\n}\n\n.focus-ring-info {\n    --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity))\n}\n\n.focus-ring-warning {\n    --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity))\n}\n\n.focus-ring-danger {\n    --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity))\n}\n\n.focus-ring-light {\n    --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity))\n}\n\n.focus-ring-dark {\n    --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity))\n}\n\n.position-static {\n    position: static !important\n}\n\n.position-relative {\n    position: relative !important\n}\n\n.position-absolute {\n    position: absolute !important\n}\n\n.position-fixed {\n    position: fixed !important\n}\n\n.position-sticky {\n    position: sticky !important\n}\n\n.top-0 {\n    top: 0 !important\n}\n\n.top-50 {\n    top: 50% !important\n}\n\n.top-100 {\n    top: 100% !important\n}\n\n.bottom-0 {\n    bottom: 0 !important\n}\n\n.bottom-50 {\n    bottom: 50% !important\n}\n\n.bottom-100 {\n    bottom: 100% !important\n}\n\n.start-0 {\n    left: 0 !important\n}\n\n.start-50 {\n    left: 50% !important\n}\n\n.start-100 {\n    left: 100% !important\n}\n\n.end-0 {\n    right: 0 !important\n}\n\n.end-50 {\n    right: 50% !important\n}\n\n.end-100 {\n    right: 100% !important\n}\n\n.translate-middle {\n    transform: translate(-50%, -50%) !important\n}\n\n.translate-middle-x {\n    transform: translateX(-50%) !important\n}\n\n.translate-middle-y {\n    transform: translateY(-50%) !important\n}\n\n.border {\n    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important\n}\n\n.border-0 {\n    border: 0 !important\n}\n\n.border-top {\n    border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important\n}\n\n.border-top-0 {\n    border-top: 0 !important\n}\n\n.border-end {\n    border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important\n}\n\n.border-end-0 {\n    border-right: 0 !important\n}\n\n.border-bottom {\n    border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important\n}\n\n.border-bottom-0 {\n    border-bottom: 0 !important\n}\n\n.border-start {\n    border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important\n}\n\n.border-start-0 {\n    border-left: 0 !important\n}\n\n.border-primary {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important\n}\n\n.border-secondary {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important\n}\n\n.border-success {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important\n}\n\n.border-info {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important\n}\n\n.border-warning {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important\n}\n\n.border-danger {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important\n}\n\n.border-light {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important\n}\n\n.border-dark {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important\n}\n\n.border-black {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important\n}\n\n.border-white {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important\n}\n\n.border-primary-subtle {\n    border-color: var(--bs-primary-border-subtle) !important\n}\n\n.border-secondary-subtle {\n    border-color: var(--bs-secondary-border-subtle) !important\n}\n\n.border-success-subtle {\n    border-color: var(--bs-success-border-subtle) !important\n}\n\n.border-info-subtle {\n    border-color: var(--bs-info-border-subtle) !important\n}\n\n.border-warning-subtle {\n    border-color: var(--bs-warning-border-subtle) !important\n}\n\n.border-danger-subtle {\n    border-color: var(--bs-danger-border-subtle) !important\n}\n\n.border-light-subtle {\n    border-color: var(--bs-light-border-subtle) !important\n}\n\n.border-dark-subtle {\n    border-color: var(--bs-dark-border-subtle) !important\n}\n\n.border-1 {\n    border-width: 1px !important\n}\n\n.border-2 {\n    border-width: 2px !important\n}\n\n.border-3 {\n    border-width: 3px !important\n}\n\n.border-4 {\n    border-width: 4px !important\n}\n\n.border-5 {\n    border-width: 5px !important\n}\n\n.border-opacity-10 {\n    --bs-border-opacity: 0.1\n}\n\n.border-opacity-25 {\n    --bs-border-opacity: 0.25\n}\n\n.border-opacity-50 {\n    --bs-border-opacity: 0.5\n}\n\n.border-opacity-75 {\n    --bs-border-opacity: 0.75\n}\n\n.border-opacity-100 {\n    --bs-border-opacity: 1\n}\n\n.w-25 {\n    width: 25% !important\n}\n\n.w-50 {\n    width: 50% !important\n}\n\n.w-75 {\n    width: 75% !important\n}\n\n.w-100 {\n    width: 100% !important\n}\n\n.w-auto {\n    width: auto !important\n}\n\n.mw-100 {\n    max-width: 100% !important\n}\n\n.vw-100 {\n    width: 100vw !important\n}\n\n.min-vw-100 {\n    min-width: 100vw !important\n}\n\n.h-25 {\n    height: 25% !important\n}\n\n.h-50 {\n    height: 50% !important\n}\n\n.h-75 {\n    height: 75% !important\n}\n\n.h-100 {\n    height: 100% !important\n}\n\n.h-auto {\n    height: auto !important\n}\n\n.mh-100 {\n    max-height: 100% !important\n}\n\n.vh-100 {\n    height: 100vh !important\n}\n\n.min-vh-100 {\n    min-height: 100vh !important\n}\n\n.flex-fill {\n    flex: 1 1 auto !important\n}\n\n.flex-row {\n    flex-direction: row !important\n}\n\n.flex-column {\n    flex-direction: column !important\n}\n\n.flex-row-reverse {\n    flex-direction: row-reverse !important\n}\n\n.flex-column-reverse {\n    flex-direction: column-reverse !important\n}\n\n.flex-grow-0 {\n    flex-grow: 0 !important\n}\n\n.flex-grow-1 {\n    flex-grow: 1 !important\n}\n\n.flex-shrink-0 {\n    flex-shrink: 0 !important\n}\n\n.flex-shrink-1 {\n    flex-shrink: 1 !important\n}\n\n.flex-wrap {\n    flex-wrap: wrap !important\n}\n\n.flex-nowrap {\n    flex-wrap: nowrap !important\n}\n\n.flex-wrap-reverse {\n    flex-wrap: wrap-reverse !important\n}\n\n.justify-content-start {\n    justify-content: flex-start !important\n}\n\n.justify-content-end {\n    justify-content: flex-end !important\n}\n\n.justify-content-center {\n    justify-content: center !important\n}\n\n.justify-content-between {\n    justify-content: space-between !important\n}\n\n.justify-content-around {\n    justify-content: space-around !important\n}\n\n.justify-content-evenly {\n    justify-content: space-evenly !important\n}\n\n.align-items-start {\n    align-items: flex-start !important\n}\n\n.align-items-end {\n    align-items: flex-end !important\n}\n\n.align-items-center {\n    align-items: center !important\n}\n\n.align-items-baseline {\n    align-items: baseline !important\n}\n\n.align-items-stretch {\n    align-items: stretch !important\n}\n\n.align-content-start {\n    align-content: flex-start !important\n}\n\n.align-content-end {\n    align-content: flex-end !important\n}\n\n.align-content-center {\n    align-content: center !important\n}\n\n.align-content-between {\n    align-content: space-between !important\n}\n\n.align-content-around {\n    align-content: space-around !important\n}\n\n.align-content-stretch {\n    align-content: stretch !important\n}\n\n.align-self-auto {\n    align-self: auto !important\n}\n\n.align-self-start {\n    align-self: flex-start !important\n}\n\n.align-self-end {\n    align-self: flex-end !important\n}\n\n.align-self-center {\n    align-self: center !important\n}\n\n.align-self-baseline {\n    align-self: baseline !important\n}\n\n.align-self-stretch {\n    align-self: stretch !important\n}\n\n.order-first {\n    order: -1 !important\n}\n\n.order-0 {\n    order: 0 !important\n}\n\n.order-1 {\n    order: 1 !important\n}\n\n.order-2 {\n    order: 2 !important\n}\n\n.order-3 {\n    order: 3 !important\n}\n\n.order-4 {\n    order: 4 !important\n}\n\n.order-5 {\n    order: 5 !important\n}\n\n.order-last {\n    order: 6 !important\n}\n\n.m-0 {\n    margin: 0 !important\n}\n\n.m-1 {\n    margin: .25rem !important\n}\n\n.m-2 {\n    margin: .5rem !important\n}\n\n.m-3 {\n    margin: 1rem !important\n}\n\n.m-4 {\n    margin: 1.5rem !important\n}\n\n.m-5 {\n    margin: 3rem !important\n}\n\n.m-auto {\n    margin: auto !important\n}\n\n.mx-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important\n}\n\n.mx-1 {\n    margin-right: .25rem !important;\n    margin-left: .25rem !important\n}\n\n.mx-2 {\n    margin-right: .5rem !important;\n    margin-left: .5rem !important\n}\n\n.mx-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important\n}\n\n.mx-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important\n}\n\n.mx-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important\n}\n\n.mx-auto {\n    margin-right: auto !important;\n    margin-left: auto !important\n}\n\n.my-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important\n}\n\n.my-1 {\n    margin-top: .25rem !important;\n    margin-bottom: .25rem !important\n}\n\n.my-2 {\n    margin-top: .5rem !important;\n    margin-bottom: .5rem !important\n}\n\n.my-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important\n}\n\n.my-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important\n}\n\n.my-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important\n}\n\n.my-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important\n}\n\n.mt-0 {\n    margin-top: 0 !important\n}\n\n.mt-1 {\n    margin-top: .25rem !important\n}\n\n.mt-2 {\n    margin-top: .5rem !important\n}\n\n.mt-3 {\n    margin-top: 1rem !important\n}\n\n.mt-4 {\n    margin-top: 1.5rem !important\n}\n\n.mt-5 {\n    margin-top: 3rem !important\n}\n\n.mt-auto {\n    margin-top: auto !important\n}\n\n.me-0 {\n    margin-right: 0 !important\n}\n\n.me-1 {\n    margin-right: .25rem !important\n}\n\n.me-2 {\n    margin-right: .5rem !important\n}\n\n.me-3 {\n    margin-right: 1rem !important\n}\n\n.me-4 {\n    margin-right: 1.5rem !important\n}\n\n.me-5 {\n    margin-right: 3rem !important\n}\n\n.me-auto {\n    margin-right: auto !important\n}\n\n.mb-0 {\n    margin-bottom: 0 !important\n}\n\n.mb-1 {\n    margin-bottom: .25rem !important\n}\n\n.mb-2 {\n    margin-bottom: .5rem !important\n}\n\n.mb-3 {\n    margin-bottom: 1rem !important\n}\n\n.mb-4 {\n    margin-bottom: 1.5rem !important\n}\n\n.mb-5 {\n    margin-bottom: 3rem !important\n}\n\n.mb-auto {\n    margin-bottom: auto !important\n}\n\n.ms-0 {\n    margin-left: 0 !important\n}\n\n.ms-1 {\n    margin-left: .25rem !important\n}\n\n.ms-2 {\n    margin-left: .5rem !important\n}\n\n.ms-3 {\n    margin-left: 1rem !important\n}\n\n.ms-4 {\n    margin-left: 1.5rem !important\n}\n\n.ms-5 {\n    margin-left: 3rem !important\n}\n\n.ms-auto {\n    margin-left: auto !important\n}\n\n.p-0 {\n    padding: 0 !important\n}\n\n.p-1 {\n    padding: .25rem !important\n}\n\n.p-2 {\n    padding: .5rem !important\n}\n\n.p-3 {\n    padding: 1rem !important\n}\n\n.p-4 {\n    padding: 1.5rem !important\n}\n\n.p-5 {\n    padding: 3rem !important\n}\n\n.px-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important\n}\n\n.px-1 {\n    padding-right: .25rem !important;\n    padding-left: .25rem !important\n}\n\n.px-2 {\n    padding-right: .5rem !important;\n    padding-left: .5rem !important\n}\n\n.px-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important\n}\n\n.px-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important\n}\n\n.px-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important\n}\n\n.py-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important\n}\n\n.py-1 {\n    padding-top: .25rem !important;\n    padding-bottom: .25rem !important\n}\n\n.py-2 {\n    padding-top: .5rem !important;\n    padding-bottom: .5rem !important\n}\n\n.py-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important\n}\n\n.py-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important\n}\n\n.py-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important\n}\n\n.pt-0 {\n    padding-top: 0 !important\n}\n\n.pt-1 {\n    padding-top: .25rem !important\n}\n\n.pt-2 {\n    padding-top: .5rem !important\n}\n\n.pt-3 {\n    padding-top: 1rem !important\n}\n\n.pt-4 {\n    padding-top: 1.5rem !important\n}\n\n.pt-5 {\n    padding-top: 3rem !important\n}\n\n.pe-0 {\n    padding-right: 0 !important\n}\n\n.pe-1 {\n    padding-right: .25rem !important\n}\n\n.pe-2 {\n    padding-right: .5rem !important\n}\n\n.pe-3 {\n    padding-right: 1rem !important\n}\n\n.pe-4 {\n    padding-right: 1.5rem !important\n}\n\n.pe-5 {\n    padding-right: 3rem !important\n}\n\n.pb-0 {\n    padding-bottom: 0 !important\n}\n\n.pb-1 {\n    padding-bottom: .25rem !important\n}\n\n.pb-2 {\n    padding-bottom: .5rem !important\n}\n\n.pb-3 {\n    padding-bottom: 1rem !important\n}\n\n.pb-4 {\n    padding-bottom: 1.5rem !important\n}\n\n.pb-5 {\n    padding-bottom: 3rem !important\n}\n\n.ps-0 {\n    padding-left: 0 !important\n}\n\n.ps-1 {\n    padding-left: .25rem !important\n}\n\n.ps-2 {\n    padding-left: .5rem !important\n}\n\n.ps-3 {\n    padding-left: 1rem !important\n}\n\n.ps-4 {\n    padding-left: 1.5rem !important\n}\n\n.ps-5 {\n    padding-left: 3rem !important\n}\n\n.gap-0 {\n    gap: 0 !important\n}\n\n.gap-1 {\n    gap: .25rem !important\n}\n\n.gap-2 {\n    gap: .5rem !important\n}\n\n.gap-3 {\n    gap: 1rem !important\n}\n\n.gap-4 {\n    gap: 1.5rem !important\n}\n\n.gap-5 {\n    gap: 3rem !important\n}\n\n.row-gap-0 {\n    row-gap: 0 !important\n}\n\n.row-gap-1 {\n    row-gap: .25rem !important\n}\n\n.row-gap-2 {\n    row-gap: .5rem !important\n}\n\n.row-gap-3 {\n    row-gap: 1rem !important\n}\n\n.row-gap-4 {\n    row-gap: 1.5rem !important\n}\n\n.row-gap-5 {\n    row-gap: 3rem !important\n}\n\n.column-gap-0 {\n    column-gap: 0 !important\n}\n\n.column-gap-1 {\n    column-gap: .25rem !important\n}\n\n.column-gap-2 {\n    column-gap: .5rem !important\n}\n\n.column-gap-3 {\n    column-gap: 1rem !important\n}\n\n.column-gap-4 {\n    column-gap: 1.5rem !important\n}\n\n.column-gap-5 {\n    column-gap: 3rem !important\n}\n\n.font-monospace {\n    font-family: var(--bs-font-monospace) !important\n}\n\n.fs-1 {\n    font-size: calc(1.4375rem + 2.25vw) !important\n}\n\n.fs-2 {\n    font-size: calc(1.34375rem + 1.125vw) !important\n}\n\n.fs-3 {\n    font-size: calc(1.3rem + 0.6vw) !important\n}\n\n.fs-4 {\n    font-size: calc(1.275rem + 0.3vw) !important\n}\n\n.fs-5 {\n    font-size: 1.25rem !important\n}\n\n.fs-6 {\n    font-size: 1.125rem !important\n}\n\n.fst-italic {\n    font-style: italic !important\n}\n\n.fst-normal {\n    font-style: normal !important\n}\n\n.fw-lighter {\n    font-weight: lighter !important\n}\n\n.fw-light {\n    font-weight: 300 !important\n}\n\n.fw-normal {\n    font-weight: 400 !important\n}\n\n.fw-medium {\n    font-weight: 500 !important\n}\n\n.fw-semibold {\n    font-weight: 600 !important\n}\n\n.fw-bold {\n    font-weight: 700 !important\n}\n\n.fw-bolder {\n    font-weight: bolder !important\n}\n\n.lh-1 {\n    line-height: 1 !important\n}\n\n.lh-sm {\n    line-height: 1.25 !important\n}\n\n.lh-base {\n    line-height: 1.5 !important\n}\n\n.lh-lg {\n    line-height: 2 !important\n}\n\n.text-start {\n    text-align: left !important\n}\n\n.text-end {\n    text-align: right !important\n}\n\n.text-center {\n    text-align: center !important\n}\n\n.text-decoration-none {\n    text-decoration: none !important\n}\n\n.text-decoration-underline {\n    text-decoration: underline !important\n}\n\n.text-decoration-line-through {\n    text-decoration: line-through !important\n}\n\n.text-lowercase {\n    text-transform: lowercase !important\n}\n\n.text-uppercase {\n    text-transform: uppercase !important\n}\n\n.text-capitalize {\n    text-transform: capitalize !important\n}\n\n.text-wrap {\n    white-space: normal !important\n}\n\n.text-nowrap {\n    white-space: nowrap !important\n}\n\n.text-break {\n    word-wrap: break-word !important;\n    word-break: break-word !important\n}\n\n.text-primary {\n    --bs-text-opacity: 1;\n    color: #00b8de !important\n}\n\n.text-secondary {\n    --bs-text-opacity: 1;\n    color: #00b8de !important;\n    /* color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important */\n}\n\n.text-success {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important\n}\n\n.text-info {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important\n}\n\n.text-warning {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important\n}\n\n.text-danger {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important\n}\n\n.text-light {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important\n}\n\n.text-dark {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important\n}\n\n.text-black {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important\n}\n\n.text-white {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important\n}\n\n.text-body {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important\n}\n\n.text-muted {\n    --bs-text-opacity: 1;\n    color: var(--bs-secondary-color) !important\n}\n\n.text-black-50 {\n    --bs-text-opacity: 1;\n    color: rgba(0, 0, 0, .5) !important\n}\n\n.text-white-50 {\n    --bs-text-opacity: 1;\n    color: rgba(255, 255, 255, .5) !important\n}\n\n.text-body-secondary {\n    --bs-text-opacity: 1;\n    color: var(--bs-secondary-color) !important\n}\n\n.text-body-tertiary {\n    --bs-text-opacity: 1;\n    color: var(--bs-tertiary-color) !important\n}\n\n.text-body-emphasis {\n    --bs-text-opacity: 1;\n    color: var(--bs-emphasis-color) !important\n}\n\n.text-reset {\n    --bs-text-opacity: 1;\n    color: inherit !important\n}\n\n.text-opacity-25 {\n    --bs-text-opacity: 0.25\n}\n\n.text-opacity-50 {\n    --bs-text-opacity: 0.5\n}\n\n.text-opacity-75 {\n    --bs-text-opacity: 0.75\n}\n\n.text-opacity-100 {\n    --bs-text-opacity: 1\n}\n\n.text-primary-emphasis {\n    color: var(--bs-primary-text-emphasis) !important\n}\n\n.text-secondary-emphasis {\n    color: var(--bs-secondary-text-emphasis) !important\n}\n\n.text-success-emphasis {\n    color: var(--bs-success-text-emphasis) !important\n}\n\n.text-info-emphasis {\n    color: var(--bs-info-text-emphasis) !important\n}\n\n.text-warning-emphasis {\n    color: var(--bs-warning-text-emphasis) !important\n}\n\n.text-danger-emphasis {\n    color: var(--bs-danger-text-emphasis) !important\n}\n\n.text-light-emphasis {\n    color: var(--bs-light-text-emphasis) !important\n}\n\n.text-dark-emphasis {\n    color: var(--bs-dark-text-emphasis) !important\n}\n\n.link-opacity-10 {\n    --bs-link-opacity: 0.1\n}\n\n.link-opacity-10-hover:hover {\n    --bs-link-opacity: 0.1\n}\n\n.link-opacity-25 {\n    --bs-link-opacity: 0.25\n}\n\n.link-opacity-25-hover:hover {\n    --bs-link-opacity: 0.25\n}\n\n.link-opacity-50 {\n    --bs-link-opacity: 0.5\n}\n\n.link-opacity-50-hover:hover {\n    --bs-link-opacity: 0.5\n}\n\n.link-opacity-75 {\n    --bs-link-opacity: 0.75\n}\n\n.link-opacity-75-hover:hover {\n    --bs-link-opacity: 0.75\n}\n\n.link-opacity-100 {\n    --bs-link-opacity: 1\n}\n\n.link-opacity-100-hover:hover {\n    --bs-link-opacity: 1\n}\n\n.link-offset-1 {\n    text-underline-offset: .125em !important\n}\n\n.link-offset-1-hover:hover {\n    text-underline-offset: .125em !important\n}\n\n.link-offset-2 {\n    text-underline-offset: .25em !important\n}\n\n.link-offset-2-hover:hover {\n    text-underline-offset: .25em !important\n}\n\n.link-offset-3 {\n    text-underline-offset: .375em !important\n}\n\n.link-offset-3-hover:hover {\n    text-underline-offset: .375em !important\n}\n\n.link-underline-primary {\n    --bs-link-underline-opacity: 1;\n    text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important\n}\n\n.link-underline-secondary {\n    --bs-link-underline-opacity: 1;\n    text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important\n}\n\n.link-underline-success {\n    --bs-link-underline-opacity: 1;\n    text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important\n}\n\n.link-underline-info {\n    --bs-link-underline-opacity: 1;\n    text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important\n}\n\n.link-underline-warning {\n    --bs-link-underline-opacity: 1;\n    text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important\n}\n\n.link-underline-danger {\n    --bs-link-underline-opacity: 1;\n    text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important\n}\n\n.link-underline-light {\n    --bs-link-underline-opacity: 1;\n    text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important\n}\n\n.link-underline-dark {\n    --bs-link-underline-opacity: 1;\n    text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important\n}\n\n.link-underline {\n    --bs-link-underline-opacity: 1;\n    text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important\n}\n\n.link-underline-opacity-0 {\n    --bs-link-underline-opacity: 0\n}\n\n.link-underline-opacity-0-hover:hover {\n    --bs-link-underline-opacity: 0\n}\n\n.link-underline-opacity-10 {\n    --bs-link-underline-opacity: 0.1\n}\n\n.link-underline-opacity-10-hover:hover {\n    --bs-link-underline-opacity: 0.1\n}\n\n.link-underline-opacity-25 {\n    --bs-link-underline-opacity: 0.25\n}\n\n.link-underline-opacity-25-hover:hover {\n    --bs-link-underline-opacity: 0.25\n}\n\n.link-underline-opacity-50 {\n    --bs-link-underline-opacity: 0.5\n}\n\n.link-underline-opacity-50-hover:hover {\n    --bs-link-underline-opacity: 0.5\n}\n\n.link-underline-opacity-75 {\n    --bs-link-underline-opacity: 0.75\n}\n\n.link-underline-opacity-75-hover:hover {\n    --bs-link-underline-opacity: 0.75\n}\n\n.link-underline-opacity-100 {\n    --bs-link-underline-opacity: 1\n}\n\n.link-underline-opacity-100-hover:hover {\n    --bs-link-underline-opacity: 1\n}\n\n.bg-primary {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-secondary {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-success {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-info {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-warning {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-danger {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-light {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-dark {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-black {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-white {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-body {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-transparent {\n    --bs-bg-opacity: 1;\n    background-color: rgba(0, 0, 0, 0) !important\n}\n\n.bg-body-secondary {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-body-tertiary {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important\n}\n\n.bg-opacity-10 {\n    --bs-bg-opacity: 0.1\n}\n\n.bg-opacity-25 {\n    --bs-bg-opacity: 0.25\n}\n\n.bg-opacity-50 {\n    --bs-bg-opacity: 0.5\n}\n\n.bg-opacity-75 {\n    --bs-bg-opacity: 0.75\n}\n\n.bg-opacity-100 {\n    --bs-bg-opacity: 1\n}\n\n.bg-primary-subtle {\n    background-color: var(--bs-primary-bg-subtle) !important\n}\n\n.bg-secondary-subtle {\n    background-color: var(--bs-secondary-bg-subtle) !important\n}\n\n.bg-success-subtle {\n    background-color: var(--bs-success-bg-subtle) !important\n}\n\n.bg-info-subtle {\n    background-color: var(--bs-info-bg-subtle) !important\n}\n\n.bg-warning-subtle {\n    background-color: var(--bs-warning-bg-subtle) !important\n}\n\n.bg-danger-subtle {\n    background-color: var(--bs-danger-bg-subtle) !important\n}\n\n.bg-light-subtle {\n    background-color: var(--bs-light-bg-subtle) !important\n}\n\n.bg-dark-subtle {\n    background-color: var(--bs-dark-bg-subtle) !important\n}\n\n.bg-gradient {\n    background-image: var(--bs-gradient) !important\n}\n\n.user-select-all {\n    user-select: all !important\n}\n\n.user-select-auto {\n    user-select: auto !important\n}\n\n.user-select-none {\n    user-select: none !important\n}\n\n.pe-none {\n    pointer-events: none !important\n}\n\n.pe-auto {\n    pointer-events: auto !important\n}\n\n.rounded {\n    border-radius: var(--bs-border-radius) !important\n}\n\n.rounded-0 {\n    border-radius: 0 !important\n}\n\n.rounded-1 {\n    border-radius: var(--bs-border-radius-sm) !important\n}\n\n.rounded-2 {\n    border-radius: var(--bs-border-radius) !important\n}\n\n.rounded-3 {\n    border-radius: var(--bs-border-radius-lg) !important\n}\n\n.rounded-4 {\n    border-radius: var(--bs-border-radius-xl) !important\n}\n\n.rounded-5 {\n    border-radius: var(--bs-border-radius-xxl) !important\n}\n\n.rounded-circle {\n    border-radius: 50% !important\n}\n\n.rounded-pill {\n    border-radius: var(--bs-border-radius-pill) !important\n}\n\n.rounded-top {\n    border-top-left-radius: var(--bs-border-radius) !important;\n    border-top-right-radius: var(--bs-border-radius) !important\n}\n\n.rounded-top-0 {\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important\n}\n\n.rounded-top-1 {\n    border-top-left-radius: var(--bs-border-radius-sm) !important;\n    border-top-right-radius: var(--bs-border-radius-sm) !important\n}\n\n.rounded-top-2 {\n    border-top-left-radius: var(--bs-border-radius) !important;\n    border-top-right-radius: var(--bs-border-radius) !important\n}\n\n.rounded-top-3 {\n    border-top-left-radius: var(--bs-border-radius-lg) !important;\n    border-top-right-radius: var(--bs-border-radius-lg) !important\n}\n\n.rounded-top-4 {\n    border-top-left-radius: var(--bs-border-radius-xl) !important;\n    border-top-right-radius: var(--bs-border-radius-xl) !important\n}\n\n.rounded-top-5 {\n    border-top-left-radius: var(--bs-border-radius-xxl) !important;\n    border-top-right-radius: var(--bs-border-radius-xxl) !important\n}\n\n.rounded-top-circle {\n    border-top-left-radius: 50% !important;\n    border-top-right-radius: 50% !important\n}\n\n.rounded-top-pill {\n    border-top-left-radius: var(--bs-border-radius-pill) !important;\n    border-top-right-radius: var(--bs-border-radius-pill) !important\n}\n\n.rounded-end {\n    border-top-right-radius: var(--bs-border-radius) !important;\n    border-bottom-right-radius: var(--bs-border-radius) !important\n}\n\n.rounded-end-0 {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important\n}\n\n.rounded-end-1 {\n    border-top-right-radius: var(--bs-border-radius-sm) !important;\n    border-bottom-right-radius: var(--bs-border-radius-sm) !important\n}\n\n.rounded-end-2 {\n    border-top-right-radius: var(--bs-border-radius) !important;\n    border-bottom-right-radius: var(--bs-border-radius) !important\n}\n\n.rounded-end-3 {\n    border-top-right-radius: var(--bs-border-radius-lg) !important;\n    border-bottom-right-radius: var(--bs-border-radius-lg) !important\n}\n\n.rounded-end-4 {\n    border-top-right-radius: var(--bs-border-radius-xl) !important;\n    border-bottom-right-radius: var(--bs-border-radius-xl) !important\n}\n\n.rounded-end-5 {\n    border-top-right-radius: var(--bs-border-radius-xxl) !important;\n    border-bottom-right-radius: var(--bs-border-radius-xxl) !important\n}\n\n.rounded-end-circle {\n    border-top-right-radius: 50% !important;\n    border-bottom-right-radius: 50% !important\n}\n\n.rounded-end-pill {\n    border-top-right-radius: var(--bs-border-radius-pill) !important;\n    border-bottom-right-radius: var(--bs-border-radius-pill) !important\n}\n\n.rounded-bottom {\n    border-bottom-right-radius: var(--bs-border-radius) !important;\n    border-bottom-left-radius: var(--bs-border-radius) !important\n}\n\n.rounded-bottom-0 {\n    border-bottom-right-radius: 0 !important;\n    border-bottom-left-radius: 0 !important\n}\n\n.rounded-bottom-1 {\n    border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n    border-bottom-left-radius: var(--bs-border-radius-sm) !important\n}\n\n.rounded-bottom-2 {\n    border-bottom-right-radius: var(--bs-border-radius) !important;\n    border-bottom-left-radius: var(--bs-border-radius) !important\n}\n\n.rounded-bottom-3 {\n    border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n    border-bottom-left-radius: var(--bs-border-radius-lg) !important\n}\n\n.rounded-bottom-4 {\n    border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n    border-bottom-left-radius: var(--bs-border-radius-xl) !important\n}\n\n.rounded-bottom-5 {\n    border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n    border-bottom-left-radius: var(--bs-border-radius-xxl) !important\n}\n\n.rounded-bottom-circle {\n    border-bottom-right-radius: 50% !important;\n    border-bottom-left-radius: 50% !important\n}\n\n.rounded-bottom-pill {\n    border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n    border-bottom-left-radius: var(--bs-border-radius-pill) !important\n}\n\n.rounded-start {\n    border-bottom-left-radius: var(--bs-border-radius) !important;\n    border-top-left-radius: var(--bs-border-radius) !important\n}\n\n.rounded-start-0 {\n    border-bottom-left-radius: 0 !important;\n    border-top-left-radius: 0 !important\n}\n\n.rounded-start-1 {\n    border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n    border-top-left-radius: var(--bs-border-radius-sm) !important\n}\n\n.rounded-start-2 {\n    border-bottom-left-radius: var(--bs-border-radius) !important;\n    border-top-left-radius: var(--bs-border-radius) !important\n}\n\n.rounded-start-3 {\n    border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n    border-top-left-radius: var(--bs-border-radius-lg) !important\n}\n\n.rounded-start-4 {\n    border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n    border-top-left-radius: var(--bs-border-radius-xl) !important\n}\n\n.rounded-start-5 {\n    border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n    border-top-left-radius: var(--bs-border-radius-xxl) !important\n}\n\n.rounded-start-circle {\n    border-bottom-left-radius: 50% !important;\n    border-top-left-radius: 50% !important\n}\n\n.rounded-start-pill {\n    border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n    border-top-left-radius: var(--bs-border-radius-pill) !important\n}\n\n.visible {\n    visibility: visible !important\n}\n\n.invisible {\n    visibility: hidden !important\n}\n\n.z-n1 {\n    z-index: -1 !important\n}\n\n.z-0 {\n    z-index: 0 !important\n}\n\n.z-1 {\n    z-index: 1 !important\n}\n\n.z-2 {\n    z-index: 2 !important\n}\n\n.z-3 {\n    z-index: 3 !important\n}\n\n@media(min-width: 576px) {\n    .float-sm-start {\n        float: left !important\n    }\n\n    .float-sm-end {\n        float: right !important\n    }\n\n    .float-sm-none {\n        float: none !important\n    }\n\n    .object-fit-sm-contain {\n        object-fit: contain !important\n    }\n\n    .object-fit-sm-cover {\n        object-fit: cover !important\n    }\n\n    .object-fit-sm-fill {\n        object-fit: fill !important\n    }\n\n    .object-fit-sm-scale {\n        object-fit: scale-down !important\n    }\n\n    .object-fit-sm-none {\n        object-fit: none !important\n    }\n\n    .d-sm-inline {\n        display: inline !important\n    }\n\n    .d-sm-inline-block {\n        display: inline-block !important\n    }\n\n    .d-sm-block {\n        display: block !important\n    }\n\n    .d-sm-grid {\n        display: grid !important\n    }\n\n    .d-sm-inline-grid {\n        display: inline-grid !important\n    }\n\n    .d-sm-table {\n        display: table !important\n    }\n\n    .d-sm-table-row {\n        display: table-row !important\n    }\n\n    .d-sm-table-cell {\n        display: table-cell !important\n    }\n\n    .d-sm-flex {\n        display: flex !important\n    }\n\n    .d-sm-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-sm-none {\n        display: none !important\n    }\n\n    .flex-sm-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-sm-row {\n        flex-direction: row !important\n    }\n\n    .flex-sm-column {\n        flex-direction: column !important\n    }\n\n    .flex-sm-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-sm-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-sm-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-sm-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-sm-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-sm-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .flex-sm-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-sm-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-sm-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .justify-content-sm-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-sm-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-sm-center {\n        justify-content: center !important\n    }\n\n    .justify-content-sm-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-sm-around {\n        justify-content: space-around !important\n    }\n\n    .justify-content-sm-evenly {\n        justify-content: space-evenly !important\n    }\n\n    .align-items-sm-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-sm-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-sm-center {\n        align-items: center !important\n    }\n\n    .align-items-sm-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-sm-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-sm-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-sm-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-sm-center {\n        align-content: center !important\n    }\n\n    .align-content-sm-between {\n        align-content: space-between !important\n    }\n\n    .align-content-sm-around {\n        align-content: space-around !important\n    }\n\n    .align-content-sm-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-sm-auto {\n        align-self: auto !important\n    }\n\n    .align-self-sm-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-sm-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-sm-center {\n        align-self: center !important\n    }\n\n    .align-self-sm-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-sm-stretch {\n        align-self: stretch !important\n    }\n\n    .order-sm-first {\n        order: -1 !important\n    }\n\n    .order-sm-0 {\n        order: 0 !important\n    }\n\n    .order-sm-1 {\n        order: 1 !important\n    }\n\n    .order-sm-2 {\n        order: 2 !important\n    }\n\n    .order-sm-3 {\n        order: 3 !important\n    }\n\n    .order-sm-4 {\n        order: 4 !important\n    }\n\n    .order-sm-5 {\n        order: 5 !important\n    }\n\n    .order-sm-last {\n        order: 6 !important\n    }\n\n    .m-sm-0 {\n        margin: 0 !important\n    }\n\n    .m-sm-1 {\n        margin: .25rem !important\n    }\n\n    .m-sm-2 {\n        margin: .5rem !important\n    }\n\n    .m-sm-3 {\n        margin: 1rem !important\n    }\n\n    .m-sm-4 {\n        margin: 1.5rem !important\n    }\n\n    .m-sm-5 {\n        margin: 3rem !important\n    }\n\n    .m-sm-auto {\n        margin: auto !important\n    }\n\n    .mx-sm-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important\n    }\n\n    .mx-sm-1 {\n        margin-right: .25rem !important;\n        margin-left: .25rem !important\n    }\n\n    .mx-sm-2 {\n        margin-right: .5rem !important;\n        margin-left: .5rem !important\n    }\n\n    .mx-sm-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-sm-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important\n    }\n\n    .mx-sm-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important\n    }\n\n    .mx-sm-auto {\n        margin-right: auto !important;\n        margin-left: auto !important\n    }\n\n    .my-sm-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important\n    }\n\n    .my-sm-1 {\n        margin-top: .25rem !important;\n        margin-bottom: .25rem !important\n    }\n\n    .my-sm-2 {\n        margin-top: .5rem !important;\n        margin-bottom: .5rem !important\n    }\n\n    .my-sm-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-sm-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important\n    }\n\n    .my-sm-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important\n    }\n\n    .my-sm-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important\n    }\n\n    .mt-sm-0 {\n        margin-top: 0 !important\n    }\n\n    .mt-sm-1 {\n        margin-top: .25rem !important\n    }\n\n    .mt-sm-2 {\n        margin-top: .5rem !important\n    }\n\n    .mt-sm-3 {\n        margin-top: 1rem !important\n    }\n\n    .mt-sm-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mt-sm-5 {\n        margin-top: 3rem !important\n    }\n\n    .mt-sm-auto {\n        margin-top: auto !important\n    }\n\n    .me-sm-0 {\n        margin-right: 0 !important\n    }\n\n    .me-sm-1 {\n        margin-right: .25rem !important\n    }\n\n    .me-sm-2 {\n        margin-right: .5rem !important\n    }\n\n    .me-sm-3 {\n        margin-right: 1rem !important\n    }\n\n    .me-sm-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .me-sm-5 {\n        margin-right: 3rem !important\n    }\n\n    .me-sm-auto {\n        margin-right: auto !important\n    }\n\n    .mb-sm-0 {\n        margin-bottom: 0 !important\n    }\n\n    .mb-sm-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .mb-sm-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .mb-sm-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-sm-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .mb-sm-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .mb-sm-auto {\n        margin-bottom: auto !important\n    }\n\n    .ms-sm-0 {\n        margin-left: 0 !important\n    }\n\n    .ms-sm-1 {\n        margin-left: .25rem !important\n    }\n\n    .ms-sm-2 {\n        margin-left: .5rem !important\n    }\n\n    .ms-sm-3 {\n        margin-left: 1rem !important\n    }\n\n    .ms-sm-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .ms-sm-5 {\n        margin-left: 3rem !important\n    }\n\n    .ms-sm-auto {\n        margin-left: auto !important\n    }\n\n    .p-sm-0 {\n        padding: 0 !important\n    }\n\n    .p-sm-1 {\n        padding: .25rem !important\n    }\n\n    .p-sm-2 {\n        padding: .5rem !important\n    }\n\n    .p-sm-3 {\n        padding: 1rem !important\n    }\n\n    .p-sm-4 {\n        padding: 1.5rem !important\n    }\n\n    .p-sm-5 {\n        padding: 3rem !important\n    }\n\n    .px-sm-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important\n    }\n\n    .px-sm-1 {\n        padding-right: .25rem !important;\n        padding-left: .25rem !important\n    }\n\n    .px-sm-2 {\n        padding-right: .5rem !important;\n        padding-left: .5rem !important\n    }\n\n    .px-sm-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-sm-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important\n    }\n\n    .px-sm-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important\n    }\n\n    .py-sm-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .py-sm-1 {\n        padding-top: .25rem !important;\n        padding-bottom: .25rem !important\n    }\n\n    .py-sm-2 {\n        padding-top: .5rem !important;\n        padding-bottom: .5rem !important\n    }\n\n    .py-sm-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-sm-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important\n    }\n\n    .py-sm-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important\n    }\n\n    .pt-sm-0 {\n        padding-top: 0 !important\n    }\n\n    .pt-sm-1 {\n        padding-top: .25rem !important\n    }\n\n    .pt-sm-2 {\n        padding-top: .5rem !important\n    }\n\n    .pt-sm-3 {\n        padding-top: 1rem !important\n    }\n\n    .pt-sm-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pt-sm-5 {\n        padding-top: 3rem !important\n    }\n\n    .pe-sm-0 {\n        padding-right: 0 !important\n    }\n\n    .pe-sm-1 {\n        padding-right: .25rem !important\n    }\n\n    .pe-sm-2 {\n        padding-right: .5rem !important\n    }\n\n    .pe-sm-3 {\n        padding-right: 1rem !important\n    }\n\n    .pe-sm-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pe-sm-5 {\n        padding-right: 3rem !important\n    }\n\n    .pb-sm-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pb-sm-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pb-sm-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pb-sm-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-sm-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pb-sm-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .ps-sm-0 {\n        padding-left: 0 !important\n    }\n\n    .ps-sm-1 {\n        padding-left: .25rem !important\n    }\n\n    .ps-sm-2 {\n        padding-left: .5rem !important\n    }\n\n    .ps-sm-3 {\n        padding-left: 1rem !important\n    }\n\n    .ps-sm-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .ps-sm-5 {\n        padding-left: 3rem !important\n    }\n\n    .gap-sm-0 {\n        gap: 0 !important\n    }\n\n    .gap-sm-1 {\n        gap: .25rem !important\n    }\n\n    .gap-sm-2 {\n        gap: .5rem !important\n    }\n\n    .gap-sm-3 {\n        gap: 1rem !important\n    }\n\n    .gap-sm-4 {\n        gap: 1.5rem !important\n    }\n\n    .gap-sm-5 {\n        gap: 3rem !important\n    }\n\n    .row-gap-sm-0 {\n        row-gap: 0 !important\n    }\n\n    .row-gap-sm-1 {\n        row-gap: .25rem !important\n    }\n\n    .row-gap-sm-2 {\n        row-gap: .5rem !important\n    }\n\n    .row-gap-sm-3 {\n        row-gap: 1rem !important\n    }\n\n    .row-gap-sm-4 {\n        row-gap: 1.5rem !important\n    }\n\n    .row-gap-sm-5 {\n        row-gap: 3rem !important\n    }\n\n    .column-gap-sm-0 {\n        column-gap: 0 !important\n    }\n\n    .column-gap-sm-1 {\n        column-gap: .25rem !important\n    }\n\n    .column-gap-sm-2 {\n        column-gap: .5rem !important\n    }\n\n    .column-gap-sm-3 {\n        column-gap: 1rem !important\n    }\n\n    .column-gap-sm-4 {\n        column-gap: 1.5rem !important\n    }\n\n    .column-gap-sm-5 {\n        column-gap: 3rem !important\n    }\n\n    .text-sm-start {\n        text-align: left !important\n    }\n\n    .text-sm-end {\n        text-align: right !important\n    }\n\n    .text-sm-center {\n        text-align: center !important\n    }\n}\n\n@media(min-width: 768px) {\n    .float-md-start {\n        float: left !important\n    }\n\n    .float-md-end {\n        float: right !important\n    }\n\n    .float-md-none {\n        float: none !important\n    }\n\n    .object-fit-md-contain {\n        object-fit: contain !important\n    }\n\n    .object-fit-md-cover {\n        object-fit: cover !important\n    }\n\n    .object-fit-md-fill {\n        object-fit: fill !important\n    }\n\n    .object-fit-md-scale {\n        object-fit: scale-down !important\n    }\n\n    .object-fit-md-none {\n        object-fit: none !important\n    }\n\n    .d-md-inline {\n        display: inline !important\n    }\n\n    .d-md-inline-block {\n        display: inline-block !important\n    }\n\n    .d-md-block {\n        display: block !important\n    }\n\n    .d-md-grid {\n        display: grid !important\n    }\n\n    .d-md-inline-grid {\n        display: inline-grid !important\n    }\n\n    .d-md-table {\n        display: table !important\n    }\n\n    .d-md-table-row {\n        display: table-row !important\n    }\n\n    .d-md-table-cell {\n        display: table-cell !important\n    }\n\n    .d-md-flex {\n        display: flex !important\n    }\n\n    .d-md-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-md-none {\n        display: none !important\n    }\n\n    .flex-md-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-md-row {\n        flex-direction: row !important\n    }\n\n    .flex-md-column {\n        flex-direction: column !important\n    }\n\n    .flex-md-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-md-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-md-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-md-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-md-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-md-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .flex-md-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-md-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-md-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .justify-content-md-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-md-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-md-center {\n        justify-content: center !important\n    }\n\n    .justify-content-md-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-md-around {\n        justify-content: space-around !important\n    }\n\n    .justify-content-md-evenly {\n        justify-content: space-evenly !important\n    }\n\n    .align-items-md-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-md-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-md-center {\n        align-items: center !important\n    }\n\n    .align-items-md-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-md-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-md-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-md-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-md-center {\n        align-content: center !important\n    }\n\n    .align-content-md-between {\n        align-content: space-between !important\n    }\n\n    .align-content-md-around {\n        align-content: space-around !important\n    }\n\n    .align-content-md-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-md-auto {\n        align-self: auto !important\n    }\n\n    .align-self-md-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-md-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-md-center {\n        align-self: center !important\n    }\n\n    .align-self-md-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-md-stretch {\n        align-self: stretch !important\n    }\n\n    .order-md-first {\n        order: -1 !important\n    }\n\n    .order-md-0 {\n        order: 0 !important\n    }\n\n    .order-md-1 {\n        order: 1 !important\n    }\n\n    .order-md-2 {\n        order: 2 !important\n    }\n\n    .order-md-3 {\n        order: 3 !important\n    }\n\n    .order-md-4 {\n        order: 4 !important\n    }\n\n    .order-md-5 {\n        order: 5 !important\n    }\n\n    .order-md-last {\n        order: 6 !important\n    }\n\n    .m-md-0 {\n        margin: 0 !important\n    }\n\n    .m-md-1 {\n        margin: .25rem !important\n    }\n\n    .m-md-2 {\n        margin: .5rem !important\n    }\n\n    .m-md-3 {\n        margin: 1rem !important\n    }\n\n    .m-md-4 {\n        margin: 1.5rem !important\n    }\n\n    .m-md-5 {\n        margin: 3rem !important\n    }\n\n    .m-md-auto {\n        margin: auto !important\n    }\n\n    .mx-md-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important\n    }\n\n    .mx-md-1 {\n        margin-right: .25rem !important;\n        margin-left: .25rem !important\n    }\n\n    .mx-md-2 {\n        margin-right: .5rem !important;\n        margin-left: .5rem !important\n    }\n\n    .mx-md-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-md-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important\n    }\n\n    .mx-md-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important\n    }\n\n    .mx-md-auto {\n        margin-right: auto !important;\n        margin-left: auto !important\n    }\n\n    .my-md-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important\n    }\n\n    .my-md-1 {\n        margin-top: .25rem !important;\n        margin-bottom: .25rem !important\n    }\n\n    .my-md-2 {\n        margin-top: .5rem !important;\n        margin-bottom: .5rem !important\n    }\n\n    .my-md-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-md-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important\n    }\n\n    .my-md-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important\n    }\n\n    .my-md-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important\n    }\n\n    .mt-md-0 {\n        margin-top: 0 !important\n    }\n\n    .mt-md-1 {\n        margin-top: .25rem !important\n    }\n\n    .mt-md-2 {\n        margin-top: .5rem !important\n    }\n\n    .mt-md-3 {\n        margin-top: 1rem !important\n    }\n\n    .mt-md-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mt-md-5 {\n        margin-top: 3rem !important\n    }\n\n    .mt-md-auto {\n        margin-top: auto !important\n    }\n\n    .me-md-0 {\n        margin-right: 0 !important\n    }\n\n    .me-md-1 {\n        margin-right: .25rem !important\n    }\n\n    .me-md-2 {\n        margin-right: .5rem !important\n    }\n\n    .me-md-3 {\n        margin-right: 1rem !important\n    }\n\n    .me-md-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .me-md-5 {\n        margin-right: 3rem !important\n    }\n\n    .me-md-auto {\n        margin-right: auto !important\n    }\n\n    .mb-md-0 {\n        margin-bottom: 0 !important\n    }\n\n    .mb-md-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .mb-md-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .mb-md-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-md-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .mb-md-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .mb-md-auto {\n        margin-bottom: auto !important\n    }\n\n    .ms-md-0 {\n        margin-left: 0 !important\n    }\n\n    .ms-md-1 {\n        margin-left: .25rem !important\n    }\n\n    .ms-md-2 {\n        margin-left: .5rem !important\n    }\n\n    .ms-md-3 {\n        margin-left: 1rem !important\n    }\n\n    .ms-md-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .ms-md-5 {\n        margin-left: 3rem !important\n    }\n\n    .ms-md-auto {\n        margin-left: auto !important\n    }\n\n    .p-md-0 {\n        padding: 0 !important\n    }\n\n    .p-md-1 {\n        padding: .25rem !important\n    }\n\n    .p-md-2 {\n        padding: .5rem !important\n    }\n\n    .p-md-3 {\n        padding: 1rem !important\n    }\n\n    .p-md-4 {\n        padding: 1.5rem !important\n    }\n\n    .p-md-5 {\n        padding: 3rem !important\n    }\n\n    .px-md-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important\n    }\n\n    .px-md-1 {\n        padding-right: .25rem !important;\n        padding-left: .25rem !important\n    }\n\n    .px-md-2 {\n        padding-right: .5rem !important;\n        padding-left: .5rem !important\n    }\n\n    .px-md-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-md-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important\n    }\n\n    .px-md-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important\n    }\n\n    .py-md-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .py-md-1 {\n        padding-top: .25rem !important;\n        padding-bottom: .25rem !important\n    }\n\n    .py-md-2 {\n        padding-top: .5rem !important;\n        padding-bottom: .5rem !important\n    }\n\n    .py-md-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-md-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important\n    }\n\n    .py-md-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important\n    }\n\n    .pt-md-0 {\n        padding-top: 0 !important\n    }\n\n    .pt-md-1 {\n        padding-top: .25rem !important\n    }\n\n    .pt-md-2 {\n        padding-top: .5rem !important\n    }\n\n    .pt-md-3 {\n        padding-top: 1rem !important\n    }\n\n    .pt-md-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pt-md-5 {\n        padding-top: 3rem !important\n    }\n\n    .pe-md-0 {\n        padding-right: 0 !important\n    }\n\n    .pe-md-1 {\n        padding-right: .25rem !important\n    }\n\n    .pe-md-2 {\n        padding-right: .5rem !important\n    }\n\n    .pe-md-3 {\n        padding-right: 1rem !important\n    }\n\n    .pe-md-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pe-md-5 {\n        padding-right: 3rem !important\n    }\n\n    .pb-md-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pb-md-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pb-md-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pb-md-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-md-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pb-md-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .ps-md-0 {\n        padding-left: 0 !important\n    }\n\n    .ps-md-1 {\n        padding-left: .25rem !important\n    }\n\n    .ps-md-2 {\n        padding-left: .5rem !important\n    }\n\n    .ps-md-3 {\n        padding-left: 1rem !important\n    }\n\n    .ps-md-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .ps-md-5 {\n        padding-left: 3rem !important\n    }\n\n    .gap-md-0 {\n        gap: 0 !important\n    }\n\n    .gap-md-1 {\n        gap: .25rem !important\n    }\n\n    .gap-md-2 {\n        gap: .5rem !important\n    }\n\n    .gap-md-3 {\n        gap: 1rem !important\n    }\n\n    .gap-md-4 {\n        gap: 1.5rem !important\n    }\n\n    .gap-md-5 {\n        gap: 3rem !important\n    }\n\n    .row-gap-md-0 {\n        row-gap: 0 !important\n    }\n\n    .row-gap-md-1 {\n        row-gap: .25rem !important\n    }\n\n    .row-gap-md-2 {\n        row-gap: .5rem !important\n    }\n\n    .row-gap-md-3 {\n        row-gap: 1rem !important\n    }\n\n    .row-gap-md-4 {\n        row-gap: 1.5rem !important\n    }\n\n    .row-gap-md-5 {\n        row-gap: 3rem !important\n    }\n\n    .column-gap-md-0 {\n        column-gap: 0 !important\n    }\n\n    .column-gap-md-1 {\n        column-gap: .25rem !important\n    }\n\n    .column-gap-md-2 {\n        column-gap: .5rem !important\n    }\n\n    .column-gap-md-3 {\n        column-gap: 1rem !important\n    }\n\n    .column-gap-md-4 {\n        column-gap: 1.5rem !important\n    }\n\n    .column-gap-md-5 {\n        column-gap: 3rem !important\n    }\n\n    .text-md-start {\n        text-align: left !important\n    }\n\n    .text-md-end {\n        text-align: right !important\n    }\n\n    .text-md-center {\n        text-align: center !important\n    }\n}\n\n@media(min-width: 992px) {\n    .float-lg-start {\n        float: left !important\n    }\n\n    .float-lg-end {\n        float: right !important\n    }\n\n    .float-lg-none {\n        float: none !important\n    }\n\n    .object-fit-lg-contain {\n        object-fit: contain !important\n    }\n\n    .object-fit-lg-cover {\n        object-fit: cover !important\n    }\n\n    .object-fit-lg-fill {\n        object-fit: fill !important\n    }\n\n    .object-fit-lg-scale {\n        object-fit: scale-down !important\n    }\n\n    .object-fit-lg-none {\n        object-fit: none !important\n    }\n\n    .d-lg-inline {\n        display: inline !important\n    }\n\n    .d-lg-inline-block {\n        display: inline-block !important\n    }\n\n    .d-lg-block {\n        display: block !important\n    }\n\n    .d-lg-grid {\n        display: grid !important\n    }\n\n    .d-lg-inline-grid {\n        display: inline-grid !important\n    }\n\n    .d-lg-table {\n        display: table !important\n    }\n\n    .d-lg-table-row {\n        display: table-row !important\n    }\n\n    .d-lg-table-cell {\n        display: table-cell !important\n    }\n\n    .d-lg-flex {\n        display: flex !important\n    }\n\n    .d-lg-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-lg-none {\n        display: none !important\n    }\n\n    .flex-lg-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-lg-row {\n        flex-direction: row !important\n    }\n\n    .flex-lg-column {\n        flex-direction: column !important\n    }\n\n    .flex-lg-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-lg-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-lg-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-lg-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-lg-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-lg-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .flex-lg-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-lg-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-lg-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .justify-content-lg-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-lg-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-lg-center {\n        justify-content: center !important\n    }\n\n    .justify-content-lg-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-lg-around {\n        justify-content: space-around !important\n    }\n\n    .justify-content-lg-evenly {\n        justify-content: space-evenly !important\n    }\n\n    .align-items-lg-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-lg-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-lg-center {\n        align-items: center !important\n    }\n\n    .align-items-lg-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-lg-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-lg-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-lg-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-lg-center {\n        align-content: center !important\n    }\n\n    .align-content-lg-between {\n        align-content: space-between !important\n    }\n\n    .align-content-lg-around {\n        align-content: space-around !important\n    }\n\n    .align-content-lg-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-lg-auto {\n        align-self: auto !important\n    }\n\n    .align-self-lg-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-lg-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-lg-center {\n        align-self: center !important\n    }\n\n    .align-self-lg-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-lg-stretch {\n        align-self: stretch !important\n    }\n\n    .order-lg-first {\n        order: -1 !important\n    }\n\n    .order-lg-0 {\n        order: 0 !important\n    }\n\n    .order-lg-1 {\n        order: 1 !important\n    }\n\n    .order-lg-2 {\n        order: 2 !important\n    }\n\n    .order-lg-3 {\n        order: 3 !important\n    }\n\n    .order-lg-4 {\n        order: 4 !important\n    }\n\n    .order-lg-5 {\n        order: 5 !important\n    }\n\n    .order-lg-last {\n        order: 6 !important\n    }\n\n    .m-lg-0 {\n        margin: 0 !important\n    }\n\n    .m-lg-1 {\n        margin: .25rem !important\n    }\n\n    .m-lg-2 {\n        margin: .5rem !important\n    }\n\n    .m-lg-3 {\n        margin: 1rem !important\n    }\n\n    .m-lg-4 {\n        margin: 1.5rem !important\n    }\n\n    .m-lg-5 {\n        margin: 3rem !important\n    }\n\n    .m-lg-auto {\n        margin: auto !important\n    }\n\n    .mx-lg-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important\n    }\n\n    .mx-lg-1 {\n        margin-right: .25rem !important;\n        margin-left: .25rem !important\n    }\n\n    .mx-lg-2 {\n        margin-right: .5rem !important;\n        margin-left: .5rem !important\n    }\n\n    .mx-lg-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-lg-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important\n    }\n\n    .mx-lg-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important\n    }\n\n    .mx-lg-auto {\n        margin-right: auto !important;\n        margin-left: auto !important\n    }\n\n    .my-lg-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important\n    }\n\n    .my-lg-1 {\n        margin-top: .25rem !important;\n        margin-bottom: .25rem !important\n    }\n\n    .my-lg-2 {\n        margin-top: .5rem !important;\n        margin-bottom: .5rem !important\n    }\n\n    .my-lg-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-lg-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important\n    }\n\n    .my-lg-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important\n    }\n\n    .my-lg-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important\n    }\n\n    .mt-lg-0 {\n        margin-top: 0 !important\n    }\n\n    .mt-lg-1 {\n        margin-top: .25rem !important\n    }\n\n    .mt-lg-2 {\n        margin-top: .5rem !important\n    }\n\n    .mt-lg-3 {\n        margin-top: 1rem !important\n    }\n\n    .mt-lg-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mt-lg-5 {\n        margin-top: 3rem !important\n    }\n\n    .mt-lg-auto {\n        margin-top: auto !important\n    }\n\n    .me-lg-0 {\n        margin-right: 0 !important\n    }\n\n    .me-lg-1 {\n        margin-right: .25rem !important\n    }\n\n    .me-lg-2 {\n        margin-right: .5rem !important\n    }\n\n    .me-lg-3 {\n        margin-right: 1rem !important\n    }\n\n    .me-lg-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .me-lg-5 {\n        margin-right: 3rem !important\n    }\n\n    .me-lg-auto {\n        margin-right: auto !important\n    }\n\n    .mb-lg-0 {\n        margin-bottom: 0 !important\n    }\n\n    .mb-lg-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .mb-lg-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .mb-lg-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-lg-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .mb-lg-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .mb-lg-auto {\n        margin-bottom: auto !important\n    }\n\n    .ms-lg-0 {\n        margin-left: 0 !important\n    }\n\n    .ms-lg-1 {\n        margin-left: .25rem !important\n    }\n\n    .ms-lg-2 {\n        margin-left: .5rem !important\n    }\n\n    .ms-lg-3 {\n        margin-left: 1rem !important\n    }\n\n    .ms-lg-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .ms-lg-5 {\n        margin-left: 3rem !important\n    }\n\n    .ms-lg-auto {\n        margin-left: auto !important\n    }\n\n    .p-lg-0 {\n        padding: 0 !important\n    }\n\n    .p-lg-1 {\n        padding: .25rem !important\n    }\n\n    .p-lg-2 {\n        padding: .5rem !important\n    }\n\n    .p-lg-3 {\n        padding: 1rem !important\n    }\n\n    .p-lg-4 {\n        padding: 1.5rem !important\n    }\n\n    .p-lg-5 {\n        padding: 3rem !important\n    }\n\n    .px-lg-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important\n    }\n\n    .px-lg-1 {\n        padding-right: .25rem !important;\n        padding-left: .25rem !important\n    }\n\n    .px-lg-2 {\n        padding-right: .5rem !important;\n        padding-left: .5rem !important\n    }\n\n    .px-lg-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-lg-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important\n    }\n\n    .px-lg-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important\n    }\n\n    .py-lg-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .py-lg-1 {\n        padding-top: .25rem !important;\n        padding-bottom: .25rem !important\n    }\n\n    .py-lg-2 {\n        padding-top: .5rem !important;\n        padding-bottom: .5rem !important\n    }\n\n    .py-lg-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-lg-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important\n    }\n\n    .py-lg-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important\n    }\n\n    .pt-lg-0 {\n        padding-top: 0 !important\n    }\n\n    .pt-lg-1 {\n        padding-top: .25rem !important\n    }\n\n    .pt-lg-2 {\n        padding-top: .5rem !important\n    }\n\n    .pt-lg-3 {\n        padding-top: 1rem !important\n    }\n\n    .pt-lg-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pt-lg-5 {\n        padding-top: 3rem !important\n    }\n\n    .pe-lg-0 {\n        padding-right: 0 !important\n    }\n\n    .pe-lg-1 {\n        padding-right: .25rem !important\n    }\n\n    .pe-lg-2 {\n        padding-right: .5rem !important\n    }\n\n    .pe-lg-3 {\n        padding-right: 1rem !important\n    }\n\n    .pe-lg-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pe-lg-5 {\n        padding-right: 3rem !important\n    }\n\n    .pb-lg-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pb-lg-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pb-lg-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pb-lg-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-lg-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pb-lg-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .ps-lg-0 {\n        padding-left: 0 !important\n    }\n\n    .ps-lg-1 {\n        padding-left: .25rem !important\n    }\n\n    .ps-lg-2 {\n        padding-left: .5rem !important\n    }\n\n    .ps-lg-3 {\n        padding-left: 1rem !important\n    }\n\n    .ps-lg-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .ps-lg-5 {\n        padding-left: 3rem !important\n    }\n\n    .gap-lg-0 {\n        gap: 0 !important\n    }\n\n    .gap-lg-1 {\n        gap: .25rem !important\n    }\n\n    .gap-lg-2 {\n        gap: .5rem !important\n    }\n\n    .gap-lg-3 {\n        gap: 1rem !important\n    }\n\n    .gap-lg-4 {\n        gap: 1.5rem !important\n    }\n\n    .gap-lg-5 {\n        gap: 3rem !important\n    }\n\n    .row-gap-lg-0 {\n        row-gap: 0 !important\n    }\n\n    .row-gap-lg-1 {\n        row-gap: .25rem !important\n    }\n\n    .row-gap-lg-2 {\n        row-gap: .5rem !important\n    }\n\n    .row-gap-lg-3 {\n        row-gap: 1rem !important\n    }\n\n    .row-gap-lg-4 {\n        row-gap: 1.5rem !important\n    }\n\n    .row-gap-lg-5 {\n        row-gap: 3rem !important\n    }\n\n    .column-gap-lg-0 {\n        column-gap: 0 !important\n    }\n\n    .column-gap-lg-1 {\n        column-gap: .25rem !important\n    }\n\n    .column-gap-lg-2 {\n        column-gap: .5rem !important\n    }\n\n    .column-gap-lg-3 {\n        column-gap: 1rem !important\n    }\n\n    .column-gap-lg-4 {\n        column-gap: 1.5rem !important\n    }\n\n    .column-gap-lg-5 {\n        column-gap: 3rem !important\n    }\n\n    .text-lg-start {\n        text-align: left !important\n    }\n\n    .text-lg-end {\n        text-align: right !important\n    }\n\n    .text-lg-center {\n        text-align: center !important\n    }\n}\n\n@media(min-width: 1200px) {\n    .float-xl-start {\n        float: left !important\n    }\n\n    .float-xl-end {\n        float: right !important\n    }\n\n    .float-xl-none {\n        float: none !important\n    }\n\n    .object-fit-xl-contain {\n        object-fit: contain !important\n    }\n\n    .object-fit-xl-cover {\n        object-fit: cover !important\n    }\n\n    .object-fit-xl-fill {\n        object-fit: fill !important\n    }\n\n    .object-fit-xl-scale {\n        object-fit: scale-down !important\n    }\n\n    .object-fit-xl-none {\n        object-fit: none !important\n    }\n\n    .d-xl-inline {\n        display: inline !important\n    }\n\n    .d-xl-inline-block {\n        display: inline-block !important\n    }\n\n    .d-xl-block {\n        display: block !important\n    }\n\n    .d-xl-grid {\n        display: grid !important\n    }\n\n    .d-xl-inline-grid {\n        display: inline-grid !important\n    }\n\n    .d-xl-table {\n        display: table !important\n    }\n\n    .d-xl-table-row {\n        display: table-row !important\n    }\n\n    .d-xl-table-cell {\n        display: table-cell !important\n    }\n\n    .d-xl-flex {\n        display: flex !important\n    }\n\n    .d-xl-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-xl-none {\n        display: none !important\n    }\n\n    .flex-xl-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-xl-row {\n        flex-direction: row !important\n    }\n\n    .flex-xl-column {\n        flex-direction: column !important\n    }\n\n    .flex-xl-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-xl-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-xl-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-xl-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-xl-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-xl-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .flex-xl-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-xl-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-xl-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .justify-content-xl-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-xl-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-xl-center {\n        justify-content: center !important\n    }\n\n    .justify-content-xl-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-xl-around {\n        justify-content: space-around !important\n    }\n\n    .justify-content-xl-evenly {\n        justify-content: space-evenly !important\n    }\n\n    .align-items-xl-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-xl-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-xl-center {\n        align-items: center !important\n    }\n\n    .align-items-xl-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-xl-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-xl-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-xl-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-xl-center {\n        align-content: center !important\n    }\n\n    .align-content-xl-between {\n        align-content: space-between !important\n    }\n\n    .align-content-xl-around {\n        align-content: space-around !important\n    }\n\n    .align-content-xl-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-xl-auto {\n        align-self: auto !important\n    }\n\n    .align-self-xl-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-xl-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-xl-center {\n        align-self: center !important\n    }\n\n    .align-self-xl-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-xl-stretch {\n        align-self: stretch !important\n    }\n\n    .order-xl-first {\n        order: -1 !important\n    }\n\n    .order-xl-0 {\n        order: 0 !important\n    }\n\n    .order-xl-1 {\n        order: 1 !important\n    }\n\n    .order-xl-2 {\n        order: 2 !important\n    }\n\n    .order-xl-3 {\n        order: 3 !important\n    }\n\n    .order-xl-4 {\n        order: 4 !important\n    }\n\n    .order-xl-5 {\n        order: 5 !important\n    }\n\n    .order-xl-last {\n        order: 6 !important\n    }\n\n    .m-xl-0 {\n        margin: 0 !important\n    }\n\n    .m-xl-1 {\n        margin: .25rem !important\n    }\n\n    .m-xl-2 {\n        margin: .5rem !important\n    }\n\n    .m-xl-3 {\n        margin: 1rem !important\n    }\n\n    .m-xl-4 {\n        margin: 1.5rem !important\n    }\n\n    .m-xl-5 {\n        margin: 3rem !important\n    }\n\n    .m-xl-auto {\n        margin: auto !important\n    }\n\n    .mx-xl-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important\n    }\n\n    .mx-xl-1 {\n        margin-right: .25rem !important;\n        margin-left: .25rem !important\n    }\n\n    .mx-xl-2 {\n        margin-right: .5rem !important;\n        margin-left: .5rem !important\n    }\n\n    .mx-xl-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-xl-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important\n    }\n\n    .mx-xl-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important\n    }\n\n    .mx-xl-auto {\n        margin-right: auto !important;\n        margin-left: auto !important\n    }\n\n    .my-xl-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important\n    }\n\n    .my-xl-1 {\n        margin-top: .25rem !important;\n        margin-bottom: .25rem !important\n    }\n\n    .my-xl-2 {\n        margin-top: .5rem !important;\n        margin-bottom: .5rem !important\n    }\n\n    .my-xl-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-xl-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important\n    }\n\n    .my-xl-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important\n    }\n\n    .my-xl-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important\n    }\n\n    .mt-xl-0 {\n        margin-top: 0 !important\n    }\n\n    .mt-xl-1 {\n        margin-top: .25rem !important\n    }\n\n    .mt-xl-2 {\n        margin-top: .5rem !important\n    }\n\n    .mt-xl-3 {\n        margin-top: 1rem !important\n    }\n\n    .mt-xl-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mt-xl-5 {\n        margin-top: 3rem !important\n    }\n\n    .mt-xl-auto {\n        margin-top: auto !important\n    }\n\n    .me-xl-0 {\n        margin-right: 0 !important\n    }\n\n    .me-xl-1 {\n        margin-right: .25rem !important\n    }\n\n    .me-xl-2 {\n        margin-right: .5rem !important\n    }\n\n    .me-xl-3 {\n        margin-right: 1rem !important\n    }\n\n    .me-xl-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .me-xl-5 {\n        margin-right: 3rem !important\n    }\n\n    .me-xl-auto {\n        margin-right: auto !important\n    }\n\n    .mb-xl-0 {\n        margin-bottom: 0 !important\n    }\n\n    .mb-xl-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .mb-xl-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .mb-xl-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-xl-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .mb-xl-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .mb-xl-auto {\n        margin-bottom: auto !important\n    }\n\n    .ms-xl-0 {\n        margin-left: 0 !important\n    }\n\n    .ms-xl-1 {\n        margin-left: .25rem !important\n    }\n\n    .ms-xl-2 {\n        margin-left: .5rem !important\n    }\n\n    .ms-xl-3 {\n        margin-left: 1rem !important\n    }\n\n    .ms-xl-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .ms-xl-5 {\n        margin-left: 3rem !important\n    }\n\n    .ms-xl-auto {\n        margin-left: auto !important\n    }\n\n    .p-xl-0 {\n        padding: 0 !important\n    }\n\n    .p-xl-1 {\n        padding: .25rem !important\n    }\n\n    .p-xl-2 {\n        padding: .5rem !important\n    }\n\n    .p-xl-3 {\n        padding: 1rem !important\n    }\n\n    .p-xl-4 {\n        padding: 1.5rem !important\n    }\n\n    .p-xl-5 {\n        padding: 3rem !important\n    }\n\n    .px-xl-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important\n    }\n\n    .px-xl-1 {\n        padding-right: .25rem !important;\n        padding-left: .25rem !important\n    }\n\n    .px-xl-2 {\n        padding-right: .5rem !important;\n        padding-left: .5rem !important\n    }\n\n    .px-xl-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-xl-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important\n    }\n\n    .px-xl-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important\n    }\n\n    .py-xl-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .py-xl-1 {\n        padding-top: .25rem !important;\n        padding-bottom: .25rem !important\n    }\n\n    .py-xl-2 {\n        padding-top: .5rem !important;\n        padding-bottom: .5rem !important\n    }\n\n    .py-xl-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-xl-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important\n    }\n\n    .py-xl-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important\n    }\n\n    .pt-xl-0 {\n        padding-top: 0 !important\n    }\n\n    .pt-xl-1 {\n        padding-top: .25rem !important\n    }\n\n    .pt-xl-2 {\n        padding-top: .5rem !important\n    }\n\n    .pt-xl-3 {\n        padding-top: 1rem !important\n    }\n\n    .pt-xl-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pt-xl-5 {\n        padding-top: 3rem !important\n    }\n\n    .pe-xl-0 {\n        padding-right: 0 !important\n    }\n\n    .pe-xl-1 {\n        padding-right: .25rem !important\n    }\n\n    .pe-xl-2 {\n        padding-right: .5rem !important\n    }\n\n    .pe-xl-3 {\n        padding-right: 1rem !important\n    }\n\n    .pe-xl-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pe-xl-5 {\n        padding-right: 3rem !important\n    }\n\n    .pb-xl-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pb-xl-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pb-xl-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pb-xl-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-xl-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pb-xl-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .ps-xl-0 {\n        padding-left: 0 !important\n    }\n\n    .ps-xl-1 {\n        padding-left: .25rem !important\n    }\n\n    .ps-xl-2 {\n        padding-left: .5rem !important\n    }\n\n    .ps-xl-3 {\n        padding-left: 1rem !important\n    }\n\n    .ps-xl-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .ps-xl-5 {\n        padding-left: 3rem !important\n    }\n\n    .gap-xl-0 {\n        gap: 0 !important\n    }\n\n    .gap-xl-1 {\n        gap: .25rem !important\n    }\n\n    .gap-xl-2 {\n        gap: .5rem !important\n    }\n\n    .gap-xl-3 {\n        gap: 1rem !important\n    }\n\n    .gap-xl-4 {\n        gap: 1.5rem !important\n    }\n\n    .gap-xl-5 {\n        gap: 3rem !important\n    }\n\n    .row-gap-xl-0 {\n        row-gap: 0 !important\n    }\n\n    .row-gap-xl-1 {\n        row-gap: .25rem !important\n    }\n\n    .row-gap-xl-2 {\n        row-gap: .5rem !important\n    }\n\n    .row-gap-xl-3 {\n        row-gap: 1rem !important\n    }\n\n    .row-gap-xl-4 {\n        row-gap: 1.5rem !important\n    }\n\n    .row-gap-xl-5 {\n        row-gap: 3rem !important\n    }\n\n    .column-gap-xl-0 {\n        column-gap: 0 !important\n    }\n\n    .column-gap-xl-1 {\n        column-gap: .25rem !important\n    }\n\n    .column-gap-xl-2 {\n        column-gap: .5rem !important\n    }\n\n    .column-gap-xl-3 {\n        column-gap: 1rem !important\n    }\n\n    .column-gap-xl-4 {\n        column-gap: 1.5rem !important\n    }\n\n    .column-gap-xl-5 {\n        column-gap: 3rem !important\n    }\n\n    .text-xl-start {\n        text-align: left !important\n    }\n\n    .text-xl-end {\n        text-align: right !important\n    }\n\n    .text-xl-center {\n        text-align: center !important\n    }\n}\n\n@media(min-width: 1440) {\n    .float-xxl-start {\n        float: left !important\n    }\n\n    .float-xxl-end {\n        float: right !important\n    }\n\n    .float-xxl-none {\n        float: none !important\n    }\n\n    .object-fit-xxl-contain {\n        object-fit: contain !important\n    }\n\n    .object-fit-xxl-cover {\n        object-fit: cover !important\n    }\n\n    .object-fit-xxl-fill {\n        object-fit: fill !important\n    }\n\n    .object-fit-xxl-scale {\n        object-fit: scale-down !important\n    }\n\n    .object-fit-xxl-none {\n        object-fit: none !important\n    }\n\n    .d-xxl-inline {\n        display: inline !important\n    }\n\n    .d-xxl-inline-block {\n        display: inline-block !important\n    }\n\n    .d-xxl-block {\n        display: block !important\n    }\n\n    .d-xxl-grid {\n        display: grid !important\n    }\n\n    .d-xxl-inline-grid {\n        display: inline-grid !important\n    }\n\n    .d-xxl-table {\n        display: table !important\n    }\n\n    .d-xxl-table-row {\n        display: table-row !important\n    }\n\n    .d-xxl-table-cell {\n        display: table-cell !important\n    }\n\n    .d-xxl-flex {\n        display: flex !important\n    }\n\n    .d-xxl-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-xxl-none {\n        display: none !important\n    }\n\n    .flex-xxl-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-xxl-row {\n        flex-direction: row !important\n    }\n\n    .flex-xxl-column {\n        flex-direction: column !important\n    }\n\n    .flex-xxl-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-xxl-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-xxl-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-xxl-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-xxl-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-xxl-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .flex-xxl-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-xxl-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-xxl-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .justify-content-xxl-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-xxl-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-xxl-center {\n        justify-content: center !important\n    }\n\n    .justify-content-xxl-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-xxl-around {\n        justify-content: space-around !important\n    }\n\n    .justify-content-xxl-evenly {\n        justify-content: space-evenly !important\n    }\n\n    .align-items-xxl-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-xxl-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-xxl-center {\n        align-items: center !important\n    }\n\n    .align-items-xxl-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-xxl-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-xxl-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-xxl-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-xxl-center {\n        align-content: center !important\n    }\n\n    .align-content-xxl-between {\n        align-content: space-between !important\n    }\n\n    .align-content-xxl-around {\n        align-content: space-around !important\n    }\n\n    .align-content-xxl-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-xxl-auto {\n        align-self: auto !important\n    }\n\n    .align-self-xxl-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-xxl-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-xxl-center {\n        align-self: center !important\n    }\n\n    .align-self-xxl-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-xxl-stretch {\n        align-self: stretch !important\n    }\n\n    .order-xxl-first {\n        order: -1 !important\n    }\n\n    .order-xxl-0 {\n        order: 0 !important\n    }\n\n    .order-xxl-1 {\n        order: 1 !important\n    }\n\n    .order-xxl-2 {\n        order: 2 !important\n    }\n\n    .order-xxl-3 {\n        order: 3 !important\n    }\n\n    .order-xxl-4 {\n        order: 4 !important\n    }\n\n    .order-xxl-5 {\n        order: 5 !important\n    }\n\n    .order-xxl-last {\n        order: 6 !important\n    }\n\n    .m-xxl-0 {\n        margin: 0 !important\n    }\n\n    .m-xxl-1 {\n        margin: .25rem !important\n    }\n\n    .m-xxl-2 {\n        margin: .5rem !important\n    }\n\n    .m-xxl-3 {\n        margin: 1rem !important\n    }\n\n    .m-xxl-4 {\n        margin: 1.5rem !important\n    }\n\n    .m-xxl-5 {\n        margin: 3rem !important\n    }\n\n    .m-xxl-auto {\n        margin: auto !important\n    }\n\n    .mx-xxl-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important\n    }\n\n    .mx-xxl-1 {\n        margin-right: .25rem !important;\n        margin-left: .25rem !important\n    }\n\n    .mx-xxl-2 {\n        margin-right: .5rem !important;\n        margin-left: .5rem !important\n    }\n\n    .mx-xxl-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-xxl-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important\n    }\n\n    .mx-xxl-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important\n    }\n\n    .mx-xxl-auto {\n        margin-right: auto !important;\n        margin-left: auto !important\n    }\n\n    .my-xxl-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important\n    }\n\n    .my-xxl-1 {\n        margin-top: .25rem !important;\n        margin-bottom: .25rem !important\n    }\n\n    .my-xxl-2 {\n        margin-top: .5rem !important;\n        margin-bottom: .5rem !important\n    }\n\n    .my-xxl-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-xxl-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important\n    }\n\n    .my-xxl-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important\n    }\n\n    .my-xxl-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important\n    }\n\n    .mt-xxl-0 {\n        margin-top: 0 !important\n    }\n\n    .mt-xxl-1 {\n        margin-top: .25rem !important\n    }\n\n    .mt-xxl-2 {\n        margin-top: .5rem !important\n    }\n\n    .mt-xxl-3 {\n        margin-top: 1rem !important\n    }\n\n    .mt-xxl-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mt-xxl-5 {\n        margin-top: 3rem !important\n    }\n\n    .mt-xxl-auto {\n        margin-top: auto !important\n    }\n\n    .me-xxl-0 {\n        margin-right: 0 !important\n    }\n\n    .me-xxl-1 {\n        margin-right: .25rem !important\n    }\n\n    .me-xxl-2 {\n        margin-right: .5rem !important\n    }\n\n    .me-xxl-3 {\n        margin-right: 1rem !important\n    }\n\n    .me-xxl-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .me-xxl-5 {\n        margin-right: 3rem !important\n    }\n\n    .me-xxl-auto {\n        margin-right: auto !important\n    }\n\n    .mb-xxl-0 {\n        margin-bottom: 0 !important\n    }\n\n    .mb-xxl-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .mb-xxl-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .mb-xxl-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-xxl-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .mb-xxl-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .mb-xxl-auto {\n        margin-bottom: auto !important\n    }\n\n    .ms-xxl-0 {\n        margin-left: 0 !important\n    }\n\n    .ms-xxl-1 {\n        margin-left: .25rem !important\n    }\n\n    .ms-xxl-2 {\n        margin-left: .5rem !important\n    }\n\n    .ms-xxl-3 {\n        margin-left: 1rem !important\n    }\n\n    .ms-xxl-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .ms-xxl-5 {\n        margin-left: 3rem !important\n    }\n\n    .ms-xxl-auto {\n        margin-left: auto !important\n    }\n\n    .p-xxl-0 {\n        padding: 0 !important\n    }\n\n    .p-xxl-1 {\n        padding: .25rem !important\n    }\n\n    .p-xxl-2 {\n        padding: .5rem !important\n    }\n\n    .p-xxl-3 {\n        padding: 1rem !important\n    }\n\n    .p-xxl-4 {\n        padding: 1.5rem !important\n    }\n\n    .p-xxl-5 {\n        padding: 3rem !important\n    }\n\n    .px-xxl-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important\n    }\n\n    .px-xxl-1 {\n        padding-right: .25rem !important;\n        padding-left: .25rem !important\n    }\n\n    .px-xxl-2 {\n        padding-right: .5rem !important;\n        padding-left: .5rem !important\n    }\n\n    .px-xxl-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-xxl-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important\n    }\n\n    .px-xxl-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important\n    }\n\n    .py-xxl-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .py-xxl-1 {\n        padding-top: .25rem !important;\n        padding-bottom: .25rem !important\n    }\n\n    .py-xxl-2 {\n        padding-top: .5rem !important;\n        padding-bottom: .5rem !important\n    }\n\n    .py-xxl-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-xxl-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important\n    }\n\n    .py-xxl-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important\n    }\n\n    .pt-xxl-0 {\n        padding-top: 0 !important\n    }\n\n    .pt-xxl-1 {\n        padding-top: .25rem !important\n    }\n\n    .pt-xxl-2 {\n        padding-top: .5rem !important\n    }\n\n    .pt-xxl-3 {\n        padding-top: 1rem !important\n    }\n\n    .pt-xxl-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pt-xxl-5 {\n        padding-top: 3rem !important\n    }\n\n    .pe-xxl-0 {\n        padding-right: 0 !important\n    }\n\n    .pe-xxl-1 {\n        padding-right: .25rem !important\n    }\n\n    .pe-xxl-2 {\n        padding-right: .5rem !important\n    }\n\n    .pe-xxl-3 {\n        padding-right: 1rem !important\n    }\n\n    .pe-xxl-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pe-xxl-5 {\n        padding-right: 3rem !important\n    }\n\n    .pb-xxl-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pb-xxl-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pb-xxl-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pb-xxl-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-xxl-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pb-xxl-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .ps-xxl-0 {\n        padding-left: 0 !important\n    }\n\n    .ps-xxl-1 {\n        padding-left: .25rem !important\n    }\n\n    .ps-xxl-2 {\n        padding-left: .5rem !important\n    }\n\n    .ps-xxl-3 {\n        padding-left: 1rem !important\n    }\n\n    .ps-xxl-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .ps-xxl-5 {\n        padding-left: 3rem !important\n    }\n\n    .gap-xxl-0 {\n        gap: 0 !important\n    }\n\n    .gap-xxl-1 {\n        gap: .25rem !important\n    }\n\n    .gap-xxl-2 {\n        gap: .5rem !important\n    }\n\n    .gap-xxl-3 {\n        gap: 1rem !important\n    }\n\n    .gap-xxl-4 {\n        gap: 1.5rem !important\n    }\n\n    .gap-xxl-5 {\n        gap: 3rem !important\n    }\n\n    .row-gap-xxl-0 {\n        row-gap: 0 !important\n    }\n\n    .row-gap-xxl-1 {\n        row-gap: .25rem !important\n    }\n\n    .row-gap-xxl-2 {\n        row-gap: .5rem !important\n    }\n\n    .row-gap-xxl-3 {\n        row-gap: 1rem !important\n    }\n\n    .row-gap-xxl-4 {\n        row-gap: 1.5rem !important\n    }\n\n    .row-gap-xxl-5 {\n        row-gap: 3rem !important\n    }\n\n    .column-gap-xxl-0 {\n        column-gap: 0 !important\n    }\n\n    .column-gap-xxl-1 {\n        column-gap: .25rem !important\n    }\n\n    .column-gap-xxl-2 {\n        column-gap: .5rem !important\n    }\n\n    .column-gap-xxl-3 {\n        column-gap: 1rem !important\n    }\n\n    .column-gap-xxl-4 {\n        column-gap: 1.5rem !important\n    }\n\n    .column-gap-xxl-5 {\n        column-gap: 3rem !important\n    }\n\n    .text-xxl-start {\n        text-align: left !important\n    }\n\n    .text-xxl-end {\n        text-align: right !important\n    }\n\n    .text-xxl-center {\n        text-align: center !important\n    }\n}\n\n@media(min-width: 1200px) {\n    .fs-1 {\n        font-size: 3.125rem !important\n    }\n\n    .fs-2 {\n        font-size: 2.1875rem !important\n    }\n\n    .fs-3 {\n        font-size: 1.75rem !important\n    }\n\n    .fs-4 {\n        font-size: 1.5rem !important\n    }\n}\n\n@media print {\n    .d-print-inline {\n        display: inline !important\n    }\n\n    .d-print-inline-block {\n        display: inline-block !important\n    }\n\n    .d-print-block {\n        display: block !important\n    }\n\n    .d-print-grid {\n        display: grid !important\n    }\n\n    .d-print-inline-grid {\n        display: inline-grid !important\n    }\n\n    .d-print-table {\n        display: table !important\n    }\n\n    .d-print-table-row {\n        display: table-row !important\n    }\n\n    .d-print-table-cell {\n        display: table-cell !important\n    }\n\n    .d-print-flex {\n        display: flex !important\n    }\n\n    .d-print-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-print-none {\n        display: none !important\n    }\n}\n\n* {\n    outline: none;\n    padding: 0\n}\n\n*::after {\n    margin: 0;\n    padding: 0\n}\n\n*::before {\n    margin: 0;\n    padding: 0\n}\n\nbody {\n    line-height: 1.7;\n    color: #444\n}\n\nbody.fixed {\n    overflow: hidden;\n    position: fixed\n}\n\nh1,\n.h1 {\n    font-size: 50px;\n    font-weight: 700\n}\n\n@media only screen and (max-width: 1380px) {\n\n    h1,\n    .h1 {\n        font-size: 42px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n\n    h1,\n    .h1 {\n        font-size: 38px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n\n    h1,\n    .h1 {\n        font-size: 35px\n    }\n}\n\nh2,\n.h2 {\n    font-size: 35px;\n    font-weight: 700\n}\n\n@media only screen and (max-width: 1380px) {\n\n    h2,\n    .h2 {\n        font-size: 36px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n\n    h2,\n    .h2 {\n        font-size: 32px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n\n    h2,\n    .h2 {\n        font-size: 28px\n    }\n}\n\nh3,\n.h3 {\n    font-size: 28px;\n    font-weight: 700\n}\n\n@media only screen and (max-width: 767px) {\n\n    h3,\n    .h3 {\n        font-size: 24px\n    }\n}\n\nh4,\n.h4 {\n    font-size: 24px;\n    font-weight: 700\n}\n\n@media only screen and (max-width: 767px) {\n\n    h4,\n    .h4 {\n        font-size: 20px\n    }\n}\n\nh5,\n.h5 {\n    font-size: 20px;\n    font-weight: 700\n}\n\n@media only screen and (max-width: 575px) {\n\n    h5,\n    .h5 {\n        font-size: 18px\n    }\n}\n\nh6,\n.h6 {\n    font-size: 18px;\n    font-weight: 700\n}\n\n@media only screen and (max-width: 575px) {\n\n    h6,\n    .h6 {\n        font-size: 16px\n    }\n}\n\nh1,\n.h1,\nh2,\n.h2,\nh3,\n.h3,\nh4,\n.h4,\nh5,\n.h5,\nh6,\n.h6 {\n    font-family: \"Montserrat\", sans-serif;\n    color: var(--bs-dark);\n    line-height: 1.3\n}\n\nh1 a,\nh2 a,\nh3 a,\nh4 a,\nh5 a,\nh6 a,\n.h1 a,\n.h2 a,\n.h3 a,\n.h4 a,\n.h5 a,\n.h6 a {\n    color: var(--bs-dark)\n}\n\nul {\n    padding: 0;\n    margin: 0\n}\n\nimg {\n    border-style: none;\n    height: auto;\n    max-width: 100%;\n    vertical-align: middle\n}\n\nli {\n    list-style: none\n}\n\na {\n    text-decoration: none;\n    outline: none;\n    color: #565acf\n}\n\na:hover,\na:focus,\na.active {\n    text-decoration: none;\n    outline: none;\n    color: #565acf\n}\n\nb,\nstrong,\n.strong {\n    font-weight: 500;\n    color: #14181d\n}\n\n.h-0 {\n    height: 0\n}\n\n#main-wrapper {\n    opacity: 0;\n    transition: all .25s ease-in;\n    overflow: hidden;\n    position: relative;\n    z-index: 1;\n    margin-top: 60px\n}\n\n#main-wrapper.show {\n    opacity: 1\n}\n\n.content-body {\n    margin-left: 65px;\n    margin-top: 18px;\n    margin-right: 6px;\n    margin-bottom: 45px\n}\n\n.bg-gray {\n    background-color: #fafafb\n}\n\n.container-sm {\n    max-width: 990px !important\n}\n\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl {\n    padding-left: 30px;\n    padding-right: 30px\n}\n\n@media only screen and (min-width: 1800px) {\n\n    .container-fluid,\n    .container-sm,\n    .container-md,\n    .container-lg,\n    .container-xl {\n        max-width: 1720px;\n        padding-left: 15px;\n        padding-right: 15px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n\n    .container-fluid,\n    .container-sm,\n    .container-md,\n    .container-lg,\n    .container-xl {\n        padding-left: 15px;\n        padding-right: 15px\n    }\n}\n\n.rounded {\n    border-radius: 8px !important\n}\n\n#loading-icon-bx {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background-color: #fff;\n    z-index: 999999999\n}\n\n#loading-icon-bx .loading-inner {\n    position: absolute;\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%)\n}\n\n#loading-icon-bx .loading-inner div {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%\n}\n\n#loading-icon-bx .loading-inner div.load-one {\n    left: 0%;\n    top: 0%;\n    animation: load-rotate-one 1.15s linear infinite;\n    -o-animation: load-rotate-one 1.15s linear infinite;\n    -ms-animation: load-rotate-one 1.15s linear infinite;\n    -webkit-animation: load-rotate-one 1.15s linear infinite;\n    -moz-animation: load-rotate-one 1.15s linear infinite;\n    border-bottom: 5px solid #565acf\n}\n\n#loading-icon-bx .loading-inner div.load-two {\n    right: 0%;\n    top: 0%;\n    animation: load-rotate-two 1.15s linear infinite;\n    -o-animation: load-rotate-two 1.15s linear infinite;\n    -ms-animation: load-rotate-two 1.15s linear infinite;\n    -webkit-animation: load-rotate-two 1.15s linear infinite;\n    -moz-animation: load-rotate-two 1.15s linear infinite;\n    border-right: 5px solid #565acf\n}\n\n#loading-icon-bx .loading-inner div.load-three {\n    right: 0%;\n    bottom: 0%;\n    animation: load-rotate-three 1.15s linear infinite;\n    -o-animation: load-rotate-three 1.15s linear infinite;\n    -ms-animation: load-rotate-three 1.15s linear infinite;\n    -webkit-animation: load-rotate-three 1.15s linear infinite;\n    -moz-animation: load-rotate-three 1.15s linear infinite;\n    border-top: 5px solid #565acf\n}\n\n@keyframes load-rotate-one {\n    0% {\n        transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg)\n    }\n\n    100% {\n        transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg)\n    }\n}\n\n@-o-keyframes load-rotate-one {\n    0% {\n        -o-transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg)\n    }\n\n    100% {\n        -o-transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg)\n    }\n}\n\n@-ms-keyframes load-rotate-one {\n    0% {\n        -ms-transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg)\n    }\n\n    100% {\n        -ms-transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg)\n    }\n}\n\n@-webkit-keyframes load-rotate-one {\n    0% {\n        -webkit-transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg)\n    }\n\n    100% {\n        -webkit-transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg)\n    }\n}\n\n@-moz-keyframes load-rotate-one {\n    0% {\n        -moz-transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg)\n    }\n\n    100% {\n        -moz-transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg)\n    }\n}\n\n@keyframes load-rotate-two {\n    0% {\n        transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg)\n    }\n\n    100% {\n        transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg)\n    }\n}\n\n@-o-keyframes load-rotate-two {\n    0% {\n        -o-transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg)\n    }\n\n    100% {\n        -o-transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg)\n    }\n}\n\n@-ms-keyframes load-rotate-two {\n    0% {\n        -ms-transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg)\n    }\n\n    100% {\n        -ms-transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg)\n    }\n}\n\n@-webkit-keyframes load-rotate-two {\n    0% {\n        -webkit-transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg)\n    }\n\n    100% {\n        -webkit-transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg)\n    }\n}\n\n@-moz-keyframes load-rotate-two {\n    0% {\n        -moz-transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg)\n    }\n\n    100% {\n        -moz-transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg)\n    }\n}\n\n@keyframes load-rotate-three {\n    0% {\n        transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg)\n    }\n\n    100% {\n        transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg)\n    }\n}\n\n@-o-keyframes load-rotate-three {\n    0% {\n        -o-transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg)\n    }\n\n    100% {\n        -o-transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg)\n    }\n}\n\n@-ms-keyframes load-rotate-three {\n    0% {\n        -ms-transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg)\n    }\n\n    100% {\n        -ms-transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg)\n    }\n}\n\n@-webkit-keyframes load-rotate-three {\n    0% {\n        -webkit-transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg)\n    }\n\n    100% {\n        -webkit-transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg)\n    }\n}\n\n@-moz-keyframes load-rotate-three {\n    0% {\n        -moz-transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg)\n    }\n\n    100% {\n        -moz-transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg)\n    }\n}\n\n.pa-0 {\n    padding: 0\n}\n\n.pa-5 {\n    padding: 5px\n}\n\n.pa-10 {\n    padding: 10px\n}\n\n.pa-15 {\n    padding: 15px\n}\n\n.pa-20 {\n    padding: 20px\n}\n\n.pa-25 {\n    padding: 25px\n}\n\n.pa-30 {\n    padding: 30px\n}\n\n.pa-40 {\n    padding: 40px\n}\n\n.pa-50 {\n    padding: 50px\n}\n\n.pa-60 {\n    padding: 60px\n}\n\n.pa-70 {\n    padding: 70px\n}\n\n.pa-80 {\n    padding: 80px\n}\n\n.pa-90 {\n    padding: 90px\n}\n\n.pa-100 {\n    padding: 100px\n}\n\n.pt-0 {\n    padding-top: 0\n}\n\n.pt-5 {\n    padding-top: 5px\n}\n\n.pt-10 {\n    padding-top: 10px\n}\n\n.pt-15 {\n    padding-top: 15px\n}\n\n.pt-20 {\n    padding-top: 20px\n}\n\n.pt-30 {\n    padding-top: 30px\n}\n\n.pt-40 {\n    padding-top: 40px\n}\n\n.pt-50 {\n    padding-top: 50px\n}\n\n.pt-60 {\n    padding-top: 60px\n}\n\n.pt-70 {\n    padding-top: 70px\n}\n\n.pt-80 {\n    padding-top: 80px\n}\n\n.pt-90 {\n    padding-top: 90px\n}\n\n.pt-100 {\n    padding-top: 100px\n}\n\n.pb-0 {\n    padding-bottom: 0\n}\n\n.pb-5 {\n    padding-bottom: 5px\n}\n\n.pb-10 {\n    padding-bottom: 10px\n}\n\n.pb-15 {\n    padding-bottom: 15px\n}\n\n.pb-20 {\n    padding-bottom: 20px\n}\n\n.pb-30 {\n    padding-bottom: 30px\n}\n\n.pb-40 {\n    padding-bottom: 40px\n}\n\n.pb-50 {\n    padding-bottom: 50px\n}\n\n.pb-60 {\n    padding-bottom: 60px\n}\n\n.pb-70 {\n    padding-bottom: 70px\n}\n\n.pb-80 {\n    padding-bottom: 80px\n}\n\n.pb-90 {\n    padding-bottom: 90px\n}\n\n.pb-100 {\n    padding-bottom: 100px\n}\n\n.pl-0 {\n    padding-left: 0\n}\n\n.pl-5 {\n    padding-left: 5px\n}\n\n.pl-10 {\n    padding-left: 10px\n}\n\n.pl-15 {\n    padding-left: 15px\n}\n\n.pl-20 {\n    padding-left: 20px\n}\n\n.pl-30 {\n    padding-left: 30px\n}\n\n.pl-40 {\n    padding-left: 40px\n}\n\n.pl-50 {\n    padding-left: 50px\n}\n\n.pl-60 {\n    padding-left: 60px\n}\n\n.pl-70 {\n    padding-left: 70px\n}\n\n.pl-80 {\n    padding-left: 80px\n}\n\n.pl-90 {\n    padding-left: 90px\n}\n\n.pl-100 {\n    padding-left: 100px\n}\n\n.pr-0 {\n    padding-right: 0\n}\n\n.pr-5 {\n    padding-right: 5px\n}\n\n.pr-10 {\n    padding-right: 10px\n}\n\n.pr-15 {\n    padding-right: 15px\n}\n\n.pr-20 {\n    padding-right: 20px\n}\n\n.pr-30 {\n    padding-right: 30px\n}\n\n.pr-40 {\n    padding-right: 40px\n}\n\n.pr-50 {\n    padding-right: 50px\n}\n\n.pr-60 {\n    padding-right: 60px\n}\n\n.pr-70 {\n    padding-right: 70px\n}\n\n.pr-80 {\n    padding-right: 80px\n}\n\n.pr-90 {\n    padding-right: 90px\n}\n\n.pr-100 {\n    padding-right: 100px\n}\n\n.px-0 {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.px-5 {\n    padding-left: 5px;\n    padding-right: 5px\n}\n\n.px-10 {\n    padding-left: 10px;\n    padding-right: 10px\n}\n\n.px-15 {\n    padding-left: 15px;\n    padding-right: 15px\n}\n\n.px-20 {\n    padding-left: 20px;\n    padding-right: 20px\n}\n\n.px-30 {\n    padding-left: 30px;\n    padding-right: 30px\n}\n\n.px-40 {\n    padding-left: 40px;\n    padding-right: 40px\n}\n\n.px-50 {\n    padding-left: 50px;\n    padding-right: 50px\n}\n\n.px-60 {\n    padding-left: 60px;\n    padding-right: 60px\n}\n\n.px-70 {\n    padding-left: 70px;\n    padding-right: 70px\n}\n\n.px-80 {\n    padding-left: 80px;\n    padding-right: 80px\n}\n\n.px-90 {\n    padding-left: 90px;\n    padding-right: 90px\n}\n\n.px-100 {\n    padding-left: 100px;\n    padding-right: 100px\n}\n\n.py-0 {\n    padding-bottom: 0;\n    padding-top: 0\n}\n\n.py-5 {\n    padding-bottom: 5px;\n    padding-top: 5px\n}\n\n.py-10 {\n    padding-bottom: 10px;\n    padding-top: 10px\n}\n\n.py-15 {\n    padding-bottom: 15px;\n    padding-top: 15px\n}\n\n.py-20 {\n    padding-bottom: 20px;\n    padding-top: 20px\n}\n\n.py-30 {\n    padding-bottom: 30px;\n    padding-top: 30px\n}\n\n.py-40 {\n    padding-bottom: 40px;\n    padding-top: 40px\n}\n\n.py-50 {\n    padding-bottom: 50px;\n    padding-top: 50px\n}\n\n.py-60 {\n    padding-bottom: 60px;\n    padding-top: 60px\n}\n\n.py-70 {\n    padding-bottom: 70px;\n    padding-top: 70px\n}\n\n.py-80 {\n    padding-bottom: 80px;\n    padding-top: 80px\n}\n\n.py-90 {\n    padding-bottom: 90px;\n    padding-top: 90px\n}\n\n.py-100 {\n    padding-bottom: 100px;\n    padding-top: 100px\n}\n\n.mx-auto {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.ma-0 {\n    margin: 0\n}\n\n.ma-5 {\n    margin: 5px\n}\n\n.ma-10 {\n    margin: 10px\n}\n\n.ma-15 {\n    margin: 15px\n}\n\n.ma-20 {\n    margin: 20px\n}\n\n.ma-25 {\n    margin: 25px\n}\n\n.ma-30 {\n    margin: 30px\n}\n\n.ma-40 {\n    margin: 40px\n}\n\n.ma-50 {\n    margin: 50px\n}\n\n.ma-60 {\n    margin: 60px\n}\n\n.ma-70 {\n    margin: 70px\n}\n\n.ma-80 {\n    margin: 80px\n}\n\n.ma-90 {\n    margin: 90px\n}\n\n.ma-100 {\n    margin: 100px\n}\n\n.mt-0 {\n    margin-top: 0\n}\n\n.mt-5 {\n    margin-top: 5px\n}\n\n.mt-10 {\n    margin-top: 10px\n}\n\n.mt-15 {\n    margin-top: 15px\n}\n\n.mt-20 {\n    margin-top: 20px\n}\n\n.mt-30 {\n    margin-top: 30px\n}\n\n.mt-40 {\n    margin-top: 40px\n}\n\n.mt-50 {\n    margin-top: 50px\n}\n\n.mt-60 {\n    margin-top: 60px\n}\n\n.mt-70 {\n    margin-top: 70px\n}\n\n.mt-80 {\n    margin-top: 80px\n}\n\n.mt-90 {\n    margin-top: 90px\n}\n\n.mt-100 {\n    margin-top: 100px\n}\n\n.mb-0 {\n    margin-bottom: 0\n}\n\n.mb-5 {\n    margin-bottom: 5px\n}\n\n.mb-10 {\n    margin-bottom: 10px\n}\n\n.mb-15 {\n    margin-bottom: 15px\n}\n\n.mb-20 {\n    margin-bottom: 20px\n}\n\n.mb-30 {\n    margin-bottom: 30px\n}\n\n.mb-40 {\n    margin-bottom: 40px\n}\n\n.mb-50 {\n    margin-bottom: 50px\n}\n\n.mb-60 {\n    margin-bottom: 60px\n}\n\n.mb-70 {\n    margin-bottom: 70px\n}\n\n.mb-80 {\n    margin-bottom: 80px\n}\n\n.mb-90 {\n    margin-bottom: 90px\n}\n\n.mb-100 {\n    margin-bottom: 100px\n}\n\n.ml-0 {\n    margin-left: 0\n}\n\n.ml-5 {\n    margin-left: 5px\n}\n\n.ml-10 {\n    margin-left: 10px\n}\n\n.ml-15 {\n    margin-left: 15px\n}\n\n.ml-20 {\n    margin-left: 20px\n}\n\n.ml-30 {\n    margin-left: 30px\n}\n\n.ml-40 {\n    margin-left: 40px\n}\n\n.ml-50 {\n    margin-left: 50px\n}\n\n.ml-60 {\n    margin-left: 60px\n}\n\n.ml-70 {\n    margin-left: 70px\n}\n\n.ml-80 {\n    margin-left: 80px\n}\n\n.ml-90 {\n    margin-left: 90px\n}\n\n.ml-100 {\n    margin-left: 100px\n}\n\n.m-r0 {\n    margin-right: 0\n}\n\n.m-r5 {\n    margin-right: 5px\n}\n\n.m-r10 {\n    margin-right: 10px\n}\n\n.m-r15 {\n    margin-right: 15px\n}\n\n.m-r20 {\n    margin-right: 20px\n}\n\n.m-r30 {\n    margin-right: 30px\n}\n\n.m-r40 {\n    margin-right: 40px\n}\n\n.m-r50 {\n    margin-right: 50px\n}\n\n.m-r60 {\n    margin-right: 60px\n}\n\n.m-r70 {\n    margin-right: 70px\n}\n\n.m-r80 {\n    margin-right: 80px\n}\n\n.m-r90 {\n    margin-right: 90px\n}\n\n.m-r100 {\n    margin-right: 100px\n}\n\n.mx-0 {\n    margin-left: 0;\n    margin-right: 0\n}\n\n.mx-5 {\n    margin-left: 5px;\n    margin-right: 5px\n}\n\n.mx-10 {\n    margin-left: 10px;\n    margin-right: 10px\n}\n\n.mx-15 {\n    margin-left: 15px;\n    margin-right: 15px\n}\n\n.mx-20 {\n    margin-left: 20px;\n    margin-right: 20px\n}\n\n.mx-30 {\n    margin-left: 30px;\n    margin-right: 30px\n}\n\n.mx-40 {\n    margin-left: 40px;\n    margin-right: 40px\n}\n\n.mx-50 {\n    margin-left: 50px;\n    margin-right: 50px\n}\n\n.mx-60 {\n    margin-left: 60px;\n    margin-right: 60px\n}\n\n.mx-70 {\n    margin-left: 70px;\n    margin-right: 70px\n}\n\n.mx-80 {\n    margin-left: 80px;\n    margin-right: 80px\n}\n\n.mx-90 {\n    margin-left: 90px;\n    margin-right: 90px\n}\n\n.mx-100 {\n    margin-left: 100px;\n    margin-right: 100px\n}\n\n.my-0 {\n    margin-bottom: 0;\n    margin-top: 0\n}\n\n.my-5 {\n    margin-bottom: 5px;\n    margin-top: 5px\n}\n\n.my-10 {\n    margin-bottom: 10px;\n    margin-top: 10px\n}\n\n.my-15 {\n    margin-bottom: 15px;\n    margin-top: 15px\n}\n\n.my-20 {\n    margin-bottom: 20px;\n    margin-top: 20px\n}\n\n.my-30 {\n    margin-bottom: 30px;\n    margin-top: 30px\n}\n\n.my-40 {\n    margin-bottom: 40px;\n    margin-top: 40px\n}\n\n.my-50 {\n    margin-bottom: 50px;\n    margin-top: 50px\n}\n\n.my-60 {\n    margin-bottom: 60px;\n    margin-top: 60px\n}\n\n.my-70 {\n    margin-bottom: 70px;\n    margin-top: 70px\n}\n\n.my-80 {\n    margin-bottom: 80px;\n    margin-top: 80px\n}\n\n.my-90 {\n    margin-bottom: 90px;\n    margin-top: 90px\n}\n\n.my-100 {\n    margin-bottom: 100px;\n    margin-top: 100px\n}\n\n@media only screen and (max-width: 1200px) {\n    .mt-lg-0 {\n        margin-top: 0\n    }\n\n    .mt-lg-5 {\n        margin-top: 5px\n    }\n\n    .mt-lg-10 {\n        margin-top: 10px\n    }\n\n    .mt-lg-15 {\n        margin-top: 15px\n    }\n\n    .mt-lg-20 {\n        margin-top: 20px\n    }\n\n    .mt-lg-30 {\n        margin-top: 30px\n    }\n\n    .mt-lg-40 {\n        margin-top: 40px\n    }\n\n    .mt-lg-50 {\n        margin-top: 50px\n    }\n\n    .mt-lg-60 {\n        margin-top: 60px\n    }\n\n    .mt-lg-70 {\n        margin-top: 70px\n    }\n\n    .mt-lg-80 {\n        margin-top: 80px\n    }\n\n    .mt-lg-90 {\n        margin-top: 90px\n    }\n\n    .mt-lg-100 {\n        margin-top: 100px\n    }\n\n    .mb-lg-0 {\n        margin-bottom: 0\n    }\n\n    .mb-lg-5 {\n        margin-bottom: 5px\n    }\n\n    .mb-lg-10 {\n        margin-bottom: 10px\n    }\n\n    .mb-lg-15 {\n        margin-bottom: 15px\n    }\n\n    .mb-lg-20 {\n        margin-bottom: 20px\n    }\n\n    .mb-lg-30 {\n        margin-bottom: 30px\n    }\n\n    .mb-lg-40 {\n        margin-bottom: 40px\n    }\n\n    .mb-lg-50 {\n        margin-bottom: 50px\n    }\n\n    .mb-lg-60 {\n        margin-bottom: 60px\n    }\n\n    .mb-lg-70 {\n        margin-bottom: 70px\n    }\n\n    .mb-lg-80 {\n        margin-bottom: 80px\n    }\n\n    .mb-lg-90 {\n        margin-bottom: 90px\n    }\n\n    .mb-lg-100 {\n        margin-bottom: 100px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .mt-md-0 {\n        margin-top: 0\n    }\n\n    .mt-md-5 {\n        margin-top: 5px\n    }\n\n    .mt-md-10 {\n        margin-top: 10px\n    }\n\n    .mt-md-15 {\n        margin-top: 15px\n    }\n\n    .mt-md-20 {\n        margin-top: 20px\n    }\n\n    .mt-md-30 {\n        margin-top: 30px\n    }\n\n    .mt-md-40 {\n        margin-top: 40px\n    }\n\n    .mt-md-50 {\n        margin-top: 50px\n    }\n\n    .mt-md-60 {\n        margin-top: 60px\n    }\n\n    .mt-md-70 {\n        margin-top: 70px\n    }\n\n    .mt-md-80 {\n        margin-top: 80px\n    }\n\n    .mt-md-90 {\n        margin-top: 90px\n    }\n\n    .mt-md-100 {\n        margin-top: 100px\n    }\n\n    .mb-md-0 {\n        margin-bottom: 0\n    }\n\n    .mb-md-5 {\n        margin-bottom: 5px\n    }\n\n    .mb-md-10 {\n        margin-bottom: 10px\n    }\n\n    .mb-md-15 {\n        margin-bottom: 15px\n    }\n\n    .mb-md-20 {\n        margin-bottom: 20px\n    }\n\n    .mb-md-30 {\n        margin-bottom: 30px\n    }\n\n    .mb-md-40 {\n        margin-bottom: 40px\n    }\n\n    .mb-md-50 {\n        margin-bottom: 50px\n    }\n\n    .mb-md-60 {\n        margin-bottom: 60px\n    }\n\n    .mb-md-70 {\n        margin-bottom: 70px\n    }\n\n    .mb-md-80 {\n        margin-bottom: 80px\n    }\n\n    .mb-md-90 {\n        margin-bottom: 90px\n    }\n\n    .mb-md-100 {\n        margin-bottom: 100px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .mt-sm-0 {\n        margin-top: 0\n    }\n\n    .mt-sm-5 {\n        margin-top: 5px\n    }\n\n    .mt-sm-10 {\n        margin-top: 10px\n    }\n\n    .mt-sm-15 {\n        margin-top: 15px\n    }\n\n    .mt-sm-20 {\n        margin-top: 20px\n    }\n\n    .mt-sm-30 {\n        margin-top: 30px\n    }\n\n    .mt-sm-40 {\n        margin-top: 40px\n    }\n\n    .mt-sm-50 {\n        margin-top: 50px\n    }\n\n    .mt-sm-60 {\n        margin-top: 60px\n    }\n\n    .mt-sm-70 {\n        margin-top: 70px\n    }\n\n    .mt-sm-80 {\n        margin-top: 80px\n    }\n\n    .mt-sm-90 {\n        margin-top: 90px\n    }\n\n    .mt-sm-100 {\n        margin-top: 100px\n    }\n\n    .mb-sm-0 {\n        margin-bottom: 0\n    }\n\n    .mb-sm-5 {\n        margin-bottom: 5px\n    }\n\n    .mb-sm-10 {\n        margin-bottom: 10px\n    }\n\n    .mb-sm-15 {\n        margin-bottom: 15px\n    }\n\n    .mb-sm-20 {\n        margin-bottom: 20px\n    }\n\n    .mb-sm-30 {\n        margin-bottom: 30px\n    }\n\n    .mb-sm-40 {\n        margin-bottom: 40px\n    }\n\n    .mb-sm-50 {\n        margin-bottom: 50px\n    }\n\n    .mb-sm-60 {\n        margin-bottom: 60px\n    }\n\n    .mb-sm-70 {\n        margin-bottom: 70px\n    }\n\n    .mb-sm-80 {\n        margin-bottom: 80px\n    }\n\n    .mb-sm-90 {\n        margin-bottom: 90px\n    }\n\n    .mb-sm-100 {\n        margin-bottom: 100px\n    }\n}\n\n@media only screen and (max-width: 576px) {\n    .mt-xs-0 {\n        margin-top: 0\n    }\n\n    .mt-xs-5 {\n        margin-top: 5px\n    }\n\n    .mt-xs-10 {\n        margin-top: 10px\n    }\n\n    .mt-xs-15 {\n        margin-top: 15px\n    }\n\n    .mt-xs-20 {\n        margin-top: 20px\n    }\n\n    .mt-xs-30 {\n        margin-top: 30px\n    }\n\n    .mt-xs-40 {\n        margin-top: 40px\n    }\n\n    .mt-xs-50 {\n        margin-top: 50px\n    }\n\n    .mt-xs-60 {\n        margin-top: 60px\n    }\n\n    .mt-xs-70 {\n        margin-top: 70px\n    }\n\n    .mt-xs-80 {\n        margin-top: 80px\n    }\n\n    .mt-xs-90 {\n        margin-top: 90px\n    }\n\n    .mt-xs-100 {\n        margin-top: 100px\n    }\n\n    .mb-xs-0 {\n        margin-bottom: 0\n    }\n\n    .mb-xs-5 {\n        margin-bottom: 5px\n    }\n\n    .mb-xs-10 {\n        margin-bottom: 10px\n    }\n\n    .mb-xs-15 {\n        margin-bottom: 15px\n    }\n\n    .mb-xs-20 {\n        margin-bottom: 20px\n    }\n\n    .mb-xs-30 {\n        margin-bottom: 30px\n    }\n\n    .mb-xs-40 {\n        margin-bottom: 40px\n    }\n\n    .mb-xs-50 {\n        margin-bottom: 50px\n    }\n\n    .mb-xs-60 {\n        margin-bottom: 60px\n    }\n\n    .mb-xs-70 {\n        margin-bottom: 70px\n    }\n\n    .mb-xs-80 {\n        margin-bottom: 80px\n    }\n\n    .mb-xs-90 {\n        margin-bottom: 90px\n    }\n\n    .mb-xs-100 {\n        margin-bottom: 100px\n    }\n}\n\n.section-sp1 {\n    padding-top: 100px;\n    padding-bottom: 70px\n}\n\n@media only screen and (max-width: 1199px) {\n    .section-sp1 {\n        padding-top: 70px;\n        padding-bottom: 40px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .section-sp1 {\n        padding-top: 50px;\n        padding-bottom: 20px\n    }\n}\n\n.section-sp2 {\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n@media only screen and (max-width: 1199px) {\n    .section-sp2 {\n        padding-top: 70px;\n        padding-bottom: 70px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .section-sp2 {\n        padding-top: 50px;\n        padding-bottom: 50px\n    }\n}\n\n.section-sp3 {\n    padding-top: 100px;\n    padding-bottom: 0\n}\n\n@media only screen and (max-width: 1199px) {\n    .section-sp3 {\n        padding-top: 70px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .section-sp3 {\n        padding-top: 50px\n    }\n}\n\n.section-sp4 {\n    padding-top: 50px;\n    padding-bottom: 50px\n}\n\n.section-sp5 {\n    padding-bottom: 70px\n}\n\n@media only screen and (max-width: 1199px) {\n    .section-sp5 {\n        padding-bottom: 50px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .section-sp5 {\n        padding-bottom: 20px\n    }\n}\n\n.fs10 {\n    font-size: 10px\n}\n\n.fs12 {\n    font-size: 12px\n}\n\n.fs13 {\n    font-size: 13px\n}\n\n.fs14 {\n    font-size: 14px\n}\n\n.fs16 {\n    font-size: 16px\n}\n\n.fs18 {\n    font-size: 18px\n}\n\n.fs20 {\n    font-size: 20px\n}\n\n.fs22 {\n    font-size: 22px\n}\n\n.fs24 {\n    font-size: 24px\n}\n\n.fs26 {\n    font-size: 26px\n}\n\n.fs30 {\n    font-size: 30px;\n    line-height: 40px\n}\n\n.fs35 {\n    font-size: 35px;\n    line-height: 45px\n}\n\n.fs40 {\n    font-size: 40px;\n    line-height: 50px\n}\n\n.fs45 {\n    font-size: 45px;\n    line-height: 55px\n}\n\n.fs50 {\n    font-size: 50px;\n    line-height: 65px\n}\n\n.fs55 {\n    font-size: 55px;\n    line-height: 65px\n}\n\n.fs60 {\n    font-size: 60px;\n    line-height: 70px\n}\n\n.fs70 {\n    font-size: 70px;\n    line-height: 80px\n}\n\n.fs75 {\n    font-size: 75px;\n    line-height: 85px\n}\n\n.fs80 {\n    font-size: 80px;\n    line-height: 90px\n}\n\n.fs90 {\n    font-size: 90px;\n    line-height: 100px\n}\n\n.fs100 {\n    font-size: 100px;\n    line-height: 110px\n}\n\n.fw3 {\n    font-weight: 300\n}\n\n.fw4 {\n    font-weight: 400\n}\n\n.fw5 {\n    font-weight: 500\n}\n\n.fw6 {\n    font-weight: 600\n}\n\n.fw7 {\n    font-weight: 700\n}\n\n.fw8 {\n    font-weight: 800\n}\n\n.fw9 {\n    font-weight: 900\n}\n\ndl,\nul,\nol {\n    list-style-position: outside\n}\n\nul,\nol {\n    margin-bottom: 24px\n}\n\nul li,\nol li {\n    padding: 0\n}\n\ndl {\n    margin-left: 0;\n    margin-bottom: 30px\n}\n\ndl dd {\n    margin-bottom: 10px\n}\n\n.posi-ab {\n    position: absolute\n}\n\n.posi-rl {\n    position: relative\n}\n\n.posi-st {\n    position: static\n}\n\n.zi1 {\n    z-index: 1\n}\n\n.zi2 {\n    z-index: 2\n}\n\n.zi3 {\n    z-index: 3\n}\n\n.zi4 {\n    z-index: 4\n}\n\n.zi5 {\n    z-index: 5\n}\n\n.zi6 {\n    z-index: 6\n}\n\n.zi7 {\n    z-index: 7\n}\n\n.zi8 {\n    z-index: 8\n}\n\n.zi9 {\n    z-index: 9\n}\n\n.zi10 {\n    z-index: 10\n}\n\n.zi100 {\n    z-index: 100\n}\n\n.zi999 {\n    z-index: 999\n}\n\n::selection {\n    color: #fff;\n    background: #565acf\n}\n\n::-moz-selection {\n    color: #fff;\n    background: #565acf\n}\n\n::-moz-selection {\n    background: #565acf;\n    color: #fff\n}\n\n::selection {\n    background: #565acf;\n    color: #fff\n}\n\n.mfp-gallery {\n    list-style: none;\n    margin-bottom: 0\n}\n\n.mfp-title {\n    display: none\n}\n\n.list-inline li {\n    display: inline-block\n}\n\n.full-img {\n    width: 100%\n}\n\n.sticky-top {\n    top: 130px\n}\n\nsection {\n    position: relative\n}\n\n.ov-hidden {\n    overflow: hidden\n}\n\n.row.spno,\n.spno {\n    margin-left: 0;\n    margin-right: 0\n}\n\n.row.spno [class*=col],\n.row.spno [class*=col],\n.spno [class*=col],\n.spno [class*=col] {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.row.sp5,\n.sp5 {\n    margin-left: -5px;\n    margin-right: -5px\n}\n\n.row.sp5 [class*=col],\n.row.sp5 [class*=col],\n.sp5 [class*=col],\n.sp5 [class*=col] {\n    padding-left: 5px;\n    padding-right: 5px\n}\n\n.row.sp10,\n.sp10 {\n    margin-left: -10px;\n    margin-right: -10px\n}\n\n.row.sp10 [class*=col],\n.row.sp10 [class*=col],\n.sp10 [class*=col],\n.sp10 [class*=col] {\n    padding-left: 10px;\n    padding-right: 10px\n}\n\n.row.sp10,\n.sp10 {\n    margin-left: -10px;\n    margin-right: -10px\n}\n\n.row.sp10 [class*=col],\n.row.sp10 [class*=col],\n.sp10 [class*=col],\n.sp10 [class*=col] {\n    padding-left: 10px;\n    padding-right: 10px\n}\n\n.row.sp20,\n.sp20 {\n    margin-left: -20px;\n    margin-right: -20px\n}\n\n.row.sp20 [class*=col],\n.row.sp20 [class*=col],\n.sp20 [class*=col],\n.sp20 [class*=col] {\n    padding-left: 20px;\n    padding-right: 20px\n}\n\n.page-banner {\n    background: #fff;\n    background-repeat: no-repeat;\n    background-size: cover;\n    position: relative;\n    overflow: hidden;\n    height: 420px;\n    width: 100%;\n    z-index: 1\n}\n\n@media only screen and (max-width: 991px) {\n    .page-banner {\n        height: 320px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .page-banner {\n        height: 280px\n    }\n}\n\n.page-banner .container {\n    display: table;\n    height: 100%\n}\n\n.page-banner .page-banner-entry {\n    height: 420px;\n    vertical-align: middle;\n    display: table-cell;\n    padding-top: 40px;\n    padding-bottom: 60px\n}\n\n@media only screen and (max-width: 991px) {\n    .page-banner .page-banner-entry {\n        height: 320px;\n        padding-bottom: 30px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .page-banner .page-banner-entry {\n        height: 280px\n    }\n}\n\n.page-banner h1,\n.page-banner .h1 {\n    font-weight: 700;\n    /* font-size: 72px; */\n    font-size: 50px;\n    margin-bottom: 20px;\n    color: var(--bs-dark);\n    text-transform: capitalize\n}\n\n@media only screen and (max-width: 1380px) {\n\n    .page-banner h1,\n    .page-banner .h1 {\n        font-size: 62px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n\n    .page-banner h1,\n    .page-banner .h1 {\n        font-size: 52px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n\n    .page-banner h1,\n    .page-banner .h1 {\n        font-size: 42px\n    }\n}\n\n.page-banner:after {\n    content: \"\";\n    background-image: url(./images/banner/shape.png);\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: bottom;\n    background-size: contain;\n    z-index: -1\n}\n\n.page-banner.banner-lg {\n    height: 550px\n}\n\n.page-banner.banner-lg .page-banner-entry {\n    height: 550px\n}\n\n@media only screen and (max-width: 991px) {\n    .page-banner.banner-lg {\n        height: 450px\n    }\n\n    .page-banner.banner-lg .page-banner-entry {\n        height: 450px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .page-banner.banner-lg {\n        height: 400px\n    }\n\n    .page-banner.banner-lg .page-banner-entry {\n        height: 400px\n    }\n}\n\n.page-banner.banner-md {\n    height: 450px\n}\n\n.page-banner.banner-md .page-banner-entry {\n    height: 450px\n}\n\n.page-banner.banner-sm {\n    height: 300px\n}\n\n.page-banner.banner-sm .page-banner-entry {\n    height: 300px\n}\n\n/* .custom-text{\n    -webkit-line-clamp: 3;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n} */\n\n\n\n.cutom-search input {\n    border: 1px solid #D5D5D5;\n    min-height: 53px;\n    padding: 8px 16px 8px 42px;\n    border-radius: 10px;\n    /* min-width: 340px; */\n    color: #757575;\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.cutom-search i {\n    transform: rotate(270deg) !important;\n    top: 34%;\n    left: 16px;\n}\n\n.cutom-search::placeholder {\n    color: #757575;\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.custom-select {\n    background-color: #F6F8FA !important;\n    padding: 2px 24px 8px 24px;\n    border-radius: 10px;\n}\n\n.custom-select .css-b62m3t-container,\n.custom-select .css-3iigni-container {\n    margin-top: -4px;\n}\n\n.custom-select .css-1f43avz-a11yText-A11yText,\n.custom-select .css-894a34-indicatorSeparator {\n    display: none !important;\n}\n\n.custom-select .css-13cymwt-control,\n.custom-select .css-t3ipsp-control,\n.custom-select .css-16xfy0z-control {\n    border: none !important;\n    background-color: transparent;\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 500 !important;\n    height: 20px !important;\n    min-height: 20px !important;\n    color: #444444 !important;\n    box-shadow: none !important;\n}\n\n\n\n.custom-select .css-tj5bde-Svg {\n    fill: #000000 !important;\n    font-weight: 400 !important;\n\n}\n\n.custom-select .css-1xc3v61-indicatorContainer,\n.custom-select .css-15lsz6c-indicatorContainer {\n    padding: 0;\n    height: 14px;\n    width: 14px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuOTk5OTggOS43MDAyOUM2LjgyMDc2IDkuNzAwMjkgNi42NDE1NiA5LjYzMTg2IDYuNTA0OTMgOS40OTUyOUwyLjIwNTE0IDUuMTk1NDZDMS45MzE2MiA0LjkyMTk0IDEuOTMxNjIgNC40Nzg0NyAyLjIwNTE0IDQuMjA1MDZDMi40Nzg1NSAzLjkzMTY1IDIuOTIxOTMgMy45MzE2NSAzLjE5NTQ4IDQuMjA1MDZMNi45OTk5OCA4LjAwOTc4TDEwLjgwNDUgNC4yMDUxOUMxMS4wNzggMy45MzE3OCAxMS41MjE0IDMuOTMxNzggMTEuNzk0OCA0LjIwNTE5QzEyLjA2ODQgNC40Nzg2IDEyLjA2ODQgNC45MjIwNyAxMS43OTQ4IDUuMTk1Nkw3LjQ5NTA0IDkuNDk1NDJDNy4zNTgzNCA5LjYzMjAyIDcuMTc5MTQgOS43MDAyOSA2Ljk5OTk4IDkuNzAwMjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K);\n}\n\n.custom-select .css-1xc3v61-indicatorContainer svg,\n.custom-select .css-15lsz6c-indicatorContainer svg {\n    display: none !important;\n}\n\n.custom-select .css-10wo9uf-option,\n.custom-select .css-d7l1ni-option {\n    font-size: 14px;\n    font-weight: 500;\n\n}\n\n\n.custom-select .css-d7l1ni-option,\n.custom-select .css-1224hz6-option,\n.custom-select .css-tr4s17-option {\n    background-color: #F6F8FA !important;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 8px;\n    color: #444444;\n}\n\n.custom-select .css-nkt5xy-option {\n    color: #757575 !important;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.custom-select .css-10wo9uf-option:active {\n    background-color: #F6F8FA !important;\n    color: #444444 !important;\n}\n\n.custom-select .css-qr46ko {\n    padding: 12px;\n}\n\n.custom-select .css-tr4s17-option:active {\n    background-color: #F6F8FA !important;\n}\n\n.custom-select .css-hlgwow {\n    padding: 0;\n}\n\n.custom-select .css-qr46ko::-webkit-scrollbar {\n    width: 5px !important;\n}\n\n.custom-select .css-qr46ko::-webkit-scrollbar-thumb {\n    background: #008BB1;\n    width: 4px;\n    border-radius: 50px !important;\n}\n\n.custom-select .css-qr46ko::-webkit-scrollbar-track {\n    background: #F6F8FA !important;\n}\n\n.custom-select .css-1u9des2-indicatorSeparator {\n    display: none;\n}\n\n.custom-select label {\n    color: #757575;\n    font-size: 12px;\n    margin-top: -2px;\n    line-height: 10px !important;\n    /* line-height: 15px; */\n}\n\n/* .custom-select select {\n    background-color: transparent !important;\n    border: none !important;\n    padding: 4px 0 0 0 !important;\n    line-height: 17px !important;\n    font-size: 15px;\n    color: #444444 !important;\n    font-weight: 500;\n}\n\n.custom-select select option{\n    border: none !important;\n} */\n\n.section-area .pt-img1 {\n    left: 15%;\n    bottom: 50px;\n    z-index: 1\n}\n\n.section-area .pt-img2 {\n    left: 0;\n    top: 10px\n}\n\n.section-area .pt-img3 {\n    right: 38%;\n    bottom: 6%;\n    z-index: 2;\n}\n\n.breadcrumb-row {\n    /* box-shadow: 0px 5px 30px 0px rgba(86, 90, 207, .3); */\n    font-family: \"Montserrat\", sans-serif;\n    /* background-color: #008BB1; */\n    padding: 12px 30px;\n    border-radius: 10px;\n    display: inline-block\n}\n\n@media only screen and (max-width: 767px) {\n    .breadcrumb-row {\n        padding: 10px 24px\n    }\n}\n\n.breadcrumb-row ul {\n    background: rgba(0, 0, 0, 0);\n    padding: 0;\n    justify-content: center;\n    margin: 0\n}\n\n.breadcrumb-row ul li {\n    padding: 0;\n    display: inline-flex;\n    font-size: 16px;\n    font-weight: 500;\n    align-items: center\n}\n\n.breadcrumb-row ul li a {\n    /* color: #fff; */\n    color: #008BB1;\n    display: flex;\n    align-items: center\n}\n\n.breadcrumb-row ul li a svg {\n    margin-right: 10px;\n    transform: translateY(-2px)\n}\n\n@media only screen and (max-width: 1380px) {\n    .breadcrumb-row ul li {\n        font-size: 14px\n    }\n}\n\n.breadcrumb-item+.breadcrumb-item {\n    /* padding-left: 15px; */\n    /* color: #fff */\n    color: #008BB1;\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n    /* color: #fff; */\n    color: #008BB1;\n    content: \"/\";\n    font-size: 22px;\n    /* padding-right: 15px; */\n    opacity: .4;\n    font-weight: 300;\n    line-height: 22px;\n    margin-top: 5px\n}\n\n@media only screen and (max-width: 1380px) {\n    .breadcrumb-item+.breadcrumb-item {\n        padding-left: 10px\n    }\n\n    .breadcrumb-item+.breadcrumb-item::before {\n        font-size: 18px;\n        padding-right: 10px;\n        line-height: 18px\n    }\n}\n\nsection {\n    position: relative;\n    z-index: 1\n}\n\n/* .heading-bx {\n    margin-bottom: 45px\n} */\n\n.heading-bx .title-ext {\n    font-weight: 700;\n    display: inline-block;\n    padding: 3px 15px;\n    background-position: center;\n    background-repeat: repeat;\n    margin-bottom: 15px\n}\n\n.heading-bx .title-ext.text-primary {\n    background-image: url(./images/shap/ext-blue.png)\n}\n\n.heading-bx .title-ext.text-secondary {\n    background-image: url(./images/shap/ext-orange.png)\n}\n\n.heading-bx h2.title,\n.heading-bx .title.h2 {\n    font-size: 45px\n}\n\n@media only screen and (max-width: 1380px) {\n\n    .heading-bx h2.title,\n    .heading-bx .title.h2 {\n        font-size: 36px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n\n    .heading-bx h2.title,\n    .heading-bx .title.h2 {\n        font-size: 32px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n\n    .heading-bx h2.title,\n    .heading-bx .title.h2 {\n        font-size: 28px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .heading-bx {\n        padding: 30px 0;\n        /* margin-bottom: 20px !important; */\n        text-align: center;\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    /* .heading-bx {\n        margin-bottom: 40px\n    } */\n}\n\n.heading-bx.text-white h1,\n.heading-bx.text-white .h1,\n.heading-bx.text-white h2,\n.heading-bx.text-white .h2,\n.heading-bx.text-white h3,\n.heading-bx.text-white .h3,\n.heading-bx.text-white h4,\n.heading-bx.text-white .h4,\n.heading-bx.text-white h5,\n.heading-bx.text-white .h5,\n.heading-bx.text-white h6,\n.heading-bx.text-white .h6 {\n    color: #fff\n}\n\n.heading-bx p {\n    padding-top: 5px;\n    font-weight: 500\n}\n\n@media only screen and (max-width: 1680px) {\n    .heading-bx p {\n        font-size: 15px\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .heading-bx p {\n        font-size: 14px;\n        line-height: 24px\n    }\n}\n\n.heading-bx.text-center p {\n    max-width: 800px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.heading-bx.head-col {\n    display: flex;\n    align-items: center\n}\n\n@media only screen and (max-width: 767px) {\n    .heading-bx.head-col {\n        display: block\n    }\n}\n\n.heading-bx.head-col .title {\n    margin-bottom: 0\n}\n\n@media only screen and (max-width: 767px) {\n    .heading-bx.head-col .title {\n        margin-bottom: 10px\n    }\n}\n\n.heading-bx.head-col p {\n    padding-left: 15px;\n    border-left: 4px solid #565acf;\n    margin-left: 15px;\n    margin-bottom: 0\n}\n\n@media only screen and (max-width: 767px) {\n    .heading-bx.head-col p {\n        padding-left: 0;\n        border-left: 0;\n        margin-left: 0\n    }\n}\n\n.text-white h1,\n.text-white .h1,\n.text-white h2,\n.text-white .h2,\n.text-white h3,\n.text-white .h3,\n.text-white h4,\n.text-white .h4,\n.text-white h5,\n.text-white .h5,\n.text-white h6,\n.text-white .h6 {\n    color: #fff\n}\n\n@media only screen and (min-width: 1200px)and (max-width: 1440px) {\n    .col-xxl-1 {\n        flex: 0 0 8.3333333333%;\n        max-width: 8.3333333333%\n    }\n\n    .col-xxl-2 {\n        flex: 0 0 16.6666666667%;\n        max-width: 16.6666666667%\n    }\n\n    .col-xxl-3 {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .col-xxl-4 {\n        flex: 0 0 33.3333333333%;\n        max-width: 33.3333333333%\n    }\n\n    .col-xxl-5 {\n        flex: 0 0 41.6666666667%;\n        max-width: 41.6666666667%\n    }\n\n    .col-xxl-6 {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .col-xxl-7 {\n        flex: 0 0 58.3333333333%;\n        max-width: 58.3333333333%\n    }\n\n    .col-xxl-8 {\n        flex: 0 0 66.6666666667%;\n        max-width: 66.6666666667%\n    }\n\n    .col-xxl-9 {\n        flex: 0 0 75%;\n        max-width: 75%\n    }\n\n    .col-xxl-10 {\n        flex: 0 0 83.3333333333%;\n        max-width: 83.3333333333%\n    }\n\n    .col-xxl-11 {\n        flex: 0 0 91.6666666667%;\n        max-width: 91.6666666667%\n    }\n\n    .col-xxl-12 {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n}\n\n.ttr-accordion1 .accordion-item {\n    border: 0;\n    margin-bottom: 15px\n}\n\n.ttr-accordion1 .accordion-button {\n    background-color: #f17732;\n    font-weight: 600;\n    color: #fff;\n    border-radius: 8px !important;\n    border: 0;\n    padding: 18px 25px;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.ttr-accordion1 .accordion-button.collapsed {\n    background-color: #565acf\n}\n\n.ttr-accordion1 .accordion-button.collapsed:after {\n    transform: rotateX(0)\n}\n\n.ttr-accordion1 .accordion-button:after {\n    content: \"\";\n    font-family: \"Font Awesome 5 Free\";\n    background-image: unset;\n    font-size: 14px;\n    transform: rotateX(-180deg);\n    width: auto;\n    height: auto;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.ttr-accordion1 .accordion-header {\n    margin-bottom: -5px\n}\n\n.ttr-accordion1 .accordion-body {\n    font-size: 15px;\n    padding: 25px;\n    background-color: rgba(86, 90, 207, .1);\n    border-radius: 0 0 8px 8px\n}\n\n.card {\n    border: 0px solid #e1e1f0;\n    margin-bottom: 30px;\n    border-radius: 5px;\n    box-shadow: 0px 36px 48px rgba(31, 66, 135, .04);\n    background: #fff\n}\n\n.card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #e1e1f0;\n    background: #fff;\n    padding: 20px 30px\n}\n\n.card-title {\n    font-size: 24px;\n    margin-bottom: 0px\n}\n\n.card .card-body {\n    padding: 20px 30px;\n    background: #fff;\n    border-radius: 15px\n}\n\n.form-group {\n    position: relative;\n}\n\n.form-group label {\n    font-size: 14px;\n    font-weight: 500;\n    color: #444;\n    margin-bottom: 10px;\n    background: rgba(0, 0, 0, 0);\n    border-color: #e1e1f0;\n\n}\n\n.form-control {\n    border-radius: 6px;\n    border: 1px solid rgba(0, 0, 0, 0);\n    padding: 0px 25px;\n    font-size: 14px;\n    font-weight: 400;\n    color: #444;\n    transition: all .3s ease-in-out;\n    background: #fff;\n}\n\n.form-control .select {\n    padding: 12px 0\n}\n\n.form-control span {\n    margin-top: 0\n}\n\n.form-control::-webkit-input-placeholder {\n    color: #444\n}\n\n.form-control:-ms-input-placeholder {\n    color: #444\n}\n\n.form-control::placeholder {\n    color: #444\n}\n\n.form-control:hover {\n    box-shadow: none !important;\n    border-color: #e1e1f0;\n    color: #444;\n    background: #fff\n}\n\n.form-control:focus,\n.form-control:active,\n.form-control.active {\n    box-shadow: none !important;\n    border-color: #565acf;\n    color: #444;\n    background: #fff;\n    border-radius: 6px\n}\n\ninput:-internal-autofill-selected {\n    background: #fff !important;\n    background-image: none !important;\n    color: -internal-light-dark-color(black, white) !important\n}\n\n.input-group-text {\n    padding: 5px 15px;\n    background: #fff;\n    margin-bottom: 0px !important;\n    color: #444;\n    border-color: rgba(0, 0, 0, 0)\n}\n\n.input-group-append .input-group-text {\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px\n}\n\n.input-group-prepend .input-group-text {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px\n}\n\n.toggle {\n    cursor: pointer;\n    display: block\n}\n\n.toggle-switch {\n    display: inline-block;\n    background: #f7f7f7;\n    border-radius: 16px;\n    width: 45px;\n    height: 20px;\n    position: relative;\n    vertical-align: middle;\n    transition: background .25s\n}\n\n.toggle-switch:before,\n.toggle-switch:after {\n    content: \"\"\n}\n\n.toggle-switch:before {\n    display: block;\n    background: linear-gradient(to bottom, #fff 0%, #eee 100%);\n    border-radius: 50%;\n    width: 17px;\n    height: 17px;\n    position: absolute;\n    top: 1px;\n    left: 3px;\n    transition: left .25s\n}\n\n.toggle:hover .toggle-switch:before {\n    background: linear-gradient(to bottom, #fff 0%, #fff 100%)\n}\n\n.toggle-checkbox:checked+.toggle-switch {\n    background: #565acf\n}\n\n.toggle-checkbox:checked+.toggle-switch:before {\n    left: 26px\n}\n\n.toggle-checkbox {\n    position: absolute;\n    visibility: hidden\n}\n\n.toggle-label {\n    margin-left: 15px;\n    position: relative;\n    top: 2px;\n    font-size: 16px;\n    font-weight: 400\n}\n\n.file-upload-wrapper {\n    position: relative;\n    width: 100%;\n    height: calc(1.5em + 1rem + 2px);\n    border: 1px solid #e1e1f0;\n    border-radius: 5px;\n    color: #aeaed5\n}\n\n.file-upload-wrapper:after {\n    content: attr(data-text);\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: #fff;\n    padding: 4px 15px;\n    display: block;\n    width: calc(100% - 40px);\n    pointer-events: none;\n    z-index: 20;\n    height: calc(1.5em + 1rem + 2px);\n    line-height: 30px;\n    border-radius: 5px 10px 10px 5px;\n    font-weight: 400;\n    overflow: hidden\n}\n\n.file-upload-wrapper:before {\n    content: \"Upload\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: inline-block;\n    height: calc(1.5em + 1rem + 2px);\n    background: #565acf;\n    color: #fff;\n    font-weight: 400;\n    z-index: 25;\n    font-size: 14px;\n    line-height: 40px;\n    padding: 0 15px;\n    text-transform: capitalize;\n    pointer-events: none;\n    border-radius: 0 5px 5px 0\n}\n\n.file-upload-wrapper:hover:before {\n    background: #363abc\n}\n\n.file-upload-wrapper input {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 99;\n    height: calc(1.5em + 1rem + 2px);\n    margin: 0;\n    padding: 0;\n    display: block;\n    cursor: pointer;\n    width: 100%\n}\n\n#ui-datepicker-div {\n    display: none;\n    background: #fafafa;\n    box-shadow: 0 .125rem .5rem rgba(0, 0, 0, .1);\n    margin-top: .25rem;\n    border-radius: .5rem;\n    padding: .5rem\n}\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0\n}\n\n.ui-datepicker-calendar thead th {\n    padding: .25rem 0;\n    text-align: center;\n    font-size: .75rem;\n    font-weight: 400;\n    color: #444\n}\n\n.ui-datepicker-calendar tbody td {\n    width: 2.5rem;\n    text-align: center;\n    padding: 0\n}\n\n.ui-datepicker-calendar tbody td a {\n    display: block;\n    border-radius: .25rem;\n    line-height: 2rem;\n    transition: .3s all;\n    color: #444;\n    font-size: .875rem;\n    text-decoration: none\n}\n\n.ui-datepicker-calendar tbody td a:hover {\n    background-color: #565acf;\n    color: #fff\n}\n\n.ui-datepicker-calendar tbody td a.ui-state-active {\n    background-color: #565acf;\n    color: #fff\n}\n\n.ui-datepicker-header a.ui-corner-all {\n    cursor: pointer;\n    position: absolute;\n    top: 0;\n    width: 2rem;\n    height: 2rem;\n    margin: .5rem;\n    border-radius: .25rem;\n    transition: .3s all\n}\n\n.ui-datepicker-header a.ui-corner-all:hover {\n    background-color: #cdcef1;\n    color: #fff\n}\n\n.ui-datepicker-header a.ui-datepicker-prev {\n    left: 0;\n    background: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDEzIDEzIj48cGF0aCBmaWxsPSIjNDI0NzcwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjI4OCA2LjI5NkwzLjIwMiAyLjIxYS43MS43MSAwIDAgMSAuMDA3LS45OTljLjI4LS4yOC43MjUtLjI4Ljk5OS0uMDA3TDguODAzIDUuOGEuNjk1LjY5NSAwIDAgMSAuMjAyLjQ5Ni42OTUuNjk1IDAgMCAxLS4yMDIuNDk3bC00LjU5NSA0LjU5NWEuNzA0LjcwNCAwIDAgMS0xLS4wMDcuNzEuNzEgMCAwIDEtLjAwNi0uOTk5bDQuMDg2LTQuMDg2eiIvPjwvc3ZnPg==\");\n    background-repeat: no-repeat;\n    background-size: .5rem;\n    background-position: 50%;\n    transform: rotate(180deg)\n}\n\n.ui-datepicker-header a.ui-datepicker-next {\n    right: 0;\n    background: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDEzIDEzIj48cGF0aCBmaWxsPSIjNDI0NzcwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjI4OCA2LjI5NkwzLjIwMiAyLjIxYS43MS43MSAwIDAgMSAuMDA3LS45OTljLjI4LS4yOC43MjUtLjI4Ljk5OS0uMDA3TDguODAzIDUuOGEuNjk1LjY5NSAwIDAgMSAuMjAyLjQ5Ni42OTUuNjk1IDAgMCAxLS4yMDIuNDk3bC00LjU5NSA0LjU5NWEuNzA0LjcwNCAwIDAgMS0xLS4wMDcuNzEuNzEgMCAwIDEtLjAwNi0uOTk5bDQuMDg2LTQuMDg2eiIvPjwvc3ZnPg==\");\n    background-repeat: no-repeat;\n    background-size: 10px;\n    background-position: 50%\n}\n\n.ui-datepicker-header a>span {\n    display: none\n}\n\n.ui-datepicker-title {\n    text-align: center;\n    line-height: 2rem;\n    margin-bottom: .25rem;\n    font-size: .875rem;\n    font-weight: 500;\n    padding-bottom: .25rem\n}\n\n.ui-datepicker-week-col {\n    color: #444;\n    font-weight: 400;\n    font-size: .75rem\n}\n\nlabel.error {\n    color: #f72b50;\n    position: absolute;\n    bottom: 0;\n    margin-bottom: -22px;\n    font-size: 12px;\n    font-weight: 400\n}\n\n.bootstrap-select {\n    width: 100% !important\n}\n\n.bootstrap-select .dropdown-toggle {\n    width: 100%;\n    padding: 10px;\n    font-family: \"Montserrat\", sans-serif;\n    text-transform: none;\n    background: #fff;\n    color: #444;\n    font-size: 14px;\n    outline: none !important\n}\n\n.bootstrap-select .dropdown-toggle:focus {\n    outline: none !important\n}\n\n.bootstrap-select .dropdown-toggle:after {\n    content: none\n}\n\n.bootstrap-select.show.btn-group .dropdown-menu.inner {\n    display: block\n}\n\n.bootstrap-select .dropdown-menu {\n    border: 0;\n    border-radius: 0;\n    margin-top: -1px;\n    padding: 10px 0;\n    font-size: 14px;\n    box-shadow: 0 20px 30px 0 rgba(0, 0, 0, .1)\n}\n\n.bootstrap-select .dropdown-menu a {\n    padding: 5px 25px;\n    display: block\n}\n\n.bootstrap-select .dropdown-menu a:hover {\n    background: #fff\n}\n\n.bootstrap-select .list {\n    background: var(--bs-dark)\n}\n\n.nice-select .list {\n    width: 100%;\n    border: 0;\n    margin: 1px 0 0;\n    box-shadow: 0 0 10px rgba(0, 0, 0, .1);\n    padding: 8px 0\n}\n\n.nice-select .list li {\n    font-weight: 500\n}\n\n.nice-select .list .option:hover,\n.nice-select .list .option.selected {\n    background-color: #565acf;\n    color: #fff\n}\n\n.nice-select:after {\n    right: 22px\n}\n\n.btn {\n    padding: 15px 30px;\n    border-radius: 8px;\n    text-decoration: none;\n    font-weight: 500;\n    font-size: 14px;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    border-width: 2px;\n    line-height: 1.2\n}\n\n.btn.shadow {\n    box-shadow: 0px 5px 20px 0px rgba(86, 90, 207, .3)\n}\n\n.btn-icon-bx {\n    width: 40px;\n    height: 40px;\n    background: #fff;\n    border-radius: inherit;\n    line-height: 40px;\n    display: inline-block;\n    margin: -12px -27px -12px 15px;\n    color: #000\n}\n\n.btn:hover .btn-icon-bx {\n    background-color: #2ab4ff;\n}\n\n.btn-xs {\n    font-size: 12px;\n    padding: 6px 15px\n}\n\n.btn-xs .btn-icon-bx {\n    width: 26px;\n    height: 26px;\n    line-height: 26px;\n    margin: -10px -15px -10px 10px\n}\n\n.btn-sm,\n.btn-group-sm>.btn {\n    font-size: 14px;\n    padding: 12px 27px 12px 20px\n}\n\n.btn-sm .btn-icon-bx,\n.btn-group-sm>.btn .btn-icon-bx {\n    width: 34px;\n    height: 34px;\n    margin: -10px -24px -10px 15px;\n    line-height: 34px\n}\n\n.btn-lg,\n.btn-group-lg>.btn {\n    font-size: 16px;\n    padding: 20px 35px;\n    line-height: 1\n}\n\n.btn-lg .btn-icon-bx,\n.btn-group-lg>.btn .btn-icon-bx {\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    margin: -16px -31px -16px 20px\n}\n\n.btn-xl {\n    font-size: 18px;\n    padding: 24px 40px;\n    line-height: 1\n}\n\n.btn-xl .btn-icon-bx {\n    width: 60px;\n    height: 60px;\n    line-height: 60px;\n    margin: -20px -37px -20px 20px\n}\n\n[class*=btn-outline-] .btn-icon-bx {\n    color: #fff\n}\n\n.btn-outline-primary .btn-icon-bx {\n    background: #00b8de\n}\n\n.btn-outline-secondary .btn-icon-bx {\n    background: #f17732\n}\n\n.btn-outline-success .btn-icon-bx {\n    background: #209f84\n}\n\n.btn-outline-danger .btn-icon-bx {\n    background: #f72b50\n}\n\n.btn-outline-info .btn-icon-bx {\n    background: #2754e6\n}\n\n.btn-outline-warning .btn-icon-bx {\n    background: #fe970e\n}\n\n.btn-outline-light .btn-icon-bx {\n    background: #fff\n}\n\n.btn-outline-dark .btn-icon-bx {\n    background: var(--bs-dark)\n}\n\n.btn-light {\n    color: #f17732;\n    background-color: #fff\n}\n\n.btn-secondary {\n    background-color: var(--bs-btn-bg);\n    color: #fff\n}\n\n.btn-secondary.light {\n    background-color: #fff;\n    color: #f17732\n}\n\n.btn-secondary.shadow {\n    box-shadow: 0px 5px 20px 0px rgba(8, 116, 150, .3) !important\n}\n\n.btn-secondary:hover {\n    background-color: #2ab4ff;\n    color: #fff;\n    border: 2px solid #2ab4ff;\n    box-shadow: 0px 5px 20px 0px rgba(8, 116, 150, .3) !important\n}\n\n/* .btn-primary {\n    background-color: #2ab4ff;\n} */\n\n.btn-primary.light {\n    background-color: #008bb1;\n    color: #fff;\n    border: 2px solid #008bb1;\n}\n\n.btn-primary.light:hover {\n    background-color: #2AB4FF;\n    box-shadow: 0px 1px 7px 0px rgba(86, 90, 207, .3);\n    color: #fff;\n    border: 2px solid #2AB4FF;\n}\n\n.btn-primary .btn-icon-bx {\n    color: #565acf\n}\n\n.btn-primary.shadow {\n    box-shadow: 0px 5px 20px 0px rgba(86, 90, 207, .3) !important\n}\n\n.btn-success {\n    background-color: #209f84\n}\n\n.btn-success.light {\n    background-color: #b4f0e3;\n    color: #209f84\n}\n\n.btn-success .btn-icon-bx {\n    color: #209f84\n}\n\n.btn-danger {\n    background-color: #f72b50\n}\n\n.btn-danger.light {\n    background-color: #fef0f2;\n    color: #f72b50\n}\n\n.btn-danger .btn-icon-bx {\n    color: #f72b50\n}\n\n.btn-warning {\n    background-color: #fe970e\n}\n\n.btn-warning.light {\n    background-color: #fffaf3;\n    color: #fe970e\n}\n\n.btn-warning .btn-icon-bx {\n    color: #fe970e\n}\n\n.btn-info {\n    background-color: #2754e6\n}\n\n.btn-info.light {\n    background-color: #f5f7fe;\n    color: #2754e6\n}\n\n.btn-info .btn-icon-bx {\n    color: #2754e6\n}\n\n.btn-dark {\n    background-color: var(--bs-dark)\n}\n\n.btn-dark.light {\n    background-color: #989be4;\n    color: #fff\n}\n\n.btn-dark .btn-icon-bx {\n    color: var(--bs-dark)\n}\n\n.table-responsive-sm {\n    min-width: 48rem\n}\n\n.table {\n    margin-bottom: 0px;\n    font-weight: 400\n}\n\n.table tr td,\n.table tr th {\n    padding: 15px\n}\n\n.table tr th {\n    color: #14181d;\n    font-weight: 500\n}\n\n.table-striped thead tr th {\n    padding-bottom: 15px !important\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n    background-color: #fff\n}\n\n.table-striped tfoot {\n    border-top: 2px solid #e1e1f0\n}\n\n.table-striped tfoot tr th {\n    padding-top: 10px\n}\n\n.ttr-separator {\n    display: inline-block;\n    height: 4px;\n    width: 90px;\n    margin-bottom: 10px;\n    position: relative\n}\n\n.ttr-separator.m-b0 {\n    margin-bottom: 0\n}\n\n.ttr-separator.style-liner {\n    width: 20px\n}\n\n.ttr-separator.style-icon {\n    width: 30px;\n    height: auto;\n    text-align: center;\n    font-size: 20px\n}\n\n.ttr-separator[class*=style-]:after,\n.ttr-separator[class*=style-]:before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 40px;\n    width: 70px;\n    height: 2px;\n    background: #eee;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%)\n}\n\n.ttr-separator[class*=style-]:before {\n    left: auto;\n    right: 40px\n}\n\n.ttr-separator.style-skew {\n    width: 15px;\n    height: 10px;\n    margin-left: 1px;\n    margin-right: 1px;\n    -moz-transform: skewX(-10deg);\n    -webkit-transform: skewX(-10deg);\n    -o-transform: skewX(-10deg);\n    -ms-transform: skewX(-10deg);\n    transform: skewX(-10deg)\n}\n\n.ttr-separator.style-skew[class*=style-]:after,\n.ttr-separator.style-skew[class*=style-]:before {\n    width: 80px;\n    height: 4px;\n    left: 20px;\n    -moz-transform: translateY(-50%) skewX(-10deg);\n    -webkit-transform: translateY(-50%) skewX(-10deg);\n    -o-transform: translateY(-50%) skewX(-10deg);\n    -ms-transform: translateY(-50%) skewX(-10deg);\n    transform: translateY(-50%) skewX(-10deg)\n}\n\n.ttr-separator.style-skew[class*=style-]:before {\n    right: 20px;\n    left: auto\n}\n\n.ttr-separator.bnr-title {\n    height: 1px;\n    width: 155px;\n    opacity: .5\n}\n\n.ttr-separator.bnr-title:before,\n.ttr-separator.bnr-title:after {\n    position: absolute;\n    content: \"\";\n    background-color: inherit\n}\n\n.ttr-separator.bnr-title:before {\n    height: inherit;\n    right: -80px;\n    width: 25px\n}\n\n.ttr-separator.bnr-title:after {\n    height: inherit;\n    right: -90px;\n    top: 0;\n    width: 6px\n}\n\n.ttr-separator.bnr-title i {\n    background-color: inherit;\n    display: block;\n    height: inherit;\n    position: absolute;\n    right: -50px;\n    width: 45px\n}\n\n.ttr-separator-outer {\n    overflow: hidden\n}\n\n.feature-box-xl {\n    display: inline-block;\n    text-align: center;\n    border-radius: 3px;\n    width: 150px;\n    height: 150px;\n    line-height: 150px\n}\n\n.feature-box-xl.radius {\n    -webkit-border-radius: 100%;\n    -moz-border-radius: 100%;\n    border-radius: 100%\n}\n\n.feature-box-xl i {\n    font-size: 80px;\n    vertical-align: middle\n}\n\n.feature-box-xl img {\n    vertical-align: middle;\n    max-width: 100%;\n    width: auto;\n    height: 80px\n}\n\n.feature-box-lg {\n    display: inline-block;\n    text-align: center;\n    border-radius: 3px;\n    width: 120px;\n    height: 120px;\n    line-height: 120px\n}\n\n.feature-box-lg.radius {\n    -webkit-border-radius: 100%;\n    -moz-border-radius: 100%;\n    border-radius: 100%\n}\n\n.feature-box-lg i {\n    font-size: 60px;\n    vertical-align: middle\n}\n\n.feature-box-lg img {\n    vertical-align: middle;\n    max-width: 100%;\n    width: auto;\n    height: 55px\n}\n\n.feature-box-md {\n    display: inline-block;\n    text-align: center;\n    border-radius: 3px;\n    width: 100px;\n    height: 100px;\n    line-height: 100px\n}\n\n.feature-box-md.radius {\n    -webkit-border-radius: 100%;\n    -moz-border-radius: 100%;\n    border-radius: 100%\n}\n\n.feature-box-md i {\n    font-size: 45px;\n    vertical-align: middle\n}\n\n.feature-box-md img {\n    vertical-align: middle;\n    max-width: 100%;\n    width: auto;\n    height: 40px\n}\n\n.feature-box-sm {\n    display: inline-block;\n    text-align: center;\n    border-radius: 3px;\n    width: 80px;\n    height: 80px;\n    line-height: 80px\n}\n\n.feature-box-sm.radius {\n    -webkit-border-radius: 100%;\n    -moz-border-radius: 100%;\n    border-radius: 100%\n}\n\n.feature-box-sm i {\n    font-size: 30px;\n    vertical-align: middle\n}\n\n.feature-box-sm img {\n    vertical-align: middle;\n    max-width: 100%;\n    width: auto;\n    height: 30px\n}\n\n.feature-box-xs {\n    display: inline-block;\n    text-align: center;\n    border-radius: 3px;\n    width: 40px;\n    height: 40px;\n    line-height: 40px\n}\n\n.feature-box-xs.radius {\n    -webkit-border-radius: 100%;\n    -moz-border-radius: 100%;\n    border-radius: 100%\n}\n\n.feature-box-xs i {\n    font-size: 20px;\n    vertical-align: middle\n}\n\n.feature-box-xs img {\n    vertical-align: middle;\n    max-width: 100%;\n    width: auto;\n    height: 20px\n}\n\n.icon-xl {\n    display: inline-block;\n    text-align: center\n}\n\n.icon-xl i {\n    vertical-align: middle;\n    font-size: 80px\n}\n\n.icon-xl img {\n    vertical-align: middle;\n    max-width: 100%;\n    width: auto;\n    height: 80px\n}\n\n.icon-lg {\n    display: inline-block;\n    text-align: center\n}\n\n.icon-lg i {\n    vertical-align: middle;\n    font-size: 60px\n}\n\n.icon-lg img {\n    vertical-align: middle;\n    max-width: 100%;\n    width: auto;\n    height: 70px\n}\n\n.icon-md {\n    display: inline-block;\n    text-align: center\n}\n\n.icon-md i {\n    vertical-align: middle;\n    font-size: 45px\n}\n\n.icon-md img {\n    vertical-align: middle;\n    max-width: 100%;\n    width: auto;\n    height: 50px\n}\n\n.icon-sm {\n    display: inline-block;\n    text-align: center\n}\n\n.icon-sm i {\n    vertical-align: middle;\n    font-size: 30px\n}\n\n.icon-sm img {\n    vertical-align: middle;\n    max-width: 100%;\n    width: auto;\n    height: 30px\n}\n\n.icon-xs {\n    display: inline-block;\n    text-align: center\n}\n\n.icon-xs i {\n    vertical-align: middle;\n    font-size: 20px\n}\n\n.icon-xs img {\n    vertical-align: middle;\n    max-width: 100%;\n    width: auto;\n    height: 20px\n}\n\n.feature-container {\n    position: relative\n}\n\n.feature-container .feature-title {\n    margin-top: 0\n}\n\n.feature-container .after-titile-line {\n    margin-bottom: 10px\n}\n\n.feature-container p:last-child {\n    margin: 0\n}\n\n.feature-container.center {\n    text-align: center\n}\n\n.feature-container.left .feature-box-xl,\n.feature-container.left .feature-box-lg,\n.feature-container.left .feature-box-md,\n.feature-container.left .feature-box-sm,\n.feature-container.left .feature-box-xs {\n    float: left;\n    margin-right: 20px\n}\n\n.feature-container.left .icon-xl,\n.feature-container.left .icon-lg,\n.feature-container.left .icon-md,\n.feature-container.left .icon-sm,\n.feature-container.left .icon-xs {\n    float: left;\n    margin-right: 10px\n}\n\n.feature-container.right {\n    text-align: right\n}\n\n.feature-container.right .feature-box-xl,\n.feature-container.right .feature-box-lg,\n.feature-container.right .feature-box-md,\n.feature-container.right .feature-box-sm,\n.feature-container.right .feature-box-xs {\n    float: right;\n    margin-left: 20px\n}\n\n.feature-container.right .icon-xl,\n.feature-container.right .icon-lg,\n.feature-container.right .icon-md,\n.feature-container.right .icon-sm,\n.feature-container.right .icon-xs {\n    float: right;\n    margin-left: 10px\n}\n\n.icon-content {\n    overflow: hidden\n}\n\n[class*=feature-box-][class*=bg-] a {\n    color: #fff\n}\n\n[class*=feature-box-].bg-white a {\n    color: inherit\n}\n\n[class*=feature-box-][class*=border-] {\n    display: table;\n    line-height: normal;\n    margin-left: auto;\n    margin-right: auto\n}\n\n[class*=feature-box-][class*=border-] .icon-cell {\n    display: table-cell;\n    vertical-align: middle\n}\n\n.ttr-box,\n.info-bx,\n.feature-title,\n.feature-title-inner {\n    position: relative\n}\n\n.feature-title-inner {\n    display: inline-block\n}\n\n.ttr-box[class*=border-],\n.info-bx[class*=border-] {\n    border-color: #eee\n}\n\n.info-bx.border-1,\n.info-bx.border-2,\n.info-bx.border-3,\n.info-bx.border-4,\n.info-bx.border-5 {\n    border-top: none\n}\n\n.border-1,\n.border-2,\n.border-3,\n.border-4,\n.border-5 {\n    border-style: solid\n}\n\n.border-1 {\n    border-width: 1px\n}\n\n.border-2 {\n    border-width: 2px\n}\n\n.border-3 {\n    border-width: 3px\n}\n\n.border-4 {\n    border-width: 4px\n}\n\n.border-5 {\n    border-width: 5px\n}\n\n.left-border,\n.right-border {\n    position: relative\n}\n\n.left-border:before,\n.right-border:before {\n    content: \"\";\n    position: absolute;\n    top: 5px;\n    width: 1px;\n    height: 90%;\n    background: #ccc\n}\n\n.right-border:before {\n    right: 0\n}\n\n.action-box,\n.ttr-post-media {\n    position: relative;\n    overflow: hidden\n}\n\n.action-box img,\n.ttr-post-media img {\n    width: 100%;\n    height: auto\n}\n\n.ttr-box-bg {\n    overflow: hidden;\n    background-size: cover\n}\n\n.ttr-box-bg .btn {\n    overflow: unset\n}\n\n.ttr-box-bg .glyph-icon {\n    font-size: 50px\n}\n\n.ttr-box-bg .feature-container {\n    background-color: #f8f8f8\n}\n\n.ttr-box-bg .text-primary,\n.ttr-box-bg .icon-content .feature-title,\n.ttr-box-bg .icon-content p,\n.ttr-box-bg .icon-box-btn .btn {\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.ttr-box-bg.active .feature-container {\n    background-color: rgba(0, 0, 0, .7)\n}\n\n.ttr-box-bg.active .text-primary,\n.ttr-box-bg.active .icon-content .feature-title,\n.ttr-box-bg.active .icon-content p,\n.ttr-box-bg.active .icon-box-btn .btn {\n    color: #fff;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.ttr-box-bg .icon-box-btn .btn {\n    background-color: #eee;\n    padding: 15px 20px;\n    text-transform: uppercase;\n    font-size: 15px;\n    border-radius: 0;\n    color: #1abc9c;\n    font-weight: 600;\n    margin-bottom: 0\n}\n\n.feature-bx1 {\n    align-items: center;\n    display: flex;\n    background-color: #fff;\n    border-radius: 8px;\n    padding: 10px 20px 10px 15px;\n    z-index: 1;\n    overflow: hidden;\n    box-shadow: 0px 5px 30px 0px rgba(31, 34, 120, .08);\n    border: 1px solid;\n    border-color: #565acf\n}\n\n.feature-bx1 .icon-cell {\n    margin-right: 30px\n}\n\n.feature-bx1 .icon-cell svg {\n    width: 45px;\n    height: 45px\n}\n\n.feature-bx1:after {\n    content: \"\";\n    width: 85px;\n    height: 85px;\n    position: absolute;\n    border-radius: 50%;\n    z-index: -1;\n    top: -8px;\n    left: -12px\n}\n\n.feature-bx1.feature1 {\n    border-color: #b2f0fb\n}\n\n.feature-bx1.feature1:after {\n    background-color: #ecfcff\n}\n\n.feature-bx1.feature2 {\n    border-color: #a4fcc4\n}\n\n.feature-bx1.feature2:after {\n    background-color: #eefff4\n}\n\n.feature-bx1.feature3 {\n    border-color: #ffbdbc\n}\n\n.feature-bx1.feature3:after {\n    background-color: #fff0f0\n}\n\n.feature-bx1.feature4 {\n    border-color: #e2c4ff\n}\n\n.feature-bx1.feature4:after {\n    background-color: #f8f0ff\n}\n\n.feature-bx1 .icon-content .ttr-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--bs-dark);\n    margin: 0\n}\n\n.feature-bx1:hover .icon-cell svg {\n    -webkit-animation: vibrate .5s alternate;\n    animation: vibrate .5s alternate\n}\n\n.feature-bx2 {\n    border-radius: 20px;\n    background-color: #fff;\n    z-index: 1;\n    overflow: hidden;\n    padding: 40px;\n    box-shadow: 1px 1px 50px rgba(0, 0, 0, .08);\n    background-image: url(./images/background/line-bg3.png);\n    background-repeat: no-repeat;\n    background-size: 100%\n}\n\n@media only screen and (max-width: 575px) {\n    .feature-bx2 {\n        padding: 30px 20px\n    }\n}\n\n.feature-bx2 .feature-box-xl {\n    background: #fff;\n    border: 2px solid rgba(86, 90, 207, .1);\n    border-radius: 13px;\n    width: 130px;\n    height: 130px;\n    line-height: 130px\n}\n\n.feature-bx2 .feature-box-xl img,\n.feature-bx2 .feature-box-xl svg {\n    width: 60px\n}\n\n.feature-bx2 .icon-content p {\n    font-size: 15px;\n    margin-bottom: 20px\n}\n\n.feature-bx2:hover .feature-box-xl i,\n.feature-bx2:hover .feature-box-xl svg,\n.feature-bx2:hover .feature-box-xl img {\n    -webkit-animation: vibrate .5s alternate;\n    animation: vibrate .5s alternate\n}\n\n.feature-bx2:hover .btn {\n    background-color: #008bb1;\n    border-color: #008bb1;\n    color: #fff\n}\n\n.feature-bx3 {\n    border-radius: 20px;\n    padding: 50px 30px;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    background-color: #fff;\n    position: relative;\n    margin: 15px 0 0 15px\n}\n\n.feature-bx3:after {\n    content: \"\";\n    position: absolute;\n    top: -15px;\n    left: -15px;\n    border-radius: 20px;\n    width: 100%;\n    height: 100%;\n    border: 2px solid #565acf;\n    z-index: -1\n}\n\n.feature-bx3 .ttr-title {\n    margin-bottom: 12px\n}\n\n.feature-bx3 .counter {\n    font-size: 60px;\n    line-height: 1;\n    margin-bottom: 10px\n}\n\n.feature-bx3 p {\n    font-size: 14px\n}\n\n.feature-bx3 .ttr-title,\n.feature-bx3 .counter,\n.feature-bx3 p {\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.feature-bx3:hover {\n    background-color: #565acf\n}\n\n.feature-bx3:hover .ttr-title,\n.feature-bx3:hover .counter,\n.feature-bx3:hover p {\n    color: #fff !important\n}\n\n\n@media only screen and (max-width: 575px) {\n    .feature-bx3 {\n        padding: 40px\n    }\n}\n\n.feature-bx4 {\n    background-color: #fff;\n    border-radius: 8px;\n    padding: 45px 35px 35px;\n    z-index: 1;\n    overflow: hidden;\n    box-shadow: 0px 5px 30px 0px rgba(31, 34, 120, .08);\n    border: 1px solid;\n    border-color: #565acf\n}\n\n.feature-bx4 .feature-icon {\n    position: relative;\n    margin-bottom: 25px\n}\n\n.feature-bx4 .feature-icon svg {\n    width: 45px;\n    height: 45px\n}\n\n.feature-bx4 .feature-icon:after {\n    content: \"\";\n    width: 65px;\n    height: 65px;\n    position: absolute;\n    border-radius: 50%;\n    z-index: -1;\n    top: -18px;\n    right: -22px\n}\n\n.feature-bx4.feature1 {\n    border-color: #b2f0fb\n}\n\n.feature-bx4.feature1 .feature-icon:after {\n    background-color: #ecfcff\n}\n\n.feature-bx4.feature2 {\n    border-color: #a4fcc4\n}\n\n.feature-bx4.feature2 .feature-icon:after {\n    background-color: #eefff4\n}\n\n.feature-bx4.feature3 {\n    border-color: #ffbdbc\n}\n\n.feature-bx4.feature3 .feature-icon:after {\n    background-color: #fff0f0\n}\n\n.feature-bx4.feature4 {\n    border-color: #e2c4ff\n}\n\n.feature-bx4.feature4 .feature-icon:after {\n    background-color: #f8f0ff\n}\n\n.feature-bx4 .icon-content .ttr-title {\n    color: var(--bs-dark);\n    margin: 0 0 12px\n}\n\n.feature-bx4 .icon-content p {\n    margin: 0\n}\n\n.feature-bx4:hover .feature-icon img {\n    -webkit-animation: vibrate .5s alternate;\n    animation: vibrate .5s alternate\n}\n\n.feature-bx5 {\n    position: relative;\n    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);\n    padding: 40px 30px;\n    border-radius: 20px;\n    background-color: #fff;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    overflow: hidden;\n    z-index: 1\n}\n\n.feature-bx5:before,\n.feature-bx5:after {\n    content: \"\";\n    position: absolute;\n    height: 100px;\n    width: 100px;\n    border: 3px solid;\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, 0);\n    opacity: .2;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.feature-bx5:before {\n    left: -30px;\n    top: -30px;\n    border-color: #565acf\n}\n\n.feature-bx5:after {\n    right: -30px;\n    bottom: -30px;\n    border-color: #f17732\n}\n\n.table-wrapper {\n    position: relative;\n    padding: 30px;\n    background: #fff;\n    border: 2px solid #e4e3e4;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    border-radius: 8px\n}\n\n.table-wrapper .table-head {\n    margin-bottom: 30px\n}\n\n.table-wrapper .table-head .table-title {\n    margin-bottom: 25px;\n    text-align: center\n}\n\n.table-wrapper .table-head .table-title .sub-title {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 0\n}\n\n.table-wrapper .table-head .table-price {\n    display: flex;\n    justify-content: center;\n    align-items: center\n}\n\n.table-wrapper .table-head .table-price sup {\n    font-size: 26px;\n    font-weight: bold;\n    margin-right: 5px;\n    color: #14181d\n}\n\n.table-wrapper .table-head .table-price h6,\n.table-wrapper .table-head .table-price .h6 {\n    font-size: 52px;\n    font-weight: 700;\n    margin-bottom: 0\n}\n\n.table-wrapper .table-head .table-price p {\n    margin: 0 0 0 5px;\n    font-size: 14px\n}\n\n@media only screen and (max-width: 767px) {\n    .table-wrapper .table-head .table-price sup {\n        font-size: 14px\n    }\n\n    .table-wrapper .table-head .table-price h6,\n    .table-wrapper .table-head .table-price .h6 {\n        font-size: 36px\n    }\n}\n\n.table-wrapper .table-body {\n    margin-bottom: 40px\n}\n\n.table-wrapper .table-body .title {\n    font-size: 16px;\n    margin-bottom: 30px;\n    text-align: center\n}\n\n@media only screen and (max-width: 767px) {\n    .table-wrapper .table-body .title {\n        font-size: 14px\n    }\n}\n\n.table-wrapper .table-body .table-features {\n    margin-bottom: 0\n}\n\n.table-wrapper .table-body .table-features li {\n    font-size: 15px;\n    position: relative;\n    line-height: 20px;\n    margin-bottom: 15px;\n    padding-left: 34px;\n    font-weight: 500\n}\n\n.table-wrapper .table-body .table-features li:before {\n    content: \"\";\n    font-size: 24px;\n    font-family: \"Line Awesome Free\";\n    font-weight: 900;\n    line-height: 25px;\n    color: #11a435;\n    position: absolute;\n    left: 0;\n    top: 0\n}\n\n.table-wrapper:hover {\n    border: 2px solid #565acf;\n    box-shadow: 0 5px 20px rgba(0, 98, 255, .2);\n    margin-top: -10px\n}\n\n.table-wrapper:hover .table-head .table-price sup,\n.table-wrapper:hover .table-head .table-price h6,\n.table-wrapper:hover .table-head .table-price .h6 {\n    color: #565acf\n}\n\n.table-wrapper:hover .table-footer .btn {\n    background-color: #565acf;\n    color: #fff\n}\n\n.table-switch {\n    display: flex;\n    justify-content: center;\n    align-items: center\n}\n\n.table-switch .form-check-input {\n    width: 60px;\n    height: 30px;\n    box-shadow: 0 3px 10px 0 rgba(0, 98, 252, .2);\n    background-color: #565acf\n}\n\n.table-switch:before {\n    height: 22px;\n    width: 22px\n}\n\n.table-switch label {\n    margin: 0 55px 0 14px;\n    font-size: 16px;\n    color: #666;\n    cursor: pointer;\n    font-weight: 500\n}\n\n.ovbl-light,\n.ovbl-middle,\n.ovbl-dark,\n.ovgd-light,\n.ovgd-middle,\n.ovgd-dark,\n.ovwh-light,\n.ovwh-middle,\n.ovwh-dark,\n.ovpr-light,\n.ovpr-middle,\n.ovpr-dark,\n.ovpr {\n    position: relative\n}\n\n.ovbl-light:before,\n.ovbl-middle:before,\n.ovbl-dark:before,\n.ovgd-light:before,\n.ovgd-middle:before,\n.ovgd-dark:before,\n.ovwh-light:before,\n.ovwh-middle:before,\n.ovwh-dark:before,\n.ovpr-light:before,\n.ovpr-middle:before,\n.ovpr-dark:before,\n.ovpr:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%\n}\n\n.ovbl-light .container,\n.ovbl-light .container-fluid,\n.ovbl-light .container-sm,\n.ovbl-light .container-md,\n.ovbl-light .container-lg,\n.ovbl-light .container-xl,\n.ovbl-middle .container,\n.ovbl-middle .container-fluid,\n.ovbl-middle .container-sm,\n.ovbl-middle .container-md,\n.ovbl-middle .container-lg,\n.ovbl-middle .container-xl,\n.ovbl-dark .container,\n.ovbl-dark .container-fluid,\n.ovbl-dark .container-sm,\n.ovbl-dark .container-md,\n.ovbl-dark .container-lg,\n.ovbl-dark .container-xl,\n.ovgd-light .container,\n.ovgd-light .container-fluid,\n.ovgd-light .container-sm,\n.ovgd-light .container-md,\n.ovgd-light .container-lg,\n.ovgd-light .container-xl,\n.ovgd-middle .container,\n.ovgd-middle .container-fluid,\n.ovgd-middle .container-sm,\n.ovgd-middle .container-md,\n.ovgd-middle .container-lg,\n.ovgd-middle .container-xl,\n.ovgd-dark .container,\n.ovgd-dark .container-fluid,\n.ovgd-dark .container-sm,\n.ovgd-dark .container-md,\n.ovgd-dark .container-lg,\n.ovgd-dark .container-xl,\n.ovwh-light .container,\n.ovwh-light .container-fluid,\n.ovwh-light .container-sm,\n.ovwh-light .container-md,\n.ovwh-light .container-lg,\n.ovwh-light .container-xl,\n.ovwh-middle .container,\n.ovwh-middle .container-fluid,\n.ovwh-middle .container-sm,\n.ovwh-middle .container-md,\n.ovwh-middle .container-lg,\n.ovwh-middle .container-xl,\n.ovwh-dark .container,\n.ovwh-dark .container-fluid,\n.ovwh-dark .container-sm,\n.ovwh-dark .container-md,\n.ovwh-dark .container-lg,\n.ovwh-dark .container-xl,\n.ovpr-light .container,\n.ovpr-light .container-fluid,\n.ovpr-light .container-sm,\n.ovpr-light .container-md,\n.ovpr-light .container-lg,\n.ovpr-light .container-xl,\n.ovpr-middle .container,\n.ovpr-middle .container-fluid,\n.ovpr-middle .container-sm,\n.ovpr-middle .container-md,\n.ovpr-middle .container-lg,\n.ovpr-middle .container-xl,\n.ovpr-dark .container,\n.ovpr-dark .container-fluid,\n.ovpr-dark .container-sm,\n.ovpr-dark .container-md,\n.ovpr-dark .container-lg,\n.ovpr-dark .container-xl,\n.ovpr .container,\n.ovpr .container-fluid,\n.ovpr .container-sm,\n.ovpr .container-md,\n.ovpr .container-lg,\n.ovpr .container-xl {\n    position: relative;\n    z-index: 1\n}\n\n.ovbl-light:before,\n.ovbl-middle:before,\n.ovbl-dark:before {\n    background: var(--bs-dark)\n}\n\n.ovgd-light:before,\n.ovgd-middle:before,\n.ovgd-dark:before {\n    background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);\n    background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%)\n}\n\n.ovwh-light:before,\n.ovwh-middle:before,\n.ovwh-dark:before {\n    background: #fff\n}\n\n.ovpr-light:before,\n.ovpr-middle:before,\n.ovpr-dark:before,\n.ovpr:before {\n    background: #008bb1;\n}\n\n.ovpr-light:before,\n.ovwh-light:before,\n.ovgd-light:before,\n.ovbl-light:before {\n    opacity: .3\n}\n\n.ovpr-middle:before,\n.ovwh-middle:before,\n.ovgd-middle:before,\n.ovbl-middle:before {\n    opacity: .5\n}\n\n.ovpr-dark:before,\n.ovwh-dark:before,\n.ovgd-dark:before,\n.ovbl-dark:before {\n    opacity: .9\n}\n\n.overlay-bx {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    z-index: 10;\n    opacity: 0;\n    visibility: hidden;\n    -webkit-transition: all .8s;\n    -ms-transition: all .8s;\n    transition: all .8s\n}\n\n.overlay-bx .align-b {\n    height: auto;\n    left: 0;\n    list-style: outside none none;\n    margin: 0;\n    position: absolute;\n    top: auto;\n    bottom: 0;\n    width: 100%;\n    transform: translate(0);\n    -o-transform: translate(0);\n    -moz-transform: translate(0);\n    -webkit-transform: translate(0)\n}\n\n.overlay-bx .align-m {\n    height: auto;\n    left: 50%;\n    list-style: outside none none;\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    width: 100%;\n    padding: 0 10px\n}\n\n.overlay-icon {\n    height: auto;\n    left: 50%;\n    list-style: outside none none;\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    width: 100%;\n    padding: 0 10px\n}\n\n.overlay-icon a {\n    display: inline-block;\n    padding: 0;\n    margin: 0 2px\n}\n\n.overlay-icon a i {\n    background-color: #fff\n}\n\n.thumb-wraper {\n    display: inline-block;\n    position: relative\n}\n\n@media only screen and (max-width: 575px) {\n    .thumb-wraper {\n        padding: 15px\n    }\n}\n\n.thumb-wraper .bg-img {\n    position: relative;\n    z-index: -2\n}\n\n.thumb-wraper ul li {\n    position: absolute\n}\n\n.thumb-wraper ul li a {\n    width: 65px;\n    height: 65px;\n    border-radius: 50%;\n    overflow: hidden;\n    display: block;\n    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    position: relative\n}\n\n.thumb-wraper ul li a img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover\n}\n\n.thumb-wraper ul li:after {\n    content: \"\";\n    height: 100%;\n    width: 100%;\n    left: 0;\n    top: 0;\n    position: absolute;\n    background-color: #565acf;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    z-index: -1;\n    transform: scale(0);\n    border-radius: 50%\n}\n\n.thumb-wraper ul li.active:after {\n    transform: scale(1.14)\n}\n\n.thumb-wraper ul li:nth-child(1) {\n    top: 100px;\n    left: 20px\n}\n\n.thumb-wraper ul li:nth-child(2) {\n    top: 0px;\n    left: 50%;\n    transform: translateX(-50%)\n}\n\n.thumb-wraper ul li:nth-child(3) {\n    top: 100px;\n    right: 20px\n}\n\n.thumb-wraper ul li:nth-child(4) {\n    right: 30px;\n    bottom: 110px\n}\n\n.thumb-wraper ul li:nth-child(5) {\n    bottom: 20px;\n    left: 50%;\n    transform: translateX(-50%)\n}\n\n.thumb-wraper ul li:nth-child(6) {\n    left: 30px;\n    bottom: 110px\n}\n\n@media only screen and (max-width: 575px) {\n    .thumb-wraper ul li:nth-child(2) {\n        top: 10px\n    }\n\n    .thumb-wraper ul li:nth-child(5) {\n        bottom: 32px\n    }\n\n    .thumb-wraper ul li a {\n        width: 50px;\n        height: 50px\n    }\n}\n\n.testimonial-bx {\n    height: 303px;\n    min-height: 302px;\n    position: relative;\n    border-radius: 40px 0 40px 40px;\n    box-shadow: 0px 0px 30px rgba(185, 67, 0, .1);\n    background-color: var(--bs-dark);\n    padding: 50px;\n    margin: 50px 20px 20px\n}\n\n.testimonial-bx:after {\n    content: \"\";\n    position: absolute;\n    right: 40px;\n    bottom: 20px;\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    font-size: 92px;\n    color: #fff;\n    opacity: .3;\n    line-height: 92px\n}\n\n.testimonial-bx .testimonial-content p {\n    line-height: 28px;\n    font-size: 18px;\n    color: #fff;\n    font-weight: 400;\n    font-style: italic;\n    margin-bottom: 30px\n}\n\n.testimonial-bx .client-info .name {\n    font-weight: 600;\n    color: #fff;\n    margin-bottom: 8px;\n    font-size: 22px\n}\n\n.testimonial-bx .client-info p {\n    font-weight: 600;\n    color: #fff;\n    font-size: 14px;\n    text-transform: uppercase;\n    margin-bottom: 0\n}\n\n.testimonial-bx .quote-icon {\n    position: absolute;\n    top: -50px;\n    left: 50px\n}\n\n.testimonial-bx .quote-icon i {\n    font-size: 36px;\n    color: #008BB1;\n    width: 75px;\n    height: 75px;\n    text-align: center;\n    background-color: #fff;\n    line-height: 75px;\n    border-radius: 20px;\n    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1)\n}\n\n@media only screen and (max-width: 1199px) {\n    .testimonial-bx {\n        border-radius: 30px 0 30px 30px;\n        padding: 50px 30px 30px\n    }\n\n    .testimonial-bx .testimonial-content p {\n        line-height: 26px;\n        font-size: 16px\n    }\n\n    .testimonial-bx .quote-icon {\n        top: -45px;\n        left: 30px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    .testimonial-bx {\n        margin: 50px 0px 0px\n    }\n\n    .testimonial-bx:after {\n        font-size: 50px;\n        line-height: 72px\n    }\n\n    .testimonial-bx .quote-icon {\n        top: -35px\n    }\n\n    .testimonial-bx .quote-icon i {\n        font-size: 28px;\n        width: 65px;\n        height: 65px;\n        line-height: 65px\n    }\n}\n\n.testimonial-slide {\n    padding-bottom: 75px\n}\n\n.testimonial-slide .slick-arrow {\n    height: 50px;\n    width: 50px;\n    border-radius: 12px;\n    background-color: #60eaff;\n    color: #008BB1;\n    font-size: 24px;\n    bottom: 0;\n    top: auto;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    font-size: 0\n}\n\n.testimonial-slide .slick-arrow:before {\n    content: \"\";\n    font-family: \"Line Awesome Free\";\n    font-weight: 900;\n    color: var(--primary);\n    font-size: 24px\n}\n\n.testimonial-slide .slick-arrow:hover {\n    background-color: #008BB1;\n    color: #60eaff\n}\n\n.testimonial-slide .slick-prev {\n    left: 20px\n}\n\n.testimonial-slide .slick-prev:before {\n    content: \"\"\n}\n\n.testimonial-slide .slick-next {\n    right: auto;\n    left: 85px\n}\n\n.testimonial-slide .slick-next:before {\n    content: \"\"\n}\n\n.testimonial-slide .swiper-pagination {\n    right: 30px;\n    display: inline-block;\n    text-align: right;\n    left: auto;\n    width: auto;\n    bottom: 0;\n    color: #f17732;\n    font-weight: 700\n}\n\n.testimonial-slide .swiper-pagination .swiper-pagination-current {\n    font-size: 25px\n}\n\n.testimonial-slide .swiper-pagination .swiper-pagination-total {\n    font-size: 15px;\n    opacity: .5\n}\n\n@media only screen and (max-width: 575px) {\n    .testimonial-slide {\n        padding-bottom: 100px\n    }\n\n    .testimonial-slide .slick-prev {\n        left: 0\n    }\n\n    .testimonial-slide .slick-next {\n        left: 60px\n    }\n\n    .testimonial-slide .swiper-pagination {\n        right: 10px\n    }\n}\n\n.section-area .pt-img1 {\n    bottom: 94px;\n    left: 180px\n}\n\n@media only screen and (max-width: 768px) {\n    .section-area .pt-img1 {\n        top: 94%;\n        left: 30px;\n        width: 70px;\n        height: 70px;\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .section-area .pt-img1 {\n        top: 94%;\n        left: 30px;\n        width: 70px;\n        height: 70px;\n    }\n}\n\n@media only screen and (max-width: 1024px) {\n    .section-area .pt-img1 {\n        top: 93%;\n        left: 30px;\n        width: 70px;\n        height: 70px;\n    }\n}\n\n\n.section-area .pt-img2 {\n    bottom: 110px;\n    left: 150px\n}\n\n@media only screen and (max-width: 1380px) {\n    .section-area .pt-img2 {\n        bottom: 30px;\n        left: 30px\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .section-area .pt-img2 {\n        top: 30px;\n        left: 140px\n    }\n}\n\n.section-area .pt-img3 {\n    bottom: 7%;\n    right: 400px;\n    z-index: 99;\n}\n\n@media only screen and (max-width: 1024px) {\n    .section-area .pt-img3 {\n        top: 92%;\n        right: 40px;\n        z-index: 99;\n\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .section-area .pt-img3 {\n        top: 1370px;\n        right: 10%;\n        z-index: 99;\n    }\n}\n\n.section-area .pt-img4 {\n    top: 5%;\n    right: 160px\n}\n\n@media only screen and (max-width: 1380px) {\n    .section-area .pt-img4 {\n        top: 6%;\n        right: 10%\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .section-area .pt-img3 {\n        top: 94%;\n        right: 10%;\n        z-index: 99;\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .section-area .pt-img4 {\n        top: 22%;\n        right: 10%\n    }\n}\n\n.action-wraper .action-inner {\n    background-color: #565acf;\n    box-shadow: 0 5px 20px rgba(86, 90, 207, .2);\n    border-radius: 20px;\n    padding: 45px\n}\n\n.action-wraper .action-inner .title {\n    font-size: 40px;\n    color: #fff;\n    font-weight: 700;\n    margin-bottom: 15px\n}\n\n.action-wraper .action-inner .text {\n    margin: 0;\n    font-weight: 400;\n    color: #fff\n}\n\n.filter-mobile {\n    display: flex;\n    margin-bottom: 30px;\n    display: none;\n    border: 1px solid rgba(0, 0, 0, .1);\n    align-items: center;\n    text-align: center;\n    position: sticky;\n    top: 80px;\n    background: #fff;\n    box-shadow: 0px 0px 10px 0 rgba(0, 0, 0, .2)\n}\n\n.filter-mobile .filter-bx:first-child {\n    border-right: 1px solid rgba(0, 0, 0, .1)\n}\n\n.filter-mobile .filter-bx {\n    width: 50%;\n    padding: 10px\n}\n\n.filter-btn i {\n    margin-right: 5px\n}\n\n.filter-btn .close {\n    display: none;\n    opacity: 0\n}\n\n.filter-btn .close:hover {\n    background: rgba(255, 255, 255, .1)\n}\n\n.filter-bx .bootstrap-select .dropdown-toggle {\n    max-width: 100px;\n    border: 2px solid rgba(0, 0, 0, .1) !important;\n    border-radius: 4px;\n    padding: 2px 10px;\n    color: #404040;\n    font-weight: 600;\n    height: 32px\n}\n\n.filter-bx .bootstrap-select .dropdown-toggle .caret {\n    top: 9px\n}\n\n.filter-on .filter-btn.close {\n    border: 0;\n    z-index: 1;\n    position: fixed;\n    right: 10px;\n    top: 10px;\n    color: #565acf;\n    opacity: 1;\n    font-size: 18px;\n    display: block;\n    transition: all .5s;\n    -moz-transition: all .5s;\n    -moz-transition: all .5s;\n    -ms-transition: all .5s;\n    -o-transition: all .5s;\n    opacity: 1\n}\n\n.filter-left {\n    padding: 20px 20px;\n    width: 280px;\n    position: fixed !important;\n    left: -310px;\n    top: 0;\n    background: #fff;\n    z-index: 9999999;\n    box-shadow: 0 0 30px 0 rgba(0, 0, 0, .1);\n    overflow-y: scroll;\n    height: 100%;\n    transition: all .5s;\n    -moz-transition: all .5s;\n    -moz-transition: all .5s;\n    -ms-transition: all .5s;\n    -o-transition: all .5s\n}\n\n.filter-left .filter-bar {\n    top: 80px;\n    position: sticky;\n    z-index: 999\n}\n\n.filter-bar.sticky-top .side-bar {\n    z-index: 9;\n    top: 0;\n    position: unset\n}\n\n.sticky-top.filter-bar {\n    z-index: 99999999;\n    top: 80px;\n    position: sticky\n}\n\n.filter-left:after {\n    content: \"\";\n    position: fixed;\n    width: 0;\n    background: #fff;\n    height: 100%;\n    z-index: -1;\n    left: 0;\n    top: 0;\n    opacity: 0;\n    transition: all .5s;\n    -moz-transition: all .5s;\n    -moz-transition: all .5s;\n    -ms-transition: all .5s;\n    -o-transition: all .5s\n}\n\n.filter-left.filter-on:after {\n    width: 100%;\n    left: 280px;\n    opacity: .8\n}\n\n.filter-left.filter-on {\n    left: 0\n}\n\n.filter-bar {\n    top: 80px;\n    position: sticky;\n    z-index: 999\n}\n\n.filter-bar.sticky-top .side-bar {\n    z-index: 9;\n    top: 0;\n    position: unset\n}\n\n.contectus-flex {\n    display: flex;\n    flex-direction: row;\n}\n\n.sticky-top.filter-bar {\n    z-index: 99999999;\n    top: 80px;\n    position: sticky\n}\n\n.pagination-bx .pagination {\n    margin: 0;\n    width: 100%\n}\n\n.pagination {\n    padding: 10px 0;\n    display: block\n}\n\n.pagination li {\n    display: inline-block;\n    padding: 0 4px\n}\n\n.pagination li:first-child,\n.pagination li:last-child {\n    min-width: 103px;\n}\n\n.pagination>li:first-child>a,\n.pagination>li:first-child>span {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n    margin-left: 0;\n}\n\n.pagination>li:last-child>a,\n.pagination>li:last-child>span {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0\n}\n\n.pagination>li>a,\n.pagination>li>span {\n    background-color: #fff;\n    color: #008BB1;\n    padding: 12px 15px;\n    font-weight: 600;\n    font-size: 14px;\n    min-width: 40px;\n    line-height: 1;\n    display: block;\n    border-radius: 8px !important;\n    border: 2px solid rgba(86, 90, 207, .2);\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.pagination>li>a:hover,\n.pagination>li>span:hover {\n    border-color: #008bb1;\n    color: #fff\n}\n\n@media only screen and (max-width: 575px) {\n\n    .pagination>li>a,\n    .pagination>li>span {\n        padding: 10px 15px\n    }\n}\n\n.pagination>.active>a,\n.pagination>.active>span,\n.pagination>.active>a:hover,\n.pagination>.active>span:hover,\n.pagination>.active>a:focus,\n.pagination>.active>span:focus {\n    border-color: rgba(0, 0, 0, 0)\n}\n\n@media only screen and (max-width: 575px) {\n    .pagination li {\n        margin: 0\n    }\n}\n\n.pagination-sm .pagination>li>a,\n.pagination-sm .pagination>li>span .pagination-sm .pagination>.previous>a,\n.pagination-sm .pagination>.next>a {\n    font-size: 12px;\n    padding: 6px 12px\n}\n\n.pagination-lg .pagination>li>a,\n.pagination-lg .pagination>li>span .pagination-lg .pagination>.previous>a,\n.pagination-lg .pagination>.next>a {\n    font-size: 18px;\n    padding: 10px 20px\n}\n\n.pagination-bx.primary .pagination>li>a,\n.pagination-bx.primary .pagination>li>span {\n    background-color: #1abc9c;\n    color: #fff;\n    margin: 0 1px;\n    border: 0\n}\n\n.pagination-bx.primary .pagination>li>a:hover,\n.pagination-bx.primary .pagination>li>span:hover,\n.pagination-bx.primary .pagination>li.active>span,\n.pagination-bx.primary .pagination>li.active>a {\n    background-color: #148f77\n}\n\n.pagination-bx.rounded .pagination>li>a,\n.pagination-bx.rounded .pagination>li>span {\n    border-radius: 30px;\n    margin: 0 1px\n}\n\n.pagination-bx.rounded-sm .pagination>li>a,\n.pagination-bx.rounded-sm .pagination>li>span {\n    border-radius: 4px;\n    margin: 0 1px;\n    display: block;\n    text-transform: uppercase;\n    letter-spacing: 2px\n}\n\n.pagination-bx.gray .pagination>li>a,\n.pagination-bx.gray .pagination>li>span {\n    background-color: #f6f7f8;\n    margin: 0 1px;\n    border: 0\n}\n\n.pagination-bx.gray .pagination>li>a:hover,\n.pagination-bx.gray .pagination>li>span:hover,\n.pagination-bx.gray .pagination>li.active>span,\n.pagination-bx.gray .pagination>li.active>a {\n    background-color: #565acf;\n    color: #fff\n}\n\n.pagination i {\n    font-size: 12px\n}\n\n.pagination li.active a {\n    background-color: #008BB1;\n    color: #fff\n}\n\n.pagination>li.active>a:hover,\n.pagination>li>a:hover,\n.pagination>li>span:hover {\n    color: #fff;\n    background-color: #565acf\n}\n\n.main-banner {\n    position: relative;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    overflow: hidden;\n    z-index: 1;\n    height: 1085px\n}\n\n.main-banner:after {\n    content: \"\";\n    height: 100%;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    position: absolute;\n    background-image: url(./images/main-banner/shape1.png);\n    background-repeat: no-repeat;\n    background-position: bottom left;\n    background-size: 100%;\n    z-index: -1\n}\n\n.main-banner h1,\n.main-banner .h1 {\n    margin-bottom: 50px;\n    font-weight: 800;\n    line-height: 1.3;\n    color: var(--bs-dark);\n    font-size: 55px\n}\n\n.main-banner .btn-lg,\n.main-banner .btn-group-lg>.btn {\n    padding: 20px 45px\n}\n\n.main-banner .title-ext {\n    margin: 0 0 20px;\n    font-size: 21px;\n    font-weight: 700;\n    display: inline-block;\n    padding: 5px 15px;\n    background-position: center;\n    background-repeat: repeat\n}\n\n.main-banner .title-ext.text-primary {\n    background-image: url(./images/shap/ext-blue.png)\n}\n\n.main-banner .title-ext.text-secondary {\n    background-image: url(./images/shap/ext-orange.png)\n}\n\n.main-banner .tag-list li {\n    display: inline-block;\n    margin-right: 8px;\n    position: relative;\n    padding-right: 5px;\n    font-size: 14px;\n    color: var(--bs-dark);\n    font-weight: 600\n}\n\n.main-banner .tag-list li:after {\n    content: \",\";\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    color: #777\n}\n\n.main-banner .tag-list li.title {\n    font-weight: 600\n}\n\n.main-banner .tag-list li.title:after {\n    content: none\n}\n\n.main-banner .tag-list li a {\n    text-transform: capitalize;\n    font-weight: 400;\n    color: #666\n}\n\n.main-banner .tag-list li a:hover {\n    color: #565acf\n}\n\n.main-banner .banner-img {\n    -webkit-animation: up-down 2.5s infinite alternate;\n    animation: up-down 2.5s infinite alternate;\n    position: relative;\n    margin-right: -160px;\n    margin-left: -50px\n}\n\n.main-banner .inner-content {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%)\n}\n\n@media only screen and (max-width: 1680px) {\n    .main-banner {\n        height: 800px\n    }\n\n    .main-banner .banner-img {\n        margin-right: 0;\n        margin-left: 0px\n    }\n\n    .main-banner h1,\n    .main-banner .h1 {\n        margin-bottom: 30px;\n        font-size: 45px\n    }\n\n    .main-banner .title-ext {\n        margin: 0 0 10px;\n        font-size: 18px\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .main-banner {\n        height: 700px\n    }\n\n    .main-banner h1,\n    .main-banner .h1 {\n        margin-bottom: 30px;\n        font-size: 36px\n    }\n\n    .main-banner .title-ext {\n        font-size: 16px;\n        margin: 0 0 15px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .main-banner {\n        height: 500px\n    }\n\n    .main-banner h1,\n    .main-banner .h1 {\n        font-size: 28px;\n        margin-bottom: 20px\n    }\n\n    .main-banner .title-ext {\n        font-size: 14px;\n        margin: 0 0 10px;\n        padding: 3px 10px\n    }\n\n    .main-banner .btn-lg,\n    .main-banner .btn-group-lg>.btn {\n        padding: 12px 24px;\n        font-size: 14px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .main-banner .banner-img {\n        margin-right: -40px;\n        margin-left: -20px\n    }\n\n    .main-banner h1,\n    .main-banner .h1 {\n        font-size: 24px;\n        margin-bottom: 20px\n    }\n\n    .main-banner .main-banner {\n        height: 500px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    .main-banner {\n        height: auto;\n        padding-top: 100px\n    }\n\n    .main-banner .banner-img {\n        margin: 30px 10px\n    }\n\n    .main-banner .inner-content {\n        position: unset;\n        transform: unset\n    }\n}\n\n.main-banner .pt-img1 {\n    bottom: 35%;\n    left: 5%\n}\n\n@media only screen and (max-width: 1380px) {\n    .main-banner .pt-img1 {\n        left: 0%;\n        bottom: 25%\n    }\n}\n\n.main-banner .pt-img2 {\n    top: 24%;\n    left: 51%\n}\n\n@media only screen and (max-width: 991px) {\n    .main-banner .pt-img2 {\n        top: 30%;\n        left: 55%\n    }\n}\n\n.main-banner .pt-img3 {\n    top: 23%;\n    left: 17%\n}\n\n.main-banner .pt-img4 {\n    bottom: 15%;\n    left: 41%;\n    z-index: 1\n}\n\n@media only screen and (max-width: 991px) {\n    .main-banner .pt-img4 {\n        bottom: 10%;\n        left: 45%\n    }\n}\n\n.main-banner .pt-img5 {\n    bottom: 150px;\n    right: 150px\n}\n\n.work-area .pt-img1 {\n    bottom: 15%;\n    left: 5%\n}\n\n.work-area .pt-img2 {\n    top: 50%;\n    right: 5%\n}\n\n@media only screen and (max-width: 991px) {\n    .work-area .pt-img2 {\n        top: 250px;\n        width: 100px;\n        height: 100px;\n        right: 10px\n    }\n}\n\n.work-area .pt-img3 {\n    bottom: 10%;\n    right: 20%\n}\n\n@media only screen and (max-width: 991px) {\n    .work-area .pt-img3 {\n        bottom: 120px;\n        right: 430px\n    }\n}\n\n.work-area .work-bx {\n    margin-top: 30px\n}\n\n@media only screen and (max-width: 991px) {\n    .work-area .work-bx {\n        margin-top: 0\n    }\n}\n\n.work-area .work-bx.active {\n    margin-top: 0\n}\n\n.slider {\n    width: 550px;\n}\n\n@media only screen and (max-width: 576px) {\n    .slider {\n        width: 100%;\n    }\n\n}\n\n.work-bx {\n    position: relative;\n    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);\n    padding: 40px 30px;\n    border-radius: 20px;\n    background-color: #fff;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    overflow: hidden;\n    z-index: 1\n}\n\n.work-bx:after {\n    content: \"\";\n    height: 0;\n    width: 100%;\n    background-color: #008BB1;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: -1;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    transform-origin: top;\n    -moz-transform-origin: top;\n    -ms-transform-origin: top;\n    -webkit-transform-origin: top;\n    -o-transform-origin: top\n}\n\n.work-bx .work-num-bx {\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    z-index: 9;\n    font-size: 80px;\n    font-weight: 900;\n    margin-bottom: 30px;\n    line-height: 80px;\n    -webkit-text-stroke: 2px #f17732;\n    text-shadow: 0 10px 0 #ffe3d3;\n    color: rgba(0, 0, 0, 0)\n}\n\n.work-bx .work-content {\n    transition: all .5s;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.work-bx .work-content p {\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 500;\n    margin-bottom: 30px\n}\n\n.work-bx .btn {\n    font-weight: 600\n}\n\n.work-bx.active:after,\n.work-bx:hover:after {\n    height: 100%;\n    top: auto;\n    bottom: 0;\n    transform-origin: bottom;\n    -moz-transform-origin: bottom;\n    -ms-transform-origin: bottom;\n    -webkit-transform-origin: bottom;\n    -o-transform-origin: bottom;\n    animation-duration: .5s\n}\n\n.work-bx.active .work-num-bx,\n.work-bx:hover .work-num-bx {\n    text-shadow: 0 10px 0 #f38f5e;\n    -webkit-text-stroke: 2px #fff\n}\n\n.work-bx.active .work-content p,\n.work-bx.active .work-content .title,\n.work-bx:hover .work-content p,\n.work-bx:hover .work-content .title {\n    color: #fff !important\n}\n\n.work-bx.active .btn,\n.work-bx:hover .btn {\n    background-color: #fff;\n    border-color: #fff;\n    color: #f17732\n}\n\n.work-bx.active .btn .btn-icon-bx,\n.work-bx:hover .btn .btn-icon-bx {\n    /* background-color: #f17732; */\n    color: #fff\n}\n\n.about-area .pt-img1 {\n    bottom: 20%;\n    left: 16%\n}\n\n@media only screen and (max-width: 1380px) {\n    .about-area .pt-img1 {\n        left: 100px\n    }\n}\n\n.about-area .pt-img2 {\n    bottom: 5%;\n    right: 25%\n}\n\n.about-area .pt-img3 {\n    top: 30%;\n    right: 7%\n}\n\n.about-area .pt-img4 {\n    bottom: 10%;\n    right: 1%\n}\n\n.about-area .pt-img5 {\n    top: 25%;\n    left: 5%\n}\n\n@media only screen and (max-width: 1380px) {\n    .about-area .pt-img5 {\n        left: 35px\n    }\n}\n\n.about-thumb-area {\n    margin-right: 30px;\n    position: relative\n}\n\n.about-thumb-area ul {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -20px\n}\n\n.about-thumb-area ul li {\n    display: inline-flex;\n    padding: 0 10px;\n    margin-bottom: 20px\n}\n\n.about-thumb-area ul li:nth-child(1),\n.about-thumb-area ul li:nth-child(3) {\n    width: 45%\n}\n\n.about-thumb-area ul li:nth-child(2),\n.about-thumb-area ul li:nth-child(4) {\n    width: 55%\n}\n\n.about-thumb-area .about-thumb1 {\n    border-radius: 0 60px 60px;\n    margin-top: auto;\n    margin-left: auto\n}\n\n.about-thumb-area .about-thumb2 {\n    border-radius: 60px 0 60px 60px;\n    margin-top: auto;\n    margin-right: auto\n}\n\n.about-thumb-area .about-thumb3 {\n    border-radius: 60px 60px 60px 0;\n    margin-bottom: auto;\n    margin-left: auto\n}\n\n.about-thumb-area .about-thumb4 {\n    border-radius: 60px 60px 0px 60px;\n    margin-bottom: auto;\n    margin-left: auto\n}\n\n.about-thumb-area .exp-bx {\n    background-color: #e6e7ff;\n    border-radius: 60px 60px 0px 60px;\n    padding: 60px 0px 30px;\n    text-align: center;\n    line-height: 75px;\n    font-size: 120px;\n    font-weight: 800;\n    position: relative;\n    display: block;\n    color: #008BB1;\n    z-index: 2;\n    width: 220px\n}\n\n.about-thumb-area .exp-bx span {\n    display: block;\n    font-size: 18px;\n    color: var(--bs-dark)\n}\n\n.about-thumb-area .exp-bx:after {\n    content: \"\";\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    width: 100%;\n    height: 100%;\n    border: 2px solid #565acf;\n    border-radius: 60px 60px 0px 60px;\n    z-index: -1\n}\n\n.about-thumb-area:after {\n    content: \"\";\n    position: absolute;\n    top: 49%;\n    left: 40%;\n    width: 50px;\n    height: 50px;\n    background-color: #008BB1;\n    border-radius: 15px;\n    transform: rotate(45deg)\n}\n\n@media only screen and (max-width: 1199px) {\n    .about-thumb-area {\n        margin-right: 0\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .about-thumb-area:after {\n        top: 51%;\n        left: 41%\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .about-thumb-area:after {\n        top: 48%;\n        left: 40%\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    .about-thumb-area {\n        margin: 0 15px\n    }\n\n    .about-thumb-area ul {\n        margin: 0 -10px\n    }\n\n    .about-thumb-area ul li {\n        padding: 0 5px;\n        margin-bottom: 10px\n    }\n\n    .about-thumb-area .about-thumb2 {\n        border-radius: 30px 0 30px 30px\n    }\n\n    .about-thumb-area .about-thumb3 {\n        border-radius: 30px 30px 30px 0\n    }\n\n    .about-thumb-area .about-thumb1 {\n        border-radius: 0 30px 30px\n    }\n\n    .about-thumb-area .exp-bx {\n        padding: 50px 0px 20px;\n        border-radius: 30px 30px 0px 30px;\n        line-height: 55px;\n        font-size: 70px;\n        width: 85%\n    }\n\n    .about-thumb-area .exp-bx:after {\n        border-radius: 30px 30px 0px 30px;\n        top: 8px;\n        left: 8px\n    }\n\n    .about-thumb-area .exp-bx span {\n        font-size: 12px\n    }\n\n    .about-thumb-area:after {\n        top: 43%;\n        left: 41%;\n        width: 25px;\n        height: 25px;\n        border-radius: 5px\n    }\n}\n\n.account-wraper1 {\n    padding-bottom: 100px;\n\n}\n\n.account-wraper1 .appointment-inner {\n    background-color: #f5f5fc;\n    border-radius: 40px;\n    position: relative;\n    z-index: 1\n}\n\n@media only screen and (max-width: 767px) {\n    .account-wraper1 {\n        background-color: #f5f5fc\n    }\n}\n\n.account-wraper1 .pt-img1 {\n    top: 100px;\n    left: 70px\n}\n\n@media only screen and (max-width: 991px) {\n    .account-wraper1 .pt-img1 {\n        top: 190px;\n        left: 10px\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .account-wraper1 .pt-img1 {\n        top: 50px;\n        left: 50px\n    }\n}\n\n.account-wraper1 .pt-img2 {\n    left: -90px;\n    bottom: 150px\n}\n\n@media only screen and (max-width: 991px) {\n    .account-wraper1 .pt-img2 {\n        left: -60px;\n        bottom: 50px\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .account-wraper1 .pt-img2 {\n        left: -60px;\n        bottom: -40px\n    }\n}\n\n.account-wraper1 .pt-img3 {\n    right: -70px;\n    top: 50px\n}\n\n@media only screen and (max-width: 1680px) {\n    .account-wraper1 .pt-img3 {\n        right: 20px;\n        top: -30px\n    }\n}\n\n.account-wraper1 .pt-img4 {\n    right: -40px;\n    bottom: 150px\n}\n\n@media only screen and (max-width: 1680px) {\n    .account-wraper1 .pt-img4 {\n        right: 30px;\n        bottom: -30px\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .account-wraper1 {\n        padding-bottom: 70px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .account-wraper1 {\n        padding-bottom: 50px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .account-wraper1 {\n        padding-bottom: 0\n    }\n}\n\n@media only screen and (max-width: 575px) {\n\n    .account-wraper1 .container-fluid,\n    .account-wraper1 .container-sm,\n    .account-wraper1 .container-md,\n    .account-wraper1 .container-lg,\n    .account-wraper1 .container-xl {\n        padding-left: 0;\n        padding-right: 0\n    }\n}\n\n.flex-form-group {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n}\n\n.form-wraper .form-group {\n    margin-bottom: 20px\n}\n\n.form-wraper .form-select.bootstrap-select {\n    padding: 0;\n    border: 0\n}\n\n.form-wraper .form-select.bootstrap-select .dropdown-toggle {\n    border: 1px solid;\n    border-color: rgba(86, 90, 207, .3);\n    border-radius: 8px;\n    height: 60px;\n    font-weight: 500;\n    font-size: 16px;\n    color: #444;\n    padding: 18px 25px;\n    margin-top: 0\n}\n\n.form-wraper .form-select.bootstrap-select .dropdown-toggle:after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    font-family: \"Line Awesome Free\";\n    right: 20px;\n    font-weight: 900;\n    border: 0;\n    transform: translateY(-50%);\n    color: #9a9ccc\n}\n\n.form-wraper .form-select.bootstrap-select .dropdown-menu {\n    box-shadow: 0 2px 20px rgba(0, 0, 0, .1)\n}\n\n.form-wraper .form-select.bootstrap-select .dropdown-menu .dropdown-item {\n    padding: 10px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--bs-dark);\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.form-wraper .form-select.bootstrap-select .dropdown-menu .dropdown-item:hover {\n    background-color: #565acf;\n    color: #fff\n}\n\n.form-wraper .form-select.bootstrap-select .dropdown-item.active.selected {\n    color: #fff\n}\n\n.form-wraper .form-select.bootstrap-select .dropdown-item.active.selected:hover {\n    background-color: #565acf\n}\n\n.form-wraper .form-control {\n    border: 1px solid;\n    border-color: rgba(86, 90, 207, .3);\n    border-radius: 8px;\n    height: 60px;\n    font-weight: 500;\n    font-size: 16px;\n    color: #000\n}\n\n.form-wraper .form-control:active,\n.form-wraper .form-control:focus,\n.form-wraper .form-control:hover {\n    border-color: #565acf\n}\n\n.form-wraper .form-control::-webkit-input-placeholder {\n    color: #444\n}\n\n.form-wraper .form-control:-ms-input-placeholder {\n    color: #444\n}\n\n.form-wraper .form-control::placeholder {\n    color: #444\n}\n\n.form-wraper textarea.form-control {\n    height: 150px\n}\n\n@media only screen and (max-width: 991px) {\n    .form-wraper .form-group {\n        margin-bottom: 15px\n    }\n}\n\n.appointment-form {\n    background-color: #fff;\n    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);\n    border-radius: 40px;\n    padding: 40px 35px;\n    text-align: center;\n    position: relative\n}\n\n.appointment-form .title {\n    margin-bottom: 30px\n}\n\n.appointment-form button {\n    margin-top: 15px\n}\n\n.appointment-form:after {\n    content: \"\";\n    position: absolute;\n    top: -20px;\n    left: -20px;\n    border-radius: 40px;\n    width: 100%;\n    height: 100%;\n    border: 2px solid #008bb1;\n    z-index: -1\n}\n\n@media only screen and (max-width: 1380px) {\n    .appointment-form {\n        margin-left: 50px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .appointment-form {\n        margin-left: 20px;\n        padding: 30px;\n        border-radius: 20px\n    }\n\n    .appointment-form:after {\n        top: -15px;\n        left: -15px;\n        border-radius: 20px\n    }\n\n    .appointment-form .title {\n        margin-bottom: 20px;\n        font-size: 20px\n    }\n\n    .appointment-form .form-group {\n        margin-bottom: 15px\n    }\n\n    .appointment-form button {\n        margin-top: 5px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    .appointment-form {\n        margin-left: 10px;\n        border-radius: 20px;\n        padding: 20px\n    }\n\n    .appointment-form .form-control {\n        height: 50px;\n        font-size: 14px;\n        padding: 12px 18px\n    }\n\n    .appointment-form .form-select.bootstrap-select .dropdown-toggle {\n        height: 50px;\n        font-size: 14px;\n        padding: 15px 18px\n    }\n\n    .appointment-form:after {\n        top: -10px;\n        left: -10px;\n        border-radius: 20px\n    }\n}\n\n.appointment-thumb {\n    position: relative;\n    width: 730px;\n    margin-left: 70px\n}\n\n.appointment-thumb .images-group img {\n    position: absolute\n}\n\n.appointment-thumb .images-group .img1 {\n    right: 16px;\n    bottom: 16px;\n    height: 530px;\n    -webkit-animation: left-right 2s infinite alternate;\n    animation: left-right 2s infinite alternate\n}\n\n@media only screen and (max-width: 1199px) {\n    .appointment-thumb .images-group .img1 {\n        right: 10px;\n        bottom: 14px;\n        height: 430px\n    }\n}\n\n.appointment-thumb .images-group .img2 {\n    left: 80px;\n    bottom: 255px;\n    width: 130px;\n    -webkit-animation: up-down 2s infinite alternate;\n    animation: up-down 2.3s infinite alternate\n}\n\n@media only screen and (max-width: 1199px) {\n    .appointment-thumb .images-group .img2 {\n        left: 60px;\n        bottom: 200px;\n        width: 100px\n    }\n}\n\n.appointment-thumb .images-group .img3 {\n    right: 260px;\n    bottom: 120px;\n    width: 94px;\n    -webkit-animation: up-down 2.5s infinite alternate;\n    animation: up-down 2.5s infinite alternate\n}\n\n@media only screen and (max-width: 1199px) {\n    .appointment-thumb .images-group .img3 {\n        right: 166px;\n        bottom: 90px;\n        width: 85px\n    }\n}\n\n.appointment-thumb .images-group .img4 {\n    left: 20px;\n    top: 150px;\n    -webkit-animation: up-down 1.5s infinite alternate;\n    animation: up-down 1.5s infinite alternate\n}\n\n@media only screen and (max-width: 1199px) {\n    .appointment-thumb .images-group .img4 {\n        left: 10px;\n        top: 80px\n    }\n}\n\n.appointment-thumb .images-group .img5 {\n    right: 70px;\n    top: 30px;\n    -webkit-animation: up-down 2s infinite alternate;\n    animation: up-down 2s infinite alternate\n}\n\n@media only screen and (max-width: 1380px) {\n    .appointment-thumb .images-group .img1 {\n        height: 400px;\n        right: 20px\n    }\n\n    .appointment-thumb .images-group .img2 {\n        left: 93px;\n        width: 80px;\n        bottom: 240px\n    }\n\n    .appointment-thumb .images-group .img3 {\n        right: 225px;\n        width: 70px\n    }\n\n    .appointment-thumb .images-group .img4 {\n        left: 40px;\n        width: 50px\n    }\n\n    .appointment-thumb .images-group .img5 {\n        right: 80px;\n        width: 80px\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .appointment-thumb .images-group .img1 {\n        height: 280px\n    }\n\n    .appointment-thumb .images-group .img2 {\n        left: 62px;\n        width: 60px;\n        bottom: 170px\n    }\n\n    .appointment-thumb .images-group .img3 {\n        right: 154px;\n        width: 50px\n    }\n\n    .appointment-thumb .images-group .img4 {\n        left: 20px;\n        width: 40px\n    }\n\n    .appointment-thumb .images-group .img5 {\n        right: 70px;\n        width: 70px;\n        top: 60px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .appointment-thumb .images-group .img1 {\n        height: 180px\n    }\n\n    .appointment-thumb .images-group .img2 {\n        left: 39px;\n        width: 50px;\n        bottom: 110px\n    }\n\n    .appointment-thumb .images-group .img3 {\n        right: 110px;\n        width: 40px\n    }\n\n    .appointment-thumb .images-group .img4 {\n        left: 15px;\n        width: 30px\n    }\n\n    .appointment-thumb .images-group .img5 {\n        right: 30px;\n        width: 60px;\n        top: 40px\n    }\n}\n\n@media only screen and (max-width: 1380px) {\n    .appointment-thumb {\n        width: 650px;\n        margin-left: 0\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .appointment-thumb {\n        width: 100%;\n        padding-left: 0\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .appointment-thumb {\n        width: 320px;\n        margin: 30px auto 0\n    }\n}\n\n.account-wraper2 {\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    background-color: #f5f5fc\n}\n\n.account-wraper2 .appointment-form {\n    padding: 50px 40px\n}\n\n.account-wraper2 .appointment-form button {\n    margin-top: 0\n}\n\n.account-wraper2 .logo {\n    margin-bottom: 30px\n}\n\n@media only screen and (max-width: 767px) {\n    .account-wraper2 .appointment-form {\n        padding: 30px\n    }\n}\n\n.blog-card {\n    border: 2px solid #008BB1;\n    background-color: #fff;\n    border-radius: 10px;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    padding: 20px;\n    cursor: pointer;\n}\n\n.blog-card .post-media {\n    border-radius: 6px;\n    overflow: hidden;\n    margin-bottom: 20px;\n    min-height: 237px;\n    height: 237px;\n    border: 1px solid #f6f6f6;\n}\n\n.blog-detail-card .post-media {\n    min-height: 480px !important;\n    height: 480px !important;\n}\n\n\n\n.blog-card .post-media img {\n    width: 100%;\n}\n\n.blog-card .post-title {\n    margin-bottom: 25px;\n    -webkit-line-clamp: 2;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n\n}\n\n\n\n.blog-card .post-info {\n    padding: 12px\n}\n\n@media only screen and (max-width: 991px) {\n    .blog-card {\n        padding: 15px\n    }\n\n    .blog-card .post-info {\n        padding: 5px 5px 10px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    .blog-card {\n        padding: 10px\n    }\n\n    .blog-card .post-title {\n        margin-bottom: 20px\n    }\n}\n\n.blog-card:hover {\n    box-shadow: 0px 10px 30px 0px rgba(31, 34, 120, .1);\n    border: 2px solid #565acf;\n}\n\n.post-meta {\n    align-items: center;\n    margin-bottom: 15px;\n    display: flex;\n    flex-wrap: wrap\n}\n\n.post-meta li {\n    display: inline-block;\n    position: relative;\n    font-size: 14px;\n    margin-right: 19px;\n    color: var(--bs-dark);\n    line-height: 1\n}\n\n.post-meta li:last-child {\n    margin-right: 0\n}\n\n.post-meta li.author a {\n    display: flex;\n    align-items: center\n}\n\n.post-meta li img {\n    border-radius: 30px;\n    height: 30px;\n    width: 30px;\n    display: inline-block;\n    margin-right: 10px\n}\n\n.post-meta li i {\n    font-size: 18px;\n    margin-right: 5px\n}\n\n.post-meta li a {\n    color: var(--bs-dark)\n}\n\n.blog-slide {\n    margin-top: -15px\n}\n\n.blog-slide .blog-card {\n    margin: 15px\n}\n\n@media only screen and (min-width: 1199px) {\n    .blog-slide .slick-active.slick-current+.slick-active .blog-card {\n        box-shadow: 0px 10px 30px 0px rgba(31, 34, 120, .1);\n        border: 2px solid #008bb1;\n    }\n}\n\n.blog-slide .swiper-slide {\n    margin-bottom: 10px\n}\n\n@media only screen and (max-width: 575px) {\n    .blog-slide .blog-card {\n        margin: 5px\n    }\n}\n\n.blog-area .pt-img1 {\n    top: 200px;\n    left: 100px\n}\n\n@media only screen and (max-width: 991px) {\n    .blog-area .pt-img1 {\n        top: 170px;\n        left: 30px\n    }\n}\n\n.blog-area .pt-img2 {\n    bottom: 50px;\n    left: 150px\n}\n\n@media only screen and (max-width: 991px) {\n    .blog-area .pt-img2 {\n        bottom: -50px;\n        left: 90px\n    }\n}\n\n.blog-area .pt-img3 {\n    top: 120px;\n    right: 200px\n}\n\n@media only screen and (max-width: 991px) {\n    .blog-area .pt-img3 {\n        top: 100px;\n        right: 20px\n    }\n}\n\n.blog-area .pt-img4 {\n    bottom: 40px;\n    right: 100px\n}\n\n@media only screen and (max-width: 991px) {\n    .blog-area .pt-img4 {\n        bottom: 30px;\n        right: 50px\n    }\n}\n\n.blog-area .blog-bg-5 {\n    position: absolute;\n    top: 60px;\n    left: 0;\n    z-index: -1;\n    opacity: .2;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat\n}\n\n.blog-area .blog-bg-5 svg {\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat\n}\n\n[class*=pt-img] {\n    position: absolute;\n    user-select: none;\n    z-index: -1\n}\n\n@media only screen and (max-width: 767px) {\n    [class*=pt-img] {\n        display: none\n    }\n}\n\n.animate1 {\n    -webkit-animation: up-down 1.5s infinite alternate;\n    animation: up-down 1.5s infinite alternate\n}\n\n@media only screen and (max-width: 1380px) {\n    .animate1 {\n        width: 80px\n    }\n}\n\n.animate2 {\n    -webkit-animation: up-down 2s infinite alternate;\n    animation: up-down 2s infinite alternate\n}\n\n.animate-rotate {\n    -webkit-animation: rotation 20s infinite linear;\n    animation: rotation 20s infinite linear\n}\n\n.animate-wave {\n    -webkit-animation: left-right 1.5s infinite alternate;\n    animation: left-right 1.5s infinite alternate\n}\n\n@media only screen and (max-width: 1380px) {\n    .animate-wave {\n        width: 100px\n    }\n}\n\n@-webkit-keyframes rotation {\n    0% {\n        -webkit-transform: rotate(0deg)\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg)\n    }\n}\n\n@keyframes rotation {\n    0% {\n        transform: rotate(0deg)\n    }\n\n    100% {\n        transform: rotate(360deg)\n    }\n}\n\n@-webkit-keyframes move {\n    0% {\n        -webkit-transform: translate(0);\n        transform: translate(0)\n    }\n\n    25% {\n        -webkit-transform: translate(10px, 10px);\n        transform: translate(10px, 10px)\n    }\n\n    50% {\n        -webkit-transform: translate(5px, 5px);\n        transform: translate(5px, 5px)\n    }\n\n    75% {\n        -webkit-transform: translate(10px, -5px);\n        transform: translate(10px, -5px)\n    }\n\n    100% {\n        -webkit-transform: translate(0);\n        transform: translate(0)\n    }\n}\n\n@-webkit-keyframes up-down {\n    0% {\n        transform: translatey(0)\n    }\n\n    100% {\n        transform: translatey(-10px)\n    }\n}\n\n@keyframes up-down {\n    0% {\n        transform: translatey(0)\n    }\n\n    100% {\n        transform: translatey(-10px)\n    }\n}\n\n@-webkit-keyframes left-right {\n    0% {\n        transform: translateX(0)\n    }\n\n    100% {\n        transform: translateX(-10px)\n    }\n}\n\n@keyframes left-right {\n    0% {\n        transform: translateX(0)\n    }\n\n    100% {\n        transform: translateX(-10px)\n    }\n}\n\n@keyframes vibrate {\n\n    10%,\n    90% {\n        transform: translate3d(-1px, 0, 0)\n    }\n\n    20%,\n    80% {\n        transform: translate3d(2px, 0, 0)\n    }\n\n    30%,\n    50%,\n    70% {\n        transform: translate3d(-4px, 0, 0)\n    }\n\n    40%,\n    60% {\n        transform: translate3d(4px, 0, 0)\n    }\n}\n\n@keyframes up-down2 {\n    0% {\n        transform: translate(-50px)\n    }\n\n    50% {\n        transform: translateX(80px) translateY(-200px)\n    }\n\n    100% {\n        transform: translate(-50px)\n    }\n}\n\n.team-member {\n    background-color: #fff;\n    text-align: center;\n    padding: 35px 40px 50px;\n    border-radius: 20px;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    z-index: 1;\n    position: relative;\n    border: 2px solid;\n    border-color: rgba(86, 90, 207, .2)\n}\n\n.team-member .team-info .team-info-comntent {\n    margin-bottom: 25px\n}\n\n.team-member .team-info .team-info-comntent span {\n    font-size: 16px;\n    font-weight: 600\n}\n\n.team-member .team-media {\n    padding: 20%;\n    position: relative;\n    margin-bottom: 20px\n}\n\n.team-member .team-media img {\n    -webkit-mask-image: url(./images/team/shape3.png);\n    mask-image: url(./images/team/shape3.png);\n    -webkit-mask-position: center center;\n    mask-position: center center;\n    -webkit-mask-repeat: no-repeat;\n    mask-repeat: no-repeat;\n    -webkit-mask-size: 100%;\n    mask-size: 100%;\n    padding-top: 40px;\n}\n\n.team-member .team-media:after,\n.team-member .team-media:before {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    opacity: .2;\n    transform: translate(-50%, -50%);\n    top: 50%;\n    left: 50%\n}\n\n.team-member .team-media:after {\n    background-image: url(./images/team/shape1.png);\n    background-size: 100%\n}\n\n.team-member .team-media:before {\n    background-image: url(./images/team/shape2.png);\n    background-size: 77%\n}\n\n.team-member .social-media {\n    display: flex;\n    justify-content: center;\n    margin: 0 -6px\n}\n\n.team-member .social-media li {\n    display: inline-block;\n    padding: 0 6px\n}\n\n.team-member .social-media li a {\n    display: block;\n    height: 40px;\n    width: 40px;\n    background-color: #008BB1;\n    border-radius: 8px;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    color: #fff;\n    line-height: 42px;\n    text-align: center;\n    box-shadow: 0px 10px 40px 0px rgba(31, 34, 120, .1)\n}\n\n.team-member.active,\n.team-member:hover {\n    box-shadow: 0px 10px 50px 0px rgba(0, 2, 72, .1);\n    z-index: 9;\n    border-color: #fff\n}\n\n.team-member.active .team-media:before,\n.team-member.active .team-media:after,\n.team-member:hover .team-media:before,\n.team-member:hover .team-media:after {\n    opacity: 1\n}\n\n@media only screen and (max-width: 767px) {\n    .team-member {\n        padding: 20px 30px 30px\n    }\n}\n\n.team-wraper .pt-img1 {\n    top: 15%;\n    left: 10%\n}\n\n.team-wraper .pt-img2 {\n    bottom: 30%;\n    left: 5%\n}\n\n@media only screen and (max-width: 1380px) {\n    .team-wraper .pt-img2 {\n        left: 1%\n    }\n}\n\n.team-wraper .pt-img3 {\n    bottom: -50px;\n    left: 58%\n}\n\n.team-wraper .pt-img4 {\n    top: 10%;\n    right: 25%\n}\n\n.team-wraper .pt-img5 {\n    top: 50%;\n    right: 5%\n}\n\n@media only screen and (max-width: 1380px) {\n    .team-wraper .pt-img5 {\n        right: 1%\n    }\n}\n\n.service-menu {\n    position: relative;\n    background-color: #fff;\n    border-radius: 6px 6px 4px 4px !important;\n    padding: 30px 30px;\n    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);\n    border: 1px solid rgba(86, 90, 207, .2);\n    border-width: 1px 1px 3px 1px;\n    border-bottom-color: #565acf\n}\n\n.service-menu li {\n    margin-bottom: 10px\n}\n\n.service-menu li a {\n    display: block;\n    padding: 15px 50px 15px 20px;\n    text-transform: capitalize;\n    font-weight: 600;\n    position: relative;\n    z-index: 1;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    color: #fff;\n    font-weight: 500;\n    font-size: 16px;\n    border-radius: 8px;\n    background-color: #565acf\n}\n\n.service-menu li a i {\n    font-size: 18px;\n    text-align: center;\n    border-radius: 35px;\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    width: 38px;\n    height: 38px;\n    line-height: 38px;\n    background: #fff;\n    border-radius: inherit;\n    display: inline-block;\n    color: #565acf\n}\n\n.service-menu li:last-child {\n    margin-bottom: 0\n}\n\n.service-menu li.active a,\n.service-menu li:hover a {\n    background-color: #f17732\n}\n\n.service-menu li.active a i,\n.service-menu li:hover a i {\n    color: #f17732\n}\n\n.service-menu.style-1 li a i {\n    font-size: 24px\n}\n\n@media only screen and (max-width: 1199px) {\n    .service-menu {\n        padding: 15px\n    }\n}\n\n.left-border-1 {\n    padding-left: 30px;\n    border-left: 1px solid rgba(0, 0, 0, .1)\n}\n\n.contact-infolist {\n    margin: 0 0 40px;\n    padding: 25px 0 5px;\n    list-style: none;\n    border-top: 1px solid rgba(0, 0, 0, .1);\n    border-bottom: 1px solid rgba(0, 0, 0, .1)\n}\n\n.contact-infolist li {\n    position: relative;\n    padding: 0 20px 20px 80px\n}\n\n.contact-infolist li img {\n    position: absolute;\n    left: 0;\n    top: 10px;\n    width: 60px\n}\n\n.contact-infolist li .contact-title {\n    color: #020d26;\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 600;\n    margin-bottom: 2px\n}\n\n.contact-infolist li a,\n.contact-infolist li p {\n    font-size: 16px;\n    line-height: 24px;\n    color: #555;\n    font-weight: 400;\n    margin-bottom: 5px\n}\n\nbutton.back-to-top {\n    border-style: solid;\n    border-width: 0;\n    bottom: 15px;\n    box-shadow: 0px 10px 30px 0px rgba(31, 34, 120, .1);\n    color: #fff;\n    background-color: #008BB1;\n    border-radius: 8px;\n    cursor: pointer;\n    height: 45px;\n    margin: 0;\n    position: fixed;\n    right: 15px;\n    text-align: center;\n    width: 45px;\n    z-index: 999;\n    padding: 0;\n    font-size: 12px\n}\n\n@media only screen and (max-width: 575px) {\n    button.back-to-top {\n        height: 35px;\n        width: 35px\n    }\n}\n\n.mfp-bg {\n    z-index: 999999\n}\n\n.mfp-wrap {\n    z-index: 9999999\n}\n\n.card-img-servic img {\n    border-radius: 5px;\n}\n\n.service-wraper {\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n    padding-left: calc((100% - 1200px)/2);\n    margin-bottom: 50px;\n\n}\n\n.service-wraper:after {\n    content: \"\";\n    background-color: #008BB1;\n    height: 100%;\n    width: 45%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: -1;\n    border-radius: 40px 0 0 40px\n}\n\n.service-wraper .pt-img1 {\n    top: 60px;\n    left: 80px;\n    opacity: .2\n}\n\n@media only screen and (max-width: 991px) {\n    .service-wraper .pt-img1 {\n        top: 10px;\n        left: 80px\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .service-wraper .pt-img1 {\n        top: 20px;\n        left: 80px\n    }\n}\n\n.service-wraper .pt-img2 {\n    bottom: 150px;\n    left: 140px\n}\n\n@media only screen and (max-width: 1380px) {\n    .service-wraper .pt-img2 {\n        bottom: 50px;\n        left: 150px\n    }\n}\n\n.service-wraper .pt-img3 {\n    bottom: 60px;\n    left: 50%\n}\n\n@media only screen and (max-width: 991px) {\n    .service-wraper .pt-img3 {\n        display: none\n    }\n}\n\n.service-wraper .pt-img4 {\n    top: 10px;\n    left: 40%\n}\n\n.service-wraper .feature-container {\n    margin: 15px\n}\n\n.service-wraper .slick-slider {\n    margin-right: -100px\n}\n\n@media only screen and (max-width: 1380px) {\n    .service-wraper {\n        padding-left: 30px;\n        padding-right: 30px\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .service-wraper .slick-slider {\n        margin-right: -15px;\n        margin-left: -15px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .service-wraper:after {\n        width: 100%;\n        border-radius: 0\n    }\n\n    .service-wraper .heading-bx .title,\n    .service-wraper .heading-bx p {\n        color: #fff\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .service-wraper {\n        padding-left: 15px;\n        padding-right: 15px\n    }\n}\n\n.service-wraper2 {\n    background-color: rgba(86, 90, 207, .1)\n}\n\n.contact-banner .page-banner-entry {\n    padding-bottom: 140px\n}\n\n.contact-wraper {\n    background-color: #fff;\n    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);\n    border-radius: 40px;\n    padding: 70px 50px 40px;\n    position: relative;\n    margin-top: -150px\n}\n\n.contact-wraper .contact-form .form-group {\n    margin-bottom: 30px\n}\n\n@media only screen and (max-width: 575px) {\n    .contact-wraper .contact-form .form-group {\n        margin-bottom: 20px\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .contact-wraper {\n        padding: 50px 40px 20px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    .contact-wraper {\n        padding: 30px 30px 0px;\n        border-radius: 20px\n    }\n}\n\n.card {\n    border: 1px solid rgba(0, 0, 0, .125);\n    border-radius: .25rem;\n    background: #fcfcfc;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n    margin-bottom: 20px;\n}\n\n.card-body {\n    padding: 10px;\n}\n\n.contact-info {\n    padding: 50px 50px 30px;\n    color: #fff;\n    overflow: hidden;\n    border-radius: 8px;\n    height: 100%;\n    /* width: 1200px; */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    /* margin-left: 50px */\n}\n\n.contact-info .info-inner {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    z-index: 1\n}\n\n.contact-info .info-inner .title {\n    color: #fff\n}\n\n.contact-info .social-media {\n    margin: 0 -3px\n}\n\n.contact-info .social-media li {\n    display: inline-block;\n    padding: 0 3px\n}\n\n.contact-info .social-media li a {\n    color: #565acf;\n    background-color: #fff\n}\n\n.contact-info .icon-box {\n    margin-right: 100px;\n    margin-bottom: 30px\n}\n\n.contact-info .icon-box p {\n    font-size: 14px\n}\n\n.flex-cards-service {\n    display: flex;\n    flex-direction: row;\n    gap: 80px;\n    justify-content: center;\n    padding: 15px 20px;\n    margin-top: 30px !important;\n}\n\n@media only screen and (max-width: 1199px) {\n    .flex-cards-service {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        justify-content: space-evenly;\n        padding: 15px 20px;\n    }\n}\n\n\n.contact-info .icon-box .title {\n    margin-bottom: 12px;\n    border-bottom: 2px solid rgba(255, 255, 255, .2);\n    padding-bottom: 10px;\n    display: flex;\n    align-items: center;\n    text-transform: capitalize;\n    font-size: 18px;\n    font-weight: 600\n}\n\n.contact-info .icon-box .title i {\n    font-size: 24px;\n    margin-right: 10px;\n    color: #fff\n}\n\n@media only screen and (max-width: 1199px) {\n    .contact-info {\n        margin-left: 0\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    .contact-info {\n        padding: 30px 30px 0px\n    }\n\n    .contact-info .icon-box {\n        margin-right: 0\n    }\n}\n\n@media only screen and (max-width: 575px) {\n\n    #rc-imageselect,\n    .g-recaptcha {\n        transform-origin: 0 0;\n        -moz-transform-origin: 0 0;\n        -o-transform-origin: 0 0;\n        -webkit-transform-origin: 0 0;\n        transform: scale(0.8);\n        -moz-transform: scale(0.8);\n        -o-transform: scale(0.8);\n        -webkit-transform: scale(0.8);\n        margin-bottom: -15px\n    }\n}\n\n.social-media {\n    margin: 0 -3px\n}\n\n.social-media li {\n    display: inline-block;\n    padding: 0 3px\n}\n\n.social-media li a {\n    display: block;\n    height: 40px;\n    width: 40px;\n    line-height: 40px;\n    background-color: #008BB1;\n    color: #fff;\n    text-align: center;\n    border-radius: 8px;\n    box-shadow: 0px 10px 40px 0px rgba(31, 34, 120, .1);\n    font-size: 16px;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.social-media li a:hover {\n    color: #fff;\n    background-color: #f17732\n}\n\n.skillbar-box .title {\n    margin-bottom: 0\n}\n\n.skillbar-box .skillbar {\n    position: relative;\n    display: inline-block;\n    background: rgba(0, 0, 0, .15);\n    height: 6px;\n    width: 100%;\n    text-align: left;\n    border-radius: 10px\n}\n\n.skillbar-box .skillbar-bar {\n    height: 6px;\n    border-radius: 10px;\n    width: 0px;\n    background: #565acf;\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    margin-bottom: 0px;\n    overflow: unset !important\n}\n\n.skillbar-box .skillbar-bar:after {\n    content: \"\";\n    border-radius: 15px;\n    background: #fff;\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    right: -5px;\n    border: 3px solid #565acf;\n    top: -8px\n}\n\n.skillbar-box .skill-bar-percent {\n    position: absolute;\n    top: -35px;\n    right: 0;\n    color: #565acf;\n    font-weight: 700;\n    font-size: 16px\n}\n\n.skillbar-box .skill-bar-text {\n    top: -22px;\n    position: absolute\n}\n\n.skillbar-box .skillbar-bar-main {\n    padding: 30px 30px 20px 30px;\n    border: 1px solid rgba(0, 0, 0, .1);\n    background: #f3f3f3\n}\n\n.skillbar-box .skillbar-box {\n    margin-bottom: 25px\n}\n\n.skillbar-box .skillbar-bar-main.white .title {\n    color: #fff\n}\n\n.skillbar-box .skillbar-bar-main.white .skillbar {\n    background: rgba(255, 255, 255, .15)\n}\n\n.skillbar-box .skillbar-bar-main.white .skillbar-bar {\n    background: #f17732\n}\n\n.skillbar-box .skillbar-bar-main.white .skill-bar-percent {\n    color: #f17732\n}\n\n.service-wraper3 {\n    position: relative\n}\n\n.service-wraper3:before {\n    content: \"\";\n    border-radius: 50%;\n    position: absolute;\n    height: 250px;\n    width: 250px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: rgba(86, 90, 207, .1);\n    z-index: -1\n}\n\n.slick-arrow-none .slick-arrow {\n    display: none !important\n}\n\n.help-bx {\n    position: relative;\n    border-radius: 8px;\n    overflow: hidden\n}\n\n.help-bx .info {\n    padding: 70px 50px;\n    text-align: center;\n    z-index: 1;\n    background-color: rgba(86, 90, 207, .9);\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%\n}\n\n.help-bx .info img {\n    max-width: 60px;\n    margin-bottom: 20px\n}\n\n.help-bx .title {\n    color: #fff;\n    margin-bottom: 15px\n}\n\n.help-bx p {\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 30px;\n    color: #fff\n}\n\n.brochure-bx {\n    position: relative;\n    background-color: #fff;\n    border-radius: 6px 6px 4px 4px !important;\n    padding: 30px 30px;\n    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);\n    border: 1px solid rgba(86, 90, 207, .2);\n    border-width: 1px 1px 3px 1px;\n    border-bottom-color: #565acf\n}\n\n.brochure-bx .title-head {\n    border-bottom: 1px solid rgba(0, 0, 0, .15);\n    padding-bottom: 8px;\n    position: relative;\n    margin-bottom: 30px\n}\n\n.brochure-bx .title-head:after {\n    background: #565acf;\n    content: \"\";\n    width: 30px;\n    height: 3px;\n    position: absolute;\n    bottom: -2px;\n    left: 0\n}\n\n@media only screen and (max-width: 575px) {\n    .brochure-bx {\n        padding: 15px\n    }\n\n    .brochure-bx .title-head {\n        margin-bottom: 20px\n    }\n}\n\n.download-link {\n    position: relative;\n    display: block;\n    padding: 15px 15px 15px 65px;\n    margin-top: 20px;\n    border-radius: 8px;\n    background-color: #565acf\n}\n\n.download-link .title {\n    font-size: 15px;\n    margin: 0;\n    line-height: 22px;\n    color: #fff\n}\n\n.download-link span {\n    color: #fff;\n    font-size: 14px;\n    line-height: 18px\n}\n\n.download-link img {\n    width: 40px;\n    position: absolute;\n    left: 15px;\n    top: 18px\n}\n\n@media only screen and (max-width: 575px) {\n    .download-link {\n        margin-top: 10px\n    }\n}\n\n.list-check-squer li {\n    display: block;\n    color: var(--bs-dark);\n    font-size: 20px;\n    font-family: \"Roboto Condensed\";\n    font-weight: 500;\n    position: relative;\n    padding: 8px 15px 7px 50px;\n    margin-bottom: 10px;\n    line-height: 20px\n}\n\n.list-check-squer li:before {\n    content: \"\";\n    font-family: \"Line Awesome Free\";\n    font-weight: 900;\n    background-color: #565acf;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    width: 35px;\n    height: 35px;\n    display: block;\n    text-align: center;\n    line-height: 35px;\n    color: #fff;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    border-radius: 4px;\n    transform: translateY(-50%)\n}\n\n.list-check-squer li:hover:before {\n    background-color: #f17732\n}\n\n@media only screen and (max-width: 575px) {\n    .list-check-squer li {\n        font-size: 18px;\n        padding: 8px 15px 7px 46px\n    }\n}\n\n.error-404 .inner-content {\n    text-align: center;\n    max-width: 550px;\n    margin: auto\n}\n\n.error-404 .error-title {\n    font-size: 180px;\n    line-height: 180px;\n    margin-bottom: 15px\n}\n\n.error-404 .error-title span {\n    width: 145px;\n    height: 145px;\n    display: inline-block;\n    background-image: url(./images/error.gif);\n    background-size: 100%;\n    margin: 0 10px\n}\n\n.error-404 .error-text {\n    margin-bottom: 15px\n}\n\n.error-404 p {\n    margin-bottom: 30px\n}\n\n@media only screen and (max-width: 575px) {\n    .error-404 .error-title {\n        font-size: 120px;\n        line-height: 120px\n    }\n\n    .error-404 .error-title span {\n        width: 100px;\n        height: 100px\n    }\n}\n\n.blog-single {\n    margin-bottom: 60px;\n    box-shadow: unset;\n    padding: 0;\n    border: 0\n}\n\n.blog-single .ttr-post-title {\n    margin-bottom: 10px\n}\n\n.blog-single .ttr-post-title .post-title {\n    margin-bottom: 10px\n}\n\n.blog-single .action-box {\n    margin-bottom: 30px\n}\n\n.blog-single .ttr-post-text {\n    margin-top: 10px\n}\n\n.blog-single .ttr-post-text ul {\n    padding: 0\n}\n\n.blog-single .share-post li:first-child {\n    margin-right: 5px\n}\n\n.blog-single .ttr-post-text ul li {\n    padding: 5px 0\n}\n\n.blog-single .ttr-post-footer {\n    display: flex;\n    align-items: center;\n    border: 1px solid rgba(0, 0, 0, .1);\n    border-width: 1px 0;\n    padding: 12px 0;\n    margin-top: 30px;\n    justify-content: space-between\n}\n\n.blog-single .ttr-post-footer .post-tags a {\n    color: #008BB1;\n    font-size: 15px;\n    font-weight: 600;\n    text-transform: capitalize;\n    margin-right: 10px\n}\n\n.blog-single .ttr-post-footer strong {\n    font-size: 15px;\n    font-weight: 600;\n    margin-right: 10px\n}\n\n.blog-single .ttr-post-footer .social-media {\n    margin-bottom: 0\n}\n\n.blog-single .ttr-post-meta {\n    margin-bottom: 0\n}\n\n.blog-single .ttr-post-tags {\n    margin-top: 20px\n}\n\n.blog-single .ttr-post-media {\n    border-radius: 4px\n}\n\n@media only screen and (max-width: 767px) {\n    .blog-single {\n        margin-bottom: 40px\n    }\n\n    .blog-single .ttr-post-footer {\n        display: block\n    }\n\n    .blog-single .ttr-post-footer .social-media {\n        margin: 15px 0 0\n    }\n\n    .blog-single .wp-block-gallery {\n        margin-bottom: 5px\n    }\n}\n\n.blog-single:hover {\n    box-shadow: unset;\n    border: 0\n}\n\n.comments-area {\n    padding: 0\n}\n\n.comments-area .comments-title {\n    text-transform: uppercase;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 28px;\n    margin-bottom: 30px\n}\n\nol.comment-list {\n    margin-bottom: 60px;\n    list-style: none;\n    padding-left: 0\n}\n\nol.comment-list li.comment {\n    position: relative;\n    padding: 0\n}\n\nol.comment-list li.comment .comment-body {\n    margin-bottom: 30px;\n    position: relative;\n    background-color: #fff;\n    border-radius: 6px 6px 4px 4px;\n    padding: 30px 30px;\n    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);\n    border: 1px solid rgba(86, 90, 207, .2);\n    border-width: 1px 1px 3px 1px;\n    border-bottom-color: #008bb1\n}\n\nol.comment-list li.comment .comment-author {\n    margin-bottom: 15px;\n    display: flex;\n    align-items: center\n}\n\nol.comment-list li.comment .comment-author .avatar {\n    width: 70px;\n    height: 70px;\n    border-radius: 14px;\n    -webkit-border-radius: 14px;\n    background: #fff;\n    padding: 4px;\n    margin-right: 16px;\n    box-shadow: 0 0 30px 0 rgba(0, 10, 105, .03)\n}\n\nol.comment-list li.comment .comment-author .fn {\n    display: inline-block;\n    color: var(--bs-dark);\n    font-size: 20px;\n    font-weight: 700;\n    font-style: normal;\n    margin-bottom: 5px;\n    line-height: 28px\n}\n\nol.comment-list li.comment .comment-author .says {\n    display: none;\n    color: #999;\n    font-weight: 600\n}\n\nol.comment-list li.comment .comment-meta {\n    color: #8d8d8d;\n    text-transform: uppercase\n}\n\nol.comment-list li.comment .comment-meta a {\n    color: #008BB1;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0;\n    text-transform: uppercase\n}\n\nol.comment-list li.comment p {\n    margin: 0 0 5px;\n    font-size: 15px\n}\n\nol.comment-list li.comment .reply a {\n    background: #00b8de;\n    padding: 6px 14px;\n    border-radius: 8px;\n    display: inline-block;\n    margin-top: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #fff;\n    text-transform: uppercase\n}\n\nol.comment-list li.comment .reply a:hover {\n    background-color: #008bb1;\n    color: #fff\n}\n\nol.comment-list li.comment .comment-respond .comment-form p {\n    padding: 0 15px\n}\n\nol.comment-list li .children {\n    list-style: none;\n    margin-left: 80px;\n    padding: 0\n}\n\nol.comment-list li .children li {\n    padding: 0\n}\n\n@media only screen and (max-width: 767px) {\n    ol.comment-list {\n        margin-bottom: 40px\n    }\n\n    ol.comment-list .padding-30 {\n        padding: 15px\n    }\n\n    ol.comment-list li.comment .comment-body {\n        margin-bottom: 30px\n    }\n\n    ol.comment-list li.comment .reply a {\n        position: static\n    }\n\n    ol.comment-list li .children {\n        margin-left: 30px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    ol.comment-list li.comment .comment-body {\n        padding: 25px\n    }\n}\n\n.comment-respond {\n    position: relative;\n    background-color: #fff;\n    border-radius: 6px 6px 4px 4px;\n    padding: 30px 30px;\n    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);\n    border: 1px solid #008bb1;\n    border-width: 1px 1px 3px 1px;\n    border-bottom-color: #565acf\n}\n\n.comment-respond .comment-reply-title {\n    margin-bottom: 25px\n}\n\n.comment-respond .comment-form {\n    margin: 0 -10px\n}\n\n.comment-respond .comment-notes {\n    display: none\n}\n\n.comment-respond p {\n    width: 50%;\n    float: left;\n    padding: 0 10px;\n    margin-bottom: 20px;\n    position: relative\n}\n\n.comment-respond p.form-allowed-tags {\n    width: 100%\n}\n\n.comments-area .comment-form p label {\n    display: none;\n    line-height: 18px;\n    margin-bottom: 10px\n}\n\n.comments-area .comment-form p input[type=text],\n.comments-area .comment-form p textarea {\n    width: 100%;\n    height: 50px;\n    padding: 15px 25px;\n    border: 1px solid;\n    text-transform: capitalize;\n    color: #000;\n    background: #fff;\n    font-size: 16px;\n    border-color: rgba(86, 90, 207, .3);\n    border-radius: 6px;\n    font-weight: 500\n}\n\n.comments-area .comment-form p input[type=text]::-webkit-input-placeholder,\n.comments-area .comment-form p textarea::-webkit-input-placeholder {\n    color: #444\n}\n\n.comments-area .comment-form p input[type=text]:-ms-input-placeholder,\n.comments-area .comment-form p textarea:-ms-input-placeholder {\n    color: #444\n}\n\n.comments-area .comment-form p input[type=text]::placeholder,\n.comments-area .comment-form p textarea::placeholder {\n    color: #444\n}\n\n.comments-area .comment-form p input[type=text]:hover,\n.comments-area .comment-form p textarea:hover,\n.comments-area .comment-form p input[type=text]:focus,\n.comments-area .comment-form p textarea:focus {\n    border-color: #565acf;\n    box-shadow: none;\n    outline: none\n}\n\n.comments-area .comment-form p.comment-form-comment {\n    width: 100%;\n    display: block;\n    clear: both\n}\n\n.comments-area .comment-form p textarea {\n    height: 120px\n}\n\n.comments-area .comment-form p.form-submit {\n    clear: both;\n    float: none;\n    width: 100%;\n    margin: 0\n}\n\n.comments-area .comment-form p input[type=submit] {\n    background-color: #008bb1;\n    color: #fff;\n    display: inline-block;\n    font-weight: 500;\n    font-size: 14px;\n    padding: 15px 30px;\n    border: 2px solid;\n    border-color: #008bb1;\n    border-radius: 8px;\n    text-decoration: none;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    line-height: 1.2\n}\n\n.comments-area .comment-form p input[type=submit]:hover,\n.comments-area .comment-form p input[type=submit]:focus,\n.comments-area .comment-form p input[type=submit]:active {\n    background-color: #00b8de;\n    border: 2px solid #00b8de;\n}\n\n@media only screen and (max-width: 767px) {\n    .comments-area .comment-form p {\n        width: 100%;\n        float: none;\n        margin-bottom: 20px\n    }\n\n    .comments-area .comment-respond {\n        padding: 20px\n    }\n}\n\n.author-box {\n    margin-bottom: 50px;\n    position: relative;\n    background-color: #fff;\n    border-radius: 6px 6px 4px 4px;\n    padding: 30px 30px;\n    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);\n    border: 1px solid rgba(86, 90, 207, .2);\n    border-width: 1px 1px 3px 1px;\n    border-bottom-color: #008bb1\n}\n\n.author-box.blog-user .author-profile-info {\n    display: flex\n}\n\n@media only screen and (max-width: 575px) {\n    .author-box.blog-user .author-profile-info {\n        display: block\n    }\n}\n\n.author-box .author-profile-pic {\n    width: 100px;\n    height: 100px;\n    min-width: 100px;\n    border-radius: 10px;\n    overflow: hidden;\n    z-index: 2;\n    position: relative;\n    margin-right: 20px\n}\n\n.author-box .author-profile-pic img {\n    width: 100%;\n    min-width: 100px;\n    height: 100px;\n    border-radius: 4px;\n    overflow: hidden;\n    box-shadow: none;\n    z-index: 2;\n    position: relative;\n    margin: 0 auto;\n    border: 0\n}\n\n.author-box .author-profile-pic h6,\n.author-box .author-profile-pic .h6 {\n    font-size: 24px;\n    line-height: 32px;\n    margin-bottom: 5px\n}\n\n.author-box .author-profile-pic p {\n    margin-bottom: 15px;\n    font-size: 18px;\n    line-height: 24px\n}\n\n@media only screen and (max-width: 575px) {\n    .author-box .author-profile-pic {\n        margin-bottom: 20px\n    }\n}\n\n.min-container,\n.blog-post.blog-single {\n    max-width: 750px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 15px;\n    padding-right: 15px\n}\n\n.max-container {\n    max-width: 1500px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 55px;\n    padding-right: 55px\n}\n\n.blog-post.blog-single .ttr-post-info {\n    padding: 0\n}\n\n.blog-post.blog-single .ttr-post-text.text>ol,\n.blog-post.blog-single .ttr-post-text.text>ul {\n    padding-left: 30px\n}\n\n.blog-post.blog-single .ttr-post-text.text>ol li,\n.blog-post.blog-single .ttr-post-text.text>ul li {\n    padding: 5px 5px;\n    color: #2b2d2e\n}\n\n.blog-post.blog-single .ttr-post-text.text>.wp-block-gallery {\n    padding: 0;\n    list-style: none\n}\n\n.blog-post.blog-single .ttr-post-text.text>.wp-block-gallery li {\n    padding: 0;\n    list-style: none;\n    margin: 10px\n}\n\n.blog-post.blog-single .ttr-post-text ul li,\n.blog-post.blog-single .ttr-post-text ol li,\n.blog-post.blog-single .ttr-post-text p {\n    font-size: 15px;\n    line-height: 28px\n}\n\n.blog-post.blog-single .ttr-post-text p {\n    margin-bottom: 28px\n}\n\n.blog-post.blog-single .ttr-post-text .wp-block-gallery {\n    margin-left: -195px;\n    margin-right: -195px;\n    width: calc(100% + 380px + 10px);\n    max-width: initial\n}\n\n.blog-post.blog-single .ttr-post-text>div+p:first-letter,\n.blog-post.blog-single .ttr-post-text>p:first-child:first-letter {\n    color: #6d9ec4;\n    font-size: 100px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 14px;\n    margin-top: 15px\n}\n\n.blog-post.blog-single .ttr-post-text .has-large-font-size {\n    font-size: 36px;\n    line-height: 50px;\n    color: #000\n}\n\n.content-spacious-full .wp-block-gallery {\n    margin-left: -205px;\n    margin-right: -205px;\n    width: calc(100% + 400px + 10px);\n    max-width: initial\n}\n\n.alignwide {\n    margin-left: -105px;\n    margin-right: -105px;\n    width: calc(100% + 200px + 10px);\n    max-width: initial\n}\n\n.alignfullwide {\n    margin-left: calc(50% - 50vw - var(--content-share-ml, 0px)/2);\n    width: 100vw;\n    max-width: 100vw;\n    box-sizing: border-box\n}\n\n.ttr-post-text h1,\n.ttr-post-text .h1,\n.thm-unit-test .ttr-post-text h1 {\n    font-size: 36px;\n    line-height: 45px;\n    margin-bottom: 10px;\n    font-weight: 700\n}\n\n.ttr-post-text h2,\n.ttr-post-text .h2,\n.thm-unit-test .ttr-post-text h2 {\n    font-size: 32px;\n    line-height: 45px;\n    margin-bottom: 5px;\n    font-weight: 700\n}\n\n.ttr-post-text h3,\n.ttr-post-text .h3,\n.thm-unit-test .ttr-post-text h3 {\n    font-size: 28px;\n    line-height: 35px;\n    margin-bottom: 8px;\n    font-weight: 700\n}\n\n.ttr-post-text h4,\n.ttr-post-text .h4,\n.thm-unit-test .ttr-post-text h4 {\n    font-size: 22px;\n    line-height: 32px;\n    margin-bottom: 5px;\n    font-weight: 600\n}\n\n.ttr-post-text h5,\n.ttr-post-text .h5,\n.thm-unit-test .ttr-post-text h5 {\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 8px;\n    font-weight: 600\n}\n\n.ttr-post-text h6,\n.ttr-post-text .h6,\n.thm-unit-test .ttr-post-text h6 {\n    font-size: 16px;\n    line-height: 22px;\n    margin-bottom: 10px;\n    font-weight: 600\n}\n\npre {\n    margin: 0 0 25px;\n    padding: 20px;\n    color: #ddd;\n    background-color: #222;\n    white-space: pre;\n    text-shadow: 0 1px 0 #000;\n    border-radius: 5px;\n    border-bottom: 1px solid #555;\n    box-shadow: 0 1px 5px rgba(0, 0, 0, .4) inset, 0 0 20px rgba(0, 0, 0, .2) inset\n}\n\nblockquote {\n    padding: 50px 30px 50px 140px;\n    font-size: 20px;\n    color: #fff;\n    margin: 25px 0;\n    line-height: 1.7;\n    position: relative;\n    clear: both;\n    background: #00b8de;\n    border-radius: 10px;\n    /* box-shadow: 0 7px 50px -20px #f17732; */\n    width: 80%;\n\n}\n\nblockquote:after {\n    content: \"\";\n    background-image: url(./images/quote.png);\n    position: absolute;\n    width: 90px;\n    height: 90px;\n    left: 30px;\n    top: 10px;\n    background-size: cover\n}\n\nblockquote p {\n    color: inherit;\n    margin-bottom: 0px;\n    font-weight: 600;\n    font-style: italic;\n    text-align: center;\n}\n\n.block-quote-section-main {\n    display: flex;\n    justify-content: center;\n}\n\n.block-quote-section {\n    display: flex;\n    justify-content: center;\n    margin-bottom: -100px;\n}\n\n.styled-text {\n    font-size: 28px;\n    /* font-family: \"Poppins\", sans-serif; */\n}\n\n@media only screen and (max-width: 767px) {\n    blockquote {\n        font-size: 16px;\n        padding: 25px 25px 25px 90px\n    }\n\n    blockquote:after {\n        width: 40px;\n        height: 40px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    blockquote {\n        font-size: 15px;\n        padding: 20px 20px 20px 80px\n    }\n\n    blockquote:after {\n        left: 20px;\n        top: 20px\n    }\n}\n\n.paginate-links {\n    display: flex;\n    align-items: center;\n    margin: 20px 0\n}\n\n.paginate-links a,\n.paginate-links>span {\n    margin: 0 0 0 10px;\n    position: relative;\n    border: 0px solid #6cc000;\n    color: #000;\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 40px;\n    min-width: 40px;\n    height: 40px;\n    text-align: center;\n    text-transform: capitalize;\n    transition: all 500ms ease 0s;\n    background: #e0e0e0;\n    border-radius: 3px\n}\n\n.wp-block-button__link {\n    border-radius: 4px;\n    font-size: 16px;\n    padding: 10px 30px;\n    font-weight: 700\n}\n\n.wp-block-gallery {\n    display: flex;\n    flex-wrap: wrap;\n    list-style-type: none;\n    padding: 0\n}\n\n.wp-block-gallery .blocks-gallery-image,\n.wp-block-gallery .blocks-gallery-item {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    justify-content: center;\n    margin: 0 8px 8px 0;\n    position: relative;\n    width: calc(50% - 8px)\n}\n\n.wp-block-gallery .blocks-gallery-image figure,\n.wp-block-gallery .blocks-gallery-item figure {\n    height: 100%;\n    margin: 0\n}\n\n.wp-block-gallery .blocks-gallery-image img,\n.wp-block-gallery .blocks-gallery-item img {\n    display: block;\n    height: auto;\n    max-width: 100%;\n    width: 100%\n}\n\n.wp-block-gallery .blocks-gallery-image figcaption,\n.wp-block-gallery .blocks-gallery-item figcaption {\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3) 60%, transparent);\n    bottom: 0;\n    color: #fff;\n    font-size: 13px;\n    max-height: 100%;\n    overflow: auto;\n    padding: 40px 10px 5px;\n    position: absolute;\n    text-align: center;\n    width: 100%\n}\n\n.wp-block-gallery .blocks-gallery-image figcaption img,\n.wp-block-gallery .blocks-gallery-item figcaption img {\n    display: inline\n}\n\n.wp-block-gallery .blocks-gallery-image:last-child,\n.wp-block-gallery .blocks-gallery-item:last-child {\n    margin-right: 0\n}\n\n.wp-block-gallery .blocks-gallery-image:nth-of-type(2n),\n.wp-block-gallery .blocks-gallery-item:nth-of-type(2n) {\n    margin-right: 0\n}\n\n.wp-block-gallery .blocks-gallery-item.has-add-item-button {\n    width: 100%\n}\n\n.wp-block-gallery.aligncenter .blocks-gallery-item figure {\n    justify-content: center\n}\n\n.wp-block-gallery.columns-4 .blocks-gallery-image,\n.wp-block-gallery.columns-4 .blocks-gallery-item,\n.wp-block-gallery.columns-3 .blocks-gallery-image,\n.wp-block-gallery.columns-3 .blocks-gallery-item {\n    margin-right: 8px\n}\n\n.wp-block-gallery.columns-1 .blocks-gallery-image,\n.wp-block-gallery.columns-1 .blocks-gallery-item {\n    margin-right: 0;\n    width: 100%\n}\n\n.wp-block-gallery.is-cropped .blocks-gallery-image a,\n.wp-block-gallery.is-cropped .blocks-gallery-image img,\n.wp-block-gallery.is-cropped .blocks-gallery-item a,\n.wp-block-gallery.is-cropped .blocks-gallery-item img {\n    width: 100%\n}\n\n.wp-block-gallery.aligncenter,\n.wp-block-gallery.alignleft,\n.wp-block-gallery.alignright {\n    display: flex\n}\n\n.wp-block-gallery.alignleft,\n.wp-block-gallery.alignright {\n    max-width: 305px;\n    width: 100%\n}\n\n.wp-block-image.alignfullwide img {\n    border-radius: 0\n}\n\n.wp-block-image img {\n    border-radius: 10px\n}\n\n.aligncenter {\n    text-align: center\n}\n\n@supports(position: -webkit-sticky) or (position: sticky) {\n    .wp-block-gallery .blocks-gallery-image figure {\n        align-items: flex-end;\n        display: flex;\n        justify-content: flex-start\n    }\n}\n\n@supports(position: -webkit-sticky) or (position: sticky) {\n\n    .wp-block-gallery .blocks-gallery-image img,\n    .wp-block-gallery .blocks-gallery-item img {\n        width: auto\n    }\n}\n\n@supports(position: -webkit-sticky) or (position: sticky) {\n\n    .wp-block-gallery.is-cropped .blocks-gallery-image a,\n    .wp-block-gallery.is-cropped .blocks-gallery-image img {\n        -o-object-fit: cover;\n        flex: 1;\n        height: 100%;\n        object-fit: cover\n    }\n}\n\n@media only screen and (max-width: 1024px) {\n    .alignwide {\n        margin-left: 0;\n        margin-right: 0;\n        width: 100%;\n        max-width: 100%\n    }\n\n    .alignwide .alignleft {\n        margin: 5px 0px 25px 0;\n        float: none\n    }\n\n    .alignwide .alignleft img {\n        width: 100%\n    }\n}\n\n@media(min-width: 600px) {\n\n    .wp-block-gallery.columns-3 .blocks-gallery-image,\n    .wp-block-gallery.columns-3 .blocks-gallery-item {\n        margin-right: 20px;\n        width: calc(33.33333% - 10.66667px)\n    }\n\n    .wp-block-gallery.columns-4 .blocks-gallery-image,\n    .wp-block-gallery.columns-4 .blocks-gallery-item {\n        margin-right: 20px;\n        width: calc(25% - 12px)\n    }\n\n    .wp-block-gallery.columns-5 .blocks-gallery-image,\n    .wp-block-gallery.columns-5 .blocks-gallery-item {\n        margin-right: 20px;\n        width: calc(20% - 12.8px)\n    }\n\n    .wp-block-gallery.columns-6 .blocks-gallery-image,\n    .wp-block-gallery.columns-6 .blocks-gallery-item {\n        margin-right: 20px;\n        width: calc(16.66667% - 13.33333px)\n    }\n\n    .wp-block-gallery.columns-7 .blocks-gallery-image,\n    .wp-block-gallery.columns-7 .blocks-gallery-item {\n        margin-right: 20px;\n        width: calc(14.28571% - 13.71429px)\n    }\n\n    .wp-block-gallery.columns-8 .blocks-gallery-image,\n    .wp-block-gallery.columns-8 .blocks-gallery-item {\n        margin-right: 20px;\n        width: calc(12.5% - 14px)\n    }\n\n    .wp-block-gallery.columns-1 .blocks-gallery-image:last-child,\n    .wp-block-gallery.columns-1 .blocks-gallery-item:last-child,\n    .wp-block-gallery.columns-2 .blocks-gallery-image:last-child,\n    .wp-block-gallery.columns-2 .blocks-gallery-item:last-child,\n    .wp-block-gallery.columns-3 .blocks-gallery-image:last-child,\n    .wp-block-gallery.columns-3 .blocks-gallery-item:last-child,\n    .wp-block-gallery.columns-4 .blocks-gallery-image:last-child,\n    .wp-block-gallery.columns-4 .blocks-gallery-item:last-child,\n    .wp-block-gallery.columns-5 .blocks-gallery-image:last-child,\n    .wp-block-gallery.columns-5 .blocks-gallery-item:last-child,\n    .wp-block-gallery.columns-6 .blocks-gallery-image:last-child,\n    .wp-block-gallery.columns-6 .blocks-gallery-item:last-child,\n    .wp-block-gallery.columns-7 .blocks-gallery-image:last-child,\n    .wp-block-gallery.columns-7 .blocks-gallery-item:last-child,\n    .wp-block-gallery.columns-8 .blocks-gallery-image:last-child,\n    .wp-block-gallery.columns-8 .blocks-gallery-item:last-child {\n        margin-right: 0\n    }\n}\n\n.menu-logo {\n    display: table;\n    float: left;\n    vertical-align: middle;\n    padding: 10px;\n    color: #efbb20;\n    margin-top: 0;\n    margin-bottom: 0;\n    margin-left: 0;\n    margin-right: 0;\n    width: 150px;\n    height: 105px;\n    position: relative;\n    z-index: 9\n}\n\n.menu-logo a {\n    display: table-cell;\n    vertical-align: middle\n}\n\n.menu-logo img {\n    height: auto;\n    width: 100%\n}\n\n.menu-logo span {\n    font-size: 20px;\n    letter-spacing: 20px\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-logo {\n        height: 85px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .menu-logo {\n        width: 180px\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    .menu-logo {\n        height: 75px;\n        width: 150px\n    }\n}\n\n.header {\n    position: relative;\n    z-index: 9999\n}\n\n.header .menu-bar {\n    background: #fff;\n    width: 100%;\n    position: relative\n}\n\n.header .container {\n    position: relative\n}\n\n.header .secondary-menu {\n    float: right;\n    height: 105px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    z-index: 9;\n    padding-left: 15px\n}\n\n.header .secondary-menu .search-btn {\n    margin-right: 35px\n}\n\n.header .secondary-menu .search-btn .btn-link {\n    font-size: 25px;\n    line-height: 25px;\n    color: #008BB1;\n    cursor: pointer;\n    border: 0;\n    padding: 8px 0;\n    background: none\n}\n\n.header .secondary-menu ul {\n    margin-bottom: 0;\n    display: flex;\n    align-items: center\n}\n\n.header .secondary-menu ul .num-bx {\n    margin-right: 40px\n}\n\n.header .secondary-menu ul .num-bx a {\n    font-weight: 700;\n    font-size: 20px;\n    color: var(--bs-dark);\n    display: flex;\n    align-items: center\n}\n\n.header .secondary-menu ul .num-bx a i {\n    width: 42px;\n    height: 42px;\n    text-align: center;\n    line-height: 42px;\n    background-color: rgba(86, 90, 207, .1);\n    font-size: 18px;\n    border-radius: 8px;\n    color: #565acf;\n    margin-right: 15px\n}\n\n@media only screen and (max-width: 1680px) {\n    .header .secondary-menu .search-btn {\n        margin-right: 25px\n    }\n\n    .header .secondary-menu ul .num-bx {\n        margin-right: 30px\n    }\n}\n\n@media only screen and (max-width: 1380px) {\n    .header .secondary-menu ul .num-bx {\n        display: none\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .header .secondary-menu {\n        height: 85px\n    }\n\n    .header .secondary-menu .btn-area {\n        display: none\n    }\n\n    .header .secondary-menu .search-btn {\n        margin-right: 0\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    .header .secondary-menu {\n        height: 75px\n    }\n}\n\n.navbar-toggler {\n    border: 0 solid #efbb20;\n    font-size: 16px;\n    line-height: 24px;\n    margin: 35px 0 32px 20px;\n    padding: 0;\n    float: right;\n    outline: none\n}\n\n@media only screen and (max-width: 575px) {\n    .navbar-toggler {\n        margin: 28px 0 28px 20px\n    }\n}\n\n.menuicon {\n    width: 20px;\n    height: 18px;\n    position: relative;\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .5s ease-in-out;\n    -moz-transition: .5s ease-in-out;\n    -o-transition: .5s ease-in-out;\n    transition: .5s ease-in-out;\n    cursor: pointer\n}\n\n.menuicon span {\n    display: block;\n    position: absolute;\n    height: 2px;\n    width: 100%;\n    border-radius: 1px;\n    opacity: 1;\n    left: 0;\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .25s ease-in-out;\n    -moz-transition: .25s ease-in-out;\n    -o-transition: .25s ease-in-out;\n    transition: .25s ease-in-out;\n    background: #000\n}\n\n.menuicon span:nth-child(1) {\n    top: 0px\n}\n\n.menuicon span:nth-child(2) {\n    top: 7px\n}\n\n.menuicon span:nth-child(3) {\n    top: 14px\n}\n\n.menuicon.open span:nth-child(1) {\n    top: 7px;\n    -webkit-transform: rotate(135deg);\n    -moz-transform: rotate(135deg);\n    -o-transform: rotate(135deg);\n    transform: rotate(135deg)\n}\n\n.menuicon.open span:nth-child(2) {\n    opacity: 0;\n    left: -60px\n}\n\n.menuicon.open span:nth-child(3) {\n    top: 7px;\n    -webkit-transform: rotate(-135deg);\n    -moz-transform: rotate(-135deg);\n    -o-transform: rotate(-135deg);\n    transform: rotate(-135deg)\n}\n\n.header-tb .menuicon span {\n    background: #fff\n}\n\n.menu-links {\n    padding: 0\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links.show {\n        left: -1px;\n        -webkit-transition: all .8s;\n        -ms-transition: all .8s;\n        transition: all .8s;\n        margin: 0;\n        width: 280px\n    }\n}\n\n.menu-links .menu-logo {\n    display: none\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .menu-logo {\n        padding: 30px 20px;\n        float: none;\n        height: auto;\n        width: 240px\n    }\n}\n\n.menu-links .nav {\n    float: right;\n    padding: 0;\n    margin-right: 50px\n}\n\n.menu-links .nav>li {\n    margin: 0px;\n    font-weight: 400;\n    position: relative\n}\n\n.menu-links .nav>li.has-mega-menu {\n    position: inherit\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .nav>li {\n        border-bottom: 1px solid #eee;\n        width: 100%\n    }\n}\n\n.menu-links .nav>li.active>a {\n    color: #f17732\n}\n\n.menu-links .nav>li>a {\n    color: var(--bs-dark);\n    font-size: 16px;\n    padding: 45px 20px;\n    cursor: pointer;\n    font-weight: 600;\n    display: inline-block;\n    position: relative;\n    border-width: 0 0 0 1px;\n    line-height: 1\n}\n\n.menu-links .nav>li>a i {\n    font-size: 10px;\n    margin-left: 5px;\n    margin-top: -3px;\n    vertical-align: middle;\n    color: #bbbbcf;\n    transition: all .5s\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .nav>li>a i {\n        right: 0;\n        text-align: center;\n        z-index: 3;\n        float: right;\n        margin: 10px 5px 0 0;\n        font-size: 12px\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    .menu-links .nav>li>a {\n        padding: 45px 15px\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .nav>li>a {\n        padding: 8px 0;\n        display: block;\n        line-height: 30px;\n        color: #fff\n    }\n}\n\n.menu-links .nav>li .mega-menu,\n.menu-links .nav>li .sub-menu {\n    background-color: #fff;\n    display: block;\n    left: 0;\n    list-style: none;\n    opacity: 0;\n    padding: 5px 0;\n    position: absolute;\n    visibility: hidden;\n    width: 220px;\n    z-index: 10;\n    margin-top: 20px;\n    box-shadow: 0px 1px 40px 0px rgba(0, 0, 0, .1);\n    -webkit-transition: all .8s;\n    -ms-transition: all .8s;\n    transition: all .8s\n}\n\n@media only screen and (max-width: 991px) {\n\n    .menu-links .nav>li .mega-menu,\n    .menu-links .nav>li .sub-menu {\n        display: none;\n        position: static;\n        visibility: visible;\n        width: auto;\n        background: rgba(0, 0, 0, 0);\n        box-shadow: none;\n        margin: 0;\n        border-top: 1px solid rgba(255, 255, 255, .1);\n        padding: 0\n    }\n}\n\n.menu-links .nav>li .mega-menu li,\n.menu-links .nav>li .sub-menu li {\n    position: relative\n}\n\n.menu-links .nav>li .mega-menu li a,\n.menu-links .nav>li .sub-menu li a {\n    color: #666;\n    display: block;\n    font-size: 14px;\n    padding: 10px 25px;\n    text-transform: capitalize;\n    position: relative;\n    transition: all .15s linear;\n    -webkit-transition: all .15s linear;\n    -moz-transition: all .15s linear;\n    -o-transition: all .15s linear;\n    font-weight: 500\n}\n\n.menu-links .nav>li .mega-menu li a span,\n.menu-links .nav>li .sub-menu li a span {\n    position: relative\n}\n\n.menu-links .nav>li .mega-menu li a span:after,\n.menu-links .nav>li .sub-menu li a span:after {\n    content: \"\";\n    position: absolute;\n    height: 1px;\n    width: 0;\n    background: #565acf;\n    bottom: 0;\n    right: 0;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    -moz-transform-origin: right;\n    -webkit-transform-origin: right;\n    -ms-transform-origin: right;\n    -o-transform-origin: right;\n    transform-origin: right\n}\n\n.menu-links .nav>li .mega-menu li a:hover,\n.menu-links .nav>li .sub-menu li a:hover {\n    color: #565acf\n}\n\n.menu-links .nav>li .mega-menu li a:hover span:after,\n.menu-links .nav>li .sub-menu li a:hover span:after {\n    width: 100%;\n    -moz-transform-origin: left;\n    -webkit-transform-origin: left;\n    -ms-transform-origin: left;\n    -o-transform-origin: left;\n    transform-origin: left;\n    left: 0;\n    right: auto\n}\n\n@media only screen and (max-width: 991px) {\n\n    .menu-links .nav>li .mega-menu li a,\n    .menu-links .nav>li .sub-menu li a {\n        padding: 10px 0px 10px 20px;\n        border-bottom: 1px solid rgba(255, 255, 255, .1)\n    }\n\n    .menu-links .nav>li .mega-menu li a span:after,\n    .menu-links .nav>li .sub-menu li a span:after {\n        content: none\n    }\n}\n\n.menu-links .nav>li .mega-menu li:hover>a,\n.menu-links .nav>li .sub-menu li:hover>a {\n    color: #565acf\n}\n\n.menu-links .nav>li .mega-menu li>.sub-menu,\n.menu-links .nav>li .sub-menu li>.sub-menu {\n    left: 220px;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.menu-links .nav>li .sub-menu li .fa {\n    color: inherit;\n    display: block;\n    float: right;\n    font-size: 9px;\n    opacity: 1;\n    margin-top: 4px\n}\n\n.menu-links .nav>li .mega-menu {\n    display: flex;\n    right: 0px;\n    width: 100%;\n    z-index: 9;\n    padding: 0\n}\n\n.menu-links .nav>li .mega-menu>li {\n    display: block;\n    padding: 30px 0 25px;\n    position: relative;\n    vertical-align: top;\n    width: 25%\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .nav>li .mega-menu>li {\n        width: 100%;\n        padding: 0\n    }\n}\n\n.menu-links .nav>li .mega-menu>li>a {\n    color: #000;\n    display: block;\n    padding: 0 20px;\n    font-size: 16px;\n    font-weight: 600;\n    border-bottom: 1px solid rgba(0, 0, 0, .1);\n    padding-bottom: 15px\n}\n\n.menu-links .nav>li .mega-menu>li>a>i {\n    font-size: 14px;\n    margin-right: 5px;\n    text-align: center;\n    width: 15px\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .nav>li .mega-menu>li>a {\n        display: none\n    }\n}\n\n.menu-links .nav>li .mega-menu>li:after {\n    content: \"\";\n    background-color: rgba(0, 0, 0, .1);\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    display: block;\n    width: 1px;\n    height: 100%\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .nav>li .mega-menu>li:after {\n        content: none\n    }\n}\n\n.menu-links .nav>li .mega-menu>li:last-child:after {\n    display: none\n}\n\n.menu-links .nav>li .mega-menu>li:hover>a {\n    background-color: rgba(0, 0, 0, 0)\n}\n\n.menu-links .nav>li .mega-menu>li li i {\n    font-size: 14px;\n    margin-right: 5px;\n    text-align: center;\n    width: 15px\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .nav>li .mega-menu {\n        display: none;\n        padding: 10px 0\n    }\n}\n\n.menu-links .nav>li:hover>.mega-menu,\n.menu-links .nav>li:hover>.sub-menu {\n    opacity: 1;\n    visibility: visible;\n    margin-top: 0;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.menu-links .nav>li:hover>.mega-menu li:hover>.sub-menu,\n.menu-links .nav>li:hover>.sub-menu li:hover>.sub-menu {\n    opacity: 1;\n    visibility: visible;\n    margin-top: 0;\n    top: -1px\n}\n\n.menu-links .nav>li:hover a {\n    color: #00b8de\n}\n\n.menu-links .nav>li:hover a i {\n    transform: rotate(45deg);\n    color: #f17732\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .nav>li:hover a i {\n        transform: unset\n    }\n}\n\n.menu-links .nav>li.open .mega-menu,\n.menu-links .nav>li.open .sub-menu {\n    display: block;\n    opacity: 1\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .nav>li.open>a i:before {\n        content: \"\"\n    }\n}\n\n@media only screen and (max-width: 1680px) {\n    .menu-links .nav {\n        margin-right: 0\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links .nav {\n        float: none;\n        width: 70%;\n        min-width: 300px\n    }\n}\n\n.menu-links .social-media {\n    text-align: center;\n    margin-top: 50px;\n    margin: 0 -3px;\n    display: none\n}\n\n.menu-links .social-media li {\n    display: inline-block;\n    padding: 0 3px\n}\n\n.menu-links .social-media li a {\n    height: 40px;\n    width: 40px;\n    padding: 0;\n    line-height: 38px\n}\n\n.menu-links .menu-close {\n    height: 40px;\n    color: #fff;\n    background-color: #565acf;\n    line-height: 44px;\n    text-align: center;\n    width: 40px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    display: none;\n    z-index: 9999\n}\n\n@media only screen and (max-width: 991px) {\n    .menu-links {\n        overflow-y: scroll;\n        position: fixed;\n        width: 60px;\n        left: -280px;\n        height: 100vh;\n        -webkit-transition: all .5s;\n        -ms-transition: all .5s;\n        transition: all .5s;\n        top: 0;\n        background-color: #fff;\n        margin: 0;\n        z-index: 99\n    }\n\n    .menu-links .social-media,\n    .menu-links .menu-close {\n        display: block\n    }\n}\n\n.top-bar {\n    background-color: #191f23;\n    color: #fff;\n    padding: 8px 0\n}\n\n@media only screen and (max-width: 575px) {\n    .top-bar {\n        display: none\n    }\n}\n\n.top-bar .topbar-left {\n    float: left\n}\n\n.top-bar .topbar-left li {\n    padding-right: 15px\n}\n\n.top-bar .topbar-right {\n    float: right\n}\n\n.top-bar .topbar-right li {\n    padding-left: 15px\n}\n\n.top-bar .topbar-center,\n.top-bar .topbar-left,\n.top-bar .topbar-right {\n    padding-left: 15px;\n    padding-right: 15px\n}\n\n.top-bar .topbar-center ul,\n.top-bar .topbar-left ul,\n.top-bar .topbar-right ul {\n    list-style: none;\n    margin: 0;\n    padding: 0\n}\n\n.top-bar .topbar-center ul li,\n.top-bar .topbar-left ul li,\n.top-bar .topbar-right ul li {\n    display: inline-block;\n    font-size: 15px\n}\n\n@media only screen and (max-width: 1199px) {\n\n    .top-bar .topbar-center ul li,\n    .top-bar .topbar-left ul li,\n    .top-bar .topbar-right ul li {\n        font-size: 13px\n    }\n}\n\n.top-bar .topbar-center ul a,\n.top-bar .topbar-left ul a,\n.top-bar .topbar-right ul a {\n    color: inherit\n}\n\n.top-bar .topbar-center ul i,\n.top-bar .topbar-left ul i,\n.top-bar .topbar-right ul i {\n    color: #565acf;\n    transform: scale(1.3);\n    -moz-transform: scale(1.3);\n    -webkit-transform: scale(1.3);\n    -ms-transform: scale(1.3);\n    -o-transform: scale(1.3);\n    margin-right: 5px\n}\n\n.header-transparent {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%\n}\n\n.header-transparent.style-1 .menu-links .nav>li>a {\n    color: var(--bs-dark)\n}\n\n.header-transparent.style-1 .menu-links .nav>li>a:hover {\n    color: #f17732\n}\n\n.header-transparent.style-1 .menu-links .nav>li>a:hover i {\n    transform: rotate(45deg);\n    color: #f17732\n}\n\n.header-transparent.style-2 .menu-links .nav>li>a {\n    color: #fff\n}\n\n.header-transparent.style-2 .menu-links .nav>li>a:hover {\n    color: #fff\n}\n\n.header-transparent .top-bar,\n.header-transparent .menu-bar {\n    background: rgba(0, 0, 0, 0)\n}\n\n.header-transparent .top-bar {\n    color: #777;\n    border-bottom: 1px solid rgba(0, 0, 0, .1)\n}\n\n@media only screen and (max-width: 575px) {\n    .header-transparent .top-bar {\n        display: none\n    }\n}\n\n.sticky-header.active .menu-logo {\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.sticky-header.active .menu-bar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    box-shadow: 0 0 50px 0 rgba(0, 0, 0, .1)\n}\n\n.sticky-header.active .logo-change .logo1 {\n    display: none\n}\n\n.sticky-header.active .logo-change .logo2 {\n    display: block\n}\n\n.header-transparent .sticky-header.active .menu-bar {\n    position: fixed;\n    background-color: #fff\n}\n\n@media only screen and (max-width: 991px) {\n    .rs-nav .menu-links {\n        position: fixed;\n        width: 60px;\n        left: -105%;\n        height: 100vh;\n        -webkit-transition: all .5s;\n        -ms-transition: all .5s;\n        transition: all .5s;\n        top: 0;\n        background-color: #171a1e;\n        margin: 0;\n        z-index: 99;\n        overflow-y: scroll;\n        flex-direction: column;\n        display: flex;\n        flex-direction: column;\n        justify-content: unset !important\n    }\n\n    .rs-nav .menu-links li.open a {\n        position: relative\n    }\n\n    .rs-nav .menu-links .menu-logo {\n        display: block;\n        float: none;\n        height: auto;\n        max-width: 100%;\n        padding: 20px 15px;\n        width: 100%;\n        text-align: center\n    }\n\n    .rs-nav .menu-links .menu-logo img {\n        max-width: unset;\n        width: 150px;\n        vertical-align: middle\n    }\n\n    .rs-nav .menu-links .menu-logo a {\n        display: inline-block\n    }\n\n    .rs-nav .menu-links.nav-dark {\n        background-color: #202020\n    }\n\n    .rs-nav .menu-links.show {\n        left: 0;\n        -webkit-transition: all .8s;\n        -ms-transition: all .8s;\n        transition: all .8s;\n        margin: 0;\n        width: 100%;\n        padding: 15px 15px 5px 15px\n    }\n\n    .rs-nav .sticky-header.active .menu-links .nav {\n        height: auto\n    }\n\n    .rs-nav .social-media {\n        margin-top: auto;\n        padding: 30px 0\n    }\n\n    .navbar-nav {\n        height: auto\n    }\n\n    .menu-links .nav>li {\n        border-color: rgba(255, 255, 255, .1)\n    }\n\n    .menu-links .nav>li a {\n        font-size: 14px;\n        color: #fff\n    }\n\n    .menu-links .nav>li:hover>a,\n    .menu-links .nav>li.active>a {\n        color: #fff;\n        border-color: rgba(255, 255, 255, .1)\n    }\n\n    .menu-links .nav>li .mega-menu li a,\n    .menu-links .nav>li .sub-menu li a {\n        color: rgba(255, 255, 255, .7)\n    }\n\n    .menu-links .nav>li .mega-menu li:hover>a,\n    .menu-links .nav>li .sub-menu li:hover>a {\n        background-color: rgba(0, 0, 0, 0)\n    }\n\n    .header-transparent .sticky-header.active .menu-links .nav>li>a {\n        color: #fff\n    }\n}\n\n.nav-search-bar {\n    background-color: rgba(255, 255, 255, .95);\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 999;\n    display: none;\n    overflow: hidden;\n    padding: 0 15px\n}\n\n.nav-search-bar>span {\n    position: absolute;\n    right: 15px;\n    top: 15px;\n    font-size: 14px;\n    cursor: pointer;\n    color: #fff;\n    background-color: #008BB1;\n    height: 40px;\n    width: 40px;\n    text-align: center;\n    line-height: 44px\n}\n\n.nav-search-bar.show {\n    display: block\n}\n\n.nav-search-bar.show form {\n    transition: all .5s ease .5s;\n    -moz-transition: all .5s ease .5s;\n    -webkit-transition: all .5s ease .5s;\n    opacity: 1\n}\n\n.nav-search-bar form {\n    width: 100%;\n    max-width: 700px;\n    margin: auto;\n    position: relative;\n    top: 50%;\n    transition: all .5s;\n    transition: all .5s;\n    -webkit-transition: all .5s;\n    -moz-transform: translate(0px, -50%);\n    -moz-transform: translate(0px, -50%);\n    -o-transform: translate(0px, -50%);\n    -webkit-transform: translate(0px, -50%);\n    opacity: 0\n}\n\n.nav-search-bar form span {\n    position: absolute;\n    right: 15px;\n    top: 50%;\n    margin: -15px 0;\n    height: 25px;\n    font-size: 20px;\n    cursor: pointer;\n    color: #000\n}\n\n.nav-search-bar .form-control {\n    padding: 15px 60px 15px 15px;\n    width: 100%;\n    height: 70px;\n    border: none;\n    background: none;\n    color: #000;\n    font-size: 20px;\n    border-bottom: 2px solid #000;\n    border-radius: 0\n}\n\n.nav-search-bar .form-control::-moz-placeholder {\n    color: #000\n}\n\n.nav-search-bar .form-control:-moz-placeholder {\n    color: #000\n}\n\n.nav-search-bar .form-control:-ms-input-placeholder {\n    color: #000\n}\n\n.nav-search-bar .form-control::-webkit-input-placeholder {\n    color: #000\n}\n\n.widget {\n    margin-bottom: 40px\n}\n\n@media only screen and (max-width: 575px) {\n    .widget {\n        margin-bottom: 30px\n    }\n}\n\n.widget-title {\n    margin-bottom: 30px;\n    position: relative;\n    padding-bottom: 15px\n}\n\n.widget-title:after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 85px;\n    height: 7px;\n    background-image: url(./images/shap/footer-line.png);\n    background-repeat: no-repeat\n}\n\n@media only screen and (max-width: 767px) {\n    .widget-title {\n        padding-bottom: 15px;\n        font-size: 20px;\n        margin-bottom: 25px\n    }\n\n    .widget-title:after {\n        width: 75px;\n        height: 5px\n    }\n}\n\n.side-bar .widget {\n    position: relative;\n    background-color: #fff;\n    border-radius: 6px 6px 4px 4px;\n    padding: 30px 30px;\n    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);\n    border: 1px solid rgba(86, 90, 207, .2);\n    border-width: 1px 1px 3px 1px;\n    border-bottom-color: #008bb1\n}\n\n@media only screen and (max-width: 575px) {\n    .side-bar .widget {\n        margin-bottom: 30px\n    }\n}\n\n.recent-overlay-post .widget-post {\n    position: relative;\n    z-index: 1\n}\n\n.recent-overlay-post .widget-post:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    display: block;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background: #0f1012;\n    opacity: .6;\n    z-index: 1\n}\n\n.widget-link {\n    margin: 0px;\n    padding: 0px\n}\n\n.widget-link li {\n    list-style: none;\n    display: inline-block;\n    padding-left: 3px;\n    padding-right: 10px;\n    position: relative\n}\n\n.widget-link li:after {\n    content: \"/\";\n    position: absolute;\n    right: 0\n}\n\n.widget-link li:last-child {\n    padding-right: 3px\n}\n\n.widget-link li:last-child:after {\n    content: none\n}\n\n.widget-link-2 ul {\n    margin: 0px;\n    padding: 0px;\n    list-style: none\n}\n\n.widget-link-2 ul li {\n    list-style: none;\n    display: inline-block;\n    padding: 10px 0;\n    position: relative\n}\n\n.widget-link-2 ul li a {\n    padding: 10px 0\n}\n\n.wp-block-latest-posts ul,\n.wp-block-categories-list ul,\n.wp-block-archives-list ul,\n.widget_categories ul,\n.widget_archive ul,\n.widget_meta ul,\n.widget_pages ul,\n.widget_recent_comments ul,\n.widget_nav_menu ul,\n.widget_rss ul,\n.widget_recent_entries ul,\n.widget_services ul,\n.widget_getintuch ul {\n    list-style: none;\n    padding-left: 0;\n    margin-bottom: 0\n}\n\n.wp-block-latest-posts ul li,\n.wp-block-categories-list ul li,\n.wp-block-archives-list ul li,\n.widget_categories ul li,\n.widget_archive ul li,\n.widget_meta ul li,\n.widget_pages ul li,\n.widget_recent_comments ul li,\n.widget_nav_menu ul li,\n.widget_rss ul li,\n.widget_recent_entries ul li,\n.widget_services ul li,\n.widget_getintuch ul li {\n    padding-bottom: 18px;\n    margin-bottom: 13px;\n    position: relative;\n    padding: 10px 0px 10px 15px;\n    margin-bottom: 0;\n    line-height: 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, .1)\n}\n\n.wp-block-latest-posts ul li a,\n.wp-block-categories-list ul li a,\n.wp-block-archives-list ul li a,\n.widget_categories ul li a,\n.widget_archive ul li a,\n.widget_meta ul li a,\n.widget_pages ul li a,\n.widget_recent_comments ul li a,\n.widget_nav_menu ul li a,\n.widget_rss ul li a,\n.widget_recent_entries ul li a,\n.widget_services ul li a,\n.widget_getintuch ul li a {\n    color: #11171a;\n    text-transform: capitalize;\n    font-size: 14px;\n    font-weight: 500\n}\n\n.wp-block-latest-posts ul li a:hover,\n.wp-block-categories-list ul li a:hover,\n.wp-block-archives-list ul li a:hover,\n.widget_categories ul li a:hover,\n.widget_archive ul li a:hover,\n.widget_meta ul li a:hover,\n.widget_pages ul li a:hover,\n.widget_recent_comments ul li a:hover,\n.widget_nav_menu ul li a:hover,\n.widget_rss ul li a:hover,\n.widget_recent_entries ul li a:hover,\n.widget_services ul li a:hover,\n.widget_getintuch ul li a:hover {\n    color: #565acf\n}\n\n.wp-block-latest-posts ul li:before,\n.wp-block-categories-list ul li:before,\n.wp-block-archives-list ul li:before,\n.widget_categories ul li:before,\n.widget_archive ul li:before,\n.widget_meta ul li:before,\n.widget_pages ul li:before,\n.widget_recent_comments ul li:before,\n.widget_nav_menu ul li:before,\n.widget_rss ul li:before,\n.widget_recent_entries ul li:before,\n.widget_services ul li:before,\n.widget_getintuch ul li:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 10px;\n    display: block;\n    width: 5px;\n    height: 5px;\n    background: #a6611c;\n    top: 17px\n}\n\n.wp-block-latest-posts ul li li,\n.wp-block-categories-list ul li li,\n.wp-block-archives-list ul li li,\n.widget_categories ul li li,\n.widget_archive ul li li,\n.widget_meta ul li li,\n.widget_pages ul li li,\n.widget_recent_comments ul li li,\n.widget_nav_menu ul li li,\n.widget_rss ul li li,\n.widget_recent_entries ul li li,\n.widget_services ul li li,\n.widget_getintuch ul li li {\n    border-bottom: none;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    line-height: 22px;\n    border-bottom: 1px solid rgba(0, 0, 0, .1)\n}\n\n.wp-block-latest-posts ul li li:last-child,\n.wp-block-categories-list ul li li:last-child,\n.wp-block-archives-list ul li li:last-child,\n.widget_categories ul li li:last-child,\n.widget_archive ul li li:last-child,\n.widget_meta ul li li:last-child,\n.widget_pages ul li li:last-child,\n.widget_recent_comments ul li li:last-child,\n.widget_nav_menu ul li li:last-child,\n.widget_rss ul li li:last-child,\n.widget_recent_entries ul li li:last-child,\n.widget_services ul li li:last-child,\n.widget_getintuch ul li li:last-child {\n    border-bottom: 0;\n    padding-bottom: 0\n}\n\n.wp-block-latest-posts ul li li:before,\n.wp-block-categories-list ul li li:before,\n.wp-block-archives-list ul li li:before,\n.widget_categories ul li li:before,\n.widget_archive ul li li:before,\n.widget_meta ul li li:before,\n.widget_pages ul li li:before,\n.widget_recent_comments ul li li:before,\n.widget_nav_menu ul li li:before,\n.widget_rss ul li li:before,\n.widget_recent_entries ul li li:before,\n.widget_services ul li li:before,\n.widget_getintuch ul li li:before {\n    top: 16px;\n    left: 0\n}\n\n.wp-block-latest-posts ul li ul,\n.wp-block-categories-list ul li ul,\n.wp-block-archives-list ul li ul,\n.widget_categories ul li ul,\n.widget_archive ul li ul,\n.widget_meta ul li ul,\n.widget_pages ul li ul,\n.widget_recent_comments ul li ul,\n.widget_nav_menu ul li ul,\n.widget_rss ul li ul,\n.widget_recent_entries ul li ul,\n.widget_services ul li ul,\n.widget_getintuch ul li ul {\n    padding-left: 20px;\n    margin-top: 8px;\n    border-top: 1px solid rgba(0, 0, 0, .1);\n    margin-left: -15px\n}\n\n.search-bx .btn {\n    padding: 11px 15px;\n    border: 1px solid rgba(0, 0, 0, 0);\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n    height: 100%\n}\n\n.widget.widget_search {\n    border: 0;\n    padding: 0\n}\n\n.widget.widget_search .screen-reader-text {\n    display: block\n}\n\n.widget.widget_search .input-group-btn {\n    position: relative;\n    z-index: 99\n}\n\n.searchform {\n    position: relative\n}\n\n.searchform input[type=text] {\n    width: 100%;\n    height: 70px;\n    position: relative;\n    background-color: #fff;\n    border-radius: 6px 6px 4px 4px !important;\n    padding: 30px 30px;\n    box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, .06);\n    border: 1px solid rgba(86, 90, 207, .2);\n    border-width: 1px 1px 3px 1px;\n    border-bottom-color: #008bb1\n}\n\n.searchform input[type=text]:hover,\n.searchform input[type=text]:focus,\n.searchform input[type=text]:active {\n    border-color: #565acf\n}\n\n.searchform .btn {\n    height: 50px;\n    padding: 0;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    z-index: 1;\n    width: 50px\n}\n\n.recent-posts-entry .widget-post {\n    margin-bottom: 15px;\n    align-items: center;\n    display: flex;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 15px\n}\n\n.recent-posts-entry .widget-post:last-child {\n    margin-bottom: 0;\n    border-bottom: 0;\n    padding-bottom: 0\n}\n\n.recent-posts-entry .ttr-post-media {\n    width: 100px;\n    min-width: 100px;\n    margin: 0;\n    border-radius: 12px\n}\n\n.recent-posts-entry .ttr-post-info {\n    background: rgba(0, 0, 0, 0);\n    padding: 0;\n    padding-left: 15px;\n    border: none;\n    padding-right: 0\n}\n\n.recent-posts-entry .ttr-post-info .post-title {\n    margin-bottom: 12px;\n    font-size: 16px\n}\n\n.recent-posts-entry .ttr-post-info .post-title a {\n    color: var(--bs-dark)\n}\n\n.recent-posts-entry .post-meta {\n    margin-bottom: 0\n}\n\n.recent-posts-entry .post-meta li a {\n    font-family: \"Montserrat\", sans-serif;\n    color: var(--bs-dark);\n    text-transform: uppercase;\n    font-weight: 400;\n    font-size: 14px\n}\n\n.widget_recent_comments ul li:before {\n    content: \"\";\n    font-family: FontAwesome;\n    background: rgba(0, 0, 0, 0);\n    width: auto;\n    height: auto;\n    left: 0;\n    top: 10px;\n    font-size: 18px;\n    color: #11171a\n}\n\n.widget_recent_comments ul {\n    margin-top: -10px\n}\n\n.widget_recent_comments ul li {\n    padding-left: 30px;\n    color: #11171a;\n    line-height: 26px\n}\n\n.widget_meta ul li a abbr[title] {\n    color: #333;\n    border-bottom: none\n}\n\n.widget_calendar th,\n.widget_calendar td {\n    text-align: center;\n    border: 1px solid rgba(0, 0, 0, .05);\n    padding: .4em\n}\n\n.widget_calendar tr {\n    border-bottom: 1px solid #eee\n}\n\n.widget_calendar table {\n    border-collapse: collapse;\n    margin: 0;\n    width: 100%\n}\n\n.widget_calendar .calendar_wrap th,\n.widget_calendar .calendar_wrap tfoot td a {\n    color: #fff\n}\n\n.widget_calendar .calendar_wrap th,\n.widget_calendar .calendar_wrap tfoot td {\n    background: #7a4815;\n    border-color: rgba(0, 0, 0, .05)\n}\n\n.widget_calendar .calendar_wrap td a {\n    font-weight: 600;\n    text-transform: uppercase;\n    font-size: 14px;\n    color: inherit\n}\n\n.widget_calendar .calendar_wrap th:last-child,\n.widget_calendar .calendar_wrap tfoot td:last-child {\n    border: 0\n}\n\n.widget_calendar .calendar_wrap tr:nth-child(2n+2) {\n    background-color: #faf8f2\n}\n\n.widget_calendar caption {\n    text-align: center;\n    font-weight: 600;\n    caption-side: top;\n    background: #a6611c;\n    color: #fff;\n    text-transform: uppercase;\n    font-size: 15px\n}\n\n.wp-calendar-nav {\n    background: #854e16;\n    color: #fff;\n    display: flex;\n    justify-content: space-between;\n    text-align: center\n}\n\n.wp-calendar-nav span {\n    padding: 5px 20px;\n    width: 44%;\n    border-right: 1px solid rgba(255, 255, 255, .2)\n}\n\n.wp-calendar-nav span a {\n    color: #fff\n}\n\n.wp-calendar-nav span .pad {\n    width: 15%\n}\n\n.widget_tag_cloud a {\n    padding: 8px 12px;\n    background-color: #008bb1;\n    font-size: 12px;\n    display: inline-block;\n    margin: 0 1px 6px;\n    color: #fff;\n    font-weight: 600;\n    border-radius: 8px;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s\n}\n\n.widget_tag_cloud a:hover {\n    background-color: #00b8de;\n    color: #fff;\n}\n\n.widget_archive select {\n    width: 100%;\n    padding: 5px;\n    border: 1px solid #ccc\n}\n\n.widget_text select {\n    width: 100%;\n    padding: 5px;\n    border: 1px solid #ccc\n}\n\n.widget_text select option {\n    width: 100%\n}\n\n.widget_text p {\n    font-size: 15px;\n    line-height: 28px\n}\n\n.widget_text b,\n.widget_text strong {\n    color: #11171a\n}\n\n.widget_archive ul li,\n.wp-block-categories-list li,\n.wp-block-archives-list li,\n.wp-block-latest-posts li,\n.widget_categories ul li {\n    text-align: right;\n    display: table;\n    width: 100%;\n    font-size: 14px;\n    padding: 10px 0px 10px 15px;\n    line-height: 1.3\n}\n\n.widget_archive ul li a,\n.wp-block-categories-list li a,\n.wp-block-archives-list li a,\n.wp-block-latest-posts li a,\n.widget_categories ul li a {\n    float: left;\n    text-transform: capitalize;\n    box-shadow: none;\n    text-align: left\n}\n\n.widget_archive ul li ul,\n.wp-block-categories-list li ul,\n.wp-block-archives-list li ul,\n.wp-block-latest-posts li ul,\n.widget_categories ul li ul {\n    margin-bottom: -10px\n}\n\n.widget_archive ul li:before,\n.wp-block-categories-list li:before,\n.wp-block-archives-list li:before,\n.wp-block-latest-posts li:before,\n.widget_categories ul li:before {\n    content: none\n}\n\n.wp-block-latest-posts,\n.wp-block-categories-list,\n.wp-block-archives-list {\n    margin-bottom: 40px;\n    padding: 0\n}\n\n.widget_categories form label {\n    display: block\n}\n\n.rsswidget img {\n    display: inherit\n}\n\n.widget-title .rsswidget {\n    display: inline-block\n}\n\nul a.rsswidget,\nul cite {\n    font-weight: 600;\n    color: #060429;\n    font-size: 14px\n}\n\nul a.rsswidget {\n    font-size: 18px\n}\n\nul a.rsswidget:hover {\n    color: #a6611c\n}\n\n.rssSummary {\n    margin: 20px 0;\n    font-size: 14px;\n    line-height: 1.7\n}\n\n.rss-date {\n    display: block;\n    margin-top: 5px;\n    font-size: 14px;\n    font-weight: 400;\n    color: #9fa1a4\n}\n\n.widget_rss ul li {\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, .1);\n    padding-top: 0\n}\n\n.widget_rss ul li:last-child {\n    margin-bottom: 0;\n    border-bottom: 0;\n    padding-bottom: 0\n}\n\n.widget_getintuch {\n    padding-top: 10px\n}\n\n.widget_getintuch li {\n    margin-bottom: 20px;\n    position: relative;\n    padding-left: 40px\n}\n\n.widget_getintuch li,\n.widget_getintuch b,\n.widget_getintuch strong {\n    display: block;\n    text-transform: capitalize\n}\n\n.widget_getintuch strong {\n    font-weight: 600;\n    font-size: 16px\n}\n\n.widget_getintuch i {\n    position: absolute;\n    left: 0;\n    top: 5px;\n    text-align: center;\n    font-size: 22px;\n    width: 30px;\n    height: 30px;\n    line-height: 30px\n}\n\n.widget_gallery ul {\n    padding-left: 0;\n    display: table;\n    margin-bottom: 0\n}\n\n.widget_gallery ul li {\n    display: inline-block;\n    width: 33.33%;\n    float: left;\n    -webkit-transition: all .5s;\n    -ms-transition: all .5s;\n    transition: all .5s;\n    padding: 2px\n}\n\n.widget_gallery ul li img {\n    display: inline-block;\n    width: 100%\n}\n\n.widget_gallery ul li:nth-child(3n-3) {\n    margin-right: 0\n}\n\n.widget_gallery ul li:hover {\n    opacity: .7\n}\n\n.widget_gallery ul li a {\n    display: inline-block\n}\n\n.widget_gallery.gallery-grid-2 li {\n    width: 50%\n}\n\n.widget_gallery.gallery-grid-4 li {\n    width: 25%\n}\n\n.widget_gallery.gallery-grid-8 li {\n    width: 12.5%\n}\n\n@media only screen and (max-width: 767px) {\n    .gallery-grid-8 li {\n        width: 25%\n    }\n}\n\n.commentlist .bypostauthor {\n    font-weight: 600\n}\n\n.admin-bar .is-fixed .main-bar {\n    top: 30px\n}\n\n@media only screen and (max-width: 991px) {\n    .admin-bar .header-nav {\n        top: 30px;\n        height: calc(100vh - 30px)\n    }\n}\n\n@media only screen and (max-width: 782px) {\n    .admin-bar .is-fixed .main-bar {\n        top: 45px\n    }\n\n    .admin-bar .header-nav {\n        top: 45px;\n        height: calc(100vh - 45px)\n    }\n}\n\n@media only screen and (max-width: 600px) {\n    .admin-bar .is-fixed .main-bar {\n        top: 0\n    }\n\n    .admin-bar .header-nav {\n        top: 45px;\n        height: calc(100vh - 45px)\n    }\n\n    .admin-bar .is-fixed .header-nav {\n        top: 0;\n        height: 100vh\n    }\n}\n\nfooter {\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n    font-size: 15px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover\n}\n\nfooter p {\n    font-weight: 500\n}\n\nfooter .widget.footer_widget ul {\n    margin-bottom: 0\n}\n\nfooter .widget .footer-title {\n    margin-bottom: 30px;\n    position: relative;\n    padding-bottom: 20px;\n    font-size: 24px\n}\n\nfooter .widget .footer-title:after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 85px;\n    height: 7px;\n    background-image: url(./images/shap/footer-line.png);\n    background-repeat: no-repeat\n}\n\n@media only screen and (max-width: 767px) {\n    footer .widget .footer-title {\n        padding-bottom: 15px;\n        font-size: 20px;\n        margin-bottom: 25px\n    }\n\n    footer .widget .footer-title:after {\n        width: 75px;\n        height: 5px\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    footer .widget {\n        margin-bottom: 40px\n    }\n}\n\nfooter .ft-contact p {\n    font-size: 16px;\n    line-height: 28px;\n    font-weight: 500;\n    margin-bottom: 30px\n}\n\nfooter .ft-contact .contact-bx {\n    display: flex;\n    align-items: center\n}\n\nfooter .ft-contact .contact-bx .icon i {\n    font-size: 24px;\n    color: #fff;\n    margin-right: 15px;\n    border-radius: 30px 30px 0px 30px;\n    width: 58px;\n    height: 58px;\n    line-height: 58px;\n    text-align: center;\n    background-color: var(--bs-dark)\n}\n\nfooter .ft-contact .contact-bx .contact-number .number {\n    margin-bottom: 0;\n    font-size: 20px\n}\n\nfooter .ft-contact .contact-bx .contact-number span {\n    font-size: 14px;\n    margin-bottom: 5px;\n    font-weight: 600;\n    display: block;\n    color: var(--bs-dark)\n}\n\n@media only screen and (max-width: 767px) {\n    footer .ft-contact p {\n        margin-bottom: 20px\n    }\n}\n\nfooter .footer-logo {\n    max-width: 190px;\n    margin-bottom: 25px\n}\n\n@media only screen and (max-width: 767px) {\n    footer .footer-logo {\n        margin-bottom: 15px\n    }\n}\n\nfooter .widget-logo ul {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap\n}\n\nfooter .widget-logo ul li {\n    display: inline-block;\n    flex: 50%;\n    padding: 0 15px 15px 0px\n}\n\nfooter .footer-top {\n    padding: 200px 0 20px\n}\n\n@media only screen and (max-width: 1380px) {\n    footer .footer-top {\n        padding: 150px 0 0\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    footer .footer-top {\n        padding: 120px 0 0\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    footer .footer-top {\n        padding: 100px 0 0\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    footer .footer-top {\n        padding: 70px 0 10px\n    }\n}\n\nfooter .footer-bottom {\n    padding: 25px 0;\n    font-size: 15px\n}\n\nfooter .subscribe-form .form-control {\n    border-radius: 10px;\n    box-shadow: 0px 10px 60px 0px rgba(31, 34, 120, .1);\n    margin-bottom: 20px;\n    height: 52px;\n    font-size: 15px;\n    font-weight: 500\n}\n\n@media only screen and (max-width: 991px) {\n    footer .widget.footer_widget.ml-50 {\n        margin-left: 0\n    }\n}\n\n.footer .footer_widget ul li a {\n    font-size: 16px;\n    font-weight: 500;\n    padding: 6px 0;\n    display: block;\n    line-height: 25px;\n    color: #444;\n    position: relative\n}\n\n.footer .footer_widget ul li a:hover,\n.footer .custom-links li a:hover {\n    color: var(--bs-dark);\n}\n\n.footer .custom-links li a {\n    color: #444444;\n}\n\n\n\n.footer .footer-bottom {\n    border-top: 1px solid #d4d5f1\n}\n\n.footer .footer-bottom .copyright-text {\n    margin: 0\n}\n\n.footer .footer-bottom .copyright-text a {\n    color: var(--bs-dark) !important;\n}\n\n.footer .footer-bottom .link-inline {\n    margin: 0 -15px\n}\n\n.footer .footer-bottom .link-inline li {\n    display: inline-block;\n    margin-left: 15px;\n    margin-right: 15px;\n    text-transform: capitalize\n}\n\n.footer .footer-bottom .link-inline li a:hover {\n    color: #565acf\n}\n\n.footer:after {\n    content: \"\";\n    background-image: url(./images/background/footer-shape.png);\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-size: 100%;\n    z-index: -1;\n    background-position: left top\n}\n\n.footer .footer-social-link ul {\n    margin: 0 -8px\n}\n\n.footer .footer-social-link ul li {\n    display: inline-block;\n    padding: 0 8px\n}\n\n.footer .pt-img1 {\n    top: 100px;\n    left: 130px;\n    z-index: 1\n}\n\n@media only screen and (max-width: 1380px) {\n    .footer .pt-img1 {\n        top: 80px;\n        left: 80px\n    }\n}\n\n\n.footer .pt-img2 {\n    bottom: 180px;\n    left: 30px\n}\n\n@media only screen and (max-width: 1380px) {\n    .footer .pt-img2 {\n        bottom: 100px;\n        left: 60px\n    }\n}\n\n.footer .pt-img3 {\n    top: 180px;\n    right: 40px\n}\n\n@media only screen and (max-width: 991px) {\n    .footer .pt-img3 {\n        right: -50px\n    }\n}\n\n.footer .pt-img4 {\n    bottom: 120px;\n    right: 60px\n}\n\n@media only screen and (max-width: 991px) {\n    .footer .pt-img4 {\n        bottom: 40px;\n        sright: 0px\n    }\n}\n\n.App {\n    text-align: center\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none\n}\n\n@media(prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear\n    }\n}\n\n.App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: #fff\n}\n\n.App-link {\n    color: #61dafb\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg)\n    }\n\n    to {\n        transform: rotate(360deg)\n    }\n}\n\n.product-card-design h3 {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis !important;\n}\n\n\n.services-block-three {\n    margin-bottom: 30px;\n    cursor: pointer;\n\n    i {\n        font-size: 32px;\n    }\n\n    .custom-icon {\n        font-size: 18px !important;\n        color: var(--bs-dark);\n    }\n\n    >div {\n        display: block;\n        border: 2px solid #d5d5d5;\n        border-radius: 4px;\n        text-align: center;\n        background: #fff;\n        /* padding: 20px; */\n        padding: 14px;\n        position: relative;\n        margin-bottom: 30px;\n        transition: all 0.5s ease;\n\n        &:before {\n            display: block;\n            content: \"\";\n            width: 9%;\n            height: 17%;\n            position: absolute;\n            bottom: -2px;\n            right: -2px;\n            border-bottom: 2px solid #03a9f5;\n            border-right: 2px solid #03a9f5;\n            transition: all 0.5s ease;\n        }\n\n        &:after {\n            display: block;\n            content: \"\";\n            width: 9%;\n            height: 17%;\n            position: absolute;\n            top: -2px;\n            left: -2px;\n            border-top: 2px solid #03a9f5;\n            border-left: 2px solid #03a9f5;\n            transition: all 0.5s ease;\n        }\n\n        &:hover {\n            opacity: 1;\n            border-color: #d5d5d5;\n\n            &:before,\n            &:after {\n                width: 95%;\n                height: 90%;\n            }\n        }\n    }\n\n    h4 {\n        color: #6f6f6f;\n        font-size: 14px;\n        margin-bottom: 10px;\n        font-weight: 600;\n    }\n\n    p {\n        margin-bottom: 0;\n        color: #757575;\n    }\n\n    .bg-color {\n        /* background-color: #F6F8FA; */\n        min-height: 225px !important;\n        height: 225px !important;\n        max-height: 225px !important;\n\n    }\n\n    .bg-color img {\n        width: 222px;\n        height: 166px;\n    }\n}\n\n.padding-15px-bottom {\n    padding-bottom: 15px;\n}\n\na {\n\n    &:hover,\n    &:active {\n        color: #03a9f5;\n        text-decoration: none;\n    }\n}\n\n/* Product Page Style Sheet Start */\n.product-searchbar {\n    border-radius: 10px;\n    background-color: #F6F8FA;\n    max-width: 598px;\n}\n\n.product-searchbar input {\n    padding: 16px 16px 16px 44px;\n    line-height: 17px;\n    color: #757575;\n    font-weight: 500;\n    font-size: 15px;\n}\n\n.product-searchbar input::placeholder {\n    color: #757575;\n    font-size: 15px;\n}\n\n.product-searchbar input[type=\"search\"]::-webkit-search-cancel-button {\n    display: none;\n}\n\n.product-searchbar i {\n    top: 30%;\n    left: 16px;\n    transform: rotate(270deg) !important;\n}\n\n.product-tabs {\n    height: 100px;\n    width: 100px;\n}\n\n.product-tabs .tab-icon {\n    height: 100px;\n    width: 100px;\n}\n\n.product-tabs .tab-icon img {\n    height: 48px;\n    max-width: 68px;\n}\n\n.product-tabs p {\n    text-transform: capitalize !important;\n}\n\n.product-tabs.active p {\n    color: var(--bs-dark) !important;\n}\n\n.product-tabs>div::before,\n.product-tabs>div::after {\n    opacity: 0;\n    border-color: #008BB1 !important;\n    /* width: 20% !important;\n    height: 20% !important; */\n    width: 20% !important;\n    height: 20% !important;\n}\n\n\n.product-tabs.active>div::before,\n.product-tabs.active>div::after {\n    opacity: 1 !important;\n}\n\n.product-tabs.active>div:hover::before,\n.product-tabs.active>div:hover::after {\n    width: 9%;\n    opacity: 1 !important;\n    height: 17%\n}\n\n\n.product-tabs:hover>div::before,\n.product-tabs:hover>div::after {\n    opacity: 1 !important;\n    /* width: 9%;\n    height: 17% */\n}\n\n/* Product Page Style Sheet End */\n\n/* Product Detail Page Style Sheet Start */\n.product-img-container {\n    border: 1px solid #f6f6f6;\n    min-height: 380px;\n    height: 380px;\n    max-height: 380px;\n}\n\n.product-detail-container .content {\n    font-size: 16px;\n    overflow: hidden;\n    -webkit-line-clamp: 2;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n}\n\n/* .product-detail-container .product-detail-varient .product-detail-item:hover svg path {\n    fill: #008bb1 !important;\n} */\n\n.product-detail-container .product-detail-varient .product-detail-item:nth-child(1):hover svg path,\n.product-detail-container .product-detail-varient .product-detail-item:nth-child(3):hover svg path,\n.product-detail-container .product-detail-varient .product-detail-item:nth-child(5):hover svg path,\n.product-detail-container .product-detail-varient .product-detail-item:nth-child(6):hover svg path {\n    fill: #008bb1 !important;\n}\n\n.product-detail-container .product-detail-varient .product-detail-item:nth-child(2):hover svg path,\n.product-detail-container .product-detail-varient .product-detail-item:nth-child(4):hover svg path {\n    stroke: #008bb1 !important;\n}\n\n.product-detail-container .product-detail-varient .product-detail-item span {\n    font-size: 14px;\n}\n\n.product-detail-container .product-detail-varient .product-detail-item:hover span {\n    color: #00b8de;\n    fill: #008bb1 !important;\n}\n\n.product-detail-container .product-detail-varient .product-detail-item h6 {\n    font-size: 16px;\n    padding-top: 3px;\n    color: #222222;\n}\n\n.custom-submit-btn {\n    max-width: 140px;\n}\n\n.custom-form-br {\n    border: 1px solid #d5d5d5;\n}\n\n.custom-form-br input,\n.custom-form-br textarea {\n    font-size: 15px !important;\n}\n\n.custom-form-br input::placeholder,\n.custom-form-br textarea::placeholder {\n    font-size: 15px !important;\n}\n\n.custom-section-bg {\n    background-color: #f5f5fc;\n}\n\n/* Product Detail Page Style Sheet End */\n\n/* Footer Style Sheet Start */\n/* Footer Style Sheet Start */\n.foot-contact i {\n    color: var(--bs-dark);\n    margin-top: 6px;\n}\n\n.foot-contact a {\n    color: #444;\n    font-size: 15px;\n}\n\n.foot-contact a:hover {\n    color: var(--bs-dark);\n}\n\n/* Footer Style Sheet End */\n\n/* Client Review Style Sheet Start */\n.custom-client-review .slick-list {\n    max-height: 420px;\n}\n\n/* Client Review Style Sheet End */\n\n/* About Us Style Sheet Start */\n.our-partner-box {\n    border: 2px solid #d5d5d5;\n\n    height: 180px;\n    width: 180px;\n}\n\n\n.our-partner-box img {\n    width: 135px;\n    height: 135px;\n    transform: scale(1);\n    transition: all 0.6s;\n    object-fit: contain;\n}\n\n.our-partner-box:hover img {\n    transform: scale(1.1);\n    transition: all 0.6s;\n}\n\n/* About Us Style Sheet End */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
